/*! jQuery Migrate v3.3.2 | (c) OpenJS Foundation and other contributors | jquery.org/license */
"undefined" == typeof jQuery.migrateMute && (jQuery.migrateMute = !0),
    (function (t) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["jquery"], function (e) {
                  return t(e, window);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(require("jquery"), window))
            : t(jQuery, window);
    })(function (s, n) {
        "use strict";
        function e(e) {
            return (
                0 <=
                (function (e, t) {
                    for (var r = /^(\d+)\.(\d+)\.(\d+)/, n = r.exec(e) || [], o = r.exec(t) || [], i = 1; i <= 3; i++) {
                        if (+o[i] < +n[i]) return 1;
                        if (+n[i] < +o[i]) return -1;
                    }
                    return 0;
                })(s.fn.jquery, e)
            );
        }
        (s.migrateVersion = "3.3.2"),
            n.console &&
                n.console.log &&
                ((s && e("3.0.0")) || n.console.log("JQMIGRATE: jQuery 3.0.0+ REQUIRED"),
                s.migrateWarnings && n.console.log("JQMIGRATE: Migrate plugin loaded multiple times"),
                n.console.log("JQMIGRATE: Migrate is installed" + (s.migrateMute ? "" : " with logging active") + ", version " + s.migrateVersion));
        var r = {};
        function u(e) {
            var t = n.console;
            (s.migrateDeduplicateWarnings && r[e]) || ((r[e] = !0), s.migrateWarnings.push(e), t && t.warn && !s.migrateMute && (t.warn("JQMIGRATE: " + e), s.migrateTrace && t.trace && t.trace()));
        }
        function t(e, t, r, n) {
            Object.defineProperty(e, t, {
                configurable: !0,
                enumerable: !0,
                get: function () {
                    return u(n), r;
                },
                set: function (e) {
                    u(n), (r = e);
                },
            });
        }
        function o(e, t, r, n) {
            e[t] = function () {
                return u(n), r.apply(this, arguments);
            };
        }
        (s.migrateDeduplicateWarnings = !0),
            (s.migrateWarnings = []),
            void 0 === s.migrateTrace && (s.migrateTrace = !0),
            (s.migrateReset = function () {
                (r = {}), (s.migrateWarnings.length = 0);
            }),
            "BackCompat" === n.document.compatMode && u("jQuery is not compatible with Quirks Mode");
        var i,
            a,
            c,
            d = {},
            l = s.fn.init,
            p = s.find,
            f = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
            y = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g,
            m = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        for (i in ((s.fn.init = function (e) {
            var t = Array.prototype.slice.call(arguments);
            return "string" == typeof e && "#" === e && (u("jQuery( '#' ) is not a valid selector"), (t[0] = [])), l.apply(this, t);
        }),
        (s.fn.init.prototype = s.fn),
        (s.find = function (t) {
            var r = Array.prototype.slice.call(arguments);
            if ("string" == typeof t && f.test(t))
                try {
                    n.document.querySelector(t);
                } catch (e) {
                    t = t.replace(y, function (e, t, r, n) {
                        return "[" + t + r + '"' + n + '"]';
                    });
                    try {
                        n.document.querySelector(t), u("Attribute selector with '#' must be quoted: " + r[0]), (r[0] = t);
                    } catch (e) {
                        u("Attribute selector with '#' was not fixed: " + r[0]);
                    }
                }
            return p.apply(this, r);
        }),
        p))
            Object.prototype.hasOwnProperty.call(p, i) && (s.find[i] = p[i]);
        o(
            s.fn,
            "size",
            function () {
                return this.length;
            },
            "jQuery.fn.size() is deprecated and removed; use the .length property"
        ),
            o(
                s,
                "parseJSON",
                function () {
                    return JSON.parse.apply(null, arguments);
                },
                "jQuery.parseJSON is deprecated; use JSON.parse"
            ),
            o(s, "holdReady", s.holdReady, "jQuery.holdReady is deprecated"),
            o(s, "unique", s.uniqueSort, "jQuery.unique is deprecated; use jQuery.uniqueSort"),
            t(s.expr, "filters", s.expr.pseudos, "jQuery.expr.filters is deprecated; use jQuery.expr.pseudos"),
            t(s.expr, ":", s.expr.pseudos, "jQuery.expr[':'] is deprecated; use jQuery.expr.pseudos"),
            e("3.1.1") &&
                o(
                    s,
                    "trim",
                    function (e) {
                        return null == e ? "" : (e + "").replace(m, "");
                    },
                    "jQuery.trim is deprecated; use String.prototype.trim"
                ),
            e("3.2.0") &&
                (o(
                    s,
                    "nodeName",
                    function (e, t) {
                        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
                    },
                    "jQuery.nodeName is deprecated"
                ),
                o(s, "isArray", Array.isArray, "jQuery.isArray is deprecated; use Array.isArray")),
            e("3.3.0") &&
                (o(
                    s,
                    "isNumeric",
                    function (e) {
                        var t = typeof e;
                        return ("number" == t || "string" == t) && !isNaN(e - parseFloat(e));
                    },
                    "jQuery.isNumeric() is deprecated"
                ),
                s.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                    d["[object " + t + "]"] = t.toLowerCase();
                }),
                o(
                    s,
                    "type",
                    function (e) {
                        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? d[Object.prototype.toString.call(e)] || "object" : typeof e;
                    },
                    "jQuery.type is deprecated"
                ),
                o(
                    s,
                    "isFunction",
                    function (e) {
                        return "function" == typeof e;
                    },
                    "jQuery.isFunction() is deprecated"
                ),
                o(
                    s,
                    "isWindow",
                    function (e) {
                        return null != e && e === e.window;
                    },
                    "jQuery.isWindow() is deprecated"
                )),
            s.ajax &&
                ((a = s.ajax),
                (c = /(=)\?(?=&|$)|\?\?/),
                (s.ajax = function () {
                    var e = a.apply(this, arguments);
                    return (
                        e.promise &&
                            (o(e, "success", e.done, "jQXHR.success is deprecated and removed"), o(e, "error", e.fail, "jQXHR.error is deprecated and removed"), o(e, "complete", e.always, "jQXHR.complete is deprecated and removed")),
                        e
                    );
                }),
                e("4.0.0") ||
                    s.ajaxPrefilter("+json", function (e) {
                        !1 !== e.jsonp && (c.test(e.url) || ("string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && c.test(e.data))) && u("JSON-to-JSONP auto-promotion is deprecated");
                    }));
        var g = s.fn.removeAttr,
            h = s.fn.toggleClass,
            v = /\S+/g;
        function j(e) {
            return e.replace(/-([a-z])/g, function (e, t) {
                return t.toUpperCase();
            });
        }
        s.fn.removeAttr = function (e) {
            var r = this;
            return (
                s.each(e.match(v), function (e, t) {
                    s.expr.match.bool.test(t) && (u("jQuery.fn.removeAttr no longer sets boolean properties: " + t), r.prop(t, !1));
                }),
                g.apply(this, arguments)
            );
        };
        var Q,
            b = !(s.fn.toggleClass = function (t) {
                return void 0 !== t && "boolean" != typeof t
                    ? h.apply(this, arguments)
                    : (u("jQuery.fn.toggleClass( boolean ) is deprecated"),
                      this.each(function () {
                          var e = (this.getAttribute && this.getAttribute("class")) || "";
                          e && s.data(this, "__className__", e), this.setAttribute && this.setAttribute("class", (!e && !1 !== t && s.data(this, "__className__")) || "");
                      }));
            }),
            w = /^[a-z]/,
            x = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
        s.swap &&
            s.each(["height", "width", "reliableMarginRight"], function (e, t) {
                var r = s.cssHooks[t] && s.cssHooks[t].get;
                r &&
                    (s.cssHooks[t].get = function () {
                        var e;
                        return (b = !0), (e = r.apply(this, arguments)), (b = !1), e;
                    });
            }),
            (s.swap = function (e, t, r, n) {
                var o,
                    i,
                    a = {};
                for (i in (b || u("jQuery.swap() is undocumented and deprecated"), t)) (a[i] = e.style[i]), (e.style[i] = t[i]);
                for (i in ((o = r.apply(e, n || [])), t)) e.style[i] = a[i];
                return o;
            }),
            e("3.4.0") &&
                "undefined" != typeof Proxy &&
                (s.cssProps = new Proxy(s.cssProps || {}, {
                    set: function () {
                        return u("JQMIGRATE: jQuery.cssProps is deprecated"), Reflect.set.apply(this, arguments);
                    },
                })),
            s.cssNumber || (s.cssNumber = {}),
            (Q = s.fn.css),
            (s.fn.css = function (e, t) {
                var r,
                    n,
                    o = this;
                return e && "object" == typeof e && !Array.isArray(e)
                    ? (s.each(e, function (e, t) {
                          s.fn.css.call(o, e, t);
                      }),
                      this)
                    : ("number" == typeof t && ((r = j(e)), (n = r), (w.test(n) && x.test(n[0].toUpperCase() + n.slice(1))) || s.cssNumber[r] || u('Number-typed values are deprecated for jQuery.fn.css( "' + e + '", value )')),
                      Q.apply(this, arguments));
            });
        var A,
            k,
            S,
            M,
            N = s.data;
        (s.data = function (e, t, r) {
            var n, o, i;
            if (t && "object" == typeof t && 2 === arguments.length) {
                for (i in ((n = s.hasData(e) && N.call(this, e)), (o = {}), t)) i !== j(i) ? (u("jQuery.data() always sets/gets camelCased names: " + i), (n[i] = t[i])) : (o[i] = t[i]);
                return N.call(this, e, o), t;
            }
            return t && "string" == typeof t && t !== j(t) && (n = s.hasData(e) && N.call(this, e)) && t in n
                ? (u("jQuery.data() always sets/gets camelCased names: " + t), 2 < arguments.length && (n[t] = r), n[t])
                : N.apply(this, arguments);
        }),
            s.fx &&
                ((S = s.Tween.prototype.run),
                (M = function (e) {
                    return e;
                }),
                (s.Tween.prototype.run = function () {
                    1 < s.easing[this.easing].length && (u("'jQuery.easing." + this.easing.toString() + "' should use only one argument"), (s.easing[this.easing] = M)), S.apply(this, arguments);
                }),
                (A = s.fx.interval || 13),
                (k = "jQuery.fx.interval is deprecated"),
                n.requestAnimationFrame &&
                    Object.defineProperty(s.fx, "interval", {
                        configurable: !0,
                        enumerable: !0,
                        get: function () {
                            return n.document.hidden || u(k), A;
                        },
                        set: function (e) {
                            u(k), (A = e);
                        },
                    }));
        var R = s.fn.load,
            H = s.event.add,
            C = s.event.fix;
        (s.event.props = []),
            (s.event.fixHooks = {}),
            t(s.event.props, "concat", s.event.props.concat, "jQuery.event.props.concat() is deprecated and removed"),
            (s.event.fix = function (e) {
                var t,
                    r = e.type,
                    n = this.fixHooks[r],
                    o = s.event.props;
                if (o.length) {
                    u("jQuery.event.props are deprecated and removed: " + o.join());
                    while (o.length) s.event.addProp(o.pop());
                }
                if (n && !n._migrated_ && ((n._migrated_ = !0), u("jQuery.event.fixHooks are deprecated and removed: " + r), (o = n.props) && o.length)) while (o.length) s.event.addProp(o.pop());
                return (t = C.call(this, e)), n && n.filter ? n.filter(t, e) : t;
            }),
            (s.event.add = function (e, t) {
                return e === n && "load" === t && "complete" === n.document.readyState && u("jQuery(window).on('load'...) called after load event occurred"), H.apply(this, arguments);
            }),
            s.each(["load", "unload", "error"], function (e, t) {
                s.fn[t] = function () {
                    var e = Array.prototype.slice.call(arguments, 0);
                    return "load" === t && "string" == typeof e[0] ? R.apply(this, e) : (u("jQuery.fn." + t + "() is deprecated"), e.splice(0, 0, t), arguments.length ? this.on.apply(this, e) : (this.triggerHandler.apply(this, e), this));
                };
            }),
            s.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, r) {
                s.fn[r] = function (e, t) {
                    return u("jQuery.fn." + r + "() event shorthand is deprecated"), 0 < arguments.length ? this.on(r, null, e, t) : this.trigger(r);
                };
            }),
            s(function () {
                s(n.document).triggerHandler("ready");
            }),
            (s.event.special.ready = {
                setup: function () {
                    this === n.document && u("'ready' event is deprecated");
                },
            }),
            s.fn.extend({
                bind: function (e, t, r) {
                    return u("jQuery.fn.bind() is deprecated"), this.on(e, null, t, r);
                },
                unbind: function (e, t) {
                    return u("jQuery.fn.unbind() is deprecated"), this.off(e, null, t);
                },
                delegate: function (e, t, r, n) {
                    return u("jQuery.fn.delegate() is deprecated"), this.on(t, e, r, n);
                },
                undelegate: function (e, t, r) {
                    return u("jQuery.fn.undelegate() is deprecated"), 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", r);
                },
                hover: function (e, t) {
                    return u("jQuery.fn.hover() is deprecated"), this.on("mouseenter", e).on("mouseleave", t || e);
                },
            });
        function T(e) {
            var t = n.document.implementation.createHTMLDocument("");
            return (t.body.innerHTML = e), t.body && t.body.innerHTML;
        }
        function P(e) {
            var t = e.replace(O, "<$1></$2>");
            t !== e && T(e) !== T(t) && u("HTML tags must be properly nested and closed: " + e);
        }
        var O = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            q = s.htmlPrefilter;
        (s.UNSAFE_restoreLegacyHtmlPrefilter = function () {
            s.htmlPrefilter = function (e) {
                return P(e), e.replace(O, "<$1></$2>");
            };
        }),
            (s.htmlPrefilter = function (e) {
                return P(e), q(e);
            });
        var D,
            _ = s.fn.offset;
        (s.fn.offset = function () {
            var e = this[0];
            return !e || (e.nodeType && e.getBoundingClientRect) ? _.apply(this, arguments) : (u("jQuery.fn.offset() requires a valid DOM element"), arguments.length ? this : void 0);
        }),
            s.ajax &&
                ((D = s.param),
                (s.param = function (e, t) {
                    var r = s.ajaxSettings && s.ajaxSettings.traditional;
                    return void 0 === t && r && (u("jQuery.param() no longer uses jQuery.ajaxSettings.traditional"), (t = r)), D.call(this, e, t);
                }));
        var E,
            F,
            J = s.fn.andSelf || s.fn.addBack;
        return (
            (s.fn.andSelf = function () {
                return u("jQuery.fn.andSelf() is deprecated and removed, use jQuery.fn.addBack()"), J.apply(this, arguments);
            }),
            s.Deferred &&
                ((E = s.Deferred),
                (F = [
                    ["resolve", "done", s.Callbacks("once memory"), s.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", s.Callbacks("once memory"), s.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", s.Callbacks("memory"), s.Callbacks("memory")],
                ]),
                (s.Deferred = function (e) {
                    var i = E(),
                        a = i.promise();
                    return (
                        (i.pipe = a.pipe = function () {
                            var o = arguments;
                            return (
                                u("deferred.pipe() is deprecated"),
                                s
                                    .Deferred(function (n) {
                                        s.each(F, function (e, t) {
                                            var r = "function" == typeof o[e] && o[e];
                                            i[t[1]](function () {
                                                var e = r && r.apply(this, arguments);
                                                e && "function" == typeof e.promise ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[t[0] + "With"](this === a ? n.promise() : this, r ? [e] : arguments);
                                            });
                                        }),
                                            (o = null);
                                    })
                                    .promise()
                            );
                        }),
                        e && e.call(i, i),
                        i
                    );
                }),
                (s.Deferred.exceptionHook = E.exceptionHook)),
            s
        );
    });
/*!
 * jQuery blockUI plugin
 * Version 2.70.0-2014.11.23
 * Requires jQuery v1.7 or later
 *
 * Examples at: http://malsup.com/jquery/block/
 * Copyright (c) 2007-2013 M. Alsup
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
 */
!(function () {
    "use strict";
    function e(p) {
        p.fn._fadeIn = p.fn.fadeIn;
        var b = p.noop || function () {},
            h = /MSIE/.test(navigator.userAgent),
            k = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent),
            y = (document.documentMode, "function" == typeof document.createElement("div").style.setExpression && document.createElement("div").style.setExpression);
        (p.blockUI = function (e) {
            o(window, e);
        }),
            (p.unblockUI = function (e) {
                v(window, e);
            }),
            (p.growlUI = function (e, t, o, n) {
                var i = p('<div class="growlUI"></div>');
                e && i.append("<h1>" + e + "</h1>"), t && i.append("<h2>" + t + "</h2>"), o === undefined && (o = 3e3);
                var s = function (e) {
                    p.blockUI({
                        message: i,
                        fadeIn: "undefined" != typeof (e = e || {}).fadeIn ? e.fadeIn : 700,
                        fadeOut: "undefined" != typeof e.fadeOut ? e.fadeOut : 1e3,
                        timeout: "undefined" != typeof e.timeout ? e.timeout : o,
                        centerY: !1,
                        showOverlay: !1,
                        onUnblock: n,
                        css: p.blockUI.defaults.growlCSS,
                    });
                };
                s();
                i.css("opacity");
                i.on("mouseover", function () {
                    s({ fadeIn: 0, timeout: 3e4 });
                    var e = p(".blockMsg");
                    e.stop(), e.fadeTo(300, 1);
                }).on("mouseout", function () {
                    p(".blockMsg").fadeOut(1e3);
                });
            }),
            (p.fn.block = function (e) {
                if (this[0] === window) return p.blockUI(e), this;
                var t = p.extend({}, p.blockUI.defaults, e || {});
                return (
                    this.each(function () {
                        var e = p(this);
                        (t.ignoreIfBlocked && e.data("blockUI.isBlocked")) || e.unblock({ fadeOut: 0 });
                    }),
                    this.each(function () {
                        "static" == p.css(this, "position") && ((this.style.position = "relative"), p(this).data("blockUI.static", !0)), (this.style.zoom = 1), o(this, e);
                    })
                );
            }),
            (p.fn.unblock = function (e) {
                return this[0] === window
                    ? (p.unblockUI(e), this)
                    : this.each(function () {
                          v(this, e);
                      });
            }),
            (p.blockUI.version = 2.7),
            (p.blockUI.defaults = {
                message: "<h1>Please wait...</h1>",
                title: null,
                draggable: !0,
                theme: !1,
                css: { padding: 0, margin: 0, width: "30%", top: "40%", left: "35%", textAlign: "center", color: "#000", border: "3px solid #aaa", backgroundColor: "#fff", cursor: "wait" },
                themedCSS: { width: "30%", top: "40%", left: "35%" },
                overlayCSS: { backgroundColor: "#000", opacity: 0.6, cursor: "wait" },
                cursorReset: "default",
                growlCSS: {
                    width: "350px",
                    top: "10px",
                    left: "",
                    right: "10px",
                    border: "none",
                    padding: "5px",
                    opacity: 0.6,
                    cursor: "default",
                    color: "#fff",
                    backgroundColor: "#000",
                    "-webkit-border-radius": "10px",
                    "-moz-border-radius": "10px",
                    "border-radius": "10px",
                },
                iframeSrc: /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank",
                forceIframe: !1,
                baseZ: 1e3,
                centerX: !0,
                centerY: !0,
                allowBodyStretch: !0,
                bindEvents: !0,
                constrainTabKey: !0,
                fadeIn: 200,
                fadeOut: 400,
                timeout: 0,
                showOverlay: !0,
                focusInput: !0,
                focusableElements: ":input:enabled:visible",
                onBlock: null,
                onUnblock: null,
                onOverlayClick: null,
                quirksmodeOffsetHack: 4,
                blockMsgClass: "blockMsg",
                ignoreIfBlocked: !1,
            });
        var m = null,
            g = [];
        function o(e, o) {
            var t,
                n,
                i,
                s,
                l,
                d,
                a,
                c,
                r,
                u = e == window,
                f = o && o.message !== undefined ? o.message : undefined;
            ((o = p.extend({}, p.blockUI.defaults, o || {})).ignoreIfBlocked && p(e).data("blockUI.isBlocked")) ||
                ((o.overlayCSS = p.extend({}, p.blockUI.defaults.overlayCSS, o.overlayCSS || {})),
                (i = p.extend({}, p.blockUI.defaults.css, o.css || {})),
                o.onOverlayClick && (o.overlayCSS.cursor = "pointer"),
                (s = p.extend({}, p.blockUI.defaults.themedCSS, o.themedCSS || {})),
                (f = f === undefined ? o.message : f),
                u && m && v(window, { fadeOut: 0 }),
                f &&
                    "string" != typeof f &&
                    (f.parentNode || f.jquery) &&
                    ((a = f.jquery ? f[0] : f), (t = {}), p(e).data("blockUI.history", t), (t.el = a), (t.parent = a.parentNode), (t.display = a.style.display), (t.position = a.style.position), t.parent && t.parent.removeChild(a)),
                p(e).data("blockUI.onUnblock", o.onUnblock),
                (r = o.baseZ),
                (a =
                    h || o.forceIframe
                        ? p('<iframe class="blockUI" style="z-index:' + r++ + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + o.iframeSrc + '"></iframe>')
                        : p('<div class="blockUI" style="display:none"></div>')),
                (t = o.theme
                    ? p('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + r++ + ';display:none"></div>')
                    : p('<div class="blockUI blockOverlay" style="z-index:' + r++ + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>')),
                o.theme && u
                    ? ((c = '<div class="blockUI ' + o.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (r + 10) + ';display:none;position:fixed">'),
                      o.title && (c += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (o.title || "&nbsp;") + "</div>"),
                      (c += '<div class="ui-widget-content ui-dialog-content"></div>'),
                      (c += "</div>"))
                    : o.theme
                    ? ((c = '<div class="blockUI ' + o.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (r + 10) + ';display:none;position:absolute">'),
                      o.title && (c += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (o.title || "&nbsp;") + "</div>"),
                      (c += '<div class="ui-widget-content ui-dialog-content"></div>'),
                      (c += "</div>"))
                    : (c = u
                          ? '<div class="blockUI ' + o.blockMsgClass + ' blockPage" style="z-index:' + (r + 10) + ';display:none;position:fixed"></div>'
                          : '<div class="blockUI ' + o.blockMsgClass + ' blockElement" style="z-index:' + (r + 10) + ';display:none;position:absolute"></div>'),
                (r = p(c)),
                f && (o.theme ? (r.css(s), r.addClass("ui-widget-content")) : r.css(i)),
                o.theme || t.css(o.overlayCSS),
                t.css("position", u ? "fixed" : "absolute"),
                (h || o.forceIframe) && a.css("opacity", 0),
                (c = [a, t, r]),
                (n = p(u ? "body" : e)),
                p.each(c, function () {
                    this.appendTo(n);
                }),
                o.theme && o.draggable && p.fn.draggable && r.draggable({ handle: ".ui-dialog-titlebar", cancel: "li" }),
                (s = y && (!p.support.boxModel || 0 < p("object,embed", u ? null : e).length)),
                (k || s) &&
                    (u && o.allowBodyStretch && p.support.boxModel && p("html,body").css("height", "100%"),
                    (!k && p.support.boxModel) || u || ((i = U(e, "borderTopWidth")), (s = U(e, "borderLeftWidth")), (l = i ? "(0 - " + i + ")" : 0), (d = s ? "(0 - " + s + ")" : 0)),
                    p.each(c, function (e, t) {
                        t = t[0].style;
                        (t.position = "absolute"),
                            e < 2
                                ? (u
                                      ? t.setExpression("height", "Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:" + o.quirksmodeOffsetHack + ') + "px"')
                                      : t.setExpression("height", 'this.parentNode.offsetHeight + "px"'),
                                  u ? t.setExpression("width", 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"') : t.setExpression("width", 'this.parentNode.offsetWidth + "px"'),
                                  d && t.setExpression("left", d),
                                  l && t.setExpression("top", l))
                                : o.centerY
                                ? (u &&
                                      t.setExpression(
                                          "top",
                                          '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"'
                                      ),
                                  (t.marginTop = 0))
                                : !o.centerY &&
                                  u &&
                                  ((e = o.css && o.css.top ? parseInt(o.css.top, 10) : 0), t.setExpression("top", "((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + " + e + ') + "px"'));
                    })),
                f && ((o.theme ? r.find(".ui-widget-content") : r).append(f), (f.jquery || f.nodeType) && p(f).show()),
                (h || o.forceIframe) && o.showOverlay && a.show(),
                o.fadeIn
                    ? ((c = o.onBlock || b), (a = o.showOverlay && !f ? c : b), (c = f ? c : b), o.showOverlay && t._fadeIn(o.fadeIn, a), f && r._fadeIn(o.fadeIn, c))
                    : (o.showOverlay && t.show(), f && r.show(), o.onBlock && o.onBlock.bind(r)()),
                I(1, e, o),
                u
                    ? ((m = r[0]), (g = p(o.focusableElements, m)), o.focusInput && setTimeout(w, 20))
                    : (function (e, t, o) {
                          var n = e.parentNode,
                              i = e.style,
                              s = (n.offsetWidth - e.offsetWidth) / 2 - U(n, "borderLeftWidth"),
                              n = (n.offsetHeight - e.offsetHeight) / 2 - U(n, "borderTopWidth");
                          t && (i.left = 0 < s ? s + "px" : "0");
                          o && (i.top = 0 < n ? n + "px" : "0");
                      })(r[0], o.centerX, o.centerY),
                o.timeout &&
                    ((r = setTimeout(function () {
                        u ? p.unblockUI(o) : p(e).unblock(o);
                    }, o.timeout)),
                    p(e).data("blockUI.timeout", r)));
        }
        function v(e, t) {
            var o,
                n,
                i = e == window,
                s = p(e),
                l = s.data("blockUI.history"),
                d = s.data("blockUI.timeout");
            d && (clearTimeout(d), s.removeData("blockUI.timeout")),
                (t = p.extend({}, p.blockUI.defaults, t || {})),
                I(0, e, t),
                null === t.onUnblock && ((t.onUnblock = s.data("blockUI.onUnblock")), s.removeData("blockUI.onUnblock")),
                (n = i ? p(document.body).children().filter(".blockUI").add("body > .blockUI") : s.find(">.blockUI")),
                t.cursorReset && (1 < n.length && (n[1].style.cursor = t.cursorReset), 2 < n.length && (n[2].style.cursor = t.cursorReset)),
                i && (m = g = null),
                t.fadeOut
                    ? ((o = n.length),
                      n.stop().fadeOut(t.fadeOut, function () {
                          0 == --o && a(n, l, t, e);
                      }))
                    : a(n, l, t, e);
        }
        function a(e, t, o, n) {
            var i = p(n);
            i.data("blockUI.isBlocked") ||
                (e.each(function (e, t) {
                    this.parentNode && this.parentNode.removeChild(this);
                }),
                t && t.el && ((t.el.style.display = t.display), (t.el.style.position = t.position), (t.el.style.cursor = "default"), t.parent && t.parent.appendChild(t.el), i.removeData("blockUI.history")),
                i.data("blockUI.static") && i.css("position", "static"),
                "function" == typeof o.onUnblock && o.onUnblock(n, o),
                (n = (i = p(document.body)).width()),
                (o = i[0].style.width),
                i.width(n - 1).width(n),
                (i[0].style.width = o));
        }
        function I(e, t, o) {
            var n = t == window,
                t = p(t);
            (!e && ((n && !m) || (!n && !t.data("blockUI.isBlocked")))) ||
                (t.data("blockUI.isBlocked", e), n && o.bindEvents && (!e || o.showOverlay) && ((n = "mousedown mouseup keydown keypress keyup touchstart touchend touchmove"), e ? p(document).on(n, o, i) : p(document).off(n, i)));
        }
        function i(e) {
            if ("keydown" === e.type && e.keyCode && 9 == e.keyCode && m && e.data.constrainTabKey) {
                var t = g,
                    o = !e.shiftKey && e.target === t[t.length - 1],
                    n = e.shiftKey && e.target === t[0];
                if (o || n)
                    return (
                        setTimeout(function () {
                            w(n);
                        }, 10),
                        !1
                    );
            }
            (t = e.data), (o = p(e.target));
            return o.hasClass("blockOverlay") && t.onOverlayClick && t.onOverlayClick(e), 0 < o.parents("div." + t.blockMsgClass).length || 0 === o.parents().children().filter("div.blockUI").length;
        }
        function w(e) {
            !g || ((e = g[!0 === e ? g.length - 1 : 0]) && e.trigger("focus"));
        }
        function U(e, t) {
            return parseInt(p.css(e, t), 10) || 0;
        }
    }
    "function" == typeof define && define.amd && define.amd.jQuery ? define(["jquery"], e) : e(jQuery);
})();
jQuery(function ($) {
    "use strict";
    var FGF_Frontend = {
        init: function () {
            $(document).on("click", ".fgf_pagination", this.manual_gift_pagination);
            $(document).on("click", ".fgf-add-manual-gift-product", this.block_manual_gift_products);
            $(document).on("click", ".fgf-add-gift-product", this.add_manually_gift_product);
            $(document).on("change", ".fgf-gift-product-selection", this.add_automatically_gift_product);
            $(document).on("change", ".fgf-product-variations", this.handle_variation_gift_product);
            $(document.body).on("updated_shipping_method", this.updated_shipping_method);
        },
        updated_shipping_method: function () {
            $(document.body).trigger("wc_update_cart");
        },
        block_manual_gift_products: function (event) {
            var $this = $(event.currentTarget),
                wrapper = $this.closest(".fgf_gift_products_wrapper");
            FGF_Frontend.block(wrapper);
            return true;
        },
        handle_variation_gift_product: function (event) {
            var $this = $(event.currentTarget),
                product_id = $($this).val(),
                url = fgf_frontend_params.add_to_cart_link,
                link = $($this).closest("span").find(".fgf-add-manual-gift-product");
            url = url.replace("%s", product_id);
            url = url.replace("%s", $($this).data("rule_id"));
            link.attr("href", url);
        },
        add_manually_gift_product: function (event) {
            event.preventDefault();
            if ("2" == fgf_frontend_params.dropdown_add_to_cart_behaviour) {
                return false;
            }
            var $this = $(event.currentTarget),
                url = fgf_frontend_params.add_to_cart_link,
                wrapper = $this.closest(".fgf-gift-product-wrapper"),
                product_id = wrapper.find(".fgf-gift-product-selection").val(),
                rule_id = wrapper.find(".fgf-gift-product-selection").find(":selected").data("rule-id");
            if ("" == product_id) {
                alert(fgf_frontend_params.add_to_cart_alert_message);
                return false;
            }
            url = url.replace("%s", product_id);
            url = url.replace("%s", rule_id);
            window.location.href = url;
        },
        add_automatically_gift_product: function (event) {
            event.preventDefault();
            if ("2" != fgf_frontend_params.dropdown_add_to_cart_behaviour) {
                return false;
            }
            var $this = $(event.currentTarget),
                url = fgf_frontend_params.add_to_cart_link,
                rule_id = $($this).find(":selected").data("rule-id");
            if ("" == $($this).val()) {
                return false;
            }
            url = url.replace("%s", $($this).val());
            url = url.replace("%s", rule_id);
            window.location.href = url;
        },
        manual_gift_pagination: function (event) {
            event.preventDefault();
            var $this = $(event.currentTarget),
                table = $this.closest("table.fgf_gift_products_table"),
                table_body = table.find("tbody"),
                current_page = $this.data("page");
            FGF_Frontend.block(table_body);
            var data = { action: "fgf_gift_products_pagination", page_number: current_page, page_url: fgf_frontend_params.current_page_url, fgf_security: fgf_frontend_params.gift_products_pagination_nonce };
            $.post(fgf_frontend_params.ajaxurl, data, function (res) {
                if (true === res.success) {
                    table_body.html(res.data.html);
                    table.find(".fgf_pagination").removeClass("current");
                    table.find(".fgf_pagination_" + current_page).addClass("current");
                    var next_page = current_page;
                    if (current_page > 1) {
                        next_page = current_page - 1;
                    }
                    var last_page = table.find(".fgf_last_pagination").data("page");
                    if (current_page < last_page) {
                        last_page = current_page + 1;
                    }
                    table.find(".fgf_next_pagination").data("page", last_page);
                    table.find(".fgf_prev_pagination").data("page", next_page);
                } else {
                    alert(res.data.error);
                }
                FGF_Frontend.unblock(table_body);
            });
        },
        block: function (id) {
            $(id).block({ message: null, overlayCSS: { background: "#fff", opacity: 0.7 } });
        },
        unblock: function (id) {
            $(id).unblock();
        },
    };
    FGF_Frontend.init();
});

!(function (a, b, c, d) {
    function e(b, c) {
        (this.settings = null),
            (this.options = a.extend({}, e.Defaults, c)),
            (this.$element = a(b)),
            (this._handlers = {}),
            (this._plugins = {}),
            (this._supress = {}),
            (this._current = null),
            (this._speed = null),
            (this._coordinates = []),
            (this._breakpoint = null),
            (this._width = null),
            (this._items = []),
            (this._clones = []),
            (this._mergers = []),
            (this._widths = []),
            (this._invalidated = {}),
            (this._pipe = []),
            (this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }),
            (this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }),
            a.each(
                ["onResize", "onThrottledResize"],
                a.proxy(function (b, c) {
                    this._handlers[c] = a.proxy(this[c], this);
                }, this)
            ),
            a.each(
                e.Plugins,
                a.proxy(function (a, b) {
                    this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
                }, this)
            ),
            a.each(
                e.Workers,
                a.proxy(function (b, c) {
                    this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
                }, this)
            ),
            this.setup(),
            this.initialize();
    }
    (e.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: b,
        fallbackEasing: "swing",
        slideTransition: "",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab",
    }),
        (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
        (e.Type = { Event: "event", State: "state" }),
        (e.Plugins = {}),
        (e.Workers = [
            {
                filter: ["width", "settings"],
                run: function () {
                    this._width = this.$element.width();
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    a.current = this._items && this._items[this.relative(this._current)];
                },
            },
            {
                filter: ["items", "settings"],
                run: function () {
                    this.$stage.children(".cloned").remove();
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    var b = this.settings.margin || "",
                        c = !this.settings.autoWidth,
                        d = this.settings.rtl,
                        e = { width: "auto", "margin-left": d ? b : "", "margin-right": d ? "" : b };
                    !c && this.$stage.children().css(e), (a.css = e);
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                        c = null,
                        d = this._items.length,
                        e = !this.settings.autoWidth,
                        f = [];
                    for (a.items = { merge: !1, width: b }; d--; )
                        (c = this._mergers[d]), (c = (this.settings.mergeFit && Math.min(c, this.settings.items)) || c), (a.items.merge = c > 1 || a.items.merge), (f[d] = e ? b * c : this._items[d].width());
                    this._widths = f;
                },
            },
            {
                filter: ["items", "settings"],
                run: function () {
                    var b = [],
                        c = this._items,
                        d = this.settings,
                        e = Math.max(2 * d.items, 4),
                        f = 2 * Math.ceil(c.length / 2),
                        g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
                        h = "",
                        i = "";
                    for (g /= 2; g > 0; ) b.push(this.normalize(b.length / 2, !0)), (h += c[b[b.length - 1]][0].outerHTML), b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)), (i = c[b[b.length - 1]][0].outerHTML + i), (g -= 1);
                    (this._clones = b), a(h).addClass("cloned").appendTo(this.$stage), a(i).addClass("cloned").prependTo(this.$stage);
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function () {
                    for (var a = this.settings.rtl ? 1 : -1, b = this._clones.length + this._items.length, c = -1, d = 0, e = 0, f = []; ++c < b; )
                        (d = f[c - 1] || 0), (e = this._widths[this.relative(c)] + this.settings.margin), f.push(d + e * a);
                    this._coordinates = f;
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function () {
                    var a = this.settings.stagePadding,
                        b = this._coordinates,
                        c = { width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a, "padding-left": a || "", "padding-right": a || "" };
                    this.$stage.css(c);
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    var b = this._coordinates.length,
                        c = !this.settings.autoWidth,
                        d = this.$stage.children();
                    if (c && a.items.merge) for (; b--; ) (a.css.width = this._widths[this.relative(b)]), d.eq(b).css(a.css);
                    else c && ((a.css.width = a.items.width), d.css(a.css));
                },
            },
            {
                filter: ["items"],
                run: function () {
                    this._coordinates.length < 1 && this.$stage.removeAttr("style");
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    (a.current = a.current ? this.$stage.children().index(a.current) : 0), (a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current))), this.reset(a.current);
                },
            },
            {
                filter: ["position"],
                run: function () {
                    this.animate(this.coordinates(this._current));
                },
            },
            {
                filter: ["width", "position", "items", "settings"],
                run: function () {
                    var a,
                        b,
                        c,
                        d,
                        e = this.settings.rtl ? 1 : -1,
                        f = 2 * this.settings.stagePadding,
                        g = this.coordinates(this.current()) + f,
                        h = g + this.width() * e,
                        i = [];
                    for (c = 0, d = this._coordinates.length; c < d; c++)
                        (a = this._coordinates[c - 1] || 0), (b = Math.abs(this._coordinates[c]) + f * e), ((this.op(a, "<=", g) && this.op(a, ">", h)) || (this.op(b, "<", g) && this.op(b, ">", h))) && i.push(c);
                    this.$stage.children(".active").removeClass("active"),
                        this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"),
                        this.$stage.children(".center").removeClass("center"),
                        this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
                },
            },
        ]),
        (e.prototype.initializeStage = function () {
            (this.$stage = this.$element.find("." + this.settings.stageClass)),
                this.$stage.length ||
                    (this.$element.addClass(this.options.loadingClass),
                    (this.$stage = a("<" + this.settings.stageElement + ">", { class: this.settings.stageClass }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
                    this.$element.append(this.$stage.parent()));
        }),
        (e.prototype.initializeItems = function () {
            var b = this.$element.find(".owl-item");
            if (b.length)
                return (
                    (this._items = b.get().map(function (b) {
                        return a(b);
                    })),
                    (this._mergers = this._items.map(function () {
                        return 1;
                    })),
                    void this.refresh()
                );
            this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
        }),
        (e.prototype.initialize = function () {
            if ((this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading"))) {
                var a, b, c;
                (a = this.$element.find("img")), (b = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d), (c = this.$element.children(b).width()), a.length && c <= 0 && this.preloadAutoWidthImages(a);
            }
            this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized");
        }),
        (e.prototype.isVisible = function () {
            return !this.settings.checkVisibility || this.$element.is(":visible");
        }),
        (e.prototype.setup = function () {
            var b = this.viewport(),
                c = this.options.responsive,
                d = -1,
                e = null;
            c
                ? (a.each(c, function (a) {
                      a <= b && a > d && (d = Number(a));
                  }),
                  (e = a.extend({}, this.options, c[d])),
                  "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()),
                  delete e.responsive,
                  e.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d)))
                : (e = a.extend({}, this.options)),
                this.trigger("change", { property: { name: "settings", value: e } }),
                (this._breakpoint = d),
                (this.settings = e),
                this.invalidate("settings"),
                this.trigger("changed", { property: { name: "settings", value: this.settings } });
        }),
        (e.prototype.optionsLogic = function () {
            this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1));
        }),
        (e.prototype.prepare = function (b) {
            var c = this.trigger("prepare", { content: b });
            return (
                c.data ||
                    (c.data = a("<" + this.settings.itemElement + "/>")
                        .addClass(this.options.itemClass)
                        .append(b)),
                this.trigger("prepared", { content: c.data }),
                c.data
            );
        }),
        (e.prototype.update = function () {
            for (
                var b = 0,
                    c = this._pipe.length,
                    d = a.proxy(function (a) {
                        return this[a];
                    }, this._invalidated),
                    e = {};
                b < c;

            )
                (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
            (this._invalidated = {}), !this.is("valid") && this.enter("valid");
        }),
        (e.prototype.width = function (a) {
            switch ((a = a || e.Width.Default)) {
                case e.Width.Inner:
                case e.Width.Outer:
                    return this._width;
                default:
                    return this._width - 2 * this.settings.stagePadding + this.settings.margin;
            }
        }),
        (e.prototype.refresh = function () {
            this.enter("refreshing"),
                this.trigger("refresh"),
                this.setup(),
                this.optionsLogic(),
                this.$element.addClass(this.options.refreshClass),
                this.update(),
                this.$element.removeClass(this.options.refreshClass),
                this.leave("refreshing"),
                this.trigger("refreshed");
        }),
        (e.prototype.onThrottledResize = function () {
            b.clearTimeout(this.resizeTimer), (this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate));
        }),
        (e.prototype.onResize = function () {
            return (
                !!this._items.length &&
                this._width !== this.$element.width() &&
                !!this.isVisible() &&
                (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))
            );
        }),
        (e.prototype.registerEventHandlers = function () {
            a.support.transition && this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)),
                !1 !== this.settings.responsive && this.on(b, "resize", this._handlers.onThrottledResize),
                this.settings.mouseDrag &&
                    (this.$element.addClass(this.options.dragClass),
                    this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
                    this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
                        return !1;
                    })),
                this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)));
        }),
        (e.prototype.onDragStart = function (b) {
            var d = null;
            3 !== b.which &&
                (a.support.transform
                    ? ((d = this.$stage
                          .css("transform")
                          .replace(/.*\(|\)| /g, "")
                          .split(",")),
                      (d = { x: d[16 === d.length ? 12 : 4], y: d[16 === d.length ? 13 : 5] }))
                    : ((d = this.$stage.position()), (d = { x: this.settings.rtl ? d.left + this.$stage.width() - this.width() + this.settings.margin : d.left, y: d.top })),
                this.is("animating") && (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate("position")),
                this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type),
                this.speed(0),
                (this._drag.time = new Date().getTime()),
                (this._drag.target = a(b.target)),
                (this._drag.stage.start = d),
                (this._drag.stage.current = d),
                (this._drag.pointer = this.pointer(b)),
                a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)),
                a(c).one(
                    "mousemove.owl.core touchmove.owl.core",
                    a.proxy(function (b) {
                        var d = this.difference(this._drag.pointer, this.pointer(b));
                        a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)), (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) || (b.preventDefault(), this.enter("dragging"), this.trigger("drag"));
                    }, this)
                ));
        }),
        (e.prototype.onDragMove = function (a) {
            var b = null,
                c = null,
                d = null,
                e = this.difference(this._drag.pointer, this.pointer(a)),
                f = this.difference(this._drag.stage.start, e);
            this.is("dragging") &&
                (a.preventDefault(),
                this.settings.loop
                    ? ((b = this.coordinates(this.minimum())), (c = this.coordinates(this.maximum() + 1) - b), (f.x = ((((f.x - b) % c) + c) % c) + b))
                    : ((b = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum())),
                      (c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum())),
                      (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
                      (f.x = Math.max(Math.min(f.x, b + d), c + d))),
                (this._drag.stage.current = f),
                this.animate(f.x));
        }),
        (e.prototype.onDragEnd = function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b)),
                e = this._drag.stage.current,
                f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
            a(c).off(".owl.core"),
                this.$element.removeClass(this.options.grabClass),
                ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
                    (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
                    this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
                    this.invalidate("position"),
                    this.update(),
                    (this._drag.direction = f),
                    (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
                        this._drag.target.one("click.owl.core", function () {
                            return !1;
                        })),
                this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
        }),
        (e.prototype.closest = function (b, c) {
            var e = -1,
                f = 30,
                g = this.width(),
                h = this.coordinates();
            return (
                this.settings.freeDrag ||
                    a.each(
                        h,
                        a.proxy(function (a, i) {
                            return (
                                "left" === c && b > i - f && b < i + f
                                    ? (e = a)
                                    : "right" === c && b > i - g - f && b < i - g + f
                                    ? (e = a + 1)
                                    : this.op(b, "<", i) && this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) && (e = "left" === c ? a + 1 : a),
                                -1 === e
                            );
                        }, this)
                    ),
                this.settings.loop || (this.op(b, ">", h[this.minimum()]) ? (e = b = this.minimum()) : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
                e
            );
        }),
        (e.prototype.animate = function (b) {
            var c = this.speed() > 0;
            this.is("animating") && this.onTransitionEnd(),
                c && (this.enter("animating"), this.trigger("translate")),
                a.support.transform3d && a.support.transition
                    ? this.$stage.css({ transform: "translate3d(" + b + "px,0px,0px)", transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "") })
                    : c
                    ? this.$stage.animate({ left: b + "px" }, this.speed(), this.settings.fallbackEasing, a.proxy(this.onTransitionEnd, this))
                    : this.$stage.css({ left: b + "px" });
        }),
        (e.prototype.is = function (a) {
            return this._states.current[a] && this._states.current[a] > 0;
        }),
        (e.prototype.current = function (a) {
            if (a === d) return this._current;
            if (0 === this._items.length) return d;
            if (((a = this.normalize(a)), this._current !== a)) {
                var b = this.trigger("change", { property: { name: "position", value: a } });
                b.data !== d && (a = this.normalize(b.data)), (this._current = a), this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } });
            }
            return this._current;
        }),
        (e.prototype.invalidate = function (b) {
            return (
                "string" === a.type(b) && ((this._invalidated[b] = !0), this.is("valid") && this.leave("valid")),
                a.map(this._invalidated, function (a, b) {
                    return b;
                })
            );
        }),
        (e.prototype.reset = function (a) {
            (a = this.normalize(a)) !== d && ((this._speed = 0), (this._current = a), this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"]));
        }),
        (e.prototype.normalize = function (a, b) {
            var c = this._items.length,
                e = b ? 0 : this._clones.length;
            return !this.isNumeric(a) || c < 1 ? (a = d) : (a < 0 || a >= c + e) && (a = ((((a - e / 2) % c) + c) % c) + e / 2), a;
        }),
        (e.prototype.relative = function (a) {
            return (a -= this._clones.length / 2), this.normalize(a, !0);
        }),
        (e.prototype.maximum = function (a) {
            var b,
                c,
                d,
                e = this.settings,
                f = this._coordinates.length;
            if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
            else if (e.autoWidth || e.merge) {
                if ((b = this._items.length)) for (c = this._items[--b].width(), d = this.$element.width(); b-- && !((c += this._items[b].width() + this.settings.margin) > d); );
                f = b + 1;
            } else f = e.center ? this._items.length - 1 : this._items.length - e.items;
            return a && (f -= this._clones.length / 2), Math.max(f, 0);
        }),
        (e.prototype.minimum = function (a) {
            return a ? 0 : this._clones.length / 2;
        }),
        (e.prototype.items = function (a) {
            return a === d ? this._items.slice() : ((a = this.normalize(a, !0)), this._items[a]);
        }),
        (e.prototype.mergers = function (a) {
            return a === d ? this._mergers.slice() : ((a = this.normalize(a, !0)), this._mergers[a]);
        }),
        (e.prototype.clones = function (b) {
            var c = this._clones.length / 2,
                e = c + this._items.length,
                f = function (a) {
                    return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
                };
            return b === d
                ? a.map(this._clones, function (a, b) {
                      return f(b);
                  })
                : a.map(this._clones, function (a, c) {
                      return a === b ? f(c) : null;
                  });
        }),
        (e.prototype.speed = function (a) {
            return a !== d && (this._speed = a), this._speed;
        }),
        (e.prototype.coordinates = function (b) {
            var c,
                e = 1,
                f = b - 1;
            return b === d
                ? a.map(
                      this._coordinates,
                      a.proxy(function (a, b) {
                          return this.coordinates(b);
                      }, this)
                  )
                : (this.settings.center ? (this.settings.rtl && ((e = -1), (f = b + 1)), (c = this._coordinates[b]), (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e)) : (c = this._coordinates[f] || 0), (c = Math.ceil(c)));
        }),
        (e.prototype.duration = function (a, b, c) {
            return 0 === c ? 0 : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
        }),
        (e.prototype.to = function (a, b) {
            var c = this.current(),
                d = null,
                e = a - this.relative(c),
                f = (e > 0) - (e < 0),
                g = this._items.length,
                h = this.minimum(),
                i = this.maximum();
            this.settings.loop
                ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g), (a = c + e), (d = ((((a - h) % g) + g) % g) + h) !== a && d - e <= i && d - e > 0 && ((c = d - e), (a = d), this.reset(c)))
                : this.settings.rewind
                ? ((i += 1), (a = ((a % i) + i) % i))
                : (a = Math.max(h, Math.min(i, a))),
                this.speed(this.duration(c, a, b)),
                this.current(a),
                this.isVisible() && this.update();
        }),
        (e.prototype.next = function (a) {
            (a = a || !1), this.to(this.relative(this.current()) + 1, a);
        }),
        (e.prototype.prev = function (a) {
            (a = a || !1), this.to(this.relative(this.current()) - 1, a);
        }),
        (e.prototype.onTransitionEnd = function (a) {
            if (a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))) return !1;
            this.leave("animating"), this.trigger("translated");
        }),
        (e.prototype.viewport = function () {
            var d;
            return (
                this.options.responsiveBaseElement !== b
                    ? (d = a(this.options.responsiveBaseElement).width())
                    : b.innerWidth
                    ? (d = b.innerWidth)
                    : c.documentElement && c.documentElement.clientWidth
                    ? (d = c.documentElement.clientWidth)
                    : console.warn("Can not detect viewport width."),
                d
            );
        }),
        (e.prototype.replace = function (b) {
            this.$stage.empty(),
                (this._items = []),
                b && (b = b instanceof jQuery ? b : a(b)),
                this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)),
                b
                    .filter(function () {
                        return 1 === this.nodeType;
                    })
                    .each(
                        a.proxy(function (a, b) {
                            (b = this.prepare(b)), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
                        }, this)
                    ),
                this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
                this.invalidate("items");
        }),
        (e.prototype.add = function (b, c) {
            var e = this.relative(this._current);
            (c = c === d ? this._items.length : this.normalize(c, !0)),
                (b = b instanceof jQuery ? b : a(b)),
                this.trigger("add", { content: b, position: c }),
                (b = this.prepare(b)),
                0 === this._items.length || c === this._items.length
                    ? (0 === this._items.length && this.$stage.append(b),
                      0 !== this._items.length && this._items[c - 1].after(b),
                      this._items.push(b),
                      this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1))
                    : (this._items[c].before(b), this._items.splice(c, 0, b), this._mergers.splice(c, 0, 1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
                this._items[e] && this.reset(this._items[e].index()),
                this.invalidate("items"),
                this.trigger("added", { content: b, position: c });
        }),
        (e.prototype.remove = function (a) {
            (a = this.normalize(a, !0)) !== d &&
                (this.trigger("remove", { content: this._items[a], position: a }),
                this._items[a].remove(),
                this._items.splice(a, 1),
                this._mergers.splice(a, 1),
                this.invalidate("items"),
                this.trigger("removed", { content: null, position: a }));
        }),
        (e.prototype.preloadAutoWidthImages = function (b) {
            b.each(
                a.proxy(function (b, c) {
                    this.enter("pre-loading"),
                        (c = a(c)),
                        a(new Image())
                            .one(
                                "load",
                                a.proxy(function (a) {
                                    c.attr("src", a.target.src), c.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh();
                                }, this)
                            )
                            .attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina"));
                }, this)
            );
        }),
        (e.prototype.destroy = function () {
            this.$element.off(".owl.core"), this.$stage.off(".owl.core"), a(c).off(".owl.core"), !1 !== this.settings.responsive && (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize));
            for (var d in this._plugins) this._plugins[d].destroy();
            this.$stage.children(".cloned").remove(),
                this.$stage.unwrap(),
                this.$stage.children().contents().unwrap(),
                this.$stage.children().unwrap(),
                this.$stage.remove(),
                this.$element
                    .removeClass(this.options.refreshClass)
                    .removeClass(this.options.loadingClass)
                    .removeClass(this.options.loadedClass)
                    .removeClass(this.options.rtlClass)
                    .removeClass(this.options.dragClass)
                    .removeClass(this.options.grabClass)
                    .attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), ""))
                    .removeData("owl.carousel");
        }),
        (e.prototype.op = function (a, b, c) {
            var d = this.settings.rtl;
            switch (b) {
                case "<":
                    return d ? a > c : a < c;
                case ">":
                    return d ? a < c : a > c;
                case ">=":
                    return d ? a <= c : a >= c;
                case "<=":
                    return d ? a >= c : a <= c;
            }
        }),
        (e.prototype.on = function (a, b, c, d) {
            a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c);
        }),
        (e.prototype.off = function (a, b, c, d) {
            a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c);
        }),
        (e.prototype.trigger = function (b, c, d, f, g) {
            var h = { item: { count: this._items.length, index: this.current() } },
                i = a.camelCase(
                    a
                        .grep(["on", b, d], function (a) {
                            return a;
                        })
                        .join("-")
                        .toLowerCase()
                ),
                j = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({ relatedTarget: this }, h, c));
            return (
                this._supress[b] ||
                    (a.each(this._plugins, function (a, b) {
                        b.onTrigger && b.onTrigger(j);
                    }),
                    this.register({ type: e.Type.Event, name: b }),
                    this.$element.trigger(j),
                    this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)),
                j
            );
        }),
        (e.prototype.enter = function (b) {
            a.each(
                [b].concat(this._states.tags[b] || []),
                a.proxy(function (a, b) {
                    this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++;
                }, this)
            );
        }),
        (e.prototype.leave = function (b) {
            a.each(
                [b].concat(this._states.tags[b] || []),
                a.proxy(function (a, b) {
                    this._states.current[b]--;
                }, this)
            );
        }),
        (e.prototype.register = function (b) {
            if (b.type === e.Type.Event) {
                if ((a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl)) {
                    var c = a.event.special[b.name]._default;
                    (a.event.special[b.name]._default = function (a) {
                        return !c || !c.apply || (a.namespace && -1 !== a.namespace.indexOf("owl")) ? a.namespace && a.namespace.indexOf("owl") > -1 : c.apply(this, arguments);
                    }),
                        (a.event.special[b.name].owl = !0);
                }
            } else
                b.type === e.Type.State &&
                    (this._states.tags[b.name] ? (this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags)) : (this._states.tags[b.name] = b.tags),
                    (this._states.tags[b.name] = a.grep(
                        this._states.tags[b.name],
                        a.proxy(function (c, d) {
                            return a.inArray(c, this._states.tags[b.name]) === d;
                        }, this)
                    )));
        }),
        (e.prototype.suppress = function (b) {
            a.each(
                b,
                a.proxy(function (a, b) {
                    this._supress[b] = !0;
                }, this)
            );
        }),
        (e.prototype.release = function (b) {
            a.each(
                b,
                a.proxy(function (a, b) {
                    delete this._supress[b];
                }, this)
            );
        }),
        (e.prototype.pointer = function (a) {
            var c = { x: null, y: null };
            return (
                (a = a.originalEvent || a || b.event),
                (a = a.touches && a.touches.length ? a.touches[0] : a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a),
                a.pageX ? ((c.x = a.pageX), (c.y = a.pageY)) : ((c.x = a.clientX), (c.y = a.clientY)),
                c
            );
        }),
        (e.prototype.isNumeric = function (a) {
            return !isNaN(parseFloat(a));
        }),
        (e.prototype.difference = function (a, b) {
            return { x: a.x - b.x, y: a.y - b.y };
        }),
        (a.fn.owlCarousel = function (b) {
            var c = Array.prototype.slice.call(arguments, 1);
            return this.each(function () {
                var d = a(this),
                    f = d.data("owl.carousel");
                f ||
                    ((f = new e(this, "object" == typeof b && b)),
                    d.data("owl.carousel", f),
                    a.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (b, c) {
                        f.register({ type: e.Type.Event, name: c }),
                            f.$element.on(
                                c + ".owl.carousel.core",
                                a.proxy(function (a) {
                                    a.namespace && a.relatedTarget !== this && (this.suppress([c]), f[c].apply(this, [].slice.call(arguments, 1)), this.release([c]));
                                }, f)
                            );
                    })),
                    "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
            });
        }),
        (a.fn.owlCarousel.Constructor = e);
})(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._interval = null),
                (this._visible = null),
                (this._handlers = {
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoRefresh && this.watch();
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        };
        (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
            (e.prototype.watch = function () {
                this._interval || ((this._visible = this._core.isVisible()), (this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval)));
            }),
            (e.prototype.refresh = function () {
                this._core.isVisible() !== this._visible && ((this._visible = !this._visible), this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
            }),
            (e.prototype.destroy = function () {
                var a, c;
                b.clearInterval(this._interval);
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._loaded = []),
                (this._handlers = {
                    "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (b) {
                        if (b.namespace && this._core.settings && this._core.settings.lazyLoad && ((b.property && "position" == b.property.name) || "initialized" == b.type)) {
                            var c = this._core.settings,
                                e = (c.center && Math.ceil(c.items / 2)) || c.items,
                                f = (c.center && -1 * e) || 0,
                                g = (b.property && b.property.value !== d ? b.property.value : this._core.current()) + f,
                                h = this._core.clones().length,
                                i = a.proxy(function (a, b) {
                                    this.load(b);
                                }, this);
                            for (c.lazyLoadEager > 0 && ((e += c.lazyLoadEager), c.loop && ((g -= c.lazyLoadEager), e++)); f++ < e; ) this.load(h / 2 + this._core.relative(g)), h && a.each(this._core.clones(this._core.relative(g)), i), g++;
                        }
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        };
        (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
            (e.prototype.load = function (c) {
                var d = this._core.$stage.children().eq(c),
                    e = d && d.find(".owl-lazy");
                !e ||
                    a.inArray(d.get(0), this._loaded) > -1 ||
                    (e.each(
                        a.proxy(function (c, d) {
                            var e,
                                f = a(d),
                                g = (b.devicePixelRatio > 1 && f.attr("data-src-retina")) || f.attr("data-src") || f.attr("data-srcset");
                            this._core.trigger("load", { element: f, url: g }, "lazy"),
                                f.is("img")
                                    ? f
                                          .one(
                                              "load.owl.lazy",
                                              a.proxy(function () {
                                                  f.css("opacity", 1), this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                              }, this)
                                          )
                                          .attr("src", g)
                                    : f.is("source")
                                    ? f
                                          .one(
                                              "load.owl.lazy",
                                              a.proxy(function () {
                                                  this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                              }, this)
                                          )
                                          .attr("srcset", g)
                                    : ((e = new Image()),
                                      (e.onload = a.proxy(function () {
                                          f.css({ "background-image": 'url("' + g + '")', opacity: "1" }), this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                      }, this)),
                                      (e.src = g));
                        }, this)
                    ),
                    this._loaded.push(d.get(0)));
            }),
            (e.prototype.destroy = function () {
                var a, b;
                for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (c) {
            (this._core = c),
                (this._previousHeight = null),
                (this._handlers = {
                    "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoHeight && this.update();
                    }, this),
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoHeight && "position" === a.property.name && this.update();
                    }, this),
                    "loaded.owl.lazy": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                (this._intervalId = null);
            var d = this;
            a(b).on("load", function () {
                d._core.settings.autoHeight && d.update();
            }),
                a(b).resize(function () {
                    d._core.settings.autoHeight &&
                        (null != d._intervalId && clearTimeout(d._intervalId),
                        (d._intervalId = setTimeout(function () {
                            d.update();
                        }, 250)));
                });
        };
        (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
            (e.prototype.update = function () {
                var b = this._core._current,
                    c = b + this._core.settings.items,
                    d = this._core.settings.lazyLoad,
                    e = this._core.$stage.children().toArray().slice(b, c),
                    f = [],
                    g = 0;
                a.each(e, function (b, c) {
                    f.push(a(c).height());
                }),
                    (g = Math.max.apply(null, f)),
                    g <= 1 && d && this._previousHeight && (g = this._previousHeight),
                    (this._previousHeight = g),
                    this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass);
            }),
            (e.prototype.destroy = function () {
                var a, b;
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._videos = {}),
                (this._playing = null),
                (this._handlers = {
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
                    }, this),
                    "resize.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault();
                    }, this),
                    "refreshed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
                    }, this),
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && "position" === a.property.name && this._playing && this.stop();
                    }, this),
                    "prepared.owl.carousel": a.proxy(function (b) {
                        if (b.namespace) {
                            var c = a(b.content).find(".owl-video");
                            c.length && (c.css("display", "none"), this.fetch(c, a(b.content)));
                        }
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                this._core.$element.on(
                    "click.owl.video",
                    ".owl-video-play-icon",
                    a.proxy(function (a) {
                        this.play(a);
                    }, this)
                );
        };
        (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
            (e.prototype.fetch = function (a, b) {
                var c = (function () {
                        return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube";
                    })(),
                    d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"),
                    e = a.attr("data-width") || this._core.settings.videoWidth,
                    f = a.attr("data-height") || this._core.settings.videoHeight,
                    g = a.attr("href");
                if (!g) throw new Error("Missing video URL.");
                if (
                    ((d = g.match(
                        /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
                    )),
                    d[3].indexOf("youtu") > -1)
                )
                    c = "youtube";
                else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
                else {
                    if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
                    c = "vzaar";
                }
                (d = d[6]), (this._videos[g] = { type: c, id: d, width: e, height: f }), b.attr("data-video", g), this.thumbnail(a, this._videos[g]);
            }),
            (e.prototype.thumbnail = function (b, c) {
                var d,
                    e,
                    f,
                    g = c.width && c.height ? "width:" + c.width + "px;height:" + c.height + "px;" : "",
                    h = b.find("img"),
                    i = "src",
                    j = "",
                    k = this._core.settings,
                    l = function (c) {
                        (e = '<div class="owl-video-play-icon"></div>'),
                            (d = k.lazyLoad ? a("<div/>", { class: "owl-video-tn " + j, srcType: c }) : a("<div/>", { class: "owl-video-tn", style: "opacity:1;background-image:url(" + c + ")" })),
                            b.after(d),
                            b.after(e);
                    };
                if ((b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })), this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")), h.length)) return l(h.attr(i)), h.remove(), !1;
                "youtube" === c.type
                    ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
                    : "vimeo" === c.type
                    ? a.ajax({
                          type: "GET",
                          url: "//vimeo.com/api/v2/video/" + c.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (a) {
                              (f = a[0].thumbnail_large), l(f);
                          },
                      })
                    : "vzaar" === c.type &&
                      a.ajax({
                          type: "GET",
                          url: "//vzaar.com/api/videos/" + c.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (a) {
                              (f = a.framegrab_url), l(f);
                          },
                      });
            }),
            (e.prototype.stop = function () {
                this._core.trigger("stop", null, "video"),
                    this._playing.find(".owl-video-frame").remove(),
                    this._playing.removeClass("owl-video-playing"),
                    (this._playing = null),
                    this._core.leave("playing"),
                    this._core.trigger("stopped", null, "video");
            }),
            (e.prototype.play = function (b) {
                var c,
                    d = a(b.target),
                    e = d.closest("." + this._core.settings.itemClass),
                    f = this._videos[e.attr("data-video")],
                    g = f.width || "100%",
                    h = f.height || this._core.$stage.height();
                this._playing ||
                    (this._core.enter("playing"),
                    this._core.trigger("play", null, "video"),
                    (e = this._core.items(this._core.relative(e.index()))),
                    this._core.reset(e.index()),
                    (c = a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')),
                    c.attr("height", h),
                    c.attr("width", g),
                    "youtube" === f.type
                        ? c.attr("src", "//www.youtube.com/embed/" + f.id + "?autoplay=1&rel=0&v=" + f.id)
                        : "vimeo" === f.type
                        ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1")
                        : "vzaar" === f.type && c.attr("src", "//view.vzaar.com/" + f.id + "/player?autoplay=true"),
                    a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),
                    (this._playing = e.addClass("owl-video-playing")));
            }),
            (e.prototype.isInFullScreen = function () {
                var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
                return b && a(b).parent().hasClass("owl-video-frame");
            }),
            (e.prototype.destroy = function () {
                var a, b;
                this._core.$element.off("click.owl.video");
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Video = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this.core = b),
                (this.core.options = a.extend({}, e.Defaults, this.core.options)),
                (this.swapping = !0),
                (this.previous = d),
                (this.next = d),
                (this.handlers = {
                    "change.owl.carousel": a.proxy(function (a) {
                        a.namespace && "position" == a.property.name && ((this.previous = this.core.current()), (this.next = a.property.value));
                    }, this),
                    "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
                        a.namespace && (this.swapping = "translated" == a.type);
                    }, this),
                    "translate.owl.carousel": a.proxy(function (a) {
                        a.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
                    }, this),
                }),
                this.core.$element.on(this.handlers);
        };
        (e.Defaults = { animateOut: !1, animateIn: !1 }),
            (e.prototype.swap = function () {
                if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
                    this.core.speed(0);
                    var b,
                        c = a.proxy(this.clear, this),
                        d = this.core.$stage.children().eq(this.previous),
                        e = this.core.$stage.children().eq(this.next),
                        f = this.core.settings.animateIn,
                        g = this.core.settings.animateOut;
                    this.core.current() !== this.previous &&
                        (g &&
                            ((b = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
                            d
                                .one(a.support.animation.end, c)
                                .css({ left: b + "px" })
                                .addClass("animated owl-animated-out")
                                .addClass(g)),
                        f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f));
                }
            }),
            (e.prototype.clear = function (b) {
                a(b.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
            }),
            (e.prototype.destroy = function () {
                var a, b;
                for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._call = null),
                (this._time = 0),
                (this._timeout = 0),
                (this._paused = !0),
                (this._handlers = {
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && "settings" === a.property.name ? (this._core.settings.autoplay ? this.play() : this.stop()) : a.namespace && "position" === a.property.name && this._paused && (this._time = 0);
                    }, this),
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoplay && this.play();
                    }, this),
                    "play.owl.autoplay": a.proxy(function (a, b, c) {
                        a.namespace && this.play(b, c);
                    }, this),
                    "stop.owl.autoplay": a.proxy(function (a) {
                        a.namespace && this.stop();
                    }, this),
                    "mouseover.owl.autoplay": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "mouseleave.owl.autoplay": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
                    }, this),
                    "touchstart.owl.core": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "touchend.owl.core": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this.play();
                    }, this),
                }),
                this._core.$element.on(this._handlers),
                (this._core.options = a.extend({}, e.Defaults, this._core.options));
        };
        (e.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }),
            (e.prototype._next = function (d) {
                (this._call = b.setTimeout(a.proxy(this._next, this, d), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read())),
                    this._core.is("interacting") || c.hidden || this._core.next(d || this._core.settings.autoplaySpeed);
            }),
            (e.prototype.read = function () {
                return new Date().getTime() - this._time;
            }),
            (e.prototype.play = function (c, d) {
                var e;
                this._core.is("rotating") || this._core.enter("rotating"),
                    (c = c || this._core.settings.autoplayTimeout),
                    (e = Math.min(this._time % (this._timeout || c), c)),
                    this._paused ? ((this._time = this.read()), (this._paused = !1)) : b.clearTimeout(this._call),
                    (this._time += (this.read() % c) - e),
                    (this._timeout = c),
                    (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
            }),
            (e.prototype.stop = function () {
                this._core.is("rotating") && ((this._time = 0), (this._paused = !0), b.clearTimeout(this._call), this._core.leave("rotating"));
            }),
            (e.prototype.pause = function () {
                this._core.is("rotating") && !this._paused && ((this._time = this.read()), (this._paused = !0), b.clearTimeout(this._call));
            }),
            (e.prototype.destroy = function () {
                var a, b;
                this.stop();
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        "use strict";
        var e = function (b) {
            (this._core = b),
                (this._initialized = !1),
                (this._pages = []),
                (this._controls = {}),
                (this._templates = []),
                (this.$element = this._core.$element),
                (this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }),
                (this._handlers = {
                    "prepared.owl.carousel": a.proxy(function (b) {
                        b.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
                    }, this),
                    "added.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 0, this._templates.pop());
                    }, this),
                    "remove.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1);
                    }, this),
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && "position" == a.property.name && this.draw();
                    }, this),
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace &&
                            !this._initialized &&
                            (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), (this._initialized = !0), this._core.trigger("initialized", null, "navigation"));
                    }, this),
                    "refreshed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this.$element.on(this._handlers);
        };
        (e.Defaults = {
            nav: !1,
            navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
            navSpeed: !1,
            navElement: 'button type="button" role="presentation"',
            navContainer: !1,
            navContainerClass: "owl-nav",
            navClass: ["owl-prev", "owl-next"],
            slideBy: 1,
            dotClass: "owl-dot",
            dotsClass: "owl-dots",
            dots: !0,
            dotsEach: !1,
            dotsData: !1,
            dotsSpeed: !1,
            dotsContainer: !1,
        }),
            (e.prototype.initialize = function () {
                var b,
                    c = this._core.settings;
                (this._controls.$relative = (c.navContainer ? a(c.navContainer) : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled")),
                    (this._controls.$previous = a("<" + c.navElement + ">")
                        .addClass(c.navClass[0])
                        .html(c.navText[0])
                        .prependTo(this._controls.$relative)
                        .on(
                            "click",
                            a.proxy(function (a) {
                                this.prev(c.navSpeed);
                            }, this)
                        )),
                    (this._controls.$next = a("<" + c.navElement + ">")
                        .addClass(c.navClass[1])
                        .html(c.navText[1])
                        .appendTo(this._controls.$relative)
                        .on(
                            "click",
                            a.proxy(function (a) {
                                this.next(c.navSpeed);
                            }, this)
                        )),
                    c.dotsData || (this._templates = [a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),
                    (this._controls.$absolute = (c.dotsContainer ? a(c.dotsContainer) : a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled")),
                    this._controls.$absolute.on(
                        "click",
                        "button",
                        a.proxy(function (b) {
                            var d = a(b.target).parent().is(this._controls.$absolute) ? a(b.target).index() : a(b.target).parent().index();
                            b.preventDefault(), this.to(d, c.dotsSpeed);
                        }, this)
                    );
                for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
            }),
            (e.prototype.destroy = function () {
                var a, b, c, d, e;
                e = this._core.settings;
                for (a in this._handlers) this.$element.off(a, this._handlers[a]);
                for (b in this._controls) "$relative" === b && e.navContainer ? this._controls[b].html("") : this._controls[b].remove();
                for (d in this.overides) this._core[d] = this._overrides[d];
                for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null);
            }),
            (e.prototype.update = function () {
                var a,
                    b,
                    c,
                    d = this._core.clones().length / 2,
                    e = d + this._core.items().length,
                    f = this._core.maximum(!0),
                    g = this._core.settings,
                    h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
                if (("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || "page" == g.slideBy))
                    for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
                        if (b >= h || 0 === b) {
                            if ((this._pages.push({ start: Math.min(f, a - d), end: a - d + h - 1 }), Math.min(f, a - d) === f)) break;
                            (b = 0), ++c;
                        }
                        b += this._core.mergers(this._core.relative(a));
                    }
            }),
            (e.prototype.draw = function () {
                var b,
                    c = this._core.settings,
                    d = this._core.items().length <= c.items,
                    e = this._core.relative(this._core.current()),
                    f = c.loop || c.rewind;
                this._controls.$relative.toggleClass("disabled", !c.nav || d),
                    c.nav && (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))),
                    this._controls.$absolute.toggleClass("disabled", !c.dots || d),
                    c.dots &&
                        ((b = this._pages.length - this._controls.$absolute.children().length),
                        c.dotsData && 0 !== b
                            ? this._controls.$absolute.html(this._templates.join(""))
                            : b > 0
                            ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0]))
                            : b < 0 && this._controls.$absolute.children().slice(b).remove(),
                        this._controls.$absolute.find(".active").removeClass("active"),
                        this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass("active"));
            }),
            (e.prototype.onTrigger = function (b) {
                var c = this._core.settings;
                b.page = { index: a.inArray(this.current(), this._pages), count: this._pages.length, size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items) };
            }),
            (e.prototype.current = function () {
                var b = this._core.relative(this._core.current());
                return a
                    .grep(
                        this._pages,
                        a.proxy(function (a, c) {
                            return a.start <= b && a.end >= b;
                        }, this)
                    )
                    .pop();
            }),
            (e.prototype.getPosition = function (b) {
                var c,
                    d,
                    e = this._core.settings;
                return (
                    "page" == e.slideBy
                        ? ((c = a.inArray(this.current(), this._pages)), (d = this._pages.length), b ? ++c : --c, (c = this._pages[((c % d) + d) % d].start))
                        : ((c = this._core.relative(this._core.current())), (d = this._core.items().length), b ? (c += e.slideBy) : (c -= e.slideBy)),
                    c
                );
            }),
            (e.prototype.next = function (b) {
                a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
            }),
            (e.prototype.prev = function (b) {
                a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
            }),
            (e.prototype.to = function (b, c, d) {
                var e;
                !d && this._pages.length ? ((e = this._pages.length), a.proxy(this._overrides.to, this._core)(this._pages[((b % e) + e) % e].start, c)) : a.proxy(this._overrides.to, this._core)(b, c);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        "use strict";
        var e = function (c) {
            (this._core = c),
                (this._hashes = {}),
                (this.$element = this._core.$element),
                (this._handlers = {
                    "initialized.owl.carousel": a.proxy(function (c) {
                        c.namespace && "URLHash" === this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation");
                    }, this),
                    "prepared.owl.carousel": a.proxy(function (b) {
                        if (b.namespace) {
                            var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                            if (!c) return;
                            this._hashes[c] = b.content;
                        }
                    }, this),
                    "changed.owl.carousel": a.proxy(function (c) {
                        if (c.namespace && "position" === c.property.name) {
                            var d = this._core.items(this._core.relative(this._core.current())),
                                e = a
                                    .map(this._hashes, function (a, b) {
                                        return a === d ? b : null;
                                    })
                                    .join();
                            if (!e || b.location.hash.slice(1) === e) return;
                            b.location.hash = e;
                        }
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this.$element.on(this._handlers),
                a(b).on(
                    "hashchange.owl.navigation",
                    a.proxy(function (a) {
                        var c = b.location.hash.substring(1),
                            e = this._core.$stage.children(),
                            f = this._hashes[c] && e.index(this._hashes[c]);
                        f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0);
                    }, this)
                );
        };
        (e.Defaults = { URLhashListener: !1 }),
            (e.prototype.destroy = function () {
                var c, d;
                a(b).off("hashchange.owl.navigation");
                for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
                for (d in Object.getOwnPropertyNames(this)) "function" != typeof this[d] && (this[d] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        function e(b, c) {
            var e = !1,
                f = b.charAt(0).toUpperCase() + b.slice(1);
            return (
                a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
                    if (g[b] !== d) return (e = !c || b), !1;
                }),
                e
            );
        }
        function f(a) {
            return e(a, !0);
        }
        var g = a("<support>").get(0).style,
            h = "Webkit Moz O ms".split(" "),
            i = {
                transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } },
                animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } },
            },
            j = {
                csstransforms: function () {
                    return !!e("transform");
                },
                csstransforms3d: function () {
                    return !!e("perspective");
                },
                csstransitions: function () {
                    return !!e("transition");
                },
                cssanimations: function () {
                    return !!e("animation");
                },
            };
        j.csstransitions() && ((a.support.transition = new String(f("transition"))), (a.support.transition.end = i.transition.end[a.support.transition])),
            j.cssanimations() && ((a.support.animation = new String(f("animation"))), (a.support.animation.end = i.animation.end[a.support.animation])),
            j.csstransforms() && ((a.support.transform = new String(f("transform"))), (a.support.transform3d = j.csstransforms3d()));
    })(window.Zepto || window.jQuery, window, document);
jQuery(function ($) {
    "use strict";
    try {
        $(document.body).on("fgf-enhanced-carousel", function () {
            var owl_carousels = $(".fgf-owl-carousel-items");
            if (!owl_carousels.length) {
                return;
            }
            owl_carousels.each(function (e) {
                $(this).owlCarousel({
                    loop: true,
                    margin: parseInt(fgf_carousel_params.item_margin),
                    responsiveClass: true,
                    nav: "true" === fgf_carousel_params.nav,
                    navText: [fgf_carousel_params.nav_prev_text, fgf_carousel_params.nav_next_text],
                    autoplay: "true" === fgf_carousel_params.auto_play,
                    dots: "true" === fgf_carousel_params.pagination,
                    slideBy: fgf_carousel_params.item_per_slide,
                    autoplayTimeout: fgf_carousel_params.slide_speed,
                    autoplayHoverPause: true,
                    responsive: { 0: { items: 1 }, 600: { items: 2 }, 1000: { items: fgf_carousel_params.per_page } },
                });
            });
        });
        $(document.body).on("updated_wc_div", function () {
            $(document.body).trigger("fgf-enhanced-carousel");
        });
        $(document.body).trigger("fgf-enhanced-carousel");
    } catch (err) {
        window.console.log(err);
    }
});
!(function (t) {
    "use strict";
    var e = {
        cache: {},
        support: {},
        objects: {},
        init: function (e) {
            return this.each(function () {
                t(this)
                    .unbind("click.lightcase")
                    .bind("click.lightcase", function (i) {
                        i.preventDefault(), t(this).lightcase("start", e);
                    });
            });
        },
        start: function (i) {
            (e.origin = lightcase.origin = this),
                (e.settings = lightcase.settings = t.extend(
                    !0,
                    {
                        idPrefix: "lightcase-",
                        classPrefix: "lightcase-",
                        attrPrefix: "lc-",
                        transition: "elastic",
                        transitionOpen: null,
                        transitionClose: null,
                        transitionIn: null,
                        transitionOut: null,
                        cssTransitions: !0,
                        speedIn: 250,
                        speedOut: 250,
                        width: null,
                        height: null,
                        maxWidth: 800,
                        maxHeight: 500,
                        forceWidth: !1,
                        forceHeight: !1,
                        liveResize: !0,
                        fullScreenModeForMobile: !0,
                        mobileMatchExpression: /(iphone|ipod|ipad|android|blackberry|symbian)/,
                        disableShrink: !1,
                        fixedRatio: !0,
                        shrinkFactor: 0.75,
                        overlayOpacity: 0.9,
                        slideshow: !1,
                        slideshowAutoStart: !0,
                        breakBeforeShow: !1,
                        timeout: 5e3,
                        swipe: !0,
                        useKeys: !0,
                        useCategories: !0,
                        useAsCollection: !1,
                        navigateEndless: !0,
                        closeOnOverlayClick: !0,
                        title: null,
                        caption: null,
                        showTitle: !0,
                        showCaption: !0,
                        showSequenceInfo: !0,
                        inline: { width: "auto", height: "auto" },
                        ajax: { width: "auto", height: "auto", type: "get", dataType: "html", data: {} },
                        iframe: { width: 800, height: 500, frameborder: 0 },
                        flash: { width: 400, height: 205, wmode: "transparent" },
                        video: { width: 400, height: 225, poster: "", preload: "auto", controls: !0, autobuffer: !0, autoplay: !0, loop: !1 },
                        attr: "data-rel",
                        href: null,
                        type: null,
                        typeMapping: { image: "jpg,jpeg,gif,png,bmp", flash: "swf", video: "mp4,mov,ogv,ogg,webm", iframe: "html,php", ajax: "json,txt", inline: "#" },
                        errorMessage: function () {
                            return '<p class="' + e.settings.classPrefix + 'error">' + e.settings.labels.errorMessage + "</p>";
                        },
                        labels: { errorMessage: "Source could not be found...", "sequenceInfo.of": " of ", close: "Close", "navigator.prev": "Prev", "navigator.next": "Next", "navigator.play": "Play", "navigator.pause": "Pause" },
                        markup: function () {
                            e.objects.body.append(
                                (e.objects.overlay = t('<div id="' + e.settings.idPrefix + 'overlay"></div>')),
                                (e.objects.loading = t('<div id="' + e.settings.idPrefix + 'loading" class="' + e.settings.classPrefix + 'icon-spin"></div>')),
                                (e.objects.case = t('<div id="' + e.settings.idPrefix + 'case" aria-hidden="true" role="dialog"></div>'))
                            ),
                                e.objects.case.after(
                                    (e.objects.close = t('<a href="#" class="' + e.settings.classPrefix + 'icon-close"><span>' + e.settings.labels.close + "</span></a>")),
                                    (e.objects.nav = t('<div id="' + e.settings.idPrefix + 'nav"></div>'))
                                ),
                                e.objects.nav.append(
                                    (e.objects.prev = t('<a href="#" class="' + e.settings.classPrefix + 'icon-prev"><span>' + e.settings.labels["navigator.prev"] + "</span></a>").hide()),
                                    (e.objects.next = t('<a href="#" class="' + e.settings.classPrefix + 'icon-next"><span>' + e.settings.labels["navigator.next"] + "</span></a>").hide()),
                                    (e.objects.play = t('<a href="#" class="' + e.settings.classPrefix + 'icon-play"><span>' + e.settings.labels["navigator.play"] + "</span></a>").hide()),
                                    (e.objects.pause = t('<a href="#" class="' + e.settings.classPrefix + 'icon-pause"><span>' + e.settings.labels["navigator.pause"] + "</span></a>").hide())
                                ),
                                e.objects.case.append((e.objects.content = t('<div id="' + e.settings.idPrefix + 'content"></div>')), (e.objects.info = t('<div id="' + e.settings.idPrefix + 'info"></div>'))),
                                e.objects.content.append((e.objects.contentInner = t('<div class="' + e.settings.classPrefix + 'contentInner"></div>'))),
                                e.objects.info.append(
                                    (e.objects.sequenceInfo = t('<div id="' + e.settings.idPrefix + 'sequenceInfo"></div>')),
                                    (e.objects.title = t('<h4 id="' + e.settings.idPrefix + 'title"></h4>')),
                                    (e.objects.caption = t('<p id="' + e.settings.idPrefix + 'caption"></p>'))
                                );
                        },
                        onInit: {},
                        onStart: {},
                        onBeforeCalculateDimensions: {},
                        onAfterCalculateDimensions: {},
                        onBeforeShow: {},
                        onFinish: {},
                        onResize: {},
                        onClose: {},
                        onCleanup: {},
                    },
                    i,
                    e.origin.data ? e.origin.data("lc-options") : {}
                )),
                (e.objects.document = t("html")),
                (e.objects.body = t("body")),
                e._callHooks(e.settings.onInit),
                (e.objectData = e._setObjectData(this)),
                e._addElements(),
                e._open(),
                (e.dimensions = e.getViewportDimensions());
        },
        get: function (t) {
            return e.objects[t];
        },
        getObjectData: function () {
            return e.objectData;
        },
        _setObjectData: function (i) {
            var s = t(i),
                n = {
                    this: t(i),
                    title: e.settings.title || s.attr(e._prefixAttributeName("title")) || s.attr("title"),
                    caption: e.settings.caption || s.attr(e._prefixAttributeName("caption")) || s.children("img").attr("alt"),
                    url: e._determineUrl(),
                    requestType: e.settings.ajax.type,
                    requestData: e.settings.ajax.data,
                    requestDataType: e.settings.ajax.dataType,
                    rel: s.attr(e._determineAttributeSelector()),
                    type: e.settings.type || e._verifyDataType(e._determineUrl()),
                    isPartOfSequence: e.settings.useAsCollection || e._isPartOfSequence(s.attr(e.settings.attr), ":"),
                    isPartOfSequenceWithSlideshow: e._isPartOfSequence(s.attr(e.settings.attr), ":slideshow"),
                    currentIndex: t(e._determineAttributeSelector()).index(s),
                    sequenceLength: t(e._determineAttributeSelector()).length,
                };
            return (n.sequenceInfo = n.currentIndex + 1 + e.settings.labels["sequenceInfo.of"] + n.sequenceLength), (n.prevIndex = n.currentIndex - 1), (n.nextIndex = n.currentIndex + 1), n;
        },
        _prefixAttributeName: function (t) {
            return "data-" + e.settings.attrPrefix + t;
        },
        _determineLinkTarget: function () {
            return e.settings.href || t(e.origin).attr(e._prefixAttributeName("href")) || t(e.origin).attr("href");
        },
        _determineAttributeSelector: function () {
            var i = t(e.origin),
                s = "";
            if (void 0 !== e.cache.selector) s = e.cache.selector;
            else if (!0 === e.settings.useCategories && i.attr(e._prefixAttributeName("categories"))) {
                var n = i.attr(e._prefixAttributeName("categories")).split(" ");
                t.each(n, function (t, i) {
                    t > 0 && (s += ","), (s += "[" + e._prefixAttributeName("categories") + '~="' + i + '"]');
                });
            } else s = "[" + e.settings.attr + '="' + i.attr(e.settings.attr) + '"]';
            return (e.cache.selector = s), s;
        },
        _determineUrl: function () {
            var i,
                s = e._verifyDataUrl(e._determineLinkTarget()),
                n = 0,
                a = 0,
                o = "";
            return (
                t.each(s, function (t, s) {
                    switch (e._verifyDataType(s.url)) {
                        case "video":
                            var c = document.createElement("video"),
                                r = e._verifyDataType(s.url) + "/" + e._getFileUrlSuffix(s.url);
                            "probably" !== o && o !== c.canPlayType(r) && "" !== c.canPlayType(r) && ((o = c.canPlayType(r)), (i = s.url));
                            break;
                        default:
                            e._devicePixelRatio() >= s.density && s.density >= a && e._matchMedia()("screen and (min-width:" + s.width + "px)").matches && s.width >= n && ((n = s.width), (a = s.density), (i = s.url));
                    }
                }),
                i
            );
        },
        _normalizeUrl: function (t) {
            var e = /^\d+$/;
            return t.split(",").map(function (t) {
                var i = { width: 0, density: 0 };
                return (
                    t
                        .trim()
                        .split(/\s+/)
                        .forEach(function (t, s) {
                            if (0 === s) return (i.url = t);
                            var n = t.substring(0, t.length - 1),
                                a = t[t.length - 1],
                                o = parseInt(n, 10),
                                c = parseFloat(n);
                            "w" === a && e.test(n) ? (i.width = o) : "h" === a && e.test(n) ? (i.height = o) : "x" !== a || isNaN(c) || (i.density = c);
                        }),
                    i
                );
            });
        },
        _isPartOfSequence: function (i, s) {
            var n = t("[" + e.settings.attr + '="' + i + '"]');
            return new RegExp(s).test(i) && n.length > 1;
        },
        isSlideshowEnabled: function () {
            return e.objectData.isPartOfSequence && (!0 === e.settings.slideshow || !0 === e.objectData.isPartOfSequenceWithSlideshow);
        },
        _loadContent: function () {
            e.cache.originalObject && e._restoreObject(), e._createObject();
        },
        _createObject: function () {
            var i;
            switch (e.objectData.type) {
                case "image":
                    (i = t(new Image())).attr({ src: e.objectData.url, alt: e.objectData.title });
                    break;
                case "inline":
                    (i = t('<div class="' + e.settings.classPrefix + 'inlineWrap"></div>')).html(e._cloneObject(t(e.objectData.url))),
                        t.each(e.settings.inline, function (t, s) {
                            i.attr(e._prefixAttributeName(t), s);
                        });
                    break;
                case "ajax":
                    (i = t('<div class="' + e.settings.classPrefix + 'inlineWrap"></div>')),
                        t.each(e.settings.ajax, function (t, s) {
                            "data" !== t && i.attr(e._prefixAttributeName(t), s);
                        });
                    break;
                case "flash":
                    (i = t('<embed src="' + e.objectData.url + '" type="application/x-shockwave-flash"></embed>')),
                        t.each(e.settings.flash, function (t, e) {
                            i.attr(t, e);
                        });
                    break;
                case "video":
                    (i = t("<video></video>")).attr("src", e.objectData.url),
                        t.each(e.settings.video, function (t, e) {
                            i.attr(t, e);
                        });
                    break;
                default:
                    (i = t("<iframe></iframe>")).attr({ src: e.objectData.url }),
                        t.each(e.settings.iframe, function (t, e) {
                            i.attr(t, e);
                        });
            }
            e._addObject(i), e._loadObject(i);
        },
        _addObject: function (t) {
            e.objects.contentInner.html(t),
                e._loading("start"),
                e._callHooks(e.settings.onStart),
                !0 === e.settings.showSequenceInfo && e.objectData.isPartOfSequence ? (e.objects.sequenceInfo.html(e.objectData.sequenceInfo), e.objects.sequenceInfo.show()) : (e.objects.sequenceInfo.empty(), e.objects.sequenceInfo.hide()),
                !0 === e.settings.showTitle && void 0 !== e.objectData.title && "" !== e.objectData.title ? (e.objects.title.html(e.objectData.title), e.objects.title.show()) : (e.objects.title.empty(), e.objects.title.hide()),
                !0 === e.settings.showCaption && void 0 !== e.objectData.caption && "" !== e.objectData.caption
                    ? (e.objects.caption.html(e.objectData.caption), e.objects.caption.show())
                    : (e.objects.caption.empty(), e.objects.caption.hide());
        },
        _loadObject: function (i) {
            switch (e.objectData.type) {
                case "inline":
                    t(e.objectData.url) ? e._showContent(i) : e.error();
                    break;
                case "ajax":
                    t.ajax(
                        t.extend({}, e.settings.ajax, {
                            url: e.objectData.url,
                            type: e.objectData.requestType,
                            dataType: e.objectData.requestDataType,
                            data: e.objectData.requestData,
                            success: function (t, s, n) {
                                n.getResponseHeader("X-Ajax-Location")
                                    ? ((e.objectData.url = n.getResponseHeader("X-Ajax-Location")), e._loadObject(i))
                                    : ("json" === e.objectData.requestDataType ? (e.objectData.data = t) : i.html(t), e._showContent(i));
                            },
                            error: function (t, i, s) {
                                e.error();
                            },
                        })
                    );
                    break;
                case "flash":
                    e._showContent(i);
                    break;
                case "video":
                    "function" == typeof i.get(0).canPlayType || 0 === e.objects.case.find("video").length ? e._showContent(i) : e.error();
                    break;
                default:
                    e.objectData.url
                        ? (i.on("load", function () {
                              e._showContent(i);
                          }),
                          i.on("error", function () {
                              e.error();
                          }))
                        : e.error();
            }
        },
        error: function () {
            e.objectData.type = "error";
            var i = t('<div class="' + e.settings.classPrefix + 'inlineWrap"></div>');
            i.html(e.settings.errorMessage), e.objects.contentInner.html(i), e._showContent(e.objects.contentInner);
        },
        _calculateDimensions: function (t) {
            if ((e._cleanupDimensions(), t)) {
                var i = { ratio: 1, objectWidth: t.attr("width") ? t.attr("width") : t.attr(e._prefixAttributeName("width")), objectHeight: t.attr("height") ? t.attr("height") : t.attr(e._prefixAttributeName("height")) };
                if (!e.settings.disableShrink)
                    switch (
                        ((i.maxWidth = parseInt(e.dimensions.windowWidth * e.settings.shrinkFactor)),
                        (i.maxHeight = parseInt(e.dimensions.windowHeight * e.settings.shrinkFactor)),
                        i.maxWidth > e.settings.maxWidth && (i.maxWidth = e.settings.maxWidth),
                        i.maxHeight > e.settings.maxHeight && (i.maxHeight = e.settings.maxHeight),
                        (i.differenceWidthAsPercent = parseInt((100 / i.maxWidth) * i.objectWidth)),
                        (i.differenceHeightAsPercent = parseInt((100 / i.maxHeight) * i.objectHeight)),
                        e.objectData.type)
                    ) {
                        case "image":
                        case "flash":
                        case "video":
                        case "iframe":
                        case "ajax":
                        case "inline":
                            if ("image" === e.objectData.type || !0 === e.settings.fixedRatio) {
                                i.differenceWidthAsPercent > 100 &&
                                    i.differenceWidthAsPercent > i.differenceHeightAsPercent &&
                                    ((i.objectWidth = i.maxWidth), (i.objectHeight = parseInt((i.objectHeight / i.differenceWidthAsPercent) * 100))),
                                    i.differenceHeightAsPercent > 100 &&
                                        i.differenceHeightAsPercent > i.differenceWidthAsPercent &&
                                        ((i.objectWidth = parseInt((i.objectWidth / i.differenceHeightAsPercent) * 100)), (i.objectHeight = i.maxHeight)),
                                    i.differenceHeightAsPercent > 100 &&
                                        i.differenceWidthAsPercent < i.differenceHeightAsPercent &&
                                        ((i.objectWidth = parseInt((i.maxWidth / i.differenceHeightAsPercent) * i.differenceWidthAsPercent)), (i.objectHeight = i.maxHeight));
                                break;
                            }
                        case "error":
                            !isNaN(i.objectWidth) && i.objectWidth > i.maxWidth && (i.objectWidth = i.maxWidth);
                            break;
                        default:
                            (isNaN(i.objectWidth) || i.objectWidth > i.maxWidth) && !e.settings.forceWidth && (i.objectWidth = i.maxWidth),
                                ((isNaN(i.objectHeight) && "auto" !== i.objectHeight) || i.objectHeight > i.maxHeight) && !e.settings.forceHeight && (i.objectHeight = i.maxHeight);
                    }
                if (e.settings.forceWidth) {
                    try {
                        i.objectWidth = e.settings[e.objectData.type].width;
                    } catch (t) {
                        i.objectWidth = e.settings.width || i.objectWidth;
                    }
                    i.maxWidth = null;
                }
                if ((t.attr(e._prefixAttributeName("max-width")) && (i.maxWidth = t.attr(e._prefixAttributeName("max-width"))), e.settings.forceHeight)) {
                    try {
                        i.objectHeight = e.settings[e.objectData.type].height;
                    } catch (t) {
                        i.objectHeight = e.settings.height || i.objectHeight;
                    }
                    i.maxHeight = null;
                }
                t.attr(e._prefixAttributeName("max-height")) && (i.maxHeight = t.attr(e._prefixAttributeName("max-height"))), e._adjustDimensions(t, i);
            }
        },
        _adjustDimensions: function (t, i) {
            t.css({ width: i.objectWidth, height: i.objectHeight, "max-width": i.maxWidth, "max-height": i.maxHeight }),
                e.objects.contentInner.css({ width: t.outerWidth(), height: t.outerHeight(), "max-width": "100%" }),
                e.objects.case.css({ width: e.objects.contentInner.outerWidth(), "max-width": "100%" }),
                e.objects.case.css({ "margin-top": parseInt(-e.objects.case.outerHeight() / 2), "margin-left": parseInt(-e.objects.case.outerWidth() / 2) });
        },
        _loading: function (t) {
            "start" === t ? (e.objects.case.addClass(e.settings.classPrefix + "loading"), e.objects.loading.show()) : "end" === t && (e.objects.case.removeClass(e.settings.classPrefix + "loading"), e.objects.loading.hide());
        },
        getViewportDimensions: function () {
            return { windowWidth: t(window).innerWidth(), windowHeight: t(window).innerHeight() };
        },
        _verifyDataUrl: function (t) {
            return !(!t || void 0 === t || "" === t) && (t.indexOf("#") > -1 && (t = "#" + (t = t.split("#"))[t.length - 1]), e._normalizeUrl(t.toString()));
        },
        _getFileUrlSuffix: function (t) {
            return /(?:\.([^.]+))?$/.exec(t.toLowerCase())[1];
        },
        _verifyDataType: function (t) {
            var i = e.settings.typeMapping;
            if (!t) return !1;
            for (var s in i)
                if (i.hasOwnProperty(s))
                    for (var n = i[s].split(","), a = 0; a < n.length; a++) {
                        var o = n[a].toLowerCase(),
                            c = new RegExp(".(" + o + ")$", "i"),
                            r = t.toLowerCase().split("?")[0].substr(-5);
                        if (!0 === c.test(r) || ("inline" === s && t.indexOf(o) > -1)) return s;
                    }
            return "iframe";
        },
        _addElements: function () {
            (void 0 !== e.objects.case && t("#" + e.objects.case.attr("id")).length) || e.settings.markup();
        },
        _showContent: function (t) {
            e.objects.document.attr(e._prefixAttributeName("type"), e.objectData.type), (e.cache.object = t), e._callHooks(e.settings.onBeforeShow), e.settings.breakBeforeShow || e.show();
        },
        _startInTransition: function () {
            switch (e.transition.in()) {
                case "scrollTop":
                case "scrollRight":
                case "scrollBottom":
                case "scrollLeft":
                case "scrollHorizontal":
                case "scrollVertical":
                    e.transition.scroll(e.objects.case, "in", e.settings.speedIn), e.transition.fade(e.objects.contentInner, "in", e.settings.speedIn);
                    break;
                case "elastic":
                    e.objects.case.css("opacity") < 1 && (e.transition.zoom(e.objects.case, "in", e.settings.speedIn), e.transition.fade(e.objects.contentInner, "in", e.settings.speedIn));
                case "fade":
                case "fadeInline":
                    e.transition.fade(e.objects.case, "in", e.settings.speedIn), e.transition.fade(e.objects.contentInner, "in", e.settings.speedIn);
                    break;
                default:
                    e.transition.fade(e.objects.case, "in", 0);
            }
            e._loading("end"),
                (e.isBusy = !1),
                e.cache.firstOpened || (e.cache.firstOpened = e.objectData.this),
                e.objects.info.hide(),
                setTimeout(function () {
                    e.transition.fade(e.objects.info, "in", e.settings.speedIn);
                }, e.settings.speedIn),
                e._callHooks(e.settings.onFinish);
        },
        _processContent: function () {
            switch (((e.isBusy = !0), e.transition.fade(e.objects.info, "out", 0), e.settings.transitionOut)) {
                case "scrollTop":
                case "scrollRight":
                case "scrollBottom":
                case "scrollLeft":
                case "scrollVertical":
                case "scrollHorizontal":
                    e.objects.case.is(":hidden")
                        ? (e.transition.fade(e.objects.contentInner, "out", 0),
                          e.transition.fade(e.objects.case, "out", 0, 0, function () {
                              e._loadContent();
                          }))
                        : e.transition.scroll(e.objects.case, "out", e.settings.speedOut, function () {
                              e._loadContent();
                          });
                    break;
                case "fade":
                    e.objects.case.is(":hidden")
                        ? e.transition.fade(e.objects.case, "out", 0, 0, function () {
                              e._loadContent();
                          })
                        : e.transition.fade(e.objects.case, "out", e.settings.speedOut, 0, function () {
                              e._loadContent();
                          });
                    break;
                case "fadeInline":
                case "elastic":
                    e.objects.case.is(":hidden")
                        ? e.transition.fade(e.objects.case, "out", 0, 0, function () {
                              e._loadContent();
                          })
                        : e.transition.fade(e.objects.contentInner, "out", e.settings.speedOut, 0, function () {
                              e._loadContent();
                          });
                    break;
                default:
                    e.transition.fade(e.objects.case, "out", 0, 0, function () {
                        e._loadContent();
                    });
            }
        },
        _handleEvents: function () {
            e._unbindEvents(),
                e.objects.nav.children().not(e.objects.close).hide(),
                e.isSlideshowEnabled() && ((!0 !== e.settings.slideshowAutoStart && !e.isSlideshowStarted) || e.objects.nav.hasClass(e.settings.classPrefix + "paused") ? e._stopTimeout() : e._startTimeout()),
                e.settings.liveResize && e._watchResizeInteraction(),
                e.objects.close.click(function (t) {
                    t.preventDefault(), e.close();
                }),
                !0 === e.settings.closeOnOverlayClick &&
                    e.objects.overlay.css("cursor", "pointer").click(function (t) {
                        t.preventDefault(), e.close();
                    }),
                !0 === e.settings.useKeys && e._addKeyEvents(),
                e.objectData.isPartOfSequence &&
                    (e.objects.nav.attr(e._prefixAttributeName("ispartofsequence"), !0),
                    e.objects.nav.data("items", e._setNavigation()),
                    e.objects.prev.click(function (t) {
                        t.preventDefault(),
                            (!0 !== e.settings.navigateEndless && e.item.isFirst()) || (e.objects.prev.unbind("click"), (e.cache.action = "prev"), e.objects.nav.data("items").prev.click(), e.isSlideshowEnabled() && e._stopTimeout());
                    }),
                    e.objects.next.click(function (t) {
                        t.preventDefault(),
                            (!0 !== e.settings.navigateEndless && e.item.isLast()) || (e.objects.next.unbind("click"), (e.cache.action = "next"), e.objects.nav.data("items").next.click(), e.isSlideshowEnabled() && e._stopTimeout());
                    }),
                    e.isSlideshowEnabled() &&
                        (e.objects.play.click(function (t) {
                            t.preventDefault(), e._startTimeout();
                        }),
                        e.objects.pause.click(function (t) {
                            t.preventDefault(), e._stopTimeout();
                        })),
                    !0 === e.settings.swipe &&
                        (t.isPlainObject(t.event.special.swipeleft) &&
                            e.objects.case.on("swipeleft", function (t) {
                                t.preventDefault(), e.objects.next.click(), e.isSlideshowEnabled() && e._stopTimeout();
                            }),
                        t.isPlainObject(t.event.special.swiperight) &&
                            e.objects.case.on("swiperight", function (t) {
                                t.preventDefault(), e.objects.prev.click(), e.isSlideshowEnabled() && e._stopTimeout();
                            })));
        },
        _addKeyEvents: function () {
            t(document).bind("keyup.lightcase", function (t) {
                if (!e.isBusy)
                    switch (t.keyCode) {
                        case 27:
                            e.objects.close.click();
                            break;
                        case 37:
                            e.objectData.isPartOfSequence && e.objects.prev.click();
                            break;
                        case 39:
                            e.objectData.isPartOfSequence && e.objects.next.click();
                    }
            });
        },
        _startTimeout: function () {
            (e.isSlideshowStarted = !0),
                e.objects.play.hide(),
                e.objects.pause.show(),
                (e.cache.action = "next"),
                e.objects.nav.removeClass(e.settings.classPrefix + "paused"),
                (e.timeout = setTimeout(function () {
                    e.objects.nav.data("items").next.click();
                }, e.settings.timeout));
        },
        _stopTimeout: function () {
            e.objects.play.show(), e.objects.pause.hide(), e.objects.nav.addClass(e.settings.classPrefix + "paused"), clearTimeout(e.timeout);
        },
        _setNavigation: function () {
            var i = t(e.cache.selector || e.settings.attr),
                s = e.objectData.sequenceLength - 1,
                n = { prev: i.eq(e.objectData.prevIndex), next: i.eq(e.objectData.nextIndex) };
            return (
                e.objectData.currentIndex > 0 ? e.objects.prev.show() : (n.prevItem = i.eq(s)),
                e.objectData.nextIndex <= s ? e.objects.next.show() : (n.next = i.eq(0)),
                !0 === e.settings.navigateEndless && (e.objects.prev.show(), e.objects.next.show()),
                n
            );
        },
        item: {
            isFirst: function () {
                return 0 === e.objectData.currentIndex;
            },
            isFirstOpened: function () {
                return e.objectData.this.is(e.cache.firstOpened);
            },
            isLast: function () {
                return e.objectData.currentIndex === e.objectData.sequenceLength - 1;
            },
        },
        _cloneObject: function (t) {
            var i = t.clone(),
                s = t.attr("id");
            return t.is(":hidden") ? (e._cacheObjectData(t), t.attr("id", e.settings.idPrefix + "temp-" + s).empty()) : i.removeAttr("id"), i.show();
        },
        isMobileDevice: function () {
            return !!navigator.userAgent.toLowerCase().match(e.settings.mobileMatchExpression);
        },
        isTransitionSupported: function () {
            var t = e.objects.body.get(0),
                i = !1,
                s = { transition: "", WebkitTransition: "-webkit-", MozTransition: "-moz-", OTransition: "-o-", MsTransition: "-ms-" };
            for (var n in s) s.hasOwnProperty(n) && n in t.style && ((e.support.transition = s[n]), (i = !0));
            return i;
        },
        transition: {
            in: function () {
                return e.settings.transitionOpen && !e.cache.firstOpened ? e.settings.transitionOpen : e.settings.transitionIn;
            },
            fade: function (t, i, s, n, a) {
                var o = "in" === i,
                    c = {},
                    r = t.css("opacity"),
                    l = {},
                    d = n || (o ? 1 : 0);
                (!e.isOpen && o) ||
                    ((c.opacity = r),
                    (l.opacity = d),
                    t.css(e.support.transition + "transition", "none"),
                    t.css(c).show(),
                    e.support.transitions
                        ? ((l[e.support.transition + "transition"] = s + "ms ease"),
                          setTimeout(function () {
                              t.css(l),
                                  setTimeout(function () {
                                      t.css(e.support.transition + "transition", ""), !a || (!e.isOpen && o) || a();
                                  }, s);
                          }, 15))
                        : (t.stop(), t.animate(l, s, a)));
            },
            scroll: function (t, i, s, n) {
                var a = "in" === i,
                    o = a ? e.settings.transitionIn : e.settings.transitionOut,
                    c = "left",
                    r = {},
                    l = a ? 0 : 1,
                    d = a ? "-50%" : "50%",
                    u = {},
                    h = a ? 1 : 0,
                    f = a ? "50%" : "-50%";
                if (e.isOpen || !a) {
                    switch (o) {
                        case "scrollTop":
                            c = "top";
                            break;
                        case "scrollRight":
                            (d = a ? "150%" : "50%"), (f = a ? "50%" : "150%");
                            break;
                        case "scrollBottom":
                            (c = "top"), (d = a ? "150%" : "50%"), (f = a ? "50%" : "150%");
                            break;
                        case "scrollHorizontal":
                            (d = a ? "150%" : "50%"), (f = a ? "50%" : "-50%");
                            break;
                        case "scrollVertical":
                            (c = "top"), (d = a ? "-50%" : "50%"), (f = a ? "50%" : "150%");
                    }
                    if ("prev" === e.cache.action)
                        switch (o) {
                            case "scrollHorizontal":
                                (d = a ? "-50%" : "50%"), (f = a ? "50%" : "150%");
                                break;
                            case "scrollVertical":
                                (d = a ? "150%" : "50%"), (f = a ? "50%" : "-50%");
                        }
                    (r.opacity = l),
                        (r[c] = d),
                        (u.opacity = h),
                        (u[c] = f),
                        t.css(e.support.transition + "transition", "none"),
                        t.css(r).show(),
                        e.support.transitions
                            ? ((u[e.support.transition + "transition"] = s + "ms ease"),
                              setTimeout(function () {
                                  t.css(u),
                                      setTimeout(function () {
                                          t.css(e.support.transition + "transition", ""), !n || (!e.isOpen && a) || n();
                                      }, s);
                              }, 15))
                            : (t.stop(), t.animate(u, s, n));
                }
            },
            zoom: function (t, i, s, n) {
                var a = "in" === i,
                    o = {},
                    c = t.css("opacity"),
                    r = a ? "scale(0.75)" : "scale(1)",
                    l = {},
                    d = a ? 1 : 0,
                    u = a ? "scale(1)" : "scale(0.75)";
                (!e.isOpen && a) ||
                    ((o.opacity = c),
                    (o[e.support.transition + "transform"] = r),
                    (l.opacity = d),
                    t.css(e.support.transition + "transition", "none"),
                    t.css(o).show(),
                    e.support.transitions
                        ? ((l[e.support.transition + "transform"] = u),
                          (l[e.support.transition + "transition"] = s + "ms ease"),
                          setTimeout(function () {
                              t.css(l),
                                  setTimeout(function () {
                                      t.css(e.support.transition + "transform", ""), t.css(e.support.transition + "transition", ""), !n || (!e.isOpen && a) || n();
                                  }, s);
                          }, 15))
                        : (t.stop(), t.animate(l, s, n)));
            },
        },
        _callHooks: function (i) {
            "object" == typeof i &&
                t.each(i, function (t, i) {
                    "function" == typeof i && i.call(e.origin);
                });
        },
        _cacheObjectData: function (i) {
            t.data(i, "cache", { id: i.attr("id"), content: i.html() }), (e.cache.originalObject = i);
        },
        _restoreObject: function () {
            var i = t('[id^="' + e.settings.idPrefix + 'temp-"]');
            i.attr("id", t.data(e.cache.originalObject, "cache").id), i.html(t.data(e.cache.originalObject, "cache").content);
        },
        resize: function (t, i) {
            e.isOpen &&
                (e.isSlideshowEnabled() && e._stopTimeout(),
                "object" == typeof i &&
                    null !== i &&
                    (i.width && e.cache.object.attr(e._prefixAttributeName("width"), i.width),
                    i.maxWidth && e.cache.object.attr(e._prefixAttributeName("max-width"), i.maxWidth),
                    i.height && e.cache.object.attr(e._prefixAttributeName("height"), i.height),
                    i.maxHeight && e.cache.object.attr(e._prefixAttributeName("max-height"), i.maxHeight)),
                (e.dimensions = e.getViewportDimensions()),
                e._calculateDimensions(e.cache.object),
                e._callHooks(e.settings.onResize));
        },
        _watchResizeInteraction: function () {
            t(window).resize(e.resize);
        },
        _unwatchResizeInteraction: function () {
            t(window).off("resize", e.resize);
        },
        _switchToFullScreenMode: function () {
            (e.settings.shrinkFactor = 1), (e.settings.overlayOpacity = 1), t("html").addClass(e.settings.classPrefix + "fullScreenMode");
        },
        _open: function () {
            switch (
                ((e.isOpen = !0),
                (e.support.transitions = !!e.settings.cssTransitions && e.isTransitionSupported()),
                (e.support.mobileDevice = e.isMobileDevice()),
                e.support.mobileDevice && (t("html").addClass(e.settings.classPrefix + "isMobileDevice"), e.settings.fullScreenModeForMobile && e._switchToFullScreenMode()),
                e.settings.transitionIn || (e.settings.transitionIn = e.settings.transition),
                e.settings.transitionOut || (e.settings.transitionOut = e.settings.transition),
                e.transition.in())
            ) {
                case "fade":
                case "fadeInline":
                case "elastic":
                case "scrollTop":
                case "scrollRight":
                case "scrollBottom":
                case "scrollLeft":
                case "scrollVertical":
                case "scrollHorizontal":
                    e.objects.case.is(":hidden") && (e.objects.close.css("opacity", 0), e.objects.overlay.css("opacity", 0), e.objects.case.css("opacity", 0), e.objects.contentInner.css("opacity", 0)),
                        e.transition.fade(e.objects.overlay, "in", e.settings.speedIn, e.settings.overlayOpacity, function () {
                            e.transition.fade(e.objects.close, "in", e.settings.speedIn), e._handleEvents(), e._processContent();
                        });
                    break;
                default:
                    e.transition.fade(e.objects.overlay, "in", 0, e.settings.overlayOpacity, function () {
                        e.transition.fade(e.objects.close, "in", 0), e._handleEvents(), e._processContent();
                    });
            }
            e.objects.document.addClass(e.settings.classPrefix + "open"), e.objects.case.attr("aria-hidden", "false");
        },
        show: function () {
            e._callHooks(e.settings.onBeforeCalculateDimensions), e._calculateDimensions(e.cache.object), e._callHooks(e.settings.onAfterCalculateDimensions), e._startInTransition();
        },
        close: function () {
            switch (
                ((e.isOpen = !1),
                e.isSlideshowEnabled() && (e._stopTimeout(), (e.isSlideshowStarted = !1), e.objects.nav.removeClass(e.settings.classPrefix + "paused")),
                e.objects.loading.hide(),
                e._unbindEvents(),
                e._unwatchResizeInteraction(),
                t("html").removeClass(e.settings.classPrefix + "open"),
                e.objects.case.attr("aria-hidden", "true"),
                e.objects.nav.children().hide(),
                e.objects.close.hide(),
                e._callHooks(e.settings.onClose),
                e.transition.fade(e.objects.info, "out", 0),
                e.settings.transitionClose || e.settings.transitionOut)
            ) {
                case "fade":
                case "fadeInline":
                case "scrollTop":
                case "scrollRight":
                case "scrollBottom":
                case "scrollLeft":
                case "scrollHorizontal":
                case "scrollVertical":
                    e.transition.fade(e.objects.case, "out", e.settings.speedOut, 0, function () {
                        e.transition.fade(e.objects.overlay, "out", e.settings.speedOut, 0, function () {
                            e.cleanup();
                        });
                    });
                    break;
                case "elastic":
                    e.transition.zoom(e.objects.case, "out", e.settings.speedOut, function () {
                        e.transition.fade(e.objects.overlay, "out", e.settings.speedOut, 0, function () {
                            e.cleanup();
                        });
                    });
                    break;
                default:
                    e.cleanup();
            }
        },
        _unbindEvents: function () {
            e.objects.overlay.unbind("click"),
                t(document).unbind("keyup.lightcase"),
                e.objects.case.unbind("swipeleft").unbind("swiperight"),
                e.objects.prev.unbind("click"),
                e.objects.next.unbind("click"),
                e.objects.play.unbind("click"),
                e.objects.pause.unbind("click"),
                e.objects.close.unbind("click");
        },
        _cleanupDimensions: function () {
            var t = e.objects.contentInner.css("opacity");
            e.objects.case.css({ width: "", height: "", top: "", left: "", "margin-top": "", "margin-left": "" }), e.objects.contentInner.removeAttr("style").css("opacity", t), e.objects.contentInner.children().removeAttr("style");
        },
        cleanup: function () {
            e._cleanupDimensions(),
                e.objects.loading.hide(),
                e.objects.overlay.hide(),
                e.objects.case.hide(),
                e.objects.prev.hide(),
                e.objects.next.hide(),
                e.objects.play.hide(),
                e.objects.pause.hide(),
                e.objects.document.removeAttr(e._prefixAttributeName("type")),
                e.objects.nav.removeAttr(e._prefixAttributeName("ispartofsequence")),
                e.objects.contentInner.empty().hide(),
                e.objects.info.children().empty(),
                e.cache.originalObject && e._restoreObject(),
                e._callHooks(e.settings.onCleanup),
                (e.cache = {});
        },
        _matchMedia: function () {
            return window.matchMedia || window.msMatchMedia;
        },
        _devicePixelRatio: function () {
            return window.devicePixelRatio || 1;
        },
        _isPublicMethod: function (t) {
            return "function" == typeof e[t] && "_" !== t.charAt(0);
        },
        _export: function () {
            (window.lightcase = {}),
                t.each(e, function (t) {
                    e._isPublicMethod(t) && (lightcase[t] = e[t]);
                });
        },
    };
    e._export(),
        (t.fn.lightcase = function (i) {
            return e._isPublicMethod(i) ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof i && i ? void t.error("Method " + i + " does not exist on jQuery.lightcase") : e.init.apply(this, arguments);
        });
})(jQuery);
jQuery(function ($) {
    "use strict";
    try {
        $(document.body).on("fgf-enhanced-lightcase", function () {
            var lightcases = $(".fgf-popup-gift-products");
            if (!lightcases.length) {
                return;
            }
            $(".fgf-popup-gift-products").lightcase({
                href: "#fgf_gift_products_modal",
                onFinish: {
                    foo: function () {
                        $(".fgf-owl-carousel-items").closest("#fgf_gift_products_modal").find(".owl-nav").remove();
                        $(".fgf-owl-carousel-items").closest("#fgf_gift_products_modal").find(".owl-dots").remove();
                        lightcase.resize();
                        $(document.body).trigger("fgf-enhanced-carousel");
                    },
                },
            });
        });
        $(document.body).on("updated_wc_div", function () {
            $(document.body).trigger("fgf-enhanced-lightcase");
        });
        $(document.body).on("updated_checkout", function () {
            $(document.body).trigger("fgf-enhanced-lightcase");
        });
        $(document.body).trigger("fgf-enhanced-lightcase");
    } catch (err) {
        window.console.log(err);
    }
});
jQuery(function (d) {
    if ("undefined" == typeof wc_add_to_cart_params) return !1;
    var t = function () {
        (this.requests = []),
            (this.addRequest = this.addRequest.bind(this)),
            (this.run = this.run.bind(this)),
            d(document.body)
                .on("click", ".add_to_cart_button", { addToCartHandler: this }, this.onAddToCart)
                .on("click", ".remove_from_cart_button", { addToCartHandler: this }, this.onRemoveFromCart)
                .on("added_to_cart", this.updateButton)
                .on("ajax_request_not_sent.adding_to_cart", this.updateButton)
                .on("added_to_cart removed_from_cart", { addToCartHandler: this }, this.updateFragments);
    };
    (t.prototype.addRequest = function (t) {
        this.requests.push(t), 1 === this.requests.length && this.run();
    }),
        (t.prototype.run = function () {
            var t = this,
                a = t.requests[0].complete;
            (t.requests[0].complete = function () {
                "function" == typeof a && a(), t.requests.shift(), 0 < t.requests.length && t.run();
            }),
                d.ajax(this.requests[0]);
        }),
        (t.prototype.onAddToCart = function (t) {
            var a = d(this);
            if (a.is(".ajax_add_to_cart")) {
                if (!a.attr("data-product_id")) return !0;
                if ((t.preventDefault(), a.removeClass("added"), a.addClass("loading"), !1 === d(document.body).triggerHandler("should_send_ajax_request.adding_to_cart", [a])))
                    return d(document.body).trigger("ajax_request_not_sent.adding_to_cart", [!1, !1, a]), !0;
                var e = {};
                d.each(a.data(), function (t, a) {
                    e[t] = a;
                }),
                    d.each(a[0].dataset, function (t, a) {
                        e[t] = a;
                    }),
                    d(document.body).trigger("adding_to_cart", [a, e]),
                    t.data.addToCartHandler.addRequest({
                        type: "POST",
                        url: wc_add_to_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "add_to_cart"),
                        data: e,
                        success: function (t) {
                            t &&
                                (t.error && t.product_url
                                    ? (window.location = t.product_url)
                                    : "yes" !== wc_add_to_cart_params.cart_redirect_after_add
                                    ? d(document.body).trigger("added_to_cart", [t.fragments, t.cart_hash, a])
                                    : (window.location = wc_add_to_cart_params.cart_url));
                        },
                        dataType: "json",
                    });
            }
        }),
        (t.prototype.onRemoveFromCart = function (t) {
            var a = d(this),
                e = a.closest(".woocommerce-mini-cart-item");
            t.preventDefault(),
                e.block({ message: null, overlayCSS: { opacity: 0.6 } }),
                t.data.addToCartHandler.addRequest({
                    type: "POST",
                    url: wc_add_to_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "remove_from_cart"),
                    data: { cart_item_key: a.data("cart_item_key") },
                    success: function (t) {
                        t && t.fragments ? d(document.body).trigger("removed_from_cart", [t.fragments, t.cart_hash, a]) : (window.location = a.attr("href"));
                    },
                    error: function () {
                        window.location = a.attr("href");
                    },
                    dataType: "json",
                });
        }),
        (t.prototype.updateButton = function (t, a, e, r) {
            (r = void 0 !== r && r) &&
                (r.removeClass("loading"),
                a && r.addClass("added"),
                a &&
                    !wc_add_to_cart_params.is_cart &&
                    0 === r.parent().find(".added_to_cart").length &&
                    r.after('<a href="' + wc_add_to_cart_params.cart_url + '" class="added_to_cart wc-forward" title="' + wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + "</a>"),
                d(document.body).trigger("wc_cart_button_updated", [r]));
        }),
        (t.prototype.updateFragments = function (t, a) {
            a &&
                (d.each(a, function (t) {
                    d(t)
                        .addClass("updating")
                        .fadeTo("400", "0.6")
                        .block({ message: null, overlayCSS: { opacity: 0.6 } });
                }),
                d.each(a, function (t, a) {
                    d(t).replaceWith(a), d(t).stop(!0).css("opacity", "1").unblock();
                }),
                d(document.body).trigger("wc_fragments_loaded"));
        }),
        new t();
});

!(function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define(t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).flatpickr = t());
})(this, function () {
    "use strict";
    var e = function () {
        return (e =
            Object.assign ||
            function (e) {
                for (var t, n = 1, a = arguments.length; n < a; n++) for (var i in (t = arguments[n])) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                return e;
            }).apply(this, arguments);
    };
    function t() {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var a = Array(e),
            i = 0;
        for (t = 0; t < n; t++) for (var o = arguments[t], r = 0, l = o.length; r < l; r++, i++) a[i] = o[r];
        return a;
    }
    var n = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"],
        a = {
            _disable: [],
            allowInput: !1,
            allowInvalidPreload: !1,
            altFormat: "F j, Y",
            altInput: !1,
            altInputClass: "form-control input",
            animate: "object" == typeof window && -1 === window.navigator.userAgent.indexOf("MSIE"),
            ariaDateFormat: "F j, Y",
            autoFillDefaultTime: !0,
            clickOpens: !0,
            closeOnSelect: !0,
            conjunction: ", ",
            dateFormat: "Y-m-d",
            defaultHour: 12,
            defaultMinute: 0,
            defaultSeconds: 0,
            disable: [],
            disableMobile: !1,
            enableSeconds: !1,
            enableTime: !1,
            errorHandler: function (e) {
                return "undefined" != typeof console && console.warn(e);
            },
            getWeek: function (e) {
                var t = new Date(e.getTime());
                t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - ((t.getDay() + 6) % 7));
                var n = new Date(t.getFullYear(), 0, 4);
                return 1 + Math.round(((t.getTime() - n.getTime()) / 864e5 - 3 + ((n.getDay() + 6) % 7)) / 7);
            },
            hourIncrement: 1,
            ignoredFocusElements: [],
            inline: !1,
            locale: "default",
            minuteIncrement: 5,
            mode: "single",
            monthSelectorType: "dropdown",
            nextArrow:
                "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
            noCalendar: !1,
            now: new Date(),
            onChange: [],
            onClose: [],
            onDayCreate: [],
            onDestroy: [],
            onKeyDown: [],
            onMonthChange: [],
            onOpen: [],
            onParseConfig: [],
            onReady: [],
            onValueUpdate: [],
            onYearChange: [],
            onPreCalendarPosition: [],
            plugins: [],
            position: "auto",
            positionElement: void 0,
            prevArrow:
                "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
            shorthandCurrentMonth: !1,
            showMonths: 1,
            static: !1,
            time_24hr: !1,
            weekNumbers: !1,
            wrap: !1,
        },
        i = {
            weekdays: { shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] },
            months: {
                shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            },
            daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            firstDayOfWeek: 0,
            ordinal: function (e) {
                var t = e % 100;
                if (t > 3 && t < 21) return "th";
                switch (t % 10) {
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th";
                }
            },
            rangeSeparator: " to ",
            weekAbbreviation: "Wk",
            scrollTitle: "Scroll to increment",
            toggleTitle: "Click to toggle",
            amPM: ["AM", "PM"],
            yearAriaLabel: "Year",
            monthAriaLabel: "Month",
            hourAriaLabel: "Hour",
            minuteAriaLabel: "Minute",
            time_24hr: !1,
        },
        o = function (e, t) {
            return void 0 === t && (t = 2), ("000" + e).slice(-1 * t);
        },
        r = function (e) {
            return !0 === e ? 1 : 0;
        };
    function l(e, t) {
        var n;
        return function () {
            var a = this;
            clearTimeout(n),
                (n = setTimeout(function () {
                    return e.apply(a, arguments);
                }, t));
        };
    }
    var c = function (e) {
        return e instanceof Array ? e : [e];
    };
    function d(e, t, n) {
        if (!0 === n) return e.classList.add(t);
        e.classList.remove(t);
    }
    function s(e, t, n) {
        var a = window.document.createElement(e);
        return (t = t || ""), (n = n || ""), (a.className = t), void 0 !== n && (a.textContent = n), a;
    }
    function u(e) {
        for (; e.firstChild; ) e.removeChild(e.firstChild);
    }
    function f(e, t) {
        return t(e) ? e : e.parentNode ? f(e.parentNode, t) : void 0;
    }
    function m(e, t) {
        var n = s("div", "numInputWrapper"),
            a = s("input", "numInput " + e),
            i = s("span", "arrowUp"),
            o = s("span", "arrowDown");
        if ((-1 === navigator.userAgent.indexOf("MSIE 9.0") ? (a.type = "number") : ((a.type = "text"), (a.pattern = "\\d*")), void 0 !== t)) for (var r in t) a.setAttribute(r, t[r]);
        return n.appendChild(a), n.appendChild(i), n.appendChild(o), n;
    }
    function g(e) {
        try {
            return "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
        } catch (t) {
            return e.target;
        }
    }
    var p = function () {},
        h = function (e, t, n) {
            return n.months[t ? "shorthand" : "longhand"][e];
        },
        v = {
            D: p,
            F: function (e, t, n) {
                e.setMonth(n.months.longhand.indexOf(t));
            },
            G: function (e, t) {
                e.setHours(parseFloat(t));
            },
            H: function (e, t) {
                e.setHours(parseFloat(t));
            },
            J: function (e, t) {
                e.setDate(parseFloat(t));
            },
            K: function (e, t, n) {
                e.setHours((e.getHours() % 12) + 12 * r(new RegExp(n.amPM[1], "i").test(t)));
            },
            M: function (e, t, n) {
                e.setMonth(n.months.shorthand.indexOf(t));
            },
            S: function (e, t) {
                e.setSeconds(parseFloat(t));
            },
            U: function (e, t) {
                return new Date(1e3 * parseFloat(t));
            },
            W: function (e, t, n) {
                var a = parseInt(t),
                    i = new Date(e.getFullYear(), 0, 2 + 7 * (a - 1), 0, 0, 0, 0);
                return i.setDate(i.getDate() - i.getDay() + n.firstDayOfWeek), i;
            },
            Y: function (e, t) {
                e.setFullYear(parseFloat(t));
            },
            Z: function (e, t) {
                return new Date(t);
            },
            d: function (e, t) {
                e.setDate(parseFloat(t));
            },
            h: function (e, t) {
                e.setHours(parseFloat(t));
            },
            i: function (e, t) {
                e.setMinutes(parseFloat(t));
            },
            j: function (e, t) {
                e.setDate(parseFloat(t));
            },
            l: p,
            m: function (e, t) {
                e.setMonth(parseFloat(t) - 1);
            },
            n: function (e, t) {
                e.setMonth(parseFloat(t) - 1);
            },
            s: function (e, t) {
                e.setSeconds(parseFloat(t));
            },
            u: function (e, t) {
                return new Date(parseFloat(t));
            },
            w: p,
            y: function (e, t) {
                e.setFullYear(2e3 + parseFloat(t));
            },
        },
        D = {
            D: "(\\w+)",
            F: "(\\w+)",
            G: "(\\d\\d|\\d)",
            H: "(\\d\\d|\\d)",
            J: "(\\d\\d|\\d)\\w+",
            K: "",
            M: "(\\w+)",
            S: "(\\d\\d|\\d)",
            U: "(.+)",
            W: "(\\d\\d|\\d)",
            Y: "(\\d{4})",
            Z: "(.+)",
            d: "(\\d\\d|\\d)",
            h: "(\\d\\d|\\d)",
            i: "(\\d\\d|\\d)",
            j: "(\\d\\d|\\d)",
            l: "(\\w+)",
            m: "(\\d\\d|\\d)",
            n: "(\\d\\d|\\d)",
            s: "(\\d\\d|\\d)",
            u: "(.+)",
            w: "(\\d\\d|\\d)",
            y: "(\\d{2})",
        },
        w = {
            Z: function (e) {
                return e.toISOString();
            },
            D: function (e, t, n) {
                return t.weekdays.shorthand[w.w(e, t, n)];
            },
            F: function (e, t, n) {
                return h(w.n(e, t, n) - 1, !1, t);
            },
            G: function (e, t, n) {
                return o(w.h(e, t, n));
            },
            H: function (e) {
                return o(e.getHours());
            },
            J: function (e, t) {
                return void 0 !== t.ordinal ? e.getDate() + t.ordinal(e.getDate()) : e.getDate();
            },
            K: function (e, t) {
                return t.amPM[r(e.getHours() > 11)];
            },
            M: function (e, t) {
                return h(e.getMonth(), !0, t);
            },
            S: function (e) {
                return o(e.getSeconds());
            },
            U: function (e) {
                return e.getTime() / 1e3;
            },
            W: function (e, t, n) {
                return n.getWeek(e);
            },
            Y: function (e) {
                return o(e.getFullYear(), 4);
            },
            d: function (e) {
                return o(e.getDate());
            },
            h: function (e) {
                return e.getHours() % 12 ? e.getHours() % 12 : 12;
            },
            i: function (e) {
                return o(e.getMinutes());
            },
            j: function (e) {
                return e.getDate();
            },
            l: function (e, t) {
                return t.weekdays.longhand[e.getDay()];
            },
            m: function (e) {
                return o(e.getMonth() + 1);
            },
            n: function (e) {
                return e.getMonth() + 1;
            },
            s: function (e) {
                return e.getSeconds();
            },
            u: function (e) {
                return e.getTime();
            },
            w: function (e) {
                return e.getDay();
            },
            y: function (e) {
                return String(e.getFullYear()).substring(2);
            },
        },
        b = function (e) {
            var t = e.config,
                n = void 0 === t ? a : t,
                o = e.l10n,
                r = void 0 === o ? i : o,
                l = e.isMobile,
                c = void 0 !== l && l;
            return function (e, t, a) {
                var i = a || r;
                return void 0 === n.formatDate || c
                    ? t
                          .split("")
                          .map(function (t, a, o) {
                              return w[t] && "\\" !== o[a - 1] ? w[t](e, i, n) : "\\" !== t ? t : "";
                          })
                          .join("")
                    : n.formatDate(e, t, i);
            };
        },
        C = function (e) {
            var t = e.config,
                n = void 0 === t ? a : t,
                o = e.l10n,
                r = void 0 === o ? i : o;
            return function (e, t, i, o) {
                if (0 === e || e) {
                    var l,
                        c = o || r,
                        d = e;
                    if (e instanceof Date) l = new Date(e.getTime());
                    else if ("string" != typeof e && void 0 !== e.toFixed) l = new Date(e);
                    else if ("string" == typeof e) {
                        var s = t || (n || a).dateFormat,
                            u = String(e).trim();
                        if ("today" === u) (l = new Date()), (i = !0);
                        else if (/Z$/.test(u) || /GMT$/.test(u)) l = new Date(e);
                        else if (n && n.parseDate) l = n.parseDate(e, s);
                        else {
                            l = n && n.noCalendar ? new Date(new Date().setHours(0, 0, 0, 0)) : new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
                            for (var f = void 0, m = [], g = 0, p = 0, h = ""; g < s.length; g++) {
                                var w = s[g],
                                    b = "\\" === w,
                                    C = "\\" === s[g - 1] || b;
                                if (D[w] && !C) {
                                    h += D[w];
                                    var M = new RegExp(h).exec(e);
                                    M && (f = !0) && m["Y" !== w ? "push" : "unshift"]({ fn: v[w], val: M[++p] });
                                } else b || (h += ".");
                                m.forEach(function (e) {
                                    var t = e.fn,
                                        n = e.val;
                                    return (l = t(l, n, c) || l);
                                });
                            }
                            l = f ? l : void 0;
                        }
                    }
                    if (l instanceof Date && !isNaN(l.getTime())) return !0 === i && l.setHours(0, 0, 0, 0), l;
                    n.errorHandler(new Error("Invalid date provided: " + d));
                }
            };
        };
    function M(e, t, n) {
        return void 0 === n && (n = !0), !1 !== n ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : e.getTime() - t.getTime();
    }
    var y = 864e5;
    function x(e) {
        var t = e.defaultHour,
            n = e.defaultMinute,
            a = e.defaultSeconds;
        if (void 0 !== e.minDate) {
            var i = e.minDate.getHours(),
                o = e.minDate.getMinutes(),
                r = e.minDate.getSeconds();
            t < i && (t = i), t === i && n < o && (n = o), t === i && n === o && a < r && (a = e.minDate.getSeconds());
        }
        if (void 0 !== e.maxDate) {
            var l = e.maxDate.getHours(),
                c = e.maxDate.getMinutes();
            (t = Math.min(t, l)) === l && (n = Math.min(c, n)), t === l && n === c && (a = e.maxDate.getSeconds());
        }
        return { hours: t, minutes: n, seconds: a };
    }
    "function" != typeof Object.assign &&
        (Object.assign = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            if (!e) throw TypeError("Cannot convert undefined or null to object");
            for (
                var a = function (t) {
                        t &&
                            Object.keys(t).forEach(function (n) {
                                return (e[n] = t[n]);
                            });
                    },
                    i = 0,
                    o = t;
                i < o.length;
                i++
            ) {
                var r = o[i];
                a(r);
            }
            return e;
        });
    function E(p, v) {
        var w = { config: e(e({}, a), T.defaultConfig), l10n: i };
        function E(e) {
            return e.bind(w);
        }
        function k() {
            var e = w.config;
            (!1 === e.weekNumbers && 1 === e.showMonths) ||
                (!0 !== e.noCalendar &&
                    window.requestAnimationFrame(function () {
                        if ((void 0 !== w.calendarContainer && ((w.calendarContainer.style.visibility = "hidden"), (w.calendarContainer.style.display = "block")), void 0 !== w.daysContainer)) {
                            var t = (w.days.offsetWidth + 1) * e.showMonths;
                            (w.daysContainer.style.width = t + "px"),
                                (w.calendarContainer.style.width = t + (void 0 !== w.weekWrapper ? w.weekWrapper.offsetWidth : 0) + "px"),
                                w.calendarContainer.style.removeProperty("visibility"),
                                w.calendarContainer.style.removeProperty("display");
                        }
                    }));
        }
        function I(e) {
            if (0 === w.selectedDates.length) {
                var t = void 0 === w.config.minDate || M(new Date(), w.config.minDate) >= 0 ? new Date() : new Date(w.config.minDate.getTime()),
                    n = x(w.config);
                t.setHours(n.hours, n.minutes, n.seconds, t.getMilliseconds()), (w.selectedDates = [t]), (w.latestSelectedDateObj = t);
            }
            void 0 !== e &&
                "blur" !== e.type &&
                (function (e) {
                    e.preventDefault();
                    var t = "keydown" === e.type,
                        n = g(e),
                        a = n;
                    void 0 !== w.amPM && n === w.amPM && (w.amPM.textContent = w.l10n.amPM[r(w.amPM.textContent === w.l10n.amPM[0])]);
                    var i = parseFloat(a.getAttribute("min")),
                        l = parseFloat(a.getAttribute("max")),
                        c = parseFloat(a.getAttribute("step")),
                        d = parseInt(a.value, 10),
                        s = e.delta || (t ? (38 === e.which ? 1 : -1) : 0),
                        u = d + c * s;
                    if (void 0 !== a.value && 2 === a.value.length) {
                        var f = a === w.hourElement,
                            m = a === w.minuteElement;
                        u < i ? ((u = l + u + r(!f) + (r(f) && r(!w.amPM))), m && j(void 0, -1, w.hourElement)) : u > l && ((u = a === w.hourElement ? u - l - r(!w.amPM) : i), m && j(void 0, 1, w.hourElement)),
                            w.amPM && f && (1 === c ? u + d === 23 : Math.abs(u - d) > c) && (w.amPM.textContent = w.l10n.amPM[r(w.amPM.textContent === w.l10n.amPM[0])]),
                            (a.value = o(u));
                    }
                })(e);
            var a = w._input.value;
            S(), be(), w._input.value !== a && w._debouncedChange();
        }
        function S() {
            if (void 0 !== w.hourElement && void 0 !== w.minuteElement) {
                var e,
                    t,
                    n = (parseInt(w.hourElement.value.slice(-2), 10) || 0) % 24,
                    a = (parseInt(w.minuteElement.value, 10) || 0) % 60,
                    i = void 0 !== w.secondElement ? (parseInt(w.secondElement.value, 10) || 0) % 60 : 0;
                void 0 !== w.amPM && ((e = n), (t = w.amPM.textContent), (n = (e % 12) + 12 * r(t === w.l10n.amPM[1])));
                var o = void 0 !== w.config.minTime || (w.config.minDate && w.minDateHasTime && w.latestSelectedDateObj && 0 === M(w.latestSelectedDateObj, w.config.minDate, !0));
                if (void 0 !== w.config.maxTime || (w.config.maxDate && w.maxDateHasTime && w.latestSelectedDateObj && 0 === M(w.latestSelectedDateObj, w.config.maxDate, !0))) {
                    var l = void 0 !== w.config.maxTime ? w.config.maxTime : w.config.maxDate;
                    (n = Math.min(n, l.getHours())) === l.getHours() && (a = Math.min(a, l.getMinutes())), a === l.getMinutes() && (i = Math.min(i, l.getSeconds()));
                }
                if (o) {
                    var c = void 0 !== w.config.minTime ? w.config.minTime : w.config.minDate;
                    (n = Math.max(n, c.getHours())) === c.getHours() && a < c.getMinutes() && (a = c.getMinutes()), a === c.getMinutes() && (i = Math.max(i, c.getSeconds()));
                }
                O(n, a, i);
            }
        }
        function _(e) {
            var t = e || w.latestSelectedDateObj;
            t && O(t.getHours(), t.getMinutes(), t.getSeconds());
        }
        function O(e, t, n) {
            void 0 !== w.latestSelectedDateObj && w.latestSelectedDateObj.setHours(e % 24, t, n || 0, 0),
                w.hourElement &&
                    w.minuteElement &&
                    !w.isMobile &&
                    ((w.hourElement.value = o(w.config.time_24hr ? e : ((12 + e) % 12) + 12 * r(e % 12 == 0))),
                    (w.minuteElement.value = o(t)),
                    void 0 !== w.amPM && (w.amPM.textContent = w.l10n.amPM[r(e >= 12)]),
                    void 0 !== w.secondElement && (w.secondElement.value = o(n)));
        }
        function F(e) {
            var t = g(e),
                n = parseInt(t.value) + (e.delta || 0);
            (n / 1e3 > 1 || ("Enter" === e.key && !/[^\d]/.test(n.toString()))) && Q(n);
        }
        function A(e, t, n, a) {
            return t instanceof Array
                ? t.forEach(function (t) {
                      return A(e, t, n, a);
                  })
                : e instanceof Array
                ? e.forEach(function (e) {
                      return A(e, t, n, a);
                  })
                : (e.addEventListener(t, n, a),
                  void w._handlers.push({
                      remove: function () {
                          return e.removeEventListener(t, n);
                      },
                  }));
        }
        function N() {
            pe("onChange");
        }
        function P(e, t) {
            var n = void 0 !== e ? w.parseDate(e) : w.latestSelectedDateObj || (w.config.minDate && w.config.minDate > w.now ? w.config.minDate : w.config.maxDate && w.config.maxDate < w.now ? w.config.maxDate : w.now),
                a = w.currentYear,
                i = w.currentMonth;
            try {
                void 0 !== n && ((w.currentYear = n.getFullYear()), (w.currentMonth = n.getMonth()));
            } catch (e) {
                (e.message = "Invalid date supplied: " + n), w.config.errorHandler(e);
            }
            t && w.currentYear !== a && (pe("onYearChange"), K()), !t || (w.currentYear === a && w.currentMonth === i) || pe("onMonthChange"), w.redraw();
        }
        function Y(e) {
            var t = g(e);
            ~t.className.indexOf("arrow") && j(e, t.classList.contains("arrowUp") ? 1 : -1);
        }
        function j(e, t, n) {
            var a = e && g(e),
                i = n || (a && a.parentNode && a.parentNode.firstChild),
                o = he("increment");
            (o.delta = t), i && i.dispatchEvent(o);
        }
        function H(e, t, n, a) {
            var i = X(t, !0),
                o = s("span", "flatpickr-day " + e, t.getDate().toString());
            return (
                (o.dateObj = t),
                (o.$i = a),
                o.setAttribute("aria-label", w.formatDate(t, w.config.ariaDateFormat)),
                -1 === e.indexOf("hidden") && 0 === M(t, w.now) && ((w.todayDateElem = o), o.classList.add("today"), o.setAttribute("aria-current", "date")),
                i
                    ? ((o.tabIndex = -1),
                      ve(t) &&
                          (o.classList.add("selected"),
                          (w.selectedDateElem = o),
                          "range" === w.config.mode &&
                              (d(o, "startRange", w.selectedDates[0] && 0 === M(t, w.selectedDates[0], !0)), d(o, "endRange", w.selectedDates[1] && 0 === M(t, w.selectedDates[1], !0)), "nextMonthDay" === e && o.classList.add("inRange"))))
                    : o.classList.add("flatpickr-disabled"),
                "range" === w.config.mode &&
                    (function (e) {
                        return !("range" !== w.config.mode || w.selectedDates.length < 2) && M(e, w.selectedDates[0]) >= 0 && M(e, w.selectedDates[1]) <= 0;
                    })(t) &&
                    !ve(t) &&
                    o.classList.add("inRange"),
                w.weekNumbers && 1 === w.config.showMonths && "prevMonthDay" !== e && n % 7 == 1 && w.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + w.config.getWeek(t) + "</span>"),
                pe("onDayCreate", o),
                o
            );
        }
        function L(e) {
            e.focus(), "range" === w.config.mode && ae(e);
        }
        function W(e) {
            for (var t = e > 0 ? 0 : w.config.showMonths - 1, n = e > 0 ? w.config.showMonths : -1, a = t; a != n; a += e)
                for (var i = w.daysContainer.children[a], o = e > 0 ? 0 : i.children.length - 1, r = e > 0 ? i.children.length : -1, l = o; l != r; l += e) {
                    var c = i.children[l];
                    if (-1 === c.className.indexOf("hidden") && X(c.dateObj)) return c;
                }
        }
        function R(e, t) {
            var n = ee(document.activeElement || document.body),
                a = void 0 !== e ? e : n ? document.activeElement : void 0 !== w.selectedDateElem && ee(w.selectedDateElem) ? w.selectedDateElem : void 0 !== w.todayDateElem && ee(w.todayDateElem) ? w.todayDateElem : W(t > 0 ? 1 : -1);
            void 0 === a
                ? w._input.focus()
                : n
                ? (function (e, t) {
                      for (var n = -1 === e.className.indexOf("Month") ? e.dateObj.getMonth() : w.currentMonth, a = t > 0 ? w.config.showMonths : -1, i = t > 0 ? 1 : -1, o = n - w.currentMonth; o != a; o += i)
                          for (var r = w.daysContainer.children[o], l = n - w.currentMonth === o ? e.$i + t : t < 0 ? r.children.length - 1 : 0, c = r.children.length, d = l; d >= 0 && d < c && d != (t > 0 ? c : -1); d += i) {
                              var s = r.children[d];
                              if (-1 === s.className.indexOf("hidden") && X(s.dateObj) && Math.abs(e.$i - d) >= Math.abs(t)) return L(s);
                          }
                      w.changeMonth(i), R(W(i), 0);
                  })(a, t)
                : L(a);
        }
        function B(e, t) {
            for (
                var n = (new Date(e, t, 1).getDay() - w.l10n.firstDayOfWeek + 7) % 7,
                    a = w.utils.getDaysInMonth((t - 1 + 12) % 12, e),
                    i = w.utils.getDaysInMonth(t, e),
                    o = window.document.createDocumentFragment(),
                    r = w.config.showMonths > 1,
                    l = r ? "prevMonthDay hidden" : "prevMonthDay",
                    c = r ? "nextMonthDay hidden" : "nextMonthDay",
                    d = a + 1 - n,
                    u = 0;
                d <= a;
                d++, u++
            )
                o.appendChild(H(l, new Date(e, t - 1, d), d, u));
            for (d = 1; d <= i; d++, u++) o.appendChild(H("", new Date(e, t, d), d, u));
            for (var f = i + 1; f <= 42 - n && (1 === w.config.showMonths || u % 7 != 0); f++, u++) o.appendChild(H(c, new Date(e, t + 1, f % i), f, u));
            var m = s("div", "dayContainer");
            return m.appendChild(o), m;
        }
        function J() {
            if (void 0 !== w.daysContainer) {
                u(w.daysContainer), w.weekNumbers && u(w.weekNumbers);
                for (var e = document.createDocumentFragment(), t = 0; t < w.config.showMonths; t++) {
                    var n = new Date(w.currentYear, w.currentMonth, 1);
                    n.setMonth(w.currentMonth + t), e.appendChild(B(n.getFullYear(), n.getMonth()));
                }
                w.daysContainer.appendChild(e), (w.days = w.daysContainer.firstChild), "range" === w.config.mode && 1 === w.selectedDates.length && ae();
            }
        }
        function K() {
            if (!(w.config.showMonths > 1 || "dropdown" !== w.config.monthSelectorType)) {
                var e = function (e) {
                    return (
                        !(void 0 !== w.config.minDate && w.currentYear === w.config.minDate.getFullYear() && e < w.config.minDate.getMonth()) &&
                        !(void 0 !== w.config.maxDate && w.currentYear === w.config.maxDate.getFullYear() && e > w.config.maxDate.getMonth())
                    );
                };
                (w.monthsDropdownContainer.tabIndex = -1), (w.monthsDropdownContainer.innerHTML = "");
                for (var t = 0; t < 12; t++)
                    if (e(t)) {
                        var n = s("option", "flatpickr-monthDropdown-month");
                        (n.value = new Date(w.currentYear, t).getMonth().toString()),
                            (n.textContent = h(t, w.config.shorthandCurrentMonth, w.l10n)),
                            (n.tabIndex = -1),
                            w.currentMonth === t && (n.selected = !0),
                            w.monthsDropdownContainer.appendChild(n);
                    }
            }
        }
        function U() {
            var e,
                t = s("div", "flatpickr-month"),
                n = window.document.createDocumentFragment();
            w.config.showMonths > 1 || "static" === w.config.monthSelectorType
                ? (e = s("span", "cur-month"))
                : ((w.monthsDropdownContainer = s("select", "flatpickr-monthDropdown-months")),
                  w.monthsDropdownContainer.setAttribute("aria-label", w.l10n.monthAriaLabel),
                  A(w.monthsDropdownContainer, "change", function (e) {
                      var t = g(e),
                          n = parseInt(t.value, 10);
                      w.changeMonth(n - w.currentMonth), pe("onMonthChange");
                  }),
                  K(),
                  (e = w.monthsDropdownContainer));
            var a = m("cur-year", { tabindex: "-1" }),
                i = a.getElementsByTagName("input")[0];
            i.setAttribute("aria-label", w.l10n.yearAriaLabel),
                w.config.minDate && i.setAttribute("min", w.config.minDate.getFullYear().toString()),
                w.config.maxDate && (i.setAttribute("max", w.config.maxDate.getFullYear().toString()), (i.disabled = !!w.config.minDate && w.config.minDate.getFullYear() === w.config.maxDate.getFullYear()));
            var o = s("div", "flatpickr-current-month");
            return o.appendChild(e), o.appendChild(a), n.appendChild(o), t.appendChild(n), { container: t, yearElement: i, monthElement: e };
        }
        function q() {
            u(w.monthNav), w.monthNav.appendChild(w.prevMonthNav), w.config.showMonths && ((w.yearElements = []), (w.monthElements = []));
            for (var e = w.config.showMonths; e--; ) {
                var t = U();
                w.yearElements.push(t.yearElement), w.monthElements.push(t.monthElement), w.monthNav.appendChild(t.container);
            }
            w.monthNav.appendChild(w.nextMonthNav);
        }
        function $() {
            w.weekdayContainer ? u(w.weekdayContainer) : (w.weekdayContainer = s("div", "flatpickr-weekdays"));
            for (var e = w.config.showMonths; e--; ) {
                var t = s("div", "flatpickr-weekdaycontainer");
                w.weekdayContainer.appendChild(t);
            }
            return z(), w.weekdayContainer;
        }
        function z() {
            if (w.weekdayContainer) {
                var e = w.l10n.firstDayOfWeek,
                    n = t(w.l10n.weekdays.shorthand);
                e > 0 && e < n.length && (n = t(n.splice(e, n.length), n.splice(0, e)));
                for (var a = w.config.showMonths; a--; ) w.weekdayContainer.children[a].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + n.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
            }
        }
        function G(e, t) {
            void 0 === t && (t = !0);
            var n = t ? e : e - w.currentMonth;
            (n < 0 && !0 === w._hidePrevMonthArrow) ||
                (n > 0 && !0 === w._hideNextMonthArrow) ||
                ((w.currentMonth += n),
                (w.currentMonth < 0 || w.currentMonth > 11) && ((w.currentYear += w.currentMonth > 11 ? 1 : -1), (w.currentMonth = (w.currentMonth + 12) % 12), pe("onYearChange"), K()),
                J(),
                pe("onMonthChange"),
                De());
        }
        function V(e) {
            return !(!w.config.appendTo || !w.config.appendTo.contains(e)) || w.calendarContainer.contains(e);
        }
        function Z(e) {
            if (w.isOpen && !w.config.inline) {
                var t = g(e),
                    n = V(t),
                    a = t === w.input || t === w.altInput || w.element.contains(t) || (e.path && e.path.indexOf && (~e.path.indexOf(w.input) || ~e.path.indexOf(w.altInput))),
                    i = "blur" === e.type ? a && e.relatedTarget && !V(e.relatedTarget) : !a && !n && !V(e.relatedTarget),
                    o = !w.config.ignoredFocusElements.some(function (e) {
                        return e.contains(t);
                    });
                i &&
                    o &&
                    (void 0 !== w.timeContainer && void 0 !== w.minuteElement && void 0 !== w.hourElement && "" !== w.input.value && void 0 !== w.input.value && I(),
                    w.close(),
                    w.config && "range" === w.config.mode && 1 === w.selectedDates.length && (w.clear(!1), w.redraw()));
            }
        }
        function Q(e) {
            if (!(!e || (w.config.minDate && e < w.config.minDate.getFullYear()) || (w.config.maxDate && e > w.config.maxDate.getFullYear()))) {
                var t = e,
                    n = w.currentYear !== t;
                (w.currentYear = t || w.currentYear),
                    w.config.maxDate && w.currentYear === w.config.maxDate.getFullYear()
                        ? (w.currentMonth = Math.min(w.config.maxDate.getMonth(), w.currentMonth))
                        : w.config.minDate && w.currentYear === w.config.minDate.getFullYear() && (w.currentMonth = Math.max(w.config.minDate.getMonth(), w.currentMonth)),
                    n && (w.redraw(), pe("onYearChange"), K());
            }
        }
        function X(e, t) {
            var n;
            void 0 === t && (t = !0);
            var a = w.parseDate(e, void 0, t);
            if ((w.config.minDate && a && M(a, w.config.minDate, void 0 !== t ? t : !w.minDateHasTime) < 0) || (w.config.maxDate && a && M(a, w.config.maxDate, void 0 !== t ? t : !w.maxDateHasTime) > 0)) return !1;
            if (!w.config.enable && 0 === w.config.disable.length) return !0;
            if (void 0 === a) return !1;
            for (var i = !!w.config.enable, o = null !== (n = w.config.enable) && void 0 !== n ? n : w.config.disable, r = 0, l = void 0; r < o.length; r++) {
                if ("function" == typeof (l = o[r]) && l(a)) return i;
                if (l instanceof Date && void 0 !== a && l.getTime() === a.getTime()) return i;
                if ("string" == typeof l) {
                    var c = w.parseDate(l, void 0, !0);
                    return c && c.getTime() === a.getTime() ? i : !i;
                }
                if ("object" == typeof l && void 0 !== a && l.from && l.to && a.getTime() >= l.from.getTime() && a.getTime() <= l.to.getTime()) return i;
            }
            return !i;
        }
        function ee(e) {
            return void 0 !== w.daysContainer && -1 === e.className.indexOf("hidden") && -1 === e.className.indexOf("flatpickr-disabled") && w.daysContainer.contains(e);
        }
        function te(e) {
            !(e.target === w._input) ||
                !(w.selectedDates.length > 0 || w._input.value.length > 0) ||
                (e.relatedTarget && V(e.relatedTarget)) ||
                w.setDate(w._input.value, !0, e.target === w.altInput ? w.config.altFormat : w.config.dateFormat);
        }
        function ne(e) {
            var t = g(e),
                n = w.config.wrap ? p.contains(t) : t === w._input,
                a = w.config.allowInput,
                i = w.isOpen && (!a || !n),
                o = w.config.inline && n && !a;
            if (13 === e.keyCode && n) {
                if (a) return w.setDate(w._input.value, !0, t === w.altInput ? w.config.altFormat : w.config.dateFormat), t.blur();
                w.open();
            } else if (V(t) || i || o) {
                var r = !!w.timeContainer && w.timeContainer.contains(t);
                switch (e.keyCode) {
                    case 13:
                        r ? (e.preventDefault(), I(), se()) : ue(e);
                        break;
                    case 27:
                        e.preventDefault(), se();
                        break;
                    case 8:
                    case 46:
                        n && !w.config.allowInput && (e.preventDefault(), w.clear());
                        break;
                    case 37:
                    case 39:
                        if (r || n) w.hourElement && w.hourElement.focus();
                        else if ((e.preventDefault(), void 0 !== w.daysContainer && (!1 === a || (document.activeElement && ee(document.activeElement))))) {
                            var l = 39 === e.keyCode ? 1 : -1;
                            e.ctrlKey ? (e.stopPropagation(), G(l), R(W(1), 0)) : R(void 0, l);
                        }
                        break;
                    case 38:
                    case 40:
                        e.preventDefault();
                        var c = 40 === e.keyCode ? 1 : -1;
                        (w.daysContainer && void 0 !== t.$i) || t === w.input || t === w.altInput
                            ? e.ctrlKey
                                ? (e.stopPropagation(), Q(w.currentYear - c), R(W(1), 0))
                                : r || R(void 0, 7 * c)
                            : t === w.currentYearElement
                            ? Q(w.currentYear - c)
                            : w.config.enableTime && (!r && w.hourElement && w.hourElement.focus(), I(e), w._debouncedChange());
                        break;
                    case 9:
                        if (r) {
                            var d = [w.hourElement, w.minuteElement, w.secondElement, w.amPM].concat(w.pluginElements).filter(function (e) {
                                    return e;
                                }),
                                s = d.indexOf(t);
                            if (-1 !== s) {
                                var u = d[s + (e.shiftKey ? -1 : 1)];
                                e.preventDefault(), (u || w._input).focus();
                            }
                        } else !w.config.noCalendar && w.daysContainer && w.daysContainer.contains(t) && e.shiftKey && (e.preventDefault(), w._input.focus());
                }
            }
            if (void 0 !== w.amPM && t === w.amPM)
                switch (e.key) {
                    case w.l10n.amPM[0].charAt(0):
                    case w.l10n.amPM[0].charAt(0).toLowerCase():
                        (w.amPM.textContent = w.l10n.amPM[0]), S(), be();
                        break;
                    case w.l10n.amPM[1].charAt(0):
                    case w.l10n.amPM[1].charAt(0).toLowerCase():
                        (w.amPM.textContent = w.l10n.amPM[1]), S(), be();
                }
            (n || V(t)) && pe("onKeyDown", e);
        }
        function ae(e) {
            if (1 === w.selectedDates.length && (!e || (e.classList.contains("flatpickr-day") && !e.classList.contains("flatpickr-disabled")))) {
                for (
                    var t = e ? e.dateObj.getTime() : w.days.firstElementChild.dateObj.getTime(),
                        n = w.parseDate(w.selectedDates[0], void 0, !0).getTime(),
                        a = Math.min(t, w.selectedDates[0].getTime()),
                        i = Math.max(t, w.selectedDates[0].getTime()),
                        o = !1,
                        r = 0,
                        l = 0,
                        c = a;
                    c < i;
                    c += y
                )
                    X(new Date(c), !0) || ((o = o || (c > a && c < i)), c < n && (!r || c > r) ? (r = c) : c > n && (!l || c < l) && (l = c));
                for (var d = 0; d < w.config.showMonths; d++)
                    for (
                        var s = w.daysContainer.children[d],
                            u = function (a, i) {
                                var c,
                                    d,
                                    u,
                                    f = s.children[a],
                                    m = f.dateObj.getTime(),
                                    g = (r > 0 && m < r) || (l > 0 && m > l);
                                return g
                                    ? (f.classList.add("notAllowed"),
                                      ["inRange", "startRange", "endRange"].forEach(function (e) {
                                          f.classList.remove(e);
                                      }),
                                      "continue")
                                    : o && !g
                                    ? "continue"
                                    : (["startRange", "inRange", "endRange", "notAllowed"].forEach(function (e) {
                                          f.classList.remove(e);
                                      }),
                                      void (
                                          void 0 !== e &&
                                          (e.classList.add(t <= w.selectedDates[0].getTime() ? "startRange" : "endRange"),
                                          n < t && m === n ? f.classList.add("startRange") : n > t && m === n && f.classList.add("endRange"),
                                          m >= r && (0 === l || m <= l) && ((d = n), (u = t), (c = m) > Math.min(d, u) && c < Math.max(d, u)) && f.classList.add("inRange"))
                                      ));
                            },
                            f = 0,
                            m = s.children.length;
                        f < m;
                        f++
                    )
                        u(f);
            }
        }
        function ie() {
            !w.isOpen || w.config.static || w.config.inline || ce();
        }
        function oe(e) {
            return function (t) {
                var n = (w.config["_" + e + "Date"] = w.parseDate(t, w.config.dateFormat)),
                    a = w.config["_" + ("min" === e ? "max" : "min") + "Date"];
                void 0 !== n && (w["min" === e ? "minDateHasTime" : "maxDateHasTime"] = n.getHours() > 0 || n.getMinutes() > 0 || n.getSeconds() > 0),
                    w.selectedDates &&
                        ((w.selectedDates = w.selectedDates.filter(function (e) {
                            return X(e);
                        })),
                        w.selectedDates.length || "min" !== e || _(n),
                        be()),
                    w.daysContainer &&
                        (de(), void 0 !== n ? (w.currentYearElement[e] = n.getFullYear().toString()) : w.currentYearElement.removeAttribute(e), (w.currentYearElement.disabled = !!a && void 0 !== n && a.getFullYear() === n.getFullYear()));
            };
        }
        function re() {
            return w.config.wrap ? p.querySelector("[data-input]") : p;
        }
        function le() {
            "object" != typeof w.config.locale && void 0 === T.l10ns[w.config.locale] && w.config.errorHandler(new Error("flatpickr: invalid locale " + w.config.locale)),
                (w.l10n = e(e({}, T.l10ns.default), "object" == typeof w.config.locale ? w.config.locale : "default" !== w.config.locale ? T.l10ns[w.config.locale] : void 0)),
                (D.K = "(" + w.l10n.amPM[0] + "|" + w.l10n.amPM[1] + "|" + w.l10n.amPM[0].toLowerCase() + "|" + w.l10n.amPM[1].toLowerCase() + ")"),
                void 0 === e(e({}, v), JSON.parse(JSON.stringify(p.dataset || {}))).time_24hr && void 0 === T.defaultConfig.time_24hr && (w.config.time_24hr = w.l10n.time_24hr),
                (w.formatDate = b(w)),
                (w.parseDate = C({ config: w.config, l10n: w.l10n }));
        }
        function ce(e) {
            if ("function" != typeof w.config.position) {
                if (void 0 !== w.calendarContainer) {
                    pe("onPreCalendarPosition");
                    var t = e || w._positionElement,
                        n = Array.prototype.reduce.call(
                            w.calendarContainer.children,
                            function (e, t) {
                                return e + t.offsetHeight;
                            },
                            0
                        ),
                        a = w.calendarContainer.offsetWidth,
                        i = w.config.position.split(" "),
                        o = i[0],
                        r = i.length > 1 ? i[1] : null,
                        l = t.getBoundingClientRect(),
                        c = window.innerHeight - l.bottom,
                        s = "above" === o || ("below" !== o && c < n && l.top > n),
                        u = window.pageYOffset + l.top + (s ? -n - 2 : t.offsetHeight + 2);
                    if ((d(w.calendarContainer, "arrowTop", !s), d(w.calendarContainer, "arrowBottom", s), !w.config.inline)) {
                        var f = window.pageXOffset + l.left,
                            m = !1,
                            g = !1;
                        "center" === r ? ((f -= (a - l.width) / 2), (m = !0)) : "right" === r && ((f -= a - l.width), (g = !0)),
                            d(w.calendarContainer, "arrowLeft", !m && !g),
                            d(w.calendarContainer, "arrowCenter", m),
                            d(w.calendarContainer, "arrowRight", g);
                        var p = window.document.body.offsetWidth - (window.pageXOffset + l.right),
                            h = f + a > window.document.body.offsetWidth,
                            v = p + a > window.document.body.offsetWidth;
                        if ((d(w.calendarContainer, "rightMost", h), !w.config.static))
                            if (((w.calendarContainer.style.top = u + "px"), h))
                                if (v) {
                                    var D = (function () {
                                        for (var e = null, t = 0; t < document.styleSheets.length; t++) {
                                            var n = document.styleSheets[t];
                                            try {
                                                n.cssRules;
                                            } catch (e) {
                                                continue;
                                            }
                                            e = n;
                                            break;
                                        }
                                        return null != e ? e : ((a = document.createElement("style")), document.head.appendChild(a), a.sheet);
                                        var a;
                                    })();
                                    if (void 0 === D) return;
                                    var b = window.document.body.offsetWidth,
                                        C = Math.max(0, b / 2 - a / 2),
                                        M = D.cssRules.length,
                                        y = "{left:" + l.left + "px;right:auto;}";
                                    d(w.calendarContainer, "rightMost", !1),
                                        d(w.calendarContainer, "centerMost", !0),
                                        D.insertRule(".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after" + y, M),
                                        (w.calendarContainer.style.left = C + "px"),
                                        (w.calendarContainer.style.right = "auto");
                                } else (w.calendarContainer.style.left = "auto"), (w.calendarContainer.style.right = p + "px");
                            else (w.calendarContainer.style.left = f + "px"), (w.calendarContainer.style.right = "auto");
                    }
                }
            } else w.config.position(w, e);
        }
        function de() {
            w.config.noCalendar || w.isMobile || (K(), De(), J());
        }
        function se() {
            w._input.focus(), -1 !== window.navigator.userAgent.indexOf("MSIE") || void 0 !== navigator.msMaxTouchPoints ? setTimeout(w.close, 0) : w.close();
        }
        function ue(e) {
            e.preventDefault(), e.stopPropagation();
            var t = f(g(e), function (e) {
                return e.classList && e.classList.contains("flatpickr-day") && !e.classList.contains("flatpickr-disabled") && !e.classList.contains("notAllowed");
            });
            if (void 0 !== t) {
                var n = t,
                    a = (w.latestSelectedDateObj = new Date(n.dateObj.getTime())),
                    i = (a.getMonth() < w.currentMonth || a.getMonth() > w.currentMonth + w.config.showMonths - 1) && "range" !== w.config.mode;
                if (((w.selectedDateElem = n), "single" === w.config.mode)) w.selectedDates = [a];
                else if ("multiple" === w.config.mode) {
                    var o = ve(a);
                    o ? w.selectedDates.splice(parseInt(o), 1) : w.selectedDates.push(a);
                } else
                    "range" === w.config.mode &&
                        (2 === w.selectedDates.length && w.clear(!1, !1),
                        (w.latestSelectedDateObj = a),
                        w.selectedDates.push(a),
                        0 !== M(a, w.selectedDates[0], !0) &&
                            w.selectedDates.sort(function (e, t) {
                                return e.getTime() - t.getTime();
                            }));
                if ((S(), i)) {
                    var r = w.currentYear !== a.getFullYear();
                    (w.currentYear = a.getFullYear()), (w.currentMonth = a.getMonth()), r && (pe("onYearChange"), K()), pe("onMonthChange");
                }
                if (
                    (De(),
                    J(),
                    be(),
                    i || "range" === w.config.mode || 1 !== w.config.showMonths ? void 0 !== w.selectedDateElem && void 0 === w.hourElement && w.selectedDateElem && w.selectedDateElem.focus() : L(n),
                    void 0 !== w.hourElement && void 0 !== w.hourElement && w.hourElement.focus(),
                    w.config.closeOnSelect)
                ) {
                    var l = "single" === w.config.mode && !w.config.enableTime,
                        c = "range" === w.config.mode && 2 === w.selectedDates.length && !w.config.enableTime;
                    (l || c) && se();
                }
                N();
            }
        }
        (w.parseDate = C({ config: w.config, l10n: w.l10n })),
            (w._handlers = []),
            (w.pluginElements = []),
            (w.loadedPlugins = []),
            (w._bind = A),
            (w._setHoursFromDate = _),
            (w._positionCalendar = ce),
            (w.changeMonth = G),
            (w.changeYear = Q),
            (w.clear = function (e, t) {
                void 0 === e && (e = !0);
                void 0 === t && (t = !0);
                (w.input.value = ""), void 0 !== w.altInput && (w.altInput.value = "");
                void 0 !== w.mobileInput && (w.mobileInput.value = "");
                (w.selectedDates = []), (w.latestSelectedDateObj = void 0), !0 === t && ((w.currentYear = w._initialDate.getFullYear()), (w.currentMonth = w._initialDate.getMonth()));
                if (!0 === w.config.enableTime) {
                    var n = x(w.config),
                        a = n.hours,
                        i = n.minutes,
                        o = n.seconds;
                    O(a, i, o);
                }
                w.redraw(), e && pe("onChange");
            }),
            (w.close = function () {
                (w.isOpen = !1), w.isMobile || (void 0 !== w.calendarContainer && w.calendarContainer.classList.remove("open"), void 0 !== w._input && w._input.classList.remove("active"));
                pe("onClose");
            }),
            (w._createElement = s),
            (w.destroy = function () {
                void 0 !== w.config && pe("onDestroy");
                for (var e = w._handlers.length; e--; ) w._handlers[e].remove();
                if (((w._handlers = []), w.mobileInput)) w.mobileInput.parentNode && w.mobileInput.parentNode.removeChild(w.mobileInput), (w.mobileInput = void 0);
                else if (w.calendarContainer && w.calendarContainer.parentNode)
                    if (w.config.static && w.calendarContainer.parentNode) {
                        var t = w.calendarContainer.parentNode;
                        if ((t.lastChild && t.removeChild(t.lastChild), t.parentNode)) {
                            for (; t.firstChild; ) t.parentNode.insertBefore(t.firstChild, t);
                            t.parentNode.removeChild(t);
                        }
                    } else w.calendarContainer.parentNode.removeChild(w.calendarContainer);
                w.altInput && ((w.input.type = "text"), w.altInput.parentNode && w.altInput.parentNode.removeChild(w.altInput), delete w.altInput);
                w.input && ((w.input.type = w.input._type), w.input.classList.remove("flatpickr-input"), w.input.removeAttribute("readonly"));
                [
                    "_showTimeInput",
                    "latestSelectedDateObj",
                    "_hideNextMonthArrow",
                    "_hidePrevMonthArrow",
                    "__hideNextMonthArrow",
                    "__hidePrevMonthArrow",
                    "isMobile",
                    "isOpen",
                    "selectedDateElem",
                    "minDateHasTime",
                    "maxDateHasTime",
                    "days",
                    "daysContainer",
                    "_input",
                    "_positionElement",
                    "innerContainer",
                    "rContainer",
                    "monthNav",
                    "todayDateElem",
                    "calendarContainer",
                    "weekdayContainer",
                    "prevMonthNav",
                    "nextMonthNav",
                    "monthsDropdownContainer",
                    "currentMonthElement",
                    "currentYearElement",
                    "navigationCurrentMonth",
                    "selectedDateElem",
                    "config",
                ].forEach(function (e) {
                    try {
                        delete w[e];
                    } catch (e) {}
                });
            }),
            (w.isEnabled = X),
            (w.jumpToDate = P),
            (w.open = function (e, t) {
                void 0 === t && (t = w._positionElement);
                if (!0 === w.isMobile) {
                    if (e) {
                        e.preventDefault();
                        var n = g(e);
                        n && n.blur();
                    }
                    return void 0 !== w.mobileInput && (w.mobileInput.focus(), w.mobileInput.click()), void pe("onOpen");
                }
                if (w._input.disabled || w.config.inline) return;
                var a = w.isOpen;
                (w.isOpen = !0), a || (w.calendarContainer.classList.add("open"), w._input.classList.add("active"), pe("onOpen"), ce(t));
                !0 === w.config.enableTime &&
                    !0 === w.config.noCalendar &&
                    (!1 !== w.config.allowInput ||
                        (void 0 !== e && w.timeContainer.contains(e.relatedTarget)) ||
                        setTimeout(function () {
                            return w.hourElement.select();
                        }, 50));
            }),
            (w.redraw = de),
            (w.set = function (e, t) {
                if (null !== e && "object" == typeof e)
                    for (var a in (Object.assign(w.config, e), e))
                        void 0 !== fe[a] &&
                            fe[a].forEach(function (e) {
                                return e();
                            });
                else
                    (w.config[e] = t),
                        void 0 !== fe[e]
                            ? fe[e].forEach(function (e) {
                                  return e();
                              })
                            : n.indexOf(e) > -1 && (w.config[e] = c(t));
                w.redraw(), be(!0);
            }),
            (w.setDate = function (e, t, n) {
                void 0 === t && (t = !1);
                void 0 === n && (n = w.config.dateFormat);
                if ((0 !== e && !e) || (e instanceof Array && 0 === e.length)) return w.clear(t);
                me(e, n), (w.latestSelectedDateObj = w.selectedDates[w.selectedDates.length - 1]), w.redraw(), P(void 0, t), _(), 0 === w.selectedDates.length && w.clear(!1);
                be(t), t && pe("onChange");
            }),
            (w.toggle = function (e) {
                if (!0 === w.isOpen) return w.close();
                w.open(e);
            });
        var fe = {
            locale: [le, z],
            showMonths: [q, k, $],
            minDate: [P],
            maxDate: [P],
            clickOpens: [
                function () {
                    !0 === w.config.clickOpens ? (A(w._input, "focus", w.open), A(w._input, "click", w.open)) : (w._input.removeEventListener("focus", w.open), w._input.removeEventListener("click", w.open));
                },
            ],
        };
        function me(e, t) {
            var n = [];
            if (e instanceof Array)
                n = e.map(function (e) {
                    return w.parseDate(e, t);
                });
            else if (e instanceof Date || "number" == typeof e) n = [w.parseDate(e, t)];
            else if ("string" == typeof e)
                switch (w.config.mode) {
                    case "single":
                    case "time":
                        n = [w.parseDate(e, t)];
                        break;
                    case "multiple":
                        n = e.split(w.config.conjunction).map(function (e) {
                            return w.parseDate(e, t);
                        });
                        break;
                    case "range":
                        n = e.split(w.l10n.rangeSeparator).map(function (e) {
                            return w.parseDate(e, t);
                        });
                }
            else w.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(e)));
            (w.selectedDates = w.config.allowInvalidPreload
                ? n
                : n.filter(function (e) {
                      return e instanceof Date && X(e, !1);
                  })),
                "range" === w.config.mode &&
                    w.selectedDates.sort(function (e, t) {
                        return e.getTime() - t.getTime();
                    });
        }
        function ge(e) {
            return e
                .slice()
                .map(function (e) {
                    return "string" == typeof e || "number" == typeof e || e instanceof Date
                        ? w.parseDate(e, void 0, !0)
                        : e && "object" == typeof e && e.from && e.to
                        ? { from: w.parseDate(e.from, void 0), to: w.parseDate(e.to, void 0) }
                        : e;
                })
                .filter(function (e) {
                    return e;
                });
        }
        function pe(e, t) {
            if (void 0 !== w.config) {
                var n = w.config[e];
                if (void 0 !== n && n.length > 0) for (var a = 0; n[a] && a < n.length; a++) n[a](w.selectedDates, w.input.value, w, t);
                "onChange" === e && (w.input.dispatchEvent(he("change")), w.input.dispatchEvent(he("input")));
            }
        }
        function he(e) {
            var t = document.createEvent("Event");
            return t.initEvent(e, !0, !0), t;
        }
        function ve(e) {
            for (var t = 0; t < w.selectedDates.length; t++) if (0 === M(w.selectedDates[t], e)) return "" + t;
            return !1;
        }
        function De() {
            w.config.noCalendar ||
                w.isMobile ||
                !w.monthNav ||
                (w.yearElements.forEach(function (e, t) {
                    var n = new Date(w.currentYear, w.currentMonth, 1);
                    n.setMonth(w.currentMonth + t),
                        w.config.showMonths > 1 || "static" === w.config.monthSelectorType
                            ? (w.monthElements[t].textContent = h(n.getMonth(), w.config.shorthandCurrentMonth, w.l10n) + " ")
                            : (w.monthsDropdownContainer.value = n.getMonth().toString()),
                        (e.value = n.getFullYear().toString());
                }),
                (w._hidePrevMonthArrow = void 0 !== w.config.minDate && (w.currentYear === w.config.minDate.getFullYear() ? w.currentMonth <= w.config.minDate.getMonth() : w.currentYear < w.config.minDate.getFullYear())),
                (w._hideNextMonthArrow = void 0 !== w.config.maxDate && (w.currentYear === w.config.maxDate.getFullYear() ? w.currentMonth + 1 > w.config.maxDate.getMonth() : w.currentYear > w.config.maxDate.getFullYear())));
        }
        function we(e) {
            return w.selectedDates
                .map(function (t) {
                    return w.formatDate(t, e);
                })
                .filter(function (e, t, n) {
                    return "range" !== w.config.mode || w.config.enableTime || n.indexOf(e) === t;
                })
                .join("range" !== w.config.mode ? w.config.conjunction : w.l10n.rangeSeparator);
        }
        function be(e) {
            void 0 === e && (e = !0),
                void 0 !== w.mobileInput && w.mobileFormatStr && (w.mobileInput.value = void 0 !== w.latestSelectedDateObj ? w.formatDate(w.latestSelectedDateObj, w.mobileFormatStr) : ""),
                (w.input.value = we(w.config.dateFormat)),
                void 0 !== w.altInput && (w.altInput.value = we(w.config.altFormat)),
                !1 !== e && pe("onValueUpdate");
        }
        function Ce(e) {
            var t = g(e),
                n = w.prevMonthNav.contains(t),
                a = w.nextMonthNav.contains(t);
            n || a ? G(n ? -1 : 1) : w.yearElements.indexOf(t) >= 0 ? t.select() : t.classList.contains("arrowUp") ? w.changeYear(w.currentYear + 1) : t.classList.contains("arrowDown") && w.changeYear(w.currentYear - 1);
        }
        return (
            (function () {
                (w.element = w.input = p),
                    (w.isOpen = !1),
                    (function () {
                        var t = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"],
                            i = e(e({}, JSON.parse(JSON.stringify(p.dataset || {}))), v),
                            o = {};
                        (w.config.parseDate = i.parseDate),
                            (w.config.formatDate = i.formatDate),
                            Object.defineProperty(w.config, "enable", {
                                get: function () {
                                    return w.config._enable;
                                },
                                set: function (e) {
                                    w.config._enable = ge(e);
                                },
                            }),
                            Object.defineProperty(w.config, "disable", {
                                get: function () {
                                    return w.config._disable;
                                },
                                set: function (e) {
                                    w.config._disable = ge(e);
                                },
                            });
                        var r = "time" === i.mode;
                        if (!i.dateFormat && (i.enableTime || r)) {
                            var l = T.defaultConfig.dateFormat || a.dateFormat;
                            o.dateFormat = i.noCalendar || r ? "H:i" + (i.enableSeconds ? ":S" : "") : l + " H:i" + (i.enableSeconds ? ":S" : "");
                        }
                        if (i.altInput && (i.enableTime || r) && !i.altFormat) {
                            var d = T.defaultConfig.altFormat || a.altFormat;
                            o.altFormat = i.noCalendar || r ? "h:i" + (i.enableSeconds ? ":S K" : " K") : d + " h:i" + (i.enableSeconds ? ":S" : "") + " K";
                        }
                        Object.defineProperty(w.config, "minDate", {
                            get: function () {
                                return w.config._minDate;
                            },
                            set: oe("min"),
                        }),
                            Object.defineProperty(w.config, "maxDate", {
                                get: function () {
                                    return w.config._maxDate;
                                },
                                set: oe("max"),
                            });
                        var s = function (e) {
                            return function (t) {
                                w.config["min" === e ? "_minTime" : "_maxTime"] = w.parseDate(t, "H:i:S");
                            };
                        };
                        Object.defineProperty(w.config, "minTime", {
                            get: function () {
                                return w.config._minTime;
                            },
                            set: s("min"),
                        }),
                            Object.defineProperty(w.config, "maxTime", {
                                get: function () {
                                    return w.config._maxTime;
                                },
                                set: s("max"),
                            }),
                            "time" === i.mode && ((w.config.noCalendar = !0), (w.config.enableTime = !0));
                        Object.assign(w.config, o, i);
                        for (var u = 0; u < t.length; u++) w.config[t[u]] = !0 === w.config[t[u]] || "true" === w.config[t[u]];
                        n
                            .filter(function (e) {
                                return void 0 !== w.config[e];
                            })
                            .forEach(function (e) {
                                w.config[e] = c(w.config[e] || []).map(E);
                            }),
                            (w.isMobile =
                                !w.config.disableMobile &&
                                !w.config.inline &&
                                "single" === w.config.mode &&
                                !w.config.disable.length &&
                                !w.config.enable &&
                                !w.config.weekNumbers &&
                                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
                        for (u = 0; u < w.config.plugins.length; u++) {
                            var f = w.config.plugins[u](w) || {};
                            for (var m in f) n.indexOf(m) > -1 ? (w.config[m] = c(f[m]).map(E).concat(w.config[m])) : void 0 === i[m] && (w.config[m] = f[m]);
                        }
                        i.altInputClass || (w.config.altInputClass = re().className + " " + w.config.altInputClass);
                        pe("onParseConfig");
                    })(),
                    le(),
                    (function () {
                        if (((w.input = re()), !w.input)) return void w.config.errorHandler(new Error("Invalid input element specified"));
                        (w.input._type = w.input.type),
                            (w.input.type = "text"),
                            w.input.classList.add("flatpickr-input"),
                            (w._input = w.input),
                            w.config.altInput &&
                                ((w.altInput = s(w.input.nodeName, w.config.altInputClass)),
                                (w._input = w.altInput),
                                (w.altInput.placeholder = w.input.placeholder),
                                (w.altInput.disabled = w.input.disabled),
                                (w.altInput.required = w.input.required),
                                (w.altInput.tabIndex = w.input.tabIndex),
                                (w.altInput.type = "text"),
                                w.input.setAttribute("type", "hidden"),
                                !w.config.static && w.input.parentNode && w.input.parentNode.insertBefore(w.altInput, w.input.nextSibling));
                        w.config.allowInput || w._input.setAttribute("readonly", "readonly");
                        w._positionElement = w.config.positionElement || w._input;
                    })(),
                    (function () {
                        (w.selectedDates = []), (w.now = w.parseDate(w.config.now) || new Date());
                        var e = w.config.defaultDate || (("INPUT" !== w.input.nodeName && "TEXTAREA" !== w.input.nodeName) || !w.input.placeholder || w.input.value !== w.input.placeholder ? w.input.value : null);
                        e && me(e, w.config.dateFormat);
                        (w._initialDate =
                            w.selectedDates.length > 0
                                ? w.selectedDates[0]
                                : w.config.minDate && w.config.minDate.getTime() > w.now.getTime()
                                ? w.config.minDate
                                : w.config.maxDate && w.config.maxDate.getTime() < w.now.getTime()
                                ? w.config.maxDate
                                : w.now),
                            (w.currentYear = w._initialDate.getFullYear()),
                            (w.currentMonth = w._initialDate.getMonth()),
                            w.selectedDates.length > 0 && (w.latestSelectedDateObj = w.selectedDates[0]);
                        void 0 !== w.config.minTime && (w.config.minTime = w.parseDate(w.config.minTime, "H:i"));
                        void 0 !== w.config.maxTime && (w.config.maxTime = w.parseDate(w.config.maxTime, "H:i"));
                        (w.minDateHasTime = !!w.config.minDate && (w.config.minDate.getHours() > 0 || w.config.minDate.getMinutes() > 0 || w.config.minDate.getSeconds() > 0)),
                            (w.maxDateHasTime = !!w.config.maxDate && (w.config.maxDate.getHours() > 0 || w.config.maxDate.getMinutes() > 0 || w.config.maxDate.getSeconds() > 0));
                    })(),
                    (w.utils = {
                        getDaysInMonth: function (e, t) {
                            return void 0 === e && (e = w.currentMonth), void 0 === t && (t = w.currentYear), 1 === e && ((t % 4 == 0 && t % 100 != 0) || t % 400 == 0) ? 29 : w.l10n.daysInMonth[e];
                        },
                    }),
                    w.isMobile ||
                        (function () {
                            var e = window.document.createDocumentFragment();
                            if (((w.calendarContainer = s("div", "flatpickr-calendar")), (w.calendarContainer.tabIndex = -1), !w.config.noCalendar)) {
                                if (
                                    (e.appendChild(
                                        ((w.monthNav = s("div", "flatpickr-months")),
                                        (w.yearElements = []),
                                        (w.monthElements = []),
                                        (w.prevMonthNav = s("span", "flatpickr-prev-month")),
                                        (w.prevMonthNav.innerHTML = w.config.prevArrow),
                                        (w.nextMonthNav = s("span", "flatpickr-next-month")),
                                        (w.nextMonthNav.innerHTML = w.config.nextArrow),
                                        q(),
                                        Object.defineProperty(w, "_hidePrevMonthArrow", {
                                            get: function () {
                                                return w.__hidePrevMonthArrow;
                                            },
                                            set: function (e) {
                                                w.__hidePrevMonthArrow !== e && (d(w.prevMonthNav, "flatpickr-disabled", e), (w.__hidePrevMonthArrow = e));
                                            },
                                        }),
                                        Object.defineProperty(w, "_hideNextMonthArrow", {
                                            get: function () {
                                                return w.__hideNextMonthArrow;
                                            },
                                            set: function (e) {
                                                w.__hideNextMonthArrow !== e && (d(w.nextMonthNav, "flatpickr-disabled", e), (w.__hideNextMonthArrow = e));
                                            },
                                        }),
                                        (w.currentYearElement = w.yearElements[0]),
                                        De(),
                                        w.monthNav)
                                    ),
                                    (w.innerContainer = s("div", "flatpickr-innerContainer")),
                                    w.config.weekNumbers)
                                ) {
                                    var t = (function () {
                                            w.calendarContainer.classList.add("hasWeeks");
                                            var e = s("div", "flatpickr-weekwrapper");
                                            e.appendChild(s("span", "flatpickr-weekday", w.l10n.weekAbbreviation));
                                            var t = s("div", "flatpickr-weeks");
                                            return e.appendChild(t), { weekWrapper: e, weekNumbers: t };
                                        })(),
                                        n = t.weekWrapper,
                                        a = t.weekNumbers;
                                    w.innerContainer.appendChild(n), (w.weekNumbers = a), (w.weekWrapper = n);
                                }
                                (w.rContainer = s("div", "flatpickr-rContainer")),
                                    w.rContainer.appendChild($()),
                                    w.daysContainer || ((w.daysContainer = s("div", "flatpickr-days")), (w.daysContainer.tabIndex = -1)),
                                    J(),
                                    w.rContainer.appendChild(w.daysContainer),
                                    w.innerContainer.appendChild(w.rContainer),
                                    e.appendChild(w.innerContainer);
                            }
                            w.config.enableTime &&
                                e.appendChild(
                                    (function () {
                                        w.calendarContainer.classList.add("hasTime"), w.config.noCalendar && w.calendarContainer.classList.add("noCalendar");
                                        var e = x(w.config);
                                        (w.timeContainer = s("div", "flatpickr-time")), (w.timeContainer.tabIndex = -1);
                                        var t = s("span", "flatpickr-time-separator", ":"),
                                            n = m("flatpickr-hour", { "aria-label": w.l10n.hourAriaLabel });
                                        w.hourElement = n.getElementsByTagName("input")[0];
                                        var a = m("flatpickr-minute", { "aria-label": w.l10n.minuteAriaLabel });
                                        (w.minuteElement = a.getElementsByTagName("input")[0]),
                                            (w.hourElement.tabIndex = w.minuteElement.tabIndex = -1),
                                            (w.hourElement.value = o(
                                                w.latestSelectedDateObj
                                                    ? w.latestSelectedDateObj.getHours()
                                                    : w.config.time_24hr
                                                    ? e.hours
                                                    : (function (e) {
                                                          switch (e % 24) {
                                                              case 0:
                                                              case 12:
                                                                  return 12;
                                                              default:
                                                                  return e % 12;
                                                          }
                                                      })(e.hours)
                                            )),
                                            (w.minuteElement.value = o(w.latestSelectedDateObj ? w.latestSelectedDateObj.getMinutes() : e.minutes)),
                                            w.hourElement.setAttribute("step", w.config.hourIncrement.toString()),
                                            w.minuteElement.setAttribute("step", w.config.minuteIncrement.toString()),
                                            w.hourElement.setAttribute("min", w.config.time_24hr ? "0" : "1"),
                                            w.hourElement.setAttribute("max", w.config.time_24hr ? "23" : "12"),
                                            w.hourElement.setAttribute("maxlength", "2"),
                                            w.minuteElement.setAttribute("min", "0"),
                                            w.minuteElement.setAttribute("max", "59"),
                                            w.minuteElement.setAttribute("maxlength", "2"),
                                            w.timeContainer.appendChild(n),
                                            w.timeContainer.appendChild(t),
                                            w.timeContainer.appendChild(a),
                                            w.config.time_24hr && w.timeContainer.classList.add("time24hr");
                                        if (w.config.enableSeconds) {
                                            w.timeContainer.classList.add("hasSeconds");
                                            var i = m("flatpickr-second");
                                            (w.secondElement = i.getElementsByTagName("input")[0]),
                                                (w.secondElement.value = o(w.latestSelectedDateObj ? w.latestSelectedDateObj.getSeconds() : e.seconds)),
                                                w.secondElement.setAttribute("step", w.minuteElement.getAttribute("step")),
                                                w.secondElement.setAttribute("min", "0"),
                                                w.secondElement.setAttribute("max", "59"),
                                                w.secondElement.setAttribute("maxlength", "2"),
                                                w.timeContainer.appendChild(s("span", "flatpickr-time-separator", ":")),
                                                w.timeContainer.appendChild(i);
                                        }
                                        w.config.time_24hr ||
                                            ((w.amPM = s("span", "flatpickr-am-pm", w.l10n.amPM[r((w.latestSelectedDateObj ? w.hourElement.value : w.config.defaultHour) > 11)])),
                                            (w.amPM.title = w.l10n.toggleTitle),
                                            (w.amPM.tabIndex = -1),
                                            w.timeContainer.appendChild(w.amPM));
                                        return w.timeContainer;
                                    })()
                                );
                            d(w.calendarContainer, "rangeMode", "range" === w.config.mode),
                                d(w.calendarContainer, "animate", !0 === w.config.animate),
                                d(w.calendarContainer, "multiMonth", w.config.showMonths > 1),
                                w.calendarContainer.appendChild(e);
                            var i = void 0 !== w.config.appendTo && void 0 !== w.config.appendTo.nodeType;
                            if (
                                (w.config.inline || w.config.static) &&
                                (w.calendarContainer.classList.add(w.config.inline ? "inline" : "static"),
                                w.config.inline &&
                                    (!i && w.element.parentNode ? w.element.parentNode.insertBefore(w.calendarContainer, w._input.nextSibling) : void 0 !== w.config.appendTo && w.config.appendTo.appendChild(w.calendarContainer)),
                                w.config.static)
                            ) {
                                var l = s("div", "flatpickr-wrapper");
                                w.element.parentNode && w.element.parentNode.insertBefore(l, w.element), l.appendChild(w.element), w.altInput && l.appendChild(w.altInput), l.appendChild(w.calendarContainer);
                            }
                            w.config.static || w.config.inline || (void 0 !== w.config.appendTo ? w.config.appendTo : window.document.body).appendChild(w.calendarContainer);
                        })(),
                    (function () {
                        w.config.wrap &&
                            ["open", "close", "toggle", "clear"].forEach(function (e) {
                                Array.prototype.forEach.call(w.element.querySelectorAll("[data-" + e + "]"), function (t) {
                                    return A(t, "click", w[e]);
                                });
                            });
                        if (w.isMobile)
                            return void (function () {
                                var e = w.config.enableTime ? (w.config.noCalendar ? "time" : "datetime-local") : "date";
                                (w.mobileInput = s("input", w.input.className + " flatpickr-mobile")),
                                    (w.mobileInput.tabIndex = 1),
                                    (w.mobileInput.type = e),
                                    (w.mobileInput.disabled = w.input.disabled),
                                    (w.mobileInput.required = w.input.required),
                                    (w.mobileInput.placeholder = w.input.placeholder),
                                    (w.mobileFormatStr = "datetime-local" === e ? "Y-m-d\\TH:i:S" : "date" === e ? "Y-m-d" : "H:i:S"),
                                    w.selectedDates.length > 0 && (w.mobileInput.defaultValue = w.mobileInput.value = w.formatDate(w.selectedDates[0], w.mobileFormatStr));
                                w.config.minDate && (w.mobileInput.min = w.formatDate(w.config.minDate, "Y-m-d"));
                                w.config.maxDate && (w.mobileInput.max = w.formatDate(w.config.maxDate, "Y-m-d"));
                                w.input.getAttribute("step") && (w.mobileInput.step = String(w.input.getAttribute("step")));
                                (w.input.type = "hidden"), void 0 !== w.altInput && (w.altInput.type = "hidden");
                                try {
                                    w.input.parentNode && w.input.parentNode.insertBefore(w.mobileInput, w.input.nextSibling);
                                } catch (e) {}
                                A(w.mobileInput, "change", function (e) {
                                    w.setDate(g(e).value, !1, w.mobileFormatStr), pe("onChange"), pe("onClose");
                                });
                            })();
                        var e = l(ie, 50);
                        (w._debouncedChange = l(N, 300)),
                            w.daysContainer &&
                                !/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
                                A(w.daysContainer, "mouseover", function (e) {
                                    "range" === w.config.mode && ae(g(e));
                                });
                        A(window.document.body, "keydown", ne), w.config.inline || w.config.static || A(window, "resize", e);
                        void 0 !== window.ontouchstart ? A(window.document, "touchstart", Z) : A(window.document, "mousedown", Z);
                        A(window.document, "focus", Z, { capture: !0 }), !0 === w.config.clickOpens && (A(w._input, "focus", w.open), A(w._input, "click", w.open));
                        void 0 !== w.daysContainer && (A(w.monthNav, "click", Ce), A(w.monthNav, ["keyup", "increment"], F), A(w.daysContainer, "click", ue));
                        if (void 0 !== w.timeContainer && void 0 !== w.minuteElement && void 0 !== w.hourElement) {
                            var t = function (e) {
                                return g(e).select();
                            };
                            A(w.timeContainer, ["increment"], I),
                                A(w.timeContainer, "blur", I, { capture: !0 }),
                                A(w.timeContainer, "click", Y),
                                A([w.hourElement, w.minuteElement], ["focus", "click"], t),
                                void 0 !== w.secondElement &&
                                    A(w.secondElement, "focus", function () {
                                        return w.secondElement && w.secondElement.select();
                                    }),
                                void 0 !== w.amPM &&
                                    A(w.amPM, "click", function (e) {
                                        I(e), N();
                                    });
                        }
                        w.config.allowInput && A(w._input, "blur", te);
                    })(),
                    (w.selectedDates.length || w.config.noCalendar) && (w.config.enableTime && _(w.config.noCalendar ? w.latestSelectedDateObj : void 0), be(!1)),
                    k();
                var t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                !w.isMobile && t && ce(), pe("onReady");
            })(),
            w
        );
    }
    function k(e, t) {
        for (
            var n = Array.prototype.slice.call(e).filter(function (e) {
                    return e instanceof HTMLElement;
                }),
                a = [],
                i = 0;
            i < n.length;
            i++
        ) {
            var o = n[i];
            try {
                if (null !== o.getAttribute("data-fp-omit")) continue;
                void 0 !== o._flatpickr && (o._flatpickr.destroy(), (o._flatpickr = void 0)), (o._flatpickr = E(o, t || {})), a.push(o._flatpickr);
            } catch (e) {
                console.error(e);
            }
        }
        return 1 === a.length ? a[0] : a;
    }
    "undefined" != typeof HTMLElement &&
        "undefined" != typeof HTMLCollection &&
        "undefined" != typeof NodeList &&
        ((HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (e) {
            return k(this, e);
        }),
        (HTMLElement.prototype.flatpickr = function (e) {
            return k([this], e);
        }));
    var T = function (e, t) {
        return "string" == typeof e ? k(window.document.querySelectorAll(e), t) : e instanceof Node ? k([e], t) : k(e, t);
    };
    return (
        (T.defaultConfig = {}),
        (T.l10ns = { en: e({}, i), default: e({}, i) }),
        (T.localize = function (t) {
            T.l10ns.default = e(e({}, T.l10ns.default), t);
        }),
        (T.setDefaults = function (t) {
            T.defaultConfig = e(e({}, T.defaultConfig), t);
        }),
        (T.parseDate = C({})),
        (T.formatDate = b({})),
        (T.compareDates = M),
        "undefined" != typeof jQuery &&
            void 0 !== jQuery.fn &&
            (jQuery.fn.flatpickr = function (e) {
                return k(this, e);
            }),
        (Date.prototype.fp_incr = function (e) {
            return new Date(this.getFullYear(), this.getMonth(), this.getDate() + ("string" == typeof e ? parseInt(e, 10) : e));
        }),
        "undefined" != typeof window && (window.flatpickr = T),
        T
    );
});
/*! Select2 4.0.13 | https://github.com/select2/select2/blob/master/LICENSE.md */
!(function (n) {
    "function" == typeof define && define.amd
        ? define(["jquery"], n)
        : "object" == typeof module && module.exports
        ? (module.exports = function (e, t) {
              return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), n(t), t;
          })
        : n(jQuery);
})(function (u) {
    var e = (function () {
            if (u && u.fn && u.fn.select2 && u.fn.select2.amd) var e = u.fn.select2.amd;
            var t, n, r, h, o, s, f, g, m, v, y, _, i, a, b;
            function w(e, t) {
                return i.call(e, t);
            }
            function l(e, t) {
                var n,
                    r,
                    i,
                    o,
                    s,
                    a,
                    l,
                    c,
                    u,
                    d,
                    p,
                    h = t && t.split("/"),
                    f = y.map,
                    g = (f && f["*"]) || {};
                if (e) {
                    for (s = (e = e.split("/")).length - 1, y.nodeIdCompat && b.test(e[s]) && (e[s] = e[s].replace(b, "")), "." === e[0].charAt(0) && h && (e = h.slice(0, h.length - 1).concat(e)), u = 0; u < e.length; u++)
                        if ("." === (p = e[u])) e.splice(u, 1), --u;
                        else if (".." === p) {
                            if (0 === u || (1 === u && ".." === e[2]) || ".." === e[u - 1]) continue;
                            0 < u && (e.splice(u - 1, 2), (u -= 2));
                        }
                    e = e.join("/");
                }
                if ((h || g) && f) {
                    for (u = (n = e.split("/")).length; 0 < u; --u) {
                        if (((r = n.slice(0, u).join("/")), h))
                            for (d = h.length; 0 < d; --d)
                                if ((i = (i = f[h.slice(0, d).join("/")]) && i[r])) {
                                    (o = i), (a = u);
                                    break;
                                }
                        if (o) break;
                        !l && g && g[r] && ((l = g[r]), (c = u));
                    }
                    !o && l && ((o = l), (a = c)), o && (n.splice(0, a, o), (e = n.join("/")));
                }
                return e;
            }
            function A(t, n) {
                return function () {
                    var e = a.call(arguments, 0);
                    return "string" != typeof e[0] && 1 === e.length && e.push(null), s.apply(h, e.concat([t, n]));
                };
            }
            function x(t) {
                return function (e) {
                    m[t] = e;
                };
            }
            function D(e) {
                if (w(v, e)) {
                    var t = v[e];
                    delete v[e], (_[e] = !0), o.apply(h, t);
                }
                if (!w(m, e) && !w(_, e)) throw new Error("No " + e);
                return m[e];
            }
            function c(e) {
                var t,
                    n = e ? e.indexOf("!") : -1;
                return -1 < n && ((t = e.substring(0, n)), (e = e.substring(n + 1, e.length))), [t, e];
            }
            function S(e) {
                return e ? c(e) : [];
            }
            return (
                (e && e.requirejs) ||
                    (e ? (n = e) : (e = {}),
                    (m = {}),
                    (v = {}),
                    (y = {}),
                    (_ = {}),
                    (i = Object.prototype.hasOwnProperty),
                    (a = [].slice),
                    (b = /\.js$/),
                    (f = function (e, t) {
                        var n,
                            r,
                            i = c(e),
                            o = i[0],
                            s = t[1];
                        return (
                            (e = i[1]),
                            o && (n = D((o = l(o, s)))),
                            o
                                ? (e =
                                      n && n.normalize
                                          ? n.normalize(
                                                e,
                                                ((r = s),
                                                function (e) {
                                                    return l(e, r);
                                                })
                                            )
                                          : l(e, s))
                                : ((o = (i = c((e = l(e, s))))[0]), (e = i[1]), o && (n = D(o))),
                            { f: o ? o + "!" + e : e, n: e, pr: o, p: n }
                        );
                    }),
                    (g = {
                        require: function (e) {
                            return A(e);
                        },
                        exports: function (e) {
                            var t = m[e];
                            return void 0 !== t ? t : (m[e] = {});
                        },
                        module: function (e) {
                            return {
                                id: e,
                                uri: "",
                                exports: m[e],
                                config:
                                    ((t = e),
                                    function () {
                                        return (y && y.config && y.config[t]) || {};
                                    }),
                            };
                            var t;
                        },
                    }),
                    (o = function (e, t, n, r) {
                        var i,
                            o,
                            s,
                            a,
                            l,
                            c,
                            u,
                            d = [],
                            p = typeof n;
                        if (((c = S((r = r || e))), "undefined" == p || "function" == p)) {
                            for (t = !t.length && n.length ? ["require", "exports", "module"] : t, l = 0; l < t.length; l += 1)
                                if ("require" === (o = (a = f(t[l], c)).f)) d[l] = g.require(e);
                                else if ("exports" === o) (d[l] = g.exports(e)), (u = !0);
                                else if ("module" === o) i = d[l] = g.module(e);
                                else if (w(m, o) || w(v, o) || w(_, o)) d[l] = D(o);
                                else {
                                    if (!a.p) throw new Error(e + " missing " + o);
                                    a.p.load(a.n, A(r, !0), x(o), {}), (d[l] = m[o]);
                                }
                            (s = n ? n.apply(m[e], d) : void 0), e && (i && i.exports !== h && i.exports !== m[e] ? (m[e] = i.exports) : (s === h && u) || (m[e] = s));
                        } else e && (m[e] = n);
                    }),
                    (t = n = s = function (e, t, n, r, i) {
                        if ("string" == typeof e) return g[e] ? g[e](t) : D(f(e, S(t)).f);
                        if (!e.splice) {
                            if (((y = e).deps && s(y.deps, y.callback), !t)) return;
                            t.splice ? ((e = t), (t = n), (n = null)) : (e = h);
                        }
                        return (
                            (t = t || function () {}),
                            "function" == typeof n && ((n = r), (r = i)),
                            r
                                ? o(h, e, t, n)
                                : setTimeout(function () {
                                      o(h, e, t, n);
                                  }, 4),
                            s
                        );
                    }),
                    (s.config = function (e) {
                        return s(e);
                    }),
                    (t._defined = m),
                    ((r = function (e, t, n) {
                        if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");
                        t.splice || ((n = t), (t = [])), w(m, e) || w(v, e) || (v[e] = [e, t, n]);
                    }).amd = { jQuery: !0 }),
                    (e.requirejs = t),
                    (e.require = n),
                    (e.define = r)),
                e.define("almond", function () {}),
                e.define("jquery", [], function () {
                    var e = u || $;
                    return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e;
                }),
                e.define("select2/utils", ["jquery"], function (o) {
                    var i = {};
                    function u(e) {
                        var t = e.prototype,
                            n = [];
                        for (var r in t) {
                            "function" == typeof t[r] && "constructor" !== r && n.push(r);
                        }
                        return n;
                    }
                    (i.Extend = function (e, t) {
                        var n = {}.hasOwnProperty;
                        function r() {
                            this.constructor = e;
                        }
                        for (var i in t) n.call(t, i) && (e[i] = t[i]);
                        return (r.prototype = t.prototype), (e.prototype = new r()), (e.__super__ = t.prototype), e;
                    }),
                        (i.Decorate = function (r, i) {
                            var e = u(i),
                                t = u(r);
                            function o() {
                                var e = Array.prototype.unshift,
                                    t = i.prototype.constructor.length,
                                    n = r.prototype.constructor;
                                0 < t && (e.call(arguments, r.prototype.constructor), (n = i.prototype.constructor)), n.apply(this, arguments);
                            }
                            (i.displayName = r.displayName),
                                (o.prototype = new (function () {
                                    this.constructor = o;
                                })());
                            for (var n = 0; n < t.length; n++) {
                                var s = t[n];
                                o.prototype[s] = r.prototype[s];
                            }
                            function a(e) {
                                var t = function () {};
                                e in o.prototype && (t = o.prototype[e]);
                                var n = i.prototype[e];
                                return function () {
                                    return Array.prototype.unshift.call(arguments, t), n.apply(this, arguments);
                                };
                            }
                            for (var l = 0; l < e.length; l++) {
                                var c = e[l];
                                o.prototype[c] = a(c);
                            }
                            return o;
                        });
                    function e() {
                        this.listeners = {};
                    }
                    (e.prototype.on = function (e, t) {
                        (this.listeners = this.listeners || {}), e in this.listeners ? this.listeners[e].push(t) : (this.listeners[e] = [t]);
                    }),
                        (e.prototype.trigger = function (e) {
                            var t = Array.prototype.slice,
                                n = t.call(arguments, 1);
                            (this.listeners = this.listeners || {}),
                                null == n && (n = []),
                                0 === n.length && n.push({}),
                                (n[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)),
                                "*" in this.listeners && this.invoke(this.listeners["*"], arguments);
                        }),
                        (e.prototype.invoke = function (e, t) {
                            for (var n = 0, r = e.length; n < r; n++) e[n].apply(this, t);
                        }),
                        (i.Observable = e),
                        (i.generateChars = function (e) {
                            for (var t = "", n = 0; n < e; n++) {
                                t += Math.floor(36 * Math.random()).toString(36);
                            }
                            return t;
                        }),
                        (i.bind = function (e, t) {
                            return function () {
                                e.apply(t, arguments);
                            };
                        }),
                        (i._convertData = function (e) {
                            for (var t in e) {
                                var n = t.split("-"),
                                    r = e;
                                if (1 !== n.length) {
                                    for (var i = 0; i < n.length; i++) {
                                        var o = n[i];
                                        (o = o.substring(0, 1).toLowerCase() + o.substring(1)) in r || (r[o] = {}), i == n.length - 1 && (r[o] = e[t]), (r = r[o]);
                                    }
                                    delete e[t];
                                }
                            }
                            return e;
                        }),
                        (i.hasScroll = function (e, t) {
                            var n = o(t),
                                r = t.style.overflowX,
                                i = t.style.overflowY;
                            return (r !== i || ("hidden" !== i && "visible" !== i)) && ("scroll" === r || "scroll" === i || n.innerHeight() < t.scrollHeight || n.innerWidth() < t.scrollWidth);
                        }),
                        (i.escapeMarkup = function (e) {
                            var t = { "\\": "&#92;", "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#47;" };
                            return "string" != typeof e
                                ? e
                                : String(e).replace(/[&<>"'\/\\]/g, function (e) {
                                      return t[e];
                                  });
                        }),
                        (i.appendMany = function (e, t) {
                            if ("1.7" === o.fn.jquery.substr(0, 3)) {
                                var n = o();
                                o.map(t, function (e) {
                                    n = n.add(e);
                                }),
                                    (t = n);
                            }
                            e.append(t);
                        }),
                        (i.__cache = {});
                    var n = 0;
                    return (
                        (i.GetUniqueElementId = function (e) {
                            var t = e.getAttribute("data-select2-id");
                            return null == t && (e.id ? ((t = e.id), e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++n), (t = n.toString()))), t;
                        }),
                        (i.StoreData = function (e, t, n) {
                            var r = i.GetUniqueElementId(e);
                            i.__cache[r] || (i.__cache[r] = {}), (i.__cache[r][t] = n);
                        }),
                        (i.GetData = function (e, t) {
                            var n = i.GetUniqueElementId(e);
                            return t ? (i.__cache[n] && null != i.__cache[n][t] ? i.__cache[n][t] : o(e).data(t)) : i.__cache[n];
                        }),
                        (i.RemoveData = function (e) {
                            var t = i.GetUniqueElementId(e);
                            null != i.__cache[t] && delete i.__cache[t], e.removeAttribute("data-select2-id");
                        }),
                        i
                    );
                }),
                e.define("select2/results", ["jquery", "./utils"], function (h, f) {
                    function r(e, t, n) {
                        (this.$element = e), (this.data = n), (this.options = t), r.__super__.constructor.call(this);
                    }
                    return (
                        f.Extend(r, f.Observable),
                        (r.prototype.render = function () {
                            var e = h('<ul class="select2-results__options" role="listbox"></ul>');
                            return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), (this.$results = e);
                        }),
                        (r.prototype.clear = function () {
                            this.$results.empty();
                        }),
                        (r.prototype.displayMessage = function (e) {
                            var t = this.options.get("escapeMarkup");
                            this.clear(), this.hideLoading();
                            var n = h('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
                                r = this.options.get("translations").get(e.message);
                            n.append(t(r(e.args))), (n[0].className += " select2-results__message"), this.$results.append(n);
                        }),
                        (r.prototype.hideMessages = function () {
                            this.$results.find(".select2-results__message").remove();
                        }),
                        (r.prototype.append = function (e) {
                            this.hideLoading();
                            var t = [];
                            if (null != e.results && 0 !== e.results.length) {
                                e.results = this.sort(e.results);
                                for (var n = 0; n < e.results.length; n++) {
                                    var r = e.results[n],
                                        i = this.option(r);
                                    t.push(i);
                                }
                                this.$results.append(t);
                            } else 0 === this.$results.children().length && this.trigger("results:message", { message: "noResults" });
                        }),
                        (r.prototype.position = function (e, t) {
                            t.find(".select2-results").append(e);
                        }),
                        (r.prototype.sort = function (e) {
                            return this.options.get("sorter")(e);
                        }),
                        (r.prototype.highlightFirstItem = function () {
                            var e = this.$results.find(".select2-results__option[aria-selected]"),
                                t = e.filter("[aria-selected=true]");
                            0 < t.length ? t.first().trigger("mouseenter") : e.first().trigger("mouseenter"), this.ensureHighlightVisible();
                        }),
                        (r.prototype.setClasses = function () {
                            var t = this;
                            this.data.current(function (e) {
                                var r = h.map(e, function (e) {
                                    return e.id.toString();
                                });
                                t.$results.find(".select2-results__option[aria-selected]").each(function () {
                                    var e = h(this),
                                        t = f.GetData(this, "data"),
                                        n = "" + t.id;
                                    (null != t.element && t.element.selected) || (null == t.element && -1 < h.inArray(n, r)) ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false");
                                });
                            });
                        }),
                        (r.prototype.showLoading = function (e) {
                            this.hideLoading();
                            var t = { disabled: !0, loading: !0, text: this.options.get("translations").get("searching")(e) },
                                n = this.option(t);
                            (n.className += " loading-results"), this.$results.prepend(n);
                        }),
                        (r.prototype.hideLoading = function () {
                            this.$results.find(".loading-results").remove();
                        }),
                        (r.prototype.option = function (e) {
                            var t = document.createElement("li");
                            t.className = "select2-results__option";
                            var n = { role: "option", "aria-selected": "false" },
                                r = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                            for (var i in (((null != e.element && r.call(e.element, ":disabled")) || (null == e.element && e.disabled)) && (delete n["aria-selected"], (n["aria-disabled"] = "true")),
                            null == e.id && delete n["aria-selected"],
                            null != e._resultId && (t.id = e._resultId),
                            e.title && (t.title = e.title),
                            e.children && ((n.role = "group"), (n["aria-label"] = e.text), delete n["aria-selected"]),
                            n)) {
                                var o = n[i];
                                t.setAttribute(i, o);
                            }
                            if (e.children) {
                                var s = h(t),
                                    a = document.createElement("strong");
                                a.className = "select2-results__group";
                                h(a);
                                this.template(e, a);
                                for (var l = [], c = 0; c < e.children.length; c++) {
                                    var u = e.children[c],
                                        d = this.option(u);
                                    l.push(d);
                                }
                                var p = h("<ul></ul>", { class: "select2-results__options select2-results__options--nested" });
                                p.append(l), s.append(a), s.append(p);
                            } else this.template(e, t);
                            return f.StoreData(t, "data", e), t;
                        }),
                        (r.prototype.bind = function (t, e) {
                            var l = this,
                                n = t.id + "-results";
                            this.$results.attr("id", n),
                                t.on("results:all", function (e) {
                                    l.clear(), l.append(e.data), t.isOpen() && (l.setClasses(), l.highlightFirstItem());
                                }),
                                t.on("results:append", function (e) {
                                    l.append(e.data), t.isOpen() && l.setClasses();
                                }),
                                t.on("query", function (e) {
                                    l.hideMessages(), l.showLoading(e);
                                }),
                                t.on("select", function () {
                                    t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem());
                                }),
                                t.on("unselect", function () {
                                    t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem());
                                }),
                                t.on("open", function () {
                                    l.$results.attr("aria-expanded", "true"), l.$results.attr("aria-hidden", "false"), l.setClasses(), l.ensureHighlightVisible();
                                }),
                                t.on("close", function () {
                                    l.$results.attr("aria-expanded", "false"), l.$results.attr("aria-hidden", "true"), l.$results.removeAttr("aria-activedescendant");
                                }),
                                t.on("results:toggle", function () {
                                    var e = l.getHighlightedResults();
                                    0 !== e.length && e.trigger("mouseup");
                                }),
                                t.on("results:select", function () {
                                    var e = l.getHighlightedResults();
                                    if (0 !== e.length) {
                                        var t = f.GetData(e[0], "data");
                                        "true" == e.attr("aria-selected") ? l.trigger("close", {}) : l.trigger("select", { data: t });
                                    }
                                }),
                                t.on("results:previous", function () {
                                    var e = l.getHighlightedResults(),
                                        t = l.$results.find("[aria-selected]"),
                                        n = t.index(e);
                                    if (!(n <= 0)) {
                                        var r = n - 1;
                                        0 === e.length && (r = 0);
                                        var i = t.eq(r);
                                        i.trigger("mouseenter");
                                        var o = l.$results.offset().top,
                                            s = i.offset().top,
                                            a = l.$results.scrollTop() + (s - o);
                                        0 === r ? l.$results.scrollTop(0) : s - o < 0 && l.$results.scrollTop(a);
                                    }
                                }),
                                t.on("results:next", function () {
                                    var e = l.getHighlightedResults(),
                                        t = l.$results.find("[aria-selected]"),
                                        n = t.index(e) + 1;
                                    if (!(n >= t.length)) {
                                        var r = t.eq(n);
                                        r.trigger("mouseenter");
                                        var i = l.$results.offset().top + l.$results.outerHeight(!1),
                                            o = r.offset().top + r.outerHeight(!1),
                                            s = l.$results.scrollTop() + o - i;
                                        0 === n ? l.$results.scrollTop(0) : i < o && l.$results.scrollTop(s);
                                    }
                                }),
                                t.on("results:focus", function (e) {
                                    e.element.addClass("select2-results__option--highlighted");
                                }),
                                t.on("results:message", function (e) {
                                    l.displayMessage(e);
                                }),
                                h.fn.mousewheel &&
                                    this.$results.on("mousewheel", function (e) {
                                        var t = l.$results.scrollTop(),
                                            n = l.$results.get(0).scrollHeight - t + e.deltaY,
                                            r = 0 < e.deltaY && t - e.deltaY <= 0,
                                            i = e.deltaY < 0 && n <= l.$results.height();
                                        r ? (l.$results.scrollTop(0), e.preventDefault(), e.stopPropagation()) : i && (l.$results.scrollTop(l.$results.get(0).scrollHeight - l.$results.height()), e.preventDefault(), e.stopPropagation());
                                    }),
                                this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (e) {
                                    var t = h(this),
                                        n = f.GetData(this, "data");
                                    "true" !== t.attr("aria-selected") ? l.trigger("select", { originalEvent: e, data: n }) : l.options.get("multiple") ? l.trigger("unselect", { originalEvent: e, data: n }) : l.trigger("close", {});
                                }),
                                this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (e) {
                                    var t = f.GetData(this, "data");
                                    l.getHighlightedResults().removeClass("select2-results__option--highlighted"), l.trigger("results:focus", { data: t, element: h(this) });
                                });
                        }),
                        (r.prototype.getHighlightedResults = function () {
                            return this.$results.find(".select2-results__option--highlighted");
                        }),
                        (r.prototype.destroy = function () {
                            this.$results.remove();
                        }),
                        (r.prototype.ensureHighlightVisible = function () {
                            var e = this.getHighlightedResults();
                            if (0 !== e.length) {
                                var t = this.$results.find("[aria-selected]").index(e),
                                    n = this.$results.offset().top,
                                    r = e.offset().top,
                                    i = this.$results.scrollTop() + (r - n),
                                    o = r - n;
                                (i -= 2 * e.outerHeight(!1)), t <= 2 ? this.$results.scrollTop(0) : (o > this.$results.outerHeight() || o < 0) && this.$results.scrollTop(i);
                            }
                        }),
                        (r.prototype.template = function (e, t) {
                            var n = this.options.get("templateResult"),
                                r = this.options.get("escapeMarkup"),
                                i = n(e, t);
                            null == i ? (t.style.display = "none") : "string" == typeof i ? (t.innerHTML = r(i)) : h(t).append(i);
                        }),
                        r
                    );
                }),
                e.define("select2/keys", [], function () {
                    return { BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, ESC: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, DELETE: 46 };
                }),
                e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (n, r, i) {
                    function o(e, t) {
                        (this.$element = e), (this.options = t), o.__super__.constructor.call(this);
                    }
                    return (
                        r.Extend(o, r.Observable),
                        (o.prototype.render = function () {
                            var e = n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                            return (
                                (this._tabindex = 0),
                                null != r.GetData(this.$element[0], "old-tabindex")
                                    ? (this._tabindex = r.GetData(this.$element[0], "old-tabindex"))
                                    : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")),
                                e.attr("title", this.$element.attr("title")),
                                e.attr("tabindex", this._tabindex),
                                e.attr("aria-disabled", "false"),
                                (this.$selection = e)
                            );
                        }),
                        (o.prototype.bind = function (e, t) {
                            var n = this,
                                r = e.id + "-results";
                            (this.container = e),
                                this.$selection.on("focus", function (e) {
                                    n.trigger("focus", e);
                                }),
                                this.$selection.on("blur", function (e) {
                                    n._handleBlur(e);
                                }),
                                this.$selection.on("keydown", function (e) {
                                    n.trigger("keypress", e), e.which === i.SPACE && e.preventDefault();
                                }),
                                e.on("results:focus", function (e) {
                                    n.$selection.attr("aria-activedescendant", e.data._resultId);
                                }),
                                e.on("selection:update", function (e) {
                                    n.update(e.data);
                                }),
                                e.on("open", function () {
                                    n.$selection.attr("aria-expanded", "true"), n.$selection.attr("aria-owns", r), n._attachCloseHandler(e);
                                }),
                                e.on("close", function () {
                                    n.$selection.attr("aria-expanded", "false"), n.$selection.removeAttr("aria-activedescendant"), n.$selection.removeAttr("aria-owns"), n.$selection.trigger("focus"), n._detachCloseHandler(e);
                                }),
                                e.on("enable", function () {
                                    n.$selection.attr("tabindex", n._tabindex), n.$selection.attr("aria-disabled", "false");
                                }),
                                e.on("disable", function () {
                                    n.$selection.attr("tabindex", "-1"), n.$selection.attr("aria-disabled", "true");
                                });
                        }),
                        (o.prototype._handleBlur = function (e) {
                            var t = this;
                            window.setTimeout(function () {
                                document.activeElement == t.$selection[0] || n.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e);
                            }, 1);
                        }),
                        (o.prototype._attachCloseHandler = function (e) {
                            n(document.body).on("mousedown.select2." + e.id, function (e) {
                                var t = n(e.target).closest(".select2");
                                n(".select2.select2-container--open").each(function () {
                                    this != t[0] && r.GetData(this, "element").select2("close");
                                });
                            });
                        }),
                        (o.prototype._detachCloseHandler = function (e) {
                            n(document.body).off("mousedown.select2." + e.id);
                        }),
                        (o.prototype.position = function (e, t) {
                            t.find(".selection").append(e);
                        }),
                        (o.prototype.destroy = function () {
                            this._detachCloseHandler(this.container);
                        }),
                        (o.prototype.update = function (e) {
                            throw new Error("The `update` method must be defined in child classes.");
                        }),
                        (o.prototype.isEnabled = function () {
                            return !this.isDisabled();
                        }),
                        (o.prototype.isDisabled = function () {
                            return this.options.get("disabled");
                        }),
                        o
                    );
                }),
                e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (e, t, n, r) {
                    function i() {
                        i.__super__.constructor.apply(this, arguments);
                    }
                    return (
                        n.Extend(i, t),
                        (i.prototype.render = function () {
                            var e = i.__super__.render.call(this);
                            return e.addClass("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e;
                        }),
                        (i.prototype.bind = function (t, e) {
                            var n = this;
                            i.__super__.bind.apply(this, arguments);
                            var r = t.id + "-container";
                            this.$selection.find(".select2-selection__rendered").attr("id", r).attr("role", "textbox").attr("aria-readonly", "true"),
                                this.$selection.attr("aria-labelledby", r),
                                this.$selection.on("mousedown", function (e) {
                                    1 === e.which && n.trigger("toggle", { originalEvent: e });
                                }),
                                this.$selection.on("focus", function (e) {}),
                                this.$selection.on("blur", function (e) {}),
                                t.on("focus", function (e) {
                                    t.isOpen() || n.$selection.trigger("focus");
                                });
                        }),
                        (i.prototype.clear = function () {
                            var e = this.$selection.find(".select2-selection__rendered");
                            e.empty(), e.removeAttr("title");
                        }),
                        (i.prototype.display = function (e, t) {
                            var n = this.options.get("templateSelection");
                            return this.options.get("escapeMarkup")(n(e, t));
                        }),
                        (i.prototype.selectionContainer = function () {
                            return e("<span></span>");
                        }),
                        (i.prototype.update = function (e) {
                            if (0 !== e.length) {
                                var t = e[0],
                                    n = this.$selection.find(".select2-selection__rendered"),
                                    r = this.display(t, n);
                                n.empty().append(r);
                                var i = t.title || t.text;
                                i ? n.attr("title", i) : n.removeAttr("title");
                            } else this.clear();
                        }),
                        i
                    );
                }),
                e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (i, e, l) {
                    function n(e, t) {
                        n.__super__.constructor.apply(this, arguments);
                    }
                    return (
                        l.Extend(n, e),
                        (n.prototype.render = function () {
                            var e = n.__super__.render.call(this);
                            return e.addClass("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e;
                        }),
                        (n.prototype.bind = function (e, t) {
                            var r = this;
                            n.__super__.bind.apply(this, arguments),
                                this.$selection.on("click", function (e) {
                                    r.trigger("toggle", { originalEvent: e });
                                }),
                                this.$selection.on("click", ".select2-selection__choice__remove", function (e) {
                                    if (!r.isDisabled()) {
                                        var t = i(this).parent(),
                                            n = l.GetData(t[0], "data");
                                        r.trigger("unselect", { originalEvent: e, data: n });
                                    }
                                });
                        }),
                        (n.prototype.clear = function () {
                            var e = this.$selection.find(".select2-selection__rendered");
                            e.empty(), e.removeAttr("title");
                        }),
                        (n.prototype.display = function (e, t) {
                            var n = this.options.get("templateSelection");
                            return this.options.get("escapeMarkup")(n(e, t));
                        }),
                        (n.prototype.selectionContainer = function () {
                            return i('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
                        }),
                        (n.prototype.update = function (e) {
                            if ((this.clear(), 0 !== e.length)) {
                                for (var t = [], n = 0; n < e.length; n++) {
                                    var r = e[n],
                                        i = this.selectionContainer(),
                                        o = this.display(r, i);
                                    i.append(o);
                                    var s = r.title || r.text;
                                    s && i.attr("title", s), l.StoreData(i[0], "data", r), t.push(i);
                                }
                                var a = this.$selection.find(".select2-selection__rendered");
                                l.appendMany(a, t);
                            }
                        }),
                        n
                    );
                }),
                e.define("select2/selection/placeholder", ["../utils"], function (e) {
                    function t(e, t, n) {
                        (this.placeholder = this.normalizePlaceholder(n.get("placeholder"))), e.call(this, t, n);
                    }
                    return (
                        (t.prototype.normalizePlaceholder = function (e, t) {
                            return "string" == typeof t && (t = { id: "", text: t }), t;
                        }),
                        (t.prototype.createPlaceholder = function (e, t) {
                            var n = this.selectionContainer();
                            return n.html(this.display(t)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n;
                        }),
                        (t.prototype.update = function (e, t) {
                            var n = 1 == t.length && t[0].id != this.placeholder.id;
                            if (1 < t.length || n) return e.call(this, t);
                            this.clear();
                            var r = this.createPlaceholder(this.placeholder);
                            this.$selection.find(".select2-selection__rendered").append(r);
                        }),
                        t
                    );
                }),
                e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function (i, r, a) {
                    function e() {}
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            var r = this;
                            e.call(this, t, n),
                                null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),
                                this.$selection.on("mousedown", ".select2-selection__clear", function (e) {
                                    r._handleClear(e);
                                }),
                                t.on("keypress", function (e) {
                                    r._handleKeyboardClear(e, t);
                                });
                        }),
                        (e.prototype._handleClear = function (e, t) {
                            if (!this.isDisabled()) {
                                var n = this.$selection.find(".select2-selection__clear");
                                if (0 !== n.length) {
                                    t.stopPropagation();
                                    var r = a.GetData(n[0], "data"),
                                        i = this.$element.val();
                                    this.$element.val(this.placeholder.id);
                                    var o = { data: r };
                                    if ((this.trigger("clear", o), o.prevented)) this.$element.val(i);
                                    else {
                                        for (var s = 0; s < r.length; s++) if (((o = { data: r[s] }), this.trigger("unselect", o), o.prevented)) return void this.$element.val(i);
                                        this.$element.trigger("input").trigger("change"), this.trigger("toggle", {});
                                    }
                                }
                            }
                        }),
                        (e.prototype._handleKeyboardClear = function (e, t, n) {
                            n.isOpen() || (t.which != r.DELETE && t.which != r.BACKSPACE) || this._handleClear(t);
                        }),
                        (e.prototype.update = function (e, t) {
                            if ((e.call(this, t), !(0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length))) {
                                var n = this.options.get("translations").get("removeAllItems"),
                                    r = i('<span class="select2-selection__clear" title="' + n() + '">&times;</span>');
                                a.StoreData(r[0], "data", t), this.$selection.find(".select2-selection__rendered").prepend(r);
                            }
                        }),
                        e
                    );
                }),
                e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (r, a, l) {
                    function e(e, t, n) {
                        e.call(this, t, n);
                    }
                    return (
                        (e.prototype.render = function (e) {
                            var t = r(
                                '<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>'
                            );
                            (this.$searchContainer = t), (this.$search = t.find("input"));
                            var n = e.call(this);
                            return this._transferTabIndex(), n;
                        }),
                        (e.prototype.bind = function (e, t, n) {
                            var r = this,
                                i = t.id + "-results";
                            e.call(this, t, n),
                                t.on("open", function () {
                                    r.$search.attr("aria-controls", i), r.$search.trigger("focus");
                                }),
                                t.on("close", function () {
                                    r.$search.val(""), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.trigger("focus");
                                }),
                                t.on("enable", function () {
                                    r.$search.prop("disabled", !1), r._transferTabIndex();
                                }),
                                t.on("disable", function () {
                                    r.$search.prop("disabled", !0);
                                }),
                                t.on("focus", function (e) {
                                    r.$search.trigger("focus");
                                }),
                                t.on("results:focus", function (e) {
                                    e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant");
                                }),
                                this.$selection.on("focusin", ".select2-search--inline", function (e) {
                                    r.trigger("focus", e);
                                }),
                                this.$selection.on("focusout", ".select2-search--inline", function (e) {
                                    r._handleBlur(e);
                                }),
                                this.$selection.on("keydown", ".select2-search--inline", function (e) {
                                    if ((e.stopPropagation(), r.trigger("keypress", e), (r._keyUpPrevented = e.isDefaultPrevented()), e.which === l.BACKSPACE && "" === r.$search.val())) {
                                        var t = r.$searchContainer.prev(".select2-selection__choice");
                                        if (0 < t.length) {
                                            var n = a.GetData(t[0], "data");
                                            r.searchRemoveChoice(n), e.preventDefault();
                                        }
                                    }
                                }),
                                this.$selection.on("click", ".select2-search--inline", function (e) {
                                    r.$search.val() && e.stopPropagation();
                                });
                            var o = document.documentMode,
                                s = o && o <= 11;
                            this.$selection.on("input.searchcheck", ".select2-search--inline", function (e) {
                                s ? r.$selection.off("input.search input.searchcheck") : r.$selection.off("keyup.search");
                            }),
                                this.$selection.on("keyup.search input.search", ".select2-search--inline", function (e) {
                                    if (s && "input" === e.type) r.$selection.off("input.search input.searchcheck");
                                    else {
                                        var t = e.which;
                                        t != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && r.handleSearch(e);
                                    }
                                });
                        }),
                        (e.prototype._transferTabIndex = function (e) {
                            this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1");
                        }),
                        (e.prototype.createPlaceholder = function (e, t) {
                            this.$search.attr("placeholder", t.text);
                        }),
                        (e.prototype.update = function (e, t) {
                            var n = this.$search[0] == document.activeElement;
                            this.$search.attr("placeholder", ""), e.call(this, t), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.trigger("focus");
                        }),
                        (e.prototype.handleSearch = function () {
                            if ((this.resizeSearch(), !this._keyUpPrevented)) {
                                var e = this.$search.val();
                                this.trigger("query", { term: e });
                            }
                            this._keyUpPrevented = !1;
                        }),
                        (e.prototype.searchRemoveChoice = function (e, t) {
                            this.trigger("unselect", { data: t }), this.$search.val(t.text), this.handleSearch();
                        }),
                        (e.prototype.resizeSearch = function () {
                            this.$search.css("width", "25px");
                            var e = "";
                            "" !== this.$search.attr("placeholder") ? (e = this.$selection.find(".select2-selection__rendered").width()) : (e = 0.75 * (this.$search.val().length + 1) + "em");
                            this.$search.css("width", e);
                        }),
                        e
                    );
                }),
                e.define("select2/selection/eventRelay", ["jquery"], function (s) {
                    function e() {}
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            var r = this,
                                i = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
                                o = ["opening", "closing", "selecting", "unselecting", "clearing"];
                            e.call(this, t, n),
                                t.on("*", function (e, t) {
                                    if (-1 !== s.inArray(e, i)) {
                                        t = t || {};
                                        var n = s.Event("select2:" + e, { params: t });
                                        r.$element.trigger(n), -1 !== s.inArray(e, o) && (t.prevented = n.isDefaultPrevented());
                                    }
                                });
                        }),
                        e
                    );
                }),
                e.define("select2/translation", ["jquery", "require"], function (t, n) {
                    function r(e) {
                        this.dict = e || {};
                    }
                    return (
                        (r.prototype.all = function () {
                            return this.dict;
                        }),
                        (r.prototype.get = function (e) {
                            return this.dict[e];
                        }),
                        (r.prototype.extend = function (e) {
                            this.dict = t.extend({}, e.all(), this.dict);
                        }),
                        (r._cache = {}),
                        (r.loadPath = function (e) {
                            if (!(e in r._cache)) {
                                var t = n(e);
                                r._cache[e] = t;
                            }
                            return new r(r._cache[e]);
                        }),
                        r
                    );
                }),
                e.define("select2/diacritics", [], function () {
                    return '';
                }),
                e.define("select2/data/base", ["../utils"], function (r) {
                    function n(e, t) {
                        n.__super__.constructor.call(this);
                    }
                    return (
                        r.Extend(n, r.Observable),
                        (n.prototype.current = function (e) {
                            throw new Error("The `current` method must be defined in child classes.");
                        }),
                        (n.prototype.query = function (e, t) {
                            throw new Error("The `query` method must be defined in child classes.");
                        }),
                        (n.prototype.bind = function (e, t) {}),
                        (n.prototype.destroy = function () {}),
                        (n.prototype.generateResultId = function (e, t) {
                            var n = e.id + "-result-";
                            return (n += r.generateChars(4)), null != t.id ? (n += "-" + t.id.toString()) : (n += "-" + r.generateChars(4)), n;
                        }),
                        n
                    );
                }),
                e.define("select2/data/select", ["./base", "../utils", "jquery"], function (e, a, l) {
                    function n(e, t) {
                        (this.$element = e), (this.options = t), n.__super__.constructor.call(this);
                    }
                    return (
                        a.Extend(n, e),
                        (n.prototype.current = function (e) {
                            var n = [],
                                r = this;
                            this.$element.find(":selected").each(function () {
                                var e = l(this),
                                    t = r.item(e);
                                n.push(t);
                            }),
                                e(n);
                        }),
                        (n.prototype.select = function (i) {
                            var o = this;
                            if (((i.selected = !0), l(i.element).is("option"))) return (i.element.selected = !0), void this.$element.trigger("input").trigger("change");
                            if (this.$element.prop("multiple"))
                                this.current(function (e) {
                                    var t = [];
                                    (i = [i]).push.apply(i, e);
                                    for (var n = 0; n < i.length; n++) {
                                        var r = i[n].id;
                                        -1 === l.inArray(r, t) && t.push(r);
                                    }
                                    o.$element.val(t), o.$element.trigger("input").trigger("change");
                                });
                            else {
                                var e = i.id;
                                this.$element.val(e), this.$element.trigger("input").trigger("change");
                            }
                        }),
                        (n.prototype.unselect = function (i) {
                            var o = this;
                            if (this.$element.prop("multiple")) {
                                if (((i.selected = !1), l(i.element).is("option"))) return (i.element.selected = !1), void this.$element.trigger("input").trigger("change");
                                this.current(function (e) {
                                    for (var t = [], n = 0; n < e.length; n++) {
                                        var r = e[n].id;
                                        r !== i.id && -1 === l.inArray(r, t) && t.push(r);
                                    }
                                    o.$element.val(t), o.$element.trigger("input").trigger("change");
                                });
                            }
                        }),
                        (n.prototype.bind = function (e, t) {
                            var n = this;
                            (this.container = e).on("select", function (e) {
                                n.select(e.data);
                            }),
                                e.on("unselect", function (e) {
                                    n.unselect(e.data);
                                });
                        }),
                        (n.prototype.destroy = function () {
                            this.$element.find("*").each(function () {
                                a.RemoveData(this);
                            });
                        }),
                        (n.prototype.query = function (r, e) {
                            var i = [],
                                o = this;
                            this.$element.children().each(function () {
                                var e = l(this);
                                if (e.is("option") || e.is("optgroup")) {
                                    var t = o.item(e),
                                        n = o.matches(r, t);
                                    null !== n && i.push(n);
                                }
                            }),
                                e({ results: i });
                        }),
                        (n.prototype.addOptions = function (e) {
                            a.appendMany(this.$element, e);
                        }),
                        (n.prototype.option = function (e) {
                            var t;
                            e.children ? ((t = document.createElement("optgroup")).label = e.text) : void 0 !== (t = document.createElement("option")).textContent ? (t.textContent = e.text) : (t.innerText = e.text),
                                void 0 !== e.id && (t.value = e.id),
                                e.disabled && (t.disabled = !0),
                                e.selected && (t.selected = !0),
                                e.title && (t.title = e.title);
                            var n = l(t),
                                r = this._normalizeItem(e);
                            return (r.element = t), a.StoreData(t, "data", r), n;
                        }),
                        (n.prototype.item = function (e) {
                            var t = {};
                            if (null != (t = a.GetData(e[0], "data"))) return t;
                            if (e.is("option")) t = { id: e.val(), text: e.text(), disabled: e.prop("disabled"), selected: e.prop("selected"), title: e.prop("title") };
                            else if (e.is("optgroup")) {
                                t = { text: e.prop("label"), children: [], title: e.prop("title") };
                                for (var n = e.children("option"), r = [], i = 0; i < n.length; i++) {
                                    var o = l(n[i]),
                                        s = this.item(o);
                                    r.push(s);
                                }
                                t.children = r;
                            }
                            return ((t = this._normalizeItem(t)).element = e[0]), a.StoreData(e[0], "data", t), t;
                        }),
                        (n.prototype._normalizeItem = function (e) {
                            e !== Object(e) && (e = { id: e, text: e });
                            return (
                                null != (e = l.extend({}, { text: "" }, e)).id && (e.id = e.id.toString()),
                                null != e.text && (e.text = e.text.toString()),
                                null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)),
                                l.extend({}, { selected: !1, disabled: !1 }, e)
                            );
                        }),
                        (n.prototype.matches = function (e, t) {
                            return this.options.get("matcher")(e, t);
                        }),
                        n
                    );
                }),
                e.define("select2/data/array", ["./select", "../utils", "jquery"], function (e, f, g) {
                    function r(e, t) {
                        (this._dataToConvert = t.get("data") || []), r.__super__.constructor.call(this, e, t);
                    }
                    return (
                        f.Extend(r, e),
                        (r.prototype.bind = function (e, t) {
                            r.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert));
                        }),
                        (r.prototype.select = function (n) {
                            var e = this.$element.find("option").filter(function (e, t) {
                                return t.value == n.id.toString();
                            });
                            0 === e.length && ((e = this.option(n)), this.addOptions(e)), r.__super__.select.call(this, n);
                        }),
                        (r.prototype.convertToOptions = function (e) {
                            var t = this,
                                n = this.$element.find("option"),
                                r = n
                                    .map(function () {
                                        return t.item(g(this)).id;
                                    })
                                    .get(),
                                i = [];
                            function o(e) {
                                return function () {
                                    return g(this).val() == e.id;
                                };
                            }
                            for (var s = 0; s < e.length; s++) {
                                var a = this._normalizeItem(e[s]);
                                if (0 <= g.inArray(a.id, r)) {
                                    var l = n.filter(o(a)),
                                        c = this.item(l),
                                        u = g.extend(!0, {}, a, c),
                                        d = this.option(u);
                                    l.replaceWith(d);
                                } else {
                                    var p = this.option(a);
                                    if (a.children) {
                                        var h = this.convertToOptions(a.children);
                                        f.appendMany(p, h);
                                    }
                                    i.push(p);
                                }
                            }
                            return i;
                        }),
                        r
                    );
                }),
                e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (e, t, o) {
                    function n(e, t) {
                        (this.ajaxOptions = this._applyDefaults(t.get("ajax"))), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), n.__super__.constructor.call(this, e, t);
                    }
                    return (
                        t.Extend(n, e),
                        (n.prototype._applyDefaults = function (e) {
                            var t = {
                                data: function (e) {
                                    return o.extend({}, e, { q: e.term });
                                },
                                transport: function (e, t, n) {
                                    var r = o.ajax(e);
                                    return r.then(t), r.fail(n), r;
                                },
                            };
                            return o.extend({}, t, e, !0);
                        }),
                        (n.prototype.processResults = function (e) {
                            return e;
                        }),
                        (n.prototype.query = function (n, r) {
                            var i = this;
                            null != this._request && (o.isFunction(this._request.abort) && this._request.abort(), (this._request = null));
                            var t = o.extend({ type: "GET" }, this.ajaxOptions);
                            function e() {
                                var e = t.transport(
                                    t,
                                    function (e) {
                                        var t = i.processResults(e, n);
                                        i.options.get("debug") &&
                                            window.console &&
                                            console.error &&
                                            ((t && t.results && o.isArray(t.results)) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),
                                            r(t);
                                    },
                                    function () {
                                        ("status" in e && (0 === e.status || "0" === e.status)) || i.trigger("results:message", { message: "errorLoading" });
                                    }
                                );
                                i._request = e;
                            }
                            "function" == typeof t.url && (t.url = t.url.call(this.$element, n)),
                                "function" == typeof t.data && (t.data = t.data.call(this.$element, n)),
                                this.ajaxOptions.delay && null != n.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), (this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay))) : e();
                        }),
                        n
                    );
                }),
                e.define("select2/data/tags", ["jquery"], function (u) {
                    function e(e, t, n) {
                        var r = n.get("tags"),
                            i = n.get("createTag");
                        void 0 !== i && (this.createTag = i);
                        var o = n.get("insertTag");
                        if ((void 0 !== o && (this.insertTag = o), e.call(this, t, n), u.isArray(r)))
                            for (var s = 0; s < r.length; s++) {
                                var a = r[s],
                                    l = this._normalizeItem(a),
                                    c = this.option(l);
                                this.$element.append(c);
                            }
                    }
                    return (
                        (e.prototype.query = function (e, c, u) {
                            var d = this;
                            this._removeOldTags(),
                                null != c.term && null == c.page
                                    ? e.call(this, c, function e(t, n) {
                                          for (var r = t.results, i = 0; i < r.length; i++) {
                                              var o = r[i],
                                                  s = null != o.children && !e({ results: o.children }, !0);
                                              if ((o.text || "").toUpperCase() === (c.term || "").toUpperCase() || s) return !n && ((t.data = r), void u(t));
                                          }
                                          if (n) return !0;
                                          var a = d.createTag(c);
                                          if (null != a) {
                                              var l = d.option(a);
                                              l.attr("data-select2-tag", !0), d.addOptions([l]), d.insertTag(r, a);
                                          }
                                          (t.results = r), u(t);
                                      })
                                    : e.call(this, c, u);
                        }),
                        (e.prototype.createTag = function (e, t) {
                            var n = u.trim(t.term);
                            return "" === n ? null : { id: n, text: n };
                        }),
                        (e.prototype.insertTag = function (e, t, n) {
                            t.unshift(n);
                        }),
                        (e.prototype._removeOldTags = function (e) {
                            this.$element.find("option[data-select2-tag]").each(function () {
                                this.selected || u(this).remove();
                            });
                        }),
                        e
                    );
                }),
                e.define("select2/data/tokenizer", ["jquery"], function (d) {
                    function e(e, t, n) {
                        var r = n.get("tokenizer");
                        void 0 !== r && (this.tokenizer = r), e.call(this, t, n);
                    }
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            e.call(this, t, n), (this.$search = t.dropdown.$search || t.selection.$search || n.find(".select2-search__field"));
                        }),
                        (e.prototype.query = function (e, t, n) {
                            var i = this;
                            t.term = t.term || "";
                            var r = this.tokenizer(t, this.options, function (e) {
                                var t,
                                    n = i._normalizeItem(e);
                                if (
                                    !i.$element.find("option").filter(function () {
                                        return d(this).val() === n.id;
                                    }).length
                                ) {
                                    var r = i.option(n);
                                    r.attr("data-select2-tag", !0), i._removeOldTags(), i.addOptions([r]);
                                }
                                (t = n), i.trigger("select", { data: t });
                            });
                            r.term !== t.term && (this.$search.length && (this.$search.val(r.term), this.$search.trigger("focus")), (t.term = r.term)), e.call(this, t, n);
                        }),
                        (e.prototype.tokenizer = function (e, t, n, r) {
                            for (
                                var i = n.get("tokenSeparators") || [],
                                    o = t.term,
                                    s = 0,
                                    a =
                                        this.createTag ||
                                        function (e) {
                                            return { id: e.term, text: e.term };
                                        };
                                s < o.length;

                            ) {
                                var l = o[s];
                                if (-1 !== d.inArray(l, i)) {
                                    var c = o.substr(0, s),
                                        u = a(d.extend({}, t, { term: c }));
                                    null != u ? (r(u), (o = o.substr(s + 1) || ""), (s = 0)) : s++;
                                } else s++;
                            }
                            return { term: o };
                        }),
                        e
                    );
                }),
                e.define("select2/data/minimumInputLength", [], function () {
                    function e(e, t, n) {
                        (this.minimumInputLength = n.get("minimumInputLength")), e.call(this, t, n);
                    }
                    return (
                        (e.prototype.query = function (e, t, n) {
                            (t.term = t.term || ""),
                                t.term.length < this.minimumInputLength ? this.trigger("results:message", { message: "inputTooShort", args: { minimum: this.minimumInputLength, input: t.term, params: t } }) : e.call(this, t, n);
                        }),
                        e
                    );
                }),
                e.define("select2/data/maximumInputLength", [], function () {
                    function e(e, t, n) {
                        (this.maximumInputLength = n.get("maximumInputLength")), e.call(this, t, n);
                    }
                    return (
                        (e.prototype.query = function (e, t, n) {
                            (t.term = t.term || ""),
                                0 < this.maximumInputLength && t.term.length > this.maximumInputLength
                                    ? this.trigger("results:message", { message: "inputTooLong", args: { maximum: this.maximumInputLength, input: t.term, params: t } })
                                    : e.call(this, t, n);
                        }),
                        e
                    );
                }),
                e.define("select2/data/maximumSelectionLength", [], function () {
                    function e(e, t, n) {
                        (this.maximumSelectionLength = n.get("maximumSelectionLength")), e.call(this, t, n);
                    }
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            var r = this;
                            e.call(this, t, n),
                                t.on("select", function () {
                                    r._checkIfMaximumSelected();
                                });
                        }),
                        (e.prototype.query = function (e, t, n) {
                            var r = this;
                            this._checkIfMaximumSelected(function () {
                                e.call(r, t, n);
                            });
                        }),
                        (e.prototype._checkIfMaximumSelected = function (e, n) {
                            var r = this;
                            this.current(function (e) {
                                var t = null != e ? e.length : 0;
                                0 < r.maximumSelectionLength && t >= r.maximumSelectionLength ? r.trigger("results:message", { message: "maximumSelected", args: { maximum: r.maximumSelectionLength } }) : n && n();
                            });
                        }),
                        e
                    );
                }),
                e.define("select2/dropdown", ["jquery", "./utils"], function (t, e) {
                    function n(e, t) {
                        (this.$element = e), (this.options = t), n.__super__.constructor.call(this);
                    }
                    return (
                        e.Extend(n, e.Observable),
                        (n.prototype.render = function () {
                            var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                            return e.attr("dir", this.options.get("dir")), (this.$dropdown = e);
                        }),
                        (n.prototype.bind = function () {}),
                        (n.prototype.position = function (e, t) {}),
                        (n.prototype.destroy = function () {
                            this.$dropdown.remove();
                        }),
                        n
                    );
                }),
                e.define("select2/dropdown/search", ["jquery", "../utils"], function (o, e) {
                    function t() {}
                    return (
                        (t.prototype.render = function (e) {
                            var t = e.call(this),
                                n = o(
                                    '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>'
                                );
                            return (this.$searchContainer = n), (this.$search = n.find("input")), t.prepend(n), t;
                        }),
                        (t.prototype.bind = function (e, t, n) {
                            var r = this,
                                i = t.id + "-results";
                            e.call(this, t, n),
                                this.$search.on("keydown", function (e) {
                                    r.trigger("keypress", e), (r._keyUpPrevented = e.isDefaultPrevented());
                                }),
                                this.$search.on("input", function (e) {
                                    o(this).off("keyup");
                                }),
                                this.$search.on("keyup input", function (e) {
                                    r.handleSearch(e);
                                }),
                                t.on("open", function () {
                                    r.$search.attr("tabindex", 0),
                                        r.$search.attr("aria-controls", i),
                                        r.$search.trigger("focus"),
                                        window.setTimeout(function () {
                                            r.$search.trigger("focus");
                                        }, 0);
                                }),
                                t.on("close", function () {
                                    r.$search.attr("tabindex", -1), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.val(""), r.$search.trigger("blur");
                                }),
                                t.on("focus", function () {
                                    t.isOpen() || r.$search.trigger("focus");
                                }),
                                t.on("results:all", function (e) {
                                    (null != e.query.term && "" !== e.query.term) || (r.showSearch(e) ? r.$searchContainer.removeClass("select2-search--hide") : r.$searchContainer.addClass("select2-search--hide"));
                                }),
                                t.on("results:focus", function (e) {
                                    e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant");
                                });
                        }),
                        (t.prototype.handleSearch = function (e) {
                            if (!this._keyUpPrevented) {
                                var t = this.$search.val();
                                this.trigger("query", { term: t });
                            }
                            this._keyUpPrevented = !1;
                        }),
                        (t.prototype.showSearch = function (e, t) {
                            return !0;
                        }),
                        t
                    );
                }),
                e.define("select2/dropdown/hidePlaceholder", [], function () {
                    function e(e, t, n, r) {
                        (this.placeholder = this.normalizePlaceholder(n.get("placeholder"))), e.call(this, t, n, r);
                    }
                    return (
                        (e.prototype.append = function (e, t) {
                            (t.results = this.removePlaceholder(t.results)), e.call(this, t);
                        }),
                        (e.prototype.normalizePlaceholder = function (e, t) {
                            return "string" == typeof t && (t = { id: "", text: t }), t;
                        }),
                        (e.prototype.removePlaceholder = function (e, t) {
                            for (var n = t.slice(0), r = t.length - 1; 0 <= r; r--) {
                                var i = t[r];
                                this.placeholder.id === i.id && n.splice(r, 1);
                            }
                            return n;
                        }),
                        e
                    );
                }),
                e.define("select2/dropdown/infiniteScroll", ["jquery"], function (n) {
                    function e(e, t, n, r) {
                        (this.lastParams = {}), e.call(this, t, n, r), (this.$loadingMore = this.createLoadingMore()), (this.loading = !1);
                    }
                    return (
                        (e.prototype.append = function (e, t) {
                            this.$loadingMore.remove(), (this.loading = !1), e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded());
                        }),
                        (e.prototype.bind = function (e, t, n) {
                            var r = this;
                            e.call(this, t, n),
                                t.on("query", function (e) {
                                    (r.lastParams = e), (r.loading = !0);
                                }),
                                t.on("query:append", function (e) {
                                    (r.lastParams = e), (r.loading = !0);
                                }),
                                this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
                        }),
                        (e.prototype.loadMoreIfNeeded = function () {
                            var e = n.contains(document.documentElement, this.$loadingMore[0]);
                            if (!this.loading && e) {
                                var t = this.$results.offset().top + this.$results.outerHeight(!1);
                                this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore();
                            }
                        }),
                        (e.prototype.loadMore = function () {
                            this.loading = !0;
                            var e = n.extend({}, { page: 1 }, this.lastParams);
                            e.page++, this.trigger("query:append", e);
                        }),
                        (e.prototype.showLoadingMore = function (e, t) {
                            return t.pagination && t.pagination.more;
                        }),
                        (e.prototype.createLoadingMore = function () {
                            var e = n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
                                t = this.options.get("translations").get("loadingMore");
                            return e.html(t(this.lastParams)), e;
                        }),
                        e
                    );
                }),
                e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (f, a) {
                    function e(e, t, n) {
                        (this.$dropdownParent = f(n.get("dropdownParent") || document.body)), e.call(this, t, n);
                    }
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            var r = this;
                            e.call(this, t, n),
                                t.on("open", function () {
                                    r._showDropdown(), r._attachPositioningHandler(t), r._bindContainerResultHandlers(t);
                                }),
                                t.on("close", function () {
                                    r._hideDropdown(), r._detachPositioningHandler(t);
                                }),
                                this.$dropdownContainer.on("mousedown", function (e) {
                                    e.stopPropagation();
                                });
                        }),
                        (e.prototype.destroy = function (e) {
                            e.call(this), this.$dropdownContainer.remove();
                        }),
                        (e.prototype.position = function (e, t, n) {
                            t.attr("class", n.attr("class")), t.removeClass("select2"), t.addClass("select2-container--open"), t.css({ position: "absolute", top: -999999 }), (this.$container = n);
                        }),
                        (e.prototype.render = function (e) {
                            var t = f("<span></span>"),
                                n = e.call(this);
                            return t.append(n), (this.$dropdownContainer = t);
                        }),
                        (e.prototype._hideDropdown = function (e) {
                            this.$dropdownContainer.detach();
                        }),
                        (e.prototype._bindContainerResultHandlers = function (e, t) {
                            if (!this._containerResultsHandlersBound) {
                                var n = this;
                                t.on("results:all", function () {
                                    n._positionDropdown(), n._resizeDropdown();
                                }),
                                    t.on("results:append", function () {
                                        n._positionDropdown(), n._resizeDropdown();
                                    }),
                                    t.on("results:message", function () {
                                        n._positionDropdown(), n._resizeDropdown();
                                    }),
                                    t.on("select", function () {
                                        n._positionDropdown(), n._resizeDropdown();
                                    }),
                                    t.on("unselect", function () {
                                        n._positionDropdown(), n._resizeDropdown();
                                    }),
                                    (this._containerResultsHandlersBound = !0);
                            }
                        }),
                        (e.prototype._attachPositioningHandler = function (e, t) {
                            var n = this,
                                r = "scroll.select2." + t.id,
                                i = "resize.select2." + t.id,
                                o = "orientationchange.select2." + t.id,
                                s = this.$container.parents().filter(a.hasScroll);
                            s.each(function () {
                                a.StoreData(this, "select2-scroll-position", { x: f(this).scrollLeft(), y: f(this).scrollTop() });
                            }),
                                s.on(r, function (e) {
                                    var t = a.GetData(this, "select2-scroll-position");
                                    f(this).scrollTop(t.y);
                                }),
                                f(window).on(r + " " + i + " " + o, function (e) {
                                    n._positionDropdown(), n._resizeDropdown();
                                });
                        }),
                        (e.prototype._detachPositioningHandler = function (e, t) {
                            var n = "scroll.select2." + t.id,
                                r = "resize.select2." + t.id,
                                i = "orientationchange.select2." + t.id;
                            this.$container.parents().filter(a.hasScroll).off(n), f(window).off(n + " " + r + " " + i);
                        }),
                        (e.prototype._positionDropdown = function () {
                            var e = f(window),
                                t = this.$dropdown.hasClass("select2-dropdown--above"),
                                n = this.$dropdown.hasClass("select2-dropdown--below"),
                                r = null,
                                i = this.$container.offset();
                            i.bottom = i.top + this.$container.outerHeight(!1);
                            var o = { height: this.$container.outerHeight(!1) };
                            (o.top = i.top), (o.bottom = i.top + o.height);
                            var s = this.$dropdown.outerHeight(!1),
                                a = e.scrollTop(),
                                l = e.scrollTop() + e.height(),
                                c = a < i.top - s,
                                u = l > i.bottom + s,
                                d = { left: i.left, top: o.bottom },
                                p = this.$dropdownParent;
                            "static" === p.css("position") && (p = p.offsetParent());
                            var h = { top: 0, left: 0 };
                            (f.contains(document.body, p[0]) || p[0].isConnected) && (h = p.offset()),
                                (d.top -= h.top),
                                (d.left -= h.left),
                                t || n || (r = "below"),
                                u || !c || t ? !c && u && t && (r = "below") : (r = "above"),
                                ("above" == r || (t && "below" !== r)) && (d.top = o.top - h.top - s),
                                null != r &&
                                    (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + r),
                                    this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + r)),
                                this.$dropdownContainer.css(d);
                        }),
                        (e.prototype._resizeDropdown = function () {
                            var e = { width: this.$container.outerWidth(!1) + "px" };
                            this.options.get("dropdownAutoWidth") && ((e.minWidth = e.width), (e.position = "relative"), (e.width = "auto")), this.$dropdown.css(e);
                        }),
                        (e.prototype._showDropdown = function (e) {
                            this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown();
                        }),
                        e
                    );
                }),
                e.define("select2/dropdown/minimumResultsForSearch", [], function () {
                    function e(e, t, n, r) {
                        (this.minimumResultsForSearch = n.get("minimumResultsForSearch")), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, n, r);
                    }
                    return (
                        (e.prototype.showSearch = function (e, t) {
                            return (
                                !(
                                    (function e(t) {
                                        for (var n = 0, r = 0; r < t.length; r++) {
                                            var i = t[r];
                                            i.children ? (n += e(i.children)) : n++;
                                        }
                                        return n;
                                    })(t.data.results) < this.minimumResultsForSearch
                                ) && e.call(this, t)
                            );
                        }),
                        e
                    );
                }),
                e.define("select2/dropdown/selectOnClose", ["../utils"], function (o) {
                    function e() {}
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            var r = this;
                            e.call(this, t, n),
                                t.on("close", function (e) {
                                    r._handleSelectOnClose(e);
                                });
                        }),
                        (e.prototype._handleSelectOnClose = function (e, t) {
                            if (t && null != t.originalSelect2Event) {
                                var n = t.originalSelect2Event;
                                if ("select" === n._type || "unselect" === n._type) return;
                            }
                            var r = this.getHighlightedResults();
                            if (!(r.length < 1)) {
                                var i = o.GetData(r[0], "data");
                                (null != i.element && i.element.selected) || (null == i.element && i.selected) || this.trigger("select", { data: i });
                            }
                        }),
                        e
                    );
                }),
                e.define("select2/dropdown/closeOnSelect", [], function () {
                    function e() {}
                    return (
                        (e.prototype.bind = function (e, t, n) {
                            var r = this;
                            e.call(this, t, n),
                                t.on("select", function (e) {
                                    r._selectTriggered(e);
                                }),
                                t.on("unselect", function (e) {
                                    r._selectTriggered(e);
                                });
                        }),
                        (e.prototype._selectTriggered = function (e, t) {
                            var n = t.originalEvent;
                            (n && (n.ctrlKey || n.metaKey)) || this.trigger("close", { originalEvent: n, originalSelect2Event: t });
                        }),
                        e
                    );
                }),
                e.define("select2/i18n/en", [], function () {
                    return {
                        errorLoading: function () {
                            return "The results could not be loaded.";
                        },
                        inputTooLong: function (e) {
                            var t = e.input.length - e.maximum,
                                n = "Please delete " + t + " character";
                            return 1 != t && (n += "s"), n;
                        },
                        inputTooShort: function (e) {
                            return "Please enter " + (e.minimum - e.input.length) + " or more characters";
                        },
                        loadingMore: function () {
                            return "Loading more resultsÃ¢â‚¬Â¦";
                        },
                        maximumSelected: function (e) {
                            var t = "You can only select " + e.maximum + " item";
                            return 1 != e.maximum && (t += "s"), t;
                        },
                        noResults: function () {
                            return "No results found";
                        },
                        searching: function () {
                            return "SearchingÃ¢â‚¬Â¦";
                        },
                        removeAllItems: function () {
                            return "Remove all items";
                        },
                    };
                }),
                e.define(
                    "select2/defaults",
                    [
                        "jquery",
                        "require",
                        "./results",
                        "./selection/single",
                        "./selection/multiple",
                        "./selection/placeholder",
                        "./selection/allowClear",
                        "./selection/search",
                        "./selection/eventRelay",
                        "./utils",
                        "./translation",
                        "./diacritics",
                        "./data/select",
                        "./data/array",
                        "./data/ajax",
                        "./data/tags",
                        "./data/tokenizer",
                        "./data/minimumInputLength",
                        "./data/maximumInputLength",
                        "./data/maximumSelectionLength",
                        "./dropdown",
                        "./dropdown/search",
                        "./dropdown/hidePlaceholder",
                        "./dropdown/infiniteScroll",
                        "./dropdown/attachBody",
                        "./dropdown/minimumResultsForSearch",
                        "./dropdown/selectOnClose",
                        "./dropdown/closeOnSelect",
                        "./i18n/en",
                    ],
                    function (c, u, d, p, h, f, g, m, v, y, s, t, _, $, b, w, A, x, D, S, E, C, O, T, q, L, I, j, e) {
                        function n() {
                            this.reset();
                        }
                        return (
                            (n.prototype.apply = function (e) {
                                if (null == (e = c.extend(!0, {}, this.defaults, e)).dataAdapter) {
                                    if (
                                        (null != e.ajax ? (e.dataAdapter = b) : null != e.data ? (e.dataAdapter = $) : (e.dataAdapter = _),
                                        0 < e.minimumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, x)),
                                        0 < e.maximumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, D)),
                                        0 < e.maximumSelectionLength && (e.dataAdapter = y.Decorate(e.dataAdapter, S)),
                                        e.tags && (e.dataAdapter = y.Decorate(e.dataAdapter, w)),
                                        (null == e.tokenSeparators && null == e.tokenizer) || (e.dataAdapter = y.Decorate(e.dataAdapter, A)),
                                        null != e.query)
                                    ) {
                                        var t = u(e.amdBase + "compat/query");
                                        e.dataAdapter = y.Decorate(e.dataAdapter, t);
                                    }
                                    if (null != e.initSelection) {
                                        var n = u(e.amdBase + "compat/initSelection");
                                        e.dataAdapter = y.Decorate(e.dataAdapter, n);
                                    }
                                }
                                if (
                                    (null == e.resultsAdapter &&
                                        ((e.resultsAdapter = d),
                                        null != e.ajax && (e.resultsAdapter = y.Decorate(e.resultsAdapter, T)),
                                        null != e.placeholder && (e.resultsAdapter = y.Decorate(e.resultsAdapter, O)),
                                        e.selectOnClose && (e.resultsAdapter = y.Decorate(e.resultsAdapter, I))),
                                    null == e.dropdownAdapter)
                                ) {
                                    if (e.multiple) e.dropdownAdapter = E;
                                    else {
                                        var r = y.Decorate(E, C);
                                        e.dropdownAdapter = r;
                                    }
                                    if (
                                        (0 !== e.minimumResultsForSearch && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, L)),
                                        e.closeOnSelect && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, j)),
                                        null != e.dropdownCssClass || null != e.dropdownCss || null != e.adaptDropdownCssClass)
                                    ) {
                                        var i = u(e.amdBase + "compat/dropdownCss");
                                        e.dropdownAdapter = y.Decorate(e.dropdownAdapter, i);
                                    }
                                    e.dropdownAdapter = y.Decorate(e.dropdownAdapter, q);
                                }
                                if (null == e.selectionAdapter) {
                                    if (
                                        (e.multiple ? (e.selectionAdapter = h) : (e.selectionAdapter = p),
                                        null != e.placeholder && (e.selectionAdapter = y.Decorate(e.selectionAdapter, f)),
                                        e.allowClear && (e.selectionAdapter = y.Decorate(e.selectionAdapter, g)),
                                        e.multiple && (e.selectionAdapter = y.Decorate(e.selectionAdapter, m)),
                                        null != e.containerCssClass || null != e.containerCss || null != e.adaptContainerCssClass)
                                    ) {
                                        var o = u(e.amdBase + "compat/containerCss");
                                        e.selectionAdapter = y.Decorate(e.selectionAdapter, o);
                                    }
                                    e.selectionAdapter = y.Decorate(e.selectionAdapter, v);
                                }
                                (e.language = this._resolveLanguage(e.language)), e.language.push("en");
                                for (var s = [], a = 0; a < e.language.length; a++) {
                                    var l = e.language[a];
                                    -1 === s.indexOf(l) && s.push(l);
                                }
                                return (e.language = s), (e.translations = this._processTranslations(e.language, e.debug)), e;
                            }),
                            (n.prototype.reset = function () {
                                function a(e) {
                                    return e.replace(/[^\u0000-\u007E]/g, function (e) {
                                        return t[e] || e;
                                    });
                                }
                                this.defaults = {
                                    amdBase: "./",
                                    amdLanguageBase: "./i18n/",
                                    closeOnSelect: !0,
                                    debug: !1,
                                    dropdownAutoWidth: !1,
                                    escapeMarkup: y.escapeMarkup,
                                    language: {},
                                    matcher: function e(t, n) {
                                        if ("" === c.trim(t.term)) return n;
                                        if (n.children && 0 < n.children.length) {
                                            for (var r = c.extend(!0, {}, n), i = n.children.length - 1; 0 <= i; i--) null == e(t, n.children[i]) && r.children.splice(i, 1);
                                            return 0 < r.children.length ? r : e(t, r);
                                        }
                                        var o = a(n.text).toUpperCase(),
                                            s = a(t.term).toUpperCase();
                                        return -1 < o.indexOf(s) ? n : null;
                                    },
                                    minimumInputLength: 0,
                                    maximumInputLength: 0,
                                    maximumSelectionLength: 0,
                                    minimumResultsForSearch: 0,
                                    selectOnClose: !1,
                                    scrollAfterSelect: !1,
                                    sorter: function (e) {
                                        return e;
                                    },
                                    templateResult: function (e) {
                                        return e.text;
                                    },
                                    templateSelection: function (e) {
                                        return e.text;
                                    },
                                    theme: "default",
                                    width: "resolve",
                                };
                            }),
                            (n.prototype.applyFromElement = function (e, t) {
                                var n = e.language,
                                    r = this.defaults.language,
                                    i = t.prop("lang"),
                                    o = t.closest("[lang]").prop("lang"),
                                    s = Array.prototype.concat.call(this._resolveLanguage(i), this._resolveLanguage(n), this._resolveLanguage(r), this._resolveLanguage(o));
                                return (e.language = s), e;
                            }),
                            (n.prototype._resolveLanguage = function (e) {
                                if (!e) return [];
                                if (c.isEmptyObject(e)) return [];
                                if (c.isPlainObject(e)) return [e];
                                var t;
                                t = c.isArray(e) ? e : [e];
                                for (var n = [], r = 0; r < t.length; r++)
                                    if ((n.push(t[r]), "string" == typeof t[r] && 0 < t[r].indexOf("-"))) {
                                        var i = t[r].split("-")[0];
                                        n.push(i);
                                    }
                                return n;
                            }),
                            (n.prototype._processTranslations = function (e, t) {
                                for (var n = new s(), r = 0; r < e.length; r++) {
                                    var i = new s(),
                                        o = e[r];
                                    if ("string" == typeof o)
                                        try {
                                            i = s.loadPath(o);
                                        } catch (e) {
                                            try {
                                                (o = this.defaults.amdLanguageBase + o), (i = s.loadPath(o));
                                            } catch (e) {
                                                t && window.console && console.warn && console.warn('Select2: The language file for "' + o + '" could not be automatically loaded. A fallback will be used instead.');
                                            }
                                        }
                                    else i = c.isPlainObject(o) ? new s(o) : o;
                                    n.extend(i);
                                }
                                return n;
                            }),
                            (n.prototype.set = function (e, t) {
                                var n = {};
                                n[c.camelCase(e)] = t;
                                var r = y._convertData(n);
                                c.extend(!0, this.defaults, r);
                            }),
                            new n()
                        );
                    }
                ),
                e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (r, d, i, p) {
                    function e(e, t) {
                        if (((this.options = e), null != t && this.fromElement(t), null != t && (this.options = i.applyFromElement(this.options, t)), (this.options = i.apply(this.options)), t && t.is("input"))) {
                            var n = r(this.get("amdBase") + "compat/inputData");
                            this.options.dataAdapter = p.Decorate(this.options.dataAdapter, n);
                        }
                    }
                    return (
                        (e.prototype.fromElement = function (e) {
                            var t = ["select2"];
                            null == this.options.multiple && (this.options.multiple = e.prop("multiple")),
                                null == this.options.disabled && (this.options.disabled = e.prop("disabled")),
                                null == this.options.dir && (e.prop("dir") ? (this.options.dir = e.prop("dir")) : e.closest("[dir]").prop("dir") ? (this.options.dir = e.closest("[dir]").prop("dir")) : (this.options.dir = "ltr")),
                                e.prop("disabled", this.options.disabled),
                                e.prop("multiple", this.options.multiple),
                                p.GetData(e[0], "select2Tags") &&
                                    (this.options.debug &&
                                        window.console &&
                                        console.warn &&
                                        console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),
                                    p.StoreData(e[0], "data", p.GetData(e[0], "select2Tags")),
                                    p.StoreData(e[0], "tags", !0)),
                                p.GetData(e[0], "ajaxUrl") &&
                                    (this.options.debug &&
                                        window.console &&
                                        console.warn &&
                                        console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),
                                    e.attr("ajax--url", p.GetData(e[0], "ajaxUrl")),
                                    p.StoreData(e[0], "ajax-Url", p.GetData(e[0], "ajaxUrl")));
                            var n = {};
                            function r(e, t) {
                                return t.toUpperCase();
                            }
                            for (var i = 0; i < e[0].attributes.length; i++) {
                                var o = e[0].attributes[i].name,
                                    s = "data-";
                                if (o.substr(0, s.length) == s) {
                                    var a = o.substring(s.length),
                                        l = p.GetData(e[0], a);
                                    n[a.replace(/-([a-z])/g, r)] = l;
                                }
                            }
                            d.fn.jquery && "1." == d.fn.jquery.substr(0, 2) && e[0].dataset && (n = d.extend(!0, {}, e[0].dataset, n));
                            var c = d.extend(!0, {}, p.GetData(e[0]), n);
                            for (var u in (c = p._convertData(c))) -1 < d.inArray(u, t) || (d.isPlainObject(this.options[u]) ? d.extend(this.options[u], c[u]) : (this.options[u] = c[u]));
                            return this;
                        }),
                        (e.prototype.get = function (e) {
                            return this.options[e];
                        }),
                        (e.prototype.set = function (e, t) {
                            this.options[e] = t;
                        }),
                        e
                    );
                }),
                e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (o, c, u, r) {
                    var d = function (e, t) {
                        null != u.GetData(e[0], "select2") && u.GetData(e[0], "select2").destroy(), (this.$element = e), (this.id = this._generateId(e)), (t = t || {}), (this.options = new c(t, e)), d.__super__.constructor.call(this);
                        var n = e.attr("tabindex") || 0;
                        u.StoreData(e[0], "old-tabindex", n), e.attr("tabindex", "-1");
                        var r = this.options.get("dataAdapter");
                        this.dataAdapter = new r(e, this.options);
                        var i = this.render();
                        this._placeContainer(i);
                        var o = this.options.get("selectionAdapter");
                        (this.selection = new o(e, this.options)), (this.$selection = this.selection.render()), this.selection.position(this.$selection, i);
                        var s = this.options.get("dropdownAdapter");
                        (this.dropdown = new s(e, this.options)), (this.$dropdown = this.dropdown.render()), this.dropdown.position(this.$dropdown, i);
                        var a = this.options.get("resultsAdapter");
                        (this.results = new a(e, this.options, this.dataAdapter)), (this.$results = this.results.render()), this.results.position(this.$results, this.$dropdown);
                        var l = this;
                        this._bindAdapters(),
                            this._registerDomEvents(),
                            this._registerDataEvents(),
                            this._registerSelectionEvents(),
                            this._registerDropdownEvents(),
                            this._registerResultsEvents(),
                            this._registerEvents(),
                            this.dataAdapter.current(function (e) {
                                l.trigger("selection:update", { data: e });
                            }),
                            e.addClass("select2-hidden-accessible"),
                            e.attr("aria-hidden", "true"),
                            this._syncAttributes(),
                            u.StoreData(e[0], "select2", this),
                            e.data("select2", this);
                    };
                    return (
                        u.Extend(d, u.Observable),
                        (d.prototype._generateId = function (e) {
                            return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + u.generateChars(2) : u.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "");
                        }),
                        (d.prototype._placeContainer = function (e) {
                            e.insertAfter(this.$element);
                            var t = this._resolveWidth(this.$element, this.options.get("width"));
                            null != t && e.css("width", t);
                        }),
                        (d.prototype._resolveWidth = function (e, t) {
                            var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                            if ("resolve" == t) {
                                var r = this._resolveWidth(e, "style");
                                return null != r ? r : this._resolveWidth(e, "element");
                            }
                            if ("element" == t) {
                                var i = e.outerWidth(!1);
                                return i <= 0 ? "auto" : i + "px";
                            }
                            if ("style" != t) return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;
                            var o = e.attr("style");
                            if ("string" != typeof o) return null;
                            for (var s = o.split(";"), a = 0, l = s.length; a < l; a += 1) {
                                var c = s[a].replace(/\s/g, "").match(n);
                                if (null !== c && 1 <= c.length) return c[1];
                            }
                            return null;
                        }),
                        (d.prototype._bindAdapters = function () {
                            this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container);
                        }),
                        (d.prototype._registerDomEvents = function () {
                            var t = this;
                            this.$element.on("change.select2", function () {
                                t.dataAdapter.current(function (e) {
                                    t.trigger("selection:update", { data: e });
                                });
                            }),
                                this.$element.on("focus.select2", function (e) {
                                    t.trigger("focus", e);
                                }),
                                (this._syncA = u.bind(this._syncAttributes, this)),
                                (this._syncS = u.bind(this._syncSubtree, this)),
                                this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                            var e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                            null != e
                                ? ((this._observer = new e(function (e) {
                                      t._syncA(), t._syncS(null, e);
                                  })),
                                  this._observer.observe(this.$element[0], { attributes: !0, childList: !0, subtree: !1 }))
                                : this.$element[0].addEventListener &&
                                  (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1));
                        }),
                        (d.prototype._registerDataEvents = function () {
                            var n = this;
                            this.dataAdapter.on("*", function (e, t) {
                                n.trigger(e, t);
                            });
                        }),
                        (d.prototype._registerSelectionEvents = function () {
                            var n = this,
                                r = ["toggle", "focus"];
                            this.selection.on("toggle", function () {
                                n.toggleDropdown();
                            }),
                                this.selection.on("focus", function (e) {
                                    n.focus(e);
                                }),
                                this.selection.on("*", function (e, t) {
                                    -1 === o.inArray(e, r) && n.trigger(e, t);
                                });
                        }),
                        (d.prototype._registerDropdownEvents = function () {
                            var n = this;
                            this.dropdown.on("*", function (e, t) {
                                n.trigger(e, t);
                            });
                        }),
                        (d.prototype._registerResultsEvents = function () {
                            var n = this;
                            this.results.on("*", function (e, t) {
                                n.trigger(e, t);
                            });
                        }),
                        (d.prototype._registerEvents = function () {
                            var n = this;
                            this.on("open", function () {
                                n.$container.addClass("select2-container--open");
                            }),
                                this.on("close", function () {
                                    n.$container.removeClass("select2-container--open");
                                }),
                                this.on("enable", function () {
                                    n.$container.removeClass("select2-container--disabled");
                                }),
                                this.on("disable", function () {
                                    n.$container.addClass("select2-container--disabled");
                                }),
                                this.on("blur", function () {
                                    n.$container.removeClass("select2-container--focus");
                                }),
                                this.on("query", function (t) {
                                    n.isOpen() || n.trigger("open", {}),
                                        this.dataAdapter.query(t, function (e) {
                                            n.trigger("results:all", { data: e, query: t });
                                        });
                                }),
                                this.on("query:append", function (t) {
                                    this.dataAdapter.query(t, function (e) {
                                        n.trigger("results:append", { data: e, query: t });
                                    });
                                }),
                                this.on("keypress", function (e) {
                                    var t = e.which;
                                    n.isOpen()
                                        ? t === r.ESC || t === r.TAB || (t === r.UP && e.altKey)
                                            ? (n.close(e), e.preventDefault())
                                            : t === r.ENTER
                                            ? (n.trigger("results:select", {}), e.preventDefault())
                                            : t === r.SPACE && e.ctrlKey
                                            ? (n.trigger("results:toggle", {}), e.preventDefault())
                                            : t === r.UP
                                            ? (n.trigger("results:previous", {}), e.preventDefault())
                                            : t === r.DOWN && (n.trigger("results:next", {}), e.preventDefault())
                                        : (t === r.ENTER || t === r.SPACE || (t === r.DOWN && e.altKey)) && (n.open(), e.preventDefault());
                                });
                        }),
                        (d.prototype._syncAttributes = function () {
                            this.options.set("disabled", this.$element.prop("disabled")), this.isDisabled() ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {});
                        }),
                        (d.prototype._isChangeMutation = function (e, t) {
                            var n = !1,
                                r = this;
                            if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
                                if (t)
                                    if (t.addedNodes && 0 < t.addedNodes.length)
                                        for (var i = 0; i < t.addedNodes.length; i++) {
                                            t.addedNodes[i].selected && (n = !0);
                                        }
                                    else
                                        t.removedNodes && 0 < t.removedNodes.length
                                            ? (n = !0)
                                            : o.isArray(t) &&
                                              o.each(t, function (e, t) {
                                                  if (r._isChangeMutation(e, t)) return !(n = !0);
                                              });
                                else n = !0;
                                return n;
                            }
                        }),
                        (d.prototype._syncSubtree = function (e, t) {
                            var n = this._isChangeMutation(e, t),
                                r = this;
                            n &&
                                this.dataAdapter.current(function (e) {
                                    r.trigger("selection:update", { data: e });
                                });
                        }),
                        (d.prototype.trigger = function (e, t) {
                            var n = d.__super__.trigger,
                                r = { open: "opening", close: "closing", select: "selecting", unselect: "unselecting", clear: "clearing" };
                            if ((void 0 === t && (t = {}), e in r)) {
                                var i = r[e],
                                    o = { prevented: !1, name: e, args: t };
                                if ((n.call(this, i, o), o.prevented)) return void (t.prevented = !0);
                            }
                            n.call(this, e, t);
                        }),
                        (d.prototype.toggleDropdown = function () {
                            this.isDisabled() || (this.isOpen() ? this.close() : this.open());
                        }),
                        (d.prototype.open = function () {
                            this.isOpen() || this.isDisabled() || this.trigger("query", {});
                        }),
                        (d.prototype.close = function (e) {
                            this.isOpen() && this.trigger("close", { originalEvent: e });
                        }),
                        (d.prototype.isEnabled = function () {
                            return !this.isDisabled();
                        }),
                        (d.prototype.isDisabled = function () {
                            return this.options.get("disabled");
                        }),
                        (d.prototype.isOpen = function () {
                            return this.$container.hasClass("select2-container--open");
                        }),
                        (d.prototype.hasFocus = function () {
                            return this.$container.hasClass("select2-container--focus");
                        }),
                        (d.prototype.focus = function (e) {
                            this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}));
                        }),
                        (d.prototype.enable = function (e) {
                            this.options.get("debug") &&
                                window.console &&
                                console.warn &&
                                console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'),
                                (null != e && 0 !== e.length) || (e = [!0]);
                            var t = !e[0];
                            this.$element.prop("disabled", t);
                        }),
                        (d.prototype.data = function () {
                            this.options.get("debug") &&
                                0 < arguments.length &&
                                window.console &&
                                console.warn &&
                                console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                            var t = [];
                            return (
                                this.dataAdapter.current(function (e) {
                                    t = e;
                                }),
                                t
                            );
                        }),
                        (d.prototype.val = function (e) {
                            if (
                                (this.options.get("debug") &&
                                    window.console &&
                                    console.warn &&
                                    console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),
                                null == e || 0 === e.length)
                            )
                                return this.$element.val();
                            var t = e[0];
                            o.isArray(t) &&
                                (t = o.map(t, function (e) {
                                    return e.toString();
                                })),
                                this.$element.val(t).trigger("input").trigger("change");
                        }),
                        (d.prototype.destroy = function () {
                            this.$container.remove(),
                                this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA),
                                null != this._observer
                                    ? (this._observer.disconnect(), (this._observer = null))
                                    : this.$element[0].removeEventListener &&
                                      (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1),
                                      this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1),
                                      this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)),
                                (this._syncA = null),
                                (this._syncS = null),
                                this.$element.off(".select2"),
                                this.$element.attr("tabindex", u.GetData(this.$element[0], "old-tabindex")),
                                this.$element.removeClass("select2-hidden-accessible"),
                                this.$element.attr("aria-hidden", "false"),
                                u.RemoveData(this.$element[0]),
                                this.$element.removeData("select2"),
                                this.dataAdapter.destroy(),
                                this.selection.destroy(),
                                this.dropdown.destroy(),
                                this.results.destroy(),
                                (this.dataAdapter = null),
                                (this.selection = null),
                                (this.dropdown = null),
                                (this.results = null);
                        }),
                        (d.prototype.render = function () {
                            var e = o('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                            return e.attr("dir", this.options.get("dir")), (this.$container = e), this.$container.addClass("select2-container--" + this.options.get("theme")), u.StoreData(e[0], "element", this.$element), e;
                        }),
                        d
                    );
                }),
                e.define("jquery-mousewheel", ["jquery"], function (e) {
                    return e;
                }),
                e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function (i, e, o, t, s) {
                    if (null == i.fn.select2) {
                        var a = ["open", "close", "destroy"];
                        i.fn.select2 = function (t) {
                            if ("object" == typeof (t = t || {}))
                                return (
                                    this.each(function () {
                                        var e = i.extend(!0, {}, t);
                                        new o(i(this), e);
                                    }),
                                    this
                                );
                            if ("string" != typeof t) throw new Error("Invalid arguments for Select2: " + t);
                            var n,
                                r = Array.prototype.slice.call(arguments, 1);
                            return (
                                this.each(function () {
                                    var e = s.GetData(this, "select2");
                                    null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), (n = e[t].apply(e, r));
                                }),
                                -1 < i.inArray(t, a) ? this : n
                            );
                        };
                    }
                    return null == i.fn.select2.defaults && (i.fn.select2.defaults = t), o;
                }),
                { define: e.define, require: e.require }
            );
        })(),
        t = e.require("jquery.select2");
    return (u.fn.select2.amd = e), t;
});
window.gtm4wp_last_selected_product_variation;
window.gtm4wp_changedetail_fired_during_pageload = false;
window.gtm4wp_is_cart = false;
window.gtm4wp_is_checkout = false;
window.gtm4wp_checkout_step_fired = [];
window.gtm4wp_shipping_payment_method_step_offset = window.gtm4wp_needs_shipping_address ? 0 : -1;
window.gtm4wp_first_container_id = "";
(function ($) {
    "use strict";
    $(document).ready(function () {
        $("body")
            .on("adding_to_cart", function (event, $button, data) {
                if ($button && $button.hasClass("vc_gitem-link")) {
                    $button
                        .addClass("vc-gitem-add-to-cart-loading-btn")
                        .parents(".vc_grid-item-mini")
                        .addClass("vc-woocommerce-add-to-cart-loading")
                        .append($('<div class="vc_wc-load-add-to-loader-wrapper"><div class="vc_wc-load-add-to-loader"></div></div>'));
                }
            })
            .on("added_to_cart", function (event, fragments, cart_hash, $button) {
                if ("undefined" === typeof $button) {
                    $button = $(".vc-gitem-add-to-cart-loading-btn");
                }
                if ($button && $button.hasClass("vc_gitem-link")) {
                    $button.removeClass("vc-gitem-add-to-cart-loading-btn").parents(".vc_grid-item-mini").removeClass("vc-woocommerce-add-to-cart-loading").find(".vc_wc-load-add-to-loader-wrapper").remove();
                }
            });
    });
})(window.jQuery);
!(function ($) {
    "use strict";
    var escape = /["\\\x00-\x1f\x7f-\x9f]/g,
        meta = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" },
        hasOwn = Object.prototype.hasOwnProperty;
    ($.toJSON =
        "object" == typeof JSON && JSON.stringify
            ? JSON.stringify
            : function (t) {
                  if (null === t) return "null";
                  var e,
                      r,
                      n,
                      o,
                      i = $.type(t);
                  if ("undefined" !== i) {
                      if ("number" === i || "boolean" === i) return String(t);
                      if ("string" === i) return $.quoteString(t);
                      if ("function" == typeof t.toJSON) return $.toJSON(t.toJSON());
                      if ("date" === i) {
                          var f = t.getUTCMonth() + 1,
                              u = t.getUTCDate(),
                              s = t.getUTCFullYear(),
                              a = t.getUTCHours(),
                              l = t.getUTCMinutes(),
                              c = t.getUTCSeconds(),
                              p = t.getUTCMilliseconds();
                          return (
                              f < 10 && (f = "0" + f),
                              u < 10 && (u = "0" + u),
                              a < 10 && (a = "0" + a),
                              l < 10 && (l = "0" + l),
                              c < 10 && (c = "0" + c),
                              p < 100 && (p = "0" + p),
                              p < 10 && (p = "0" + p),
                              '"' + s + "-" + f + "-" + u + "T" + a + ":" + l + ":" + c + "." + p + 'Z"'
                          );
                      }
                      if (((e = []), $.isArray(t))) {
                          for (r = 0; r < t.length; r++) e.push($.toJSON(t[r]) || "null");
                          return "[" + e.join(",") + "]";
                      }
                      if ("object" == typeof t) {
                          for (r in t)
                              if (hasOwn.call(t, r)) {
                                  if ("number" === (i = typeof r)) n = '"' + r + '"';
                                  else {
                                      if ("string" !== i) continue;
                                      n = $.quoteString(r);
                                  }
                                  "function" !== (i = typeof t[r]) && "undefined" !== i && ((o = $.toJSON(t[r])), e.push(n + ":" + o));
                              }
                          return "{" + e.join(",") + "}";
                      }
                  }
              }),
        ($.evalJSON =
            "object" == typeof JSON && JSON.parse
                ? JSON.parse
                : function (str) {
                      return eval("(" + str + ")");
                  }),
        ($.secureEvalJSON =
            "object" == typeof JSON && JSON.parse
                ? JSON.parse
                : function (str) {
                      var filtered = str
                          .replace(/\\["\\\/bfnrtu]/g, "@")
                          .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]")
                          .replace(/(?:^|:|,)(?:\s*\[)+/g, "");
                      if (/^[\],:{}\s]*$/.test(filtered)) return eval("(" + str + ")");
                      throw new SyntaxError("Error parsing JSON, source is not valid.");
                  }),
        ($.quoteString = function (t) {
            return t.match(escape)
                ? '"' +
                      t.replace(escape, function (t) {
                          var e = meta[t];
                          return "string" == typeof e ? e : ((e = t.charCodeAt()), "\\u00" + Math.floor(e / 16).toString(16) + (e % 16).toString(16));
                      }) +
                      '"'
                : '"' + t + '"';
        });
})(jQuery);
function gformBindFormatPricingFields() {
    jQuery(".ginput_amount, .ginput_donation_amount")
        .off("change.gform")
        .on("change.gform", function () {
            gformFormatPricingField(this);
        }),
        jQuery(".ginput_amount, .ginput_donation_amount").each(function () {
            gformFormatPricingField(this);
        });
}
function Currency(e) {
    (this.currency = e),
        (this.toNumber = function (e) {
            return this.isNumeric(e) ? parseFloat(e) : gformCleanNumber(e, this.currency.symbol_right, this.currency.symbol_left, this.currency.decimal_separator);
        }),
        (this.toMoney = function (e, r) {
            if (((r = r || !1) || (e = gformCleanNumber(e, this.currency.symbol_right, this.currency.symbol_left, this.currency.decimal_separator)), !1 === e)) return "";
            "-" == (e += negative = "")[0] && ((e = parseFloat(e.substr(1))), (negative = "-")),
                (money = this.numberFormat(e, this.currency.decimals, this.currency.decimal_separator, this.currency.thousand_separator)),
                "0.00" == money && (negative = "");
            var t = this.currency.symbol_left ? this.currency.symbol_left + this.currency.symbol_padding : "",
                i = this.currency.symbol_right ? this.currency.symbol_padding + this.currency.symbol_right : "";
            return (money = negative + this.htmlDecode(t) + money + this.htmlDecode(i)), money;
        }),
        (this.numberFormat = function (e, r, t, i, n) {
            (n = void 0 === n || n), (e = (e + "").replace(",", "").replace(" ", ""));
            var a,
                o,
                l,
                f = isFinite(+e) ? +e : 0,
                s = isFinite(+r) ? Math.abs(r) : 0,
                d = void 0 === i ? "," : i,
                c = void 0 === t ? "." : t,
                u = "";
            return (
                3 < (u = "0" == r ? ((f += 1e-10), ("" + Math.round(f)).split(".")) : -1 == r ? ("" + f).split(".") : ((a = f += 1e-10), (o = s), (l = Math.pow(10, o)), ("" + Math.round(a * l) / l).split(".")))[0].length &&
                    (u[0] = u[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, d)),
                n && (u[1] || "").length < s && ((u[1] = u[1] || ""), (u[1] += new Array(s - u[1].length + 1).join("0"))),
                u.join(c)
            );
        }),
        (this.isNumeric = function (e) {
            return gformIsNumber(e);
        }),
        (this.htmlDecode = function (e) {
            var r,
                t,
                i = e,
                n = i.match(/&#[0-9]{1,5};/g);
            if (null != n) for (var a = 0; a < n.length; a++) i = -32768 <= (r = (t = n[a]).substring(2, t.length - 1)) && r <= 65535 ? i.replace(t, String.fromCharCode(r)) : i.replace(t, "");
            return i;
        });
}
function gformCleanNumber(e, r, t, i) {
    var n = "",
        a = "",
        o = "",
        l = !1;
    e = (e = (e = (e += " ").replace(/&.*?;/g, "")).replace(r, "")).replace(t, "");
    for (var f = 0; f < e.length; f++) (o = e.substr(f, 1)), (0 <= parseInt(o, 10) && parseInt(o, 10) <= 9) || o == i ? (n += o) : "-" == o && (l = !0);
    for (f = 0; f < n.length; f++) "0" <= (o = n.substr(f, 1)) && o <= "9" ? (a += o) : o == i && (a += ".");
    return l && (a = "-" + a), !!gformIsNumber(a) && parseFloat(a);
}
function gformGetDecimalSeparator(e) {
    var r;
    switch (e) {
        case "currency":
            r = new Currency(gf_global.gf_currency_config).currency.decimal_separator;
            break;
        case "decimal_comma":
            r = ",";
            break;
        default:
            r = ".";
    }
    return r;
}
function gformIsNumber(e) {
    return !isNaN(parseFloat(e)) && isFinite(e);
}
function gformIsNumeric(e, r) {
    switch (r) {
        case "decimal_dot":
            return new RegExp("^(-?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]+)?)$").test(e);
        case "decimal_comma":
            return new RegExp("^(-?[0-9]{1,3}(?:.?[0-9]{3})*(?:,[0-9]+)?)$").test(e);
    }
    return !1;
}
function gformDeleteUploadedFile(e, r, t) {
    var i = jQuery("#field_" + e + "_" + r),
        n = jQuery(t).parent().index();
    i.find(".ginput_preview").eq(n).remove(), i.find('input[type="file"],.validation_message,#extensions_message_' + e + "_" + r).removeClass("gform_hidden"), i.find(".ginput_post_image_file").show(), i.find('input[type="text"]').val("");
    var a = jQuery("#gform_uploaded_files_" + e).val();
    if (a) {
        var o = jQuery.secureEvalJSON(a);
        if (o) {
            var l = "input_" + r,
                f = i.find("#gform_multifile_upload_" + e + "_" + r);
            if (0 < f.length) {
                o[l].splice(n, 1);
                var s = f.data("settings"),
                    d = s.gf_vars.max_files;
                jQuery("#" + s.gf_vars.message_id).html(""), o[l].length < d && gfMultiFileUploader.toggleDisabled(s, !1);
            } else o[l] = null;
            jQuery("#gform_uploaded_files_" + e).val(jQuery.toJSON(o));
        }
    }
}
void 0 === jQuery.fn.prop && (jQuery.fn.prop = jQuery.fn.attr),
    jQuery(document).ready(function () {
        jQuery(document).bind("gform_post_render", gformBindFormatPricingFields);
    });
var _gformPriceFields = new Array(),
    _anyProductSelected;
function gformIsHidden(e) {
    return "none" == e.parents(".gfield").not(".gfield_hidden_product").css("display");
}
function gformCalculateTotalPrice(e) {
    if (_gformPriceFields[e]) {
        var r = 0;
        _anyProductSelected = !1;
        for (var t = 0; t < _gformPriceFields[e].length; t++) r += gformCalculateProductPrice(e, _gformPriceFields[e][t]);
        if (_anyProductSelected) r += gformGetShippingPrice(e);
        window.gform_product_total && (r = window.gform_product_total(e, r)), (r = gform.applyFilters("gform_product_total", r, e));
        var i = jQuery(".ginput_total_" + e);
        if (0 < i.length) {
            var n = i.next().val(),
                a = gformFormatMoney(r, !0);
            n != r && i.next().val(r).change(), a != i.first().text() && i.html(a);
        }
    }
}
function gformGetShippingPrice(e) {
    var r = jQuery(".gfield_shipping_" + e + ' input[type="hidden"], .gfield_shipping_' + e + " select, .gfield_shipping_" + e + " input:checked"),
        t = 0;
    return 1 != r.length || gformIsHidden(r) || (t = r.attr("type") && "hidden" == r.attr("type").toLowerCase() ? r.val() : gformGetPrice(r.val())), gformToNumber(t);
}
function gformGetFieldId(e) {
    var r = jQuery(e).attr("id").split("_");
    return r.length <= 0 ? 0 : r[r.length - 1];
}
function gformCalculateProductPrice(o, e) {
    var r = "_" + o + "_" + e;
    jQuery(".gfield_option" + r + ", .gfield_shipping_" + o)
        .find("select")
        .each(function () {
            var e = jQuery(this),
                t = gformGetPrice(e.val()),
                i = e.attr("id").split("_")[2];
            e.children("option").each(function () {
                var e = jQuery(this),
                    r = gformGetOptionLabel(e, e.val(), t, o, i);
                e.html(r);
            });
        }),
        jQuery(".gfield_option" + r)
            .find(".gfield_checkbox")
            .find("input:checkbox")
            .each(function () {
                var e = jQuery(this),
                    r = e.attr("id"),
                    t = r.split("_")[2],
                    i = r.replace("choice_", "#label_"),
                    n = jQuery(i),
                    a = gformGetOptionLabel(n, e.val(), 0, o, t);
                n.html(a);
            }),
        jQuery(".gfield_option" + r + ", .gfield_shipping_" + o)
            .find(".gfield_radio")
            .each(function () {
                var n = 0,
                    e = jQuery(this),
                    a = e.attr("id").split("_")[2],
                    r = e.find("input:radio:checked").val();
                r && (n = gformGetPrice(r)),
                    e.find("input:radio").each(function () {
                        var e = jQuery(this),
                            r = e.attr("id").replace("choice_", "#label_"),
                            t = jQuery(r);
                        if (t) {
                            var i = gformGetOptionLabel(t, e.val(), n, o, a);
                            t.html(i);
                        }
                    });
            });
    var t = gformGetBasePrice(o, e),
        i = gformGetProductQuantity(o, e);
    return (
        0 < i &&
            (jQuery(".gfield_option" + r)
                .find("input:checked, select")
                .each(function () {
                    gformIsHidden(jQuery(this)) || (t += gformGetPrice(jQuery(this).val()));
                }),
            (_anyProductSelected = !0)),
        (t = gformRoundPrice((t *= i)))
    );
}
function gformGetProductQuantity(e, r) {
    if (!gformIsProductSelected(e, r)) return 0;
    var t,
        i,
        n = jQuery("#ginput_quantity_" + e + "_" + r);
    if (gformIsHidden(n)) return 0;
    0 < n.length ? (t = n.val()) : ((t = 1), 0 < (n = jQuery(".gfield_quantity_" + e + "_" + r + " :input")).length && ((t = n.val()), (i = gf_get_field_number_format(gf_get_input_id_by_html_id(n.attr("id")), e, "value"))));
    return (t = (t = gformCleanNumber(t, "", "", gformGetDecimalSeparator((i = i || "currency")))) || 0);
}
function gformIsProductSelected(e, r) {
    var t = "_" + e + "_" + r,
        i = jQuery("#ginput_base_price" + t + ", .gfield_donation" + t + ' input[type="text"], .gfield_product' + t + " .ginput_amount");
    return !(!i.val() || gformIsHidden(i)) || !(!(i = jQuery(".gfield_product" + t + " select, .gfield_product" + t + " input:checked, .gfield_donation" + t + " select, .gfield_donation" + t + " input:checked")).val() || gformIsHidden(i));
}
function gformGetBasePrice(e, r) {
    var t = "_" + e + "_" + r,
        i = 0,
        n = jQuery("#ginput_base_price" + t + ", .gfield_donation" + t + ' input[type="text"], .gfield_product' + t + " .ginput_amount");
    if (0 < n.length) (i = n.val()), gformIsHidden(n) && (i = 0);
    else {
        var a = (n = jQuery(".gfield_product" + t + " select, .gfield_product" + t + " input:checked, .gfield_donation" + t + " select, .gfield_donation" + t + " input:checked")).val();
        a && (i = 1 < (a = a.split("|")).length ? a[1] : 0), gformIsHidden(n) && (i = 0);
    }
    return !1 === (i = new Currency(gf_global.gf_currency_config).toNumber(i)) ? 0 : i;
}
function gformFormatMoney(e, r) {
    return gf_global.gf_currency_config ? new Currency(gf_global.gf_currency_config).toMoney(e, r) : e;
}
function gformFormatPricingField(e) {
    if (gf_global.gf_currency_config) {
        var r = new Currency(gf_global.gf_currency_config).toMoney(jQuery(e).val());
        jQuery(e).val(r);
    }
}
function gformToNumber(e) {
    return new Currency(gf_global.gf_currency_config).toNumber(e);
}
function gformGetPriceDifference(e, r) {
    var t = parseFloat(r) - parseFloat(e);
    return (price = gformFormatMoney(t, !0)), 0 < t && (price = "+" + price), price;
}
function gformGetOptionLabel(e, r, t, i, n) {
    e = jQuery(e);
    var a = gformGetPrice(r),
        o = e.attr("price"),
        l = e
            .html()
            .replace(/<span(.*)<\/span>/i, "")
            .replace(o, ""),
        f = gformGetPriceDifference(t, a);
    (f = 0 == gformToNumber(f) ? "" : " " + f), e.attr("price", f);
    var s = "option" == e[0].tagName.toLowerCase() ? " " + f : "<span class='ginput_price'>" + f + "</span>",
        d = l + s;
    return window.gform_format_option_label && (d = gform_format_option_label(d, l, s, t, a, i, n)), d;
}
function gformGetProductIds(e, r) {
    for (
        var t = jQuery(r).hasClass(e)
                ? jQuery(r).attr("class").split(" ")
                : jQuery(r)
                      .parents("." + e)
                      .attr("class")
                      .split(" "),
            i = 0;
        i < t.length;
        i++
    )
        if (t[i].substr(0, e.length) == e && t[i] != e) return { formId: t[i].split("_")[2], productFieldId: t[i].split("_")[3] };
    return { formId: 0, fieldId: 0 };
}
function gformGetPrice(e) {
    var r = e.split("|"),
        t = new Currency(gf_global.gf_currency_config);
    return 1 < r.length && !1 !== t.toNumber(r[1]) ? t.toNumber(r[1]) : 0;
}
function gformRoundPrice(e) {
    var r = new Currency(gf_global.gf_currency_config),
        t = r.numberFormat(e, r.currency.decimals, ".", "");
    return parseFloat(t);
}
function gformRegisterPriceField(e) {
    _gformPriceFields[e.formId] || (_gformPriceFields[e.formId] = new Array());
    for (var r = 0; r < _gformPriceFields[e.formId].length; r++) if (_gformPriceFields[e.formId][r] == e.productFieldId) return;
    _gformPriceFields[e.formId].push(e.productFieldId);
}
function gformInitPriceFields() {
    for (formId in (jQuery(".gfield_price").each(function () {
        gformRegisterPriceField(gformGetProductIds("gfield_price", this)),
            jQuery(this).on("change", 'input[type="text"], input[type="number"], select', function () {
                var e = gformGetProductIds("gfield_price", this);
                0 == e.formId && (e = gformGetProductIds("gfield_shipping", this)), jQuery(document).trigger("gform_price_change", [e, this]), gformCalculateTotalPrice(e.formId);
            }),
            jQuery(this).on("click", 'input[type="radio"], input[type="checkbox"]', function () {
                var e = gformGetProductIds("gfield_price", this);
                0 == e.formId && (e = gformGetProductIds("gfield_shipping", this)), jQuery(document).trigger("gform_price_change", [e, this]), gformCalculateTotalPrice(e.formId);
            });
    }),
    _gformPriceFields))
        _gformPriceFields.hasOwnProperty(formId) && gformCalculateTotalPrice(formId);
}
function gformShowPasswordStrength(e) {
    var r = gformPasswordStrength(document.getElementById(e).value, document.getElementById(e + "_2") ? document.getElementById(e + "_2").value : ""),
        t = window.gf_text["password_" + r],
        i = "unknown" === r ? "blank" : r;
    jQuery("#" + e + "_strength").val(r),
        jQuery("#" + e + "_strength_indicator")
            .removeClass("blank mismatch short good bad strong")
            .addClass(i)
            .html(t);
}
function gformPasswordStrength(e, r) {
    if (e.length <= 0) return "blank";
    switch (wp.passwordStrength.meter(e, wp.passwordStrength.userInputBlacklist(), r)) {
        case -1:
            return "unknown";
        case 2:
            return "bad";
        case 3:
            return "good";
        case 4:
            return "strong";
        case 5:
            return "mismatch";
        default:
            return "short";
    }
}
function gformToggleShowPassword(e) {
    var r = jQuery("#" + e),
        t = r.parent().find("button"),
        i = t.find("span");
    switch (r.attr("type")) {
        case "password":
            r.attr("type", "text"), t.attr("label", t.attr("data-label-hide")), i.removeClass("dashicons-hidden").addClass("dashicons-visibility");
            break;
        case "text":
            r.attr("type", "password"), t.attr("label", t.attr("data-label-show")), i.removeClass("dashicons-visibility").addClass("dashicons-hidden");
    }
}
function gformToggleCheckboxes(e) {
    var r = jQuery(e).parent(),
        t = r.find("label"),
        i = r.parent().find("li:not( .gchoice_select_all )"),
        n = gf_get_form_id_by_html_id(r.parents(".gfield").attr("id")),
        a = rgars(window, "gf_global/gfcalc/" + n);
    i.each(function () {
        jQuery('input[type="checkbox"]', this).prop("checked", e.checked).trigger("change"), "function" == typeof jQuery('input[type="checkbox"]', this)[0].onclick && jQuery('input[type="checkbox"]', this)[0].onclick();
    }),
        e.checked ? t.html(t.data("label-deselect")) : t.html(t.data("label-select")),
        a && a.runCalcs(n, a.formulaFields);
}
function gformAddListItem(e, r) {
    var t = jQuery(e);
    if (!t.hasClass("gfield_icon_disabled")) {
        var i = t.parents(".gfield_list_group"),
            n = i.clone(),
            a = i.parents(".gfield_list_container"),
            o = n.find(":input:last").attr("tabindex");
        n.find("input, select, textarea").attr("tabindex", o).not(":checkbox, :radio").val(""),
            n.find(":checkbox, :radio").prop("checked", !1),
            (n = gform.applyFilters("gform_list_item_pre_add", n, i)),
            i.after(n),
            gformToggleIcons(a, r),
            gformAdjustClasses(a),
            gform.doAction("gform_list_post_item_add", n, a);
    }
}
function gformDeleteListItem(e, r) {
    var t = jQuery(e).parents(".gfield_list_group"),
        i = t.parents(".gfield_list_container");
    t.remove(), gformToggleIcons(i, r), gformAdjustClasses(i), gform.doAction("gform_list_post_item_delete", i);
}
function gformAdjustClasses(e) {
    e.find(".gfield_list_group").each(function (e) {
        var r = (e + 1) % 2 == 0 ? "gfield_list_row_even" : "gfield_list_row_odd";
        jQuery(this).removeClass("gfield_list_row_odd gfield_list_row_even").addClass(r);
    });
}
function gformToggleIcons(e, r) {
    var t = e.find(".gfield_list_group").length,
        i = e.find(".add_list_item");
    e.find(".delete_list_item").css("visibility", 1 == t ? "hidden" : "visible"),
        0 < r && r <= t
            ? (i.data("title", e.find(".add_list_item").attr("title")), i.addClass("gfield_icon_disabled").attr("title", ""))
            : 0 < r && (i.removeClass("gfield_icon_disabled"), i.data("title") && i.attr("title", i.data("title")));
}
function gformAddRepeaterItem(e, r) {
    var t = jQuery(e);
    if (!t.hasClass("gfield_icon_disabled")) {
        var i = t.closest(".gfield_repeater_item"),
            n = i.clone(),
            a = i.closest(".gfield_repeater_container"),
            o = n.find(":input:last").attr("tabindex");
        n.find('input[type!="hidden"], select, textarea').attr("tabindex", o).not(":checkbox, :radio").val(""),
            n.find(":checkbox, :radio").prop("checked", !1),
            n.find(".validation_message").remove(),
            (n = gform.applyFilters("gform_repeater_item_pre_add", n, i)),
            i.after(n),
            n.children(".gfield_repeater_cell").each(function () {
                var e = jQuery(this).find(".gfield_repeater_container").first();
                0 < e.length &&
                    ((resetContainerItems = function (e) {
                        e
                            .children(".gfield_repeater_items")
                            .children(".gfield_repeater_item")
                            .each(function (e) {
                                jQuery(this)
                                    .children(".gfield_repeater_cell")
                                    .each(function () {
                                        var e = jQuery(this).find(".gfield_repeater_container").first();
                                        0 < e.length && resetContainerItems(e);
                                    });
                            }),
                            e.children(".gfield_repeater_items").children(".gfield_repeater_item").not(":first").remove();
                    }),
                    resetContainerItems(e));
            }),
            gformResetRepeaterAttributes(a),
            "function" == typeof gformInitDatepicker && (a.find(".ui-datepicker-trigger").remove(), a.find(".hasDatepicker").removeClass("hasDatepicker"), gformInitDatepicker()),
            gformBindFormatPricingFields(),
            gformToggleRepeaterButtons(a, r),
            gform.doAction("gform_repeater_post_item_add", n, a);
    }
}
function gformDeleteRepeaterItem(e, r) {
    var t = jQuery(e).closest(".gfield_repeater_item"),
        i = t.closest(".gfield_repeater_container");
    t.remove(), gformResetRepeaterAttributes(i), gformToggleRepeaterButtons(i, r), gform.doAction("gform_repeater_post_item_delete", i);
}
function gformResetRepeaterAttributes(e, p, h) {
    var y = null;
    void 0 === p && (p = 0),
        void 0 === h && (h = 0),
        e
            .children(".gfield_repeater_items")
            .children(".gfield_repeater_item")
            .each(function () {
                jQuery(this)
                    .children(".gfield_repeater_cell")
                    .each(function () {
                        var m = jQuery(this),
                            e = jQuery(this).find(".gfield_repeater_container").first();
                        0 < e.length
                            ? gformResetRepeaterAttributes(e, p + 1, h)
                            : jQuery(this)
                                  .find("input, select, textarea, :checkbox, :radio")
                                  .each(function () {
                                      var e = jQuery(this),
                                          r = e.attr("name");
                                      if (void 0 !== r) {
                                          var t = /^(input_[^\[]*)((\[[0-9]+\])+)/.exec(r);
                                          if (t) {
                                              t[1];
                                              for (var i = t[2], n = /\[([0-9]+)\]/g, a = [], o = n.exec(i); null != o; ) a.push(o[1]), (o = n.exec(i));
                                              for (var l = t[1], f = "", s = (a = a.reverse()).length - 1; 0 <= s; s--) s == p ? ((l += "[" + h + "]"), (f += "-" + h)) : ((l += "[" + a[s] + "]"), (f += "-" + a[s]));
                                              var d = e.attr("id"),
                                                  c = m.find("label[for='" + d + "']");
                                              if (d) {
                                                  var u = d.match(/((choice|input)_[0-9|_]*)-/);
                                                  u && u[2] && ((f = u[1] + f), c.attr("for", f), e.attr("id", f));
                                              }
                                              var g = r.replace(t[0], l),
                                                  _ = jQuery('input[name="' + g + '"]').is(":checked");
                                              e.is(":radio") && e.is(":checked") && r !== g && _ && (null !== y && y.prop("checked", !0), e.prop("checked", !1), (y = e)), e.attr("name", g);
                                          }
                                      }
                                  });
                    }),
                    0 === p && h++;
            }),
        null !== y && (y.prop("checked", !0), (y = null));
}
function gformToggleRepeaterButtons(e) {
    var r = e.closest(".gfield_repeater_wrapper").data("max_items"),
        t = e.children(".gfield_repeater_items").children(".gfield_repeater_item").length,
        i = e.children(".gfield_repeater_items").children(".gfield_repeater_item").children(".gfield_repeater_buttons"),
        n = i.children(".add_repeater_item");
    i.children(".remove_repeater_item").css("visibility", 1 == t ? "hidden" : "visible"),
        0 < r && r <= t
            ? (n.data("title", i.children(".add_repeater_item").attr("title")), n.addClass("gfield_icon_disabled").attr("title", ""))
            : 0 < r && (n.removeClass("gfield_icon_disabled"), n.data("title") && n.attr("title", n.data("title"))),
        e
            .children(".gfield_repeater_items")
            .children(".gfield_repeater_item")
            .children(".gfield_repeater_cell")
            .each(function (e) {
                var r = jQuery(this).find(".gfield_repeater_container").first();
                0 < r.length && gformToggleRepeaterButtons(r);
            });
}
function gformMatchCard(e) {
    var r = gformFindCardType(jQuery("#" + e).val()),
        t = jQuery("#" + e)
            .parents(".gfield")
            .find(".gform_card_icon_container");
    r
        ? (jQuery(t).find(".gform_card_icon").removeClass("gform_card_icon_selected").addClass("gform_card_icon_inactive"),
          jQuery(t)
              .find(".gform_card_icon_" + r)
              .removeClass("gform_card_icon_inactive")
              .addClass("gform_card_icon_selected"))
        : jQuery(t).find(".gform_card_icon").removeClass("gform_card_icon_selected gform_card_icon_inactive");
}
function gformFindCardType(e) {
    if (e.length < 4) return !1;
    var r = window.gf_cc_rules,
        t = new Array();
    for (type in r)
        if (r.hasOwnProperty(type))
            for (i in r[type])
                if (r[type].hasOwnProperty(i) && 0 === r[type][i].indexOf(e.substring(0, r[type][i].length))) {
                    t[t.length] = type;
                    break;
                }
    return 1 == t.length && t[0].toLowerCase();
}
function gformToggleCreditCard() {
    jQuery("#gform_payment_method_creditcard").is(":checked") ? jQuery(".gform_card_fields_container").slideDown() : jQuery(".gform_card_fields_container").slideUp();
}
function gformInitChosenFields(e, t) {
    return jQuery(e).each(function () {
        var e = jQuery(this);
        if (("rtl" == jQuery("html").attr("dir") && e.addClass("chosen-rtl chzn-rtl"), e.is(":visible") && 0 == e.siblings(".chosen-container").length)) {
            var r = gform.applyFilters("gform_chosen_options", { no_results_text: t }, e);
            e.chosen(r);
        }
    });
}
function gformInitCurrencyFormatFields(e) {
    jQuery(e)
        .each(function () {
            jQuery(this).val(gformFormatMoney(jQuery(this).val()));
        })
        .change(function (e) {
            jQuery(this).val(gformFormatMoney(jQuery(this).val()));
        });
}
var GFMergeTag = function () {
    (GFMergeTag.getMergeTagValue = function (e, r, t) {
        void 0 === t && (t = ""), (t = t.replace(":", ""));
        var i,
            n = parseInt(r, 10),
            a = jQuery("#field_" + e + "_" + n),
            o = n == r ? 'input[name^="input_' + n + '"]' : 'input[name="input_' + r + '"]',
            l = a.find(o + ', select[name^="input_' + r + '"], textarea[name="input_' + r + '"]');
        if (!(!window.gf_check_field_rule || "show" == gf_check_field_rule(e, n, !0, ""))) return "";
        a.find(".ginput_container_email").hasClass("ginput_complex") && (l = l.first());
        var f = gform.applyFilters("gform_value_merge_tag_" + e + "_" + n, !1, l, t);
        if (!1 !== f) return f;
        switch (((f = ""), t)) {
            case "label":
                return a.find(".gfield_label").text();
            case "qty":
                if (a.hasClass("gfield_price")) return !1 === (i = gformGetProductQuantity(e, n)) || "" === i ? 0 : i;
        }
        if ((("checkbox" !== l.prop("type") && "radio" !== l.prop("type")) || (l = l.filter(":checked")), 1 === l.length)) {
            if ((!l.is("select") && "radio" !== l.prop("type") && "checkbox" !== l.prop("type")) || "" !== t) void 0 === i && (i = l.val());
            else if (((i = l.is("select") ? l.find("option:selected") : l.next("label").clone()).find("span").remove(), 1 === i.length)) i = i.text();
            else {
                for (var s = [], d = 0; d < i.length; d++) s[d] = jQuery(i[d]).text();
                i = s;
            }
            f = jQuery.isArray(i) ? i.join(", ") : "string" == typeof i ? GFMergeTag.formatValue(i, t) : "";
        } else if (1 < l.length) {
            i = [];
            for (d = 0; d < l.length; d++)
                if ("checkbox" === l.prop("type") && "" === t) {
                    var c = jQuery(l[d]).next("label").clone();
                    c.find("span").remove(), (i[d] = GFMergeTag.formatValue(c.text(), t)), c.remove();
                } else i[d] = GFMergeTag.formatValue(jQuery(l[d]).val(), t);
            f = i.join(", ");
        }
        return f;
    }),
        (GFMergeTag.replaceMergeTags = function (e, r) {
            var t = GFMergeTag.parseMergeTags(r);
            for (i in t)
                if (t.hasOwnProperty(i)) {
                    var n = t[i][1],
                        a = (parseInt(n, 10), null == t[i][3] ? "" : t[i][3].replace(":", "")),
                        o = GFMergeTag.getMergeTagValue(e, n, a);
                    r = r.replace(t[i][0], o);
                }
            return r;
        }),
        (GFMergeTag.formatValue = function (e, r) {
            var t = "";
            switch (((t = 1 < (e = e.split("|")).length && ("price" === r || "currency" === r) ? gformToNumber(e[1]) : e[0]), r)) {
                case "price":
                    t = !1 === (t = gformToNumber(t)) ? "" : t;
                    break;
                case "currency":
                    t = !1 === (t = gformFormatMoney(t, !1)) ? "" : t;
                    break;
                case "numeric":
                    return !1 === (t = gformToNumber(t)) ? 0 : t;
            }
            return t;
        }),
        (GFMergeTag.parseMergeTags = function (e, r) {
            void 0 === r && (r = /{[^{]*?:(\d+(\.\d+)?)(:(.*?))?}/i);
            for (var t = []; r.test(e); ) {
                var i = t.length;
                (t[i] = r.exec(e)), (e = e.replace("" + t[i][0], ""));
            }
            return t;
        });
};
new GFMergeTag();
var GFCalc = function (formId, formulaFields) {
    (this.formId = formId),
        (this.formulaFields = formulaFields),
        (this.exprPatt = /^[0-9 -/*\(\)]+$/i),
        (this.isCalculating = {}),
        (this.init = function (e, r) {
            var t = this;
            jQuery(document).bind("gform_post_conditional_logic", function () {
                t.runCalcs(e, r);
            });
            for (var i = 0; i < r.length; i++) {
                var n = jQuery.extend({}, r[i]);
                this.runCalc(n, e), this.bindCalcEvents(n, e);
            }
        }),
        (this.runCalc = function (formulaField, formId) {
            var calcObj = this,
                field = jQuery("#field_" + formId + "_" + formulaField.field_id),
                formulaInput = field.hasClass("gfield_price") ? jQuery("#ginput_base_price_" + formId + "_" + formulaField.field_id) : jQuery("#input_" + formId + "_" + formulaField.field_id),
                previous_val = formulaInput.val(),
                formula = gform.applyFilters("gform_calculation_formula", formulaField.formula, formulaField, formId, calcObj),
                expr = calcObj.replaceFieldTags(formId, formula, formulaField).replace(/(\r\n|\n|\r)/gm, ""),
                result = "";
            if (calcObj.exprPatt.test(expr))
                try {
                    result = eval(expr);
                } catch (e) {}
            isFinite(result) || (result = 0),
                window.gform_calculation_result &&
                    ((result = window.gform_calculation_result(result, formulaField, formId, calcObj)),
                    window.console && console.log('"gform_calculation_result" function is deprecated since version 1.8! Use "gform_calculation_result" JS hook instead.')),
                (result = gform.applyFilters("gform_calculation_result", result, formulaField, formId, calcObj));
            var formattedResult = gform.applyFilters("gform_calculation_format_result", !1, result, formulaField, formId, calcObj),
                numberFormat = gf_get_field_number_format(formulaField.field_id, formId);
            if (!1 !== formattedResult) result = formattedResult;
            else if (field.hasClass("gfield_price") || "currency" == numberFormat) result = gformFormatMoney(result || 0, !0);
            else {
                var decimalSeparator = ".",
                    thousandSeparator = ",";
                "decimal_comma" == numberFormat && ((decimalSeparator = ","), (thousandSeparator = ".")),
                    (result = gformFormatNumber(result, gformIsNumber(formulaField.rounding) ? formulaField.rounding : -1, decimalSeparator, thousandSeparator));
            }
            result != previous_val &&
                (field.hasClass("gfield_price")
                    ? (jQuery("#input_" + formId + "_" + formulaField.field_id).text(result), formulaInput.val(result).trigger("change"), gformCalculateTotalPrice(formId))
                    : formulaInput.val(result).trigger("change"));
        }),
        (this.runCalcs = function (e, r) {
            for (var t = 0; t < r.length; t++) {
                var i = jQuery.extend({}, r[t]);
                this.runCalc(i, e);
            }
        }),
        (this.bindCalcEvents = function (e, r) {
            var t = this,
                i = e.field_id,
                n = GFMergeTag.parseMergeTags(e.formula);
            for (var a in ((t.isCalculating[i] = !1), n))
                if (n.hasOwnProperty(a)) {
                    var o = n[a][1],
                        l = parseInt(o, 10),
                        f = jQuery("#field_" + r + "_" + l).find('input[name="input_' + o + '"], select[name="input_' + o + '"]');
                    "checkbox" == f.prop("type") || "radio" == f.prop("type")
                        ? jQuery(f).click(function () {
                              t.bindCalcEvent(o, e, r, 0);
                          })
                        : f.is("select") || "hidden" == f.prop("type")
                        ? jQuery(f).change(function () {
                              t.bindCalcEvent(o, e, r, 0);
                          })
                        : jQuery(f)
                              .keydown(function () {
                                  t.bindCalcEvent(o, e, r);
                              })
                              .change(function () {
                                  t.bindCalcEvent(o, e, r, 0);
                              }),
                        gform.doAction("gform_post_calculation_events", n[a], e, r, t);
                }
        }),
        (this.bindCalcEvent = function (e, r, t, i) {
            var n = this,
                a = r.field_id;
            (i = null == i ? 345 : i),
                n.isCalculating[a][e] && clearTimeout(n.isCalculating[a][e]),
                (n.isCalculating[a][e] = window.setTimeout(function () {
                    n.runCalc(r, t);
                }, i));
        }),
        (this.replaceFieldTags = function (e, r, t) {
            var n = GFMergeTag.parseMergeTags(r);
            for (i in n)
                if (n.hasOwnProperty(i)) {
                    var a = n[i][1],
                        o = parseInt(a, 10),
                        l = "value";
                    if (n[i][3]) l = n[i][3];
                    else {
                        var f = jQuery(".gfield_price input[name=input_" + o + "]").is("input[type=radio]"),
                            s = 0 < jQuery(".gfield_price select[name=input_" + o + "]").length,
                            d = jQuery('.gfield_price input[name="input_' + a + '"]').is("input[type=checkbox]");
                        (s || f || d) && (l = "price");
                    }
                    var c = !window.gf_check_field_rule || "show" == gf_check_field_rule(e, o, !0, ""),
                        u = c ? GFMergeTag.getMergeTagValue(e, a, l) : 0;
                    (u = gform.applyFilters("gform_merge_tag_value_pre_calculation", u, n[i], c, t, e)), (u = this.cleanNumber(u, e, o, t)), (r = r.replace(n[i][0], u));
                }
            return r;
        }),
        (this.cleanNumber = function (e, r, t, i) {
            var n = gf_get_field_number_format(t, r);
            return (e = (e = gformCleanNumber(e, "", "", gformGetDecimalSeparator((n = n || gf_get_field_number_format(i.field_id, r))))) || 0);
        }),
        this.init(formId, formulaFields);
};
function gformFormatNumber(e, r, t, i) {
    void 0 === t && (t = window.gf_global ? new Currency(gf_global.gf_currency_config).currency.decimal_separator : ".");
    void 0 === i && (i = window.gf_global ? new Currency(gf_global.gf_currency_config).currency.thousand_separator : ",");
    return new Currency().numberFormat(e, r, t, i, !1);
}
function getMatchGroups(e, r) {
    for (var t = new Array(); r.test(e); ) {
        var i = t.length;
        (t[i] = r.exec(e)), (e = e.replace("" + t[i][0], ""));
    }
    return t;
}
function gf_get_field_number_format(e, r, t) {
    var i = rgars(window, "gf_global/number_formats/{0}/{1}".format(r, e)),
        n = !1;
    return "" === i ? n : (n = void 0 === t ? (!1 !== i.price ? i.price : i.value) : i[t]);
}
var gform = {
        hooks: { action: {}, filter: {} },
        addAction: function (e, r, t, i) {
            gform.addHook("action", e, r, t, i);
        },
        addFilter: function (e, r, t, i) {
            gform.addHook("filter", e, r, t, i);
        },
        doAction: function (e) {
            gform.doHook("action", e, arguments);
        },
        applyFilters: function (e) {
            return gform.doHook("filter", e, arguments);
        },
        removeAction: function (e, r) {
            gform.removeHook("action", e, r);
        },
        removeFilter: function (e, r, t) {
            gform.removeHook("filter", e, r, t);
        },
        addHook: function (e, r, t, i, n) {
            null == gform.hooks[e][r] && (gform.hooks[e][r] = []);
            var a = gform.hooks[e][r];
            null == n && (n = r + "_" + a.length), null == i && (i = 10), gform.hooks[e][r].push({ tag: n, callable: t, priority: i });
        },
        doHook: function (e, r, t) {
            if (((t = Array.prototype.slice.call(t, 1)), null != gform.hooks[e][r])) {
                var i,
                    n = gform.hooks[e][r];
                n.sort(function (e, r) {
                    return e.priority - r.priority;
                });
                for (var a = 0; a < n.length; a++) "function" != typeof (i = n[a].callable) && (i = window[i]), "action" == e ? i.apply(null, t) : (t[0] = i.apply(null, t));
            }
            if ("filter" == e) return t[0];
        },
        removeHook: function (e, r, t, i) {
            if (null != gform.hooks[e][r]) for (var n = gform.hooks[e][r], a = n.length - 1; 0 <= a; a--) (null != i && i != n[a].tag) || (null != t && t != n[a].priority) || n.splice(a, 1);
        },
    },
    __gf_keyup_timeout;
function renderRecaptcha() {
    jQuery(".ginput_recaptcha").each(function () {
        var r = jQuery(this),
            e = { sitekey: r.data("sitekey"), theme: r.data("theme"), tabindex: r.data("tabindex") };
        if (r.is(":empty")) {
            r.data("stoken") && (e.stoken = r.data("stoken"));
            var t = !1;
            "invisible" == r.data("size") &&
                (t = function (e) {
                    e && r.closest("form").submit();
                }),
                (t = gform.applyFilters("gform_recaptcha_callback", t, r)) && (e.callback = t),
                r.data("widget-id", grecaptcha.render(this.id, e)),
                e.tabindex && r.find("iframe").attr("tabindex", e.tabindex),
                gform.doAction("gform_post_recaptcha_render", r);
        }
    });
}
function gformIsRecaptchaPending(e) {
    var r,
        t = e.find(".ginput_recaptcha");
    return !(!t.length || "invisible" !== t.data("size")) && !((r = t.find(".g-recaptcha-response")).length && r.val());
}
function gformValidateFileSize(e, r) {
    var t;
    if (
        ((t = 0 < jQuery(e).closest("div").siblings(".validation_message").length ? jQuery(e).closest("div").siblings(".validation_message") : jQuery(e).siblings(".validation_message")),
        window.FileReader && window.File && window.FileList && window.Blob)
    ) {
        var i = e.files[0];
        i && i.size > r ? t.text(i.name + " - " + gform_gravityforms.strings.file_exceeds_limit) : t.text("");
    }
}
function gformInitSpinner(e, r) {
    jQuery("#gform_" + e).submit(function () {
        gformAddSpinner(e, r);
    });
}
function gformAddSpinner(e, r) {
    (void 0 !== r && r) || (r = gform.applyFilters("gform_spinner_url", gf_global.spinnerUrl, e)),
        0 == jQuery("#gform_ajax_spinner_" + e).length &&
            gform
                .applyFilters("gform_spinner_target_elem", jQuery("#gform_submit_button_" + e + ", #gform_wrapper_" + e + " .gform_next_button, #gform_send_resume_link_button_" + e), e)
                .after('<img id="gform_ajax_spinner_' + e + '"  class="gform_ajax_spinner" src="' + r + '" alt="" />');
}
function gf_raw_input_change(e, r) {
    clearTimeout(__gf_keyup_timeout);
    var t = jQuery(r),
        i = t.attr("id"),
        n = gf_get_input_id_by_html_id(i),
        a = gf_get_form_id_by_html_id(i),
        o = gform.applyFilters("gform_field_meta_raw_input_change", { fieldId: n, formId: a }, t, e);
    if (((n = o.fieldId), (a = o.formId), n)) {
        var l = t.is(":checkbox") || t.is(":radio") || t.is("select"),
            f = !l || t.is("textarea");
        ("keyup" == e.type && !f) ||
            ("change" == e.type && !l && !f) ||
            ("keyup" == e.type
                ? (__gf_keyup_timeout = setTimeout(function () {
                      gf_input_change(r, a, n);
                  }, 300))
                : gf_input_change(r, a, n));
    }
}
function gf_get_input_id_by_html_id(e) {
    var r = gf_get_ids_by_html_id(e),
        t = r[r.length - 1];
    return 3 == r.length && (r.shift(), (t = r.join("."))), t;
}
function gf_get_form_id_by_html_id(e) {
    return gf_get_ids_by_html_id(e)[0];
}
function gf_get_ids_by_html_id(e) {
    for (var r = e ? e.split("_") : [], t = r.length - 1; 0 <= t; t--) gformIsNumber(r[t]) || r.splice(t, 1);
    return r;
}
function gf_input_change(e, r, t) {
    gform.doAction("gform_input_change", e, r, t);
}
function gformExtractFieldId(e) {
    var r = parseInt(e.toString().split(".")[0], 10);
    return r || e;
}
function gformExtractInputIndex(e) {
    var r = parseInt(e.toString().split(".")[1], 10);
    return r || !1;
}
if (
    (!(function (h, y) {
        h.uploaders = {};
        var v = "undefined" != typeof gform_gravityforms ? gform_gravityforms.strings : {},
            b = "undefined" != typeof gform_gravityforms ? gform_gravityforms.vars.images_url : "";
        function i(e) {
            var d,
                i,
                r = y(e).data("settings"),
                t = new plupload.Uploader(r);
            function c(e, r) {
                y("#" + e).prepend("<li>" + F(r) + "</li>");
            }
            function u(e) {
                var r,
                    t,
                    i = parseInt(e.gf_vars.max_files, 10);
                if (0 < i) {
                    var n = i <= m(e.multipart_params.field_id);
                    h.toggleDisabled(e, n), n || ((r = e.gf_vars.message_id), (t = v.max_reached), y("#" + r + " li:contains('" + t + "')").remove());
                }
            }
            function g() {
                var e;
                return (e = void 0 === (e = y("#gform_uploaded_files_" + d).val()) || "" === e ? {} : y.parseJSON(e));
            }
            function _(e) {
                var r = g(),
                    t = p(e);
                return void 0 === r[t] && (r[t] = []), r[t];
            }
            function m(e) {
                return _(e).length;
            }
            function p(e) {
                return "input_" + e;
            }
            function n(e) {
                e.preventDefault();
            }
            (d = t.settings.multipart_params.form_id),
                (h.uploaders[r.container] = t).bind("Init", function (e, r) {
                    e.features.dragdrop || y(".gform_drop_instructions").hide(), u(e.settings);
                }),
                (h.toggleDisabled = function (e, r) {
                    ("string" == typeof e.browse_button ? y("#" + e.browse_button) : y(e.browse_button)).prop("disabled", r);
                }),
                t.init(),
                t.bind("BeforeUpload", function (e, r) {
                    e.settings.multipart_params.original_filename = r.name;
                }),
                t.bind("FilesAdded", function (a, e) {
                    var o,
                        l = parseInt(a.settings.gf_vars.max_files, 10),
                        f = m(a.settings.multipart_params.field_id),
                        s = a.settings.gf_vars.disallowed_extensions;
                    if (0 < l && l <= f)
                        y.each(e, function (e, r) {
                            a.removeFile(r);
                        });
                    else {
                        y.each(e, function (e, r) {
                            if (((o = r.name.split(".").pop()), -1 < y.inArray(o, s))) return c(a.settings.gf_vars.message_id, r.name + " - " + v.illegal_extension), void a.removeFile(r);
                            if (r.status == plupload.FAILED || (0 < l && l <= f)) a.removeFile(r);
                            else {
                                var t = void 0 !== r.size ? plupload.formatSize(r.size) : v.in_progress,
                                    i =
                                        "$this=jQuery(this); var uploader = gfMultiFileUploader.uploaders." +
                                        a.settings.container.id +
                                        ";uploader.stop();uploader.removeFile(uploader.getFile('" +
                                        r.id +
                                        "'));$this.after('" +
                                        v.cancelled +
                                        "'); uploader.start();$this.remove();",
                                    n = '<div id="{0}" class="ginput_preview">{1} ({2}) <b></b> <a href="javascript:void(0)" title="{3}" onclick="{4}" onkeypress="{4}">{5}</a></div>';
                                (n = gform.applyFilters("gform_file_upload_status_markup", n, r, t, v, i, a).format(r.id, F(r.name), t, v.cancel_upload, i, v.cancel)), y("#" + a.settings.filelist).prepend(n), f++;
                            }
                        }),
                            a.refresh();
                        var r = "input:hidden[name='gform_unique_id']",
                            t = y("form#gform_" + d + " " + r);
                        0 == t.length && (t = y(r)),
                            "" === (i = t.val()) &&
                                ((i = "xxxxxxxx".replace(/[xy]/g, function (e) {
                                    var r = (16 * Math.random()) | 0;
                                    return ("x" == e ? r : (3 & r) | 8).toString(16);
                                })),
                                t.val(i)),
                            0 < l && l <= f && (h.toggleDisabled(a.settings, !0), c(a.settings.gf_vars.message_id, v.max_reached)),
                            (a.settings.multipart_params.gform_unique_id = i),
                            a.start();
                    }
                }),
                t.bind("UploadProgress", function (e, r) {
                    var t = r.percent + "%";
                    y("#" + r.id + " b").html(t);
                }),
                t.bind("Error", function (e, r) {
                    if (r.code === plupload.FILE_EXTENSION_ERROR) {
                        var t = void 0 !== e.settings.filters.mime_types ? e.settings.filters.mime_types[0].extensions : e.settings.filters[0].extensions;
                        c(e.settings.gf_vars.message_id, r.file.name + " - " + v.invalid_file_extension + " " + t);
                    } else if (r.code === plupload.FILE_SIZE_ERROR) c(e.settings.gf_vars.message_id, r.file.name + " - " + v.file_exceeds_limit);
                    else {
                        var i = "Error: " + r.code + ", Message: " + r.message + (r.file ? ", File: " + r.file.name : "");
                        c(e.settings.gf_vars.message_id, i);
                    }
                    y("#" + r.file.id).html(""), e.refresh();
                }),
                t.bind("ChunkUploaded", function (e, r, t) {
                    var i = y.secureEvalJSON(t.response);
                    "error" == i.status && (e.removeFile(r), c(e.settings.gf_vars.message_id, r.name + " - " + i.error.message), y("#" + r.id).html(""));
                }),
                t.bind("FileUploaded", function (e, r, t) {
                    if (e.getFile(r.id)) {
                        var i = y.secureEvalJSON(t.response);
                        if ("error" == i.status) return c(e.settings.gf_vars.message_id, r.name + " - " + i.error.message), y("#" + r.id).html(""), void u(e.settings);
                        var n,
                            a,
                            o,
                            l = "<strong>" + F(r.name) + "</strong>",
                            f = e.settings.multipart_params.form_id,
                            s = e.settings.multipart_params.field_id;
                        (l =
                            "<img class='gform_delete' src='" +
                            b +
                            "/delete.png' onclick='gformDeleteUploadedFile(" +
                            f +
                            "," +
                            s +
                            ", this);' onkeypress='gformDeleteUploadedFile(" +
                            f +
                            "," +
                            s +
                            ", this);' alt='" +
                            v.delete_file +
                            "' title='" +
                            v.delete_file +
                            "' /> " +
                            l),
                            (l = gform.applyFilters("gform_file_upload_markup", l, r, e, v, b, i)),
                            y("#" + r.id).html(l),
                            100 == r.percent &&
                                (i.status && "ok" == i.status
                                    ? ((n = s),
                                      (a = i.data),
                                      (o = _(n)).unshift(a),
                                      (function (e, r) {
                                          var t = g(),
                                              i = y("#gform_uploaded_files_" + d),
                                              n = p(e);
                                          (t[n] = r), i.val(y.toJSON(t));
                                      })(n, o))
                                    : c(e.settings.gf_vars.message_id, v.unknown_error + ": " + r.name));
                    }
                }),
                t.bind("FilesRemoved", function (e, r) {
                    u(e.settings);
                }),
                y("#" + r.drop_element).on({ dragenter: n, dragover: n });
        }
        function F(e) {
            return y("<div/>").text(e).html();
        }
        y(document).bind("gform_post_render", function (e, r) {
            y("form#gform_" + r + " .gform_fileupload_multifile").each(function () {
                i(this);
            });
            var t = y("form#gform_" + r);
            0 < t.length &&
                t.submit(function () {
                    var t = !1;
                    if (
                        (y.each(h.uploaders, function (e, r) {
                            if (0 < r.total.queued) return !(t = !0);
                        }),
                        t)
                    )
                        return alert(v.currently_uploading), (window["gf_submitting_" + r] = !1), y("#gform_ajax_spinner_" + r).remove(), !1;
                });
        }),
            y(document).bind("gform_post_conditional_logic", function (e, r, t, i) {
                i ||
                    y.each(h.uploaders, function (e, r) {
                        r.refresh();
                    });
            }),
            y(document).ready(function () {
                ("undefined" != typeof adminpage && "toplevel_page_gf_edit_forms" === adminpage) || "undefined" == typeof plupload
                    ? y(".gform_button_select_files").prop("disabled", !0)
                    : "undefined" != typeof adminpage &&
                      -1 < adminpage.indexOf("_page_gf_entries") &&
                      y(".gform_fileupload_multifile").each(function () {
                          i(this);
                      });
            }),
            (h.setup = function (e) {
                i(e);
            });
    })((window.gfMultiFileUploader = window.gfMultiFileUploader || {}), jQuery),
    jQuery(document).on("change keyup", ".gfield input, .gfield select, .gfield textarea", function (e) {
        gf_raw_input_change(e, this);
    }),
    jQuery(document).on("submit.gravityforms", ".gform_wrapper form", function (e) {
        var r,
            t = jQuery(this).closest(".gform_wrapper"),
            i = t.attr("id").split("_")[2],
            n = 0 < t.find(".gform_page").length,
            a = parseInt(t.find('input[name^="gform_source_page_number_"]').val(), 10),
            o = parseInt(t.find('input[name^="gform_target_page_number_"]').val(), 10),
            l = 0 === o,
            f = !l && a < o,
            s = "1" === jQuery("#gform_save_" + i).val();
        if (n) {
            var d = f ? "next" : "submit";
            r = t.find(".gform_page:visible").find('.gform_page_footer [id^="gform_' + d + '_button_"]');
        } else r = t.find("#gform_submit_button_" + i);
        var c = !r.is(":visible");
        if (!s && (l || f) && c) (window["gf_submitting_" + i] = !1), t.find(".gform_ajax_spinner").remove(), e.preventDefault();
        else if (l || l) {
            var u = t.find(".ginput_recaptcha");
            if (0 !== u.length && "invisible" === u.data("size")) {
                var g = t.find('input[name="g-recaptcha-response"]');
                0 === g.length && (g = u.find(".g-recaptcha-response")), g.val() || (grecaptcha.execute(u.data("widget-id")), (window["gf_submitting_" + i] = !1), e.preventDefault());
            }
        }
    }),
    !window.rgars)
)
    function rgars(e, r) {
        for (var t = r.split("/"), i = e, n = 0; n < t.length; n++) i = rgar(i, t[n]);
        return i;
    }
if (!window.rgar)
    function rgar(e, r) {
        return void 0 !== e[r] ? e[r] : "";
    }
String.prototype.format = function () {
    var t = arguments;
    return this.replace(/{(\d+)}/g, function (e, r) {
        return void 0 !== t[r] ? t[r] : e;
    });
};

(function (t) {
    "use strict";
    function e(t, e, r) {
        return t.addEventListener ? t.addEventListener(e, r, !1) : t.attachEvent ? t.attachEvent("on" + e, r) : void 0;
    }
    function r(t, e) {
        var r, n;
        for (r = 0, n = t.length; n > r; r++) if (t[r] === e) return !0;
        return !1;
    }
    function n(t, e) {
        var r;
        t.createTextRange ? ((r = t.createTextRange()), r.move("character", e), r.select()) : t.selectionStart && (t.focus(), t.setSelectionRange(e, e));
    }
    function a(t, e) {
        try {
            return (t.type = e), !0;
        } catch (r) {
            return !1;
        }
    }
    t.Placeholders = { Utils: { addEventListener: e, inArray: r, moveCaret: n, changeType: a } };
})(this),
    (function (t) {
        "use strict";
        function e() {}
        function r() {
            try {
                return document.activeElement;
            } catch (t) {}
        }
        function n(t, e) {
            var r,
                n,
                a = !!e && t.value !== e,
                u = t.value === t.getAttribute(V);
            return (a || u) && "true" === t.getAttribute(P)
                ? (t.removeAttribute(P),
                  (t.value = t.value.replace(t.getAttribute(V), "")),
                  (t.className = t.className.replace(R, "")),
                  (n = t.getAttribute(z)),
                  parseInt(n, 10) >= 0 && (t.setAttribute("maxLength", n), t.removeAttribute(z)),
                  (r = t.getAttribute(D)),
                  r && (t.type = r),
                  !0)
                : !1;
        }
        function a(t) {
            var e,
                r,
                n = t.getAttribute(V);
            return "" === t.value && n
                ? (t.setAttribute(P, "true"),
                  (t.value = n),
                  (t.className += " " + I),
                  (r = t.getAttribute(z)),
                  r || (t.setAttribute(z, t.maxLength), t.removeAttribute("maxLength")),
                  (e = t.getAttribute(D)),
                  e ? (t.type = "text") : "password" === t.type && K.changeType(t, "text") && t.setAttribute(D, "password"),
                  !0)
                : !1;
        }
        function u(t, e) {
            var r, n, a, u, i, l, o;
            if (t && t.getAttribute(V)) e(t);
            else for (a = t ? t.getElementsByTagName("input") : f, u = t ? t.getElementsByTagName("textarea") : h, r = a ? a.length : 0, n = u ? u.length : 0, o = 0, l = r + n; l > o; o++) (i = r > o ? a[o] : u[o - r]), e(i);
        }
        function i(t) {
            u(t, n);
        }
        function l(t) {
            u(t, a);
        }
        function o(t) {
            return function () {
                b && t.value === t.getAttribute(V) && "true" === t.getAttribute(P) ? K.moveCaret(t, 0) : n(t);
            };
        }
        function c(t) {
            return function () {
                a(t);
            };
        }
        function s(t) {
            return function (e) {
                return (A = t.value), "true" === t.getAttribute(P) && A === t.getAttribute(V) && K.inArray(C, e.keyCode) ? (e.preventDefault && e.preventDefault(), !1) : void 0;
            };
        }
        function d(t) {
            return function () {
                n(t, A), "" === t.value && (t.blur(), K.moveCaret(t, 0));
            };
        }
        function v(t) {
            return function () {
                t === r() && t.value === t.getAttribute(V) && "true" === t.getAttribute(P) && K.moveCaret(t, 0);
            };
        }
        function g(t) {
            return function () {
                i(t);
            };
        }
        function p(t) {
            t.form && ((T = t.form), "string" == typeof T && (T = document.getElementById(T)), T.getAttribute(U) || (K.addEventListener(T, "submit", g(T)), T.setAttribute(U, "true"))),
                K.addEventListener(t, "focus", o(t)),
                K.addEventListener(t, "blur", c(t)),
                b && (K.addEventListener(t, "keydown", s(t)), K.addEventListener(t, "keyup", d(t)), K.addEventListener(t, "click", v(t))),
                t.setAttribute(j, "true"),
                t.setAttribute(V, x),
                (b || t !== r()) && a(t);
        }
        var f,
            h,
            b,
            m,
            A,
            y,
            E,
            x,
            L,
            T,
            S,
            N,
            w,
            B = ["text", "search", "url", "tel", "email", "password", "number", "textarea"],
            C = [27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46],
            k = "#ccc",
            I = "placeholdersjs",
            R = RegExp("(?:^|\\s)" + I + "(?!\\S)"),
            V = "data-placeholder-value",
            P = "data-placeholder-active",
            D = "data-placeholder-type",
            U = "data-placeholder-submit",
            j = "data-placeholder-bound",
            q = "data-placeholder-focus",
            Q = "data-placeholder-live",
            z = "data-placeholder-maxlength",
            F = document.createElement("input"),
            G = document.getElementsByTagName("head")[0],
            H = document.documentElement,
            J = t.Placeholders,
            K = J.Utils;
        if (((J.nativeSupport = void 0 !== F.placeholder), !J.nativeSupport)) {
            for (
                f = document.getElementsByTagName("input"),
                    h = document.getElementsByTagName("textarea"),
                    b = "false" === H.getAttribute(q),
                    m = "false" !== H.getAttribute(Q),
                    y = document.createElement("style"),
                    y.type = "text/css",
                    E = document.createTextNode("." + I + " { color:" + k + "; }"),
                    y.styleSheet ? (y.styleSheet.cssText = E.nodeValue) : y.appendChild(E),
                    G.insertBefore(y, G.firstChild),
                    w = 0,
                    N = f.length + h.length;
                N > w;
                w++
            )
                (S = f.length > w ? f[w] : h[w - f.length]), (x = S.attributes.placeholder), x && ((x = x.nodeValue), x && K.inArray(B, S.type) && p(S));
            L = setInterval(function () {
                for (w = 0, N = f.length + h.length; N > w; w++)
                    (S = f.length > w ? f[w] : h[w - f.length]),
                        (x = S.attributes.placeholder),
                        x
                            ? ((x = x.nodeValue),
                              x &&
                                  K.inArray(B, S.type) &&
                                  (S.getAttribute(j) || p(S),
                                  (x !== S.getAttribute(V) || ("password" === S.type && !S.getAttribute(D))) &&
                                      ("password" === S.type && !S.getAttribute(D) && K.changeType(S, "text") && S.setAttribute(D, "password"), S.value === S.getAttribute(V) && (S.value = x), S.setAttribute(V, x))))
                            : S.getAttribute(P) && (n(S), S.removeAttribute(V));
                m || clearInterval(L);
            }, 100);
        }
        K.addEventListener(t, "beforeunload", function () {
            J.disable();
        }),
            (J.disable = J.nativeSupport ? e : i),
            (J.enable = J.nativeSupport ? e : l);
    })(this),
    (function (t) {
        "use strict";
        var e = t.fn.val,
            r = t.fn.prop;
        Placeholders.nativeSupport ||
            ((t.fn.val = function (t) {
                var r = e.apply(this, arguments),
                    n = this.eq(0).data("placeholder-value");
                return void 0 === t && this.eq(0).data("placeholder-active") && r === n ? "" : r;
            }),
            (t.fn.prop = function (t, e) {
                return void 0 === e && this.eq(0).data("placeholder-active") && "value" === t ? "" : r.apply(this, arguments);
            }));
    })(jQuery);
var woocommerce_multi_currency_switcher = {
    use_session: 0,
    ajax_url: "",
    init: function () {
        jQuery("body").on("click", ".wmc-currency-redirect", function (e) {
            e.stopPropagation();
            e.preventDefault();
            let $switcher = jQuery(this),
                $wmc = $switcher.closest(".woocommerce-multi-currency");
            if (!$wmc.hasClass("wmc-currency-loading")) {
                let currency = $switcher.data("currency");
                if (currency) {
                    $wmc.addClass("wmc-currency-loading");
                    wmcSwitchCurrency(currency);
                }
            }
        });
        jQuery(".wmc-select-currency-js").on("change", function (e) {
            e.preventDefault();
            let $switcher = jQuery(this),
                $wmc = $switcher.closest(".woocommerce-multi-currency");
            if (!$wmc.hasClass("wmc-currency-loading")) {
                let currency = $switcher.val();
                if (currency) {
                    $wmc.addClass("wmc-currency-loading").prop("disabled", true);
                    wmcSwitchCurrency(currency);
                }
            }
        });
    },
    setCookie: function (cname, cvalue, expire) {
        var d = new Date();
        d.setTime(d.getTime() + expire * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    reload: function () {
        let url = new URL(window.location.href);
        url.searchParams.delete("wmc-currency");
        window.location.href = url.href.replace(url.hash, "");
    },
};

!(function (n, e) {
    "object" == typeof exports && "undefined" != typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : (n.anime = e());
})(this, function () {
    "use strict";
    var n = { update: null, begin: null, loopBegin: null, changeBegin: null, change: null, changeComplete: null, loopComplete: null, complete: null, loop: 1, direction: "normal", autoplay: !0, timelineOffset: 0 },
        e = { duration: 1e3, delay: 0, endDelay: 0, easing: "easeOutElastic(1, .5)", round: 0 },
        t = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"],
        r = { CSS: {}, springs: {} };
    function a(n, e, t) {
        return Math.min(Math.max(n, e), t);
    }
    function o(n, e) {
        return n.indexOf(e) > -1;
    }
    function u(n, e) {
        return n.apply(null, e);
    }
    var i = {
        arr: function (n) {
            return Array.isArray(n);
        },
        obj: function (n) {
            return o(Object.prototype.toString.call(n), "Object");
        },
        pth: function (n) {
            return i.obj(n) && n.hasOwnProperty("totalLength");
        },
        svg: function (n) {
            return n instanceof SVGElement;
        },
        inp: function (n) {
            return n instanceof HTMLInputElement;
        },
        dom: function (n) {
            return n.nodeType || i.svg(n);
        },
        str: function (n) {
            return "string" == typeof n;
        },
        fnc: function (n) {
            return "function" == typeof n;
        },
        und: function (n) {
            return void 0 === n;
        },
        nil: function (n) {
            return i.und(n) || null === n;
        },
        hex: function (n) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n);
        },
        rgb: function (n) {
            return /^rgb/.test(n);
        },
        hsl: function (n) {
            return /^hsl/.test(n);
        },
        col: function (n) {
            return i.hex(n) || i.rgb(n) || i.hsl(n);
        },
        key: function (t) {
            return !n.hasOwnProperty(t) && !e.hasOwnProperty(t) && "targets" !== t && "keyframes" !== t;
        },
    };
    function c(n) {
        var e = /\(([^)]+)\)/.exec(n);
        return e
            ? e[1].split(",").map(function (n) {
                  return parseFloat(n);
              })
            : [];
    }
    function s(n, e) {
        var t = c(n),
            o = a(i.und(t[0]) ? 1 : t[0], 0.1, 100),
            u = a(i.und(t[1]) ? 100 : t[1], 0.1, 100),
            s = a(i.und(t[2]) ? 10 : t[2], 0.1, 100),
            f = a(i.und(t[3]) ? 0 : t[3], 0.1, 100),
            l = Math.sqrt(u / o),
            d = s / (2 * Math.sqrt(u * o)),
            p = d < 1 ? l * Math.sqrt(1 - d * d) : 0,
            v = 1,
            h = d < 1 ? (d * l - f) / p : -f + l;
        function g(n) {
            var t = e ? (e * n) / 1e3 : n;
            return (t = d < 1 ? Math.exp(-t * d * l) * (v * Math.cos(p * t) + h * Math.sin(p * t)) : (v + h * t) * Math.exp(-t * l)), 0 === n || 1 === n ? n : 1 - t;
        }
        return e
            ? g
            : function () {
                  var e = r.springs[n];
                  if (e) return e;
                  for (var t = 0, a = 0; ; )
                      if (1 === g((t += 1 / 6))) {
                          if (++a >= 16) break;
                      } else a = 0;
                  var o = t * (1 / 6) * 1e3;
                  return (r.springs[n] = o), o;
              };
    }
    function f(n) {
        return (
            void 0 === n && (n = 10),
            function (e) {
                return Math.ceil(a(e, 1e-6, 1) * n) * (1 / n);
            }
        );
    }
    var l,
        d,
        p = (function () {
            var n = 11,
                e = 1 / (n - 1);
            function t(n, e) {
                return 1 - 3 * e + 3 * n;
            }
            function r(n, e) {
                return 3 * e - 6 * n;
            }
            function a(n) {
                return 3 * n;
            }
            function o(n, e, o) {
                return ((t(e, o) * n + r(e, o)) * n + a(e)) * n;
            }
            function u(n, e, o) {
                return 3 * t(e, o) * n * n + 2 * r(e, o) * n + a(e);
            }
            return function (t, r, a, i) {
                if (0 <= t && t <= 1 && 0 <= a && a <= 1) {
                    var c = new Float32Array(n);
                    if (t !== r || a !== i) for (var s = 0; s < n; ++s) c[s] = o(s * e, t, a);
                    return function (n) {
                        return t === r && a === i ? n : 0 === n || 1 === n ? n : o(f(n), r, i);
                    };
                }
                function f(r) {
                    for (var i = 0, s = 1, f = n - 1; s !== f && c[s] <= r; ++s) i += e;
                    var l = i + ((r - c[--s]) / (c[s + 1] - c[s])) * e,
                        d = u(l, t, a);
                    return d >= 0.001
                        ? (function (n, e, t, r) {
                              for (var a = 0; a < 4; ++a) {
                                  var i = u(e, t, r);
                                  if (0 === i) return e;
                                  e -= (o(e, t, r) - n) / i;
                              }
                              return e;
                          })(r, l, t, a)
                        : 0 === d
                        ? l
                        : (function (n, e, t, r, a) {
                              for (var u, i, c = 0; (u = o((i = e + (t - e) / 2), r, a) - n) > 0 ? (t = i) : (e = i), Math.abs(u) > 1e-7 && ++c < 10; );
                              return i;
                          })(r, i, i + e, t, a);
                }
            };
        })(),
        v =
            ((l = {
                linear: function () {
                    return function (n) {
                        return n;
                    };
                },
            }),
            (d = {
                Sine: function () {
                    return function (n) {
                        return 1 - Math.cos((n * Math.PI) / 2);
                    };
                },
                Circ: function () {
                    return function (n) {
                        return 1 - Math.sqrt(1 - n * n);
                    };
                },
                Back: function () {
                    return function (n) {
                        return n * n * (3 * n - 2);
                    };
                },
                Bounce: function () {
                    return function (n) {
                        for (var e, t = 4; n < ((e = Math.pow(2, --t)) - 1) / 11; );
                        return 1 / Math.pow(4, 3 - t) - 7.5625 * Math.pow((3 * e - 2) / 22 - n, 2);
                    };
                },
                Elastic: function (n, e) {
                    void 0 === n && (n = 1), void 0 === e && (e = 0.5);
                    var t = a(n, 1, 10),
                        r = a(e, 0.1, 2);
                    return function (n) {
                        return 0 === n || 1 === n ? n : -t * Math.pow(2, 10 * (n - 1)) * Math.sin(((n - 1 - (r / (2 * Math.PI)) * Math.asin(1 / t)) * (2 * Math.PI)) / r);
                    };
                },
            }),
            ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function (n, e) {
                d[n] = function () {
                    return function (n) {
                        return Math.pow(n, e + 2);
                    };
                };
            }),
            Object.keys(d).forEach(function (n) {
                var e = d[n];
                (l["easeIn" + n] = e),
                    (l["easeOut" + n] = function (n, t) {
                        return function (r) {
                            return 1 - e(n, t)(1 - r);
                        };
                    }),
                    (l["easeInOut" + n] = function (n, t) {
                        return function (r) {
                            return r < 0.5 ? e(n, t)(2 * r) / 2 : 1 - e(n, t)(-2 * r + 2) / 2;
                        };
                    }),
                    (l["easeOutIn" + n] = function (n, t) {
                        return function (r) {
                            return r < 0.5 ? (1 - e(n, t)(1 - 2 * r)) / 2 : (e(n, t)(2 * r - 1) + 1) / 2;
                        };
                    });
            }),
            l);
    function h(n, e) {
        if (i.fnc(n)) return n;
        var t = n.split("(")[0],
            r = v[t],
            a = c(n);
        switch (t) {
            case "spring":
                return s(n, e);
            case "cubicBezier":
                return u(p, a);
            case "steps":
                return u(f, a);
            default:
                return u(r, a);
        }
    }
    function g(n) {
        try {
            return document.querySelectorAll(n);
        } catch (n) {
            return;
        }
    }
    function m(n, e) {
        for (var t = n.length, r = arguments.length >= 2 ? arguments[1] : void 0, a = [], o = 0; o < t; o++)
            if (o in n) {
                var u = n[o];
                e.call(r, u, o, n) && a.push(u);
            }
        return a;
    }
    function y(n) {
        return n.reduce(function (n, e) {
            return n.concat(i.arr(e) ? y(e) : e);
        }, []);
    }
    function b(n) {
        return i.arr(n) ? n : (i.str(n) && (n = g(n) || n), n instanceof NodeList || n instanceof HTMLCollection ? [].slice.call(n) : [n]);
    }
    function M(n, e) {
        return n.some(function (n) {
            return n === e;
        });
    }
    function x(n) {
        var e = {};
        for (var t in n) e[t] = n[t];
        return e;
    }
    function w(n, e) {
        var t = x(n);
        for (var r in n) t[r] = e.hasOwnProperty(r) ? e[r] : n[r];
        return t;
    }
    function k(n, e) {
        var t = x(n);
        for (var r in e) t[r] = i.und(n[r]) ? e[r] : n[r];
        return t;
    }
    function O(n) {
        return i.rgb(n)
            ? (t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec((e = n)))
                ? "rgba(" + t[1] + ",1)"
                : e
            : i.hex(n)
            ? ((r = n.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (n, e, t, r) {
                  return e + e + t + t + r + r;
              })),
              (a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r)),
              "rgba(" + parseInt(a[1], 16) + "," + parseInt(a[2], 16) + "," + parseInt(a[3], 16) + ",1)")
            : i.hsl(n)
            ? (function (n) {
                  var e,
                      t,
                      r,
                      a = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(n) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(n),
                      o = parseInt(a[1], 10) / 360,
                      u = parseInt(a[2], 10) / 100,
                      i = parseInt(a[3], 10) / 100,
                      c = a[4] || 1;
                  function s(n, e, t) {
                      return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? n + 6 * (e - n) * t : t < 0.5 ? e : t < 2 / 3 ? n + (e - n) * (2 / 3 - t) * 6 : n;
                  }
                  if (0 == u) e = t = r = i;
                  else {
                      var f = i < 0.5 ? i * (1 + u) : i + u - i * u,
                          l = 2 * i - f;
                      (e = s(l, f, o + 1 / 3)), (t = s(l, f, o)), (r = s(l, f, o - 1 / 3));
                  }
                  return "rgba(" + 255 * e + "," + 255 * t + "," + 255 * r + "," + c + ")";
              })(n)
            : void 0;
        var e, t, r, a;
    }
    function C(n) {
        var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(n);
        if (e) return e[1];
    }
    function P(n, e) {
        return i.fnc(n) ? n(e.target, e.id, e.total) : n;
    }
    function I(n, e) {
        return n.getAttribute(e);
    }
    function D(n, e, t) {
        if (M([t, "deg", "rad", "turn"], C(e))) return e;
        var a = r.CSS[e + t];
        if (!i.und(a)) return a;
        var o = document.createElement(n.tagName),
            u = n.parentNode && n.parentNode !== document ? n.parentNode : document.body;
        u.appendChild(o), (o.style.position = "absolute"), (o.style.width = 100 + t);
        var c = 100 / o.offsetWidth;
        u.removeChild(o);
        var s = c * parseFloat(e);
        return (r.CSS[e + t] = s), s;
    }
    function B(n, e, t) {
        if (e in n.style) {
            var r = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(),
                a = n.style[e] || getComputedStyle(n).getPropertyValue(r) || "0";
            return t ? D(n, a, t) : a;
        }
    }
    function T(n, e) {
        return i.dom(n) && !i.inp(n) && (!i.nil(I(n, e)) || (i.svg(n) && n[e])) ? "attribute" : i.dom(n) && M(t, e) ? "transform" : i.dom(n) && "transform" !== e && B(n, e) ? "css" : null != n[e] ? "object" : void 0;
    }
    function E(n) {
        if (i.dom(n)) {
            for (var e, t = n.style.transform || "", r = /(\w+)\(([^)]*)\)/g, a = new Map(); (e = r.exec(t)); ) a.set(e[1], e[2]);
            return a;
        }
    }
    function F(n, e, t, r) {
        var a,
            u = o(e, "scale") ? 1 : 0 + (o((a = e), "translate") || "perspective" === a ? "px" : o(a, "rotate") || o(a, "skew") ? "deg" : void 0),
            i = E(n).get(e) || u;
        return t && (t.transforms.list.set(e, i), (t.transforms.last = e)), r ? D(n, i, r) : i;
    }
    function A(n, e, t, r) {
        switch (T(n, e)) {
            case "transform":
                return F(n, e, r, t);
            case "css":
                return B(n, e, t);
            case "attribute":
                return I(n, e);
            default:
                return n[e] || 0;
        }
    }
    function N(n, e) {
        var t = /^(\*=|\+=|-=)/.exec(n);
        if (!t) return n;
        var r = C(n) || 0,
            a = parseFloat(e),
            o = parseFloat(n.replace(t[0], ""));
        switch (t[0][0]) {
            case "+":
                return a + o + r;
            case "-":
                return a - o + r;
            case "*":
                return a * o + r;
        }
    }
    function S(n, e) {
        if (i.col(n)) return O(n);
        if (/\s/g.test(n)) return n;
        var t = C(n),
            r = t ? n.substr(0, n.length - t.length) : n;
        return e ? r + e : r;
    }
    function L(n, e) {
        return Math.sqrt(Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2));
    }
    function j(n) {
        for (var e, t = n.points, r = 0, a = 0; a < t.numberOfItems; a++) {
            var o = t.getItem(a);
            a > 0 && (r += L(e, o)), (e = o);
        }
        return r;
    }
    function q(n) {
        if (n.getTotalLength) return n.getTotalLength();
        switch (n.tagName.toLowerCase()) {
            case "circle":
                return (o = n), 2 * Math.PI * I(o, "r");
            case "rect":
                return 2 * I((a = n), "width") + 2 * I(a, "height");
            case "line":
                return L({ x: I((r = n), "x1"), y: I(r, "y1") }, { x: I(r, "x2"), y: I(r, "y2") });
            case "polyline":
                return j(n);
            case "polygon":
                return (t = (e = n).points), j(e) + L(t.getItem(t.numberOfItems - 1), t.getItem(0));
        }
        var e, t, r, a, o;
    }
    function H(n, e) {
        var t = e || {},
            r =
                t.el ||
                (function (n) {
                    for (var e = n.parentNode; i.svg(e) && i.svg(e.parentNode); ) e = e.parentNode;
                    return e;
                })(n),
            a = r.getBoundingClientRect(),
            o = I(r, "viewBox"),
            u = a.width,
            c = a.height,
            s = t.viewBox || (o ? o.split(" ") : [0, 0, u, c]);
        return { el: r, viewBox: s, x: s[0] / 1, y: s[1] / 1, w: u, h: c, vW: s[2], vH: s[3] };
    }
    function V(n, e, t) {
        function r(t) {
            void 0 === t && (t = 0);
            var r = e + t >= 1 ? e + t : 0;
            return n.el.getPointAtLength(r);
        }
        var a = H(n.el, n.svg),
            o = r(),
            u = r(-1),
            i = r(1),
            c = t ? 1 : a.w / a.vW,
            s = t ? 1 : a.h / a.vH;
        switch (n.property) {
            case "x":
                return (o.x - a.x) * c;
            case "y":
                return (o.y - a.y) * s;
            case "angle":
                return (180 * Math.atan2(i.y - u.y, i.x - u.x)) / Math.PI;
        }
    }
    function $(n, e) {
        var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
            r = S(i.pth(n) ? n.totalLength : n, e) + "";
        return { original: r, numbers: r.match(t) ? r.match(t).map(Number) : [0], strings: i.str(n) || e ? r.split(t) : [] };
    }
    function W(n) {
        return m(n ? y(i.arr(n) ? n.map(b) : b(n)) : [], function (n, e, t) {
            return t.indexOf(n) === e;
        });
    }
    function X(n) {
        var e = W(n);
        return e.map(function (n, t) {
            return { target: n, id: t, total: e.length, transforms: { list: E(n) } };
        });
    }
    function Y(n, e) {
        var t = x(e);
        if ((/^spring/.test(t.easing) && (t.duration = s(t.easing)), i.arr(n))) {
            var r = n.length;
            2 === r && !i.obj(n[0]) ? (n = { value: n }) : i.fnc(e.duration) || (t.duration = e.duration / r);
        }
        var a = i.arr(n) ? n : [n];
        return a
            .map(function (n, t) {
                var r = i.obj(n) && !i.pth(n) ? n : { value: n };
                return i.und(r.delay) && (r.delay = t ? 0 : e.delay), i.und(r.endDelay) && (r.endDelay = t === a.length - 1 ? e.endDelay : 0), r;
            })
            .map(function (n) {
                return k(n, t);
            });
    }
    function Z(n, e) {
        var t = [],
            r = e.keyframes;
        for (var a in (r &&
            (e = k(
                (function (n) {
                    for (
                        var e = m(
                                y(
                                    n.map(function (n) {
                                        return Object.keys(n);
                                    })
                                ),
                                function (n) {
                                    return i.key(n);
                                }
                            ).reduce(function (n, e) {
                                return n.indexOf(e) < 0 && n.push(e), n;
                            }, []),
                            t = {},
                            r = function (r) {
                                var a = e[r];
                                t[a] = n.map(function (n) {
                                    var e = {};
                                    for (var t in n) i.key(t) ? t == a && (e.value = n[t]) : (e[t] = n[t]);
                                    return e;
                                });
                            },
                            a = 0;
                        a < e.length;
                        a++
                    )
                        r(a);
                    return t;
                })(r),
                e
            )),
        e))
            i.key(a) && t.push({ name: a, tweens: Y(e[a], n) });
        return t;
    }
    function G(n, e) {
        var t;
        return n.tweens.map(function (r) {
            var a = (function (n, e) {
                    var t = {};
                    for (var r in n) {
                        var a = P(n[r], e);
                        i.arr(a) &&
                            1 ===
                                (a = a.map(function (n) {
                                    return P(n, e);
                                })).length &&
                            (a = a[0]),
                            (t[r] = a);
                    }
                    return (t.duration = parseFloat(t.duration)), (t.delay = parseFloat(t.delay)), t;
                })(r, e),
                o = a.value,
                u = i.arr(o) ? o[1] : o,
                c = C(u),
                s = A(e.target, n.name, c, e),
                f = t ? t.to.original : s,
                l = i.arr(o) ? o[0] : f,
                d = C(l) || C(s),
                p = c || d;
            return (
                i.und(u) && (u = f),
                (a.from = $(l, p)),
                (a.to = $(N(u, l), p)),
                (a.start = t ? t.end : 0),
                (a.end = a.start + a.delay + a.duration + a.endDelay),
                (a.easing = h(a.easing, a.duration)),
                (a.isPath = i.pth(o)),
                (a.isPathTargetInsideSVG = a.isPath && i.svg(e.target)),
                (a.isColor = i.col(a.from.original)),
                a.isColor && (a.round = 1),
                (t = a),
                a
            );
        });
    }
    var Q = {
        css: function (n, e, t) {
            return (n.style[e] = t);
        },
        attribute: function (n, e, t) {
            return n.setAttribute(e, t);
        },
        object: function (n, e, t) {
            return (n[e] = t);
        },
        transform: function (n, e, t, r, a) {
            if ((r.list.set(e, t), e === r.last || a)) {
                var o = "";
                r.list.forEach(function (n, e) {
                    o += e + "(" + n + ") ";
                }),
                    (n.style.transform = o);
            }
        },
    };
    function z(n, e) {
        X(n).forEach(function (n) {
            for (var t in e) {
                var r = P(e[t], n),
                    a = n.target,
                    o = C(r),
                    u = A(a, t, o, n),
                    i = N(S(r, o || C(u)), u),
                    c = T(a, t);
                Q[c](a, t, i, n.transforms, !0);
            }
        });
    }
    function _(n, e) {
        return m(
            y(
                n.map(function (n) {
                    return e.map(function (e) {
                        return (function (n, e) {
                            var t = T(n.target, e.name);
                            if (t) {
                                var r = G(e, n),
                                    a = r[r.length - 1];
                                return { type: t, property: e.name, animatable: n, tweens: r, duration: a.end, delay: r[0].delay, endDelay: a.endDelay };
                            }
                        })(n, e);
                    });
                })
            ),
            function (n) {
                return !i.und(n);
            }
        );
    }
    function R(n, e) {
        var t = n.length,
            r = function (n) {
                return n.timelineOffset ? n.timelineOffset : 0;
            },
            a = {};
        return (
            (a.duration = t
                ? Math.max.apply(
                      Math,
                      n.map(function (n) {
                          return r(n) + n.duration;
                      })
                  )
                : e.duration),
            (a.delay = t
                ? Math.min.apply(
                      Math,
                      n.map(function (n) {
                          return r(n) + n.delay;
                      })
                  )
                : e.delay),
            (a.endDelay = t
                ? a.duration -
                  Math.max.apply(
                      Math,
                      n.map(function (n) {
                          return r(n) + n.duration - n.endDelay;
                      })
                  )
                : e.endDelay),
            a
        );
    }
    var J = 0;
    var K = [],
        U = (function () {
            var n;
            function e(t) {
                for (var r = K.length, a = 0; a < r; ) {
                    var o = K[a];
                    o.paused ? (K.splice(a, 1), r--) : (o.tick(t), a++);
                }
                n = a > 0 ? requestAnimationFrame(e) : void 0;
            }
            return (
                "undefined" != typeof document &&
                    document.addEventListener("visibilitychange", function () {
                        en.suspendWhenDocumentHidden &&
                            (nn()
                                ? (n = cancelAnimationFrame(n))
                                : (K.forEach(function (n) {
                                      return n._onDocumentVisibility();
                                  }),
                                  U()));
                    }),
                function () {
                    n || (nn() && en.suspendWhenDocumentHidden) || !(K.length > 0) || (n = requestAnimationFrame(e));
                }
            );
        })();
    function nn() {
        return !!document && document.hidden;
    }
    function en(t) {
        void 0 === t && (t = {});
        var r,
            o = 0,
            u = 0,
            i = 0,
            c = 0,
            s = null;
        function f(n) {
            var e =
                window.Promise &&
                new Promise(function (n) {
                    return (s = n);
                });
            return (n.finished = e), e;
        }
        var l,
            d,
            p,
            v,
            h,
            g,
            y,
            b,
            M =
                ((d = w(n, (l = t))),
                (p = w(e, l)),
                (v = Z(p, l)),
                (h = X(l.targets)),
                (g = _(h, v)),
                (y = R(g, p)),
                (b = J),
                J++,
                k(d, { id: b, children: [], animatables: h, animations: g, duration: y.duration, delay: y.delay, endDelay: y.endDelay }));
        f(M);
        function x() {
            var n = M.direction;
            "alternate" !== n && (M.direction = "normal" !== n ? "normal" : "reverse"),
                (M.reversed = !M.reversed),
                r.forEach(function (n) {
                    return (n.reversed = M.reversed);
                });
        }
        function O(n) {
            return M.reversed ? M.duration - n : n;
        }
        function C() {
            (o = 0), (u = O(M.currentTime) * (1 / en.speed));
        }
        function P(n, e) {
            e && e.seek(n - e.timelineOffset);
        }
        function I(n) {
            for (var e = 0, t = M.animations, r = t.length; e < r; ) {
                var o = t[e],
                    u = o.animatable,
                    i = o.tweens,
                    c = i.length - 1,
                    s = i[c];
                c &&
                    (s =
                        m(i, function (e) {
                            return n < e.end;
                        })[0] || s);
                for (var f = a(n - s.start - s.delay, 0, s.duration) / s.duration, l = isNaN(f) ? 1 : s.easing(f), d = s.to.strings, p = s.round, v = [], h = s.to.numbers.length, g = void 0, y = 0; y < h; y++) {
                    var b = void 0,
                        x = s.to.numbers[y],
                        w = s.from.numbers[y] || 0;
                    (b = s.isPath ? V(s.value, l * x, s.isPathTargetInsideSVG) : w + l * (x - w)), p && ((s.isColor && y > 2) || (b = Math.round(b * p) / p)), v.push(b);
                }
                var k = d.length;
                if (k) {
                    g = d[0];
                    for (var O = 0; O < k; O++) {
                        d[O];
                        var C = d[O + 1],
                            P = v[O];
                        isNaN(P) || (g += C ? P + C : P + " ");
                    }
                } else g = v[0];
                Q[o.type](u.target, o.property, g, u.transforms), (o.currentValue = g), e++;
            }
        }
        function D(n) {
            M[n] && !M.passThrough && M[n](M);
        }
        function B(n) {
            var e = M.duration,
                t = M.delay,
                l = e - M.endDelay,
                d = O(n);
            (M.progress = a((d / e) * 100, 0, 100)),
                (M.reversePlayback = d < M.currentTime),
                r &&
                    (function (n) {
                        if (M.reversePlayback) for (var e = c; e--; ) P(n, r[e]);
                        else for (var t = 0; t < c; t++) P(n, r[t]);
                    })(d),
                !M.began && M.currentTime > 0 && ((M.began = !0), D("begin")),
                !M.loopBegan && M.currentTime > 0 && ((M.loopBegan = !0), D("loopBegin")),
                d <= t && 0 !== M.currentTime && I(0),
                ((d >= l && M.currentTime !== e) || !e) && I(e),
                d > t && d < l ? (M.changeBegan || ((M.changeBegan = !0), (M.changeCompleted = !1), D("changeBegin")), D("change"), I(d)) : M.changeBegan && ((M.changeCompleted = !0), (M.changeBegan = !1), D("changeComplete")),
                (M.currentTime = a(d, 0, e)),
                M.began && D("update"),
                n >= e &&
                    ((u = 0),
                    M.remaining && !0 !== M.remaining && M.remaining--,
                    M.remaining
                        ? ((o = i), D("loopComplete"), (M.loopBegan = !1), "alternate" === M.direction && x())
                        : ((M.paused = !0), M.completed || ((M.completed = !0), D("loopComplete"), D("complete"), !M.passThrough && "Promise" in window && (s(), f(M)))));
        }
        return (
            (M.reset = function () {
                var n = M.direction;
                (M.passThrough = !1),
                    (M.currentTime = 0),
                    (M.progress = 0),
                    (M.paused = !0),
                    (M.began = !1),
                    (M.loopBegan = !1),
                    (M.changeBegan = !1),
                    (M.completed = !1),
                    (M.changeCompleted = !1),
                    (M.reversePlayback = !1),
                    (M.reversed = "reverse" === n),
                    (M.remaining = M.loop),
                    (r = M.children);
                for (var e = (c = r.length); e--; ) M.children[e].reset();
                ((M.reversed && !0 !== M.loop) || ("alternate" === n && 1 === M.loop)) && M.remaining++, I(M.reversed ? M.duration : 0);
            }),
            (M._onDocumentVisibility = C),
            (M.set = function (n, e) {
                return z(n, e), M;
            }),
            (M.tick = function (n) {
                (i = n), o || (o = i), B((i + (u - o)) * en.speed);
            }),
            (M.seek = function (n) {
                B(O(n));
            }),
            (M.pause = function () {
                (M.paused = !0), C();
            }),
            (M.play = function () {
                M.paused && (M.completed && M.reset(), (M.paused = !1), K.push(M), C(), U());
            }),
            (M.reverse = function () {
                x(), (M.completed = !M.reversed), C();
            }),
            (M.restart = function () {
                M.reset(), M.play();
            }),
            (M.remove = function (n) {
                rn(W(n), M);
            }),
            M.reset(),
            M.autoplay && M.play(),
            M
        );
    }
    function tn(n, e) {
        for (var t = e.length; t--; ) M(n, e[t].animatable.target) && e.splice(t, 1);
    }
    function rn(n, e) {
        var t = e.animations,
            r = e.children;
        tn(n, t);
        for (var a = r.length; a--; ) {
            var o = r[a],
                u = o.animations;
            tn(n, u), u.length || o.children.length || r.splice(a, 1);
        }
        t.length || r.length || e.pause();
    }
    return (
        (en.version = "3.2.1"),
        (en.speed = 1),
        (en.suspendWhenDocumentHidden = !0),
        (en.running = K),
        (en.remove = function (n) {
            for (var e = W(n), t = K.length; t--; ) rn(e, K[t]);
        }),
        (en.get = A),
        (en.set = z),
        (en.convertPx = D),
        (en.path = function (n, e) {
            var t = i.str(n) ? g(n)[0] : n,
                r = e || 100;
            return function (n) {
                return { property: n, el: t, svg: H(t), totalLength: q(t) * (r / 100) };
            };
        }),
        (en.setDashoffset = function (n) {
            var e = q(n);
            return n.setAttribute("stroke-dasharray", e), e;
        }),
        (en.stagger = function (n, e) {
            void 0 === e && (e = {});
            var t = e.direction || "normal",
                r = e.easing ? h(e.easing) : null,
                a = e.grid,
                o = e.axis,
                u = e.from || 0,
                c = "first" === u,
                s = "center" === u,
                f = "last" === u,
                l = i.arr(n),
                d = l ? parseFloat(n[0]) : parseFloat(n),
                p = l ? parseFloat(n[1]) : 0,
                v = C(l ? n[1] : n) || 0,
                g = e.start || 0 + (l ? d : 0),
                m = [],
                y = 0;
            return function (n, e, i) {
                if ((c && (u = 0), s && (u = (i - 1) / 2), f && (u = i - 1), !m.length)) {
                    for (var h = 0; h < i; h++) {
                        if (a) {
                            var b = s ? (a[0] - 1) / 2 : u % a[0],
                                M = s ? (a[1] - 1) / 2 : Math.floor(u / a[0]),
                                x = b - (h % a[0]),
                                w = M - Math.floor(h / a[0]),
                                k = Math.sqrt(x * x + w * w);
                            "x" === o && (k = -x), "y" === o && (k = -w), m.push(k);
                        } else m.push(Math.abs(u - h));
                        y = Math.max.apply(Math, m);
                    }
                    r &&
                        (m = m.map(function (n) {
                            return r(n / y) * y;
                        })),
                        "reverse" === t &&
                            (m = m.map(function (n) {
                                return o ? (n < 0 ? -1 * n : -n) : Math.abs(y - n);
                            }));
                }
                return g + (l ? (p - d) / y : d) * (Math.round(100 * m[e]) / 100) + v;
            };
        }),
        (en.timeline = function (n) {
            void 0 === n && (n = {});
            var t = en(n);
            return (
                (t.duration = 0),
                (t.add = function (r, a) {
                    var o = K.indexOf(t),
                        u = t.children;
                    function c(n) {
                        n.passThrough = !0;
                    }
                    o > -1 && K.splice(o, 1);
                    for (var s = 0; s < u.length; s++) c(u[s]);
                    var f = k(r, w(e, n));
                    f.targets = f.targets || n.targets;
                    var l = t.duration;
                    (f.autoplay = !1), (f.direction = t.direction), (f.timelineOffset = i.und(a) ? l : N(a, l)), c(t), t.seek(f.timelineOffset);
                    var d = en(f);
                    c(d), u.push(d);
                    var p = R(u, n);
                    return (t.delay = p.delay), (t.endDelay = p.endDelay), (t.duration = p.duration), t.seek(0), t.reset(), t.autoplay && t.play(), t;
                }),
                t
            );
        }),
        (en.easing = h),
        (en.penner = v),
        (en.random = function (n, e) {
            return Math.floor(Math.random() * (e - n + 1)) + n;
        }),
        en
    );
});
if (!jQuery().nectarswiper) {
    var NectarSwiper = function (selector, params) {
        if (document.body.__defineGetter__) {
            var testOuterHTML = document.querySelector("div");
            if (typeof testOuterHTML.outerHTML === "undefined") {
                if (HTMLElement) {
                    var element = HTMLElement.prototype;
                    if (element.__defineGetter__) {
                        element.__defineGetter__("outerHTML", function () {
                            return new XMLSerializer().serializeToString(this);
                        });
                    }
                }
            }
        }
        if (!window.getComputedStyle) {
            window.getComputedStyle = function (el, pseudo) {
                this.el = el;
                this.getPropertyValue = function (prop) {
                    var re = /(\-([a-z]){1})/g;
                    if (prop === "float") prop = "styleFloat";
                    if (re.test(prop)) {
                        prop = prop.replace(re, function () {
                            return arguments[2].toUpperCase();
                        });
                    }
                    return el.currentStyle[prop] ? el.currentStyle[prop] : null;
                };
                return this;
            };
        }
        if (!Array.prototype.indexOf) {
            Array.prototype.indexOf = function (obj, start) {
                for (var i = start || 0, j = this.length; i < j; i++) {
                    if (this[i] === obj) {
                        return i;
                    }
                }
                return -1;
            };
        }
        if (!document.querySelectorAll) {
            if (!window.jQuery) return;
        }
        function $$(selector, context) {
            if (document.querySelectorAll) return (context || document).querySelectorAll(selector);
            else return jQuery(selector, context);
        }
        if (typeof selector === "undefined") return;
        if (!selector.nodeType) {
            if ($$(selector).length === 0) return;
        }
        var _this = this;
        _this.touches = { start: 0, startX: 0, startY: 0, current: 0, currentX: 0, currentY: 0, diff: 0, abs: 0 };
        _this.positions = { start: 0, abs: 0, diff: 0, current: 0 };
        _this.times = { start: 0, end: 0 };
        _this.id = new Date().getTime();
        _this.container = selector.nodeType ? selector : $$(selector)[0];
        _this.isTouched = false;
        _this.isMoved = false;
        _this.activeIndex = 0;
        _this.activeLoaderIndex = 0;
        _this.activeLoopIndex = 0;
        _this.previousIndex = null;
        _this.velocity = 0;
        _this.snapGrid = [];
        _this.slidesGrid = [];
        _this.imagesToLoad = [];
        _this.imagesLoaded = 0;
        _this.wrapperLeft = 0;
        _this.wrapperRight = 0;
        _this.wrapperTop = 0;
        _this.wrapperBottom = 0;
        var wrapper, slideSize, wrapperSize, direction, isScrolling, containerSize;
        var defaults = {
            mode: "horizontal",
            touchRatio: 1,
            speed: 300,
            freeMode: false,
            freeModeFluid: false,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            slidesPerView: 1,
            slidesPerGroup: 1,
            simulateTouch: true,
            followFinger: true,
            shortSwipes: true,
            moveStartThreshold: false,
            autoplay: false,
            onlyExternal: false,
            createPagination: true,
            pagination: false,
            paginationElement: "span",
            paginationClickable: false,
            paginationAsRange: true,
            resistance: true,
            scrollContainer: false,
            preventLinks: true,
            noSwiping: false,
            noSwipingClass: "swiper-no-swiping",
            initialSlide: 0,
            keyboardControl: false,
            mousewheelControl: false,
            mousewheelDebounce: 600,
            useCSS3Transforms: true,
            loop: false,
            loopAdditionalSlides: 0,
            calculateHeight: false,
            updateOnImagesReady: true,
            releaseFormElements: true,
            watchActiveIndex: false,
            visibilityFullFit: false,
            offsetPxBefore: 0,
            offsetPxAfter: 0,
            offsetSlidesBefore: 0,
            offsetSlidesAfter: 0,
            centeredSlides: false,
            queueStartCallbacks: false,
            queueEndCallbacks: false,
            autoResize: true,
            resizeReInit: false,
            DOMAnimation: true,
            loader: { slides: [], slidesHTMLType: "inner", surroundGroups: 1, logic: "reload", loadAllSlides: false },
            slideElement: "div",
            slideClass: "swiper-slide",
            slideActiveClass: "swiper-slide-active",
            slideVisibleClass: "swiper-slide-visible",
            wrapperClass: "swiper-wrapper",
            paginationElementClass: "swiper-pagination-switch",
            paginationActiveClass: "swiper-active-switch ar-vis",
            paginationVisibleClass: "swiper-visible-switch",
        };
        params = params || {};
        for (var prop in defaults) {
            if (prop in params && typeof params[prop] === "object") {
                for (var subProp in defaults[prop]) {
                    if (!(subProp in params[prop])) {
                        params[prop][subProp] = defaults[prop][subProp];
                    }
                }
            } else if (!(prop in params)) {
                params[prop] = defaults[prop];
            }
        }
        _this.params = params;
        if (params.scrollContainer) {
            params.freeMode = true;
            params.freeModeFluid = true;
        }
        if (params.loop) {
            params.resistance = "100%";
        }
        var isH = params.mode === "horizontal";
        _this.touchEvents = {
            touchStart: _this.support.touch || !params.simulateTouch ? "touchstart" : _this.browser.ie10 ? "MSPointerDown" : "mousedown",
            touchMove: _this.support.touch || !params.simulateTouch ? "touchmove" : _this.browser.ie10 ? "MSPointerMove" : "mousemove",
            touchEnd: _this.support.touch || !params.simulateTouch ? "touchend" : _this.browser.ie10 ? "MSPointerUp" : "mouseup",
        };
        for (var i = _this.container.childNodes.length - 1; i >= 0; i--) {
            if (_this.container.childNodes[i].className) {
                var _wrapperClasses = _this.container.childNodes[i].className.split(/\s+/);
                for (var j = 0; j < _wrapperClasses.length; j++) {
                    if (_wrapperClasses[j] === params.wrapperClass) {
                        wrapper = _this.container.childNodes[i];
                    }
                }
            }
        }
        _this.wrapper = wrapper;
        _this._extendSwiperSlide = function (el) {
            el.append = function () {
                if (params.loop) {
                    el.insertAfter(_this.slides.length - _this.loopedSlides);
                    _this.removeLoopedSlides();
                    _this.calcSlides();
                    _this.createLoop();
                } else {
                    _this.wrapper.appendChild(el);
                }
                _this.reInit();
                return el;
            };
            el.prepend = function () {
                if (params.loop) {
                    _this.wrapper.insertBefore(el, _this.slides[_this.loopedSlides]);
                    _this.removeLoopedSlides();
                    _this.calcSlides();
                    _this.createLoop();
                } else {
                    _this.wrapper.insertBefore(el, _this.wrapper.firstChild);
                }
                _this.reInit();
                return el;
            };
            el.insertAfter = function (index) {
                if (typeof index === "undefined") return false;
                var beforeSlide;
                if (params.loop) {
                    beforeSlide = _this.slides[index + 1 + _this.loopedSlides];
                    _this.wrapper.insertBefore(el, beforeSlide);
                    _this.removeLoopedSlides();
                    _this.calcSlides();
                    _this.createLoop();
                } else {
                    beforeSlide = _this.slides[index + 1];
                    _this.wrapper.insertBefore(el, beforeSlide);
                }
                _this.reInit();
                return el;
            };
            el.clone = function () {
                return _this._extendSwiperSlide(el.cloneNode(true));
            };
            el.remove = function () {
                _this.wrapper.removeChild(el);
                _this.reInit();
            };
            el.html = function (html) {
                if (typeof html === "undefined") {
                    return el.innerHTML;
                } else {
                    el.innerHTML = html;
                    return el;
                }
            };
            el.index = function () {
                var index;
                for (var i = _this.slides.length - 1; i >= 0; i--) {
                    if (el === _this.slides[i]) index = i;
                }
                return index;
            };
            el.isActive = function () {
                if (el.index() === _this.activeIndex) {
                    return true;
                } else return false;
            };
            if (!el.swiperSlideDataStorage) el.swiperSlideDataStorage = {};
            el.getData = function (name) {
                return el.swiperSlideDataStorage[name];
            };
            el.setData = function (name, value) {
                el.swiperSlideDataStorage[name] = value;
                return el;
            };
            el.data = function (name, value) {
                if (!value) {
                    return el.getAttribute("data-" + name);
                } else {
                    el.setAttribute("data-" + name, value);
                    return el;
                }
            };
            el.getWidth = function (outer) {
                return _this.h.getWidth(el, outer);
            };
            el.getHeight = function (outer) {
                return _this.h.getHeight(el, outer);
            };
            el.getOffset = function () {
                return _this.h.getOffset(el);
            };
            return el;
        };
        _this.calcSlides = function (forceCalcSlides) {
            var oldNumber = _this.slides ? _this.slides.length : false;
            _this.slides = [];
            _this.displaySlides = [];
            for (var i = 0; i < _this.wrapper.childNodes.length; i++) {
                if (_this.wrapper.childNodes[i].className) {
                    var _className = _this.wrapper.childNodes[i].className;
                    var _slideClasses = _className.split(" ");
                    for (var j = 0; j < _slideClasses.length; j++) {
                        if (_slideClasses[j] === params.slideClass) {
                            _this.slides.push(_this.wrapper.childNodes[i]);
                        }
                    }
                }
            }
            for (i = _this.slides.length - 1; i >= 0; i--) {
                _this._extendSwiperSlide(_this.slides[i]);
            }
            if (!oldNumber) return;
            if (oldNumber !== _this.slides.length || forceCalcSlides) {
                removeSlideEvents();
                addSlideEvents();
                _this.updateActiveSlide();
                if (params.createPagination && _this.params.pagination) _this.createPagination();
                _this.callPlugins("numberOfSlidesChanged");
            }
        };
        _this.createSlide = function (html, slideClassList, el) {
            var slideClassList = slideClassList || _this.params.slideClass;
            var el = el || params.slideElement;
            var newSlide = document.createElement(el);
            newSlide.innerHTML = html || "";
            newSlide.className = slideClassList;
            return _this._extendSwiperSlide(newSlide);
        };
        _this.appendSlide = function (html, slideClassList, el) {
            if (!html) return;
            if (html.nodeType) {
                return _this._extendSwiperSlide(html).append();
            } else {
                return _this.createSlide(html, slideClassList, el).append();
            }
        };
        _this.prependSlide = function (html, slideClassList, el) {
            if (!html) return;
            if (html.nodeType) {
                return _this._extendSwiperSlide(html).prepend();
            } else {
                return _this.createSlide(html, slideClassList, el).prepend();
            }
        };
        _this.insertSlideAfter = function (index, html, slideClassList, el) {
            if (typeof index === "undefined") return false;
            if (html.nodeType) {
                return _this._extendSwiperSlide(html).insertAfter(index);
            } else {
                return _this.createSlide(html, slideClassList, el).insertAfter(index);
            }
        };
        _this.removeSlide = function (index) {
            if (_this.slides[index]) {
                if (params.loop) {
                    if (!_this.slides[index + _this.loopedSlides]) return false;
                    _this.slides[index + _this.loopedSlides].remove();
                    _this.removeLoopedSlides();
                    _this.calcSlides();
                    _this.createLoop();
                } else _this.slides[index].remove();
                return true;
            } else return false;
        };
        _this.removeLastSlide = function () {
            if (_this.slides.length > 0) {
                if (params.loop) {
                    _this.slides[_this.slides.length - 1 - _this.loopedSlides].remove();
                    _this.removeLoopedSlides();
                    _this.calcSlides();
                    _this.createLoop();
                } else _this.slides[_this.slides.length - 1].remove();
                return true;
            } else {
                return false;
            }
        };
        _this.removeAllSlides = function () {
            for (var i = _this.slides.length - 1; i >= 0; i--) {
                _this.slides[i].remove();
            }
        };
        _this.getSlide = function (index) {
            return _this.slides[index];
        };
        _this.getLastSlide = function () {
            return _this.slides[_this.slides.length - 1];
        };
        _this.getFirstSlide = function () {
            return _this.slides[0];
        };
        _this.activeSlide = function () {
            return _this.slides[_this.activeIndex];
        };
        var _plugins = [];
        for (var plugin in _this.plugins) {
            if (params[plugin]) {
                var p = _this.plugins[plugin](_this, params[plugin]);
                if (p) _plugins.push(p);
            }
        }
        _this.callPlugins = function (method, args) {
            if (!args) args = {};
            for (var i = 0; i < _plugins.length; i++) {
                if (method in _plugins[i]) {
                    _plugins[i][method](args);
                }
            }
        };
        _this.fireCallback = function () {
            var callback = arguments[0];
            if (Object.prototype.toString.call(callback) === "[object Array]") {
                for (var i = 0; i < callback.length; i++) {
                    if (typeof callback[i] === "function") {
                        callback[i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                    }
                }
            } else {
                callback(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }
        };
        function isArray(obj) {
            "use strict";
            if (Object.prototype.toString.apply(obj) === "[object Array]") {
                return true;
            }
            return false;
        }
        _this.addCallback = function (callback, func) {
            "use strict";
            var _this = this,
                tempFunc;
            if (_this.params["on" + callback]) {
                if (isArray(this.params["on" + callback])) {
                    return this.params["on" + callback].push(func);
                } else if (typeof this.params["on" + callback] === "function") {
                    tempFunc = this.params["on" + callback];
                    this.params["on" + callback] = [];
                    this.params["on" + callback].push(tempFunc);
                    return this.params["on" + callback].push(func);
                }
            } else {
                this.params["on" + callback] = [];
                return this.params["on" + callback].push(func);
            }
        };
        _this.removeCallbacks = function (callback) {
            if (_this.params["on" + callback]) {
                return (_this.params["on" + callback] = null);
            }
        };
        if (_this.browser.ie10 && !params.onlyExternal) {
            _this.wrapper.classList.add("swiper-wp8-" + (isH ? "horizontal" : "vertical"));
        }
        if (params.freeMode) {
            _this.container.className += " swiper-free-mode";
        }
        _this.initialized = false;
        _this.init = function (force, forceCalcSlides) {
            var _width = _this.h.getWidth(_this.container);
            var _height = _this.h.getHeight(_this.container);
            if (_width === _this.width && _height === _this.height && !force) return;
            _this.width = _width;
            _this.height = _height;
            containerSize = isH ? _width : _height;
            var wrapper = _this.wrapper;
            if (force) {
                _this.calcSlides(forceCalcSlides);
            }
            if (params.slidesPerView === "auto") {
                var slidesWidth = 0;
                var slidesHeight = 0;
                if (params.slidesOffset > 0) {
                    wrapper.style.paddingLeft = "";
                    wrapper.style.paddingRight = "";
                    wrapper.style.paddingTop = "";
                    wrapper.style.paddingBottom = "";
                }
                wrapper.style.width = "";
                wrapper.style.height = "";
                if (params.offsetPxBefore > 0) {
                    if (isH) _this.wrapperLeft = params.offsetPxBefore;
                    else _this.wrapperTop = params.offsetPxBefore;
                }
                if (params.offsetPxAfter > 0) {
                    if (isH) _this.wrapperRight = params.offsetPxAfter;
                    else _this.wrapperBottom = params.offsetPxAfter;
                }
                if (params.centeredSlides) {
                    if (isH) {
                        _this.wrapperLeft = (containerSize - this.slides[0].getWidth(true)) / 2;
                        _this.wrapperRight = (containerSize - _this.slides[_this.slides.length - 1].getWidth(true)) / 2;
                    } else {
                        _this.wrapperTop = (containerSize - _this.slides[0].getHeight(true)) / 2;
                        _this.wrapperBottom = (containerSize - _this.slides[_this.slides.length - 1].getHeight(true)) / 2;
                    }
                }
                if (isH) {
                    if (_this.wrapperLeft >= 0) wrapper.style.paddingLeft = _this.wrapperLeft + "px";
                    if (_this.wrapperRight >= 0) wrapper.style.paddingRight = _this.wrapperRight + "px";
                } else {
                    if (_this.wrapperTop >= 0) wrapper.style.paddingTop = _this.wrapperTop + "px";
                    if (_this.wrapperBottom >= 0) wrapper.style.paddingBottom = _this.wrapperBottom + "px";
                }
                var slideLeft = 0;
                var centeredSlideLeft = 0;
                _this.snapGrid = [];
                _this.slidesGrid = [];
                var slideMaxHeight = 0;
                for (var i = 0; i < _this.slides.length; i++) {
                    var slideWidth = _this.slides[i].getWidth(true);
                    var slideHeight = _this.slides[i].getHeight(true);
                    if (params.calculateHeight) {
                        slideMaxHeight = Math.max(slideMaxHeight, slideHeight);
                    }
                    var _slideSize = isH ? slideWidth : slideHeight;
                    if (params.centeredSlides) {
                        var nextSlideWidth = i === _this.slides.length - 1 ? 0 : _this.slides[i + 1].getWidth(true);
                        var nextSlideHeight = i === _this.slides.length - 1 ? 0 : _this.slides[i + 1].getHeight(true);
                        var nextSlideSize = isH ? nextSlideWidth : nextSlideHeight;
                        if (_slideSize > containerSize) {
                            for (var j = 0; j <= Math.floor(_slideSize / (containerSize + _this.wrapperLeft)); j++) {
                                if (j === 0) _this.snapGrid.push(slideLeft + _this.wrapperLeft);
                                else _this.snapGrid.push(slideLeft + _this.wrapperLeft + containerSize * j);
                            }
                            _this.slidesGrid.push(slideLeft + _this.wrapperLeft);
                        } else {
                            _this.snapGrid.push(centeredSlideLeft);
                            _this.slidesGrid.push(centeredSlideLeft);
                        }
                        centeredSlideLeft += _slideSize / 2 + nextSlideSize / 2;
                    } else {
                        if (_slideSize > containerSize) {
                            for (var j = 0; j <= Math.floor(_slideSize / containerSize); j++) {
                                _this.snapGrid.push(slideLeft + containerSize * j);
                            }
                        } else {
                            _this.snapGrid.push(slideLeft);
                        }
                        _this.slidesGrid.push(slideLeft);
                    }
                    slideLeft += _slideSize;
                    slidesWidth += slideWidth;
                    slidesHeight += slideHeight;
                }
                if (params.calculateHeight) _this.height = slideMaxHeight;
                if (isH) {
                    wrapperSize = slidesWidth + _this.wrapperRight + _this.wrapperLeft;
                    wrapper.style.width = slidesWidth + "px";
                    wrapper.style.height = _this.height + "px";
                } else {
                    wrapperSize = slidesHeight + _this.wrapperTop + _this.wrapperBottom;
                    wrapper.style.width = _this.width + "px";
                    wrapper.style.height = slidesHeight + "px";
                }
            } else if (params.scrollContainer) {
                wrapper.style.width = "";
                wrapper.style.height = "";
                var wrapperWidth = _this.slides[0].getWidth(true);
                var wrapperHeight = _this.slides[0].getHeight(true);
                wrapperSize = isH ? wrapperWidth : wrapperHeight;
                wrapper.style.width = wrapperWidth + "px";
                wrapper.style.height = wrapperHeight + "px";
                slideSize = isH ? wrapperWidth : wrapperHeight;
            } else {
                if (params.calculateHeight) {
                    var slideMaxHeight = 0;
                    var wrapperHeight = 0;
                    if (!isH) _this.container.style.height = "";
                    wrapper.style.height = "";
                    for (var i = 0; i < _this.slides.length; i++) {
                        _this.slides[i].style.height = "";
                        slideMaxHeight = Math.max(_this.slides[i].getHeight(true), slideMaxHeight);
                        if (!isH) wrapperHeight += _this.slides[i].getHeight(true);
                    }
                    var slideHeight = slideMaxHeight;
                    _this.height = slideHeight;
                    if (isH) wrapperHeight = slideHeight;
                    else (containerSize = slideHeight), (_this.container.style.height = containerSize + "px");
                } else {
                    var slideHeight = isH ? _this.height : _this.height / params.slidesPerView;
                    var wrapperHeight = isH ? _this.height : _this.slides.length * slideHeight;
                }
                var slideWidth = isH ? _this.width / params.slidesPerView : _this.width;
                var wrapperWidth = isH ? _this.slides.length * slideWidth : _this.width;
                slideSize = isH ? slideWidth : slideHeight;
                if (params.offsetSlidesBefore > 0) {
                    if (isH) _this.wrapperLeft = slideSize * params.offsetSlidesBefore;
                    else _this.wrapperTop = slideSize * params.offsetSlidesBefore;
                }
                if (params.offsetSlidesAfter > 0) {
                    if (isH) _this.wrapperRight = slideSize * params.offsetSlidesAfter;
                    else _this.wrapperBottom = slideSize * params.offsetSlidesAfter;
                }
                if (params.offsetPxBefore > 0) {
                    if (isH) _this.wrapperLeft = params.offsetPxBefore;
                    else _this.wrapperTop = params.offsetPxBefore;
                }
                if (params.offsetPxAfter > 0) {
                    if (isH) _this.wrapperRight = params.offsetPxAfter;
                    else _this.wrapperBottom = params.offsetPxAfter;
                }
                if (params.centeredSlides) {
                    if (isH) {
                        _this.wrapperLeft = (containerSize - slideSize) / 2;
                        _this.wrapperRight = (containerSize - slideSize) / 2;
                    } else {
                        _this.wrapperTop = (containerSize - slideSize) / 2;
                        _this.wrapperBottom = (containerSize - slideSize) / 2;
                    }
                }
                if (isH) {
                    if (_this.wrapperLeft > 0) wrapper.style.paddingLeft = _this.wrapperLeft + "px";
                    if (_this.wrapperRight > 0) wrapper.style.paddingRight = _this.wrapperRight + "px";
                } else {
                    if (_this.wrapperTop > 0) wrapper.style.paddingTop = _this.wrapperTop + "px";
                    if (_this.wrapperBottom > 0) wrapper.style.paddingBottom = _this.wrapperBottom + "px";
                }
                wrapperSize = isH ? wrapperWidth + _this.wrapperRight + _this.wrapperLeft : wrapperHeight + _this.wrapperTop + _this.wrapperBottom;
                if (!params.cssWidthAndHeight) {
                    if (parseFloat(wrapperWidth) > 0) {
                        wrapper.style.width = wrapperWidth + "px";
                    }
                    if (parseFloat(wrapperHeight) > 0) {
                        wrapper.style.height = wrapperHeight + "px";
                    }
                }
                var slideLeft = 0;
                _this.snapGrid = [];
                _this.slidesGrid = [];
                for (var i = 0; i < _this.slides.length; i++) {
                    _this.snapGrid.push(slideLeft);
                    _this.slidesGrid.push(slideLeft);
                    slideLeft += slideSize;
                    if (!params.cssWidthAndHeight) {
                        if (parseFloat(slideWidth) > 0) {
                            _this.slides[i].style.width = slideWidth + "px";
                        }
                        if (parseFloat(slideHeight) > 0) {
                            _this.slides[i].style.height = slideHeight + "px";
                        }
                    }
                }
            }
            if (!_this.initialized) {
                _this.callPlugins("onFirstInit");
                if (params.onFirstInit) _this.fireCallback(params.onFirstInit, _this);
            } else {
                _this.callPlugins("onInit");
                if (params.onInit) _this.fireCallback(params.onInit, _this);
            }
            _this.initialized = true;
        };
        _this.reInit = function (forceCalcSlides) {
            _this.init(true, forceCalcSlides);
        };
        _this.resizeFix = function (reInit) {
            _this.callPlugins("beforeResizeFix");
            _this.init(params.resizeReInit || reInit);
            if (!params.freeMode) {
                _this.swipeTo(params.loop ? _this.activeLoopIndex : _this.activeIndex, 0, false);
            } else if (_this.getWrapperTranslate() < -maxWrapperPosition()) {
                _this.setWrapperTransition(0);
                _this.setWrapperTranslate(-maxWrapperPosition());
            }
            _this.callPlugins("afterResizeFix");
        };
        function maxWrapperPosition() {
            var a = wrapperSize - containerSize;
            if (params.freeMode) {
                a = wrapperSize - containerSize;
            }
            if (params.slidesPerView > _this.slides.length) a = 0;
            if (a < 0) a = 0;
            return a;
        }
        function minWrapperPosition() {
            var a = 0;
            return a;
        }
        function initEvents() {
            var bind = _this.h.addEventListener;
            if (!_this.browser.ie10) {
                if (_this.support.touch) {
                    bind(_this.wrapper, "touchstart", onTouchStart);
                    bind(_this.wrapper, "touchmove", onTouchMove);
                    bind(_this.wrapper, "touchend", onTouchEnd);
                }
                if (params.simulateTouch) {
                    bind(_this.wrapper, "mousedown", onTouchStart);
                    bind(document, "mousemove", onTouchMove);
                    bind(document, "mouseup", onTouchEnd);
                }
            } else {
                bind(_this.wrapper, _this.touchEvents.touchStart, onTouchStart);
                bind(document, _this.touchEvents.touchMove, onTouchMove);
                bind(document, _this.touchEvents.touchEnd, onTouchEnd);
            }
            if (params.autoResize) {
                bind(window, "resize", _this.resizeFix);
            }
            addSlideEvents();
            _this._wheelEvent = false;
            if (params.mousewheelControl) {
                if (document.onmousewheel !== undefined) {
                    _this._wheelEvent = "mousewheel";
                }
                try {
                    WheelEvent("wheel");
                    _this._wheelEvent = "wheel";
                } catch (e) {}
                if (!_this._wheelEvent) {
                    _this._wheelEvent = "DOMMouseScroll";
                }
                if (_this._wheelEvent) {
                    bind(_this.container, _this._wheelEvent, handleMousewheel);
                }
            }
            if (params.keyboardControl) {
                bind(document, "keydown", handleKeyboardKeys);
            }
            if (params.updateOnImagesReady) {
                _this.imagesToLoad = $$("img", _this.container);
                for (var i = 0; i < _this.imagesToLoad.length; i++) {
                    _loadImage(_this.imagesToLoad[i].getAttribute("src"));
                }
            }
            function _loadImage(src) {
                var image = new Image();
                image.onload = function () {
                    _this.imagesLoaded++;
                    if (_this.imagesLoaded == _this.imagesToLoad.length) {
                        _this.reInit();
                        if (params.onImagesReady) _this.fireCallback(params.onImagesReady, _this);
                    }
                };
                image.src = src;
            }
        }
        _this.destroy = function (removeResizeFix) {
            var unbind = _this.h.removeEventListener;
            if (!_this.browser.ie10) {
                if (_this.support.touch) {
                    unbind(_this.wrapper, "touchstart", onTouchStart);
                    unbind(_this.wrapper, "touchmove", onTouchMove);
                    unbind(_this.wrapper, "touchend", onTouchEnd);
                }
                if (params.simulateTouch) {
                    unbind(_this.wrapper, "mousedown", onTouchStart);
                    unbind(document, "mousemove", onTouchMove);
                    unbind(document, "mouseup", onTouchEnd);
                }
            } else {
                unbind(_this.wrapper, _this.touchEvents.touchStart, onTouchStart);
                unbind(document, _this.touchEvents.touchMove, onTouchMove);
                unbind(document, _this.touchEvents.touchEnd, onTouchEnd);
            }
            if (params.autoResize) {
                unbind(window, "resize", _this.resizeFix);
            }
            removeSlideEvents();
            if (params.paginationClickable) {
                removePaginationEvents();
            }
            if (params.mousewheelControl && _this._wheelEvent) {
                unbind(_this.container, _this._wheelEvent, handleMousewheel);
            }
            if (params.keyboardControl) {
                unbind(document, "keydown", handleKeyboardKeys);
            }
            if (params.autoplay) {
                _this.stopAutoplay();
            }
            _this.callPlugins("onDestroy");
            _this = null;
        };
        function addSlideEvents() {
            var bind = _this.h.addEventListener,
                i;
            if (params.preventLinks) {
                var links = $$("a", _this.container);
                for (i = 0; i < links.length; i++) {
                    bind(links[i], "click", preventClick);
                }
            }
            if (params.releaseFormElements) {
                var formElements = $$("input, textarea, select", _this.container);
                for (i = 0; i < formElements.length; i++) {
                    bind(formElements[i], _this.touchEvents.touchStart, releaseForms, true);
                }
            }
            if (params.onSlideClick) {
                for (i = 0; i < _this.slides.length; i++) {
                    bind(_this.slides[i], "click", slideClick);
                }
            }
            if (params.onSlideTouch) {
                for (i = 0; i < _this.slides.length; i++) {
                    bind(_this.slides[i], _this.touchEvents.touchStart, slideTouch);
                }
            }
        }
        function removeSlideEvents() {
            var unbind = _this.h.removeEventListener,
                i;
            if (params.onSlideClick) {
                for (i = 0; i < _this.slides.length; i++) {
                    unbind(_this.slides[i], "click", slideClick);
                }
            }
            if (params.onSlideTouch) {
                for (i = 0; i < _this.slides.length; i++) {
                    unbind(_this.slides[i], _this.touchEvents.touchStart, slideTouch);
                }
            }
            if (params.releaseFormElements) {
                var formElements = $$("input, textarea, select", _this.container);
                for (i = 0; i < formElements.length; i++) {
                    unbind(formElements[i], _this.touchEvents.touchStart, releaseForms, true);
                }
            }
            if (params.preventLinks) {
                var links = $$("a", _this.container);
                for (i = 0; i < links.length; i++) {
                    unbind(links[i], "click", preventClick);
                }
            }
        }
        function handleKeyboardKeys(e) {
            var kc = e.keyCode || e.charCode;
            if (kc == 37 || kc == 39 || kc == 38 || kc == 40) {
                var inView = false;
                var swiperOffset = _this.h.getOffset(_this.container);
                var scrollLeft = _this.h.windowScroll().left;
                var scrollTop = _this.h.windowScroll().top;
                var windowWidth = _this.h.windowWidth();
                var windowHeight = _this.h.windowHeight();
                var swiperCoord = [
                    [swiperOffset.left, swiperOffset.top],
                    [swiperOffset.left + _this.width, swiperOffset.top],
                    [swiperOffset.left, swiperOffset.top + _this.height],
                    [swiperOffset.left + _this.width, swiperOffset.top + _this.height],
                ];
                for (var i = 0; i < swiperCoord.length; i++) {
                    var point = swiperCoord[i];
                    if (point[0] >= scrollLeft && point[0] <= scrollLeft + windowWidth && point[1] >= scrollTop && point[1] <= scrollTop + windowHeight) {
                        inView = true;
                    }
                }
                if (!inView) return;
            }
            if (isH) {
                if (kc == 37 || kc == 39) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc == 39) _this.swipeNext();
                if (kc == 37) _this.swipePrev();
            } else {
                if (kc == 38 || kc == 40) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc == 40) _this.swipeNext();
                if (kc == 38) _this.swipePrev();
            }
        }
        var allowScrollChange = true;
        var lastScrollTime = new Date().getTime();
        function handleMousewheel(e) {
            var we = _this._wheelEvent;
            var delta = 0;
            if (e.detail) delta = -e.detail;
            else if (we == "mousewheel") delta = e.wheelDelta;
            else if (we == "DOMMouseScroll") delta = -e.detail;
            else if (we == "wheel") {
                delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? -e.deltaX : -e.deltaY;
            }
            if (!params.freeMode) {
                if (delta < 0) _this.swipeNext();
                else _this.swipePrev();
            } else {
                var position = _this.getWrapperTranslate() + delta;
                if (position > 0) position = 0;
                if (position < -maxWrapperPosition()) position = -maxWrapperPosition();
                _this.setWrapperTransition(0);
                _this.setWrapperTranslate(position);
                _this.updateActiveSlide(position);
            }
            if (params.autoplay) _this.stopAutoplay();
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
        }
        if (params.grabCursor) {
            var containerStyle = _this.container.style;
            containerStyle.cursor = "move";
            containerStyle.cursor = "grab";
            containerStyle.cursor = "-moz-grab";
            containerStyle.cursor = "-webkit-grab";
        }
        _this.allowSlideClick = true;
        function slideClick(event) {
            if (_this.allowSlideClick) {
                setClickedSlide(event);
                this.fireCallback(params.onSlideClick, _this, event);
            }
        }
        function slideTouch(event) {
            setClickedSlide(event);
            _this.fireCallback(params.onSlideTouch, _this, event);
        }
        function setClickedSlide(event) {
            if (!event.currentTarget) {
                var element = event.srcElement;
                do {
                    if (element.className.indexOf(params.slideClass) > -1) {
                        break;
                    }
                } while ((element = element.parentNode));
                _this.clickedSlide = element;
            } else {
                _this.clickedSlide = event.currentTarget;
            }
            _this.clickedSlideIndex = _this.slides.indexOf(_this.clickedSlide);
            _this.clickedSlideLoopIndex = _this.clickedSlideIndex - (_this.loopedSlides || 0);
        }
        _this.allowLinks = true;
        function preventClick(e) {
            if (!_this.allowLinks) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                return false;
            }
        }
        function releaseForms(e) {
            if (e.stopPropagation) e.stopPropagation();
            else e.returnValue = false;
            return false;
        }
        var isTouchEvent = false;
        var allowThresholdMove;
        var allowMomentumBounce = true;
        function onTouchStart(event) {
            if (jQuery(event.target).parents(".wpb_gallery").length > 0 && jQuery(event.target).parents(".swiper-container").attr("data-desktop-swipe") == "false" && !Modernizr.touch) {
                return false;
            }
            if (jQuery(event.target).parents(".swiper-container").find(".swiper-slide").length == 1) {
                return false;
            }
            if (jQuery(event.target).parents(".swiper-container").find(".swiper-slide.duplicate-transition").length > 0) return false;
            if (params.preventLinks) _this.allowLinks = true;
            if (_this.isTouched || params.onlyExternal) {
                return false;
            }
            if (params.noSwiping && (event.target || event.srcElement) && noSwipingSlide(event.target || event.srcElement)) return false;
            allowMomentumBounce = false;
            _this.isTouched = true;
            isTouchEvent = event.type == "touchstart";
            if (!isTouchEvent || event.targetTouches.length == 1) {
                _this.callPlugins("onTouchStartBegin");
                if (!isTouchEvent) {
                    if (event.preventDefault) event.preventDefault();
                    else event.returnValue = false;
                }
                var pageX = isTouchEvent ? event.targetTouches[0].pageX : event.pageX || event.clientX;
                var pageY = isTouchEvent ? event.targetTouches[0].pageY : event.pageY || event.clientY;
                _this.touches.startX = _this.touches.currentX = pageX;
                _this.touches.startY = _this.touches.currentY = pageY;
                _this.touches.start = _this.touches.current = isH ? pageX : pageY;
                _this.setWrapperTransition(0);
                _this.positions.start = _this.positions.current = _this.getWrapperTranslate();
                _this.setWrapperTranslate(_this.positions.start);
                _this.times.start = new Date().getTime();
                isScrolling = undefined;
                if (params.moveStartThreshold > 0) allowThresholdMove = false;
                if (params.onTouchStart) _this.fireCallback(params.onTouchStart, _this);
                _this.callPlugins("onTouchStartEnd");
            }
        }
        var velocityPrevPosition, velocityPrevTime;
        function onTouchMove(event) {
            if (!_this.isTouched || params.onlyExternal) return;
            if (isTouchEvent && event.type == "mousemove") return;
            var pageX = isTouchEvent ? event.targetTouches[0].pageX : event.pageX || event.clientX;
            var pageY = isTouchEvent ? event.targetTouches[0].pageY : event.pageY || event.clientY;
            if (typeof isScrolling === "undefined" && isH) {
                isScrolling = !!(isScrolling || Math.abs(pageY - _this.touches.startY) > Math.abs(pageX - _this.touches.startX));
            }
            if (typeof isScrolling === "undefined" && !isH) {
                isScrolling = !!(isScrolling || Math.abs(pageY - _this.touches.startY) < Math.abs(pageX - _this.touches.startX));
            }
            if (isScrolling) {
                _this.isTouched = false;
                return;
            }
            if (event.assignedToSwiper) {
                _this.isTouched = false;
                return;
            }
            event.assignedToSwiper = true;
            if (params.preventLinks) {
                _this.allowLinks = false;
            }
            if (params.onSlideClick) {
                _this.allowSlideClick = false;
            }
            if (params.autoplay) {
                _this.stopAutoplay();
            }
            if (!isTouchEvent || event.touches.length == 1) {
                if (!_this.isMoved) {
                    _this.callPlugins("onTouchMoveStart");
                    if (params.loop) {
                        _this.fixLoop();
                        _this.positions.start = _this.getWrapperTranslate();
                    }
                    if (params.onTouchMoveStart) _this.fireCallback(params.onTouchMoveStart, _this);
                }
                _this.isMoved = true;
                if (event.preventDefault) event.preventDefault();
                else event.returnValue = false;
                _this.touches.current = isH ? pageX : pageY;
                _this.positions.current = (_this.touches.current - _this.touches.start) * params.touchRatio + _this.positions.start;
                if (_this.positions.current > 0 && params.onResistanceBefore) {
                    _this.fireCallback(params.onResistanceBefore, _this, _this.positions.current);
                }
                if (_this.positions.current < -maxWrapperPosition() && params.onResistanceAfter) {
                    _this.fireCallback(params.onResistanceAfter, _this, Math.abs(_this.positions.current + maxWrapperPosition()));
                }
                if (params.resistance && params.resistance != "100%") {
                    if (_this.positions.current > 0) {
                        var resistance = 1 - _this.positions.current / containerSize / 2;
                        if (resistance < 0.5) _this.positions.current = containerSize / 2;
                        else _this.positions.current = _this.positions.current * resistance;
                    }
                    if (_this.positions.current < -maxWrapperPosition()) {
                        var diff = (_this.touches.current - _this.touches.start) * params.touchRatio + (maxWrapperPosition() + _this.positions.start);
                        var resistance = (containerSize + diff) / containerSize;
                        var newPos = _this.positions.current - (diff * (1 - resistance)) / 2;
                        var stopPos = -maxWrapperPosition() - containerSize / 2;
                        if (newPos < stopPos || resistance <= 0) _this.positions.current = stopPos;
                        else _this.positions.current = newPos;
                    }
                }
                if (params.resistance && params.resistance == "100%") {
                    if (_this.positions.current > 0 && !(params.freeMode && !params.freeModeFluid)) {
                        _this.positions.current = 0;
                    }
                    if (_this.positions.current < -maxWrapperPosition() && !(params.freeMode && !params.freeModeFluid)) {
                        _this.positions.current = -maxWrapperPosition();
                    }
                }
                if (!params.followFinger) return;
                if (!params.moveStartThreshold) {
                    _this.setWrapperTranslate(_this.positions.current);
                } else {
                    if (Math.abs(_this.touches.current - _this.touches.start) > params.moveStartThreshold || allowThresholdMove) {
                        allowThresholdMove = true;
                        _this.setWrapperTranslate(_this.positions.current);
                    } else {
                        _this.positions.current = _this.positions.start;
                    }
                }
                if (params.freeMode || params.watchActiveIndex) {
                    _this.updateActiveSlide(_this.positions.current);
                }
                if (params.grabCursor) {
                    _this.container.style.cursor = "move";
                    _this.container.style.cursor = "grabbing";
                    _this.container.style.cursor = "-moz-grabbing";
                    _this.container.style.cursor = "-webkit-grabbing";
                }
                if (!velocityPrevPosition) velocityPrevPosition = _this.touches.current;
                if (!velocityPrevTime) velocityPrevTime = new Date().getTime();
                _this.velocity = (_this.touches.current - velocityPrevPosition) / (new Date().getTime() - velocityPrevTime) / 2;
                if (Math.abs(_this.touches.current - velocityPrevPosition) < 2) _this.velocity = 0;
                velocityPrevPosition = _this.touches.current;
                velocityPrevTime = new Date().getTime();
                _this.callPlugins("onTouchMoveEnd");
                if (params.onTouchMove) _this.fireCallback(params.onTouchMove, _this);
                return false;
            }
        }
        function onTouchEnd(event) {
            if (isScrolling) {
                _this.swipeReset();
            }
            if (params.onlyExternal || !_this.isTouched) {
                return;
            }
            _this.isTouched = false;
            if (params.grabCursor) {
                _this.container.style.cursor = "move";
                _this.container.style.cursor = "grab";
                _this.container.style.cursor = "-moz-grab";
                _this.container.style.cursor = "-webkit-grab";
            }
            if (!_this.positions.current && _this.positions.current !== 0) {
                _this.positions.current = _this.positions.start;
            }
            if (params.followFinger) {
                _this.setWrapperTranslate(_this.positions.current);
            }
            _this.times.end = new Date().getTime();
            _this.touches.diff = _this.touches.current - _this.touches.start;
            _this.touches.abs = Math.abs(_this.touches.diff);
            _this.positions.diff = _this.positions.current - _this.positions.start;
            _this.positions.abs = Math.abs(_this.positions.diff);
            var diff = _this.positions.diff;
            var diffAbs = _this.positions.abs;
            var timeDiff = _this.times.end - _this.times.start;
            if (diffAbs < 5 && timeDiff < 300 && _this.allowLinks == false) {
                if (!params.freeMode && diffAbs != 0) {
                    _this.swipeReset();
                }
                if (params.preventLinks) {
                    _this.allowLinks = true;
                }
                if (params.onSlideClick) {
                    _this.allowSlideClick = true;
                }
            }
            setTimeout(function () {
                if (params.preventLinks) {
                    _this.allowLinks = true;
                }
                if (params.onSlideClick) {
                    _this.allowSlideClick = true;
                }
            }, 100);
            var maxPosition = maxWrapperPosition();
            if (!_this.isMoved && params.freeMode) {
                _this.isMoved = false;
                if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
                _this.callPlugins("onTouchEnd");
                return;
            }
            if (!_this.isMoved || _this.positions.current > 0 || _this.positions.current < -maxPosition) {
                _this.swipeReset();
                if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
                _this.callPlugins("onTouchEnd");
                return;
            }
            _this.isMoved = false;
            if (params.freeMode) {
                if (params.freeModeFluid) {
                    var momentumDuration = 1000 * params.momentumRatio;
                    var momentumDistance = _this.velocity * momentumDuration;
                    var newPosition = _this.positions.current + momentumDistance;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(_this.velocity) * 20 * params.momentumBounceRatio;
                    if (newPosition < -maxPosition) {
                        if (params.momentumBounce && _this.support.transitions) {
                            if (newPosition + maxPosition < -bounceAmount) newPosition = -maxPosition - bounceAmount;
                            afterBouncePosition = -maxPosition;
                            doBounce = true;
                            allowMomentumBounce = true;
                        } else newPosition = -maxPosition;
                    }
                    if (newPosition > 0) {
                        if (params.momentumBounce && _this.support.transitions) {
                            if (newPosition > bounceAmount) newPosition = bounceAmount;
                            afterBouncePosition = 0;
                            doBounce = true;
                            allowMomentumBounce = true;
                        } else newPosition = 0;
                    }
                    if (_this.velocity != 0) momentumDuration = Math.abs((newPosition - _this.positions.current) / _this.velocity);
                    _this.setWrapperTranslate(newPosition);
                    _this.setWrapperTransition(momentumDuration);
                    if (params.momentumBounce && doBounce) {
                        _this.wrapperTransitionEnd(function () {
                            if (!allowMomentumBounce) return;
                            if (params.onMomentumBounce) params.onMomentumBounce(_this);
                            _this.setWrapperTranslate(afterBouncePosition);
                            _this.setWrapperTransition(300);
                        });
                    }
                    _this.updateActiveSlide(newPosition);
                }
                if (!params.freeModeFluid || timeDiff >= 300) _this.updateActiveSlide(_this.positions.current);
                if (params.onTouchEnd) params.onTouchEnd(_this);
                _this.callPlugins("onTouchEnd");
                return;
            }
            direction = diff < 0 ? "toNext" : "toPrev";
            if (direction == "toNext" && timeDiff <= 300) {
                if (diffAbs < 30 || !params.shortSwipes) _this.swipeReset();
                else _this.swipeNext(true);
            }
            if (direction == "toPrev" && timeDiff <= 300) {
                if (diffAbs < 30 || !params.shortSwipes) _this.swipeReset();
                else _this.swipePrev(true);
            }
            var targetSlideSize = 0;
            if (params.slidesPerView == "auto") {
                var currentPosition = Math.abs(_this.getWrapperTranslate());
                var slidesOffset = 0;
                var _slideSize;
                for (var i = 0; i < _this.slides.length; i++) {
                    _slideSize = isH ? _this.slides[i].getWidth(true) : _this.slides[i].getHeight(true);
                    slidesOffset += _slideSize;
                    if (slidesOffset > currentPosition) {
                        targetSlideSize = _slideSize;
                        break;
                    }
                }
                if (targetSlideSize > containerSize) targetSlideSize = containerSize;
            } else {
                targetSlideSize = slideSize * params.slidesPerView;
            }
            if (direction == "toNext" && timeDiff > 300) {
                if (diffAbs >= targetSlideSize * 0.5) {
                    _this.swipeNext(true);
                } else {
                    _this.swipeReset();
                }
            }
            if (direction == "toPrev" && timeDiff > 300) {
                if (diffAbs >= targetSlideSize * 0.5) {
                    _this.swipePrev(true);
                } else {
                    _this.swipeReset();
                }
            }
            if (params.onTouchEnd) params.onTouchEnd(_this);
            _this.callPlugins("onTouchEnd");
        }
        function noSwipingSlide(el) {
            var noSwiping = false;
            do {
                if (el.className.indexOf(params.noSwipingClass) > -1) {
                    noSwiping = true;
                }
                el = el.parentElement;
            } while (!noSwiping && el.parentElement && el.className.indexOf(params.wrapperClass) == -1);
            if (!noSwiping && el.className.indexOf(params.wrapperClass) > -1 && el.className.indexOf(params.noSwipingClass) > -1) noSwiping = true;
            return noSwiping;
        }
        _this.swipeNext = function (internal) {
            if (!internal && params.loop) _this.fixLoop();
            _this.callPlugins("onSwipeNext");
            var currentPosition = _this.getWrapperTranslate();
            var newPosition = currentPosition;
            if (params.slidesPerView == "auto") {
                for (var i = 0; i < _this.snapGrid.length; i++) {
                    if (-currentPosition >= _this.snapGrid[i] && -currentPosition < _this.snapGrid[i + 1]) {
                        newPosition = -_this.snapGrid[i + 1];
                        break;
                    }
                }
            } else {
                var groupSize = slideSize * params.slidesPerGroup;
                newPosition = -(Math.floor(Math.abs(currentPosition) / Math.floor(groupSize)) * groupSize + groupSize);
            }
            if (newPosition < -maxWrapperPosition()) {
                newPosition = -maxWrapperPosition();
            }
            if (newPosition == currentPosition) {
                return false;
            }
            swipeToPosition(newPosition, "next");
            return true;
        };
        _this.swipePrev = function (internal) {
            if (!internal && params.loop) _this.fixLoop();
            if (!internal && params.autoplay) _this.stopAutoplay();
            _this.callPlugins("onSwipePrev");
            var currentPosition = Math.ceil(_this.getWrapperTranslate());
            var newPosition;
            if (params.slidesPerView == "auto") {
                newPosition = 0;
                for (var i = 1; i < _this.snapGrid.length; i++) {
                    if (-currentPosition == _this.snapGrid[i]) {
                        newPosition = -_this.snapGrid[i - 1];
                        break;
                    }
                    if (-currentPosition > _this.snapGrid[i] && -currentPosition < _this.snapGrid[i + 1]) {
                        newPosition = -_this.snapGrid[i];
                        break;
                    }
                }
            } else {
                var groupSize = slideSize * params.slidesPerGroup;
                newPosition = -(Math.ceil(-currentPosition / groupSize) - 1) * groupSize;
            }
            if (newPosition > 0) newPosition = 0;
            if (newPosition == currentPosition) {
                return false;
            }
            swipeToPosition(newPosition, "prev");
            return true;
        };
        _this.swipeReset = function () {
            _this.callPlugins("onSwipeReset");
            var currentPosition = _this.getWrapperTranslate();
            var groupSize = slideSize * params.slidesPerGroup;
            var newPosition;
            var maxPosition = -maxWrapperPosition();
            if (params.slidesPerView == "auto") {
                newPosition = 0;
                for (var i = 0; i < _this.snapGrid.length; i++) {
                    if (-currentPosition === _this.snapGrid[i]) return;
                    if (-currentPosition >= _this.snapGrid[i] && -currentPosition < _this.snapGrid[i + 1]) {
                        if (_this.positions.diff > 0) newPosition = -_this.snapGrid[i + 1];
                        else newPosition = -_this.snapGrid[i];
                        break;
                    }
                }
                if (-currentPosition >= _this.snapGrid[_this.snapGrid.length - 1]) newPosition = -_this.snapGrid[_this.snapGrid.length - 1];
                if (currentPosition <= -maxWrapperPosition()) newPosition = -maxWrapperPosition();
            } else {
                newPosition = currentPosition < 0 ? Math.round(currentPosition / groupSize) * groupSize : 0;
            }
            if (params.scrollContainer) {
                newPosition = currentPosition < 0 ? currentPosition : 0;
            }
            if (newPosition < -maxWrapperPosition()) {
                newPosition = -maxWrapperPosition();
            }
            if (params.scrollContainer && containerSize > slideSize) {
                newPosition = 0;
            }
            if (newPosition == currentPosition) {
                return false;
            }
            swipeToPosition(newPosition, "reset");
            return true;
        };
        _this.swipeTo = function (index, speed, runCallbacks) {
            index = parseInt(index, 10);
            _this.callPlugins("onSwipeTo", { index: index, speed: speed });
            if (params.loop) index = index + _this.loopedSlides;
            var currentPosition = _this.getWrapperTranslate();
            if (index > _this.slides.length - 1 || index < 0) {
                return;
            }
            var newPosition;
            if (params.slidesPerView == "auto") {
                newPosition = -_this.slidesGrid[index];
            } else {
                newPosition = -index * slideSize;
            }
            if (newPosition < -maxWrapperPosition()) {
                newPosition = -maxWrapperPosition();
            }
            if (newPosition == currentPosition) {
                return false;
            }
            runCallbacks = runCallbacks === false ? false : true;
            swipeToPosition(newPosition, "to", { index: index, speed: speed, runCallbacks: runCallbacks });
            return true;
        };
        function swipeToPosition(newPosition, action, toOptions) {
            var speed = action == "to" && toOptions.speed >= 0 ? toOptions.speed : params.speed;
            var timeOld = +new Date();
            if (_this.support.transitions || !params.DOMAnimation) {
                _this.setWrapperTranslate(newPosition);
                _this.setWrapperTransition(speed);
            } else {
                var currentPosition = _this.getWrapperTranslate();
                var animationStep = Math.ceil(((newPosition - currentPosition) / speed) * (1000 / 60));
                var direction = currentPosition > newPosition ? "toNext" : "toPrev";
                var condition = direction == "toNext" ? currentPosition > newPosition : currentPosition < newPosition;
                if (_this._DOMAnimating) return;
                anim();
            }
            function anim() {
                var timeNew = +new Date();
                var time = timeNew - timeOld;
                currentPosition += (animationStep * time) / (1000 / 60);
                condition = direction == "toNext" ? currentPosition > newPosition : currentPosition < newPosition;
                if (condition) {
                    _this.setWrapperTranslate(Math.round(currentPosition));
                    _this._DOMAnimating = true;
                    window.setTimeout(function () {
                        anim();
                    }, 1000 / 60);
                } else {
                    if (params.onSlideChangeEnd) {
                        _this.fireCallback(params.onSlideChangeEnd, _this);
                    }
                    _this.setWrapperTranslate(newPosition);
                    _this._DOMAnimating = false;
                }
            }
            _this.updateActiveSlide(newPosition);
            if (params.onSlideNext && action == "next") {
                _this.fireCallback(params.onSlideNext, _this, newPosition);
            }
            if (params.onSlidePrev && action == "prev") {
                _this.fireCallback(params.onSlidePrev, _this, newPosition);
            }
            if (params.onSlideReset && action == "reset") {
                _this.fireCallback(params.onSlideReset, _this, newPosition);
            }
            if (action == "next" || action == "prev" || (action == "to" && toOptions.runCallbacks == true)) slideChangeCallbacks(action);
        }
        _this._queueStartCallbacks = false;
        _this._queueEndCallbacks = false;
        function slideChangeCallbacks(direction) {
            _this.callPlugins("onSlideChangeStart");
            if (params.onSlideChangeStart) {
                if (params.queueStartCallbacks && _this.support.transitions) {
                    if (_this._queueStartCallbacks) {
                        return;
                    }
                    _this._queueStartCallbacks = true;
                    _this.fireCallback(params.onSlideChangeStart, _this, direction);
                    _this.wrapperTransitionEnd(function () {
                        _this._queueStartCallbacks = false;
                    });
                } else _this.fireCallback(params.onSlideChangeStart, _this, direction);
            }
            if (params.onSlideChangeEnd) {
                if (_this.support.transitions) {
                    if (params.queueEndCallbacks) {
                        if (_this._queueEndCallbacks) {
                            return;
                        }
                        _this._queueEndCallbacks = true;
                        _this.wrapperTransitionEnd(function (swiper) {
                            setTimeout(function () {
                                if (params.loop) _this.fixLoop();
                            }, 50);
                            _this.fireCallback(params.onSlideChangeEnd, swiper, direction);
                        });
                    } else
                        _this.wrapperTransitionEnd(function (swiper) {
                            _this.fireCallback(params.onSlideChangeEnd, swiper, direction);
                        });
                } else {
                    if (!params.DOMAnimation) {
                        setTimeout(function () {
                            _this.fireCallback(params.onSlideChangeStart, _this, direction);
                        }, 10);
                    }
                }
            }
        }
        _this.updateActiveSlide = function (position) {
            if (!_this.initialized) return;
            if (_this.slides.length == 0) return;
            _this.previousIndex = _this.activeIndex;
            if (typeof position == "undefined") position = _this.getWrapperTranslate();
            if (position > 0) position = 0;
            if (params.slidesPerView == "auto") {
                var slidesOffset = 0;
                _this.activeIndex = _this.slidesGrid.indexOf(-position);
                if (_this.activeIndex < 0) {
                    for (var i = 0; i < _this.slidesGrid.length - 1; i++) {
                        if (-position > _this.slidesGrid[i] && -position < _this.slidesGrid[i + 1]) {
                            break;
                        }
                    }
                    var leftDistance = Math.abs(_this.slidesGrid[i] + position);
                    var rightDistance = Math.abs(_this.slidesGrid[i + 1] + position);
                    if (leftDistance <= rightDistance) _this.activeIndex = i;
                    else _this.activeIndex = i + 1;
                }
            } else {
                _this.activeIndex = Math[params.visibilityFullFit ? "ceil" : "round"](-position / slideSize);
            }
            if (_this.activeIndex == _this.slides.length) _this.activeIndex = _this.slides.length - 1;
            if (_this.activeIndex < 0) _this.activeIndex = 0;
            if (!_this.slides[_this.activeIndex]) return;
            _this.calcVisibleSlides(position);
            var activeClassRegexp = new RegExp("\\s*" + params.slideActiveClass);
            var inViewClassRegexp = new RegExp("\\s*" + params.slideVisibleClass);
            for (var i = 0; i < _this.slides.length; i++) {
                _this.slides[i].className = _this.slides[i].className.replace(activeClassRegexp, "").replace(inViewClassRegexp, "");
                if (_this.visibleSlides.indexOf(_this.slides[i]) >= 0) {
                    _this.slides[i].className += " " + params.slideVisibleClass;
                }
            }
            _this.slides[_this.activeIndex].className += " " + params.slideActiveClass;
            if (params.loop) {
                var ls = _this.loopedSlides;
                _this.activeLoopIndex = _this.activeIndex - ls;
                if (_this.activeLoopIndex >= _this.slides.length - ls * 2) {
                    _this.activeLoopIndex = _this.slides.length - ls * 2 - _this.activeLoopIndex;
                }
                if (_this.activeLoopIndex < 0) {
                    _this.activeLoopIndex = _this.slides.length - ls * 2 + _this.activeLoopIndex;
                }
            } else {
                _this.activeLoopIndex = _this.activeIndex;
            }
            if (params.pagination) {
                _this.updatePagination(position);
            }
        };
        _this.createPagination = function (firstInit) {
            if (params.paginationClickable && _this.paginationButtons) {
                removePaginationEvents();
            }
            var paginationHTML = "";
            var numOfSlides = _this.slides.length;
            var numOfButtons = numOfSlides;
            if (params.loop) {
                numOfButtons -= _this.loopedSlides * 2;
            }
            for (var i = 0; i < numOfButtons; i++) {
                paginationHTML += "<" + params.paginationElement + ' class="' + params.paginationElementClass + '"></' + params.paginationElement + ">";
            }
            _this.paginationContainer = params.pagination.nodeType ? params.pagination : $$(params.pagination)[0];
            _this.paginationContainer.innerHTML = paginationHTML;
            _this.paginationButtons = $$("." + params.paginationElementClass, _this.paginationContainer);
            if (!firstInit) {
                _this.updatePagination();
            }
            _this.callPlugins("onCreatePagination");
            if (params.paginationClickable) {
                addPaginationEvents();
            }
        };
        function removePaginationEvents() {
            var pagers = _this.paginationButtons;
            for (var i = 0; i < pagers.length; i++) {
                _this.h.removeEventListener(pagers[i], "click", paginationClick);
            }
        }
        function addPaginationEvents() {
            var pagers = _this.paginationButtons;
            for (var i = 0; i < pagers.length; i++) {
                _this.h.addEventListener(pagers[i], "click", paginationClick);
            }
        }
        function paginationClick(e) {
            var index;
            var target = e.target || e.srcElement;
            var pagers = _this.paginationButtons;
            for (var i = 0; i < pagers.length; i++) {
                if (target === pagers[i]) index = i;
            }
            _this.swipeTo(index);
        }
        _this.updatePagination = function (position) {
            if (!params.pagination) return;
            if (_this.slides.length < 1) return;
            var activePagers = $$("." + params.paginationActiveClass, _this.paginationContainer);
            if (!activePagers) return;
            var pagers = _this.paginationButtons;
            if (pagers.length == 0) return;
            for (var i = 0; i < pagers.length; i++) {
                pagers[i].className = params.paginationElementClass;
            }
            var indexOffset = params.loop ? _this.loopedSlides : 0;
            if (params.paginationAsRange) {
                if (!_this.visibleSlides) _this.calcVisibleSlides(position);
                var visibleIndexes = [];
                for (var i = 0; i < _this.visibleSlides.length; i++) {
                    var visIndex = _this.slides.indexOf(_this.visibleSlides[i]) - indexOffset;
                    if (params.loop && visIndex < 0) {
                        visIndex = _this.slides.length - _this.loopedSlides * 2 + visIndex;
                    }
                    if (params.loop && visIndex >= _this.slides.length - _this.loopedSlides * 2) {
                        visIndex = _this.slides.length - _this.loopedSlides * 2 - visIndex;
                        visIndex = Math.abs(visIndex);
                    }
                    visibleIndexes.push(visIndex);
                }
                for (i = 0; i < visibleIndexes.length; i++) {
                    if (pagers[visibleIndexes[i]]) pagers[visibleIndexes[i]].className += " " + params.paginationVisibleClass;
                }
                if (params.loop) {
                    pagers[_this.activeLoopIndex].className += " " + params.paginationActiveClass;
                } else {
                    pagers[_this.activeIndex].className += " " + params.paginationActiveClass;
                }
            } else {
                if (params.loop) {
                    pagers[_this.activeLoopIndex].className += " " + params.paginationActiveClass + " " + params.paginationVisibleClass;
                } else {
                    pagers[_this.activeIndex].className += " " + params.paginationActiveClass + " " + params.paginationVisibleClass;
                }
            }
        };
        _this.calcVisibleSlides = function (position) {
            var visibleSlides = [];
            var _slideLeft = 0,
                _slideSize = 0,
                _slideRight = 0;
            if (isH && _this.wrapperLeft > 0) position = position + _this.wrapperLeft;
            if (!isH && _this.wrapperTop > 0) position = position + _this.wrapperTop;
            for (var i = 0; i < _this.slides.length; i++) {
                _slideLeft += _slideSize;
                if (params.slidesPerView == "auto") _slideSize = isH ? _this.h.getWidth(_this.slides[i], true) : _this.h.getHeight(_this.slides[i], true);
                else _slideSize = slideSize;
                _slideRight = _slideLeft + _slideSize;
                var isVisibile = false;
                if (params.visibilityFullFit) {
                    if (_slideLeft >= -position && _slideRight <= -position + containerSize) isVisibile = true;
                    if (_slideLeft <= -position && _slideRight >= -position + containerSize) isVisibile = true;
                } else {
                    if (_slideRight > -position && _slideRight <= -position + containerSize) isVisibile = true;
                    if (_slideLeft >= -position && _slideLeft < -position + containerSize) isVisibile = true;
                    if (_slideLeft < -position && _slideRight > -position + containerSize) isVisibile = true;
                }
                if (isVisibile) visibleSlides.push(_this.slides[i]);
            }
            if (visibleSlides.length == 0) visibleSlides = [_this.slides[_this.activeIndex]];
            _this.visibleSlides = visibleSlides;
        };
        _this.autoPlayIntervalId = undefined;
        _this.startAutoplay = function () {
            if (typeof _this.autoPlayIntervalId !== "undefined") return false;
            if (params.autoplay && !params.loop) {
                _this.autoPlayIntervalId = setInterval(function () {
                    if (!_this.swipeNext(true)) _this.swipeTo(0);
                }, params.autoplay);
            }
            if (params.autoplay && params.loop) {
                _this.autoPlayIntervalId = setInterval(function () {
                    _this.swipeNext();
                }, params.autoplay);
            }
            _this.callPlugins("onAutoplayStart");
        };
        _this.stopAutoplay = function () {
            if (_this.autoPlayIntervalId) clearInterval(_this.autoPlayIntervalId);
            _this.autoPlayIntervalId = undefined;
            _this.callPlugins("onAutoplayStop");
        };
        _this.loopCreated = false;
        _this.removeLoopedSlides = function () {
            if (_this.loopCreated) {
                for (var i = 0; i < _this.slides.length; i++) {
                    if (_this.slides[i].getData("looped") === true) _this.wrapper.removeChild(_this.slides[i]);
                }
            }
        };
        _this.createLoop = function () {
            if (_this.slides.length == 0) return;
            _this.loopedSlides = params.slidesPerView + params.loopAdditionalSlides;
            if (_this.loopedSlides > _this.slides.length) {
                _this.loopedSlides = _this.slides.length;
            }
            var slideFirstHTML = "",
                slideLastHTML = "",
                i;
            for (i = 0; i < _this.loopedSlides; i++) {
                slideFirstHTML += _this.slides[i].outerHTML;
            }
            for (i = _this.slides.length - _this.loopedSlides; i < _this.slides.length; i++) {
                slideLastHTML += _this.slides[i].outerHTML;
            }
            wrapper.innerHTML = slideLastHTML + wrapper.innerHTML + slideFirstHTML;
            _this.loopCreated = true;
            _this.calcSlides();
            for (i = 0; i < _this.slides.length; i++) {
                if (i < _this.loopedSlides || i >= _this.slides.length - _this.loopedSlides) _this.slides[i].setData("looped", true);
            }
            _this.callPlugins("onCreateLoop");
        };
        _this.fixLoop = function () {
            if (_this.params.loop == true) {
                var newIndex;
                if (_this.activeIndex < _this.loopedSlides) {
                    newIndex = _this.slides.length - _this.loopedSlides * 3 + _this.activeIndex;
                    _this.swipeTo(newIndex, 0, false);
                } else if (_this.activeIndex > _this.slides.length - params.slidesPerView * 2) {
                    newIndex = -_this.slides.length + _this.activeIndex + _this.loopedSlides;
                    _this.swipeTo(newIndex, 0, false);
                }
            }
        };
        _this.loadSlides = function () {
            var slidesHTML = "";
            _this.activeLoaderIndex = 0;
            var slides = params.loader.slides;
            var slidesToLoad = params.loader.loadAllSlides ? slides.length : params.slidesPerView * (1 + params.loader.surroundGroups);
            for (var i = 0; i < slidesToLoad; i++) {
                if (params.loader.slidesHTMLType == "outer") slidesHTML += slides[i];
                else {
                    slidesHTML += "<" + params.slideElement + ' class="' + params.slideClass + '" data-swiperindex="' + i + '">' + slides[i] + "</" + params.slideElement + ">";
                }
            }
            _this.wrapper.innerHTML = slidesHTML;
            _this.calcSlides(true);
            if (!params.loader.loadAllSlides) {
                _this.wrapperTransitionEnd(_this.reloadSlides, true);
            }
        };
        _this.reloadSlides = function () {
            var slides = params.loader.slides;
            var newActiveIndex = parseInt(_this.activeSlide().data("swiperindex"), 10);
            if (newActiveIndex < 0 || newActiveIndex > slides.length - 1) {
                return;
            }
            _this.activeLoaderIndex = newActiveIndex;
            var firstIndex = Math.max(0, newActiveIndex - params.slidesPerView * params.loader.surroundGroups);
            var lastIndex = Math.min(newActiveIndex + params.slidesPerView * (1 + params.loader.surroundGroups) - 1, slides.length - 1);
            if (newActiveIndex > 0) {
                var newTransform = -slideSize * (newActiveIndex - firstIndex);
                _this.setWrapperTranslate(newTransform);
                _this.setWrapperTransition(0);
            }
            if (params.loader.logic === "reload") {
                _this.wrapper.innerHTML = "";
                var slidesHTML = "";
                for (var i = firstIndex; i <= lastIndex; i++) {
                    slidesHTML += params.loader.slidesHTMLType == "outer" ? slides[i] : "<" + params.slideElement + ' class="' + params.slideClass + '" data-swiperindex="' + i + '">' + slides[i] + "</" + params.slideElement + ">";
                }
                _this.wrapper.innerHTML = slidesHTML;
            } else {
                var minExistIndex = 1000;
                var maxExistIndex = 0;
                for (var i = 0; i < _this.slides.length; i++) {
                    var index = _this.slides[i].data("swiperindex");
                    if (index < firstIndex || index > lastIndex) {
                        _this.wrapper.removeChild(_this.slides[i]);
                    } else {
                        minExistIndex = Math.min(index, minExistIndex);
                        maxExistIndex = Math.max(index, maxExistIndex);
                    }
                }
                for (var i = firstIndex; i <= lastIndex; i++) {
                    if (i < minExistIndex) {
                        var newSlide = document.createElement(params.slideElement);
                        newSlide.className = params.slideClass;
                        newSlide.setAttribute("data-swiperindex", i);
                        newSlide.innerHTML = slides[i];
                        _this.wrapper.insertBefore(newSlide, _this.wrapper.firstChild);
                    }
                    if (i > maxExistIndex) {
                        var newSlide = document.createElement(params.slideElement);
                        newSlide.className = params.slideClass;
                        newSlide.setAttribute("data-swiperindex", i);
                        newSlide.innerHTML = slides[i];
                        _this.wrapper.appendChild(newSlide);
                    }
                }
            }
            _this.reInit(true);
        };
        function makeSwiper() {
            _this.calcSlides();
            if (params.loader.slides.length > 0 && _this.slides.length == 0) {
                _this.loadSlides();
            }
            if (params.loop) {
                _this.createLoop();
            }
            _this.init();
            initEvents();
            if (params.pagination && params.createPagination) {
                _this.createPagination(true);
            }
            if (params.loop || params.initialSlide > 0) {
                _this.swipeTo(params.initialSlide, 0, false);
            } else {
                _this.updateActiveSlide(0);
            }
            if (params.autoplay) {
                _this.startAutoplay();
            }
        }
        makeSwiper();
    };
    NectarSwiper.prototype = {
        plugins: {},
        wrapperTransitionEnd: function (callback, permanent) {
            var a = this,
                el = a.wrapper,
                events = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
                i;
            function fireCallBack() {
                callback(a);
                if (a.params.queueEndCallbacks) a._queueEndCallbacks = false;
                if (!permanent) {
                    for (i = 0; i < events.length; i++) {
                        a.h.removeEventListener(el, events[i], fireCallBack);
                    }
                }
            }
            if (callback) {
                for (i = 0; i < events.length; i++) {
                    a.h.addEventListener(el, events[i], fireCallBack);
                }
            }
        },
        getWrapperTranslate: function (axis) {
            var el = this.wrapper,
                matrix,
                curTransform,
                curStyle,
                transformMatrix;
            if (typeof axis == "undefined") {
                axis = this.params.mode == "horizontal" ? "x" : "y";
            }
            curStyle = window.getComputedStyle(el, null);
            if (window.WebKitCSSMatrix) {
                transformMatrix = new WebKitCSSMatrix(curStyle.webkitTransform);
            } else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
                matrix = transformMatrix.toString().split(",");
            }
            if (this.support.transforms && this.params.useCSS3Transforms) {
                if (axis == "x") {
                    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
                    else if (matrix.length == 16) curTransform = parseFloat(matrix[12]);
                    else curTransform = parseFloat(matrix[4]);
                }
                if (axis == "y") {
                    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
                    else if (matrix.length == 16) curTransform = parseFloat(matrix[13]);
                    else curTransform = parseFloat(matrix[5]);
                }
            } else {
                if (axis == "x") curTransform = parseFloat(el.style.left, 10) || 0;
                if (axis == "y") curTransform = parseFloat(el.style.top, 10) || 0;
            }
            return curTransform || 0;
        },
        setWrapperTranslate: function (x, y, z) {
            var es = this.wrapper.style,
                coords = { x: 0, y: 0, z: 0 },
                translate;
            if (arguments.length == 3) {
                coords.x = x;
                coords.y = y;
                coords.z = z;
            } else {
                if (typeof y == "undefined") {
                    y = this.params.mode == "horizontal" ? "x" : "y";
                }
                coords[y] = x;
            }
            if (this.support.transforms && this.params.useCSS3Transforms) {
                translate = this.support.transforms3d ? "translate3d(" + coords.x + "px, " + coords.y + "px, " + coords.z + "px)" : "translate(" + coords.x + "px, " + coords.y + "px)";
                es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = translate;
            } else {
                es.left = coords.x + "px";
                es.top = coords.y + "px";
            }
            this.callPlugins("onSetWrapperTransform", coords);
            if (this.params.onSetWrapperTransform) this.fireCallback(this.params.onSetWrapperTransform, this, coords);
        },
        setWrapperTransition: function (duration) {
            var es = this.wrapper.style;
            es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = duration / 1000 + "s";
            this.callPlugins("onSetWrapperTransition", { duration: duration });
            if (this.params.onSetWrapperTransition) this.fireCallback(this.params.onSetWrapperTransition, this, duration);
        },
        h: {
            getWidth: function (el, outer) {
                var width = window.getComputedStyle(el, null).getPropertyValue("width");
                var returnWidth = parseFloat(width);
                if (isNaN(returnWidth) || width.indexOf("%") > 0) {
                    returnWidth = el.offsetWidth - parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-left")) - parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-right"));
                }
                if (outer) returnWidth += parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-right"));
                return returnWidth;
            },
            getHeight: function (el, outer) {
                if (outer) return el.offsetHeight;
                var height = window.getComputedStyle(el, null).getPropertyValue("height");
                var returnHeight = parseFloat(height);
                if (isNaN(returnHeight) || height.indexOf("%") > 0) {
                    returnHeight = el.offsetHeight - parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-top")) - parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-bottom"));
                }
                if (outer) returnHeight += parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-top")) + parseFloat(window.getComputedStyle(el, null).getPropertyValue("padding-bottom"));
                return returnHeight;
            },
            getOffset: function (el) {
                var box = el.getBoundingClientRect();
                var body = document.body;
                var clientTop = el.clientTop || body.clientTop || 0;
                var clientLeft = el.clientLeft || body.clientLeft || 0;
                var scrollTop = window.pageYOffset || el.scrollTop;
                var scrollLeft = window.pageXOffset || el.scrollLeft;
                if (document.documentElement && !window.pageYOffset) {
                    scrollTop = document.documentElement.scrollTop;
                    scrollLeft = document.documentElement.scrollLeft;
                }
                return { top: box.top + scrollTop - clientTop, left: box.left + scrollLeft - clientLeft };
            },
            windowWidth: function () {
                if (window.innerWidth) {
                    return window.innerWidth;
                } else if (document.documentElement && document.documentElement.clientWidth) {
                    return document.documentElement.clientWidth;
                }
            },
            windowHeight: function () {
                if (window.innerHeight) {
                    return window.innerHeight;
                } else if (document.documentElement && document.documentElement.clientHeight) {
                    return document.documentElement.clientHeight;
                }
            },
            windowScroll: function () {
                var left = 0,
                    top = 0;
                if (typeof pageYOffset != "undefined") {
                    return { left: window.pageXOffset, top: window.pageYOffset };
                } else if (document.documentElement) {
                    return { left: document.documentElement.scrollLeft, top: document.documentElement.scrollTop };
                }
            },
            addEventListener: function (el, event, listener, useCapture) {
                if (typeof useCapture == "undefined") {
                    useCapture = false;
                }
                if (el.addEventListener) {
                    el.addEventListener(event, listener, useCapture);
                } else if (el.attachEvent) {
                    el.attachEvent("on" + event, listener);
                }
            },
            removeEventListener: function (el, event, listener, useCapture) {
                if (typeof useCapture == "undefined") {
                    useCapture = false;
                }
                if (el.removeEventListener) {
                    el.removeEventListener(event, listener, useCapture);
                } else if (el.detachEvent) {
                    el.detachEvent("on" + event, listener);
                }
            },
        },
        setTransform: function (el, transform) {
            var es = el.style;
            es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = transform;
        },
        setTranslate: function (el, translate) {
            var es = el.style;
            var pos = { x: translate.x || 0, y: translate.y || 0, z: translate.z || 0 };
            var transformString = this.support.transforms3d ? "translate3d(" + pos.x + "px," + pos.y + "px," + pos.z + "px)" : "translate(" + pos.x + "px," + pos.y + "px)";
            es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = transformString;
            if (!this.support.transforms) {
                es.left = pos.x + "px";
                es.top = pos.y + "px";
            }
        },
        setTransition: function (el, duration) {
            var es = el.style;
            es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = duration + "ms";
        },
        support: {
            touch:
                (window.Modernizr && Modernizr.touch === true) ||
                (function () {
                    return !!("ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch));
                })(),
            transforms3d:
                (window.Modernizr && Modernizr.csstransforms3d === true) ||
                (function () {
                    var div = document.createElement("div").style;
                    return "webkitPerspective" in div || "MozPerspective" in div || "OPerspective" in div || "MsPerspective" in div || "perspective" in div;
                })(),
            transforms:
                (window.Modernizr && Modernizr.csstransforms === true) ||
                (function () {
                    var div = document.createElement("div").style;
                    return "transform" in div || "WebkitTransform" in div || "MozTransform" in div || "msTransform" in div || "MsTransform" in div || "OTransform" in div;
                })(),
            transitions:
                (window.Modernizr && Modernizr.csstransitions === true) ||
                (function () {
                    var div = document.createElement("div").style;
                    return "transition" in div || "WebkitTransition" in div || "MozTransition" in div || "msTransition" in div || "MsTransition" in div || "OTransition" in div;
                })(),
        },
        browser: {
            ie8: (function () {
                var rv = -1;
                if (navigator.appName == "Microsoft Internet Explorer") {
                    var ua = navigator.userAgent;
                    var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
                    if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
                }
                return rv != -1 && rv < 9;
            })(),
            ie10: window.navigator.msPointerEnabled,
        },
    };
    if (window.jQuery || window.Zepto) {
        (function ($) {
            if (!jQuery().nectarswiper) {
                $.fn.nectarswiper = function (params) {
                    var s = new NectarSwiper($(this)[0], params);
                    $(this).data("swiper", s);
                    return s;
                };
            }
        })(window.jQuery || window.Zepto);
    }
    if (typeof module !== "undefined") {
        module.exports = NectarSwiper;
    }
}
NectarSwiper.prototype.plugins.progress = function (a) {
    function b() {
        for (var b = 0; b < a.slides.length; b++) {
            var c = a.slides[b];
            (c.progressSlideSize = e ? a.h.getWidth(c) : a.h.getHeight(c)),
                (c.progressSlideOffset = "offsetLeft" in c ? (e ? c.offsetLeft : c.offsetTop) : e ? c.getOffset().left - a.h.getOffset(a.container).left : c.getOffset().top - a.h.getOffset(a.container).top);
        }
        d = e ? a.h.getWidth(a.wrapper) + a.wrapperLeft + a.wrapperRight - a.width : a.h.getHeight(a.wrapper) + a.wrapperTop + a.wrapperBottom - a.height;
    }
    function c(b) {
        var c,
            b = b || { x: 0, y: 0, z: 0 };
        c = 1 == a.params.centeredSlides ? (e ? -b.x + a.width / 2 : -b.y + a.height / 2) : e ? -b.x : -b.y;
        for (var f = 0; f < a.slides.length; f++) {
            var g = a.slides[f],
                h = 1 == a.params.centeredSlides ? g.progressSlideSize / 2 : 0,
                i = (c - g.progressSlideOffset - h) / g.progressSlideSize;
            g.progress = i;
        }
        (a.progress = e ? -b.x / d : -b.y / d), a.params.onProgressChange && a.fireCallback(a.params.onProgressChange, a);
    }
    var d,
        e = "horizontal" == a.params.mode,
        f = {
            onFirstInit: function () {
                b(), c({ x: a.getWrapperTranslate("x"), y: a.getWrapperTranslate("y") });
            },
            onInit: function () {
                b();
            },
            onSetWrapperTransform: function (a) {
                c(a);
            },
        };
    return f;
};
!(function (n) {
    "function" == typeof define && define.amd
        ? define(["jquery"], function (e) {
              return n(e);
          })
        : "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = n(require("jquery")))
        : n(jQuery);
})(function (n) {
    function e(n) {
        var e = 7.5625,
            t = 2.75;
        return n < 1 / t ? e * n * n : n < 2 / t ? e * (n -= 1.5 / t) * n + 0.75 : n < 2.5 / t ? e * (n -= 2.25 / t) * n + 0.9375 : e * (n -= 2.625 / t) * n + 0.984375;
    }
    void 0 !== n.easing && (n.easing.jswing = n.easing.swing);
    var t = Math.pow,
        u = Math.sqrt,
        r = Math.sin,
        i = Math.cos,
        a = Math.PI,
        o = 1.70158,
        c = 1.525 * o,
        s = (2 * a) / 3,
        f = (2 * a) / 4.5;
    return (
        n.extend(n.easing, {
            def: "easeOutQuad",
            swing: function (e) {
                return n.easing[n.easing.def](e);
            },
            easeInQuad: function (n) {
                return n * n;
            },
            easeOutQuad: function (n) {
                return 1 - (1 - n) * (1 - n);
            },
            easeInOutQuad: function (n) {
                return n < 0.5 ? 2 * n * n : 1 - t(-2 * n + 2, 2) / 2;
            },
            easeInCubic: function (n) {
                return n * n * n;
            },
            easeOutCubic: function (n) {
                return 1 - t(1 - n, 3);
            },
            easeInOutCubic: function (n) {
                return n < 0.5 ? 4 * n * n * n : 1 - t(-2 * n + 2, 3) / 2;
            },
            easeInQuart: function (n) {
                return n * n * n * n;
            },
            easeOutQuart: function (n) {
                return 1 - t(1 - n, 4);
            },
            easeInOutQuart: function (n) {
                return n < 0.5 ? 8 * n * n * n * n : 1 - t(-2 * n + 2, 4) / 2;
            },
            easeInQuint: function (n) {
                return n * n * n * n * n;
            },
            easeOutQuint: function (n) {
                return 1 - t(1 - n, 5);
            },
            easeInOutQuint: function (n) {
                return n < 0.5 ? 16 * n * n * n * n * n : 1 - t(-2 * n + 2, 5) / 2;
            },
            easeInSine: function (n) {
                return 1 - i((n * a) / 2);
            },
            easeOutSine: function (n) {
                return r((n * a) / 2);
            },
            easeInOutSine: function (n) {
                return -(i(a * n) - 1) / 2;
            },
            easeInExpo: function (n) {
                return 0 === n ? 0 : t(2, 10 * n - 10);
            },
            easeOutExpo: function (n) {
                return 1 === n ? 1 : 1 - t(2, -10 * n);
            },
            easeInOutExpo: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : n < 0.5 ? t(2, 20 * n - 10) / 2 : (2 - t(2, -20 * n + 10)) / 2;
            },
            easeInCirc: function (n) {
                return 1 - u(1 - t(n, 2));
            },
            easeOutCirc: function (n) {
                return u(1 - t(n - 1, 2));
            },
            easeInOutCirc: function (n) {
                return n < 0.5 ? (1 - u(1 - t(2 * n, 2))) / 2 : (u(1 - t(-2 * n + 2, 2)) + 1) / 2;
            },
            easeInElastic: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : -t(2, 10 * n - 10) * r((10 * n - 10.75) * s);
            },
            easeOutElastic: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : t(2, -10 * n) * r((10 * n - 0.75) * s) + 1;
            },
            easeInOutElastic: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : n < 0.5 ? (-t(2, 20 * n - 10) * r((20 * n - 11.125) * f)) / 2 : (t(2, -20 * n + 10) * r((20 * n - 11.125) * f)) / 2 + 1;
            },
            easeInBack: function (n) {
                return 2.70158 * n * n * n - o * n * n;
            },
            easeOutBack: function (n) {
                return 1 + 2.70158 * t(n - 1, 3) + o * t(n - 1, 2);
            },
            easeInOutBack: function (n) {
                return n < 0.5 ? (t(2 * n, 2) * (7.189819 * n - c)) / 2 : (t(2 * n - 2, 2) * ((c + 1) * (2 * n - 2) + c) + 2) / 2;
            },
            easeInBounce: function (n) {
                return 1 - e(1 - n);
            },
            easeOutBounce: e,
            easeInOutBounce: function (n) {
                return n < 0.5 ? (1 - e(1 - 2 * n)) / 2 : (1 + e(2 * n - 1)) / 2;
            },
        }),
        n
    );
});
jQuery(document).ready(function ($) {
    "use strict";
    Array.prototype.nectarGetKeyByValue = function (value) {
        for (var prop in this) {
            if (this.hasOwnProperty(prop)) {
                if (this[prop] === value) return prop;
            }
        }
    };
    var doneVideoInit = false;
    var $captionTrans = 0;
    var $loading_bg_storage = $(".first-section .nectar-slider-loading").css("background-image");
    function transparentheaderLoadingCalcs() {
        if ($('body #header-outer[data-transparent-header="true"]').length > 0) {
            if ($("#page-header-bg").length === 0) {
                $(".nectar-slider-wrap.first-section .swiper-container .swiper-wrapper .swiper-slide").addClass("not-loaded");
                if ($(".container-wrap .main-content > .row > div").find(".nectar-slider-wrap.first-section").length > 0) {
                    $(".container-wrap .main-content > .row > div").first().css("padding-top", "0");
                }
                if ($('#header-outer[data-remove-border="true"]').length === 0) {
                    if ($('.first-section .nectar-slider-wrap[data-flexible-height="true"]').length === 0 && $('.first-section .nectar-slider-wrap[data-fullscreen="true"]').length === 0) {
                        $(".first-section .nectar-slider-loading").css({ top: $("#header-space").height(), "background-position": "center " + ($(".first-section .swiper-container").height() / 2 + 15 - $("#header-space").height()) + "px" });
                        $(".first-section .nectar-slider-wrap .nectar-slider-loading .loading-icon").css({ opacity: "1", height: $(".first-section .swiper-container").height() - $("#header-space").height() + "px" });
                    } else {
                        $loading_bg_storage = $(".first-section .nectar-slider-loading").css("background-image");
                        $(".first-section .nectar-slider-loading").css({ top: $("#header-space").height(), "background-image": "none" });
                    }
                }
            }
        }
    }
    transparentheaderLoadingCalcs();
    var $onMobileBrowser = navigator.userAgent.match(/(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/);
    var $smoothSrollWidth = 0;
    var nectarSliderKenBurns;
    function prevArrowAnimation(e) {
        if ($(this).hasClass("inactive")) {
            return false;
        }
        var i = e.data.i;
        var $that = $(this);
        var $timeout;
        if ($(this).parents(".swiper-container").attr("data-loop") != "true") {
            if ($(this).parents(".swiper-container").find(".swiper-slide-active").index() + 1 == 1 && !$("html").hasClass("no-video")) {
                clearTimeout($timeout);
                $timeout = setTimeout(function () {
                    $that.removeClass("inactive");
                }, 700);
                if ($(this).parents(".nectar-slider-wrap ").attr("data-transition") != "fade") {
                    $that = $(this);
                    $(this)
                        .parents(".swiper-container")
                        .animate({ left: 25 + "px" }, 250, function () {
                            $that
                                .parents(".swiper-container")
                                .stop()
                                .animate({ left: 0 + "px" }, 250);
                        });
                }
                $(this).addClass("inactive");
            }
        }
        e.preventDefault();
        $nectarSliders[i].swipePrev();
        if ($(this).parents(".nectar-slider-wrap ").attr("data-transition") === "fade") {
            clearTimeout($timeout);
            $timeout = setTimeout(function () {
                $that.removeClass("inactive");
            }, 800);
            $(this).addClass("inactive");
        }
    }
    function nextArrowAnimation(e) {
        if ($(this).hasClass("inactive")) {
            return false;
        }
        var i = e.data.i;
        var $that = $(this);
        var $slideNum = $(this).parents(".swiper-container").find(".swiper-wrapper > div").length;
        var $timeout;
        if ($(this).parents(".swiper-container").attr("data-loop") != "true") {
            if ($(this).parents(".swiper-container").find(".swiper-slide-active").index() + 1 == $slideNum && !$("html").hasClass("no-video")) {
                clearTimeout($timeout);
                $timeout = setTimeout(function () {
                    $that.removeClass("inactive");
                }, 700);
                if ($(this).parents(".nectar-slider-wrap ").attr("data-transition") != "fade") {
                    $that = $(this);
                    $(this)
                        .parents(".swiper-container")
                        .animate({ left: -25 + "px" }, 250, function () {
                            $that
                                .parents(".swiper-container")
                                .stop()
                                .animate({ left: 0 + "px" }, 250);
                        });
                }
                $(this).addClass("inactive");
            }
        }
        e.preventDefault();
        $nectarSliders[i].swipeNext();
        if ($(this).parents(".nectar-slider-wrap ").attr("data-transition") === "fade") {
            clearTimeout($timeout);
            $timeout = setTimeout(function () {
                $that.removeClass("inactive");
            }, 800);
            $(this).addClass("inactive");
        }
    }
    function prevArrowAnimationWithPreview(e) {
        if ($(this).hasClass("inactive")) {
            return false;
        }
        var i = e.data.i;
        var $that = $(this);
        var $timeout;
        clearTimeout($timeout);
        $timeout = setTimeout(function () {
            $that.removeClass("inactive");
        }, 1000);
        var $timeout2;
        clearTimeout($timeout2);
        $timeout2 = setTimeout(function () {
            $that.removeClass("stophover");
        }, 500);
        $(this).addClass("inactive").addClass("stophover");
        $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").prev(".swiper-slide").removeClass("prev-high-z-index");
        $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").stop().removeClass("prev-move");
        e.preventDefault();
        $nectarSliders[i].swipePrev();
    }
    function nextArrowAnimationWithPreview(e) {
        if ($(this).hasClass("inactive")) {
            return false;
        }
        var i = e.data.i;
        var $that = $(this);
        var $timeout;
        clearTimeout($timeout);
        $timeout = setTimeout(function () {
            $that.removeClass("inactive");
        }, 1000);
        var $timeout2;
        clearTimeout($timeout2);
        $timeout2 = setTimeout(function () {
            $that.removeClass("stophover");
        }, 500);
        $(this).addClass("inactive").addClass("stophover");
        $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").next(".swiper-slide").removeClass("high-z-index");
        $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").stop().removeClass("next-move");
        e.preventDefault();
        $nectarSliders[i].swipeNext();
    }
    function darkSlideNextMouseOver(currentSlider, activeIndex) {
        var $indexAdd = $(currentSlider).find(".swiper-container").attr("data-loop") === "true" ? 2 : 2;
        if (
            $(currentSlider)
                .find(".swiper-slide:nth-child(" + (activeIndex + 1) + ")")
                .attr("data-color-scheme") === "dark"
        ) {
            if (
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ")")
                    .attr("data-color-scheme") === "dark"
            ) {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ") .video-texture")
                    .addClass("half-light-overlay")
                    .addClass("no-trans");
            } else {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ") .video-texture")
                    .addClass("light-overlay")
                    .addClass("no-trans");
            }
        } else {
            if (
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ")")
                    .attr("data-color-scheme") === "light"
            ) {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ") .video-texture")
                    .addClass("half-dark-overlay")
                    .addClass("no-trans");
            } else {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ") .video-texture")
                    .addClass("dark-overlay")
                    .addClass("no-trans");
            }
        }
    }
    function darkSlidePrevMouseOver(currentSlider, activeIndex) {
        var $indexAdd = $(currentSlider).find(".swiper-container").attr("data-loop") === "true" ? 0 : 0;
        if (
            $(currentSlider)
                .find(".swiper-slide:nth-child(" + (activeIndex + 1) + ")")
                .attr("data-color-scheme") === "dark"
        ) {
            if (
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ")")
                    .attr("data-color-scheme") === "dark"
            ) {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ") .video-texture")
                    .addClass("half-light-overlay")
                    .addClass("no-trans");
            } else {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ") .video-texture")
                    .addClass("light-overlay")
                    .addClass("no-trans");
            }
        } else {
            if (
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ")")
                    .attr("data-color-scheme") === "light"
            ) {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ") .video-texture")
                    .addClass("half-dark-overlay")
                    .addClass("no-trans");
            } else {
                $(currentSlider)
                    .find(".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ") .video-texture")
                    .addClass("dark-overlay")
                    .addClass("no-trans");
            }
        }
    }
    function resetContentPos(i) {
        $($nectarSliders[i].container).find(".swiper-slide .content > *").css({ transform: "translateX(0px)" });
    }
    function prevArrowAnimationDirectional(e) {
        if ($(this).hasClass("inactive") || $(this).parents(".swiper-container").find(".slider-next").hasClass("inactive")) {
            return false;
        }
        var i = e.data.i;
        var $that = $(this);
        var $timeout;
        clearTimeout($timeout);
        $timeout = setTimeout(function () {
            $that.parents(".swiper-container").removeClass("directional-trans-prev");
            $that
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .css({ transform: "translateX(0)", left: parseInt($that.parents(".swiper-container").find(".swiper-wrapper").css("left")) + $that.parents(".swiper-container").width() });
            setTimeout(function () {
                $nectarSliders[i].updateActiveSlide();
                $nectarSliders[i].fixLoop();
                $that.removeClass("inactive");
            }, 50);
            resetContentPos(i);
        }, 1100);
        var $timeout2;
        clearTimeout($timeout2);
        $timeout2 = setTimeout(function () {
            if ($that.parents(".swiper-container").attr("data-loop") != "true") {
                if ($that.parents(".swiper-container").find(".swiper-slide-active").index() + 1 != 1) {
                    onChangeStart($nectarSliders[i]);
                }
            } else {
                onChangeStart($nectarSliders[i]);
            }
        }, 100);
        if ($(this).parents(".swiper-container").attr("data-loop") != "true") {
            $(this)
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .find(".swiper-slide-active .content")
                .children()
                .each(function (i) {
                    anime({ targets: $(this)[0], translateX: [0, $that.parents(".swiper-container").width() / 2.5], easing: "easeInOutCubic", duration: 850 });
                });
        }
        $(this).addClass("inactive");
        anime({ targets: $(this).parents(".swiper-container").find(".swiper-wrapper")[0], translateX: [0, $(this).parents(".swiper-container").width()], easing: "easeInOutCubic", duration: 1000 });
        if ($(this).parents(".swiper-container").attr("data-loop") === "true") {
            $(this)
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .find(".swiper-slide-active .content > *")
                .each(function (i) {
                    anime({ targets: $(this)[0], translateX: [0, $that.parents(".swiper-container").width() / 2.5], easing: "easeInOutCubic", duration: 850, delay: i * 50 });
                });
        }
        if ($that.parents(".nectar-slider-wrap").is('[data-bg-animation="ken_burns"]')) {
            $that.parents(".swiper-container").find(".swiper-slide").attr("data-ken-burns", "active");
            clearTimeout(nectarSliderKenBurns);
            nectarSliderKenBurns = setTimeout(function () {
                $that.parents(".swiper-container").find('.swiper-slide:not(".swiper-slide-active")').attr("data-ken-burns", "inactive");
            }, 1350);
        }
        $that
            .parents(".swiper-container")
            .find(".swiper-wrapper")
            .find(".swiper-slide-active")
            .prev(".swiper-slide")
            .find(".content > *")
            .css({ transform: "translateX(-" + $that.parents(".swiper-container").width() + "px)" }, 0);
        setTimeout(function () {
            $that
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .find(".swiper-slide-active")
                .prev(".swiper-slide")
                .find(".content > *")
                .each(function (i) {
                    anime({ targets: $(this)[0], translateX: 0, easing: "easeInOutCubic", duration: 700, delay: i * 50 });
                });
        }, 200);
        $that.parents(".swiper-container").addClass("directional-trans-prev");
        e.preventDefault();
    }
    function nextArrowAnimationDirectional(e) {
        if ($(this).hasClass("inactive") || $(this).parents(".swiper-container").find(".slider-prev").hasClass("inactive")) {
            return false;
        }
        var i = e.data.i;
        var $that = $(this);
        var $timeout;
        clearTimeout($timeout);
        $timeout = setTimeout(function () {
            $that.parents(".swiper-container").removeClass("directional-trans-next");
            $that
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .css({ transform: "translateX(0)", left: parseInt($that.parents(".swiper-container").find(".swiper-wrapper").css("left")) - $that.parents(".swiper-container").width() });
            setTimeout(function () {
                $nectarSliders[i].updateActiveSlide();
                $nectarSliders[i].fixLoop();
                $that.removeClass("inactive");
            }, 50);
            resetContentPos(i);
        }, 1100);
        var $timeout2;
        clearTimeout($timeout2);
        $timeout2 = setTimeout(function () {
            if ($that.parents(".swiper-container").attr("data-loop") != "true") {
                if ($that.parents(".swiper-container").find(".swiper-slide-active").index() + 1 != $slideNum) {
                    onChangeStart($nectarSliders[i]);
                }
            } else {
                onChangeStart($nectarSliders[i]);
            }
        }, 100);
        var $slideNum = $(this).parents(".swiper-container").find(".swiper-wrapper > div").length;
        if ($(this).parents(".swiper-container").attr("data-loop") != "true") {
            if ($(this).parents(".swiper-container").find(".swiper-slide-active").index() + 1 == $slideNum && !$("html").hasClass("no-video")) {
                if ($(this).parents(".nectar-slider-wrap ").attr("data-transition") != "fade") {
                    $(this)
                        .parents(".swiper-container")
                        .find(".swiper-wrapper")
                        .stop(true, false)
                        .css("transition", "none")
                        .animate({ left: parseInt($(this).parents(".swiper-container").find(".swiper-wrapper").css("left")) - 20 }, 200, function () {
                            $(this).parents(".swiper-container").find(".swiper-wrapper").stop(true, false).css("transition", "left,top");
                            $nectarSliders[i].swipeReset();
                        });
                }
            } else {
                $(this)
                    .parents(".swiper-container")
                    .find(".swiper-wrapper")
                    .find(".swiper-slide-active .content > *")
                    .each(function (i) {
                        anime({ targets: $(this)[0], translateX: "-" + $that.parents(".swiper-container").width() / 2.5 + "px", easing: "easeInOutCubic", duration: 850, delay: i * 50 });
                    });
            }
        }
        $(this).addClass("inactive");
        anime({ targets: $(this).parents(".swiper-container").find(".swiper-wrapper")[0], translateX: "-" + $that.parents(".swiper-container").width() + "px", easing: "easeInOutCubic", duration: 1000 });
        if ($(this).parents(".swiper-container").attr("data-loop") === "true") {
            $(this)
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .find(".swiper-slide-active .content > *")
                .each(function (i) {
                    anime({ targets: $(this)[0], translateX: "-" + $that.parents(".swiper-container").width() / 2.5 + "px", easing: "easeInOutCubic", duration: 850, delay: i * 50 });
                });
        }
        if ($that.parents(".nectar-slider-wrap").is('[data-bg-animation="ken_burns"]')) {
            $that.parents(".swiper-container").find(".swiper-slide").attr("data-ken-burns", "active");
            clearTimeout(nectarSliderKenBurns);
            nectarSliderKenBurns = setTimeout(function () {
                $that.parents(".swiper-container").find('.swiper-slide:not(".swiper-slide-active")').attr("data-ken-burns", "inactive");
            }, 1350);
        }
        $that
            .parents(".swiper-container")
            .find(".swiper-wrapper")
            .find(".swiper-slide-active")
            .next(".swiper-slide")
            .find(".content > *")
            .css({ transform: "translateX(" + $that.parents(".swiper-container").width() + "px)" });
        setTimeout(function () {
            $that
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .find(".swiper-slide-active")
                .next(".swiper-slide")
                .find(".content > *")
                .each(function (i) {
                    anime({ targets: $(this)[0], translateX: "0px", easing: "easeInOutCubic", duration: 700, delay: i * 50 });
                });
        }, 200);
        $that.parents(".swiper-container").addClass("directional-trans-next");
        e.preventDefault();
    }
    var $nectarSliders = [];
    function nectarSliderMainInit() {
        $nectarSliders = [];
        $('.nectar-slider-wrap[data-full-width="boxed-full-width"]').each(function () {
            if ($(this).parents(".wpb_column").length > 0 && $(this).parents(".full-width-content").length > 0) {
                $(this).attr("data-full-width", "false");
            }
        });
        $('.full-width-content .wpb_column .nectar-slider-wrap[data-full-width="true"]').attr("data-full-width", "false");
        var $leftHeaderSize = $('#header-outer[data-format="left-header"]').length > 0 && window.innerWidth >= 1000 ? parseInt($('#header-outer[data-format="left-header"]').width()) : 0;
        var $windowWidth = $(window).width() - $leftHeaderSize;
        if (
            $("body > #boxed").length === 0 &&
            $('.nectar-slider-wrap[data-full-width="true"]').parent().attr("id") != "portfolio-extra" &&
            $('.nectar-slider-wrap[data-full-width="true"]').parents('.post-area:not(".span_12")').length === 0
        ) {
            $('.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap').css({ left: -(($windowWidth - $smoothSrollWidth) / 2 - $(".main-content").width() / 2), "margin-left": "0" });
            $(
                '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
            ).css("width", $windowWidth);
        } else if ($('.nectar-slider-wrap[data-full-width="true"]').parent().attr("id") === "portfolio-extra" && $("#full_width_portfolio").length !== 0) {
            $('.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap').css({ left: -(($windowWidth - $smoothSrollWidth) / 2 - $(".main-content").width() / 2), "margin-left": "0" });
            $(
                '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
            ).css("width", $windowWidth);
        } else {
            var $container = $("body > #boxed").length === 0 ? ".post-area" : ".container-wrap";
            if ($($container).width() == "0" && $("body > #boxed").length > 0) {
                $container = "#boxed";
            }
            $(
                '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
            ).css("width", $($container).width());
        }
        $(".nectar-slider-wrap, .slide-bg-overlay").show();
        $(".swiper-container, .swiper-slide").css("background-color", "#000");
        $(".video-texture").css("opacity", "1");
        $(".nectar-slider-wrap").each(function (i) {
            var $arrows = $(this).find(".swiper-container").attr("data-arrows");
            var $bullets = $(this).find(".swiper-container").attr("data-bullets");
            var $swipe = $(this).find(".swiper-container").attr("data-desktop-swipe");
            var $loop = $(this).find(".swiper-container").attr("data-loop");
            var $grab = 1;
            var $desktopSwipe = 1;
            if ($swipe == "true" && $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1 && $(this).attr("data-overall_style") != "directional") {
                $grab = 1;
                $desktopSwipe = 1;
            } else {
                $grab = 0;
                $desktopSwipe = 0;
            }
            if ($(window).width() < 1000 && $(this).attr("data-overall_style") != "directional") {
                $grab = 1;
                $desktopSwipe = 1;
            }
            if ($bullets == "true" && $(this).find(".swiper-wrapper > div").length > 1 && $(this).attr("data-overall_style") != "directional") {
                $bullets = "#" + $(this).attr("id") + " .slider-pagination";
            } else {
                $bullets = null;
            }
            var $useLoop =
                ($loop == "true" && $(this).find(".swiper-wrapper > div").length > 1 && !$("html").hasClass("no-video")) ||
                ($(this).attr("data-overall_style") === "directional" && $(this).find(".swiper-wrapper > div").length > 1 && !$("html").hasClass("no-video"))
                    ? true
                    : false;
            if ($useLoop == false) {
                $(this).find(".swiper-container").attr("data-loop", "false");
            }
            var $sliderOptions, touchRatio;
            if ($(this).attr("data-transition") === "fade" && $(this).attr("data-overall_style") !== "directional" && $(this).attr("data-button-styling") !== "btn_with_preview") {
                var progressVar = true;
                touchRatio = 1.3;
                $sliderOptions = {
                    loop: $useLoop,
                    grabCursor: $grab,
                    touchRatio: touchRatio,
                    speed: 600,
                    pagination: $bullets,
                    simulateTouch: $desktopSwipe,
                    onSlideChangeEnd: nectarSlideRotateReset,
                    onTouchEnd: nectarSlideRotateResetTouch,
                    onSlideChangeStart: onChangeStart,
                    onTouchMove: clearAutoplay,
                    onFirstInit: nectarInit,
                    progress: progressVar,
                    onProgressChange: function (swiper) {
                        if ($(swiper.container).parents(".nectar-slider-wrap").hasClass("loaded")) {
                            for (var i = 0; i < swiper.slides.length; i++) {
                                var slide = swiper.slides[i];
                                var progress = slide.progress;
                                var translate = progress * swiper.width;
                                var opacity = Math.max(1 - Math.abs(progress), 0);
                                slide.style.opacity = opacity;
                                swiper.setTransform(slide, "translate3d(" + translate + "px,0,0)");
                            }
                        }
                    },
                    onTouchStart: function (swiper) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.setTransition(swiper.slides[i], 0);
                        }
                    },
                    onSetWrapperTransition: function (swiper, speed) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.setTransition(swiper.slides[i], speed);
                        }
                    },
                };
            } else {
                touchRatio = 0.6;
                var css3Trans = $("#" + $(this).attr("id") + '.nectar-slider-wrap[data-overall_style="directional"]').length == 1 ? false : true;
                $sliderOptions = {
                    loop: $useLoop,
                    grabCursor: $grab,
                    touchRatio: touchRatio,
                    speed: 500,
                    useCSS3Transforms: css3Trans,
                    pagination: $bullets,
                    simulateTouch: $desktopSwipe,
                    onSlideChangeEnd: nectarSlideRotateReset,
                    onTouchEnd: nectarSlideRotateResetTouch,
                    onSlideChangeStart: onChangeStart,
                    onTouchMove: clearAutoplay,
                    onFirstInit: nectarInit,
                };
            }
            $nectarSliders[i] = new NectarSwiper("#" + $(this).attr("id") + " .swiper-container", $sliderOptions);
            if (isNaN($nectarSliders[i].activeIndex)) {
                $nectarSliders[i].activeIndex = $useLoop ? 1 : -0;
            }
            if (isNaN($nectarSliders[i].previousIndex)) {
                $nectarSliders[i].previousIndex = $useLoop ? 1 : 0;
            }
            $nectarSliders[i].swipeReset();
            $("#" + $(this).attr("id")).addClass("nectar-slider-enabled");
            if (navigator.userAgent.indexOf("Chrome") > 0 && !/Edge\/12./i.test(navigator.userAgent) && !/Edge\/\d./i.test(navigator.userAgent)) {
                var webmSource, webmSource2, firstVideo, lastVideo;
                if (jQuery(this).find('.swiper-slide:nth-child(2) video source[type="video/webm"]').length > 0 && jQuery(this).find(".swiper-container").attr("data-loop") === "true") {
                    webmSource = jQuery(this).find('.swiper-slide:nth-child(2) video source[type="video/webm"]').attr("src") + "?id=" + Math.ceil(Math.random() * 10000);
                    firstVideo = jQuery(this).find(".swiper-slide:nth-child(2) video").get(0);
                    firstVideo.src = webmSource;
                    firstVideo.load();
                    webmSource2 = jQuery(this).find('.swiper-slide:last-child video source[type="video/webm"]').attr("src") + "?id=" + Math.ceil(Math.random() * 10000);
                    lastVideo = jQuery(this).find(".swiper-slide:last-child video").get(0);
                    lastVideo.src = webmSource2;
                    lastVideo.load();
                }
                if (jQuery(this).find('.swiper-slide:eq(-2) video source[type="video/webm"]').length > 0 && jQuery(this).find(".swiper-container").attr("data-loop") === "true") {
                    webmSource = jQuery(this).find('.swiper-slide:eq(-2) video source[type="video/webm"]').attr("src") + "?id=" + Math.ceil(Math.random() * 10000);
                    firstVideo = jQuery(this).find(".swiper-slide:eq(-2) video").get(0);
                    firstVideo.src = webmSource;
                    firstVideo.load();
                    webmSource2 = jQuery(this).find('.swiper-slide:nth-child(1) video source[type="video/webm"]').attr("src") + "?id=" + Math.ceil(Math.random() * 10000);
                    lastVideo = jQuery(this).find(".swiper-slide:nth-child(1) video").get(0);
                    lastVideo.src = webmSource2;
                    lastVideo.load();
                }
            }
            if ($("#" + $(this).attr("id") + ' [data-bullet_style="see_through_ar_visualized"]').length == 1) {
                $("#" + $(this).attr("id"))
                    .find(".slider-pagination .swiper-pagination-switch")
                    .append(
                        '<svg width="65px" height="65px" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><circle stroke-width="9" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle> <circle class="time" stroke-width="9" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>'
                    );
            }
            if (
                $arrows == "true" &&
                $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1 &&
                $("#" + $(this).attr("id") + '.nectar-slider-wrap[data-button-styling="btn_with_preview"]').length === 0 &&
                $("#" + $(this).attr("id") + '.nectar-slider-wrap[data-overall_style="directional"]').length === 0
            ) {
                $(".slide-count i").css({ transform: "scale(0.5)", opacity: "0" });
                $("body").on(
                    "mouseenter",
                    '.nectar-slider-wrap[data-button-styling="btn_with_count"][data-overall_style="classic"] .swiper-container .slider-prev, .nectar-slider-wrap[data-button-styling="btn_with_count"][data-overall_style="classic"] .swiper-container .slider-next',
                    function () {
                        anime({ targets: $(this).find(".slide-count i")[0], scale: [0, 1], translateZ: 0, opacity: 1, easing: "easeOutCubic", duration: 250, delay: 110 });
                        anime({ targets: $(this)[0], width: [50, 100], easing: "easeOutCubic", duration: 300 });
                        anime({ targets: $(this)[0].querySelectorAll(".slide-count span"), opacity: 1, easing: "easeOutCubic", duration: 225, delay: 100 });
                    }
                );
                $("body").on(
                    "mouseleave",
                    '.nectar-slider-wrap[data-button-styling="btn_with_count"][data-overall_style="classic"] .swiper-container .slider-prev, .nectar-slider-wrap[data-button-styling="btn_with_count"][data-overall_style="classic"] .swiper-container .slider-next',
                    function () {
                        anime.remove(".slide-count i, .slider-next, .slider-prev, .slide-count span");
                        anime({ targets: $(this).find(".slide-count i")[0], scale: 0, translateZ: 0, opacity: 0, easing: "easeOutCubic", duration: 250 });
                        anime({ targets: $(this)[0], width: 50, easing: "easeOutCubic", duration: 300 });
                        anime({ targets: $(this)[0].querySelectorAll(".slide-count span"), opacity: 0, easing: "easeOutCubic", duration: 225 });
                    }
                );
                var $slideCount = $(this).find(".swiper-container").attr("data-loop") != "true" ? $("#" + $(this).attr("id") + " .swiper-wrapper > div").length : $("#" + $(this).attr("id") + " .swiper-wrapper > div").length - 2;
                if ($("html").hasClass("no-video")) $slideCount = $("#" + $(this).attr("id") + " .swiper-wrapper > div").length;
                $("#" + $(this).attr("id") + " .slider-prev .slide-count .slide-total").html($slideCount);
                $("#" + $(this).attr("id") + " .slider-next .slide-count .slide-total").html($slideCount);
                $("body").off("click", "#" + $(this).attr("id") + " .slider-prev", prevArrowAnimation);
                $("body").on("click", "#" + $(this).attr("id") + " .slider-prev", { i: i }, prevArrowAnimation);
                $("body").off("click", "#" + $(this).attr("id") + " .slider-next", nextArrowAnimation);
                $("body").on("click", "#" + $(this).attr("id") + " .slider-next", { i: i }, nextArrowAnimation);
            } else if (
                $arrows == "true" &&
                $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1 &&
                $("#" + $(this).attr("id") + '.nectar-slider-wrap[data-button-styling="btn_with_preview"]').length == 1 &&
                $("#" + $(this).attr("id") + '.nectar-slider-wrap[data-overall_style="directional"]').length == 0
            ) {
                $("body").off("click", "#" + $(this).attr("id") + " .slider-prev", prevArrowAnimationWithPreview);
                $("body").on("click", "#" + $(this).attr("id") + " .slider-prev", { i: i }, prevArrowAnimationWithPreview);
                $("body").off("click", "#" + $(this).attr("id") + " .slider-next", nextArrowAnimationWithPreview);
                $("body").on("click", "#" + $(this).attr("id") + " .slider-next", { i: i }, nextArrowAnimationWithPreview);
                $("body").on("mouseenter", '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-next:not(.stophover)', function () {
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").next(".swiper-slide").addClass("high-z-index");
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").stop().addClass("next-move");
                    $(this).stop().addClass("next-arrow-move");
                    darkSlideNextMouseOver($(this).parents(".nectar-slider-wrap"), $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").index());
                });
                $("body").on("mouseleave", '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-next', function () {
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").next(".swiper-slide").removeClass("high-z-index");
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").stop().removeClass("next-move");
                    $(this).stop().removeClass("next-arrow-move");
                });
                $("body").on("mouseenter", '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-prev:not(.stophover)', function () {
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").prev(".swiper-slide").addClass("prev-high-z-index");
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").stop().addClass("prev-move");
                    $(this).stop().addClass("prev-arrow-move");
                    darkSlidePrevMouseOver($(this).parents(".nectar-slider-wrap"), $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").index());
                });
                $("body").on("mouseleave", '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-prev', function () {
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").prev(".swiper-slide").removeClass("prev-high-z-index");
                    $(this).parents(".nectar-slider-wrap").find(".swiper-slide-active").stop().removeClass("prev-move");
                    $(this).stop().removeClass("prev-arrow-move");
                });
            } else if ($("#" + $(this).attr("id") + '.nectar-slider-wrap[data-overall_style="directional"]').length == 1) {
                $("body").off("click", "#" + $(this).attr("id") + " .slider-prev", prevArrowAnimationDirectional);
                $("body").on("click", "#" + $(this).attr("id") + " .slider-prev", { i: i }, prevArrowAnimationDirectional);
                $("body").off("click", "#" + $(this).attr("id") + " .slider-next", nextArrowAnimationDirectional);
                $("body").on("click", "#" + $(this).attr("id") + " .slider-next", { i: i }, nextArrowAnimationDirectional);
            }
            if ($("#" + $(this).attr("id") + " .swiper-container").attr("data-bullet_style") === "scale") {
                $("#" + $(this).attr("id") + " .slider-pagination .swiper-pagination-switch").append("<i />");
            }
            if ($bullets != null && $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1) {
                $("#" + $(this).attr("id") + " .slider-pagination .swiper-pagination-switch").on("click", function () {
                    $nectarSliders[i].swipeTo($(this).index());
                });
            }
        });
    }
    nectarSliderMainInit();
    $(window).on("vc_reload", function () {
        nectarSliderMainInit();
        initialSlideLoad();
    });
    if ("IntersectionObserver" in window) {
        var options = { rootMargin: "0px" };
        var sliderObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove("out-of-view");
                    setTimeout(function () {
                        if ($(entry.target).find(".swiper-slide-active").is('[data-color-scheme="dark"]')) {
                            $("#header-outer.transparent").addClass("dark-slide");
                        } else {
                            $("#header-outer.transparent").removeClass("dark-slide");
                        }
                    }, 200);
                } else {
                    entry.target.classList.add("out-of-view");
                }
            });
        }, options);
        if ($("#nectar_fullscreen_rows").length == 0 && $('#header-outer[data-permanent-transparent="1"]').length > 0) {
            $(".top-level .nectar-slider-wrap").each(function (slider) {
                sliderObserver.observe($(this)[0]);
            });
        }
    }
    function darkFirstSlide(slider) {
        if (slider.parents(".parallax_slider_outer").length > 0 && slider.parents(".first-section").length > 0 && slider.find('.swiper-slide-active[data-color-scheme="dark"]').length > 0) {
            $("#header-outer").addClass("dark-slide");
        } else if (slider.parents(".parallax_slider_outer").length > 0 || slider.parents(".first-section").length > 0) {
            if (slider.find('.swiper-slide-active[data-color-scheme="dark"]').length > 0 && slider.parents(".first-section").length > 0 && slider.is('[data-full-width="true"]')) {
            } else {
                $("#header-outer").removeClass("dark-slide");
            }
        }
    }
    var $animating = false;
    var $sliderHeights = [];
    var $existingSliders = [];
    var slideAnimationQueues = [];
    var sliderLength = $(".swiper-container").length;
    var sliderLoadedLength = 0;
    function initialSlideLoad() {
        $animating = false;
        $(".swiper-wrapper").each(function () {
            if ($(this).find(".swiper-slide:nth-child(2) video").length > 0) $(this).find(".swiper-slide:nth-child(2)").addClass("first_video_slide");
            if ($(this).parents('.nectar-slider-wrap[data-bg-animation="ken_burns"]').length > 0) {
                if ($("#nectar_fullscreen_rows").length > 0) {
                    var $that = $(this);
                    setTimeout(function () {
                        $that.find(".swiper-slide.swiper-slide-active").addClass("ken-burns").attr("data-ken-burns", "active");
                    }, 100);
                } else {
                    $(this).find(".swiper-slide.swiper-slide-active").addClass("ken-burns").attr("data-ken-burns", "active");
                }
            }
        });
        $(".nectar-slider-wrap").each(function (i) {
            slideAnimationQueues[i] = { sliderID: $(this).attr("id"), captionInterval: "", kenBurnsInterval: "" };
            var $that = $(this);
            if ($(this).find(".swiper-slide-active video").length > 0) {
                if (!$("html").hasClass("no-video") && !navigator.userAgent.match(/(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/)) {
                    showSliderControls();
                    resizeToCover();
                    slideContentPos();
                    sliderLoadIn($that, i);
                    var $timeoutDelay = 0;
                    if (
                        ($('#ajax-loading-screen[data-effect="center_mask_reveal"]').length > 0 && $that.parents(".parallax_slider_outer").length > 0) ||
                        ($('#ajax-loading-screen[data-effect="center_mask_reveal"]').length > 0 && $that.hasClass("first-nectar-slider"))
                    ) {
                        $timeoutDelay = 450;
                    }
                    setTimeout(function () {
                        captionTransition($nectarSliders[i]);
                        onChangeStart($nectarSliders[i]);
                    }, $timeoutDelay);
                    darkFirstSlide($that);
                    $that.addClass("loaded");
                    if ($that.parents(".parallax_slider_outer").length > 0 || $that.hasClass("first-nectar-slider")) {
                        $("#ajax-loading-screen").addClass("loaded");
                        setTimeout(function () {
                            $("#ajax-loading-screen").addClass("hidden");
                        }, 1000);
                    }
                } else {
                    showSliderControls();
                    resizeToCover();
                    slideContentPos();
                    sliderLoadIn($that, i);
                    captionTransition($nectarSliders[i]);
                    darkFirstSlide($that);
                }
            } else {
                showSliderControls();
                resizeToCover();
                slideContentPos();
                sliderLoadIn($that, i);
                var $timeout = 0;
                if (
                    ($('#ajax-loading-screen[data-effect="center_mask_reveal"]').length > 0 && $that.parents(".parallax_slider_outer").length > 0 && $that.parents(".first-section").length > 0) ||
                    ($('#ajax-loading-screen[data-effect="center_mask_reveal"]').length > 0 && $that.hasClass("first-nectar-slider"))
                ) {
                    $timeout = 450;
                }
                setTimeout(function () {
                    captionTransition($nectarSliders[i]);
                    onChangeStart($nectarSliders[i]);
                }, $timeout);
                darkFirstSlide($that);
                $that.addClass("loaded");
                if ($that.parents(".parallax_slider_outer").length > 0 || $that.hasClass("first-nectar-slider")) {
                    $("#ajax-loading-screen").addClass("loaded");
                    setTimeout(function () {
                        $("#ajax-loading-screen").addClass("hidden");
                    }, 1000);
                }
            }
            if (navigator.userAgent.match(/(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/)) {
                $that.find(".video-wrap").each(function () {
                    var $videoSlide = $(this);
                    $(this).css("bottom", "0");
                    $(this).find("video")[0].onplay = function () {
                        $videoSlide.find("video").css({ opacity: "1" });
                        setTimeout(function () {
                            $videoSlide.parents(".swiper-slide").find(".mobile-video-image").transition({ opacity: "0" }, 250);
                            anime({ targets: $videoSlide.parents(".swiper-slide").find(".mobile-video-image")[0], opacity: 0, easing: "easeOutCubic", duration: 250 });
                        }, 100);
                    };
                });
                captionTransition($nectarSliders[i]);
                showSliderControls();
                resizeToCover();
                slideContentPos();
                darkFirstSlide($that);
                setTimeout(function () {
                    resizeToCover();
                    slideContentPos();
                }, 400);
                $(".nectar-slider-wrap").find(".nectar-slider-loading").fadeOut(800, "easeInOutExpo");
                $(".nectar-slider-wrap.first-section .swiper-container .swiper-wrapper .swiper-slide").removeClass("not-loaded");
                $(this).addClass("loaded");
                if ($that.parents(".parallax_slider_outer").length > 0 || $that.hasClass("first-nectar-slider")) {
                    $("#ajax-loading-screen").addClass("loaded");
                    setTimeout(function () {
                        $("#ajax-loading-screen").addClass("hidden");
                    }, 1000);
                }
                autorotateInit($(this), i);
            }
            if ($("header#top #logo img").length > 0) {
                var logoImg = new Image();
                logoImg.src = $("header#top #logo img:first").attr("src");
                $(logoImg).on("load", function () {
                    if ($that.attr("data-overall_style") === "directional") {
                        $that.find(".swiper-container").addClass("directional-trans-current");
                        onChangeStart($nectarSliders[i]);
                    }
                });
            } else {
                if ($that.attr("data-overall_style") === "directional") {
                    $that.find(".swiper-container").addClass("directional-trans-current");
                    onChangeStart($nectarSliders[i]);
                }
            }
        });
        $(".swiper-container").each(function () {
            if ($(this).is('[data-bullet_position="left"]')) {
                if ($(this).find('[data-x-pos="left"]').length > 0) {
                    $(this).find(".slider-pagination-wrap").addClass("extra-room");
                }
            }
            if ($(this).is('[data-bullet_position="right"]')) {
                if ($(this).find('[data-x-pos="right"]').length > 0) {
                    $(this).find(".slider-pagination-wrap").addClass("extra-room");
                }
            }
        });
    }
    function nectarInit() {
        if (doneVideoInit == true) {
            return;
        }
        $(".swiper-slide iframe[data-aspectRatio]").each(function () {
            var newWidth = $(this).parent().width();
            var $el = $(this);
            if ($(this).parents(".swiper-slide").length > 0) {
                if ($(this).is(":visible")) $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
            } else {
                $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
            }
        });
        doneVideoInit = true;
    }
    var autoplay = [];
    var sliderAutoplayCount = 0;
    function nsSliderArrStore() {
        $sliderHeights = [];
        $existingSliders = [];
        $(".swiper-container").each(function (i) {
            $sliderHeights[i] = parseInt($(this).attr("data-height"));
            $existingSliders[i] = $(this).parent().attr("id");
        });
    }
    nsSliderArrStore();
    dynamicHeightSliders();
    sliderSize();
    resizeToCover();
    for (var nsCount = 0; nsCount < $nectarSliders.length; nsCount++) {
        $nectarSliders[nsCount].resizeFix();
    }
    $(".parallax_slider_outer .nectar-slider-wrap .slide-bg-wrap").each(function () {
        if ($(this).parents(".top-level").length > 0) {
            if ($(this).find(".image-bg").length > 0) {
                $(this)
                    .find(".image-bg")
                    .css({ height: Math.ceil($(this).parent().offset().top * 0.25) + $(this).outerHeight(true) });
            }
            if ($(this).find(".video-wrap").length > 0) {
                $(this)
                    .find(".video-wrap")
                    .css({ height: Math.ceil($(this).parent().offset().top * 0.25) + $(this).outerHeight(true) });
            }
        }
    });
    initialSlideLoad();
    document.addEventListener("visibilitychange", function () {
        if (document.hidden) {
        } else {
            $(".nectar-slider-wrap").each(function (i) {
                if (typeof $nectarSliders[i] != "undefined") {
                    $nectarSliders[i].resizeFix();
                }
            });
        }
    });
    var headerPadding = parseInt($("#header-outer").attr("data-padding"));
    var shrinkNum = 8;
    if ($("#header-outer[data-shrink-num]").length > 0) {
        shrinkNum = $("#header-outer").attr("data-shrink-num");
    }
    var feEditorStored = false;
    function dynamicHeightSliders() {
        var $adminBarHeight = $("#wpadminbar").length > 0 ? 28 : 0;
        if ($("body.compose-mode").length > 0 && feEditorStored == false) {
            nsSliderArrStore();
            feEditorStored = true;
        }
        $(".nectar-slider-wrap").each(function () {
            var $heightCalc, $heightCal;
            var $minHeight = $(".swiper-container").attr("data-min-height");
            if (window.innerWidth > 1000 && $("#ajax-content-wrap").length > 0) {
                $("body.material:not(\"[data-header-format='left-header']\") .parallax_slider_outer.first-section .nectar-slider-wrap").css("top", $("#ajax-content-wrap").offset().top);
            } else {
                $("body.material:not(\"[data-header-format='left-header']\") .parallax_slider_outer.first-section .nectar-slider-wrap").css("top", "0");
            }
            if (
                ($(this).attr("data-fullscreen") === "true" && $(this).attr("data-full-width") === "true") ||
                ($(this).attr("data-fullscreen") === "true" && $(this).attr("data-full-width") === "boxed-full-width") ||
                ($(this).attr("data-fullscreen") === "true" && $(this).parents(".full-width-content").length > 0 && $(this).parents(".vc_col-sm-12").length > 0)
            ) {
                if ($(this).parents("#nectar_fullscreen_rows").length === 0) {
                    if (
                        ($(this).hasClass("first-section") && $(this).index() === 0) ||
                        ($(this).parents(".wpb_row").length > 0 && $(this).parents(".wpb_row").hasClass("first-section") && $(this).index() === 0 && $(this).parents(".parallax_slider_outer").length === 0) ||
                        ($(this).parents(".wpb_row").length > 0 && $(this).parents(".wpb_row").hasClass("top-level") && $(this).parents(".parallax_slider_outer").length === 0)
                    ) {
                        $heightCal = $(window).height() - $(this).offset().top + 2 <= $minHeight ? $minHeight : $(window).height() - $(this).offset().top + 2;
                        $(this).find(".swiper-container").attr("data-height", $heightCal);
                    } else if (
                        ($(this).parents(".first-section").length > 0 && $(this).parents(".parallax_slider_outer").length > 0 && $(this).parents("#full_width_portfolio").length === 0) ||
                        ($(this).parents(".top-level").length > 0 && $(this).parents(".parallax_slider_outer").length > 0 && $(this).parents("#full_width_portfolio").length === 0)
                    ) {
                        $heightCal = $(window).height() - $(this).offset().top + 2 <= $minHeight ? $minHeight : $(window).height() - $(this).offset().top + 2;
                        $(this).find(".swiper-container").attr("data-height", $heightCal);
                    } else if ($(this).parents("#full_width_portfolio").length > 0 && $(this).attr("data-parallax") != "true" && $(this).index() === 0) {
                        $heightCal = $(window).height() - $(this).offset().top + 2 <= $minHeight ? $minHeight : $(window).height() - $(this).offset().top + 2;
                        $(this).find(".swiper-container").attr("data-height", $heightCal);
                    } else if ($(this).parents("#full_width_portfolio").length > 0 && $(this).attr("data-parallax") === "true") {
                        $heightCal = $(window).height() - $(this).offset().top + 2 <= $minHeight ? $minHeight : $(window).height() - $(this).offset().top + 2;
                        $(this).find(".swiper-container").attr("data-height", $heightCal);
                    } else {
                        var headerPadding = parseInt($("#header-outer").attr("data-padding"));
                        var shrinkNum = 8;
                        if ($("#header-outer[data-shrink-num]").length > 0) {
                            shrinkNum = $("#header-outer").attr("data-shrink-num");
                        }
                        var $resize = $('#header-outer[data-header-resize="0"]').length > 0 ? 0 : parseInt(shrinkNum) + headerPadding * 2;
                        var $headerSize = $('#header-outer[data-permanent-transparent="false"]').length > 0 ? $("#header-space").height() - $resize - 3 : -3;
                        if ($("#nectar_fullscreen_rows").length > 0 || ($('body[data-header-format="left-header"]').length > 0 && window.innerWidth >= 1000)) {
                            $headerSize = $adminBarHeight;
                        }
                        $heightCal = $(window).height() - $headerSize <= $minHeight ? $minHeight : $(window).height() - $headerSize;
                        $(this).find(".swiper-container").attr("data-height", $heightCal);
                    }
                    if ($('#header-outer[data-remove-border="true"]').length === 0) {
                        if ($('body #header-outer[data-transparent-header="true"]').length > 0 && $('.first-section .nectar-slider-wrap[data-fullscreen="true"]').length > 0 && $("#page-header-bg").length === 0) {
                            $(".first-section .nectar-slider-loading").css({ "background-image": $loading_bg_storage, "background-position": "center " + ($(window).height() / 2 + 15 - $("#header-space").height()) + "px" });
                            $(".first-section .nectar-slider-wrap .nectar-slider-loading .loading-icon").css({ opacity: "1", height: $(window).height() - $("#header-space").height() + "px" });
                        }
                    }
                }
            }
            if ($(this).attr("data-flexible-height") === "true" && $(this).attr("data-fullscreen") !== "true") {
                if ($(this).parents(".wpb_row.full-width-content").length === 0 && $(this).attr("data-full-width") === "false") {
                    $(this).attr("data-flexible-height", "false");
                    return false;
                }
                $minHeight = $(".swiper-container").attr("data-min-height");
                var currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                var $definedHeight = $sliderHeights[currentKey];
                var dif = $(window).width() / 1600;
                if (window.innerWidth > 1000 && $("#boxed").length === 0) {
                    $(this)
                        .find(".swiper-container")
                        .attr("data-height", Math.ceil($definedHeight * dif));
                } else {
                    var $parentCol = $(this).parents(".wpb_column").length > 0 ? $(this).parents(".wpb_column") : $(this).parents(".col");
                    if ($parentCol.length == 0) $parentCol = $(".main-content");
                    if (!$parentCol.hasClass("vc_span12") && !$parentCol.hasClass("main-content") && !$parentCol.hasClass("span_12") && !$parentCol.hasClass("vc_col-sm-12")) {
                        var $parentColWidth = sliderColumnDesktopWidth($parentCol);
                        var $parentColRatio = 1100 / $parentColWidth;
                        if ($definedHeight * dif <= $minHeight) {
                            $(this).find(".swiper-container").attr("data-height", $minHeight);
                        } else {
                            $(this)
                                .find(".swiper-container")
                                .attr("data-height", Math.ceil($parentColRatio * $definedHeight * dif));
                        }
                    } else if ($("#boxed").length > 0) {
                        dif = $("#boxed").width() / 1600;
                        if (window.innerWidth > 1300) {
                            if ($('body[data-ext-responsive="true"]').length > 0) {
                                if ($(this).has('[data-full-width="boxed-full-width"]')) {
                                    $("#boxed").width() < 1400
                                        ? $(this)
                                              .find(".swiper-container")
                                              .attr("data-height", Math.ceil($definedHeight * dif))
                                        : $(this)
                                              .find(".swiper-container")
                                              .attr("data-height", $definedHeight * (1400 / 1600));
                                }
                            } else {
                                if ($(this).has('[data-full-width="boxed-full-width"]')) {
                                    $(this)
                                        .find(".swiper-container")
                                        .attr("data-height", Math.ceil($definedHeight * (1200 / 1600)));
                                }
                            }
                        } else if (window.innerWidth <= 1300 && window.innerWidth >= 1000) {
                            if ($('body[data-ext-responsive="true"]').length > 0) {
                                $(this)
                                    .find(".swiper-container")
                                    .attr("data-height", Math.ceil($definedHeight * dif));
                            } else {
                                if ($(this).has('[data-full-width="boxed-full-width"]')) {
                                    $(this)
                                        .find(".swiper-container")
                                        .attr("data-height", Math.ceil($definedHeight * (980 / 1600)));
                                }
                            }
                        } else if (window.innerWidth < 1000 && window.innerWidth > 690) {
                            $heightCalc = $definedHeight * (679 / 1600) <= $minHeight ? $minHeight : $definedHeight * (679 / 1600);
                            if ($(this).has('[data-full-width="boxed-full-width"]')) {
                                $(this).find(".swiper-container").attr("data-height", $minHeight);
                            }
                        } else if (window.innerWidth <= 690) {
                            $heightCalc = $definedHeight * dif <= $minHeight ? $minHeight : $definedHeight * dif;
                            if ($(this).has('[data-full-width="boxed-full-width"]')) {
                                if ($(this).parents(".full-width-ns").length > 0 && $('#header-outer[data-transparent-header="true"]').length > 0) {
                                    $(this)
                                        .find(".swiper-container")
                                        .attr("data-height", $heightCalc + 50);
                                } else {
                                    $(this).find(".swiper-container").attr("data-height", $heightCalc);
                                }
                            }
                        }
                    } else {
                        if ($definedHeight * dif <= $minHeight) {
                            $(this).find(".swiper-container").attr("data-height", $minHeight);
                        } else {
                            if (window.innerWidth < 690 && $(this).parents(".full-width-ns").length > 0 && $('#header-outer[data-transparent-header="true"]').length > 0) {
                                $(this)
                                    .find(".swiper-container")
                                    .attr("data-height", Math.ceil($definedHeight * dif) + 50);
                            } else {
                                $(this)
                                    .find(".swiper-container")
                                    .attr("data-height", Math.ceil($definedHeight * dif));
                            }
                        }
                    }
                }
                if ($('body #header-outer[data-transparent-header="true"]').length > 0 && $('.first-section .nectar-slider-wrap[data-flexible-height="true"]').length > 0) {
                    $(".first-section .nectar-slider-loading").css({ "background-image": $loading_bg_storage, "background-position": "center " + (($definedHeight * dif) / 2 + 15 - $("#header-space").height()) + "px" });
                    $(".first-section .nectar-slider-wrap .nectar-slider-loading .loading-icon").css({ opacity: "1", height: $definedHeight * dif - $("#header-space").height() + "px" });
                }
            }
        });
    }
    if (window.innerWidth > 690) {
        $(window).on("resize.dynamicHeights", dynamicHeightSliders);
    } else {
        var $windowWidth = $(window).width(),
            $windowHeight = $(window).height();
        var $orientationChange = 0;
        window.addEventListener("orientationchange", function () {
            $orientationChange = 1;
        });
        $(window).resize(function () {
            if (($(window).width() != $windowWidth && $(window).height != $windowHeight) || $orientationChange == 1) {
                dynamicHeightSliders();
                $orientationChange = 0;
            }
        });
    }
    setTimeout(function () {
        dynamicHeightSliders();
    }, 100);
    function sliderColumnDesktopWidth(parentCol) {
        var $parentColWidth = 1100;
        var $columnNumberParsed = $(parentCol).attr("class").match(/\d+/);
        if ($columnNumberParsed == "2") {
            $parentColWidth = 170;
        } else if ($columnNumberParsed == "3") {
            $parentColWidth = 260;
        } else if ($columnNumberParsed == "4") {
            $parentColWidth = 340;
        } else if ($columnNumberParsed == "6") {
            $parentColWidth = 530;
        } else if ($columnNumberParsed == "8") {
            $parentColWidth = 700;
        } else if ($columnNumberParsed == "9") {
            $parentColWidth = 805;
        } else if ($columnNumberParsed == "10") {
            $parentColWidth = 916.3;
        } else if ($columnNumberParsed == "12") {
            $parentColWidth = 1100;
        }
        return $parentColWidth;
    }
    $(window).on("resize", sliderSize);
    function sliderSize() {
        if (window.innerWidth < 1000 && window.innerWidth > 690) {
            var currentKey;
            $('.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $sliderHeights[currentKey] / 1.4);
            });
            $('.nectar-slider-wrap[data-full-width="false"]:not([data-fullscreen="true"]):not([data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                var $currentSliderHeight = $sliderHeights[currentKey];
                var $parentCol = $(this).parents(".wpb_column").length > 0 ? $(this).parents(".wpb_column") : $(this).parents(".col");
                if ($(this).parents(".post-area").length > 0 && $(this).parents(".vc_span12").length > 0) $parentCol = $(this).parents(".post-area");
                if ($parentCol.length === 0) {
                    $parentCol = $(".main-content");
                }
                var $parentColWidth = sliderColumnDesktopWidth($parentCol);
                var $aspectRatio = $currentSliderHeight / $parentColWidth;
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $aspectRatio * $parentCol.width());
            });
            $('.nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $sliderHeights[currentKey] / 1.9);
            });
        } else if (window.innerWidth <= 690) {
            $('.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                if ($(this).parents(".full-width-ns").length > 0 && $('#header-outer[data-transparent-header="true"]').length > 0) {
                    $(this)
                        .find(".swiper-container")
                        .attr("data-height", $sliderHeights[currentKey] / 2.7 + 50);
                } else {
                    $(this)
                        .find(".swiper-container")
                        .attr("data-height", $sliderHeights[currentKey] / 2.7);
                }
            });
            $('.nectar-slider-wrap[data-full-width="false"]:not([data-fullscreen="true"]):not([data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                var $currentSliderHeight = $sliderHeights[currentKey];
                var $parentCol = $(this).parents(".wpb_column").length > 0 ? $(this).parents(".wpb_column") : $(this).parents(".col");
                if ($(this).parents(".post-area").length > 0 && $(this).parents(".vc_span12").length > 0) {
                    $parentCol = $(this).parents(".post-area");
                }
                if ($parentCol.length === 0) {
                    $parentCol = $(".main-content");
                }
                var $parentColWidth = sliderColumnDesktopWidth($parentCol);
                var $aspectRatio = $currentSliderHeight / $parentColWidth;
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $aspectRatio * $parentCol.width());
            });
            $('.nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                if ($(this).parents(".full-width-ns").length > 0 && $('#header-outer[data-transparent-header="true"]').length > 0) {
                    $(this)
                        .find(".swiper-container")
                        .attr("data-height", $sliderHeights[currentKey] / 2.9 + 50);
                } else {
                    $(this)
                        .find(".swiper-container")
                        .attr("data-height", $sliderHeights[currentKey] / 2.9);
                }
            });
        } else if (window.innerWidth < 1300 && window.innerWidth >= 1000) {
            $('.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $sliderHeights[currentKey] / 1.2);
            });
            $('.nectar-slider-wrap[data-full-width="false"]:not([data-fullscreen="true"]):not([data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                var $currentSliderHeight = $sliderHeights[currentKey];
                var $parentCol = $(this).parents(".wpb_column").length > 0 ? $(this).parents(".wpb_column") : $(this).parents(".col");
                if ($(this).parents(".post-area").length > 0 && $(this).parents(".vc_span12").length > 0) {
                    $parentCol = $(this).parents(".post-area");
                }
                if ($parentCol.length === 0) {
                    $parentCol = $(".main-content");
                }
                var $parentColWidth = sliderColumnDesktopWidth($parentCol);
                var $aspectRatio = $currentSliderHeight / $parentColWidth;
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $aspectRatio * $parentCol.width());
            });
            $('.nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                $(this)
                    .find(".swiper-container")
                    .attr("data-height", $sliderHeights[currentKey] / 1.2);
            });
        } else {
            $('.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                if ($(this).attr("data-flexible-height") != "true") $(this).find(".swiper-container").attr("data-height", $sliderHeights[currentKey]);
            });
            $('.nectar-slider-wrap[data-full-width="false"]:not([data-fullscreen="true"]), .nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])').each(function () {
                currentKey = $existingSliders.nectarGetKeyByValue($(this).attr("id"));
                if ($(this).attr("data-flexible-height") != "true") $(this).find(".swiper-container").attr("data-height", $sliderHeights[currentKey]);
            });
        }
    }
    $(".nectar-slider-wrap").each(function () {
        if ($(this).find(".swiper-wrapper .swiper-slide").length == 1) {
            $(this).find(".swiper-slide").addClass("no-transform");
            $(this).find(".swiper-wrapper").addClass("no-transform");
        }
    });
    var min_w = 1500;
    var vid_w_orig;
    var vid_h_orig;
    vid_w_orig = 1280;
    vid_h_orig = 720;
    var $headerHeight = $("header").height() - 1;
    function nsSliderContentResize() {
        resizeToCover();
        slideContentPos();
        for (var i = 0; i < $nectarSliders.length; i++) {
            if ($($nectarSliders[i].container).parent().attr("data-transition") && $($nectarSliders[i].container).parent().attr("data-transition") === "fade") {
                for (var k = 0; k < $nectarSliders[i].slides.length; k++) {
                    $nectarSliders[i].setTransition($nectarSliders[i].slides[k], 0);
                }
                $(".swiper-wrapper").stop(true, true).css("transition-duration", "0s");
                if ($(".nectar-slider-loading").css("display") === "none") {
                    $(".swiper-wrapper .swiper-slide.swiper-slide-active .content > *").css({ opacity: 1, transform: "translateY(0)" });
                }
            }
            $nectarSliders[i].reInit();
            $nectarSliders[i].resizeFix();
        }
    }
    $(window).on("resize.nsSliderContent", nsSliderContentResize);
    function resizeToCover() {
        $(".nectar-slider-wrap").each(function (i) {
            if ($(this).css("visibility") != "hidden") {
                var $leftHeaderSize = $('#header-outer[data-format="left-header"]').length > 0 && window.innerWidth >= 1000 ? parseInt($('#header-outer[data-format="left-header"]').width()) : 0;
                var $windowWidth = $(window).width() - $leftHeaderSize;
                if ($("body > #boxed").length === 0 && $('.nectar-slider-wrap[data-full-width="true"]').parent().attr("id") != "portfolio-extra" && $(this).parents('.post-area:not(".span_12")').length === 0) {
                    $('.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap').css({ left: -(($windowWidth - $smoothSrollWidth) / 2 - $(".main-content").width() / 2), "margin-left": "0" });
                    $(
                        '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
                    ).css("width", $windowWidth);
                } else if ($('.nectar-slider-wrap[data-full-width="true"]').parent().attr("id") === "portfolio-extra" && $("#full_width_portfolio").length !== 0) {
                    $('.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap').css({ left: -(($windowWidth - $smoothSrollWidth) / 2 - $(".main-content").width() / 2), "margin-left": "0" });
                    $(
                        '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
                    ).css("width", $windowWidth);
                } else {
                    var $container = $("body > #boxed").length === 0 ? ".post-area" : ".container-wrap";
                    if ($($container).width() == "0" && $("body > #boxed").length > 0) $container = "#boxed";
                    $(
                        '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
                    ).css({ width: $($container).width(), "margin-left": "0" });
                }
                var $sliderHeight = parseInt($(this).find(".swiper-container").attr("data-height"));
                var $sliderMinHeight =
                    $(this).find(".swiper-container").is("[data-min-height]") && $(this).find(".swiper-container").attr("data-min-height").length > 0 ? parseInt($(this).find(".swiper-container").attr("data-min-height")) : 0;
                if ($sliderMinHeight > $sliderHeight) {
                    $sliderHeight = $sliderMinHeight;
                }
                var isFullWidthCompatible = $(this).attr("data-full-width") === "true" ? "true" : "false";
                if (($(this).parent().attr("id") == "portfolio-extra" && $("#full_width_portfolio").length === 0) || $(this).parents(".post-area").length > 0) {
                    isFullWidthCompatible = "false";
                }
                var $sliderWidth = isFullWidthCompatible === "true" ? $windowWidth - $smoothSrollWidth : $(this).width();
                var lrPadding = $(this).parents(".span_12").length > 0 && parseInt($(this).parents(".span_12").css("padding-left")) > 0 ? true : false;
                if ($(this).parents(".full-width-content").length > 0 && $(this).parents(".vc_col-sm-12").length > 0 && $("#boxed").length === 0 && lrPadding === false) {
                    $sliderWidth = $windowWidth;
                }
                $(this).parents(".parallax_slider_outer").css("height", $sliderHeight);
                $(this).css("height", $sliderHeight);
                $(this)
                    .find(".swiper-container, .swiper-slide")
                    .css({ height: $sliderHeight + 1 });
                $(this).find(".swiper-container").css("width", $sliderWidth);
                if (!$(this).is('[data-parallax="true"]')) {
                    $(this)
                        .find(".video-wrap")
                        .width($sliderWidth + 2);
                    $(this)
                        .find(".video-wrap")
                        .height($sliderHeight + 2);
                    var scale_h = $sliderWidth / vid_w_orig;
                    var scale_v = ($sliderHeight - $headerHeight) / vid_h_orig;
                    var scale = scale_h > scale_v ? scale_h : scale_v;
                    min_w = (1280 / 720) * ($sliderHeight + 20);
                    if (scale * vid_w_orig < min_w) {
                        scale = min_w / vid_w_orig;
                    }
                    $(this)
                        .find("video, .mejs-overlay, .mejs-poster")
                        .width(Math.ceil(scale * vid_w_orig + 2));
                    $(this)
                        .find("video, .mejs-overlay, .mejs-poster")
                        .height(Math.ceil(scale * vid_h_orig + 2));
                    $(this)
                        .find(".video-wrap")
                        .scrollLeft(($(this).find("video").width() - $sliderWidth) / 2);
                    $(this)
                        .find(".swiper-slide")
                        .each(function () {
                            if ($(this).find(".video-wrap").length > 0) {
                                if ($(this).attr("data-bg-alignment") === "center") {
                                    $(this)
                                        .find(".video-wrap, .mejs-overlay, .mejs-poster")
                                        .scrollTop(($(this).find("video").height() - $sliderHeight) / 2);
                                } else if ($(this).attr("data-bg-alignment") === "bottom") {
                                    $(this)
                                        .find(".video-wrap")
                                        .scrollTop($(this).find("video").height() - ($sliderHeight + 2));
                                } else {
                                    $(this).find(".video-wrap").scrollTop(0);
                                }
                            }
                        });
                }
            }
        });
    }
    resizeToCover();
    function captionTransition(obj) {
        resizeToCover();
        var $containerClass;
        typeof obj == "undefined" ? ($containerClass = "div[id^=ns-id-]") : ($containerClass = "#" + $(obj.container).parents(".nectar-slider-wrap").attr("id"));
        var fromLeft = Math.abs(parseInt($($containerClass + " .swiper-wrapper").css("left")));
        var currentSlide = Math.round(fromLeft / $($containerClass + " .swiper-slide").width());
        var $slideNum = $($containerClass + ":first .swiper-wrapper > div").length;
        var captionTransString = $($containerClass).is("[data-caption-trans]") ? $($containerClass).attr("data-caption-trans") : "fade_in_from_bottom";
        currentSlide = $($containerClass + " .swiper-slide-active").index();
        if ($($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")").find(".content *").length > 0 && captionTransString !== "reveal_title") {
            if (
                $($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")")
                    .find(".content *")
                    .css("opacity") != "0" &&
                !$("html").hasClass("no-video")
            ) {
                playVideoBG(currentSlide + 1, $containerClass);
                if (!$($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")").hasClass("autorotate-shown")) {
                    return false;
                } else {
                    $($containerClass + " .swiper-slide").removeClass("autorotate-shown");
                }
            }
        }
        if ($($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")").find(".content .ns-heading-el").length > 0 && captionTransString === "reveal_title") {
            if (
                $($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")")
                    .find(".content .ns-heading-el .word")
                    .css("opacity") != "0" &&
                !$("html").hasClass("no-video")
            ) {
                playVideoBG(currentSlide + 1, $containerClass);
                if (!$($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")").hasClass("autorotate-shown")) {
                    return false;
                } else {
                    $($containerClass + " .swiper-slide").removeClass("autorotate-shown");
                }
            }
        }
        if (!$("html").hasClass("no-video")) {
            if (captionTransString === "fade_in_from_bottom") {
                if ($($containerClass).parents(".wpb_gallery").length == 0) {
                    anime.remove(
                        $containerClass +
                            " .swiper-slide .content p, " +
                            $containerClass +
                            " .swiper-slide .content h2, " +
                            $containerClass +
                            " .swiper-slide .content h1, " +
                            $containerClass +
                            " .swiper-slide .content h3, " +
                            $containerClass +
                            " .swiper-slide .content .buttons"
                    );
                }
                $(
                    $containerClass +
                        " .swiper-slide .content p, " +
                        $containerClass +
                        " .swiper-slide .content h2, " +
                        $containerClass +
                        " .swiper-slide .content h1, " +
                        $containerClass +
                        " .swiper-slide .content h3, " +
                        $containerClass +
                        " .swiper-slide .content .buttons"
                )
                    .stop(true, true)
                    .css({ opacity: 0, transform: "translateZ(0) translateY(40px)" });
            } else if (captionTransString === "reveal_title") {
                $($containerClass + " .swiper-slide .content .ns-heading-el .word")
                    .stop(true, true)
                    .css({ opacity: "0" });
                $($containerClass + ' .swiper-slide .content .ns-heading-el .word > [class*="char"]').css({ opacity: "0" });
                $($containerClass + ' .swiper-slide .content .ns-heading-el .word > [class*="char"] > span').css({ transform: "scale(0) translateZ(0)" });
                anime.remove($containerClass + " .swiper-slide .content p, " + $containerClass + " .swiper-slide .content .buttons");
                $($containerClass + " .swiper-slide .content p, " + $containerClass + " .swiper-slide .content .buttons")
                    .stop(true, true)
                    .css({ opacity: 0, transform: "translateZ(0) translateY(40px)" });
            }
        }
        $($containerClass + " .swiper-slide").each(function () {
            if ($(this).find(".video-wrap video").length > 0 && !$("html").hasClass("no-video") && !$onMobileBrowser) {
                $(this).find(".video-wrap video").get(0).pause();
            }
        });
        $($containerClass + ' .swiper-slide:not(".swiper-slide-active")').each(function () {
            if ($(this).find(".video-wrap video").length > 0) {
                if ($(this).find(".video-wrap video").get(0).currentTime != 0) {
                    $(this).find(".video-wrap video").get(0).currentTime = 0;
                }
            }
        });
        if ($($containerClass + " .swiper-container").attr("data-loop") === "true") {
            if ($($containerClass + " .swiper-slide-active").index() + 1 == 2 && $($containerClass + " .swiper-slide-active video").length > 0 && !$("html").hasClass("no-video") && !$onMobileBrowser) {
                $($containerClass + " .swiper-slide:last-child")
                    .find(".video-wrap video")
                    .get(0)
                    .play();
                $($containerClass + " .swiper-slide:last-child")
                    .find(".video-wrap video")
                    .get(0)
                    .pause();
            }
            if ($($containerClass + " .swiper-slide-active").index() + 1 == $slideNum - 1 && $($containerClass + " .swiper-slide-active video").length > 0 && !$("html").hasClass("no-video") && !$onMobileBrowser) {
                $($containerClass + " .swiper-slide:first-child")
                    .find(".video-wrap video")
                    .get(0)
                    .play();
                $($containerClass + " .swiper-slide:first-child")
                    .find(".video-wrap video")
                    .get(0)
                    .pause();
            }
            if ($($containerClass + " .swiper-slide-active").index() + 1 != 2 && $($containerClass + " .swiper-slide:nth-child(2) video").length > 0 && !$("html").hasClass("no-video") && !$onMobileBrowser) {
                $($containerClass + " .swiper-slide:last-child")
                    .find(".video-wrap video")
                    .get(0)
                    .play();
                $($containerClass + " .swiper-slide:last-child")
                    .find(".video-wrap video")
                    .get(0)
                    .pause();
                $($containerClass + " .swiper-slide:nth-child(2) video")
                    .get(0)
                    .pause();
                if ($($containerClass + " .swiper-slide:nth-child(2) video").get(0).currentTime != 0) {
                    $($containerClass + " .swiper-slide:nth-child(2) video").get(0).currentTime = 0;
                }
            }
            if ($($containerClass).attr("data-overall_style") != "directional") {
                if ($($containerClass + " .swiper-slide-active").index() + 1 == $slideNum - 1) {
                    $($containerClass + " .swiper-slide:nth-child(1)")
                        .find(".content")
                        .children()
                        .each(function (i) {
                            captionTransAnimation($(this), i, captionTransString);
                        });
                }
                if ($($containerClass + " .swiper-slide-active").index() + 1 == 2) {
                    $($containerClass + " .swiper-slide:nth-child(" + $slideNum + ")")
                        .find(".content")
                        .children()
                        .each(function (i) {
                            captionTransAnimation($(this), i, captionTransString);
                        });
                }
                if ($($containerClass + " .swiper-slide-active").index() + 1 == $slideNum) {
                    $($containerClass + " .swiper-slide:nth-child(2)")
                        .find(".content")
                        .children()
                        .each(function (i) {
                            captionTransAnimation($(this), i, captionTransString);
                        });
                }
                if ($($containerClass + " .swiper-slide-active").index() + 1 == 1) {
                    $($containerClass + " .swiper-slide:eq(-2)")
                        .find(".content")
                        .children()
                        .each(function (i) {
                            captionTransAnimation($(this), i, captionTransString);
                        });
                }
            }
        }
        setTimeout(function () {
            playVideoBG($($containerClass + " .swiper-slide-active").index() + 1, $containerClass);
        }, 50);
        if ($($containerClass).attr("data-overall_style") != "directional") {
            $($containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")")
                .find(".content")
                .children()
                .each(function (i) {
                    captionTransAnimation($(this), i, captionTransString);
                });
        }
        $captionTrans++;
        if ($captionTrans == $(".swiper-wrapper").length) {
            $("div.first_video_slide").addClass("nulled");
        }
        setTimeout(function () {
            if ($(".slider-next").hasClass("next-arrow-move")) {
                $('.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-next').trigger("mouseenter");
            } else if ($(".slider-prev").hasClass("prev-arrow-move")) {
                $('.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-prev').trigger("mouseenter");
            }
            if ($($containerClass).attr("data-button-styling") === "btn_with_preview") {
                $($containerClass + " .swiper-slide").addClass("prev-high-z-index-static");
                $($containerClass + " .swiper-slide.swiper-slide-active").removeClass("prev-high-z-index-static");
            }
        }, 175);
    }
    function NSsplitLineText() {
        $('.nectar-slider-wrap[data-caption-trans="reveal_title"] .content .ns-heading-el').each(function () {
            var storedCSSOpacity = $(this).parents(".swiper-slide-active").length > 0 && $(this).find(".word").length > 0 ? $(this).find("> .word").css("opacity") : "0";
            var textArr = $(this).text();
            textArr = textArr.trim();
            textArr = textArr.split(" ");
            $(this)[0].innerHTML = "";
            for (var i = 0; i < textArr.length; i++) {
                $(this)[0].innerHTML += '<span class="word">' + textArr[i] + "</span> ";
            }
            $(this)
                .find(".word")
                .each(function () {
                    charming($(this)[0]);
                });
            $(this).find('[class*="char"]').wrapInner('<span class="char-inner" />');
            if ($(this).parents(".swiper-slide-active").length > 0) {
                $(this).find("> .word").css("opacity", storedCSSOpacity);
            }
        });
    }
    function charming(element, options) {
        options = options || {};
        element.normalize();
        var splitRegex = options.splitRegex;
        var tagName = options.tagName || "span";
        var classPrefix = options.classPrefix != null ? options.classPrefix : "char";
        var count = 1;
        function inject(element) {
            var parentNode = element.parentNode;
            var string = element.nodeValue;
            var split = splitRegex ? string.split(splitRegex) : string;
            var length = split.length;
            var i = -1;
            while (++i < length) {
                var node = document.createElement(tagName);
                if (classPrefix) {
                    node.className = classPrefix + count;
                    count++;
                }
                node.appendChild(document.createTextNode(split[i]));
                node.setAttribute("aria-hidden", "true");
                parentNode.insertBefore(node, element);
            }
            if (string.trim() !== "") {
                parentNode.setAttribute("aria-label", string);
            }
            parentNode.removeChild(element);
        }
        (function traverse(element) {
            if (element.nodeType === 3) {
                return inject(element);
            }
            var childNodes = Array.prototype.slice.call(element.childNodes);
            var length = childNodes.length;
            if (length === 1 && childNodes[0].nodeType === 3) {
                return inject(childNodes[0]);
            }
            var i = -1;
            while (++i < length) {
                traverse(childNodes[i]);
            }
        })(element);
    }
    NSsplitLineText();
    var charCount = 0;
    function captionTransAnimation(obj, index, animationName) {
        if (animationName === "reveal_title") {
            if (obj.parent().find(".word").length === 0) charCount = 0;
            if (index === 0 && obj.parent().find(".word").length > 0) {
                charCount = obj.find('.word > [class*="char"]').length;
                obj.find(".word").css("opacity", "1");
                obj.find('.word > [class*="char"]').each(function (i) {
                    anime({ targets: $(this)[0], translateY: [50, 0], translateZ: 0, opacity: 1, easing: "cubicBezier(.25,.25,.1,1)", duration: 700, delay: i * 18 });
                    anime({ targets: $(this).find("> span")[0], scale: [0, 1], translateZ: 0, easing: "cubicBezier(.25,.25,.1,1)", duration: 700, delay: i * 18 });
                });
            } else {
                anime({ targets: obj[0], translateY: [50, 0], translateZ: 0, opacity: 1, easing: "cubicBezier(.25,.25,.1,1)", duration: 850, delay: index * 150 + charCount * 18 });
            }
        } else if (animationName === "fade_in_from_bottom") {
            anime({ targets: obj[0], translateY: [50, 0], translateZ: 0, opacity: 1, easing: "cubicBezier(.25,.25,.1,1)", duration: 800, delay: index * 130 });
        }
    }
    function playVideoBG(nthChild, containerClass) {
        if ($(containerClass + " .swiper-slide:nth-child(" + nthChild + ")").find(".video-wrap video").length > 0) {
            if (!$("html").hasClass("no-video") && !$onMobileBrowser) {
                $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".video-wrap video")
                    .get(0)
                    .play();
            }
            if (
                !$(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".mejs-overlay.mejs-overlay-play")
                    .hasClass("playing") &&
                $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".mejs-overlay.mejs-overlay-play")
                    .hasClass("mobile-played")
            ) {
                $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".mejs-overlay.mejs-overlay-play")
                    .addClass("playing");
            }
            if (
                !$(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".mejs-poster")
                    .hasClass("playing") &&
                $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".mejs-poster")
                    .hasClass("mobile-played")
            ) {
                $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
                    .find(".mejs-poster")
                    .addClass("playing");
            }
            var $that = $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")").find(".mejs-overlay.mejs-overlay-play");
            var $that2 = $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")").find(".mejs-poster");
            if ($that.hasClass("playing") && $that.hasClass("mobile-played")) {
                setTimeout(function () {
                    $that.addClass("behind-buttons");
                    $that2.addClass("behind-buttons");
                }, 200);
            } else {
                $that.removeClass("behind-buttons");
                $that2.removeClass("behind-buttons");
            }
        }
    }
    function slideContentPos() {
        $(".swiper-wrapper").each(function () {
            var $sliderHeight = parseInt($(this).parents(".swiper-container").attr("data-height"));
            var $minimumHeight = $(this).parents(".swiper-container").css("min-height") ? parseInt($(this).parents(".swiper-container").css("min-height")) : 0;
            if ($minimumHeight > $sliderHeight) {
                $sliderHeight = $minimumHeight;
            }
            var $transparentHeader = $('#header-outer[data-transparent-header="true"]').length > 0 ? $("#header-outer").height() : 0;
            if (($(this).parents(".first-section").length == 0 && $(this).parents(".top-level").length == 0) || window.innerWidth < 1000) {
                $transparentHeader = 0;
            } else if ($transparentHeader != 0 && $('#header-outer[data-remove-border="true"]').length > 0) {
                $transparentHeader = $transparentHeader / 2;
            }
            if (
                ($(this).parents('.swiper-container[data-bullet_position="right"][data-bullets="true"]').length > 0 && $transparentHeader > 0) ||
                ($(this).parents('.swiper-container[data-bullet_position="left"][data-bullets="true"]').length > 0 && $transparentHeader > 0)
            ) {
                var secondaryHeaderHeight = $("#header-secondary-outer").length > 0 ? $("#header-secondary-outer").height() : 0;
                $(this)
                    .parents(".swiper-container")
                    .find(".slider-pagination-wrap")
                    .css({ "margin-top": ($transparentHeader + secondaryHeaderHeight) / 2 });
            }
            $(this)
                .find(".swiper-slide")
                .each(function () {
                    var $contentHeight2 = 0;
                    $(this)
                        .find(".content > *")
                        .each(function () {
                            $contentHeight2 += $(this).height() + parseInt($(this).css("margin-bottom")) + parseInt($(this).css("padding-bottom"));
                        });
                    if ($(this).attr("data-y-pos") === "top" && window.innerWidth > 690) {
                        var secondaryHeaderHeight = $("#header-secondary-outer").length > 0 ? $("#header-secondary-outer").height() : 0;
                        var $topHeight = $transparentHeader > 0 ? $transparentHeader + secondaryHeaderHeight + 60 : 60;
                        $(this)
                            .find(".content")
                            .css("top", $topHeight + "px");
                    } else if ($(this).attr("data-y-pos") === "middle" || window.innerWidth <= 690) {
                        $(this)
                            .find(".content")
                            .css("top", ($sliderHeight + $transparentHeader) / 2 - $contentHeight2 / 2 + "px");
                    } else {
                        $(this).find(".content").css({ bottom: "75px", top: "auto" });
                    }
                });
        });
    }
    function showSliderControls() {
        $(".swiper-container .slider-prev, .swiper-container .slider-next, .slider-pagination").animate({ opacity: 1 }, 550, "easeOutCubic");
    }
    function sliderLoadIn(slider, index) {
        slider.find(".nectar-slider-loading").fadeOut(800, "easeInOutExpo");
        setTimeout(function () {
            slider.find(".nectar-slider-loading").css("display", "none");
        }, 1000);
        $(".nectar-slider-wrap.first-section .swiper-container .swiper-wrapper .swiper-slide").removeClass("not-loaded");
        slider.find("span.ie-fix").remove();
        if (slider.find('.swiper-container[data-bullet_style="see_through_ar_visualized"][data-bullets="true"]').length > 0) {
            slider.find(".swiper-active-switch").removeClass("ar-vis");
            setTimeout(function () {
                slider.parent().find(".swiper-active-switch").addClass("ar-vis");
            }, 50);
        }
        sliderLoadedLength++;
        if (!navigator.userAgent.match(/(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/)) {
            autorotateInit(slider, index);
        }
    }
    $("body").on("mouseover", ".swiper-slide", function () {
        if (!$onMobileBrowser && $(this).find("video").length > 0 && $(this).find("video").get(0).paused == true && $animating == false) {
            $(this).find("video").get(0).play();
        }
    });
    $("body").on("click", ".mejs-overlay.mejs-overlay-play", function () {
        $(this).toggleClass("playing");
        $(this).addClass("mobile-played");
        $(this).parent().find(".mejs-poster").toggleClass("playing");
        $(this).parent().find(".mejs-poster").addClass("mobile-played");
        var $that = $(this);
        var $that2 = $(this).parent().find(".mejs-poster");
        if ($(this).hasClass("playing") && $(this).hasClass("mobile-played")) {
            setTimeout(function () {
                $that.addClass("behind-buttons");
                $that2.addClass("behind-buttons");
            }, 200);
        } else {
            setTimeout(function () {
                $that.removeClass("behind-buttons");
                $that2.removeClass("behind-buttons");
            }, 1);
        }
    });
    function autorotateInit(slider, num) {
        var $autoplayVal = slider.attr("data-autorotate");
        var $sliderNum = num;
        if (typeof $autoplayVal != "undefined" && $autoplayVal.length != "0" && parseInt($autoplayVal)) {
            nectarSlideRotateInit(slider, $autoplayVal, $sliderNum);
        }
    }
    function nectarSlideRotateInit(slider, interval, sliderNum) {
        autoplay[sliderAutoplayCount] = {
            interval: setInterval(function () {
                nectarSlideRotate(slider, sliderNum);
            }, interval),
            nectarSliderNum: sliderNum,
            autoplayNum: sliderAutoplayCount,
            nectarSliderID: slider.attr("id"),
        };
        $("#" + slider.attr("id")).attr("autoplay-id", sliderAutoplayCount);
        if ($("#" + slider.attr("id")).find('[data-bullet_style="see_through_ar_visualized"]').length > 0) {
            $("#" + slider.attr("id"))
                .find(".slider-pagination svg circle.time")
                .css("transition", "stroke-dashoffset " + (parseInt(interval) + 100) + "ms linear, stroke 0.2s ease");
        }
        var sliderClosure = slider;
        var sliderAutoplayCountClosure = sliderAutoplayCount;
        var intervalClosure = interval;
        var sliderNumClosure = sliderNum;
        $("#" + slider.attr("id") + " a.slider-prev, #" + slider.attr("id") + " a.slider-next, #" + slider.attr("id") + " .slider-pagination span:not(.swiper-active-switch)").on("click", function () {
            nectarSlideRotateReset(sliderClosure, sliderAutoplayCountClosure, intervalClosure, sliderNumClosure);
        });
        sliderAutoplayCount++;
    }
    function nectarSlideRotateReset(slider, sliderAutoplayCount, interval, sliderNum) {
        slider = typeof slider.activeIndex === "undefined" ? slider : $(slider.container).parent();
        sliderAutoplayCount = typeof sliderAutoplayCount !== "undefined" && typeof sliderAutoplayCount === "number" ? sliderAutoplayCount : "unknown";
        if (sliderAutoplayCount === "unknown") {
            $.each(autoplay, function (k, v) {
                if ($("body").find("#" + v.nectarSliderID).length > 0 && v.nectarSliderID == $(slider).attr("id")) {
                    sliderAutoplayCount = v.autoplayNum;
                    interval =
                        $("body")
                            .find("#" + v.nectarSliderID)
                            .attr("data-autorotate").length > 0 &&
                        parseInt(
                            $("body")
                                .find("#" + v.nectarSliderID)
                                .attr("data-autorotate")
                        ) > 1000
                            ? $("body")
                                  .find("#" + v.nectarSliderID)
                                  .attr("data-autorotate")
                            : 4000;
                    sliderNum = v.nectarSliderNum;
                }
            });
        }
        if (sliderAutoplayCount !== "unknown") {
            clearInterval(autoplay[$("#" + slider.attr("id")).attr("autoplay-id")].interval);
            autoplay[sliderAutoplayCount].interval = setInterval(function () {
                nectarSlideRotate(slider, sliderNum);
            }, interval);
        }
    }
    var resetTouchIndex = 1;
    var resetTouchIndexLast = "unknown";
    function nectarSlideRotateResetTouch(slider) {
        if (Math.abs(slider.touches.diff) < 15) {
            return;
        }
        if (resetTouchIndexLast == "unknown" && $(slider.container).is('[data-loop="true"]')) {
            resetTouchIndexLast = 1;
        } else if (resetTouchIndexLast == "unknown") {
            resetTouchIndexLast = 0;
        }
        resetTouchIndex = slider.activeIndex;
        nectarSlideRotateReset(slider);
        if ($(slider.container).is('[data-bullets="true"][data-bullet_style="see_through_ar_visualized"]') && resetTouchIndex == resetTouchIndexLast) {
            var dotIndexStored = $(slider.container).find(".ar-vis").index();
            $(slider.container).find(".ar-vis").removeClass("ar-vis");
            setTimeout(function () {
                $(slider.container)
                    .find(".slider-pagination > span:nth-child(" + (dotIndexStored + 1) + ")")
                    .addClass("ar-vis");
            }, 50);
        }
        resetTouchIndexLast = slider.activeIndex;
    }
    function nectarSlideRotate(slider, sliderNum) {
        if ($(slider).hasClass("out-of-view")) {
            return true;
        }
        if ($("#nectar_fullscreen_rows").length > 0) {
            if ($(slider).parents(".wpb_row.active").length == 0) {
                return true;
            }
        }
        if ($nectarSliders[sliderNum].activeIndex + 1 < $(slider).find(".swiper-wrapper > div.swiper-slide").length) {
            if ($(slider).attr("data-button-styling") === "btn_with_preview") {
                $(slider).find(".swiper-slide").removeClass("high-z-index").removeClass("prev-high-z-index");
                $(slider).find(".swiper-slide").removeClass("next-move").removeClass("prev-move");
            }
            if ($(slider).attr("data-overall_style") != "directional") {
                $nectarSliders[sliderNum].swipeNext();
            } else {
                $($nectarSliders[sliderNum].container).find(".slider-next").trigger("click");
            }
        } else {
            if ($(slider).find(".swiper-container").is("[data-loop]") && $(slider).find(".swiper-container").attr("data-loop") === "true") {
                if ($(slider).attr("data-overall_style") != "directional") {
                    $nectarSliders[sliderNum].swipeNext();
                } else {
                    $($nectarSliders[sliderNum].container).find(".slider-next").trigger("click");
                }
            } else {
                if ($(slider).attr("data-overall_style") != "directional") {
                    $nectarSliders[sliderNum].swipeTo(0, 550);
                } else {
                    $(slider).find(".swiper-container").addClass("directional-trans-prev");
                    $nectarSliders[sliderNum].swipeTo(0, 550);
                    var $timeout2;
                    clearTimeout($timeout2);
                    $timeout2 = setTimeout(function () {
                        onChangeStart($nectarSliders[sliderNum]);
                    }, 100);
                }
            }
        }
    }
    function clearAutoplay(e) {
        var $autoplayVal = $("#" + $(e.container).parent().attr("id")).attr("data-autorotate");
        if (typeof $autoplayVal != "undefined" && $autoplayVal.length != "0" && parseInt($autoplayVal)) {
            clearInterval(autoplay[$("#" + $(e.container).parent().attr("id")).attr("autoplay-id")].interval);
        }
    }
    function onChangeStart(e) {
        var $obj = e;
        $animating = true;
        var $slideNum = $($obj.container).find(".swiper-wrapper > div").length;
        var $activeIndex = $($obj.container).attr("data-loop") === "true" ? $obj.activeIndex + 1 : $obj.activeIndex + 1;
        var $activeIndex2 = $($obj.container).attr("data-loop") === "true" ? $obj.activeIndex : $obj.activeIndex + 1;
        if ($($obj.container).parent().attr("data-overall_style") !== "directional") {
            if (
                ($($obj.container).parents(".first-section").length > 0 && $($obj.container).find('.swiper-slide-active[data-color-scheme="dark"]').length > 0) ||
                ($("#nectar_fullscreen_rows").length > 0 && $($obj.container).find('.swiper-slide-active[data-color-scheme="dark"]').length > 0)
            ) {
                $("#header-outer").addClass("dark-slide");
            } else if ($($obj.container).parents(".first-section").length > 0 || $("#nectar_fullscreen_rows").length > 0) {
                $("#header-outer").removeClass("dark-slide");
            }
        } else {
            if ($($obj.container).hasClass("directional-trans-next")) {
                if ($($obj.container).parents(".first-section").length > 0 && $($obj.container).find(".swiper-slide-active").next(".swiper-slide").is('[data-color-scheme="dark"]')) {
                    $("#header-outer").addClass("dark-slide");
                } else {
                    $("#header-outer").removeClass("dark-slide");
                }
            } else if ($($obj.container).hasClass("directional-trans-prev")) {
                if ($($obj.container).parents(".first-section").length > 0 && $($obj.container).find(".swiper-slide-active").prev(".swiper-slide").is('[data-color-scheme="dark"]')) {
                    $("#header-outer").addClass("dark-slide");
                } else {
                    $("#header-outer").removeClass("dark-slide");
                }
            } else if ($($obj.container).hasClass("directional-trans-current")) {
                if ($($obj.container).parents(".first-section").length > 0 && $($obj.container).find(".swiper-slide-active").is('[data-color-scheme="dark"]')) {
                    $("#header-outer").addClass("dark-slide");
                } else {
                    $("#header-outer").removeClass("dark-slide");
                }
            }
        }
        if ($($obj.container).parent().attr("data-overall_style") != "directional") {
            if (
                $($obj.container)
                    .find(".swiper-slide:nth-child(" + $activeIndex + ")")
                    .attr("data-color-scheme") === "dark"
            ) {
                $($obj.container).find(".slider-pagination").addClass("dark-cs");
                $($obj.container).find(".slider-prev, .slider-next").addClass("dark-cs");
            } else {
                $($obj.container).find(".slider-pagination").removeClass("dark-cs");
                $($obj.container).find(".slider-prev, .slider-next").removeClass("dark-cs");
            }
        } else {
            if ($($obj.container).hasClass("directional-trans-next")) {
                if (
                    $($obj.container)
                        .find(".swiper-slide:nth-child(" + ($activeIndex + 1) + ")")
                        .attr("data-color-scheme") === "dark"
                ) {
                    $($obj.container).find(".slider-pagination").addClass("dark-cs");
                    $($obj.container).find(".slider-prev, .slider-next").addClass("dark-cs");
                } else {
                    $($obj.container).find(".slider-pagination").removeClass("dark-cs");
                    $($obj.container).find(".slider-prev, .slider-next").removeClass("dark-cs");
                }
            } else if ($($obj.container).hasClass("directional-trans-prev")) {
                if (
                    $($obj.container)
                        .find(".swiper-slide:nth-child(" + ($activeIndex - 1) + ")")
                        .attr("data-color-scheme") === "dark"
                ) {
                    $($obj.container).find(".slider-pagination").addClass("dark-cs");
                    $($obj.container).find(".slider-prev, .slider-next").addClass("dark-cs");
                } else {
                    $($obj.container).find(".slider-pagination").removeClass("dark-cs");
                    $($obj.container).find(".slider-prev, .slider-next").removeClass("dark-cs");
                }
            } else if ($($obj.container).hasClass("directional-trans-current")) {
                if (
                    $($obj.container)
                        .find(".swiper-slide:nth-child(" + $activeIndex + ")")
                        .attr("data-color-scheme") === "dark"
                ) {
                    $($obj.container).find(".slider-pagination").addClass("dark-cs");
                    $($obj.container).find(".slider-prev, .slider-next").addClass("dark-cs");
                } else {
                    $($obj.container).find(".slider-pagination").removeClass("dark-cs");
                    $($obj.container).find(".slider-prev, .slider-next").removeClass("dark-cs");
                }
            }
        }
        $($obj.container).find(".swiper-slide .video-texture").removeClass("no-trans").removeClass("light-overlay").removeClass("dark-overlay").removeClass("half-dark-overlay").removeClass("half-light-overlay");
        $($obj.container).find(".slider-prev .slide-count .slide-current").html($activeIndex2);
        $($obj.container).find(".slider-next .slide-count .slide-current").html($activeIndex2);
        if ($($obj.container).attr("data-loop") === "true") {
            if ($($obj.container).find(".swiper-slide-active").index() + 1 == 1) {
                $($obj.container)
                    .find(".slider-next .slide-count .slide-current, .slider-prev .slide-count .slide-current")
                    .html($slideNum - 2);
            } else if ($($obj.container).find(".swiper-slide-active").index() + 1 == $slideNum) {
                $($obj.container).find(".slider-next .slide-count .slide-current, .slider-prev .slide-count .slide-current").html(1);
            }
        }
        if ($obj.activeIndex >= 10) {
            $($obj.container).find(".slider-next .slide-count .slide-current").addClass("double-digits");
        } else {
            $($obj.container).find(".slider-next .slide-count .slide-current").removeClass("double-digits");
        }
        if ($($obj.container).attr("data-loop") === "true") {
            if (($obj.previousIndex == 1 && $obj.activeIndex == 0) || ($obj.previousIndex == $slideNum - 2 && $obj.activeIndex == $slideNum - 1)) {
                $(".swiper-slide").addClass("duplicate-transition");
            }
        }
        var sliderIndex = 0;
        slideAnimationQueues.forEach(function (val, index) {
            if (typeof val === "undefined") return;
            if (val.sliderID == $($obj.container).parent().attr("id")) {
                sliderIndex = index;
            }
        });
        if ($($obj.container).parent().is('[data-bg-animation="ken_burns"]') && $($obj.container).parents('.nectar-slider-wrap[data-overall_style="directional"]').length === 0) {
            $($obj.container).find(".swiper-slide").addClass("ken-burns");
            clearTimeout(slideAnimationQueues[sliderIndex].kenBurnsInterval);
            slideAnimationQueues[sliderIndex].kenBurnsInterval = setTimeout(function () {
                $($obj.container).find('.swiper-slide:not(".swiper-slide-active")').removeClass("ken-burns");
            }, 600);
        }
        var nsTimeout = $($obj.container).parents('.nectar-slider-wrap[data-transition="fade"]').length > 0 ? 350 : 525;
        clearTimeout(slideAnimationQueues[sliderIndex].captionInterval);
        if ($($obj.container).parents('.nectar-slider-wrap[data-overall_style="directional"]').length === 0) {
            slideAnimationQueues[sliderIndex].captionInterval = setTimeout(function () {
                $animating = false;
                if ($($obj.container).attr("data-loop") === "true") {
                    $(".swiper-slide").removeClass("duplicate-transition");
                    $.each($nectarSliders, function (k) {
                        $nectarSliders[k].updateActiveSlide();
                        $nectarSliders[k].fixLoop();
                    });
                }
                captionTransition($obj);
            }, nsTimeout);
        }
    }
    window.requestAnimationFrame =
        window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (f) {
            setTimeout(f, 1000 / 60);
        };
    var $sliderHeight;
    function sliderParallaxUpdateHeight() {
        $sliderHeight = parseInt($(".parallax_slider_outer.first-section .swiper-container").attr("data-height"));
    }
    var $headerNavSpace = $('body[data-header-format="left-header"]').length > 0 && $(window).width() > 1000 ? 0 : $("#header-space").height();
    function sliderParallaxInit() {
        if ($("#portfolio-extra").length > 0 && $("#full_width_portfolio").length === 0) {
            return false;
        }
        $(".parallax_slider_outer").addClass("element-in-view");
        if (!$onMobileBrowser) {
            if ($(".project-title.parallax-effect").length > 0) {
                $(".parallax_slider_outer.first-section .swiper-slide .content, .nectar-slider-wrap.first-section .swiper-slide .content").css("margin-top", "0px");
                $(".swiper-container .slider-prev, .swiper-container .slider-next").css("margin-top", "-28px");
            }
            if ($(".demo_store").length > 0) $(".project-title.parallax-effect").css("margin-top", "-25px");
            if ($("#full_width_portfolio").length > 0) {
                $(".parallax_slider_outer.first-section").css("margin-top", "93px");
            }
            $(window).off("resize.nsHeightUpdate");
            $(window).on("resize.nsHeightUpdate", sliderParallaxUpdateHeight);
        }
    }
    function parallaxCheck() {
        $(window).off("scroll.nsParallaxScroll");
        if ($(".parallax_slider_outer").length > 0) {
            sliderParallaxInit();
            if ($('body[data-hhun="1"]').length > 0 && !$('#header-outer[data-remove-fixed="1"]').length > 0) {
                $("#header-outer").addClass("parallax-contained");
            }
        }
    }
    parallaxCheck();
    $(".portfolio-items a.pp:contains(Video), .swiper-container .buttons a.pp").on("click", function () {
        $(".swiper-slide").each(function () {
            if ($(this).find(".video-wrap video").length > 0) {
                $(this).find(".video-wrap video").get(0).pause();
            }
        });
    });
    function hexConvert(x) {
        return ("0" + parseInt(x).toString(16)).slice(-2);
    }
    $.cssHooks.backgroundColor = {
        get: function (elem) {
            var bg;
            if (elem.currentStyle) {
                bg = elem.currentStyle["backgroundColor"];
            } else if (window.getComputedStyle) {
                bg = document.defaultView.getComputedStyle(elem, null).getPropertyValue("background-color");
            }
            if (bg.search("rgb") == -1) {
                return bg;
            } else {
                bg = bg.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                if (bg) {
                    return "#" + hexConvert(bg[1]) + hexConvert(bg[2]) + hexConvert(bg[3]);
                }
            }
        },
    };
    $(".swiper-slide.external-full-link a.entire-slide-link").attr("target", "_blank");
    $(".swiper-slide.external-button-1 .buttons > div:nth-child(1) a").attr("target", "_blank");
    $(".swiper-slide.external-button-2 .buttons > div:nth-child(2) a").attr("target", "_blank");
    headerPadding = headerPadding - headerPadding / 1.8;
    $("body").on("click", ".slider-down-arrow", function () {
        if ($(this).parents("#nectar_fullscreen_rows").length > 0) {
            if ($("#fp-nav li .active").parent().next("li").length > 0) {
                $("#fp-nav li .active").parent().next("li").find("a").trigger("click");
            }
            return;
        }
        var $currentSlider = $(this).parents(".swiper-container");
        var $topDistance = $currentSlider.attr("data-height");
        var $offset = $currentSlider.parents(".first-section").length === 0 || $('#header-outer[data-transparent-header="true"]').length === 0 ? $currentSlider.offset().top : 0;
        var materialSecondary = 0;
        if ($("body.material").length > 0 && $("#header-secondary-outer").length > 0) {
            materialSecondary = $("#header-secondary-outer").height();
        }
        if ($('body[data-permanent-transparent="1"]').length === 0) {
            if (!$("body").hasClass("mobile")) {
                if ($('body[data-hhun="1"]').length > 0) {
                    $("body,html")
                        .stop()
                        .animate({ scrollTop: parseInt($topDistance) + $offset + 2 }, 1000, "easeInOutCubic");
                } else {
                    if ($('#header-outer[data-condense="true"]').length > 0) {
                        var $headerSpan9 = $('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9');
                        var $secondaryHeaderHeight = $("#header-secondary-outer").length > 0 ? $("#header-secondary-outer").height() : 0;
                        $headerNavSpace = $("#header-outer").height() - (parseInt($headerSpan9.position().top) - parseInt($("#header-outer #logo").css("margin-top"))) - parseInt($secondaryHeaderHeight);
                        $("body,html")
                            .stop()
                            .animate({ scrollTop: parseInt($topDistance - $headerNavSpace) + 2 }, 1000, "easeInOutCubic");
                    } else {
                        $("body,html")
                            .stop()
                            .animate({ scrollTop: parseInt($topDistance - $("#header-space").height()) + parseInt(shrinkNum) + headerPadding * 2 + $offset + 2 + materialSecondary }, 1000, "easeInOutCubic");
                    }
                }
            } else {
                var $scrollPos =
                    $('#header-outer[data-mobile-fixed="1"]').length > 0
                        ? parseInt($topDistance) - $("#header-space").height() + parseInt($currentSlider.offset().top) + 2
                        : parseInt($topDistance) + parseInt($currentSlider.offset().top) + 2;
                $("body,html").stop().animate({ scrollTop: $scrollPos }, 1000, "easeInOutCubic");
            }
        } else {
            $("body,html")
                .stop()
                .animate({ scrollTop: parseInt($topDistance) + parseInt($currentSlider.offset().top) + 2 }, 1000, "easeInOutCubic");
        }
        return false;
    });
});
/*!
 * Simple jQuery Equal Heights
 *
 * Copyright (c) 2013 Matt Banks
 * Dual licensed under the MIT and GPL licenses.
 * Uses the same license as jQuery, see:
 * http://docs.jquery.com/License
 *
 * @version 1.5.1
 */
!(function (a) {
    (a.fn.equalHeights = function () {
        var b = 0,
            c = a(this);
        return (
            c.each(function () {
                var c = a(this).innerHeight();
                c > b && (b = c);
            }),
            c.css("height", b)
        );
    }),
        a("[data-equal]").each(function () {
            var b = a(this),
                c = b.data("equal");
            b.find(c).equalHeights();
        });
})(jQuery);
jQuery(document).ready(function ($) {
    $(window).load(function () {
        if (window.innerWidth > 568) {
            $(".menu-item-title").equalHeights();
            $("#wpsl-wrap #wpsl-result-list ul li").equalHeights();
        }
    });
    $(window).resize(function () {
        if (window.innerWidth > 568) {
            $(".menu-item-title").height("auto");
            $(".menu-item-title").equalHeights();
            $("#wpsl-wrap #wpsl-result-list ul li").height("auto");
            $("#wpsl-wrap #wpsl-result-list ul li").equalHeights();
        }
    });
});
if (jQuery(window).width() < 1025) {
    jQuery("ul.gtech-menu > li.with-sub-menu").click(function () {
        jQuery("ul.gtech-menu > li.with-sub-menu.active").not(this).removeClass("active");
        if (jQuery(this).hasClass("active")) {
            jQuery(this).removeClass("active");
        } else {
            jQuery(this).addClass("active");
        }
        jQuery(".sub-menu-wrapper > ul > li:first-child").addClass("open");
    });
    jQuery(".sub-menu-wrapper > ul > li").click(function () {
        jQuery(".sub-menu-wrapper > ul > li.open").not(this).removeClass("active");
        if (jQuery(this).hasClass("open")) {
            jQuery(this).removeClass("open");
        } else {
            jQuery(this).addClass("open");
        }
    });
} else {
    jQuery("ul.gtech-menu > li.with-sub-menu").hover(function () {
        jQuery(this).toggleClass("active");
        if (jQuery(".sub-menu-wrapper > ul > li").hasClass("open")) {
            jQuery(".sub-menu-wrapper > ul > li").removeClass("open");
        } else {
            jQuery(".sub-menu-wrapper > ul > li:first-child").toggleClass("open");
        }
    });
    jQuery(".sub-menu-wrapper > ul > li").hover(function () {
        jQuery(".sub-menu-wrapper > ul > li.open").not(this).removeClass("open");
        jQuery(this).addClass("open");
    });
}

!(function (n) {
    "function" == typeof define && define.amd
        ? define(["jquery"], function (e) {
              return n(e);
          })
        : "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = n(require("jquery")))
        : n(jQuery);
})(function (n) {
    function e(n) {
        var e = 7.5625,
            t = 2.75;
        return n < 1 / t ? e * n * n : n < 2 / t ? e * (n -= 1.5 / t) * n + 0.75 : n < 2.5 / t ? e * (n -= 2.25 / t) * n + 0.9375 : e * (n -= 2.625 / t) * n + 0.984375;
    }
    void 0 !== n.easing && (n.easing.jswing = n.easing.swing);
    var t = Math.pow,
        u = Math.sqrt,
        r = Math.sin,
        i = Math.cos,
        a = Math.PI,
        o = 1.70158,
        c = 1.525 * o,
        s = (2 * a) / 3,
        f = (2 * a) / 4.5;
    return (
        n.extend(n.easing, {
            def: "easeOutQuad",
            swing: function (e) {
                return n.easing[n.easing.def](e);
            },
            easeInQuad: function (n) {
                return n * n;
            },
            easeOutQuad: function (n) {
                return 1 - (1 - n) * (1 - n);
            },
            easeInOutQuad: function (n) {
                return n < 0.5 ? 2 * n * n : 1 - t(-2 * n + 2, 2) / 2;
            },
            easeInCubic: function (n) {
                return n * n * n;
            },
            easeOutCubic: function (n) {
                return 1 - t(1 - n, 3);
            },
            easeInOutCubic: function (n) {
                return n < 0.5 ? 4 * n * n * n : 1 - t(-2 * n + 2, 3) / 2;
            },
            easeInQuart: function (n) {
                return n * n * n * n;
            },
            easeOutQuart: function (n) {
                return 1 - t(1 - n, 4);
            },
            easeInOutQuart: function (n) {
                return n < 0.5 ? 8 * n * n * n * n : 1 - t(-2 * n + 2, 4) / 2;
            },
            easeInQuint: function (n) {
                return n * n * n * n * n;
            },
            easeOutQuint: function (n) {
                return 1 - t(1 - n, 5);
            },
            easeInOutQuint: function (n) {
                return n < 0.5 ? 16 * n * n * n * n * n : 1 - t(-2 * n + 2, 5) / 2;
            },
            easeInSine: function (n) {
                return 1 - i((n * a) / 2);
            },
            easeOutSine: function (n) {
                return r((n * a) / 2);
            },
            easeInOutSine: function (n) {
                return -(i(a * n) - 1) / 2;
            },
            easeInExpo: function (n) {
                return 0 === n ? 0 : t(2, 10 * n - 10);
            },
            easeOutExpo: function (n) {
                return 1 === n ? 1 : 1 - t(2, -10 * n);
            },
            easeInOutExpo: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : n < 0.5 ? t(2, 20 * n - 10) / 2 : (2 - t(2, -20 * n + 10)) / 2;
            },
            easeInCirc: function (n) {
                return 1 - u(1 - t(n, 2));
            },
            easeOutCirc: function (n) {
                return u(1 - t(n - 1, 2));
            },
            easeInOutCirc: function (n) {
                return n < 0.5 ? (1 - u(1 - t(2 * n, 2))) / 2 : (u(1 - t(-2 * n + 2, 2)) + 1) / 2;
            },
            easeInElastic: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : -t(2, 10 * n - 10) * r((10 * n - 10.75) * s);
            },
            easeOutElastic: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : t(2, -10 * n) * r((10 * n - 0.75) * s) + 1;
            },
            easeInOutElastic: function (n) {
                return 0 === n ? 0 : 1 === n ? 1 : n < 0.5 ? (-t(2, 20 * n - 10) * r((20 * n - 11.125) * f)) / 2 : (t(2, -20 * n + 10) * r((20 * n - 11.125) * f)) / 2 + 1;
            },
            easeInBack: function (n) {
                return 2.70158 * n * n * n - o * n * n;
            },
            easeOutBack: function (n) {
                return 1 + 2.70158 * t(n - 1, 3) + o * t(n - 1, 2);
            },
            easeInOutBack: function (n) {
                return n < 0.5 ? (t(2 * n, 2) * (7.189819 * n - c)) / 2 : (t(2 * n - 2, 2) * ((c + 1) * (2 * n - 2) + c) + 2) / 2;
            },
            easeInBounce: function (n) {
                return 1 - e(1 - n);
            },
            easeOutBounce: e,
            easeInOutBounce: function (n) {
                return n < 0.5 ? (1 - e(1 - 2 * n)) / 2 : (1 + e(2 * n - 1)) / 2;
            },
        }),
        n
    );
});
/*!
 * jQuery Mousewheel 3.1.13
 * Copyright OpenJS Foundation and other contributors
 */
!(function (e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? (module.exports = e) : e(jQuery);
})(function (u) {
    var f,
        d,
        e = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
        t = "onwheel" in window.document || 9 <= window.document.documentMode ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
        w = Array.prototype.slice;
    if (u.event.fixHooks) for (var i = e.length; i; ) u.event.fixHooks[e[--i]] = u.event.mouseHooks;
    var c = (u.event.special.mousewheel = {
        version: "3.1.12",
        setup: function () {
            if (this.addEventListener) for (var e = t.length; e; ) this.addEventListener(t[--e], n, { passive: false });
            else this.onmousewheel = n;
            u.data(this, "mousewheel-line-height", c.getLineHeight(this)), u.data(this, "mousewheel-page-height", c.getPageHeight(this));
        },
        teardown: function () {
            if (this.removeEventListener) for (var e = t.length; e; ) this.removeEventListener(t[--e], n, !1);
            else this.onmousewheel = null;
            u.removeData(this, "mousewheel-line-height"), u.removeData(this, "mousewheel-page-height");
        },
        getLineHeight: function (e) {
            var t = u(e),
                i = t["offsetParent" in u.fn ? "offsetParent" : "parent"]();
            return i.length || (i = u("body")), parseInt(i.css("fontSize"), 10) || parseInt(t.css("fontSize"), 10) || 16;
        },
        getPageHeight: function (e) {
            return u(e).height();
        },
        settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
    });
    function n(e) {
        var t,
            i = e || window.event,
            n = w.call(arguments, 1),
            o = 0,
            l = 0,
            s = 0;
        if (
            (((e = u.event.fix(i)).type = "mousewheel"),
            "detail" in i && (s = -1 * i.detail),
            "wheelDelta" in i && (s = i.wheelDelta),
            "wheelDeltaY" in i && (s = i.wheelDeltaY),
            "wheelDeltaX" in i && (l = -1 * i.wheelDeltaX),
            "axis" in i && i.axis === i.HORIZONTAL_AXIS && ((l = -1 * s), (s = 0)),
            (o = 0 === s ? l : s),
            "deltaY" in i && (o = s = -1 * i.deltaY),
            "deltaX" in i && ((l = i.deltaX), 0 === s && (o = -1 * l)),
            0 !== s || 0 !== l)
        ) {
            if (1 === i.deltaMode) {
                var a = u.data(this, "mousewheel-line-height");
                (o *= a), (s *= a), (l *= a);
            } else if (2 === i.deltaMode) {
                var h = u.data(this, "mousewheel-page-height");
                (o *= h), (s *= h), (l *= h);
            }
            if (
                ((t = Math.max(Math.abs(s), Math.abs(l))),
                (!d || t < d) && g(i, (d = t)) && (d /= 40),
                g(i, t) && ((o /= 40), (l /= 40), (s /= 40)),
                (o = Math[1 <= o ? "floor" : "ceil"](o / d)),
                (l = Math[1 <= l ? "floor" : "ceil"](l / d)),
                (s = Math[1 <= s ? "floor" : "ceil"](s / d)),
                c.settings.normalizeOffset && this.getBoundingClientRect)
            ) {
                var r = this.getBoundingClientRect();
                (e.offsetX = e.clientX - r.left), (e.offsetY = e.clientY - r.top);
            }
            return (e.deltaX = l), (e.deltaY = s), (e.deltaFactor = d), (e.deltaMode = 0), n.unshift(e, o, l, s), f && window.clearTimeout(f), (f = window.setTimeout(m, 200)), (u.event.dispatch || u.event.handle).apply(this, n);
        }
    }
    function m() {
        d = null;
    }
    function g(e, t) {
        return c.settings.adjustOldDeltas && "mousewheel" === e.type && t % 120 == 0;
    }
    u.fn.extend({
        mousewheel: function (e) {
            return e ? this.on("mousewheel", e) : this.trigger("mousewheel");
        },
        unmousewheel: function (e) {
            return this.off("mousewheel", e);
        },
    });
});
var headerEl = document.getElementById("header-outer"),
    headerSpaceEl = document.getElementById("header-space");
void 0 !== headerEl && null != headerEl && void 0 !== headerSpaceEl && null != headerSpaceEl && headerSpaceEl.hasAttribute("data-secondary-header-display") && (headerSpaceEl.style.height = headerEl.clientHeight + "px"),
    jQuery(function (e) {
        "use strict";
        var t,
            a,
            r,
            n,
            o,
            d,
            i = !1;
        function h() {
            var a = t.offset().top;
            e("#page-header-wrap.fullscreen-header").css("height", "auto"), t.css("height", parseInt(window.innerHeight) - parseInt(a) + "px");
        }
        if ((navigator.userAgent.match(/(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/) && (i = !0), i && e("#page-header-bg.fullscreen-header").length > 0)) {
            (t = e("#page-header-bg")), h();
            var l = window.innerWidth,
                s = window.innerHeight;
            e(window).resize(function () {
                e(window).width() != l && e(window).height != s && (h(), (l = window.innerWidth), (s = window.innerHeight));
            });
        }
        i &&
            e(".nectar_fullscreen_zoom_recent_projects").length > 0 &&
            ((a = e(".body-border-top").length > 0 && e(window).width() > 1e3 ? e(".body-border-top").height() : 0),
            e(".nectar_fullscreen_zoom_recent_projects").each(function () {
                e(this).parents(".first-section").length > 0 ? e(this).css("height", e(window).height() - e(this).offset().top - a) : e(this).css("height", e(window).height());
            })),
            e('#header-outer[data-format="centered-menu-bottom-bar"]').length > 0 &&
                ((r = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9')),
                (n = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_3')),
                (o = e("#header-secondary-outer")),
                (d = n.find("#logo").clone()).is('[data-supplied-ml="true"]') && d.find("img:not(.mobile-only-logo)").remove(),
                d.find("img.starting-logo").remove(),
                o.length > 0 && o.addClass("centered-menu-bottom-bar"),
                e('#header-outer[data-condense="true"]').length > 0 && 0 == e('#header-outer[data-menu-bottom-bar-align="left"]').length && r.prepend(d)),
            e('#page-header-bg[data-animate-in-effect="zoom-out"]').addClass("loaded");
    });
jQuery(function (t) {
    !(function () {
        var e = "";
        if (
            (t(".nectar-slider-wrap").each(function () {
                if (t(this).find(".swiper-container[data-tho]").length > 0) {
                    var i = t(this).find(".swiper-container").attr("data-tho"),
                        a = t(this).find(".swiper-container").attr("data-tco"),
                        n = t(this).find(".swiper-container").attr("data-pho"),
                        d = t(this).find(".swiper-container").attr("data-pco");
                    ("auto" == i && "auto" == a) ||
                        ((e += "@media only screen and (max-width: 1000px) and (min-width: 690px) {"),
                        "auto" != i &&
                            (e +=
                                "#" +
                                t(this).attr("id") +
                                '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content .ns-heading-el, #boxed .nectar-slider-wrap#' +
                                t(this).attr("id") +
                                " .swiper-slide .content .ns-heading-el, body .nectar-slider-wrap#" +
                                t(this).attr("id") +
                                '[data-full-width="true"] .swiper-slide .content .ns-heading-el, body .nectar-slider-wrap#' +
                                t(this).attr("id") +
                                '[data-full-width="boxed-full-width"] .swiper-slide .content .ns-heading-el, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
                                t(this).attr("id") +
                                " .swiper-slide .content .ns-heading-el { font-size:" +
                                i +
                                "px!important; line-height:" +
                                (parseInt(i) + 10) +
                                "px!important;  }"),
                        "auto" != n &&
                            (e +=
                                "#" +
                                t(this).attr("id") +
                                '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content p, #boxed .nectar-slider-wrap#' +
                                t(this).attr("id") +
                                " .swiper-slide .content p, body .nectar-slider-wrap#" +
                                t(this).attr("id") +
                                '[data-full-width="true"] .swiper-slide .content p, body .nectar-slider-wrap#' +
                                t(this).attr("id") +
                                '[data-full-width="boxed-full-width"] .swiper-slide .content p, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
                                t(this).attr("id") +
                                " .swiper-slide .content p { font-size:" +
                                a +
                                "px!important; line-height:" +
                                (parseInt(a) + 10) +
                                "px!important;  }"),
                        (e += "}")),
                        ("auto" == n && "auto" == d) ||
                            ((e += "@media only screen and (max-width: 690px) {"),
                            "auto" != n &&
                                (e +=
                                    "#" +
                                    t(this).attr("id") +
                                    '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content .ns-heading-el, #boxed .nectar-slider-wrap#' +
                                    t(this).attr("id") +
                                    " .swiper-slide .content .ns-heading-el, body .nectar-slider-wrap#" +
                                    t(this).attr("id") +
                                    '[data-full-width="true"] .swiper-slide .content .ns-heading-el, body .nectar-slider-wrap#' +
                                    t(this).attr("id") +
                                    '[data-full-width="boxed-full-width"] .swiper-slide .content .ns-heading-el, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
                                    t(this).attr("id") +
                                    " .swiper-slide .content .ns-heading-el { font-size:" +
                                    n +
                                    "px!important; line-height:" +
                                    (parseInt(n) + 10) +
                                    "px!important;  }"),
                            "auto" != n &&
                                (e +=
                                    "#" +
                                    t(this).attr("id") +
                                    '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content p, #boxed .nectar-slider-wrap#' +
                                    t(this).attr("id") +
                                    " .swiper-slide .content p,  body .nectar-slider-wrap#" +
                                    t(this).attr("id") +
                                    '[data-full-width="true"] .swiper-slide .content p, body .nectar-slider-wrap#' +
                                    t(this).attr("id") +
                                    '[data-full-width="boxed-full-width"] .swiper-slide .content p, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
                                    t(this).attr("id") +
                                    " .swiper-slide .content p { font-size:" +
                                    d +
                                    "px!important; line-height:" +
                                    (parseInt(d) + 10) +
                                    "px!important;  }"),
                            (e += "}"));
                }
            }),
            e.length > 1)
        ) {
            var i = document.head || document.getElementsByTagName("head")[0],
                a = document.createElement("style");
            (a.type = "text/css"), a.styleSheet ? (a.styleSheet.cssText = e) : a.appendChild(document.createTextNode(e)), i.appendChild(a), t(".nectar-slider-wrap .content").css("visibility", "visible");
        }
    })();
});
/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2012 Rico Sta. Cruz <rico@ricostacruz.com>
 * MIT Licensed.
 */
(function (k) {
    k.transit = {
        version: "0.9.9",
        propertyMap: { marginLeft: "margin", marginRight: "margin", marginBottom: "margin", marginTop: "margin", paddingLeft: "padding", paddingRight: "padding", paddingBottom: "padding", paddingTop: "padding" },
        enabled: true,
        useTransitionEnd: false,
    };
    var d = document.createElement("div");
    var q = {};
    function b(v) {
        if (v in d.style) {
            return v;
        }
        var u = ["Moz", "Webkit", "O", "ms"];
        var r = v.charAt(0).toUpperCase() + v.substr(1);
        if (v in d.style) {
            return v;
        }
        for (var t = 0; t < u.length; ++t) {
            var s = u[t] + r;
            if (s in d.style) {
                return s;
            }
        }
    }
    function e() {
        d.style[q.transform] = "";
        d.style[q.transform] = "rotateY(90deg)";
        return d.style[q.transform] !== "";
    }
    var a = navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    q.transition = b("transition");
    q.transitionDelay = b("transitionDelay");
    q.transform = b("transform");
    q.transformOrigin = b("transformOrigin");
    q.transform3d = e();
    var i = { transition: "transitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", WebkitTransition: "webkitTransitionEnd", msTransition: "MSTransitionEnd" };
    var f = (q.transitionEnd = i[q.transition] || null);
    for (var p in q) {
        if (q.hasOwnProperty(p) && typeof k.support[p] === "undefined") {
            k.support[p] = q[p];
        }
    }
    d = null;
    k.cssEase = {
        _default: "ease",
        in: "ease-in",
        out: "ease-out",
        "in-out": "ease-in-out",
        snap: "cubic-bezier(0,1,.5,1)",
        easeOutCubic: "cubic-bezier(.215,.61,.355,1)",
        easeInOutCubic: "cubic-bezier(.645,.045,.355,1)",
        easeInCirc: "cubic-bezier(.6,.04,.98,.335)",
        easeOutCirc: "cubic-bezier(.075,.82,.165,1)",
        easeInOutCirc: "cubic-bezier(.785,.135,.15,.86)",
        easeInExpo: "cubic-bezier(.95,.05,.795,.035)",
        easeOutExpo: "cubic-bezier(.19,1,.22,1)",
        easeInOutExpo: "cubic-bezier(1,0,0,1)",
        easeInQuad: "cubic-bezier(.55,.085,.68,.53)",
        easeOutQuad: "cubic-bezier(.25,.46,.45,.94)",
        easeInOutQuad: "cubic-bezier(.455,.03,.515,.955)",
        easeInQuart: "cubic-bezier(.895,.03,.685,.22)",
        easeOutQuart: "cubic-bezier(.165,.84,.44,1)",
        easeInOutQuart: "cubic-bezier(.77,0,.175,1)",
        easeInQuint: "cubic-bezier(.755,.05,.855,.06)",
        easeOutQuint: "cubic-bezier(.23,1,.32,1)",
        easeInOutQuint: "cubic-bezier(.86,0,.07,1)",
        easeInSine: "cubic-bezier(.47,0,.745,.715)",
        easeOutSine: "cubic-bezier(.39,.575,.565,1)",
        easeInOutSine: "cubic-bezier(.445,.05,.55,.95)",
        easeInBack: "cubic-bezier(.6,-.28,.735,.045)",
        easeOutBack: "cubic-bezier(.175, .885,.32,1.275)",
        easeInOutBack: "cubic-bezier(.68,-.55,.265,1.55)",
    };
    k.cssHooks["transit:transform"] = {
        get: function (r) {
            return k(r).data("transform") || new j();
        },
        set: function (s, r) {
            var t = r;
            if (!(t instanceof j)) {
                t = new j(t);
            }
            if (q.transform === "WebkitTransform" && !a) {
                s.style[q.transform] = t.toString(true);
            } else {
                s.style[q.transform] = t.toString();
            }
            k(s).data("transform", t);
        },
    };
    k.cssHooks.transform = { set: k.cssHooks["transit:transform"].set };
    if (k.fn.jquery < "1.8") {
        k.cssHooks.transformOrigin = {
            get: function (r) {
                return r.style[q.transformOrigin];
            },
            set: function (r, s) {
                r.style[q.transformOrigin] = s;
            },
        };
        k.cssHooks.transition = {
            get: function (r) {
                return r.style[q.transition];
            },
            set: function (r, s) {
                r.style[q.transition] = s;
            },
        };
    }
    n("scale");
    n("translate");
    n("rotate");
    n("rotateX");
    n("rotateY");
    n("rotate3d");
    n("perspective");
    n("skewX");
    n("skewY");
    n("x", true);
    n("y", true);
    function j(r) {
        if (typeof r === "string") {
            this.parse(r);
        }
        return this;
    }
    j.prototype = {
        setFromString: function (t, s) {
            var r = typeof s === "string" ? s.split(",") : s.constructor === Array ? s : [s];
            r.unshift(t);
            j.prototype.set.apply(this, r);
        },
        set: function (s) {
            var r = Array.prototype.slice.apply(arguments, [1]);
            if (this.setter[s]) {
                this.setter[s].apply(this, r);
            } else {
                this[s] = r.join(",");
            }
        },
        get: function (r) {
            if (this.getter[r]) {
                return this.getter[r].apply(this);
            } else {
                return this[r] || 0;
            }
        },
        setter: {
            rotate: function (r) {
                this.rotate = o(r, "deg");
            },
            rotateX: function (r) {
                this.rotateX = o(r, "deg");
            },
            rotateY: function (r) {
                this.rotateY = o(r, "deg");
            },
            scale: function (r, s) {
                if (s === undefined) {
                    s = r;
                }
                this.scale = r + "," + s;
            },
            skewX: function (r) {
                this.skewX = o(r, "deg");
            },
            skewY: function (r) {
                this.skewY = o(r, "deg");
            },
            perspective: function (r) {
                this.perspective = o(r, "px");
            },
            x: function (r) {
                this.set("translate", r, null);
            },
            y: function (r) {
                this.set("translate", null, r);
            },
            translate: function (r, s) {
                if (this._translateX === undefined) {
                    this._translateX = 0;
                }
                if (this._translateY === undefined) {
                    this._translateY = 0;
                }
                if (r !== null && r !== undefined) {
                    this._translateX = o(r, "px");
                }
                if (s !== null && s !== undefined) {
                    this._translateY = o(s, "px");
                }
                this.translate = this._translateX + "," + this._translateY;
            },
        },
        getter: {
            x: function () {
                return this._translateX || 0;
            },
            y: function () {
                return this._translateY || 0;
            },
            scale: function () {
                var r = (this.scale || "1,1").split(",");
                if (r[0]) {
                    r[0] = parseFloat(r[0]);
                }
                if (r[1]) {
                    r[1] = parseFloat(r[1]);
                }
                return r[0] === r[1] ? r[0] : r;
            },
            rotate3d: function () {
                var t = (this.rotate3d || "0,0,0,0deg").split(",");
                for (var r = 0; r <= 3; ++r) {
                    if (t[r]) {
                        t[r] = parseFloat(t[r]);
                    }
                }
                if (t[3]) {
                    t[3] = o(t[3], "deg");
                }
                return t;
            },
        },
        parse: function (s) {
            var r = this;
            s.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function (t, v, u) {
                r.setFromString(v, u);
            });
        },
        toString: function (t) {
            var s = [];
            for (var r in this) {
                if (this.hasOwnProperty(r)) {
                    if (!q.transform3d && (r === "rotateX" || r === "rotateY" || r === "perspective" || r === "transformOrigin")) {
                        continue;
                    }
                    if (r[0] !== "_") {
                        if (t && r === "scale") {
                            s.push(r + "3d(" + this[r] + ",1)");
                        } else {
                            if (t && r === "translate") {
                                s.push(r + "3d(" + this[r] + ",0)");
                            } else {
                                s.push(r + "(" + this[r] + ")");
                            }
                        }
                    }
                }
            }
            return s.join(" ");
        },
    };
    function m(s, r, t) {
        if (r === true) {
            s.queue(t);
        } else {
            if (r) {
                s.queue(r, t);
            } else {
                t();
            }
        }
    }
    function h(s) {
        var r = [];
        k.each(s, function (t) {
            t = k.camelCase(t);
            t = k.transit.propertyMap[t] || k.cssProps[t] || t;
            t = c(t);
            if (k.inArray(t, r) === -1) {
                r.push(t);
            }
        });
        return r;
    }
    function g(s, v, x, r) {
        var t = h(s);
        if (k.cssEase[x]) {
            x = k.cssEase[x];
        }
        var w = "" + l(v) + " " + x;
        if (parseInt(r, 10) > 0) {
            w += " " + l(r);
        }
        var u = [];
        k.each(t, function (z, y) {
            u.push(y + " " + w);
        });
        return u.join(", ");
    }
    k.fn.transition = k.fn.transit = function (z, s, y, C) {
        var D = this;
        var u = 0;
        var w = true;
        if (typeof s === "function") {
            C = s;
            s = undefined;
        }
        if (typeof y === "function") {
            C = y;
            y = undefined;
        }
        if (typeof z.easing !== "undefined") {
            y = z.easing;
            delete z.easing;
        }
        if (typeof z.duration !== "undefined") {
            s = z.duration;
            delete z.duration;
        }
        if (typeof z.complete !== "undefined") {
            C = z.complete;
            delete z.complete;
        }
        if (typeof z.queue !== "undefined") {
            w = z.queue;
            delete z.queue;
        }
        if (typeof z.delay !== "undefined") {
            u = z.delay;
            delete z.delay;
        }
        if (typeof s === "undefined") {
            s = k.fx.speeds._default;
        }
        if (typeof y === "undefined") {
            y = k.cssEase._default;
        }
        s = l(s);
        var E = g(z, s, y, u);
        var B = k.transit.enabled && q.transition;
        var t = B ? parseInt(s, 10) + parseInt(u, 10) : 0;
        if (t === 0) {
            var A = function (F) {
                D.css(z);
                if (C) {
                    C.apply(D);
                }
                if (F) {
                    F();
                }
            };
            m(D, w, A);
            return D;
        }
        var x = {};
        var r = function (H) {
            var G = false;
            var F = function () {
                if (G) {
                    D.unbind(f, F);
                }
                if (t > 0) {
                    D.each(function () {
                        this.style[q.transition] = x[this] || null;
                    });
                }
                if (typeof C === "function") {
                    C.apply(D);
                }
                if (typeof H === "function") {
                    H();
                }
            };
            if (t > 0 && f && k.transit.useTransitionEnd) {
                G = true;
                D.bind(f, F);
            } else {
                window.setTimeout(F, t);
            }
            D.each(function () {
                if (t > 0) {
                    this.style[q.transition] = E;
                }
                k(this).css(z);
            });
        };
        var v = function (F) {
            this.offsetWidth;
            r(F);
        };
        m(D, w, v);
        return this;
    };
    function n(s, r) {
        if (!r) {
            k.cssNumber[s] = true;
        }
        k.transit.propertyMap[s] = q.transform;
        k.cssHooks[s] = {
            get: function (v) {
                var u = k(v).css("transit:transform");
                return u.get(s);
            },
            set: function (v, w) {
                var u = k(v).css("transit:transform");
                u.setFromString(s, w);
                k(v).css({ "transit:transform": u });
            },
        };
    }
    function c(r) {
        return r.replace(/([A-Z])/g, function (s) {
            return "-" + s.toLowerCase();
        });
    }
    function o(s, r) {
        if (typeof s === "string" && !s.match(/^[\-0-9\.]+$/)) {
            return s;
        } else {
            return "" + s + r;
        }
    }
    function l(s) {
        var r = s;
        if (k.fx.speeds[r]) {
            r = k.fx.speeds[r];
        }
        return o(r, "ms");
    }
    k.transit.getTransitionValue = g;
})(jQuery);
!(function () {
    "use strict";
    var t = 0,
        e = {};
    function i(o) {
        if (!o) throw new Error("No options passed to Waypoint constructor");
        if (!o.element) throw new Error("No element option passed to Waypoint constructor");
        if (!o.handler) throw new Error("No handler option passed to Waypoint constructor");
        (this.key = "waypoint-" + t),
            (this.options = i.Adapter.extend({}, i.defaults, o)),
            (this.element = this.options.element),
            (this.adapter = new i.Adapter(this.element)),
            (this.callback = o.handler),
            (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
            (this.enabled = this.options.enabled),
            (this.triggerPoint = null),
            (this.group = i.Group.findOrCreate({ name: this.options.group, axis: this.axis })),
            (this.context = i.Context.findOrCreateByElement(this.options.context)),
            i.offsetAliases[this.options.offset] && (this.options.offset = i.offsetAliases[this.options.offset]),
            this.group.add(this),
            this.context.add(this),
            (e[this.key] = this),
            (t += 1);
    }
    (i.prototype.queueTrigger = function (t) {
        this.group.queueTrigger(this, t);
    }),
        (i.prototype.trigger = function (t) {
            this.enabled && this.callback && this.callback.apply(this, t);
        }),
        (i.prototype.destroy = function () {
            this.context.remove(this), this.group.remove(this), delete e[this.key];
        }),
        (i.prototype.disable = function () {
            return (this.enabled = !1), this;
        }),
        (i.prototype.enable = function () {
            return this.context.refresh(), (this.enabled = !0), this;
        }),
        (i.prototype.next = function () {
            return this.group.next(this);
        }),
        (i.prototype.previous = function () {
            return this.group.previous(this);
        }),
        (i.invokeAll = function (t) {
            var i = [];
            for (var o in e) i.push(e[o]);
            for (var n = 0, r = i.length; n < r; n++) i[n][t]();
        }),
        (i.destroyAll = function () {
            i.invokeAll("destroy");
        }),
        (i.disableAll = function () {
            i.invokeAll("disable");
        }),
        (i.enableAll = function () {
            for (var t in (i.Context.refreshAll(), e)) e[t].enabled = !0;
            return this;
        }),
        (i.refreshAll = function () {
            i.Context.refreshAll();
        }),
        (i.viewportHeight = function () {
            return window.innerHeight || document.documentElement.clientHeight;
        }),
        (i.viewportWidth = function () {
            return document.documentElement.clientWidth;
        }),
        (i.adapters = []),
        (i.defaults = { context: window, continuous: !0, enabled: !0, group: "default", horizontal: !1, offset: 0 }),
        (i.offsetAliases = {
            "bottom-in-view": function () {
                return this.context.innerHeight() - this.adapter.outerHeight();
            },
            "right-in-view": function () {
                return this.context.innerWidth() - this.adapter.outerWidth();
            },
        }),
        (window.Waypoint = i);
})(),
    (function () {
        "use strict";
        function t(t) {
            window.setTimeout(t, 1e3 / 60);
        }
        var e = 0,
            i = {},
            o = window.Waypoint,
            n = window.onload;
        function r(t) {
            (this.element = t),
                (this.Adapter = o.Adapter),
                (this.adapter = new this.Adapter(t)),
                (this.key = "waypoint-context-" + e),
                (this.didScroll = !1),
                (this.didResize = !1),
                (this.oldScroll = { x: this.adapter.scrollLeft(), y: this.adapter.scrollTop() }),
                (this.waypoints = { vertical: {}, horizontal: {} }),
                (t.waypointContextKey = this.key),
                (i[t.waypointContextKey] = this),
                (e += 1),
                o.windowContext || ((o.windowContext = !0), (o.windowContext = new r(window))),
                this.createThrottledScrollHandler(),
                this.createThrottledResizeHandler();
        }
        (r.prototype.add = function (t) {
            var e = t.options.horizontal ? "horizontal" : "vertical";
            (this.waypoints[e][t.key] = t), this.refresh();
        }),
            (r.prototype.checkEmpty = function () {
                var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
                    e = this.Adapter.isEmptyObject(this.waypoints.vertical),
                    o = this.element == this.element.window;
                t && e && !o && (this.adapter.off(".waypoints"), delete i[this.key]);
            }),
            (r.prototype.createThrottledResizeHandler = function () {
                var t = this;
                function e() {
                    t.handleResize(), (t.didResize = !1);
                }
                this.adapter.on("resize.waypoints", function () {
                    t.didResize || ((t.didResize = !0), o.requestAnimationFrame(e));
                });
            }),
            (r.prototype.createThrottledScrollHandler = function () {
                var t = this;
                function e() {
                    t.handleScroll(), (t.didScroll = !1);
                }
                this.adapter.on("scroll.waypoints", function () {
                    (t.didScroll && !o.isTouch) || ((t.didScroll = !0), o.requestAnimationFrame(e));
                });
            }),
            (r.prototype.handleResize = function () {
                setTimeout(function () {
                    o.Context.refreshAll();
                }, 150);
            }),
            (r.prototype.handleScroll = function () {
                var t = {},
                    e = {
                        horizontal: { newScroll: 0, oldScroll: 0, forward: "right", backward: "left" },
                        vertical: { newScroll: window.nectarDOMInfo ? window.nectarDOMInfo.scrollTop : 0, oldScroll: this.oldScroll.y, forward: "down", backward: "up" },
                    };
                for (var i in e) {
                    var o = e[i],
                        n = o.newScroll > o.oldScroll ? o.forward : o.backward;
                    for (var r in this.waypoints[i]) {
                        var s = this.waypoints[i][r];
                        if (null !== s.triggerPoint) {
                            var a = o.oldScroll < s.triggerPoint,
                                l = o.newScroll >= s.triggerPoint;
                            ((a && l) || (!a && !l)) && (s.queueTrigger(n), (t[s.group.id] = s.group));
                        }
                    }
                }
                for (var h in t) t[h].flushTriggers();
                this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
            }),
            (r.prototype.innerHeight = function () {
                return this.element == this.element.window ? o.viewportHeight() : this.adapter.innerHeight();
            }),
            (r.prototype.remove = function (t) {
                delete this.waypoints[t.axis][t.key], this.checkEmpty();
            }),
            (r.prototype.innerWidth = function () {
                return this.element == this.element.window ? o.viewportWidth() : this.adapter.innerWidth();
            }),
            (r.prototype.destroy = function () {
                var t = [];
                for (var e in this.waypoints) for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
                for (var o = 0, n = t.length; o < n; o++) t[o].destroy();
            }),
            (r.prototype.refresh = function () {
                var t,
                    e = this.element == this.element.window,
                    i = e ? void 0 : this.adapter.offset(),
                    n = {};
                for (var r in (this.handleScroll(),
                (t = {
                    horizontal: { contextOffset: e ? 0 : i.left, contextScroll: e ? 0 : this.oldScroll.x, contextDimension: this.innerWidth(), oldScroll: this.oldScroll.x, forward: "right", backward: "left", offsetProp: "left" },
                    vertical: { contextOffset: e ? 0 : i.top, contextScroll: e ? 0 : this.oldScroll.y, contextDimension: this.innerHeight(), oldScroll: this.oldScroll.y, forward: "down", backward: "up", offsetProp: "top" },
                }))) {
                    var s = t[r];
                    for (var a in this.waypoints[r]) {
                        var l,
                            h,
                            p,
                            u,
                            c = this.waypoints[r][a],
                            d = c.options.offset,
                            f = c.triggerPoint,
                            w = 0,
                            y = null == f;
                        c.element !== c.element.window && (w = c.adapter.offset()[s.offsetProp]),
                            "function" == typeof d ? (d = d.apply(c)) : "string" == typeof d && ((d = parseFloat(d)), c.options.offset.indexOf("%") > -1 && (d = Math.ceil((s.contextDimension * d) / 100))),
                            (l = s.contextScroll - s.contextOffset),
                            (c.triggerPoint = Math.floor(w + l - d)),
                            (h = f < s.oldScroll),
                            (p = c.triggerPoint >= s.oldScroll),
                            (u = !h && !p),
                            !y && h && p
                                ? (c.queueTrigger(s.backward), (n[c.group.id] = c.group))
                                : !y && u
                                ? (c.queueTrigger(s.forward), (n[c.group.id] = c.group))
                                : y && s.oldScroll >= c.triggerPoint && (c.queueTrigger(s.forward), (n[c.group.id] = c.group));
                    }
                }
                return (
                    o.requestAnimationFrame(function () {
                        for (var t in n) n[t].flushTriggers();
                    }),
                    this
                );
            }),
            (r.findOrCreateByElement = function (t) {
                return r.findByElement(t) || new r(t);
            }),
            (r.refreshAll = function () {
                for (var t in i) i[t].refresh();
            }),
            (r.findByElement = function (t) {
                return i[t.waypointContextKey];
            }),
            (window.onload = function () {
                n && n(), r.refreshAll();
            }),
            (o.requestAnimationFrame = function (e) {
                (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t).call(window, e);
            }),
            (o.Context = r);
    })(),
    (function () {
        "use strict";
        function t(t, e) {
            return t.triggerPoint - e.triggerPoint;
        }
        function e(t, e) {
            return e.triggerPoint - t.triggerPoint;
        }
        var i = { vertical: {}, horizontal: {} },
            o = window.Waypoint;
        function n(t) {
            (this.name = t.name), (this.axis = t.axis), (this.id = this.name + "-" + this.axis), (this.waypoints = []), this.clearTriggerQueues(), (i[this.axis][this.name] = this);
        }
        (n.prototype.add = function (t) {
            this.waypoints.push(t);
        }),
            (n.prototype.clearTriggerQueues = function () {
                this.triggerQueues = { up: [], down: [], left: [], right: [] };
            }),
            (n.prototype.flushTriggers = function () {
                for (var i in this.triggerQueues) {
                    var o = this.triggerQueues[i],
                        n = "up" === i || "left" === i;
                    o.sort(n ? e : t);
                    for (var r = 0, s = o.length; r < s; r += 1) {
                        var a = o[r];
                        (a.options.continuous || r === o.length - 1) && a.trigger([i]);
                    }
                }
                this.clearTriggerQueues();
            }),
            (n.prototype.next = function (e) {
                this.waypoints.sort(t);
                var i = o.Adapter.inArray(e, this.waypoints);
                return i === this.waypoints.length - 1 ? null : this.waypoints[i + 1];
            }),
            (n.prototype.previous = function (e) {
                this.waypoints.sort(t);
                var i = o.Adapter.inArray(e, this.waypoints);
                return i ? this.waypoints[i - 1] : null;
            }),
            (n.prototype.queueTrigger = function (t, e) {
                this.triggerQueues[e].push(t);
            }),
            (n.prototype.remove = function (t) {
                var e = o.Adapter.inArray(t, this.waypoints);
                e > -1 && this.waypoints.splice(e, 1);
            }),
            (n.prototype.first = function () {
                return this.waypoints[0];
            }),
            (n.prototype.last = function () {
                return this.waypoints[this.waypoints.length - 1];
            }),
            (n.findOrCreate = function (t) {
                return i[t.axis][t.name] || new n(t);
            }),
            (o.Group = n);
    })(),
    (function () {
        "use strict";
        var t = window.jQuery,
            e = window.Waypoint;
        function i(e) {
            this.$element = t(e);
        }
        t.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function (t, e) {
            i.prototype[e] = function () {
                var t = Array.prototype.slice.call(arguments);
                return this.$element[e].apply(this.$element, t);
            };
        }),
            t.each(["extend", "inArray", "isEmptyObject"], function (e, o) {
                i[o] = t[o];
            }),
            e.adapters.push({ name: "jquery", Adapter: i }),
            (e.Adapter = i);
    })(),
    (function () {
        "use strict";
        var t = window.Waypoint;
        function e(e) {
            return function () {
                var i = [],
                    o = arguments[0];
                return (
                    e.isFunction(arguments[0]) && ((o = e.extend({}, arguments[1])).handler = arguments[0]),
                    this.each(function () {
                        var n = e.extend({}, o, { element: this });
                        "string" == typeof n.context && (n.context = e(this).closest(n.context)[0]), i.push(new t(n));
                    }),
                    i
                );
            };
        }
        window.jQuery && (window.jQuery.fn.waypoint = e(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = e(window.Zepto));
    })();
/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
!(function (e, t) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.EvEmitter = t());
})("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
        (t.on = function (e, t) {
            if (e && t) {
                var i = (this._events = this._events || {}),
                    n = (i[e] = i[e] || []);
                return n.indexOf(t) == -1 && n.push(t), this;
            }
        }),
        (t.once = function (e, t) {
            if (e && t) {
                this.on(e, t);
                var i = (this._onceEvents = this._onceEvents || {}),
                    n = (i[e] = i[e] || {});
                return (n[t] = !0), this;
            }
        }),
        (t.off = function (e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                var n = i.indexOf(t);
                return n != -1 && i.splice(n, 1), this;
            }
        }),
        (t.emitEvent = function (e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                (i = i.slice(0)), (t = t || []);
                for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                    var r = i[o],
                        s = n && n[r];
                    s && (this.off(e, r), delete n[r]), r.apply(this, t);
                }
                return this;
            }
        }),
        (t.allOff = function () {
            delete this._events, delete this._onceEvents;
        }),
        e
    );
}),
    (function (e, t) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["ev-emitter/ev-emitter"], function (i) {
                  return t(e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("ev-emitter")))
            : (e.imagesLoaded = t(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
        function i(e, t) {
            for (var i in t) e[i] = t[i];
            return e;
        }
        function n(e) {
            if (Array.isArray(e)) return e;
            var t = "object" == typeof e && "number" == typeof e.length;
            return t ? d.call(e) : [e];
        }
        function o(e, t, r) {
            if (!(this instanceof o)) return new o(e, t, r);
            var s = e;
            return (
                "string" == typeof e && (s = document.querySelectorAll(e)),
                s
                    ? ((this.elements = n(s)),
                      (this.options = i({}, this.options)),
                      "function" == typeof t ? (r = t) : i(this.options, t),
                      r && this.on("always", r),
                      this.getImages(),
                      h && (this.jqDeferred = new h.Deferred()),
                      void setTimeout(this.check.bind(this)))
                    : void a.error("Bad element for imagesLoaded " + (s || e))
            );
        }
        function r(e) {
            this.img = e;
        }
        function s(e, t) {
            (this.url = e), (this.element = t), (this.img = new Image());
        }
        var h = e.jQuery,
            a = e.console,
            d = Array.prototype.slice;
        (o.prototype = Object.create(t.prototype)),
            (o.prototype.options = {}),
            (o.prototype.getImages = function () {
                (this.images = []), this.elements.forEach(this.addElementImages, this);
            }),
            (o.prototype.addElementImages = function (e) {
                "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
                var t = e.nodeType;
                if (t && u[t]) {
                    for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                        var o = i[n];
                        this.addImage(o);
                    }
                    if ("string" == typeof this.options.background) {
                        var r = e.querySelectorAll(this.options.background);
                        for (n = 0; n < r.length; n++) {
                            var s = r[n];
                            this.addElementBackgroundImages(s);
                        }
                    }
                }
            });
        var u = { 1: !0, 9: !0, 11: !0 };
        return (
            (o.prototype.addElementBackgroundImages = function (e) {
                var t = getComputedStyle(e);
                if (t)
                    for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
                        var o = n && n[2];
                        o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
                    }
            }),
            (o.prototype.addImage = function (e) {
                var t = new r(e);
                this.images.push(t);
            }),
            (o.prototype.addBackground = function (e, t) {
                var i = new s(e, t);
                this.images.push(i);
            }),
            (o.prototype.check = function () {
                function e(e, i, n) {
                    setTimeout(function () {
                        t.progress(e, i, n);
                    });
                }
                var t = this;
                return (
                    (this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? void this.images.forEach(function (t) {
                              t.once("progress", e), t.check();
                          })
                        : void this.complete()
                );
            }),
            (o.prototype.progress = function (e, t, i) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                    this.emitEvent("progress", [this, e, t]),
                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                    this.progressedCount == this.images.length && this.complete(),
                    this.options.debug && a && a.log("progress: " + i, e, t);
            }),
            (o.prototype.complete = function () {
                var e = this.hasAnyBroken ? "fail" : "done";
                if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                    var t = this.hasAnyBroken ? "reject" : "resolve";
                    this.jqDeferred[t](this);
                }
            }),
            (r.prototype = Object.create(t.prototype)),
            (r.prototype.check = function () {
                var e = this.getIsImageComplete();
                return e
                    ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener("load", this),
                      this.proxyImage.addEventListener("error", this),
                      this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this),
                      void (this.proxyImage.src = this.img.src));
            }),
            (r.prototype.getIsImageComplete = function () {
                return this.img.complete && this.img.naturalWidth;
            }),
            (r.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
            }),
            (r.prototype.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
            }),
            (r.prototype.onload = function () {
                this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (r.prototype.onerror = function () {
                this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (r.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype = Object.create(r.prototype)),
            (s.prototype.check = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
                var e = this.getIsImageComplete();
                e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
            }),
            (s.prototype.unbindEvents = function () {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
            }),
            (o.makeJQueryPlugin = function (t) {
                (t = t || e.jQuery),
                    t &&
                        ((h = t),
                        (h.fn.imagesLoaded = function (e, t) {
                            var i = new o(this, e, t);
                            return i.jqDeferred.promise(h(this));
                        }));
            }),
            o.makeJQueryPlugin(),
            o
        );
    });
/*!
 * hoverIntent v1.9.0 // 2017.09.01 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2017 Brian Cherne
 */
!(function (factory) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], factory) : jQuery && !jQuery.fn.hoverIntent && factory(jQuery);
})(function ($) {
    "use strict";
    var cX,
        cY,
        _cfg = { interval: 100, sensitivity: 6, timeout: 0 },
        INSTANCE_COUNT = 0,
        track = function (ev) {
            (cX = ev.pageX), (cY = ev.pageY);
        },
        compare = function (ev, $el, s, cfg) {
            if (Math.sqrt((s.pX - cX) * (s.pX - cX) + (s.pY - cY) * (s.pY - cY)) < cfg.sensitivity)
                return $el.off(s.event, track), delete s.timeoutId, (s.isActive = !0), (ev.pageX = cX), (ev.pageY = cY), delete s.pX, delete s.pY, cfg.over.apply($el[0], [ev]);
            (s.pX = cX),
                (s.pY = cY),
                (s.timeoutId = setTimeout(function () {
                    compare(ev, $el, s, cfg);
                }, cfg.interval));
        },
        delay = function (ev, $el, s, out) {
            return delete $el.data("hoverIntent")[s.id], out.apply($el[0], [ev]);
        };
    $.fn.hoverIntent = function (handlerIn, handlerOut, selector) {
        var instanceId = INSTANCE_COUNT++,
            cfg = $.extend({}, _cfg);
        $.isPlainObject(handlerIn)
            ? ((cfg = $.extend(cfg, handlerIn)), $.isFunction(cfg.out) || (cfg.out = cfg.over))
            : (cfg = $.isFunction(handlerOut) ? $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector }) : $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut }));
        var handleHover = function (e) {
            var ev = $.extend({}, e),
                $el = $(this),
                hoverIntentData = $el.data("hoverIntent");
            hoverIntentData || $el.data("hoverIntent", (hoverIntentData = {}));
            var state = hoverIntentData[instanceId];
            state || (hoverIntentData[instanceId] = state = { id: instanceId }), state.timeoutId && (state.timeoutId = clearTimeout(state.timeoutId));
            var mousemove = (state.event = "mousemove.hoverIntent.hoverIntent" + instanceId);
            if ("mouseenter" === e.type) {
                if (state.isActive) return;
                (state.pX = ev.pageX),
                    (state.pY = ev.pageY),
                    $el.off(mousemove, track).on(mousemove, track),
                    (state.timeoutId = setTimeout(function () {
                        compare(ev, $el, state, cfg);
                    }, cfg.interval));
            } else {
                if (!state.isActive) return;
                $el.off(mousemove, track),
                    (state.timeoutId = setTimeout(function () {
                        delay(ev, $el, state, cfg.out);
                    }, cfg.timeout));
            }
        };
        return this.on({ "mouseenter.hoverIntent": handleHover, "mouseleave.hoverIntent": handleHover }, cfg.selector);
    };
});

!(function (t, e, n, o) {
    "use strict";
    function i(t, e) {
        var o,
            i,
            a,
            s = [],
            r = 0;
        (t && t.isDefaultPrevented()) ||
            (t.preventDefault(),
            (e = e || {}),
            t && t.data && (e = h(t.data.options, e)),
            (o = e.$target || n(t.currentTarget).trigger("blur")),
            ((a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o)) ||
                (e.selector ? (s = n(e.selector)) : ((i = o.attr("data-fancybox") || ""), i ? ((s = t.data ? t.data.items : []), (s = s.length ? s.filter('[data-fancybox="' + i + '"]') : n('[data-fancybox="' + i + '"]'))) : (s = [o])),
                (r = n(s).index(o)),
                r < 0 && (r = 0),
                (a = n.fancybox.open(s, e, r)),
                (a.$trigger = o)));
    }
    if (((t.console = t.console || { info: function (t) {} }), n)) {
        if (n.fn.fancybox) return void console.info("fancyBox already initialized");
        var a = {
                closeExisting: !1,
                loop: !1,
                gutter: 50,
                keyboard: !0,
                preventCaptionOverlap: !0,
                arrows: !0,
                infobar: !0,
                smallBtn: "auto",
                toolbar: "auto",
                buttons: ["zoom", "slideShow", "thumbs", "close"],
                idleTime: 3,
                protect: !1,
                modal: !1,
                image: { preload: !1 },
                ajax: { settings: { data: { fancybox: !0 } } },
                iframe: {
                    tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
                    preload: !0,
                    css: {},
                    attr: { scrolling: "auto" },
                },
                video: {
                    tpl:
                        '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
                    format: "",
                    autoStart: !0,
                },
                defaultType: "image",
                animationEffect: "zoom",
                animationDuration: 366,
                zoomOpacity: "auto",
                transitionEffect: "fade",
                transitionDuration: 366,
                slideClass: "",
                baseClass: "",
                baseTpl:
                    '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
                spinnerTpl: '<div class="fancybox-loading"></div>',
                errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
                btnTpl: {
                    download:
                        '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
                    zoom:
                        '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
                    close:
                        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
                    arrowLeft:
                        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
                    arrowRight:
                        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
                    smallBtn:
                        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
                },
                parentEl: "body",
                hideScrollbar: !0,
                autoFocus: !0,
                backFocus: !0,
                trapFocus: !0,
                fullScreen: { autoStart: !1 },
                touch: { vertical: !0, momentum: !0 },
                hash: null,
                media: {},
                slideShow: { autoStart: !1, speed: 3e3 },
                thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
                wheel: "auto",
                onInit: n.noop,
                beforeLoad: n.noop,
                afterLoad: n.noop,
                beforeShow: n.noop,
                afterShow: n.noop,
                beforeClose: n.noop,
                afterClose: n.noop,
                onActivate: n.noop,
                onDeactivate: n.noop,
                clickContent: function (t, e) {
                    return "image" === t.type && "zoom";
                },
                clickSlide: "close",
                clickOutside: "close",
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
                mobile: {
                    preventCaptionOverlap: !1,
                    idleTime: !1,
                    clickContent: function (t, e) {
                        return "image" === t.type && "toggleControls";
                    },
                    clickSlide: function (t, e) {
                        return "image" === t.type ? "toggleControls" : "close";
                    },
                    dblclickContent: function (t, e) {
                        return "image" === t.type && "zoom";
                    },
                    dblclickSlide: function (t, e) {
                        return "image" === t.type && "zoom";
                    },
                },
                lang: "en",
                i18n: {
                    en: {
                        CLOSE: "Close",
                        NEXT: "Next",
                        PREV: "Previous",
                        ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                        PLAY_START: "Start slideshow",
                        PLAY_STOP: "Pause slideshow",
                        FULL_SCREEN: "Full screen",
                        THUMBS: "Thumbnails",
                        DOWNLOAD: "Download",
                        SHARE: "Share",
                        ZOOM: "Zoom",
                    },
                    de: {
                        CLOSE: "Schlie&szlig;en",
                        NEXT: "Weiter",
                        PREV: "Zur&uuml;ck",
                        ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                        PLAY_START: "Diaschau starten",
                        PLAY_STOP: "Diaschau beenden",
                        FULL_SCREEN: "Vollbild",
                        THUMBS: "Vorschaubilder",
                        DOWNLOAD: "Herunterladen",
                        SHARE: "Teilen",
                        ZOOM: "Vergr&ouml;&szlig;ern",
                    },
                },
            },
            s = n(t),
            r = n(e),
            c = 0,
            l = function (t) {
                return t && t.hasOwnProperty && t instanceof n;
            },
            d = (function () {
                return (
                    t.requestAnimationFrame ||
                    t.webkitRequestAnimationFrame ||
                    t.mozRequestAnimationFrame ||
                    t.oRequestAnimationFrame ||
                    function (e) {
                        return t.setTimeout(e, 1e3 / 60);
                    }
                );
            })(),
            u = (function () {
                return (
                    t.cancelAnimationFrame ||
                    t.webkitCancelAnimationFrame ||
                    t.mozCancelAnimationFrame ||
                    t.oCancelAnimationFrame ||
                    function (e) {
                        t.clearTimeout(e);
                    }
                );
            })(),
            f = (function () {
                var t,
                    n = e.createElement("fakeelement"),
                    o = { transition: "transitionend", OTransition: "oTransitionEnd", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
                for (t in o) if (void 0 !== n.style[t]) return o[t];
                return "transitionend";
            })(),
            p = function (t) {
                return t && t.length && t[0].offsetHeight;
            },
            h = function (t, e) {
                var o = n.extend(!0, {}, t, e);
                return (
                    n.each(e, function (t, e) {
                        n.isArray(e) && (o[t] = e);
                    }),
                    o
                );
            },
            g = function (t) {
                var o, i;
                return (
                    !(!t || t.ownerDocument !== e) &&
                    (n(".fancybox-container").css("pointer-events", "none"),
                    (o = { x: t.getBoundingClientRect().left + t.offsetWidth / 2, y: t.getBoundingClientRect().top + t.offsetHeight / 2 }),
                    (i = e.elementFromPoint(o.x, o.y) === t),
                    n(".fancybox-container").css("pointer-events", ""),
                    i)
                );
            },
            b = function (t, e, o) {
                var i = this;
                (i.opts = h({ index: o }, n.fancybox.defaults)),
                    n.isPlainObject(e) && (i.opts = h(i.opts, e)),
                    n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
                    (i.id = i.opts.id || ++c),
                    (i.currIndex = parseInt(i.opts.index, 10) || 0),
                    (i.prevIndex = null),
                    (i.prevPos = null),
                    (i.currPos = 0),
                    (i.firstRun = !0),
                    (i.group = []),
                    (i.slides = {}),
                    i.addContent(t),
                    i.group.length && i.init();
            };
        n.extend(b.prototype, {
            init: function () {
                var o,
                    i,
                    a = this,
                    s = a.group[a.currIndex],
                    r = s.opts;
                r.closeExisting && n.fancybox.close(!0),
                    n("body").addClass("fancybox-active"),
                    !n.fancybox.getInstance() &&
                        !1 !== r.hideScrollbar &&
                        !n.fancybox.isMobile &&
                        e.body.scrollHeight > t.innerHeight &&
                        (n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (t.innerWidth - e.documentElement.clientWidth) + "px;}</style>"),
                        n("body").addClass("compensate-for-scrollbar")),
                    (i = ""),
                    n.each(r.buttons, function (t, e) {
                        i += r.btnTpl[e] || "";
                    }),
                    (o = n(a.translate(a, r.baseTpl.replace("{{buttons}}", i).replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)))
                        .attr("id", "fancybox-container-" + a.id)
                        .addClass(r.baseClass)
                        .data("FancyBox", a)
                        .appendTo(r.parentEl)),
                    (a.$refs = { container: o }),
                    ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function (t) {
                        a.$refs[t] = o.find(".fancybox-" + t);
                    }),
                    a.trigger("onInit"),
                    a.activate(),
                    a.jumpTo(a.currIndex);
            },
            translate: function (t, e) {
                var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
                return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
                    return void 0 === n[e] ? t : n[e];
                });
            },
            addContent: function (t) {
                var e,
                    o = this,
                    i = n.makeArray(t);
                n.each(i, function (t, e) {
                    var i,
                        a,
                        s,
                        r,
                        c,
                        l = {},
                        d = {};
                    n.isPlainObject(e)
                        ? ((l = e), (d = e.opts || e))
                        : "object" === n.type(e) && n(e).length
                        ? ((i = n(e)), (d = i.data() || {}), (d = n.extend(!0, {}, d, d.options)), (d.$orig = i), (l.src = o.opts.src || d.src || i.attr("href")), l.type || l.src || ((l.type = "inline"), (l.src = e)))
                        : (l = { type: "html", src: e + "" }),
                        (l.opts = n.extend(!0, {}, o.opts, d)),
                        n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
                        n.fancybox.isMobile && l.opts.mobile && (l.opts = h(l.opts, l.opts.mobile)),
                        (a = l.type || l.opts.type),
                        (r = l.src || ""),
                        !a &&
                            r &&
                            ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                                ? ((a = "video"), l.opts.video.format || (l.opts.video.format = "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                                : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)
                                ? (a = "image")
                                : r.match(/\.(pdf)((\?|#).*)?$/i)
                                ? ((a = "iframe"), (l = n.extend(!0, l, { contentType: "pdf", opts: { iframe: { preload: !1 } } })))
                                : "#" === r.charAt(0) && (a = "inline")),
                        a ? (l.type = a) : o.trigger("objectNeedsType", l),
                        l.contentType || (l.contentType = n.inArray(l.type, ["html", "inline", "ajax"]) > -1 ? "html" : l.type),
                        (l.index = o.group.length),
                        "auto" == l.opts.smallBtn && (l.opts.smallBtn = n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
                        "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
                        (l.$thumb = l.opts.$thumb || null),
                        l.opts.$trigger && l.index === o.opts.index && ((l.$thumb = l.opts.$trigger.find("img:first")), l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
                        (l.$thumb && l.$thumb.length) || !l.opts.$orig || (l.$thumb = l.opts.$orig.find("img:first")),
                        l.$thumb && !l.$thumb.length && (l.$thumb = null),
                        (l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null)),
                        "function" === n.type(l.opts.caption) && (l.opts.caption = l.opts.caption.apply(e, [o, l])),
                        "function" === n.type(o.opts.caption) && (l.opts.caption = o.opts.caption.apply(e, [o, l])),
                        l.opts.caption instanceof n || (l.opts.caption = void 0 === l.opts.caption ? "" : l.opts.caption + ""),
                        "ajax" === l.type && ((c = r.split(/\s+/, 2)), c.length > 1 && ((l.src = c.shift()), (l.opts.filter = c.shift()))),
                        l.opts.modal &&
                            (l.opts = n.extend(!0, l.opts, {
                                trapFocus: !0,
                                infobar: 0,
                                toolbar: 0,
                                smallBtn: 0,
                                keyboard: 0,
                                slideShow: 0,
                                fullScreen: 0,
                                thumbs: 0,
                                touch: 0,
                                clickContent: !1,
                                clickSlide: !1,
                                clickOutside: !1,
                                dblclickContent: !1,
                                dblclickSlide: !1,
                                dblclickOutside: !1,
                            })),
                        o.group.push(l);
                }),
                    Object.keys(o.slides).length && (o.updateControls(), (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
            },
            addEvents: function () {
                var e = this;
                e.removeEvents(),
                    e.$refs.container
                        .on("click.fb-close", "[data-fancybox-close]", function (t) {
                            t.stopPropagation(), t.preventDefault(), e.close(t);
                        })
                        .on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function (t) {
                            t.stopPropagation(), t.preventDefault(), e.previous();
                        })
                        .on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function (t) {
                            t.stopPropagation(), t.preventDefault(), e.next();
                        })
                        .on("click.fb", "[data-fancybox-zoom]", function (t) {
                            e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
                        }),
                    s.on("orientationchange.fb resize.fb", function (t) {
                        t && t.originalEvent && "resize" === t.originalEvent.type
                            ? (e.requestId && u(e.requestId),
                              (e.requestId = d(function () {
                                  e.update(t);
                              })))
                            : (e.current && "iframe" === e.current.type && e.$refs.stage.hide(),
                              setTimeout(
                                  function () {
                                      e.$refs.stage.show(), e.update(t);
                                  },
                                  n.fancybox.isMobile ? 600 : 250
                              ));
                    }),
                    r.on("keydown.fb", function (t) {
                        var o = n.fancybox ? n.fancybox.getInstance() : null,
                            i = o.current,
                            a = t.keyCode || t.which;
                        if (9 == a) return void (i.opts.trapFocus && e.focus(t));
                        if (!(!i.opts.keyboard || t.ctrlKey || t.altKey || t.shiftKey || n(t.target).is("input,textarea,video,audio,select")))
                            return 8 === a || 27 === a
                                ? (t.preventDefault(), void e.close(t))
                                : 37 === a || 38 === a
                                ? (t.preventDefault(), void e.previous())
                                : 39 === a || 40 === a
                                ? (t.preventDefault(), void e.next())
                                : void e.trigger("afterKeydown", t, a);
                    }),
                    e.group[e.currIndex].opts.idleTime &&
                        ((e.idleSecondsCounter = 0),
                        r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function (t) {
                            (e.idleSecondsCounter = 0), e.isIdle && e.showControls(), (e.isIdle = !1);
                        }),
                        (e.idleInterval = t.setInterval(function () {
                            ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime && !e.isDragging && ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
                        }, 1e3)));
            },
            removeEvents: function () {
                var e = this;
                s.off("orientationchange.fb resize.fb"), r.off("keydown.fb .fb-idle"), this.$refs.container.off(".fb-close .fb-prev .fb-next"), e.idleInterval && (t.clearInterval(e.idleInterval), (e.idleInterval = null));
            },
            previous: function (t) {
                return this.jumpTo(this.currPos - 1, t);
            },
            next: function (t) {
                return this.jumpTo(this.currPos + 1, t);
            },
            jumpTo: function (t, e) {
                var o,
                    i,
                    a,
                    s,
                    r,
                    c,
                    l,
                    d,
                    u,
                    f = this,
                    h = f.group.length;
                if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
                    if (((t = parseInt(t, 10)), !(a = f.current ? f.current.opts.loop : f.opts.loop) && (t < 0 || t >= h))) return !1;
                    if (
                        ((o = f.firstRun = !Object.keys(f.slides).length),
                        (r = f.current),
                        (f.prevIndex = f.currIndex),
                        (f.prevPos = f.currPos),
                        (s = f.createSlide(t)),
                        h > 1 && ((a || s.index < h - 1) && f.createSlide(t + 1), (a || s.index > 0) && f.createSlide(t - 1)),
                        (f.current = s),
                        (f.currIndex = s.index),
                        (f.currPos = s.pos),
                        f.trigger("beforeShow", o),
                        f.updateControls(),
                        (s.forcedDuration = void 0),
                        n.isNumeric(e) ? (s.forcedDuration = e) : (e = s.opts[o ? "animationDuration" : "transitionDuration"]),
                        (e = parseInt(e, 10)),
                        (i = f.isMoved(s)),
                        s.$slide.addClass("fancybox-slide--current"),
                        o)
                    )
                        return s.opts.animationEffect && e && f.$refs.container.css("transition-duration", e + "ms"), f.$refs.container.addClass("fancybox-is-open").trigger("focus"), f.loadSlide(s), void f.preload("image");
                    (c = n.fancybox.getTranslate(r.$slide)),
                        (l = n.fancybox.getTranslate(f.$refs.stage)),
                        n.each(f.slides, function (t, e) {
                            n.fancybox.stop(e.$slide, !0);
                        }),
                        r.pos !== s.pos && (r.isComplete = !1),
                        r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),
                        i
                            ? ((u = c.left - (r.pos * c.width + r.pos * r.opts.gutter)),
                              n.each(f.slides, function (t, o) {
                                  o.$slide.removeClass("fancybox-animated").removeClass(function (t, e) {
                                      return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                                  });
                                  var i = o.pos * c.width + o.pos * o.opts.gutter;
                                  n.fancybox.setTranslate(o.$slide, { top: 0, left: i - l.left + u }),
                                      o.pos !== s.pos && o.$slide.addClass("fancybox-slide--" + (o.pos > s.pos ? "next" : "previous")),
                                      p(o.$slide),
                                      n.fancybox.animate(o.$slide, { top: 0, left: (o.pos - s.pos) * c.width + (o.pos - s.pos) * o.opts.gutter }, e, function () {
                                          o.$slide.css({ transform: "", opacity: "" }).removeClass("fancybox-slide--next fancybox-slide--previous"), o.pos === f.currPos && f.complete();
                                      });
                              }))
                            : e &&
                              s.opts.transitionEffect &&
                              ((d = "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                              r.$slide.addClass("fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")),
                              n.fancybox.animate(
                                  r.$slide,
                                  d,
                                  e,
                                  function () {
                                      r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous");
                                  },
                                  !1
                              )),
                        s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
                        f.preload("image");
                }
            },
            createSlide: function (t) {
                var e,
                    o,
                    i = this;
                return (
                    (o = t % i.group.length),
                    (o = o < 0 ? i.group.length + o : o),
                    !i.slides[t] && i.group[o] && ((e = n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage)), (i.slides[t] = n.extend(!0, {}, i.group[o], { pos: t, $slide: e, isLoaded: !1 })), i.updateSlide(i.slides[t])),
                    i.slides[t]
                );
            },
            scaleToActual: function (t, e, o) {
                var i,
                    a,
                    s,
                    r,
                    c,
                    l = this,
                    d = l.current,
                    u = d.$content,
                    f = n.fancybox.getTranslate(d.$slide).width,
                    p = n.fancybox.getTranslate(d.$slide).height,
                    h = d.width,
                    g = d.height;
                l.isAnimating ||
                    l.isMoved() ||
                    !u ||
                    "image" != d.type ||
                    !d.isLoaded ||
                    d.hasError ||
                    ((l.isAnimating = !0),
                    n.fancybox.stop(u),
                    (t = void 0 === t ? 0.5 * f : t),
                    (e = void 0 === e ? 0.5 * p : e),
                    (i = n.fancybox.getTranslate(u)),
                    (i.top -= n.fancybox.getTranslate(d.$slide).top),
                    (i.left -= n.fancybox.getTranslate(d.$slide).left),
                    (r = h / i.width),
                    (c = g / i.height),
                    (a = 0.5 * f - 0.5 * h),
                    (s = 0.5 * p - 0.5 * g),
                    h > f && ((a = i.left * r - (t * r - t)), a > 0 && (a = 0), a < f - h && (a = f - h)),
                    g > p && ((s = i.top * c - (e * c - e)), s > 0 && (s = 0), s < p - g && (s = p - g)),
                    l.updateCursor(h, g),
                    n.fancybox.animate(u, { top: s, left: a, scaleX: r, scaleY: c }, o || 366, function () {
                        l.isAnimating = !1;
                    }),
                    l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
            },
            scaleToFit: function (t) {
                var e,
                    o = this,
                    i = o.current,
                    a = i.$content;
                o.isAnimating ||
                    o.isMoved() ||
                    !a ||
                    "image" != i.type ||
                    !i.isLoaded ||
                    i.hasError ||
                    ((o.isAnimating = !0),
                    n.fancybox.stop(a),
                    (e = o.getFitPos(i)),
                    o.updateCursor(e.width, e.height),
                    n.fancybox.animate(a, { top: e.top, left: e.left, scaleX: e.width / a.width(), scaleY: e.height / a.height() }, t || 366, function () {
                        o.isAnimating = !1;
                    }));
            },
            getFitPos: function (t) {
                var e,
                    o,
                    i,
                    a,
                    s = this,
                    r = t.$content,
                    c = t.$slide,
                    l = t.width || t.opts.width,
                    d = t.height || t.opts.height,
                    u = {};
                return (
                    !!(t.isLoaded && r && r.length) &&
                    ((e = n.fancybox.getTranslate(s.$refs.stage).width),
                    (o = n.fancybox.getTranslate(s.$refs.stage).height),
                    (e -= parseFloat(c.css("paddingLeft")) + parseFloat(c.css("paddingRight")) + parseFloat(r.css("marginLeft")) + parseFloat(r.css("marginRight"))),
                    (o -= parseFloat(c.css("paddingTop")) + parseFloat(c.css("paddingBottom")) + parseFloat(r.css("marginTop")) + parseFloat(r.css("marginBottom"))),
                    (l && d) || ((l = e), (d = o)),
                    (i = Math.min(1, e / l, o / d)),
                    (l *= i),
                    (d *= i),
                    l > e - 0.5 && (l = e),
                    d > o - 0.5 && (d = o),
                    "image" === t.type
                        ? ((u.top = Math.floor(0.5 * (o - d)) + parseFloat(c.css("paddingTop"))), (u.left = Math.floor(0.5 * (e - l)) + parseFloat(c.css("paddingLeft"))))
                        : "video" === t.contentType && ((a = t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9), d > l / a ? (d = l / a) : l > d * a && (l = d * a)),
                    (u.width = l),
                    (u.height = d),
                    u)
                );
            },
            update: function (t) {
                var e = this;
                n.each(e.slides, function (n, o) {
                    e.updateSlide(o, t);
                });
            },
            updateSlide: function (t, e) {
                var o = this,
                    i = t && t.$content,
                    a = t.width || t.opts.width,
                    s = t.height || t.opts.height,
                    r = t.$slide;
                o.adjustCaption(t),
                    i && (a || s || "video" === t.contentType) && !t.hasError && (n.fancybox.stop(i), n.fancybox.setTranslate(i, o.getFitPos(t)), t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
                    o.adjustLayout(t),
                    r.length &&
                        (r.trigger("refresh"), t.pos === o.currPos && o.$refs.toolbar.add(o.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", r.get(0).scrollHeight > r.get(0).clientHeight)),
                    o.trigger("onUpdate", t, e);
            },
            centerSlide: function (t) {
                var e = this,
                    o = e.current,
                    i = o.$slide;
                !e.isClosing &&
                    o &&
                    (i.siblings().css({ transform: "", opacity: "" }),
                    i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),
                    n.fancybox.animate(
                        i,
                        { top: 0, left: 0, opacity: 1 },
                        void 0 === t ? 0 : t,
                        function () {
                            i.css({ transform: "", opacity: "" }), o.isComplete || e.complete();
                        },
                        !1
                    ));
            },
            isMoved: function (t) {
                var e,
                    o,
                    i = t || this.current;
                return !!i && ((o = n.fancybox.getTranslate(this.$refs.stage)), (e = n.fancybox.getTranslate(i.$slide)), !i.$slide.hasClass("fancybox-animated") && (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5));
            },
            updateCursor: function (t, e) {
                var o,
                    i,
                    a = this,
                    s = a.current,
                    r = a.$refs.container;
                s &&
                    !a.isClosing &&
                    a.Guestures &&
                    (r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),
                    (o = a.canPan(t, e)),
                    (i = !!o || a.isZoomable()),
                    r.toggleClass("fancybox-is-zoomable", i),
                    n("[data-fancybox-zoom]").prop("disabled", !i),
                    o
                        ? r.addClass("fancybox-can-pan")
                        : i && ("zoom" === s.opts.clickContent || (n.isFunction(s.opts.clickContent) && "zoom" == s.opts.clickContent(s)))
                        ? r.addClass("fancybox-can-zoomIn")
                        : s.opts.touch && (s.opts.touch.vertical || a.group.length > 1) && "video" !== s.contentType && r.addClass("fancybox-can-swipe"));
            },
            isZoomable: function () {
                var t,
                    e = this,
                    n = e.current;
                if (n && !e.isClosing && "image" === n.type && !n.hasError) {
                    if (!n.isLoaded) return !0;
                    if ((t = e.getFitPos(n)) && (n.width > t.width || n.height > t.height)) return !0;
                }
                return !1;
            },
            isScaledDown: function (t, e) {
                var o = this,
                    i = !1,
                    a = o.current,
                    s = a.$content;
                return void 0 !== t && void 0 !== e ? (i = t < a.width && e < a.height) : s && ((i = n.fancybox.getTranslate(s)), (i = i.width < a.width && i.height < a.height)), i;
            },
            canPan: function (t, e) {
                var o = this,
                    i = o.current,
                    a = null,
                    s = !1;
                return (
                    "image" === i.type &&
                        (i.isComplete || (t && e)) &&
                        !i.hasError &&
                        ((s = o.getFitPos(i)),
                        void 0 !== t && void 0 !== e ? (a = { width: t, height: e }) : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
                        a && s && (s = Math.abs(a.width - s.width) > 1.5 || Math.abs(a.height - s.height) > 1.5)),
                    s
                );
            },
            loadSlide: function (t) {
                var e,
                    o,
                    i,
                    a = this;
                if (!t.isLoading && !t.isLoaded) {
                    if (((t.isLoading = !0), !1 === a.trigger("beforeLoad", t))) return (t.isLoading = !1), !1;
                    switch (((e = t.type), (o = t.$slide), o.off("refresh").trigger("onReset").addClass(t.opts.slideClass), e)) {
                        case "image":
                            a.setImage(t);
                            break;
                        case "iframe":
                            a.setIframe(t);
                            break;
                        case "html":
                            a.setContent(t, t.src || t.content);
                            break;
                        case "video":
                            a.setContent(
                                t,
                                t.opts.video.tpl
                                    .replace(/\{\{src\}\}/gi, t.src)
                                    .replace("{{format}}", t.opts.videoFormat || t.opts.video.format || "")
                                    .replace("{{poster}}", t.thumb || "")
                            );
                            break;
                        case "inline":
                            n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
                            break;
                        case "ajax":
                            a.showLoading(t),
                                (i = n.ajax(
                                    n.extend({}, t.opts.ajax.settings, {
                                        url: t.src,
                                        success: function (e, n) {
                                            "success" === n && a.setContent(t, e);
                                        },
                                        error: function (e, n) {
                                            e && "abort" !== n && a.setError(t);
                                        },
                                    })
                                )),
                                o.one("onReset", function () {
                                    i.abort();
                                });
                            break;
                        default:
                            a.setError(t);
                    }
                    return !0;
                }
            },
            setImage: function (t) {
                var o,
                    i = this;
                setTimeout(function () {
                    var e = t.$image;
                    i.isClosing || !t.isLoading || (e && e.length && e[0].complete) || t.hasError || i.showLoading(t);
                }, 50),
                    i.checkSrcset(t),
                    (t.$content = n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image"))),
                    !1 !== t.opts.preload &&
                        t.opts.width &&
                        t.opts.height &&
                        t.thumb &&
                        ((t.width = t.opts.width),
                        (t.height = t.opts.height),
                        (o = e.createElement("img")),
                        (o.onerror = function () {
                            n(this).remove(), (t.$ghost = null);
                        }),
                        (o.onload = function () {
                            i.afterLoad(t);
                        }),
                        (t.$ghost = n(o).addClass("fancybox-image").appendTo(t.$content).attr("src", t.thumb))),
                    i.setBigImage(t);
            },
            checkSrcset: function (e) {
                var n,
                    o,
                    i,
                    a,
                    s = e.opts.srcset || e.opts.image.srcset;
                if (s) {
                    (i = t.devicePixelRatio || 1),
                        (a = t.innerWidth * i),
                        (o = s.split(",").map(function (t) {
                            var e = {};
                            return (
                                t
                                    .trim()
                                    .split(/\s+/)
                                    .forEach(function (t, n) {
                                        var o = parseInt(t.substring(0, t.length - 1), 10);
                                        if (0 === n) return (e.url = t);
                                        o && ((e.value = o), (e.postfix = t[t.length - 1]));
                                    }),
                                e
                            );
                        })),
                        o.sort(function (t, e) {
                            return t.value - e.value;
                        });
                    for (var r = 0; r < o.length; r++) {
                        var c = o[r];
                        if (("w" === c.postfix && c.value >= a) || ("x" === c.postfix && c.value >= i)) {
                            n = c;
                            break;
                        }
                    }
                    !n && o.length && (n = o[o.length - 1]), n && ((e.src = n.url), e.width && e.height && "w" == n.postfix && ((e.height = (e.width / e.height) * n.value), (e.width = n.value)), (e.opts.srcset = s));
                }
            },
            setBigImage: function (t) {
                var o = this,
                    i = e.createElement("img"),
                    a = n(i);
                (t.$image = a
                    .one("error", function () {
                        o.setError(t);
                    })
                    .one("load", function () {
                        var e;
                        t.$ghost || (o.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight), o.afterLoad(t)),
                            o.isClosing ||
                                (t.opts.srcset &&
                                    ((e = t.opts.sizes),
                                    (e && "auto" !== e) || (e = (t.width / t.height > 1 && s.width() / s.height() > 1 ? "100" : Math.round((t.width / t.height) * 100)) + "vw"),
                                    a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                                t.$ghost &&
                                    setTimeout(function () {
                                        t.$ghost && !o.isClosing && t.$ghost.hide();
                                    }, Math.min(300, Math.max(1e3, t.height / 1600))),
                                o.hideLoading(t));
                    })
                    .addClass("fancybox-image")
                    .attr("src", t.src)
                    .appendTo(t.$content)),
                    (i.complete || "complete" == i.readyState) && a.naturalWidth && a.naturalHeight ? a.trigger("load") : i.error && a.trigger("error");
            },
            resolveImageSlideSize: function (t, e, n) {
                var o = parseInt(t.opts.width, 10),
                    i = parseInt(t.opts.height, 10);
                (t.width = e), (t.height = n), o > 0 && ((t.width = o), (t.height = Math.floor((o * n) / e))), i > 0 && ((t.width = Math.floor((i * e) / n)), (t.height = i));
            },
            setIframe: function (t) {
                var e,
                    o = this,
                    i = t.opts.iframe,
                    a = t.$slide;
                (t.$content = n('<div class="fancybox-content' + (i.preload ? " fancybox-is-hidden" : "") + '"></div>')
                    .css(i.css)
                    .appendTo(a)),
                    a.addClass("fancybox-slide--" + t.contentType),
                    (t.$iframe = e = n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                        .attr(i.attr)
                        .appendTo(t.$content)),
                    i.preload
                        ? (o.showLoading(t),
                          e.on("load.fb error.fb", function (e) {
                              (this.isReady = 1), t.$slide.trigger("refresh"), o.afterLoad(t);
                          }),
                          a.on("refresh.fb", function () {
                              var n,
                                  o,
                                  s = t.$content,
                                  r = i.css.width,
                                  c = i.css.height;
                              if (1 === e[0].isReady) {
                                  try {
                                      (n = e.contents()), (o = n.find("body"));
                                  } catch (t) {}
                                  o &&
                                      o.length &&
                                      o.children().length &&
                                      (a.css("overflow", "visible"),
                                      s.css({ width: "100%", "max-width": "100%", height: "9999px" }),
                                      void 0 === r && (r = Math.ceil(Math.max(o[0].clientWidth, o.outerWidth(!0)))),
                                      s.css("width", r || "").css("max-width", ""),
                                      void 0 === c && (c = Math.ceil(Math.max(o[0].clientHeight, o.outerHeight(!0)))),
                                      s.css("height", c || ""),
                                      a.css("overflow", "auto")),
                                      s.removeClass("fancybox-is-hidden");
                              }
                          }))
                        : o.afterLoad(t),
                    e.attr("src", t.src),
                    a.one("onReset", function () {
                        try {
                            n(this).find("iframe").hide().unbind().attr("src", "//about:blank");
                        } catch (t) {}
                        n(this).off("refresh.fb").empty(), (t.isLoaded = !1), (t.isRevealed = !1);
                    });
            },
            setContent: function (t, e) {
                var o = this;
                o.isClosing ||
                    (o.hideLoading(t),
                    t.$content && n.fancybox.stop(t.$content),
                    t.$slide.empty(),
                    l(e) && e.parent().length
                        ? ((e.hasClass("fancybox-content") || e.parent().hasClass("fancybox-content")) && e.parents(".fancybox-slide").trigger("onReset"),
                          (t.$placeholder = n("<div>").hide().insertAfter(e)),
                          e.css("display", "inline-block"))
                        : t.hasError || ("string" === n.type(e) && (e = n("<div>").append(n.trim(e)).contents()), t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
                    t.$slide.one("onReset", function () {
                        n(this).find("video,audio").trigger("pause"),
                            t.$placeholder && (t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(), (t.$placeholder = null)),
                            t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
                            t.hasError || (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1));
                    }),
                    n(e).appendTo(t.$slide),
                    n(e).is("video,audio") &&
                        (n(e).addClass("fancybox-video"), n(e).wrap("<div></div>"), (t.contentType = "video"), (t.opts.width = t.opts.width || n(e).attr("width")), (t.opts.height = t.opts.height || n(e).attr("height"))),
                    (t.$content = t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first()),
                    t.$content.siblings().hide(),
                    t.$content.length || (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
                    t.$content.addClass("fancybox-content"),
                    t.$slide.addClass("fancybox-slide--" + t.contentType),
                    o.afterLoad(t));
            },
            setError: function (t) {
                (t.hasError = !0),
                    t.$slide
                        .trigger("onReset")
                        .removeClass("fancybox-slide--" + t.contentType)
                        .addClass("fancybox-slide--error"),
                    (t.contentType = "html"),
                    this.setContent(t, this.translate(t, t.opts.errorTpl)),
                    t.pos === this.currPos && (this.isAnimating = !1);
            },
            showLoading: function (t) {
                var e = this;
                (t = t || e.current) && !t.$spinner && (t.$spinner = n(e.translate(e, e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"));
            },
            hideLoading: function (t) {
                var e = this;
                (t = t || e.current) && t.$spinner && (t.$spinner.stop().remove(), delete t.$spinner);
            },
            afterLoad: function (t) {
                var e = this;
                e.isClosing ||
                    ((t.isLoading = !1),
                    (t.isLoaded = !0),
                    e.trigger("afterLoad", t),
                    e.hideLoading(t),
                    !t.opts.smallBtn || (t.$smallBtn && t.$smallBtn.length) || (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)),
                    t.opts.protect &&
                        t.$content &&
                        !t.hasError &&
                        (t.$content.on("contextmenu.fb", function (t) {
                            return 2 == t.button && t.preventDefault(), !0;
                        }),
                        "image" === t.type && n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
                    e.adjustCaption(t),
                    e.adjustLayout(t),
                    t.pos === e.currPos && e.updateCursor(),
                    e.revealContent(t));
            },
            adjustCaption: function (t) {
                var e,
                    n = this,
                    o = t || n.current,
                    i = o.opts.caption,
                    a = o.opts.preventCaptionOverlap,
                    s = n.$refs.caption,
                    r = !1;
                s.toggleClass("fancybox-caption--separate", a),
                    a &&
                        i &&
                        i.length &&
                        (o.pos !== n.currPos ? ((e = s.clone().appendTo(s.parent())), e.children().eq(0).empty().html(i), (r = e.outerHeight(!0)), e.empty().remove()) : n.$caption && (r = n.$caption.outerHeight(!0)),
                        o.$slide.css("padding-bottom", r || ""));
            },
            adjustLayout: function (t) {
                var e,
                    n,
                    o,
                    i,
                    a = this,
                    s = t || a.current;
                s.isLoaded &&
                    !0 !== s.opts.disableLayoutFix &&
                    (s.$content.css("margin-bottom", ""),
                    s.$content.outerHeight() > s.$slide.height() + 0.5 &&
                        ((o = s.$slide[0].style["padding-bottom"]),
                        (i = s.$slide.css("padding-bottom")),
                        parseFloat(i) > 0 && ((e = s.$slide[0].scrollHeight), s.$slide.css("padding-bottom", 0), Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i), s.$slide.css("padding-bottom", o))),
                    s.$content.css("margin-bottom", n));
            },
            revealContent: function (t) {
                var e,
                    o,
                    i,
                    a,
                    s = this,
                    r = t.$slide,
                    c = !1,
                    l = !1,
                    d = s.isMoved(t),
                    u = t.isRevealed;
                return (
                    (t.isRevealed = !0),
                    (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
                    (i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
                    (i = parseInt(void 0 === t.forcedDuration ? i : t.forcedDuration, 10)),
                    (!d && t.pos === s.currPos && i) || (e = !1),
                    "zoom" === e && (t.pos === s.currPos && i && "image" === t.type && !t.hasError && (l = s.getThumbPos(t)) ? (c = s.getFitPos(t)) : (e = "fade")),
                    "zoom" === e
                        ? ((s.isAnimating = !0),
                          (c.scaleX = c.width / l.width),
                          (c.scaleY = c.height / l.height),
                          (a = t.opts.zoomOpacity),
                          "auto" == a && (a = Math.abs(t.width / t.height - l.width / l.height) > 0.1),
                          a && ((l.opacity = 0.1), (c.opacity = 1)),
                          n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), l),
                          p(t.$content),
                          void n.fancybox.animate(t.$content, c, i, function () {
                              (s.isAnimating = !1), s.complete();
                          }))
                        : (s.updateSlide(t),
                          e
                              ? (n.fancybox.stop(r),
                                (o = "fancybox-slide--" + (t.pos >= s.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + e),
                                r.addClass(o).removeClass("fancybox-slide--current"),
                                t.$content.removeClass("fancybox-is-hidden"),
                                p(r),
                                "image" !== t.type && t.$content.hide().show(0),
                                void n.fancybox.animate(
                                    r,
                                    "fancybox-slide--current",
                                    i,
                                    function () {
                                        r.removeClass(o).css({ transform: "", opacity: "" }), t.pos === s.currPos && s.complete();
                                    },
                                    !0
                                ))
                              : (t.$content.removeClass("fancybox-is-hidden"), u || !d || "image" !== t.type || t.hasError || t.$content.hide().fadeIn("fast"), void (t.pos === s.currPos && s.complete())))
                );
            },
            getThumbPos: function (t) {
                var e,
                    o,
                    i,
                    a,
                    s,
                    r = !1,
                    c = t.$thumb;
                return (
                    !(!c || !g(c[0])) &&
                    ((e = n.fancybox.getTranslate(c)),
                    (o = parseFloat(c.css("border-top-width") || 0)),
                    (i = parseFloat(c.css("border-right-width") || 0)),
                    (a = parseFloat(c.css("border-bottom-width") || 0)),
                    (s = parseFloat(c.css("border-left-width") || 0)),
                    (r = { top: e.top + o, left: e.left + s, width: e.width - i - s, height: e.height - o - a, scaleX: 1, scaleY: 1 }),
                    e.width > 0 && e.height > 0 && r)
                );
            },
            complete: function () {
                var t,
                    e = this,
                    o = e.current,
                    i = {};
                !e.isMoved() &&
                    o.isLoaded &&
                    (o.isComplete ||
                        ((o.isComplete = !0),
                        o.$slide.siblings().trigger("onReset"),
                        e.preload("inline"),
                        p(o.$slide),
                        o.$slide.addClass("fancybox-slide--complete"),
                        n.each(e.slides, function (t, o) {
                            o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1 ? (i[o.pos] = o) : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
                        }),
                        (e.slides = i)),
                    (e.isAnimating = !1),
                    e.updateCursor(),
                    e.trigger("afterShow"),
                    o.opts.video.autoStart &&
                        o.$slide
                            .find("video,audio")
                            .filter(":visible:first")
                            .trigger("play")
                            .one("ended", function () {
                                Document.exitFullscreen ? Document.exitFullscreen() : this.webkitExitFullscreen && this.webkitExitFullscreen(), e.next();
                            }),
                    o.opts.autoFocus && "html" === o.contentType && ((t = o.$content.find("input[autofocus]:enabled:visible:first")), t.length ? t.trigger("focus") : e.focus(null, !0)),
                    o.$slide.scrollTop(0).scrollLeft(0));
            },
            preload: function (t) {
                var e,
                    n,
                    o = this;
                o.group.length < 2 || ((n = o.slides[o.currPos + 1]), (e = o.slides[o.currPos - 1]), e && e.type === t && o.loadSlide(e), n && n.type === t && o.loadSlide(n));
            },
            focus: function (t, o) {
                var i,
                    a,
                    s = this,
                    r = [
                        "a[href]",
                        "area[href]",
                        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                        "select:not([disabled]):not([aria-hidden])",
                        "textarea:not([disabled]):not([aria-hidden])",
                        "button:not([disabled]):not([aria-hidden])",
                        "iframe",
                        "object",
                        "embed",
                        "video",
                        "audio",
                        "[contenteditable]",
                        '[tabindex]:not([tabindex^="-"])',
                    ].join(",");
                s.isClosing ||
                    ((i = !t && s.current && s.current.isComplete ? s.current.$slide.find("*:visible" + (o ? ":not(.fancybox-close-small)" : "")) : s.$refs.container.find("*:visible")),
                    (i = i.filter(r).filter(function () {
                        return "hidden" !== n(this).css("visibility") && !n(this).hasClass("disabled");
                    })),
                    i.length
                        ? ((a = i.index(e.activeElement)),
                          t && t.shiftKey ? (a < 0 || 0 == a) && (t.preventDefault(), i.eq(i.length - 1).trigger("focus")) : (a < 0 || a == i.length - 1) && (t && t.preventDefault(), i.eq(0).trigger("focus")))
                        : s.$refs.container.trigger("focus"));
            },
            activate: function () {
                var t = this;
                n(".fancybox-container").each(function () {
                    var e = n(this).data("FancyBox");
                    e && e.id !== t.id && !e.isClosing && (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
                }),
                    (t.isVisible = !0),
                    (t.current || t.isIdle) && (t.update(), t.updateControls()),
                    t.trigger("onActivate"),
                    t.addEvents();
            },
            close: function (t, e) {
                var o,
                    i,
                    a,
                    s,
                    r,
                    c,
                    l,
                    u = this,
                    f = u.current,
                    h = function () {
                        u.cleanUp(t);
                    };
                return (
                    !u.isClosing &&
                    ((u.isClosing = !0),
                    !1 === u.trigger("beforeClose", t)
                        ? ((u.isClosing = !1),
                          d(function () {
                              u.update();
                          }),
                          !1)
                        : (u.removeEvents(),
                          (a = f.$content),
                          (o = f.opts.animationEffect),
                          (i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
                          f.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),
                          !0 !== t ? n.fancybox.stop(f.$slide) : (o = !1),
                          f.$slide.siblings().trigger("onReset").remove(),
                          i &&
                              u.$refs.container
                                  .removeClass("fancybox-is-open")
                                  .addClass("fancybox-is-closing")
                                  .css("transition-duration", i + "ms"),
                          u.hideLoading(f),
                          u.hideControls(!0),
                          u.updateCursor(),
                          "zoom" !== o || (a && i && "image" === f.type && !u.isMoved() && !f.hasError && (l = u.getThumbPos(f))) || (o = "fade"),
                          "zoom" === o
                              ? (n.fancybox.stop(a),
                                (s = n.fancybox.getTranslate(a)),
                                (c = { top: s.top, left: s.left, scaleX: s.width / l.width, scaleY: s.height / l.height, width: l.width, height: l.height }),
                                (r = f.opts.zoomOpacity),
                                "auto" == r && (r = Math.abs(f.width / f.height - l.width / l.height) > 0.1),
                                r && (l.opacity = 0),
                                n.fancybox.setTranslate(a, c),
                                p(a),
                                n.fancybox.animate(a, l, i, h),
                                !0)
                              : (o && i ? n.fancybox.animate(f.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + o, i, h) : !0 === t ? setTimeout(h, i) : h(), !0)))
                );
            },
            cleanUp: function (e) {
                var o,
                    i,
                    a,
                    s = this,
                    r = s.current.opts.$orig;
                s.current.$slide.trigger("onReset"),
                    s.$refs.container.empty().remove(),
                    s.trigger("afterClose", e),
                    s.current.opts.backFocus && ((r && r.length && r.is(":visible")) || (r = s.$trigger), r && r.length && ((i = t.scrollX), (a = t.scrollY), r.trigger("focus"), n("html, body").scrollTop(a).scrollLeft(0))),
                    (s.current = null),
                    (o = n.fancybox.getInstance()),
                    o ? o.activate() : (n("body").removeClass("fancybox-active compensate-for-scrollbar"), n("#fancybox-style-noscroll").remove());
            },
            trigger: function (t, e) {
                var o,
                    i = Array.prototype.slice.call(arguments, 1),
                    a = this,
                    s = e && e.opts ? e : a.current;
                if ((s ? i.unshift(s) : (s = a), i.unshift(a), n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)), !1 === o)) return o;
                "afterClose" !== t && a.$refs ? a.$refs.container.trigger(t + ".fb", i) : r.trigger(t + ".fb", i);
            },
            updateControls: function () {
                var t = this,
                    o = t.current,
                    i = o.index,
                    a = t.$refs.container,
                    s = t.$refs.caption,
                    r = o.opts.caption;
                o.$slide.trigger("refresh"),
                    r && r.length ? ((t.$caption = s), s.children().eq(0).html(r)) : (t.$caption = null),
                    t.hasHiddenControls || t.isIdle || t.showControls(),
                    a.find("[data-fancybox-count]").html(t.group.length),
                    a.find("[data-fancybox-index]").html(i + 1),
                    a.find("[data-fancybox-prev]").prop("disabled", !o.opts.loop && i <= 0),
                    a.find("[data-fancybox-next]").prop("disabled", !o.opts.loop && i >= t.group.length - 1),
                    "image" === o.type
                        ? a
                              .find("[data-fancybox-zoom]")
                              .show()
                              .end()
                              .find("[data-fancybox-download]")
                              .attr("href", o.opts.image.src || o.src)
                              .show()
                        : o.opts.toolbar && a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
                    n(e.activeElement).is(":hidden,[disabled]") && t.$refs.container.trigger("focus");
            },
            hideControls: function (t) {
                var e = this,
                    n = ["infobar", "toolbar", "nav"];
                (!t && e.current.opts.preventCaptionOverlap) || n.push("caption"),
                    this.$refs.container.removeClass(
                        n
                            .map(function (t) {
                                return "fancybox-show-" + t;
                            })
                            .join(" ")
                    ),
                    (this.hasHiddenControls = !0);
            },
            showControls: function () {
                var t = this,
                    e = t.current ? t.current.opts : t.opts,
                    n = t.$refs.container;
                (t.hasHiddenControls = !1),
                    (t.idleSecondsCounter = 0),
                    n
                        .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
                        .toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1))
                        .toggleClass("fancybox-show-caption", !!t.$caption)
                        .toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1))
                        .toggleClass("fancybox-is-modal", !!e.modal);
            },
            toggleControls: function () {
                this.hasHiddenControls ? this.showControls() : this.hideControls();
            },
        }),
            (n.fancybox = {
                version: "3.5.7",
                defaults: a,
                getInstance: function (t) {
                    var e = n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
                        o = Array.prototype.slice.call(arguments, 1);
                    return e instanceof b && ("string" === n.type(t) ? e[t].apply(e, o) : "function" === n.type(t) && t.apply(e, o), e);
                },
                open: function (t, e, n) {
                    return new b(t, e, n);
                },
                close: function (t) {
                    var e = this.getInstance();
                    e && (e.close(), !0 === t && this.close(t));
                },
                destroy: function () {
                    this.close(!0), r.add("body").off("click.fb-start", "**");
                },
                isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                use3d: (function () {
                    var n = e.createElement("div");
                    return t.getComputedStyle && t.getComputedStyle(n) && t.getComputedStyle(n).getPropertyValue("transform") && !(e.documentMode && e.documentMode < 11);
                })(),
                getTranslate: function (t) {
                    var e;
                    return !(!t || !t.length) && ((e = t[0].getBoundingClientRect()), { top: e.top || 0, left: e.left || 0, width: e.width, height: e.height, opacity: parseFloat(t.css("opacity")) });
                },
                setTranslate: function (t, e) {
                    var n = "",
                        o = {};
                    if (t && e)
                        return (
                            (void 0 === e.left && void 0 === e.top) ||
                                ((n = (void 0 === e.left ? t.position().left : e.left) + "px, " + (void 0 === e.top ? t.position().top : e.top) + "px"), (n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")")),
                            void 0 !== e.scaleX && void 0 !== e.scaleY ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")") : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
                            n.length && (o.transform = n),
                            void 0 !== e.opacity && (o.opacity = e.opacity),
                            void 0 !== e.width && (o.width = e.width),
                            void 0 !== e.height && (o.height = e.height),
                            t.css(o)
                        );
                },
                animate: function (t, e, o, i, a) {
                    var s,
                        r = this;
                    n.isFunction(o) && ((i = o), (o = null)),
                        r.stop(t),
                        (s = r.getTranslate(t)),
                        t.on(f, function (c) {
                            (!c || !c.originalEvent || (t.is(c.originalEvent.target) && "z-index" != c.originalEvent.propertyName)) &&
                                (r.stop(t),
                                n.isNumeric(o) && t.css("transition-duration", ""),
                                n.isPlainObject(e)
                                    ? void 0 !== e.scaleX && void 0 !== e.scaleY && r.setTranslate(t, { top: e.top, left: e.left, width: s.width * e.scaleX, height: s.height * e.scaleY, scaleX: 1, scaleY: 1 })
                                    : !0 !== a && t.removeClass(e),
                                n.isFunction(i) && i(c));
                        }),
                        n.isNumeric(o) && t.css("transition-duration", o + "ms"),
                        n.isPlainObject(e)
                            ? (void 0 !== e.scaleX && void 0 !== e.scaleY && (delete e.width, delete e.height, t.parent().hasClass("fancybox-slide--image") && t.parent().addClass("fancybox-is-scaling")), n.fancybox.setTranslate(t, e))
                            : t.addClass(e),
                        t.data(
                            "timer",
                            setTimeout(function () {
                                t.trigger(f);
                            }, o + 33)
                        );
                },
                stop: function (t, e) {
                    t && t.length && (clearTimeout(t.data("timer")), e && t.trigger(f), t.off(f).css("transition-duration", ""), t.parent().removeClass("fancybox-is-scaling"));
                },
            }),
            (n.fn.fancybox = function (t) {
                var e;
                return (t = t || {}), (e = t.selector || !1), e ? n("body").off("click.fb-start", e).on("click.fb-start", e, { options: t }, i) : this.off("click.fb-start").on("click.fb-start", { items: this, options: t }, i), this;
            }),
            r.on("click.fb-start", "[data-fancybox]", i),
            r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
                n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
                    .eq(n(this).attr("data-fancybox-index") || 0)
                    .trigger("click.fb-start", { $trigger: n(this) });
            }),
            (function () {
                var t = null;
                r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
                    switch (e.type) {
                        case "mousedown":
                            t = n(this);
                            break;
                        case "mouseup":
                            t = null;
                            break;
                        case "focusin":
                            n(".fancybox-button").removeClass("fancybox-focus"), n(this).is(t) || n(this).is("[disabled]") || n(this).addClass("fancybox-focus");
                            break;
                        case "focusout":
                            n(".fancybox-button").removeClass("fancybox-focus");
                    }
                });
            })();
    }
})(window, document, jQuery),
    (function (t) {
        "use strict";
        var e = {
                youtube: {
                    matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                    params: { autoplay: 1, autohide: 1, fs: 1, rel: 0, hd: 1, wmode: "transparent", enablejsapi: 1, html5: 1 },
                    paramPlace: 8,
                    type: "iframe",
                    url: "https://www.youtube-nocookie.com/embed/$4",
                    thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
                },
                vimeo: { matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/, params: { autoplay: 1, hd: 1, show_title: 1, show_byline: 1, show_portrait: 0, fullscreen: 1 }, paramPlace: 3, type: "iframe", url: "//player.vimeo.com/video/$2" },
                instagram: { matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i, type: "image", url: "//$1/p/$2/media/?size=l" },
                gmap_place: {
                    matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                    type: "iframe",
                    url: function (t) {
                        return (
                            "//maps.google." +
                            t[2] +
                            "/?ll=" +
                            (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12] + "").replace(/\?/, "&") +
                            "&output=" +
                            (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
                        );
                    },
                },
                gmap_search: {
                    matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                    type: "iframe",
                    url: function (t) {
                        return "//maps.google." + t[2] + "/maps?q=" + t[5].replace("query=", "q=").replace("api=1", "") + "&output=embed";
                    },
                },
            },
            n = function (e, n, o) {
                if (e)
                    return (
                        (o = o || ""),
                        "object" === t.type(o) && (o = t.param(o, !0)),
                        t.each(n, function (t, n) {
                            e = e.replace("$" + t, n || "");
                        }),
                        o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
                        e
                    );
            };
        t(document).on("objectNeedsType.fb", function (o, i, a) {
            var s,
                r,
                c,
                l,
                d,
                u,
                f,
                p = a.src || "",
                h = !1;
            (s = t.extend(!0, {}, e, a.opts.media)),
                t.each(s, function (e, o) {
                    if ((c = p.match(o.matcher))) {
                        if (((h = o.type), (f = e), (u = {}), o.paramPlace && c[o.paramPlace])) {
                            (d = c[o.paramPlace]), "?" == d[0] && (d = d.substring(1)), (d = d.split("&"));
                            for (var i = 0; i < d.length; ++i) {
                                var s = d[i].split("=", 2);
                                2 == s.length && (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
                            }
                        }
                        return (
                            (l = t.extend(!0, {}, o.params, a.opts[e], u)),
                            (p = "function" === t.type(o.url) ? o.url.call(this, c, l, a) : n(o.url, c, l)),
                            (r = "function" === t.type(o.thumb) ? o.thumb.call(this, c, l, a) : n(o.thumb, c)),
                            "youtube" === e
                                ? (p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
                                      return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10));
                                  }))
                                : "vimeo" === e && (p = p.replace("&%23", "#")),
                            !1
                        );
                    }
                }),
                h
                    ? (a.opts.thumb || (a.opts.$thumb && a.opts.$thumb.length) || (a.opts.thumb = r),
                      "iframe" === h && (a.opts = t.extend(!0, a.opts, { iframe: { preload: !1, attr: { scrolling: "no" } } })),
                      t.extend(a, { type: h, src: p, origSrc: a.src, contentSource: f, contentType: "image" === h ? "image" : "gmap_place" == f || "gmap_search" == f ? "map" : "video" }))
                    : p && (a.type = a.opts.defaultType);
        });
        var o = {
            youtube: { src: "https://www.youtube.com/iframe_api", class: "YT", loading: !1, loaded: !1 },
            vimeo: { src: "https://player.vimeo.com/api/player.js", class: "Vimeo", loading: !1, loaded: !1 },
            load: function (t) {
                var e,
                    n = this;
                if (this[t].loaded)
                    return void setTimeout(function () {
                        n.done(t);
                    });
                this[t].loading ||
                    ((this[t].loading = !0),
                    (e = document.createElement("script")),
                    (e.type = "text/javascript"),
                    (e.src = this[t].src),
                    "youtube" === t
                        ? (window.onYouTubeIframeAPIReady = function () {
                              (n[t].loaded = !0), n.done(t);
                          })
                        : (e.onload = function () {
                              (n[t].loaded = !0), n.done(t);
                          }),
                    document.body.appendChild(e));
            },
            done: function (e) {
                var n, o, i;
                "youtube" === e && delete window.onYouTubeIframeAPIReady,
                    (n = t.fancybox.getInstance()) &&
                        ((o = n.current.$content.find("iframe")),
                        "youtube" === e && void 0 !== YT && YT
                            ? (i = new YT.Player(o.attr("id"), {
                                  events: {
                                      onStateChange: function (t) {
                                          0 == t.data && n.next();
                                      },
                                  },
                              }))
                            : "vimeo" === e &&
                              void 0 !== Vimeo &&
                              Vimeo &&
                              ((i = new Vimeo.Player(o)),
                              i.on("ended", function () {
                                  n.next();
                              })));
            },
        };
        t(document).on({
            "afterShow.fb": function (t, e, n) {
                e.group.length > 1 && ("youtube" === n.contentSource || "vimeo" === n.contentSource) && o.load(n.contentSource);
            },
        });
    })(jQuery),
    (function (t, e, n) {
        "use strict";
        var o = (function () {
                return (
                    t.requestAnimationFrame ||
                    t.webkitRequestAnimationFrame ||
                    t.mozRequestAnimationFrame ||
                    t.oRequestAnimationFrame ||
                    function (e) {
                        return t.setTimeout(e, 1e3 / 60);
                    }
                );
            })(),
            i = (function () {
                return (
                    t.cancelAnimationFrame ||
                    t.webkitCancelAnimationFrame ||
                    t.mozCancelAnimationFrame ||
                    t.oCancelAnimationFrame ||
                    function (e) {
                        t.clearTimeout(e);
                    }
                );
            })(),
            a = function (e) {
                var n = [];
                (e = e.originalEvent || e || t.e), (e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e]);
                for (var o in e) e[o].pageX ? n.push({ x: e[o].pageX, y: e[o].pageY }) : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
                return n;
            },
            s = function (t, e, n) {
                return e && t ? ("x" === n ? t.x - e.x : "y" === n ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))) : 0;
            },
            r = function (t) {
                if (t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || n.isFunction(t.get(0).onclick) || t.data("selectable")) return !0;
                for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++) if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
                return !1;
            },
            c = function (e) {
                var n = t.getComputedStyle(e)["overflow-y"],
                    o = t.getComputedStyle(e)["overflow-x"],
                    i = ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
                    a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
                return i || a;
            },
            l = function (t) {
                for (var e = !1; ; ) {
                    if ((e = c(t.get(0)))) break;
                    if (((t = t.parent()), !t.length || t.hasClass("fancybox-stage") || t.is("body"))) break;
                }
                return e;
            },
            d = function (t) {
                var e = this;
                (e.instance = t), (e.$bg = t.$refs.bg), (e.$stage = t.$refs.stage), (e.$container = t.$refs.container), e.destroy(), e.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(e, "ontouchstart"));
            };
        (d.prototype.destroy = function () {
            var t = this;
            t.$container.off(".fb.touch"), n(e).off(".fb.touch"), t.requestId && (i(t.requestId), (t.requestId = null)), t.tapped && (clearTimeout(t.tapped), (t.tapped = null));
        }),
            (d.prototype.ontouchstart = function (o) {
                var i = this,
                    c = n(o.target),
                    d = i.instance,
                    u = d.current,
                    f = u.$slide,
                    p = u.$content,
                    h = "touchstart" == o.type;
                if (
                    (h && i.$container.off("mousedown.fb.touch"),
                    (!o.originalEvent || 2 != o.originalEvent.button) && f.length && c.length && !r(c) && !r(c.parent()) && (c.is("img") || !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
                ) {
                    if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated")) return o.stopPropagation(), void o.preventDefault();
                    (i.realPoints = i.startPoints = a(o)),
                        i.startPoints.length &&
                            (u.touch && o.stopPropagation(),
                            (i.startEvent = o),
                            (i.canTap = !0),
                            (i.$target = c),
                            (i.$content = p),
                            (i.opts = u.opts.touch),
                            (i.isPanning = !1),
                            (i.isSwiping = !1),
                            (i.isZooming = !1),
                            (i.isScrolling = !1),
                            (i.canPan = d.canPan()),
                            (i.startTime = new Date().getTime()),
                            (i.distanceX = i.distanceY = i.distance = 0),
                            (i.canvasWidth = Math.round(f[0].clientWidth)),
                            (i.canvasHeight = Math.round(f[0].clientHeight)),
                            (i.contentLastPos = null),
                            (i.contentStartPos = n.fancybox.getTranslate(i.$content) || { top: 0, left: 0 }),
                            (i.sliderStartPos = n.fancybox.getTranslate(f)),
                            (i.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
                            (i.sliderStartPos.top -= i.stagePos.top),
                            (i.sliderStartPos.left -= i.stagePos.left),
                            (i.contentStartPos.top -= i.stagePos.top),
                            (i.contentStartPos.left -= i.stagePos.left),
                            n(e)
                                .off(".fb.touch")
                                .on(h ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", n.proxy(i, "ontouchend"))
                                .on(h ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(i, "ontouchmove")),
                            n.fancybox.isMobile && e.addEventListener("scroll", i.onscroll, !0),
                            (((i.opts || i.canPan) && (c.is(i.$stage) || i.$stage.find(c).length)) || (c.is(".fancybox-image") && o.preventDefault(), n.fancybox.isMobile && c.parents(".fancybox-caption").length)) &&
                                ((i.isScrollable = l(c) || l(c.parent())),
                                (n.fancybox.isMobile && i.isScrollable) || o.preventDefault(),
                                (1 === i.startPoints.length || u.hasError) && (i.canPan ? (n.fancybox.stop(i.$content), (i.isPanning = !0)) : (i.isSwiping = !0), i.$container.addClass("fancybox-is-grabbing")),
                                2 === i.startPoints.length &&
                                    "image" === u.type &&
                                    (u.isLoaded || u.$ghost) &&
                                    ((i.canTap = !1),
                                    (i.isSwiping = !1),
                                    (i.isPanning = !1),
                                    (i.isZooming = !0),
                                    n.fancybox.stop(i.$content),
                                    (i.centerPointStartX = 0.5 * (i.startPoints[0].x + i.startPoints[1].x) - n(t).scrollLeft()),
                                    (i.centerPointStartY = 0.5 * (i.startPoints[0].y + i.startPoints[1].y) - n(t).scrollTop()),
                                    (i.percentageOfImageAtPinchPointX = (i.centerPointStartX - i.contentStartPos.left) / i.contentStartPos.width),
                                    (i.percentageOfImageAtPinchPointY = (i.centerPointStartY - i.contentStartPos.top) / i.contentStartPos.height),
                                    (i.startDistanceBetweenFingers = s(i.startPoints[0], i.startPoints[1])))));
                }
            }),
            (d.prototype.onscroll = function (t) {
                var n = this;
                (n.isScrolling = !0), e.removeEventListener("scroll", n.onscroll, !0);
            }),
            (d.prototype.ontouchmove = function (t) {
                var e = this;
                return void 0 !== t.originalEvent.buttons && 0 === t.originalEvent.buttons
                    ? void e.ontouchend(t)
                    : e.isScrolling
                    ? void (e.canTap = !1)
                    : ((e.newPoints = a(t)),
                      void (
                          (e.opts || e.canPan) &&
                          e.newPoints.length &&
                          e.newPoints.length &&
                          ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
                          (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
                          (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
                          (e.distance = s(e.newPoints[0], e.startPoints[0])),
                          e.distance > 0 && (e.isSwiping ? e.onSwipe(t) : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()))
                      ));
            }),
            (d.prototype.onSwipe = function (e) {
                var a,
                    s = this,
                    r = s.instance,
                    c = s.isSwiping,
                    l = s.sliderStartPos.left || 0;
                if (!0 !== c)
                    "x" == c &&
                        (s.distanceX > 0 && (s.instance.group.length < 2 || (0 === s.instance.current.index && !s.instance.current.opts.loop))
                            ? (l += Math.pow(s.distanceX, 0.8))
                            : s.distanceX < 0 && (s.instance.group.length < 2 || (s.instance.current.index === s.instance.group.length - 1 && !s.instance.current.opts.loop))
                            ? (l -= Math.pow(-s.distanceX, 0.8))
                            : (l += s.distanceX)),
                        (s.sliderLastPos = { top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY, left: l }),
                        s.requestId && (i(s.requestId), (s.requestId = null)),
                        (s.requestId = o(function () {
                            s.sliderLastPos &&
                                (n.each(s.instance.slides, function (t, e) {
                                    var o = e.pos - s.instance.currPos;
                                    n.fancybox.setTranslate(e.$slide, { top: s.sliderLastPos.top, left: s.sliderLastPos.left + o * s.canvasWidth + o * e.opts.gutter });
                                }),
                                s.$container.addClass("fancybox-is-sliding"));
                        }));
                else if (Math.abs(s.distance) > 10) {
                    if (
                        ((s.canTap = !1),
                        r.group.length < 2 && s.opts.vertical
                            ? (s.isSwiping = "y")
                            : r.isDragging || !1 === s.opts.vertical || ("auto" === s.opts.vertical && n(t).width() > 800)
                            ? (s.isSwiping = "x")
                            : ((a = Math.abs((180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI)), (s.isSwiping = a > 45 && a < 135 ? "y" : "x")),
                        "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
                    )
                        return void (s.isScrolling = !0);
                    (r.isDragging = s.isSwiping),
                        (s.startPoints = s.newPoints),
                        n.each(r.slides, function (t, e) {
                            var o, i;
                            n.fancybox.stop(e.$slide),
                                (o = n.fancybox.getTranslate(e.$slide)),
                                (i = n.fancybox.getTranslate(r.$refs.stage)),
                                e.$slide
                                    .css({ transform: "", opacity: "", "transition-duration": "" })
                                    .removeClass("fancybox-animated")
                                    .removeClass(function (t, e) {
                                        return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                                    }),
                                e.pos === r.current.pos && ((s.sliderStartPos.top = o.top - i.top), (s.sliderStartPos.left = o.left - i.left)),
                                n.fancybox.setTranslate(e.$slide, { top: o.top - i.top, left: o.left - i.left });
                        }),
                        r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
                }
            }),
            (d.prototype.onPan = function () {
                var t = this;
                if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5)) return void (t.startPoints = t.newPoints);
                (t.canTap = !1),
                    (t.contentLastPos = t.limitMovement()),
                    t.requestId && i(t.requestId),
                    (t.requestId = o(function () {
                        n.fancybox.setTranslate(t.$content, t.contentLastPos);
                    }));
            }),
            (d.prototype.limitMovement = function () {
                var t,
                    e,
                    n,
                    o,
                    i,
                    a,
                    s = this,
                    r = s.canvasWidth,
                    c = s.canvasHeight,
                    l = s.distanceX,
                    d = s.distanceY,
                    u = s.contentStartPos,
                    f = u.left,
                    p = u.top,
                    h = u.width,
                    g = u.height;
                return (
                    (i = h > r ? f + l : f),
                    (a = p + d),
                    (t = Math.max(0, 0.5 * r - 0.5 * h)),
                    (e = Math.max(0, 0.5 * c - 0.5 * g)),
                    (n = Math.min(r - h, 0.5 * r - 0.5 * h)),
                    (o = Math.min(c - g, 0.5 * c - 0.5 * g)),
                    l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, 0.8) || 0),
                    l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, 0.8) || 0),
                    d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, 0.8) || 0),
                    d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, 0.8) || 0),
                    { top: a, left: i }
                );
            }),
            (d.prototype.limitPosition = function (t, e, n, o) {
                var i = this,
                    a = i.canvasWidth,
                    s = i.canvasHeight;
                return n > a ? ((t = t > 0 ? 0 : t), (t = t < a - n ? a - n : t)) : (t = Math.max(0, a / 2 - n / 2)), o > s ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e)) : (e = Math.max(0, s / 2 - o / 2)), { top: e, left: t };
            }),
            (d.prototype.onZoom = function () {
                var e = this,
                    a = e.contentStartPos,
                    r = a.width,
                    c = a.height,
                    l = a.left,
                    d = a.top,
                    u = s(e.newPoints[0], e.newPoints[1]),
                    f = u / e.startDistanceBetweenFingers,
                    p = Math.floor(r * f),
                    h = Math.floor(c * f),
                    g = (r - p) * e.percentageOfImageAtPinchPointX,
                    b = (c - h) * e.percentageOfImageAtPinchPointY,
                    m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
                    v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
                    y = m - e.centerPointStartX,
                    x = v - e.centerPointStartY,
                    w = l + (g + y),
                    $ = d + (b + x),
                    S = { top: $, left: w, scaleX: f, scaleY: f };
                (e.canTap = !1),
                    (e.newWidth = p),
                    (e.newHeight = h),
                    (e.contentLastPos = S),
                    e.requestId && i(e.requestId),
                    (e.requestId = o(function () {
                        n.fancybox.setTranslate(e.$content, e.contentLastPos);
                    }));
            }),
            (d.prototype.ontouchend = function (t) {
                var o = this,
                    s = o.isSwiping,
                    r = o.isPanning,
                    c = o.isZooming,
                    l = o.isScrolling;
                if (
                    ((o.endPoints = a(t)),
                    (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
                    o.$container.removeClass("fancybox-is-grabbing"),
                    n(e).off(".fb.touch"),
                    e.removeEventListener("scroll", o.onscroll, !0),
                    o.requestId && (i(o.requestId), (o.requestId = null)),
                    (o.isSwiping = !1),
                    (o.isPanning = !1),
                    (o.isZooming = !1),
                    (o.isScrolling = !1),
                    (o.instance.isDragging = !1),
                    o.canTap)
                )
                    return o.onTap(t);
                (o.speed = 100), (o.velocityX = (o.distanceX / o.dMs) * 0.5), (o.velocityY = (o.distanceY / o.dMs) * 0.5), r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
            }),
            (d.prototype.endSwiping = function (t, e) {
                var o = this,
                    i = !1,
                    a = o.instance.group.length,
                    s = Math.abs(o.distanceX),
                    r = "x" == t && a > 1 && ((o.dMs > 130 && s > 10) || s > 50);
                (o.sliderLastPos = null),
                    "y" == t && !e && Math.abs(o.distanceY) > 50
                        ? (n.fancybox.animate(o.instance.current.$slide, { top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY, opacity: 0 }, 200), (i = o.instance.close(!0, 250)))
                        : r && o.distanceX > 0
                        ? (i = o.instance.previous(300))
                        : r && o.distanceX < 0 && (i = o.instance.next(300)),
                    !1 !== i || ("x" != t && "y" != t) || o.instance.centerSlide(200),
                    o.$container.removeClass("fancybox-is-sliding");
            }),
            (d.prototype.endPanning = function () {
                var t,
                    e,
                    o,
                    i = this;
                i.contentLastPos &&
                    (!1 === i.opts.momentum || i.dMs > 350 ? ((t = i.contentLastPos.left), (e = i.contentLastPos.top)) : ((t = i.contentLastPos.left + 500 * i.velocityX), (e = i.contentLastPos.top + 500 * i.velocityY)),
                    (o = i.limitPosition(t, e, i.contentStartPos.width, i.contentStartPos.height)),
                    (o.width = i.contentStartPos.width),
                    (o.height = i.contentStartPos.height),
                    n.fancybox.animate(i.$content, o, 366));
            }),
            (d.prototype.endZooming = function () {
                var t,
                    e,
                    o,
                    i,
                    a = this,
                    s = a.instance.current,
                    r = a.newWidth,
                    c = a.newHeight;
                a.contentLastPos &&
                    ((t = a.contentLastPos.left),
                    (e = a.contentLastPos.top),
                    (i = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }),
                    n.fancybox.setTranslate(a.$content, i),
                    r < a.canvasWidth && c < a.canvasHeight
                        ? a.instance.scaleToFit(150)
                        : r > s.width || c > s.height
                        ? a.instance.scaleToActual(a.centerPointStartX, a.centerPointStartY, 150)
                        : ((o = a.limitPosition(t, e, r, c)), n.fancybox.animate(a.$content, o, 150)));
            }),
            (d.prototype.onTap = function (e) {
                var o,
                    i = this,
                    s = n(e.target),
                    r = i.instance,
                    c = r.current,
                    l = (e && a(e)) || i.startPoints,
                    d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
                    u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
                    f = function (t) {
                        var o = c.opts[t];
                        if ((n.isFunction(o) && (o = o.apply(r, [c, e])), o))
                            switch (o) {
                                case "close":
                                    r.close(i.startEvent);
                                    break;
                                case "toggleControls":
                                    r.toggleControls();
                                    break;
                                case "next":
                                    r.next();
                                    break;
                                case "nextOrClose":
                                    r.group.length > 1 ? r.next() : r.close(i.startEvent);
                                    break;
                                case "zoom":
                                    "image" == c.type && (c.isLoaded || c.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(d, u) : r.group.length < 2 && r.close(i.startEvent));
                            }
                    };
                if ((!e.originalEvent || 2 != e.originalEvent.button) && (s.is("img") || !(d > s[0].clientWidth + s.offset().left))) {
                    if (s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) o = "Outside";
                    else if (s.is(".fancybox-slide")) o = "Slide";
                    else {
                        if (!r.current.$content || !r.current.$content.find(s).addBack().filter(s).length) return;
                        o = "Content";
                    }
                    if (i.tapped) {
                        if ((clearTimeout(i.tapped), (i.tapped = null), Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)) return this;
                        f("dblclick" + o);
                    } else
                        (i.tapX = d),
                            (i.tapY = u),
                            c.opts["dblclick" + o] && c.opts["dblclick" + o] !== c.opts["click" + o]
                                ? (i.tapped = setTimeout(function () {
                                      (i.tapped = null), r.isAnimating || f("click" + o);
                                  }, 500))
                                : f("click" + o);
                    return this;
                }
            }),
            n(e)
                .on("onActivate.fb", function (t, e) {
                    e && !e.Guestures && (e.Guestures = new d(e));
                })
                .on("beforeClose.fb", function (t, e) {
                    e && e.Guestures && e.Guestures.destroy();
                });
    })(window, document, jQuery),
    (function (t, e) {
        "use strict";
        e.extend(!0, e.fancybox.defaults, {
            btnTpl: {
                slideShow:
                    '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
            },
            slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
        });
        var n = function (t) {
            (this.instance = t), this.init();
        };
        e.extend(n.prototype, {
            timer: null,
            isActive: !1,
            $button: null,
            init: function () {
                var t = this,
                    n = t.instance,
                    o = n.group[n.currIndex].opts.slideShow;
                (t.$button = n.$refs.toolbar.find("[data-fancybox-play]").on("click", function () {
                    t.toggle();
                })),
                    n.group.length < 2 || !o ? t.$button.hide() : o.progress && (t.$progress = e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner));
            },
            set: function (t) {
                var n = this,
                    o = n.instance,
                    i = o.current;
                i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1)
                    ? n.isActive &&
                      "video" !== i.contentType &&
                      (n.$progress && e.fancybox.animate(n.$progress.show(), { scaleX: 1 }, i.opts.slideShow.speed),
                      (n.timer = setTimeout(function () {
                          o.current.opts.loop || o.current.index != o.group.length - 1 ? o.next() : o.jumpTo(0);
                      }, i.opts.slideShow.speed)))
                    : (n.stop(), (o.idleSecondsCounter = 0), o.showControls());
            },
            clear: function () {
                var t = this;
                clearTimeout(t.timer), (t.timer = null), t.$progress && t.$progress.removeAttr("style").hide();
            },
            start: function () {
                var t = this,
                    e = t.instance.current;
                e &&
                    (t.$button
                        .attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP)
                        .removeClass("fancybox-button--play")
                        .addClass("fancybox-button--pause"),
                    (t.isActive = !0),
                    e.isComplete && t.set(!0),
                    t.instance.trigger("onSlideShowChange", !0));
            },
            stop: function () {
                var t = this,
                    e = t.instance.current;
                t.clear(),
                    t.$button
                        .attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START)
                        .removeClass("fancybox-button--pause")
                        .addClass("fancybox-button--play"),
                    (t.isActive = !1),
                    t.instance.trigger("onSlideShowChange", !1),
                    t.$progress && t.$progress.removeAttr("style").hide();
            },
            toggle: function () {
                var t = this;
                t.isActive ? t.stop() : t.start();
            },
        }),
            e(t).on({
                "onInit.fb": function (t, e) {
                    e && !e.SlideShow && (e.SlideShow = new n(e));
                },
                "beforeShow.fb": function (t, e, n, o) {
                    var i = e && e.SlideShow;
                    o ? i && n.opts.slideShow.autoStart && i.start() : i && i.isActive && i.clear();
                },
                "afterShow.fb": function (t, e, n) {
                    var o = e && e.SlideShow;
                    o && o.isActive && o.set();
                },
                "afterKeydown.fb": function (n, o, i, a, s) {
                    var r = o && o.SlideShow;
                    !r || !i.opts.slideShow || (80 !== s && 32 !== s) || e(t.activeElement).is("button,a,input") || (a.preventDefault(), r.toggle());
                },
                "beforeClose.fb onDeactivate.fb": function (t, e) {
                    var n = e && e.SlideShow;
                    n && n.stop();
                },
            }),
            e(t).on("visibilitychange", function () {
                var n = e.fancybox.getInstance(),
                    o = n && n.SlideShow;
                o && o.isActive && (t.hidden ? o.clear() : o.set());
            });
    })(document, jQuery),
    (function (t, e) {
        "use strict";
        var n = (function () {
            for (
                var e = [
                        ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
                        ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
                        ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
                        ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
                        ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"],
                    ],
                    n = {},
                    o = 0;
                o < e.length;
                o++
            ) {
                var i = e[o];
                if (i && i[1] in t) {
                    for (var a = 0; a < i.length; a++) n[e[0][a]] = i[a];
                    return n;
                }
            }
            return !1;
        })();
        if (n) {
            var o = {
                request: function (e) {
                    (e = e || t.documentElement), e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
                },
                exit: function () {
                    t[n.exitFullscreen]();
                },
                toggle: function (e) {
                    (e = e || t.documentElement), this.isFullscreen() ? this.exit() : this.request(e);
                },
                isFullscreen: function () {
                    return Boolean(t[n.fullscreenElement]);
                },
                enabled: function () {
                    return Boolean(t[n.fullscreenEnabled]);
                },
            };
            e.extend(!0, e.fancybox.defaults, {
                btnTpl: {
                    fullScreen:
                        '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
                },
                fullScreen: { autoStart: !1 },
            }),
                e(t).on(n.fullscreenchange, function () {
                    var t = o.isFullscreen(),
                        n = e.fancybox.getInstance();
                    n &&
                        (n.current && "image" === n.current.type && n.isAnimating && ((n.isAnimating = !1), n.update(!0, !0, 0), n.isComplete || n.complete()),
                        n.trigger("onFullscreenChange", t),
                        n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
                        n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !t).toggleClass("fancybox-button--fsexit", t));
                });
        }
        e(t).on({
            "onInit.fb": function (t, e) {
                var i;
                if (!n) return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
                e && e.group[e.currIndex].opts.fullScreen
                    ? ((i = e.$refs.container),
                      i.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (t) {
                          t.stopPropagation(), t.preventDefault(), o.toggle();
                      }),
                      e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && o.request(),
                      (e.FullScreen = o))
                    : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
            },
            "afterKeydown.fb": function (t, e, n, o, i) {
                e && e.FullScreen && 70 === i && (o.preventDefault(), e.FullScreen.toggle());
            },
            "beforeClose.fb": function (t, e) {
                e && e.FullScreen && e.$refs.container.hasClass("fancybox-is-fullscreen") && o.exit();
            },
        });
    })(document, jQuery),
    (function (t, e) {
        "use strict";
        var n = "fancybox-thumbs";
        e.fancybox.defaults = e.extend(
            !0,
            {
                btnTpl: {
                    thumbs:
                        '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
                },
                thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
            },
            e.fancybox.defaults
        );
        var o = function (t) {
            this.init(t);
        };
        e.extend(o.prototype, {
            $button: null,
            $grid: null,
            $list: null,
            isVisible: !1,
            isActive: !1,
            init: function (t) {
                var e = this,
                    n = t.group,
                    o = 0;
                (e.instance = t), (e.opts = n[t.currIndex].opts.thumbs), (t.Thumbs = e), (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]"));
                for (var i = 0, a = n.length; i < a && (n[i].thumb && o++, !(o > 1)); i++);
                o > 1 && e.opts
                    ? (e.$button.removeAttr("style").on("click", function () {
                          e.toggle();
                      }),
                      (e.isActive = !0))
                    : e.$button.hide();
            },
            create: function () {
                var t,
                    o = this,
                    i = o.instance,
                    a = o.opts.parentEl,
                    s = [];
                o.$grid ||
                    ((o.$grid = e('<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>').appendTo(i.$refs.container.find(a).addBack().filter(a))),
                    o.$grid.on("click", "a", function () {
                        i.jumpTo(e(this).attr("data-index"));
                    })),
                    o.$list || (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
                    e.each(i.group, function (e, n) {
                        (t = n.thumb),
                            t || "image" !== n.type || (t = n.src),
                            s.push('<a href="javascript:;" tabindex="0" data-index="' + e + '"' + (t && t.length ? ' style="background-image:url(' + t + ')"' : 'class="fancybox-thumbs-missing"') + "></a>");
                    }),
                    (o.$list[0].innerHTML = s.join("")),
                    "x" === o.opts.axis && o.$list.width(parseInt(o.$grid.css("padding-right"), 10) + i.group.length * o.$list.children().eq(0).outerWidth(!0));
            },
            focus: function (t) {
                var e,
                    n,
                    o = this,
                    i = o.$list,
                    a = o.$grid;
                o.instance.current &&
                    ((e = i
                        .children()
                        .removeClass("fancybox-thumbs-active")
                        .filter('[data-index="' + o.instance.current.index + '"]')
                        .addClass("fancybox-thumbs-active")),
                    (n = e.position()),
                    "y" === o.opts.axis && (n.top < 0 || n.top > i.height() - e.outerHeight())
                        ? i.stop().animate({ scrollTop: i.scrollTop() + n.top }, t)
                        : "x" === o.opts.axis && (n.left < a.scrollLeft() || n.left > a.scrollLeft() + (a.width() - e.outerWidth())) && i.parent().stop().animate({ scrollLeft: n.left }, t));
            },
            update: function () {
                var t = this;
                t.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible),
                    t.isVisible ? (t.$grid || t.create(), t.instance.trigger("onThumbsShow"), t.focus(0)) : t.$grid && t.instance.trigger("onThumbsHide"),
                    t.instance.update();
            },
            hide: function () {
                (this.isVisible = !1), this.update();
            },
            show: function () {
                (this.isVisible = !0), this.update();
            },
            toggle: function () {
                (this.isVisible = !this.isVisible), this.update();
            },
        }),
            e(t).on({
                "onInit.fb": function (t, e) {
                    var n;
                    e && !e.Thumbs && ((n = new o(e)), n.isActive && !0 === n.opts.autoStart && n.show());
                },
                "beforeShow.fb": function (t, e, n, o) {
                    var i = e && e.Thumbs;
                    i && i.isVisible && i.focus(o ? 0 : 250);
                },
                "afterKeydown.fb": function (t, e, n, o, i) {
                    var a = e && e.Thumbs;
                    a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
                },
                "beforeClose.fb": function (t, e) {
                    var n = e && e.Thumbs;
                    n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
                },
            });
    })(document, jQuery),
    (function (t, e) {
        "use strict";
        function n(t) {
            var e = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;", "`": "&#x60;", "=": "&#x3D;" };
            return String(t).replace(/[&<>"'`=\/]/g, function (t) {
                return e[t];
            });
        }
        e.extend(!0, e.fancybox.defaults, {
            btnTpl: {
                share:
                    '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
            },
            share: {
                url: function (t, e) {
                    return (!t.currentHash && "inline" !== e.type && "html" !== e.type && (e.origSrc || e.src)) || window.location;
                },
                tpl:
                    '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
            },
        }),
            e(t).on("click", "[data-fancybox-share]", function () {
                var t,
                    o,
                    i = e.fancybox.getInstance(),
                    a = i.current || null;
                a &&
                    ("function" === e.type(a.opts.share.url) && (t = a.opts.share.url.apply(a, [i, a])),
                    (o = a.opts.share.tpl
                        .replace(/\{\{media\}\}/g, "image" === a.type ? encodeURIComponent(a.src) : "")
                        .replace(/\{\{url\}\}/g, encodeURIComponent(t))
                        .replace(/\{\{url_raw\}\}/g, n(t))
                        .replace(/\{\{descr\}\}/g, i.$caption ? encodeURIComponent(i.$caption.text()) : "")),
                    e.fancybox.open({
                        src: i.translate(i, o),
                        type: "html",
                        opts: {
                            touch: !1,
                            animationEffect: !1,
                            afterLoad: function (t, e) {
                                i.$refs.container.one("beforeClose.fb", function () {
                                    t.close(null, 0);
                                }),
                                    e.$content.find(".fancybox-share__button").click(function () {
                                        return window.open(this.href, "Share", "width=550, height=450"), !1;
                                    });
                            },
                            mobile: { autoFocus: !1 },
                        },
                    }));
            });
    })(document, jQuery),
    (function (t, e, n) {
        "use strict";
        function o() {
            var e = t.location.hash.substr(1),
                n = e.split("-"),
                o = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1,
                i = n.join("-");
            return { hash: e, index: o < 1 ? 1 : o, gallery: i };
        }
        function i(t) {
            "" !== t.gallery &&
                n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
                    .eq(t.index - 1)
                    .focus()
                    .trigger("click.fb-start");
        }
        function a(t) {
            var e, n;
            return !!t && ((e = t.current ? t.current.opts : t.opts), "" !== (n = e.hash || (e.$orig ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger") : "")) && n);
        }
        n.escapeSelector ||
            (n.escapeSelector = function (t) {
                return (t + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (t, e) {
                    return e ? ("\0" === t ? "Ã¯Â¿Â½" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " ") : "\\" + t;
                });
            }),
            n(function () {
                !1 !== n.fancybox.defaults.hash &&
                    (n(e).on({
                        "onInit.fb": function (t, e) {
                            var n, i;
                            !1 !== e.group[e.currIndex].opts.hash && ((n = o()), (i = a(e)) && n.gallery && i == n.gallery && (e.currIndex = n.index - 1));
                        },
                        "beforeShow.fb": function (n, o, i, s) {
                            var r;
                            i &&
                                !1 !== i.opts.hash &&
                                (r = a(o)) &&
                                ((o.currentHash = r + (o.group.length > 1 ? "-" + (i.index + 1) : "")),
                                t.location.hash !== "#" + o.currentHash &&
                                    (s && !o.origHash && (o.origHash = t.location.hash),
                                    o.hashTimer && clearTimeout(o.hashTimer),
                                    (o.hashTimer = setTimeout(function () {
                                        "replaceState" in t.history
                                            ? (t.history[s ? "pushState" : "replaceState"]({}, e.title, t.location.pathname + t.location.search + "#" + o.currentHash), s && (o.hasCreatedHistory = !0))
                                            : (t.location.hash = o.currentHash),
                                            (o.hashTimer = null);
                                    }, 300))));
                        },
                        "beforeClose.fb": function (n, o, i) {
                            i &&
                                !1 !== i.opts.hash &&
                                (clearTimeout(o.hashTimer),
                                o.currentHash && o.hasCreatedHistory
                                    ? t.history.back()
                                    : o.currentHash && ("replaceState" in t.history ? t.history.replaceState({}, e.title, t.location.pathname + t.location.search + (o.origHash || "")) : (t.location.hash = o.origHash)),
                                (o.currentHash = null));
                        },
                    }),
                    n(t).on("hashchange.fb", function () {
                        var t = o(),
                            e = null;
                        n.each(n(".fancybox-container").get().reverse(), function (t, o) {
                            var i = n(o).data("FancyBox");
                            if (i && i.currentHash) return (e = i), !1;
                        }),
                            e ? e.currentHash === t.gallery + "-" + t.index || (1 === t.index && e.currentHash == t.gallery) || ((e.currentHash = null), e.close()) : "" !== t.gallery && i(t);
                    }),
                    setTimeout(function () {
                        n.fancybox.getInstance() || i(o());
                    }, 50));
            });
    })(window, document, jQuery),
    (function (t, e) {
        "use strict";
        var n = new Date().getTime();
        e(t).on({
            "onInit.fb": function (t, e, o) {
                e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function (t) {
                    var o = e.current,
                        i = new Date().getTime();
                    e.group.length < 2 ||
                        !1 === o.opts.wheel ||
                        ("auto" === o.opts.wheel && "image" !== o.type) ||
                        (t.preventDefault(),
                        t.stopPropagation(),
                        o.$slide.hasClass("fancybox-animated") || ((t = t.originalEvent || t), i - n < 250 || ((n = i), e[(-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0 ? "next" : "previous"]())));
                });
            },
        });
    })(document, jQuery);
/*!
 * Flickity PACKAGED v2.1.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2018 Metafizzy
 */
/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */
/* jshint browser: true, strict: true, undef: true, unused: true */
(function (window, factory) {
    /*jshint strict: false */ /* globals define, module, require */
    if (typeof define == "function" && define.amd) {
        define("jquery-bridget/jquery-bridget", ["jquery"], function (jQuery) {
            return factory(window, jQuery);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("jquery"));
    } else {
        window.jQueryBridget = factory(window, window.jQuery);
    }
})(window, function factory(window, jQuery) {
    "use strict";
    var arraySlice = Array.prototype.slice;
    var console = window.console;
    var logError =
        typeof console == "undefined"
            ? function () {}
            : function (message) {
                  console.error(message);
              };
    function jQueryBridget(namespace, PluginClass, $) {
        $ = $ || jQuery || window.jQuery;
        if (!$) {
            return;
        }
        if (!PluginClass.prototype.option) {
            PluginClass.prototype.option = function (opts) {
                if (!$.isPlainObject(opts)) {
                    return;
                }
                this.options = $.extend(true, this.options, opts);
            };
        }
        $.fn[namespace] = function (arg0 /*, arg1 */) {
            if (typeof arg0 == "string") {
                var args = arraySlice.call(arguments, 1);
                return methodCall(this, arg0, args);
            }
            plainCall(this, arg0);
            return this;
        };
        function methodCall($elems, methodName, args) {
            var returnValue;
            var pluginMethodStr = "$()." + namespace + '("' + methodName + '")';
            $elems.each(function (i, elem) {
                var instance = $.data(elem, namespace);
                if (!instance) {
                    logError(namespace + " not initialized. Cannot call methods, i.e. " + pluginMethodStr);
                    return;
                }
                var method = instance[methodName];
                if (!method || methodName.charAt(0) == "_") {
                    logError(pluginMethodStr + " is not a valid method");
                    return;
                }
                var value = method.apply(instance, args);
                returnValue = returnValue === undefined ? value : returnValue;
            });
            return returnValue !== undefined ? returnValue : $elems;
        }
        function plainCall($elems, options) {
            $elems.each(function (i, elem) {
                var instance = $.data(elem, namespace);
                if (instance) {
                    instance.option(options);
                    instance._init();
                } else {
                    instance = new PluginClass(elem, options);
                    $.data(elem, namespace, instance);
                }
            });
        }
        updateJQuery($);
    }
    function updateJQuery($) {
        if (!$ || ($ && $.bridget)) {
            return;
        }
        $.bridget = jQueryBridget;
    }
    updateJQuery(jQuery || window.jQuery);
    return jQueryBridget;
});
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */
/* jshint unused: true, undef: true, strict: true */
(function (global, factory) {
    /* jshint strict: false */ /* globals define, module, window */
    if (typeof define == "function" && define.amd) {
        define("ev-emitter/ev-emitter", factory);
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
    } else {
        global.EvEmitter = factory();
    }
})(typeof window != "undefined" ? window : this, function () {
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function (eventName, listener) {
        if (!eventName || !listener) {
            return;
        }
        var events = (this._events = this._events || {});
        var listeners = (events[eventName] = events[eventName] || []);
        if (listeners.indexOf(listener) == -1) {
            listeners.push(listener);
        }
        return this;
    };
    proto.once = function (eventName, listener) {
        if (!eventName || !listener) {
            return;
        }
        this.on(eventName, listener);
        var onceEvents = (this._onceEvents = this._onceEvents || {});
        var onceListeners = (onceEvents[eventName] = onceEvents[eventName] || {});
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function (eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
            return;
        }
        var index = listeners.indexOf(listener);
        if (index != -1) {
            listeners.splice(index, 1);
        }
        return this;
    };
    proto.emitEvent = function (eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
            return;
        }
        listeners = listeners.slice(0);
        args = args || [];
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                this.off(eventName, listener);
                delete onceListeners[listener];
            }
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function () {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */
/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */
(function (window, factory) {
    /* jshint strict: false */ /* globals define, module */
    if (typeof define == "function" && define.amd) {
        define("get-size/get-size", factory);
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
    } else {
        window.getSize = factory();
    }
})(window, function factory() {
    "use strict";
    function getStyleSize(value) {
        var num = parseFloat(value);
        var isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError =
        typeof console == "undefined"
            ? noop
            : function (message) {
                  console.error(message);
              };
    var measurements = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0,
        };
        for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    /**
     * getStyle, get style of element, check for Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
     */
    function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) {
            logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? " + "See https://bit.ly/getsizebug1");
        }
        return style;
    }
    var isSetup = false;
    var isBoxSizeOuter;
    /**
     * setup
     * check isBoxSizerOuter
     * do on first getSize() rather than on page load for Firefox bug
     */
    function setup() {
        if (isSetup) {
            return;
        }
        isSetup = true;
        /**
         * Chrome & Safari measure the outer-width on style.width on border-box elems
         * IE11 & Firefox<29 measures the inner-width
         */
        var div = document.createElement("div");
        div.style.width = "200px";
        div.style.padding = "1px 2px 3px 4px";
        div.style.borderStyle = "solid";
        div.style.borderWidth = "1px 2px 3px 4px";
        div.style.boxSizing = "border-box";
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    function getSize(elem) {
        setup();
        if (typeof elem == "string") {
            elem = document.querySelector(elem);
        }
        if (!elem || typeof elem != "object" || !elem.nodeType) {
            return;
        }
        var style = getStyle(elem);
        if (style.display == "none") {
            return getZeroSize();
        }
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = (size.isBorderBox = style.boxSizing == "border-box");
        for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
            size.width = styleWidth + (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        }
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
            size.height = styleHeight + (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        }
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */
/*jshint browser: true, strict: true, undef: true, unused: true */
(function (window, factory) {
    /*global define: false, module: false */
    "use strict";
    if (typeof define == "function" && define.amd) {
        define("desandro-matches-selector/matches-selector", factory);
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
    } else {
        window.matchesSelector = factory();
    }
})(window, function factory() {
    "use strict";
    var matchesMethod = (function () {
        var ElemProto = window.Element.prototype;
        if (ElemProto.matches) {
            return "matches";
        }
        if (ElemProto.matchesSelector) {
            return "matchesSelector";
        }
        var prefixes = ["webkit", "moz", "ms", "o"];
        for (var i = 0; i < prefixes.length; i++) {
            var prefix = prefixes[i];
            var method = prefix + "MatchesSelector";
            if (ElemProto[method]) {
                return method;
            }
        }
    })();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */
/*jshint browser: true, undef: true, unused: true, strict: true */
(function (window, factory) {
    /*jshint strict: false */ /*globals define, module, require */
    if (typeof define == "function" && define.amd) {
        define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (matchesSelector) {
            return factory(window, matchesSelector);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("desandro-matches-selector"));
    } else {
        window.fizzyUIUtils = factory(window, window.matchesSelector);
    }
})(window, function factory(window, matchesSelector) {
    var utils = {};
    utils.extend = function (a, b) {
        for (var prop in b) {
            a[prop] = b[prop];
        }
        return a;
    };
    utils.modulo = function (num, div) {
        return ((num % div) + div) % div;
    };
    var arraySlice = Array.prototype.slice;
    utils.makeArray = function (obj) {
        if (Array.isArray(obj)) {
            return obj;
        }
        if (obj === null || obj === undefined) {
            return [];
        }
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) {
            return arraySlice.call(obj);
        }
        return [obj];
    };
    utils.removeFrom = function (ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) {
            ary.splice(index, 1);
        }
    };
    utils.getParent = function (elem, selector) {
        while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) {
                return elem;
            }
        }
    };
    utils.getQueryElement = function (elem) {
        if (typeof elem == "string") {
            return document.querySelector(elem);
        }
        return elem;
    };
    utils.handleEvent = function (event) {
        var method = "on" + event.type;
        if (this[method]) {
            this[method](event);
        }
    };
    utils.filterFindElements = function (elems, selector) {
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function (elem) {
            if (!(elem instanceof HTMLElement)) {
                /*nectar addition*/
                if (jQuery("body.compose-mode").length == 0) {
                    return;
                }
                /*nectar addition end*/
            }
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            if (matchesSelector(elem, selector)) {
                ffElems.push(elem);
            }
            var childElems = elem.querySelectorAll(selector);
            for (var i = 0; i < childElems.length; i++) {
                ffElems.push(childElems[i]);
            }
        });
        return ffElems;
    };
    utils.debounceMethod = function (_class, methodName, threshold) {
        threshold = threshold || 100;
        var method = _class.prototype[methodName];
        var timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function () {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function () {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    utils.docReady = function (callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
            setTimeout(callback);
        } else {
            document.addEventListener("DOMContentLoaded", callback);
        }
    };
    utils.toDashed = function (str) {
        return str
            .replace(/(.)([A-Z])/g, function (match, $1, $2) {
                return $1 + "-" + $2;
            })
            .toLowerCase();
    };
    var console = window.console;
    /**
     * allow user to initialize classes via [data-namespace] or .js-namespace class
     * htmlInit( Widget, 'widgetName' )
     * options are parsed from data-namespace-options
     */
    utils.htmlInit = function (WidgetClass, namespace) {
        utils.docReady(function () {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = "data-" + dashedNamespace;
            var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
            var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + "-options";
            var jQuery = window.jQuery;
            elems.forEach(function (elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    if (console) {
                        console.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error);
                    }
                    return;
                }
                var instance = new WidgetClass(elem, options);
                if (jQuery) {
                    jQuery.data(elem, namespace, instance);
                }
            });
        });
    };
    return utils;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/cell", ["get-size/get-size"], function (getSize) {
            return factory(window, getSize);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("get-size"));
    } else {
        window.Flickity = window.Flickity || {};
        window.Flickity.Cell = factory(window, window.getSize);
    }
})(window, function factory(window, getSize) {
    function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
    }
    var proto = Cell.prototype;
    proto.create = function () {
        this.element.style.position = "absolute";
        this.element.setAttribute("aria-selected", "false");
        this.x = 0;
        this.shift = 0;
    };
    proto.destroy = function () {
        this.element.style.position = "";
        var side = this.parent.originSide;
        this.element.removeAttribute("aria-selected");
        this.element.style[side] = "";
    };
    proto.getSize = function () {
        this.size = getSize(this.element);
    };
    proto.setPosition = function (x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
    };
    proto.updateTarget = proto.setDefaultTarget = function () {
        var marginProperty = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
    };
    proto.renderPosition = function (x) {
        var side = this.parent.originSide;
        this.element.style[side] = this.parent.getPositionValue(x);
    };
    /**
     * @param {Integer} factor - 0, 1, or -1
     **/
    proto.wrapShift = function (shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
    };
    proto.remove = function () {
        this.element.parentNode.removeChild(this.element);
    };
    return Cell;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/slide", factory);
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
    } else {
        window.Flickity = window.Flickity || {};
        window.Flickity.Slide = factory();
    }
})(window, function factory() {
    "use strict";
    function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == "left";
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    var proto = Slide.prototype;
    proto.addCell = function (cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = cell.size[beginMargin];
        }
    };
    proto.updateTarget = function () {
        var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };
    proto.getLastCell = function () {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function () {
        this.changeSelected(true);
    };
    proto.unselect = function () {
        this.changeSelected(false);
    };
    proto.changeSelected = function (isSelected) {
        var classMethod = isSelected ? "add" : "remove";
        this.cells.forEach(function (cell) {
            cell.element.classList[classMethod]("is-selected");
            cell.element.setAttribute("aria-selected", isSelected.toString());
        });
    };
    proto.getCellElements = function () {
        return this.cells.map(function (cell) {
            return cell.element;
        });
    };
    return Slide;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (utils) {
            return factory(window, utils);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("fizzy-ui-utils"));
    } else {
        window.Flickity = window.Flickity || {};
        window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
    }
})(window, function factory(window, utils) {
    var proto = {};
    proto.startAnimation = function () {
        if (this.isAnimating) {
            return;
        }
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function () {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
                _this.animate();
            });
        }
    };
    proto.positionSlider = function () {
        var x = this.x;
        if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x = x - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        x = x + this.cursorPosition;
        x = this.options.rightToLeft ? -x : x;
        var value = this.getPositionValue(x);
        this.slider.style.transform = this.isAnimating ? "translate3d(" + value + ",0,0)" : "translateX(" + value + ")";
        var firstSlide = this.slides[0];
        if (firstSlide) {
            var positionX = -this.x - firstSlide.target;
            var progress = positionX / this.slidesWidth;
            this.dispatchEvent("scroll", null, [progress, positionX]);
        }
    };
    proto.setTranslateX = function (x, is3d) {
        x += this.cursorPosition;
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue(x);
        this.slider.style.transform = is3d ? "translate3d(" + translateX + ",0,0)" : "translateX(" + translateX + ")";
    };
    proto.dispatchScrollEvent = function () {
        var firstSlide = this.slides[0];
        if (!firstSlide) {
            return;
        }
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [progress, positionX]);
    };
    proto.positionSliderAtSelected = function () {
        if (!this.cells.length) {
            return;
        }
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function (position) {
        if (this.options.percentPosition) {
            return Math.round((position / this.size.innerWidth) * 10000) * 0.01 + "%";
        } else {
            return Math.round(position) + "px";
        }
    };
    proto.settle = function (previousX) {
        if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
            this.restingFrames++;
        }
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            this.positionSlider();
            this.dispatchEvent("settle", null, [this.selectedIndex]);
        }
    };
    proto.shiftWrapCells = function (x) {
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function (cells, gap, shift) {
        for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
        }
    };
    proto._unshiftCells = function (cells) {
        if (!cells || !cells.length) {
            return;
        }
        for (var i = 0; i < cells.length; i++) {
            cells[i].wrapShift(0);
        }
    };
    proto.integratePhysics = function () {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function (force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function () {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
    };
    proto.getRestingPosition = function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function () {
        if (!this.isDraggable || !this.isPointerDown) {
            return;
        }
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function () {
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) {
            return;
        }
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
            return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
    } else {
        var _Flickity = window.Flickity;
        window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(window, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    var jQuery = window.jQuery;
    var getComputedStyle = window.getComputedStyle;
    var console = window.console;
    function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while (elems.length) {
            toElem.appendChild(elems.shift());
        }
    }
    var GUID = 0;
    var instances = {};
    function Flickity(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) {
                console.error("Bad element for Flickity: " + (queryElement || element));
            }
            return;
        }
        this.element = queryElement;
        if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            instance.option(options);
            return instance;
        }
        if (jQuery) {
            this.$element = jQuery(this.element);
        }
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        cellAlign: "center",
        freeScrollFriction: 0.075, // friction when free-scrolling
        friction: 0.28, // friction when selecting
        namespaceJQueryEvents: true,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true,
    };
    Flickity.createMethods = [];
    var proto = Flickity.prototype;
    utils.extend(proto, EvEmitter.prototype);
    proto._create = function () {
        var id = (this.guid = ++GUID);
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        this.selectedIndex = 0;
        this.restingFrames = 0;
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? "right" : "left";
        /*nectar addition*/
        if (this.$element.hasClass("generate-markup")) {
            this.viewport = document.createElement("div");
            this.viewport.className = "flickity-viewport";
        } else {
            this.viewport = this.$element.find(".flickity-viewport")[0];
            this.slider = this.$element.find(".flickity-slider")[0];
            this.viewport.className = "flickity-viewport";
        }
        this._createSlider();
        /*nectar addition end*/
        if (this.options.resize || this.options.watchCSS) {
            window.addEventListener("resize", this);
        }
        for (var eventName in this.options.on) {
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        Flickity.createMethods.forEach(function (method) {
            this[method]();
        }, this);
        if (this.options.watchCSS) {
            this.watchCSS();
        } else {
            this.activate();
        }
    };
    /**
     * set options
     * @param {Object} opts
     */
    proto.option = function (opts) {
        utils.extend(this.options, opts);
    };
    proto.activate = function () {
        if (this.isActive) {
            return;
        }
        this.isActive = true;
        this.element.classList.add("flickity-enabled");
        if (this.options.rightToLeft) {
            this.element.classList.add("flickity-rtl");
        }
        this.getSize();
        var cellElems = this._filterFindCellElements(this.element.children);
        /* nectar addition */
        if (this.$element.hasClass("generate-markup")) {
            moveElements(cellElems, this.slider);
            this.viewport.appendChild(this.slider);
            this.element.appendChild(this.viewport);
        } else {
        }
        /* nectar addition  end */
        this.reloadCells();
        if (this.options.accessibility) {
            this.element.tabIndex = 0;
            this.element.addEventListener("keydown", this);
        }
        this.emitEvent("activate");
        var index;
        var initialIndex = this.options.initialIndex;
        if (this.isInitActivated) {
            index = this.selectedIndex;
        } else if (initialIndex !== undefined) {
            index = this.cells[initialIndex] ? initialIndex : 0;
        } else {
            index = 0;
        }
        this.select(index, false, true);
        this.isInitActivated = true;
        this.dispatchEvent("ready");
    };
    /* nectar addition */
    proto._createSlider = function () {
        if (this.$element.hasClass("generate-markup")) {
            var slider = document.createElement("div");
            slider.className = "flickity-slider";
            slider.style[this.originSide] = 0;
            this.slider = slider;
        } else {
            this.slider.style[this.originSide] = 0;
        }
    };
    /* nectar addition end */
    proto._filterFindCellElements = function (elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    proto.reloadCells = function () {
        /* nectar addition */
        if (jQuery(this.slider).parent().parent().find(".flickity-page-dots").length > 0) {
            var $that = this;
            setTimeout(function () {
                $that.pageDots.setDots();
            }, 100);
        }
        var slidesArr = [];
        jQuery(this.slider)
            .find("> *")
            .each(function (i) {
                slidesArr[i] = jQuery(this)[0];
            });
        this.cells = this._makeCells(slidesArr);
        /* nectar addition end */
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };
    /**
     * turn elements into Flickity.Cells
     * @param {Array or NodeList or HTMLElement} elems
     * @returns {Array} items - collection of new Flickity Cells
     */
    proto._makeCells = function (elems) {
        var cellElems = this._filterFindCellElements(elems);
        var cells = cellElems.map(function (cellElem) {
            return new Cell(cellElem, this);
        }, this);
        return cells;
    };
    proto.getLastCell = function () {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
    };
    proto.positionCells = function () {
        this._sizeCells(this.cells);
        this._positionCells(0);
    };
    /**
     * position certain cells
     * @param {Integer} index - which cell to start with
     */
    proto._positionCells = function (index) {
        index = index || 0;
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for (var i = index; i < len; i++) {
            var cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        this.slideableWidth = cellX;
        this.updateSlides();
        this._containSlides();
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    /**
     * cell.getSize() on multiple cells
     * @param {Array} cells
     */
    proto._sizeCells = function (cells) {
        cells.forEach(function (cell) {
            cell.getSize();
        });
    };
    proto.updateSlides = function () {
        this.slides = [];
        if (!this.cells.length) {
            return;
        }
        var slide = new Slide(this);
        this.slides.push(slide);
        var isOriginLeft = this.originSide == "left";
        var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function (cell, i) {
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
            if (canCellFit.call(this, i, slideWidth)) {
                slide.addCell(cell);
            } else {
                slide.updateTarget();
                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        }, this);
        slide.updateTarget();
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function () {
        var groupCells = this.options.groupCells;
        if (!groupCells) {
            return function () {
                return false;
            };
        } else if (typeof groupCells == "number") {
            var number = parseInt(groupCells, 10);
            return function (i) {
                return i % number !== 0;
            };
        }
        var percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function (i, slideWidth) {
            return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
    };
    proto._init = proto.reposition = function () {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function () {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var cellAlignShorthands = {
        center: {
            left: 0.5,
            right: 0.5,
        },
        left: {
            left: 0,
            right: 1,
        },
        right: {
            right: 0,
            left: 1,
        },
    };
    proto.setCellAlign = function () {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
    };
    proto.setGallerySize = function () {
        if (this.options.setGallerySize) {
            var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + "px";
        }
    };
    proto._getWrapShiftCells = function () {
        if (!this.options.wrapAround) {
            return;
        }
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        gapX = this.size.innerWidth - this.cursorPosition;
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
    };
    proto._getGapCells = function (gapX, cellIndex, increment) {
        var cells = [];
        while (gapX > 0) {
            var cell = this.cells[cellIndex];
            if (!cell) {
                break;
            }
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    proto._containSlides = function () {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
            return;
        }
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
        var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        var isContentSmaller = contentWidth < this.size.innerWidth;
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        this.slides.forEach(function (slide) {
            if (isContentSmaller) {
                slide.target = contentWidth * this.cellAlign;
            } else {
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            }
        }, this);
    };
    /**
     * emits events via eventEmitter and jQuery events
     * @param {String} type - name of event
     * @param {Event} event - original event
     * @param {Array} args - extra arguments
     */
    proto.dispatchEvent = function (type, event, args) {
        var emitArgs = event ? [event].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            var $event = type;
            if (event) {
                var jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    /**
     * @param {Integer} index - index of the slide
     * @param {Boolean} isWrap - will wrap-around to last/first if at the end
     * @param {Boolean} isInstant - will immediately set position at selected cell
     */
    proto.select = function (index, isWrap, isInstant) {
        if (!this.isActive) {
            return;
        }
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) {
            index = utils.modulo(index, this.slides.length);
        }
        if (!this.slides[index]) {
            return;
        }
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) {
            this.positionSliderAtSelected();
        } else {
            this.startAnimation();
        }
        if (this.options.adaptiveHeight) {
            this.setGallerySize();
        }
        this.dispatchEvent("select", null, [index]);
        if (index != prevIndex) {
            this.dispatchEvent("change", null, [index]);
        }
        this.dispatchEvent("cellSelect");
    };
    proto._wrapSelect = function (index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) {
            return index;
        }
        var wrapIndex = utils.modulo(index, len);
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) {
            index += len;
        } else if (!this.isDragSelect && forewardWrapDelta < delta) {
            index -= len;
        }
        if (index < 0) {
            this.x -= this.slideableWidth;
        } else if (index >= len) {
            this.x += this.slideableWidth;
        }
    };
    proto.previous = function (isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function (isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function () {
        var slide = this.slides[this.selectedIndex];
        if (!slide) {
            return;
        }
        this.unselectSelectedSlide();
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function () {
        if (this.selectedSlide) {
            this.selectedSlide.unselect();
        }
    };
    /**
     * select slide from number or cell element
     * @param {Element or Number} elem
     */
    proto.selectCell = function (value, isWrap, isInstant) {
        var cell = this.queryCell(value);
        if (!cell) {
            return;
        }
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function (cell) {
        for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides[i];
            var index = slide.cells.indexOf(cell);
            if (index != -1) {
                return i;
            }
        }
    };
    /**
     * get Flickity.Cell, given an Element
     * @param {Element} elem
     * @returns {Flickity.Cell} item
     */
    proto.getCell = function (elem) {
        for (var i = 0; i < this.cells.length; i++) {
            var cell = this.cells[i];
            if (cell.element == elem) {
                return cell;
            }
        }
    };
    /**
     * get collection of Flickity.Cells, given Elements
     * @param {Element, Array, NodeList} elems
     * @returns {Array} cells - Flickity.Cells
     */
    proto.getCells = function (elems) {
        elems = utils.makeArray(elems);
        var cells = [];
        elems.forEach(function (elem) {
            var cell = this.getCell(elem);
            if (cell) {
                cells.push(cell);
            }
        }, this);
        return cells;
    };
    /**
     * get cell elements
     * @returns {Array} cellElems
     */
    proto.getCellElements = function () {
        return this.cells.map(function (cell) {
            return cell.element;
        });
    };
    /**
     * get parent cell from an element
     * @param {Element} elem
     * @returns {Flickit.Cell} cell
     */
    proto.getParentCell = function (elem) {
        var cell = this.getCell(elem);
        if (cell) {
            return cell;
        }
        elem = utils.getParent(elem, ".flickity-slider > *");
        return this.getCell(elem);
    };
    /**
     * get cells adjacent to a slide
     * @param {Integer} adjCount - number of adjacent slides
     * @param {Integer} index - index of slide to start
     * @returns {Array} cells - array of Flickity.Cells
     */
    proto.getAdjacentCellElements = function (adjCount, index) {
        if (!adjCount) {
            return this.selectedSlide.getCellElements();
        }
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) {
            return this.getCellElements();
        }
        var cellElems = [];
        for (var i = index - adjCount; i <= index + adjCount; i++) {
            var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) {
                cellElems = cellElems.concat(slide.getCellElements());
            }
        }
        return cellElems;
    };
    /**
     * select slide from number or cell element
     * @param {Element, Selector String, or Number} selector
     */
    proto.queryCell = function (selector) {
        if (typeof selector == "number") {
            return this.cells[selector];
        }
        if (typeof selector == "string") {
            selector = this.element.querySelector(selector);
        }
        return this.getCell(selector);
    };
    proto.uiChange = function () {
        this.emitEvent("uiChange");
    };
    proto.childUIPointerDown = function (event) {
        this.emitEvent("childUIPointerDown", [event]);
    };
    proto.onresize = function () {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, "onresize", 150);
    proto.resize = function () {
        /* nectar addition to check for this.isAnimating for iOS15 fix  */
        console.log(this.isAnimating);
        if (!this.isActive || this.isAnimating) {
            return;
        }
        this.getSize();
        if (this.options.wrapAround) {
            this.x = utils.modulo(this.x, this.slideableWidth);
        }
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent("resize");
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    proto.watchCSS = function () {
        var watchOption = this.options.watchCSS;
        if (!watchOption) {
            return;
        }
        var afterContent = getComputedStyle(this.element, ":after").content;
        if (afterContent.indexOf("flickity") != -1) {
            this.activate();
        } else {
            this.deactivate();
        }
    };
    proto.onkeydown = function (event) {
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) {
            return;
        }
        var handler = Flickity.keyboardHandlers[event.keyCode];
        if (handler) {
            handler.call(this);
        }
    };
    Flickity.keyboardHandlers = {
        37: function () {
            var leftMethod = this.options.rightToLeft ? "next" : "previous";
            this.uiChange();
            this[leftMethod]();
        },
        39: function () {
            var rightMethod = this.options.rightToLeft ? "previous" : "next";
            this.uiChange();
            this[rightMethod]();
        },
    };
    proto.focus = function () {
        var prevScrollY = window.pageYOffset;
        this.element.focus({ preventScroll: true });
        if (window.pageYOffset != prevScrollY && prevScrollY > 10) {
            // nectar addition - iframe fix
            window.scrollTo(window.pageXOffset, prevScrollY);
        }
    };
    proto.deactivate = function () {
        if (!this.isActive) {
            return;
        }
        this.element.classList.remove("flickity-enabled");
        this.element.classList.remove("flickity-rtl");
        this.unselectSelectedSlide();
        this.cells.forEach(function (cell) {
            cell.destroy();
        });
        this.element.removeChild(this.viewport);
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
        }
        this.isActive = false;
        this.emitEvent("deactivate");
    };
    proto.destroy = function () {
        this.deactivate();
        window.removeEventListener("resize", this);
        this.emitEvent("destroy");
        if (jQuery && this.$element) {
            jQuery.removeData(this.element, "flickity");
        }
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    utils.extend(proto, animatePrototype);
    /**
     * get Flickity instance from element
     * @param {Element} elem
     * @returns {Flickity}
     */
    Flickity.data = function (elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
    };
    utils.htmlInit(Flickity, "flickity");
    if (jQuery && jQuery.bridget) {
        jQuery.bridget("flickity", Flickity);
    }
    Flickity.setJQuery = function (jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});
/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */
/*jshint browser: true, undef: true, unused: true, strict: true */
(function (window, factory) {
    /* jshint strict: false */ /*global define, module, require */
    if (typeof define == "function" && define.amd) {
        define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (EvEmitter) {
            return factory(window, EvEmitter);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("ev-emitter"));
    } else {
        window.Unipointer = factory(window, window.EvEmitter);
    }
})(window, function factory(window, EvEmitter) {
    function noop() {}
    function Unipointer() {}
    var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));
    proto.bindStartEvent = function (elem) {
        this._bindStartEvent(elem, true);
    };
    proto.unbindStartEvent = function (elem) {
        this._bindStartEvent(elem, false);
    };
    /**
     * Add or remove start event
     * @param {Boolean} isAdd - remove if falsey
     */
    proto._bindStartEvent = function (elem, isAdd) {
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var startEvent = "mousedown";
        if (window.PointerEvent) {
            startEvent = "pointerdown";
        } else if ("ontouchstart" in window) {
            startEvent = "touchstart";
        }
        elem[bindMethod](startEvent, this);
    };
    proto.handleEvent = function (event) {
        var method = "on" + event.type;
        if (this[method]) {
            this[method](event);
        }
    };
    proto.getTouch = function (touches) {
        for (var i = 0; i < touches.length; i++) {
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) {
                return touch;
            }
        }
    };
    proto.onmousedown = function (event) {
        var button = event.button;
        if (button && button !== 0 && button !== 1) {
            return;
        }
        this._pointerDown(event, event);
    };
    proto.ontouchstart = function (event) {
        this._pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function (event) {
        this._pointerDown(event, event);
    };
    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto._pointerDown = function (event, pointer) {
        if (event.button || this.isPointerDown) {
            return;
        }
        this.isPointerDown = true;
        this.pointerIdentifier = pointer.pointerId !== undefined ? pointer.pointerId : pointer.identifier;
        this.pointerDown(event, pointer);
    };
    proto.pointerDown = function (event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [event, pointer]);
    };
    var postStartEvents = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"],
    };
    proto._bindPostStartEvents = function (event) {
        if (!event) {
            return;
        }
        var events = postStartEvents[event.type];
        events.forEach(function (eventName) {
            window.addEventListener(eventName, this);
        }, this);
        this._boundPointerEvents = events;
    };
    proto._unbindPostStartEvents = function () {
        if (!this._boundPointerEvents) {
            return;
        }
        this._boundPointerEvents.forEach(function (eventName) {
            window.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
    };
    proto.onmousemove = function (event) {
        this._pointerMove(event, event);
    };
    proto.onpointermove = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
            this._pointerMove(event, event);
        }
    };
    proto.ontouchmove = function (event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) {
            this._pointerMove(event, touch);
        }
    };
    /**
     * pointer move
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerMove = function (event, pointer) {
        this.pointerMove(event, pointer);
    };
    proto.pointerMove = function (event, pointer) {
        this.emitEvent("pointerMove", [event, pointer]);
    };
    proto.onmouseup = function (event) {
        this._pointerUp(event, event);
    };
    proto.onpointerup = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
            this._pointerUp(event, event);
        }
    };
    proto.ontouchend = function (event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) {
            this._pointerUp(event, touch);
        }
    };
    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerUp = function (event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
    };
    proto.pointerUp = function (event, pointer) {
        this.emitEvent("pointerUp", [event, pointer]);
    };
    proto._pointerDone = function () {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };
    proto._pointerReset = function () {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };
    proto.pointerDone = noop;
    proto.onpointercancel = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
            this._pointerCancel(event, event);
        }
    };
    proto.ontouchcancel = function (event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) {
            this._pointerCancel(event, touch);
        }
    };
    /**
     * pointer cancel
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerCancel = function (event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
    };
    proto.pointerCancel = function (event, pointer) {
        this.emitEvent("pointerCancel", [event, pointer]);
    };
    Unipointer.getPointerPoint = function (pointer) {
        return {
            x: pointer.pageX,
            y: pointer.pageY,
        };
    };
    return Unipointer;
});
/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */
/*jshint browser: true, unused: true, undef: true, strict: true */
(function (window, factory) {
    /*jshint strict: false */ /*globals define, module, require */
    if (typeof define == "function" && define.amd) {
        define("unidragger/unidragger", ["unipointer/unipointer"], function (Unipointer) {
            return factory(window, Unipointer);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("unipointer"));
    } else {
        window.Unidragger = factory(window, window.Unipointer);
    }
})(window, function factory(window, Unipointer) {
    function Unidragger() {}
    var proto = (Unidragger.prototype = Object.create(Unipointer.prototype));
    proto.bindHandles = function () {
        this._bindHandles(true);
    };
    proto.unbindHandles = function () {
        this._bindHandles(false);
    };
    /**
     * Add or remove start event
     * @param {Boolean} isAdd
     */
    proto._bindHandles = function (isAdd) {
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var touchAction = isAdd ? this._touchActionValue : "";
        for (var i = 0; i < this.handles.length; i++) {
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]("click", this);
            if (window.PointerEvent) {
                handle.style.touchAction = touchAction;
            }
        }
    };
    proto._touchActionValue = "none";
    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerDown = function (event, pointer) {
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) {
            return;
        }
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY,
        };
        event.preventDefault();
        this.pointerDownBlur();
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [event, pointer]);
    };
    var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true,
    };
    var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true,
    };
    proto.okayPointerDown = function (event) {
        var isCursorNode = cursorNodes[event.target.nodeName];
        var isClickType = clickTypes[event.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) {
            this._pointerReset();
        }
        return isOkay;
    };
    proto.pointerDownBlur = function () {
        var focused = document.activeElement;
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) {
            focused.blur();
        }
    };
    /**
     * drag move
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerMove = function (event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent("pointerMove", [event, pointer, moveVector]);
        this._dragMove(event, pointer, moveVector);
    };
    proto._dragPointerMove = function (event, pointer) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY,
        };
        if (!this.isDragging && this.hasDragStarted(moveVector)) {
            this._dragStart(event, pointer);
        }
        return moveVector;
    };
    proto.hasDragStarted = function (moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerUp = function (event, pointer) {
        this.emitEvent("pointerUp", [event, pointer]);
        this._dragPointerUp(event, pointer);
    };
    proto._dragPointerUp = function (event, pointer) {
        if (this.isDragging) {
            this._dragEnd(event, pointer);
        } else {
            this._staticClick(event, pointer);
        }
    };
    proto._dragStart = function (event, pointer) {
        this.isDragging = true;
        /* nectar addition iOS15 fix */
        document.ontouchmove = function () {
            return false;
        };
        /* nectar addition iOS15 fix end */
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
    };
    proto.dragStart = function (event, pointer) {
        this.emitEvent("dragStart", [event, pointer]);
    };
    proto._dragMove = function (event, pointer, moveVector) {
        if (!this.isDragging) {
            return;
        }
        this.dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function (event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent("dragMove", [event, pointer, moveVector]);
    };
    proto._dragEnd = function (event, pointer) {
        this.isDragging = false;
        /* nectar addition iOS15 fix */
        document.ontouchmove = function () {
            return true;
        };
        /* nectar addition iOS15 fix end */
        setTimeout(
            function () {
                delete this.isPreventingClicks;
            }.bind(this)
        );
        this.dragEnd(event, pointer);
    };
    proto.dragEnd = function (event, pointer) {
        this.emitEvent("dragEnd", [event, pointer]);
    };
    proto.onclick = function (event) {
        if (this.isPreventingClicks) {
            event.preventDefault();
        }
    };
    proto._staticClick = function (event, pointer) {
        if (this.isIgnoringMouseUp && event.type == "mouseup") {
            return;
        }
        this.staticClick(event, pointer);
        if (event.type != "mouseup") {
            this.isIgnoringMouseUp = true;
            setTimeout(
                function () {
                    delete this.isIgnoringMouseUp;
                }.bind(this),
                400
            );
        }
    };
    proto.staticClick = function (event, pointer) {
        this.emitEvent("staticClick", [event, pointer]);
    };
    Unidragger.getPointerPoint = Unipointer.getPointerPoint;
    return Unidragger;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (Flickity, Unidragger, utils) {
            return factory(window, Flickity, Unidragger, utils);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("./flickity"), require("unidragger"), require("fizzy-ui-utils"));
    } else {
        window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
    }
})(window, function factory(window, Flickity, Unidragger, utils) {
    utils.extend(Flickity.defaults, {
        draggable: ">1",
        dragThreshold: 3,
    });
    Flickity.createMethods.push("_createDrag");
    var proto = Flickity.prototype;
    utils.extend(proto, Unidragger.prototype);
    proto._touchActionValue = "pan-y";
    var isTouch = "createTouch" in document;
    var isTouchmoveScrollCanceled = false;
    proto._createDrag = function () {
        this.on("activate", this.onActivateDrag);
        this.on("uiChange", this._uiChangeDrag);
        this.on("childUIPointerDown", this._childUIPointerDownDrag);
        this.on("deactivate", this.onDeactivateDrag);
        this.on("cellChange", this.updateDraggable);
        if (isTouch && !isTouchmoveScrollCanceled) {
            window.addEventListener("touchmove", function () {});
            isTouchmoveScrollCanceled = true;
        }
    };
    proto.onActivateDrag = function () {
        this.handles = [this.viewport];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function () {
        this.unbindHandles();
        this.element.classList.remove("is-draggable");
    };
    proto.updateDraggable = function () {
        if (this.options.draggable == ">1") {
            this.isDraggable = this.slides.length > 1;
        } else {
            this.isDraggable = this.options.draggable;
        }
        if (this.isDraggable) {
            this.element.classList.add("is-draggable");
        } else {
            this.element.classList.remove("is-draggable");
        }
    };
    proto.bindDrag = function () {
        this.options.draggable = true;
        this.updateDraggable();
    };
    proto.unbindDrag = function () {
        this.options.draggable = false;
        this.updateDraggable();
    };
    proto._uiChangeDrag = function () {
        delete this.isFreeScrolling;
    };
    proto._childUIPointerDownDrag = function (event) {
        event.preventDefault();
        this.pointerDownFocus(event);
    };
    proto.pointerDown = function (event, pointer) {
        if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
        }
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) {
            return;
        }
        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        if (document.activeElement != this.element) {
            this.pointerDownBlur();
        }
        this.dragX = this.x;
        this.viewport.classList.add("is-pointer-down");
        this.pointerDownScroll = getScrollPosition();
        window.addEventListener("scroll", this);
        this._pointerDownDefault(event, pointer);
    };
    proto._pointerDownDefault = function (event, pointer) {
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY,
        };
        this._bindPostStartEvents(event);
        this.dispatchEvent("pointerDown", event, [pointer]);
    };
    var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true,
    };
    proto.pointerDownFocus = function (event) {
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) {
            this.focus();
        }
    };
    proto._pointerDownPreventDefault = function (event) {
        var isTouchStart = event.type == "touchstart";
        var isTouchPointer = event.pointerType == "touch";
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) {
            event.preventDefault();
        }
    };
    proto.hasDragStarted = function (moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    proto.pointerUp = function (event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove("is-pointer-down");
        this.dispatchEvent("pointerUp", event, [pointer]);
        this._dragPointerUp(event, pointer);
    };
    proto.pointerDone = function () {
        window.removeEventListener("scroll", this);
        delete this.pointerDownScroll;
    };
    proto.dragStart = function (event, pointer) {
        if (!this.isDraggable) {
            return;
        }
        this.dragStartPosition = this.x;
        this.startAnimation();
        window.removeEventListener("scroll", this);
        this.dispatchEvent("dragStart", event, [pointer]);
    };
    proto.pointerMove = function (event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent("pointerMove", event, [pointer, moveVector]);
        this._dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function (event, pointer, moveVector) {
        if (!this.isDraggable) {
            return;
        }
        event.preventDefault();
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) {
            moveVector.x = moveVector.x % this.slideableWidth;
        }
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        if (this.dragX !== dragX) {
            this.previousDragX = this.dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
        this.dispatchEvent("dragMove", event, [pointer, moveVector]);
    };
    proto.dragEnd = function (event, pointer) {
        if (!this.isDraggable) {
            return;
        }
        if (this.options.freeScroll) {
            this.isFreeScrolling = true;
        }
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) {
            index += this.dragEndBoostSelect();
        }
        delete this.previousDragX;
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent("dragEnd", event, [pointer]);
    };
    proto.dragEndRestingSelect = function () {
        var restingX = this.getRestingPosition();
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
    };
    /**
     * given resting X and distance to selected cell
     * get the distance and index of the closest cell
     * @param {Number} restingX - estimated post-flick resting position
     * @param {Number} distance - distance to selected cell
     * @param {Integer} increment - +1 or -1, going up or down
     * @returns {Object} - { distance: {Number}, index: {Integer} }
     */
    proto._getClosestResting = function (restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition =
            this.options.contain && !this.options.wrapAround
                ? function (d, md) {
                      return d <= md;
                  }
                : function (d, md) {
                      return d < md;
                  };
        while (condition(distance, minDistance)) {
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) {
                break;
            }
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            index: index - increment,
        };
    };
    /**
     * measure distance between x and a slide target
     * @param {Number} x
     * @param {Integer} index - slide index
     */
    proto.getSlideDistance = function (x, index) {
        var len = this.slides.length;
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) {
            return null;
        }
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function () {
        if (this.previousDragX === undefined || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) {
            return 0;
        }
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) {
            return 1;
        } else if (distance < 0 && delta < 0) {
            return -1;
        }
        return 0;
    };
    proto.staticClick = function (event, pointer) {
        var clickedCell = this.getParentCell(event.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent("staticClick", event, [pointer, cellElem, cellIndex]);
    };
    proto.onscroll = function () {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
            this._pointerDone();
        }
    };
    function getScrollPosition() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset,
        };
    }
    return Flickity;
});
/*!
 * Tap listener v2.0.0
 * listens to taps
 * MIT license
 */
/*jshint browser: true, unused: true, undef: true, strict: true */
(function (window, factory) {
    /*jshint strict: false*/ /*globals define, module, require */
    if (typeof define == "function" && define.amd) {
        define("tap-listener/tap-listener", ["unipointer/unipointer"], function (Unipointer) {
            return factory(window, Unipointer);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("unipointer"));
    } else {
        window.TapListener = factory(window, window.Unipointer);
    }
})(window, function factory(window, Unipointer) {
    function TapListener(elem) {
        this.bindTap(elem);
    }
    var proto = (TapListener.prototype = Object.create(Unipointer.prototype));
    /**
     * bind tap event to element
     * @param {Element} elem
     */
    proto.bindTap = function (elem) {
        if (!elem) {
            return;
        }
        this.unbindTap();
        this.tapElement = elem;
        this._bindStartEvent(elem, true);
    };
    proto.unbindTap = function () {
        if (!this.tapElement) {
            return;
        }
        this._bindStartEvent(this.tapElement, true);
        delete this.tapElement;
    };
    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerUp = function (event, pointer) {
        if (this.isIgnoringMouseUp && event.type == "mouseup") {
            return;
        }
        var pointerPoint = Unipointer.getPointerPoint(pointer);
        var boundingRect = this.tapElement.getBoundingClientRect();
        var scrollX = window.pageXOffset;
        var scrollY = window.pageYOffset;
        var isInside = pointerPoint.x >= boundingRect.left + scrollX && pointerPoint.x <= boundingRect.right + scrollX && pointerPoint.y >= boundingRect.top + scrollY && pointerPoint.y <= boundingRect.bottom + scrollY;
        if (isInside) {
            this.emitEvent("tap", [event, pointer]);
        }
        if (event.type != "mouseup") {
            this.isIgnoringMouseUp = true;
            var _this = this;
            setTimeout(function () {
                delete _this.isIgnoringMouseUp;
            }, 400);
        }
    };
    proto.destroy = function () {
        this.pointerDone();
        this.unbindTap();
    };
    return TapListener;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (Flickity, TapListener, utils) {
            return factory(window, Flickity, TapListener, utils);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils"));
    } else {
        factory(window, window.Flickity, window.TapListener, window.fizzyUIUtils);
    }
})(window, function factory(window, Flickity, TapListener, utils) {
    "use strict";
    var svgURI = "http://www.w3.org/2000/svg";
    function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }
    PrevNextButton.prototype = Object.create(TapListener.prototype);
    PrevNextButton.prototype._create = function () {
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = (this.element = document.createElement("button"));
        element.className = "flickity-button flickity-prev-next-button";
        element.className += this.isPrevious ? " previous" : " next";
        element.setAttribute("type", "button");
        this.disable();
        element.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var svg = this.createSVG();
        element.appendChild(svg);
        this.on("tap", this.onTap);
        this.parent.on("select", this.update.bind(this));
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PrevNextButton.prototype.activate = function () {
        this.bindTap(this.element);
        this.element.addEventListener("click", this);
        this.parent.element.appendChild(this.element);
    };
    PrevNextButton.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element);
        TapListener.prototype.destroy.call(this);
        this.element.removeEventListener("click", this);
    };
    PrevNextButton.prototype.createSVG = function () {
        var svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        var path = document.createElementNS(svgURI, "path");
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        if (!this.isLeft) {
            path.setAttribute("transform", "translate(100, 100) rotate(180) ");
        }
        svg.appendChild(path);
        return svg;
    };
    function getArrowMovements(shape) {
        if (typeof shape == "string") {
            return shape;
        }
        return (
            "M " +
            shape.x0 +
            ",50" +
            " L " +
            shape.x1 +
            "," +
            (shape.y1 + 50) +
            " L " +
            shape.x2 +
            "," +
            (shape.y2 + 50) +
            " L " +
            shape.x3 +
            ",50 " +
            " L " +
            shape.x2 +
            "," +
            (50 - shape.y2) +
            " L " +
            shape.x1 +
            "," +
            (50 - shape.y1) +
            " Z"
        );
    }
    PrevNextButton.prototype.onTap = function () {
        if (!this.isEnabled) {
            return;
        }
        this.parent.uiChange();
        var method = this.isPrevious ? "previous" : "next";
        this.parent[method]();
    };
    PrevNextButton.prototype.handleEvent = utils.handleEvent;
    PrevNextButton.prototype.onclick = function (event) {
        var focused = document.activeElement;
        if (focused && focused == this.element) {
            this.onTap(event, event);
        }
    };
    PrevNextButton.prototype.enable = function () {
        if (this.isEnabled) {
            return;
        }
        this.element.disabled = false;
        this.isEnabled = true;
    };
    PrevNextButton.prototype.disable = function () {
        if (!this.isEnabled) {
            return;
        }
        this.element.disabled = true;
        this.isEnabled = false;
    };
    PrevNextButton.prototype.update = function () {
        var slides = this.parent.slides;
        if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? "disable" : "enable";
        this[method]();
    };
    PrevNextButton.prototype.destroy = function () {
        this.deactivate();
    };
    utils.extend(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
        },
    });
    Flickity.createMethods.push("_createPrevNextButtons");
    var proto = Flickity.prototype;
    proto._createPrevNextButtons = function () {
        if (!this.options.prevNextButtons) {
            return;
        }
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on("activate", this.activatePrevNextButtons);
    };
    proto.activatePrevNextButtons = function () {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on("deactivate", this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off("deactivate", this.deactivatePrevNextButtons);
    };
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (Flickity, TapListener, utils) {
            return factory(window, Flickity, TapListener, utils);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils"));
    } else {
        factory(window, window.Flickity, window.TapListener, window.fizzyUIUtils);
    }
})(window, function factory(window, Flickity, TapListener, utils) {
    function PageDots(parent) {
        this.parent = parent;
        this._create();
    }
    PageDots.prototype = new TapListener();
    PageDots.prototype._create = function () {
        this.holder = document.createElement("ol");
        this.holder.className = "flickity-page-dots";
        this.dots = [];
        this.on("tap", this.onTap);
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PageDots.prototype.activate = function () {
        this.setDots();
        this.bindTap(this.holder);
        this.parent.element.appendChild(this.holder);
    };
    PageDots.prototype.deactivate = function () {
        this.parent.element.removeChild(this.holder);
        TapListener.prototype.destroy.call(this);
    };
    PageDots.prototype.setDots = function () {
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) {
            this.addDots(delta);
        } else if (delta < 0) {
            this.removeDots(-delta);
        }
    };
    PageDots.prototype.addDots = function (count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for (var i = length; i < max; i++) {
            var dot = document.createElement("li");
            dot.className = "dot";
            dot.setAttribute("aria-label", "Page dot " + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function (count) {
        var removeDots = this.dots.splice(this.dots.length - count, count);
        removeDots.forEach(function (dot) {
            this.holder.removeChild(dot);
        }, this);
    };
    PageDots.prototype.updateSelected = function () {
        if (this.selectedDot) {
            this.selectedDot.className = "dot";
            this.selectedDot.removeAttribute("aria-current");
        }
        if (!this.dots.length) {
            return;
        }
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = "dot is-selected";
        this.selectedDot.setAttribute("aria-current", "step");
    };
    PageDots.prototype.onTap = function (event) {
        var target = event.target;
        if (target.nodeName != "LI") {
            return;
        }
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
    };
    PageDots.prototype.destroy = function () {
        this.deactivate();
    };
    Flickity.PageDots = PageDots;
    utils.extend(Flickity.defaults, {
        pageDots: true,
    });
    Flickity.createMethods.push("_createPageDots");
    var proto = Flickity.prototype;
    proto._createPageDots = function () {
        if (!this.options.pageDots) {
            return;
        }
        this.pageDots = new PageDots(this);
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
    };
    proto.activatePageDots = function () {
        this.pageDots.activate();
    };
    proto.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
    };
    proto.updatePageDots = function () {
        this.pageDots.setDots();
    };
    proto.deactivatePageDots = function () {
        this.pageDots.deactivate();
    };
    Flickity.PageDots = PageDots;
    return Flickity;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (EvEmitter, utils, Flickity) {
            return factory(EvEmitter, utils, Flickity);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity"));
    } else {
        factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
    }
})(window, function factory(EvEmitter, utils, Flickity) {
    function Player(parent) {
        this.parent = parent;
        this.state = "stopped";
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    Player.prototype = Object.create(EvEmitter.prototype);
    Player.prototype.play = function () {
        if (this.state == "playing") {
            return;
        }
        var isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return;
        }
        this.state = "playing";
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        this.tick();
    };
    Player.prototype.tick = function () {
        if (this.state != "playing") {
            return;
        }
        var time = this.parent.options.autoPlay;
        time = typeof time == "number" ? time : 3000;
        var _this = this;
        this.clear();
        this.timeout = setTimeout(function () {
            _this.parent.next(true);
            _this.tick();
        }, time);
    };
    Player.prototype.stop = function () {
        this.state = "stopped";
        this.clear();
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    };
    Player.prototype.clear = function () {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function () {
        if (this.state == "playing") {
            this.state = "paused";
            this.clear();
        }
    };
    Player.prototype.unpause = function () {
        if (this.state == "paused") {
            this.play();
        }
    };
    Player.prototype.visibilityChange = function () {
        var isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
    };
    Player.prototype.visibilityPlay = function () {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
    };
    utils.extend(Flickity.defaults, {
        pauseAutoPlayOnHover: true,
    });
    Flickity.createMethods.push("_createPlayer");
    var proto = Flickity.prototype;
    proto._createPlayer = function () {
        this.player = new Player(this);
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
    };
    proto.activatePlayer = function () {
        if (!this.options.autoPlay) {
            return;
        }
        this.player.play();
        this.element.addEventListener("mouseenter", this);
    };
    proto.playPlayer = function () {
        this.player.play();
    };
    proto.stopPlayer = function () {
        this.player.stop();
    };
    proto.pausePlayer = function () {
        this.player.pause();
    };
    proto.unpausePlayer = function () {
        this.player.unpause();
    };
    proto.deactivatePlayer = function () {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
    };
    proto.onmouseenter = function () {
        if (!this.options.pauseAutoPlayOnHover) {
            return;
        }
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
    };
    proto.onmouseleave = function () {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
    };
    Flickity.Player = Player;
    return Flickity;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (Flickity, utils) {
            return factory(window, Flickity, utils);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("./flickity"), require("fizzy-ui-utils"));
    } else {
        factory(window, window.Flickity, window.fizzyUIUtils);
    }
})(window, function factory(window, Flickity, utils) {
    function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function (cell) {
            fragment.appendChild(cell.element);
        });
        return fragment;
    }
    var proto = Flickity.prototype;
    /**
     * Insert, prepend, or append cells
     * @param {Element, Array, NodeList} elems
     * @param {Integer} index
     */
    proto.insert = function (elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) {
            return;
        }
        var len = this.cells.length;
        index = index === undefined ? len : index;
        var fragment = getCellsFragment(cells);
        var isAppend = index == len;
        if (isAppend) {
            this.slider.appendChild(fragment);
        } else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        if (index === 0) {
            this.cells = cells.concat(this.cells);
        } else if (isAppend) {
            this.cells = this.cells.concat(cells);
        } else {
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
    };
    proto.append = function (elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function (elems) {
        this.insert(elems, 0);
    };
    /**
     * Remove cells
     * @param {Element, Array, NodeList} elems
     */
    proto.remove = function (elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) {
            return;
        }
        var minCellIndex = this.cells.length - 1;
        cells.forEach(function (cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
    };
    /**
     * logic to be run after a cell's size changes
     * @param {Element} elem - cell's element
     */
    proto.cellSizeChange = function (elem) {
        var cell = this.getCell(elem);
        if (!cell) {
            return;
        }
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
    };
    /**
     * logic any time a cell is changed: added, removed, or size changed
     * @param {Integer} changedCellIndex - index of the changed cell, optional
     */
    proto.cellChange = function (changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        var cell = this.getCell(prevSelectedElem);
        if (cell) {
            this.selectedIndex = this.getCellSlideIndex(cell);
        }
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [changedCellIndex]);
        this.select(this.selectedIndex);
        if (isPositioningSlider) {
            this.positionSliderAtSelected();
        }
    };
    return Flickity;
});
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (Flickity, utils) {
            return factory(window, Flickity, utils);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("./flickity"), require("fizzy-ui-utils"));
    } else {
        factory(window, window.Flickity, window.fizzyUIUtils);
    }
})(window, function factory(window, Flickity, utils) {
    "use strict";
    Flickity.createMethods.push("_createLazyload");
    var proto = Flickity.prototype;
    proto._createLazyload = function () {
        this.on("select", this.lazyLoad);
    };
    proto.lazyLoad = function () {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) {
            return;
        }
        var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        var lazyImages = [];
        cellElems.forEach(function (cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
        });
        lazyImages.forEach(function (img) {
            new LazyLoader(img, this);
        }, this);
    };
    function getCellLazyImages(cellElem) {
        if (cellElem.nodeName == "IMG") {
            var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
            var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
            var srcsetAttr = cellElem.getAttribute("data-flickity-lazyload-srcset");
            if (lazyloadAttr || srcAttr || srcsetAttr) {
                return [cellElem];
            }
        }
        var lazySelector = "img[data-flickity-lazyload], " + "img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
    }
    /**
     * class to handle loading images
     */
    function LazyLoader(img, flickity) {
        this.img = img;
        this.flickity = flickity;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function () {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        var src = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src");
        var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = src;
        if (srcset) {
            this.img.setAttribute("srcset", srcset);
        }
        this.img.removeAttribute("data-flickity-lazyload");
        this.img.removeAttribute("data-flickity-lazyload-src");
        this.img.removeAttribute("data-flickity-lazyload-srcset");
    };
    LazyLoader.prototype.onload = function (event) {
        this.complete(event, "flickity-lazyloaded");
    };
    LazyLoader.prototype.onerror = function (event) {
        this.complete(event, "flickity-lazyerror");
    };
    LazyLoader.prototype.complete = function (event, className) {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent("lazyLoad", event, cellElem);
    };
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});
/*!
 * Flickity v2.1.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2018 Metafizzy
 */
(function (window, factory) {
    /* jshint strict: false */
    if (typeof define == "function" && define.amd) {
        define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], factory);
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload"));
    }
})(window, function factory(Flickity) {
    /*jshint strict: false*/
    return Flickity;
});
/*!
 * Flickity asNavFor v2.0.1
 * enable asNavFor for Flickity
 */
/*jshint browser: true, undef: true, unused: true, strict: true*/
(function (window, factory) {
    /*jshint strict: false */ /*globals define, module, require */
    if (typeof define == "function" && define.amd) {
        define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], factory);
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(require("flickity"), require("fizzy-ui-utils"));
    } else {
        window.Flickity = factory(window.Flickity, window.fizzyUIUtils);
    }
})(window, function factory(Flickity, utils) {
    Flickity.createMethods.push("_createAsNavFor");
    var proto = Flickity.prototype;
    proto._createAsNavFor = function () {
        this.on("activate", this.activateAsNavFor);
        this.on("deactivate", this.deactivateAsNavFor);
        this.on("destroy", this.destroyAsNavFor);
        var asNavForOption = this.options.asNavFor;
        if (!asNavForOption) {
            return;
        }
        var _this = this;
        setTimeout(function initNavCompanion() {
            _this.setNavCompanion(asNavForOption);
        });
    };
    proto.setNavCompanion = function (elem) {
        elem = utils.getQueryElement(elem);
        var companion = Flickity.data(elem);
        if (!companion || companion == this) {
            return;
        }
        this.navCompanion = companion;
        var _this = this;
        this.onNavCompanionSelect = function () {
            _this.navCompanionSelect();
        };
        companion.on("select", this.onNavCompanionSelect);
        this.on("staticClick", this.onNavStaticClick);
        this.navCompanionSelect(true);
    };
    proto.navCompanionSelect = function (isInstant) {
        if (!this.navCompanion) {
            return;
        }
        var selectedCell = this.navCompanion.selectedCells[0];
        var firstIndex = this.navCompanion.cells.indexOf(selectedCell);
        var lastIndex = firstIndex + this.navCompanion.selectedCells.length - 1;
        var selectIndex = Math.floor(lerp(firstIndex, lastIndex, this.navCompanion.cellAlign));
        this.selectCell(selectIndex, false, isInstant);
        this.removeNavSelectedElements();
        if (selectIndex >= this.cells.length) {
            return;
        }
        var selectedCells = this.cells.slice(firstIndex, lastIndex + 1);
        this.navSelectedElements = selectedCells.map(function (cell) {
            return cell.element;
        });
        this.changeNavSelectedClass("add");
    };
    function lerp(a, b, t) {
        return (b - a) * t + a;
    }
    proto.changeNavSelectedClass = function (method) {
        this.navSelectedElements.forEach(function (navElem) {
            navElem.classList[method]("is-nav-selected");
        });
    };
    proto.activateAsNavFor = function () {
        this.navCompanionSelect(true);
    };
    proto.removeNavSelectedElements = function () {
        if (!this.navSelectedElements) {
            return;
        }
        this.changeNavSelectedClass("remove");
        delete this.navSelectedElements;
    };
    proto.onNavStaticClick = function (event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex == "number") {
            this.navCompanion.selectCell(cellIndex);
        }
    };
    proto.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
    };
    proto.destroyAsNavFor = function () {
        if (!this.navCompanion) {
            return;
        }
        this.navCompanion.off("select", this.onNavCompanionSelect);
        this.off("staticClick", this.onNavStaticClick);
        delete this.navCompanion;
    };
    return Flickity;
});
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
(function (window, factory) {
    "use strict";
    /*global define: false, module: false, require: false */
    if (typeof define == "function" && define.amd) {
        define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (EvEmitter) {
            return factory(window, EvEmitter);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("ev-emitter"));
    } else {
        window.imagesLoaded = factory(window, window.EvEmitter);
    }
})(typeof window !== "undefined" ? window : this, function factory(window, EvEmitter) {
    var $ = window.jQuery;
    var console = window.console;
    function extend(a, b) {
        for (var prop in b) {
            a[prop] = b[prop];
        }
        return a;
    }
    var arraySlice = Array.prototype.slice;
    function makeArray(obj) {
        if (Array.isArray(obj)) {
            return obj;
        }
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) {
            return arraySlice.call(obj);
        }
        return [obj];
    }
    /**
     * @param {Array, Element, NodeList, String} elem
     * @param {Object or Function} options - if function, use as callback
     * @param {Function} onAlways - callback function
     */
    function ImagesLoaded(elem, options, onAlways) {
        if (!(this instanceof ImagesLoaded)) {
            return new ImagesLoaded(elem, options, onAlways);
        }
        var queryElem = elem;
        if (typeof elem == "string") {
            queryElem = document.querySelectorAll(elem);
        }
        if (!queryElem) {
            console.error("Bad element for imagesLoaded " + (queryElem || elem));
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = extend({}, this.options);
        if (typeof options == "function") {
            onAlways = options;
        } else {
            extend(this.options, options);
        }
        if (onAlways) {
            this.on("always", onAlways);
        }
        this.getImages();
        if ($) {
            this.jqDeferred = new $.Deferred();
        }
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.options = {};
    ImagesLoaded.prototype.getImages = function () {
        this.images = [];
        this.elements.forEach(this.addElementImages, this);
    };
    /**
     * @param {Node} element
     */
    ImagesLoaded.prototype.addElementImages = function (elem) {
        if (elem.nodeName == "IMG") {
            this.addImage(elem);
        }
        if (this.options.background === true) {
            this.addElementBackgroundImages(elem);
        }
        var nodeType = elem.nodeType;
        if (!nodeType || !elementNodeTypes[nodeType]) {
            return;
        }
        var childImgs = elem.querySelectorAll("img");
        for (var i = 0; i < childImgs.length; i++) {
            var img = childImgs[i];
            this.addImage(img);
        }
        if (typeof this.options.background == "string") {
            var children = elem.querySelectorAll(this.options.background);
            for (i = 0; i < children.length; i++) {
                var child = children[i];
                this.addElementBackgroundImages(child);
            }
        }
    };
    var elementNodeTypes = {
        1: true,
        9: true,
        11: true,
    };
    ImagesLoaded.prototype.addElementBackgroundImages = function (elem) {
        var style = getComputedStyle(elem);
        if (!style) {
            return;
        }
        var reURL = /url\((['"])?(.*?)\1\)/gi;
        var matches = reURL.exec(style.backgroundImage);
        while (matches !== null) {
            var url = matches && matches[2];
            if (url) {
                this.addBackground(url, elem);
            }
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
     * @param {Image} img
     */
    ImagesLoaded.prototype.addImage = function (img) {
        var loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function (url, elem) {
        var background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function () {
        var _this = this;
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        if (!this.images.length) {
            this.complete();
            return;
        }
        function onProgress(image, elem, message) {
            setTimeout(function () {
                _this.progress(image, elem, message);
            });
        }
        this.images.forEach(function (loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function (image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        this.emitEvent("progress", [this, image, elem]);
        if (this.jqDeferred && this.jqDeferred.notify) {
            this.jqDeferred.notify(this, image);
        }
        if (this.progressedCount == this.images.length) {
            this.complete();
        }
        if (this.options.debug && console) {
            console.log("progress: " + message, image, elem);
        }
    };
    ImagesLoaded.prototype.complete = function () {
        var eventName = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = true;
        this.emitEvent(eventName, [this]);
        this.emitEvent("always", [this]);
        if (this.jqDeferred) {
            var jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
        }
    };
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function () {
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
        }
        this.proxyImage = new Image();
        this.proxyImage.addEventListener("load", this);
        this.proxyImage.addEventListener("error", this);
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.proxyImage.src = this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function (isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [this, this.img, message]);
    };
    LoadingImage.prototype.handleEvent = function (event) {
        var method = "on" + event.type;
        if (this[method]) {
            this[method](event);
        }
    };
    LoadingImage.prototype.onload = function () {
        this.confirm(true, "onload");
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function () {
        this.confirm(false, "onerror");
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this);
        this.proxyImage.removeEventListener("error", this);
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function () {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.img.src = this.url;
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    Background.prototype.confirm = function (isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [this, this.element, message]);
    };
    ImagesLoaded.makeJQueryPlugin = function (jQuery) {
        jQuery = jQuery || window.jQuery;
        if (!jQuery) {
            return;
        }
        $ = jQuery;
        $.fn.imagesLoaded = function (options, callback) {
            var instance = new ImagesLoaded(this, options, callback);
            return instance.jqDeferred.promise($(this));
        };
    };
    ImagesLoaded.makeJQueryPlugin();
    return ImagesLoaded;
});
/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */
/*jshint browser: true, strict: true, undef: true, unused: true */
(function (window, factory) {
    /*jshint strict: false */ /*globals define, module, require */
    if (typeof define == "function" && define.amd) {
        define(["flickity/js/index", "imagesloaded/imagesloaded"], function (Flickity, imagesLoaded) {
            return factory(window, Flickity, imagesLoaded);
        });
    } else if (typeof module == "object" && module.exports) {
        module.exports = factory(window, require("flickity"), require("imagesloaded"));
    } else {
        window.Flickity = factory(window, window.Flickity, window.imagesLoaded);
    }
})(window, function factory(window, Flickity, imagesLoaded) {
    "use strict";
    Flickity.createMethods.push("_createImagesLoaded");
    var proto = Flickity.prototype;
    proto._createImagesLoaded = function () {
        this.on("activate", this.imagesLoaded);
    };
    proto.imagesLoaded = function () {
        if (!this.options.imagesLoaded) {
            return;
        }
        var _this = this;
        function onImagesLoadedProgress(instance, image) {
            var cell = _this.getParentCell(image.img);
            _this.cellSizeChange(cell && cell.element);
            if (!_this.options.freeScroll) {
                _this.positionSliderAtSelected();
            }
        }
        imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
    };
    return Flickity;
});
!(function (e) {
    "use strict";
    e(window).on("resize", function () {
        e(".sf-menu ul.tracked-pos").removeClass("tracked-pos");
    });
    var t,
        s,
        n,
        a,
        r,
        o,
        i,
        h,
        l,
        d,
        p,
        u,
        f,
        c,
        m,
        v,
        g =
            ((s = "sf-breadcrumb"),
            (n = "sf-js-enabled"),
            (a = "sf-with-ul"),
            (r = "sf-arrows"),
            (o = (function () {
                var t = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                return t && e("html").css("cursor", "pointer").on("click", e.noop), t;
            })()),
            (i = "behavior" in (t = document.documentElement.style) && "fill" in t && /iemobile/i.test(navigator.userAgent)),
            (h = function (e, t) {
                var s = n;
                t.cssArrows && (s += " " + r), e.toggleClass(s);
            }),
            (l = function (e) {
                e.children("a").toggleClass(a);
            }),
            (d = function (e) {
                var t = e.css("ms-touch-action");
                (t = "pan-y" === t ? "auto" : "pan-y"), e.css("ms-touch-action", t);
            }),
            (p = function (t) {
                var s = e(this),
                    n = s.siblings(t.data.popUpSelector);
                n.length > 0 && n.is(":hidden") && (s.one("click.superfish", !1), "MSPointerDown" === t.type ? s.trigger("focus") : e.proxy(u, s.parent("li"))());
            }),
            (u = function () {
                var t = e(this),
                    s = v(t);
                e(this).parents(".megamenu").length > 0 || (clearTimeout(s.sfTimer), t.siblings().superfish("hide").end().superfish("show"));
            }),
            (f = function () {
                var t = e(this),
                    s = v(t);
                o ? e.proxy(c, t, s)() : (clearTimeout(s.sfTimer), (s.sfTimer = setTimeout(e.proxy(c, t, s), s.delay)));
            }),
            (c = function (t) {
                (t.retainPath = e.inArray(this[0], t.$path) > -1), this.superfish("hide"), this.parents("." + t.hoverClass).length || (t.onIdle.call(m(this)), t.$path.length && e.proxy(u, t.$path)());
            }),
            (m = function (e) {
                return e.closest("." + n);
            }),
            (v = function (e) {
                return m(e).data("sf-options");
            }),
            {
                hide: function (t) {
                    if (this.length) {
                        var s = v((o = this));
                        if (!s) return this;
                        if (e(this).hasClass("menu-item-over") && e(this).hasClass("megamenu")) return !0;
                        var n = !0 === s.retainPath ? s.$path : "",
                            a = o
                                .find("li." + s.hoverClass)
                                .add(this)
                                .not(n)
                                .removeClass(s.hoverClass)
                                .children(s.popUpSelector),
                            r = s.speedOut;
                        if ((t && (a.show(), (r = 0)), (s.retainPath = !1), s.onBeforeHide.call(a), "minimal" == s.dropdownStyle)) {
                            var o = e(this);
                            s.onHide.call(o);
                        } else
                            a.stop(!0, !0).animate(s.animationOut, r, function () {
                                var t = e(this);
                                s.onHide.call(t);
                            });
                        if (e(this).parents(".megamenu").length > 0) return;
                        e('#header-outer[data-megamenu-rt="1"]').length > 0 &&
                            e('#header-outer[data-transparent-header="true"]').length > 0 &&
                            (0 == e("#header-outer.scrolled-down").length &&
                                0 == e("#header-outer.small-nav").length &&
                                0 == e("#header-outer.detached").length &&
                                0 == e("#header-outer.fixed-menu").length &&
                                e("#header-outer").addClass("transparent"),
                            e('#header-outer[data-permanent-transparent="1"][data-transparent-header="true"]').length > 0 && e("#header-outer").addClass("transparent"));
                    }
                    return this;
                },
                show: function () {
                    if (!(e(this).parents(".megamenu").length > 0)) {
                        var t = v(this);
                        if (!t) return this;
                        var s = this.addClass(t.hoverClass).children(t.popUpSelector);
                        if (
                            (e('#header-outer[data-megamenu-rt="1"]').length > 0 &&
                                e(this).hasClass("megamenu") &&
                                !e(this).hasClass("width-75") &&
                                !e(this).hasClass("width-50") &&
                                "true" == e("#header-outer").attr("data-transparent-header") &&
                                (e("#header-outer").addClass("no-transition"), e("#header-outer").removeClass("transparent")),
                            t.onBeforeShow.call(s),
                            !s.hasClass("tracked-pos") && !e(s).parents("li").hasClass("megamenu") && !e(s).parents("ul").hasClass("sub-menu") && s.offset())
                        ) {
                            s.addClass("temp-hidden-display");
                            var n = e("#top .container").width(),
                                a = s;
                            a.offset().left - (e(window).width() - n) / 2 + a.width() <= e(window).width() - 100 ? s.parents("li").removeClass("edge") : s.parents("li").addClass("edge"), s.removeClass("temp-hidden-display");
                        }
                        return (
                            "minimal" == t.dropdownStyle
                                ? t.onShow.call(s)
                                : s.stop(!0, !0).animate(t.animation, t.speed, function () {
                                      t.onShow.call(s);
                                  }),
                            s.hasClass("tracked-pos") ||
                                (s.length > 0 &&
                                    s.parents(".sub-menu").length > 0 &&
                                    s.parents(".sf-menu").length > 0 &&
                                    s.offset().left + s.outerWidth() > e(window).width() &&
                                    (s.addClass("on-left-side"), s.find("ul").addClass("on-left-side"))),
                            s.addClass("tracked-pos"),
                            this
                        );
                    }
                },
                destroy: function () {
                    return this.each(function () {
                        var t,
                            n = e(this),
                            a = n.data("sf-options");
                        if (!a) return !1;
                        (t = n.find(a.popUpSelector).parent("li")),
                            clearTimeout(a.sfTimer),
                            h(n, a),
                            l(t),
                            d(n),
                            n.off(".superfish").off(".hoverIntent"),
                            t.children(a.popUpSelector).attr("style", function (e, t) {
                                return t.replace(/display[^;]+;?/g, "");
                            }),
                            a.$path.removeClass(a.hoverClass + " " + s).addClass(a.pathClass),
                            n.find("." + a.hoverClass).removeClass(a.hoverClass),
                            a.onDestroy.call(n),
                            n.removeData("sf-options");
                    });
                },
                init: function (t) {
                    return this.each(function () {
                        var n = e(this);
                        if (n.data("sf-options")) return !1;
                        var a = e.extend({}, e.fn.superfish.defaults, t),
                            r = n.find(a.popUpSelector).parent("li");
                        (a.$path = (function (t, n) {
                            return t
                                .find("li." + n.pathClass)
                                .slice(0, n.pathLevels)
                                .addClass(n.hoverClass + " " + s)
                                .filter(function () {
                                    return e(this).children(n.popUpSelector).hide().show().length;
                                })
                                .removeClass(n.pathClass);
                        })(n, a)),
                            n.data("sf-options", a),
                            h(n, a),
                            l(r),
                            d(n),
                            (function (t, s) {
                                var n = "li:has(" + s.popUpSelector + ")";
                                e.fn.hoverIntent && !s.disableHI ? t.hoverIntent(u, f, n) : t.on("mouseenter.superfish", n, u).on("mouseleave.superfish", n, f);
                                var a = "MSPointerDown.superfish";
                                o || (a += " touchend.superfish"), i && (a += " mousedown.superfish"), t.on("focusin.superfish", "li", u).on("focusout.superfish", "li", f).on(a, "a", s, p);
                            })(n, a),
                            r.not("." + s).superfish("hide", !0),
                            a.onInit.call(this);
                    });
                },
            });
    (e.fn.superfish = function (t, s) {
        return g[t] ? g[t].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof t && t ? e.error("Method " + t + " does not exist on jQuery.fn.superfish") : g.init.apply(this, arguments);
    }),
        (e.fn.superfish.defaults = {
            popUpSelector: "ul,.sf-mega",
            hoverClass: "sfHover",
            pathClass: "overrideThisToUse",
            pathLevels: 1,
            delay: 800,
            animation: { opacity: "show" },
            animationOut: { opacity: "hide" },
            speed: "normal",
            speedOut: "fast",
            cssArrows: !0,
            disableHI: !1,
            onInit: e.noop,
            onBeforeShow: e.noop,
            onShow: e.noop,
            onBeforeHide: e.noop,
            onHide: e.noop,
            onIdle: e.noop,
            onDestroy: e.noop,
            dropdownStyle: e('body[data-dropdown-style="minimal"]').length > 0 ? "minimal" : "classic",
        }),
        e.fn.extend({ hideSuperfishUl: g.hide, showSuperfishUl: g.show });
})(jQuery);
!(function (e, t, a) {
    "use strict";
    var n,
        i,
        s = e(t),
        r = e("body"),
        o = e("#slide-out-widget-area"),
        l = e("#slide-out-widget-area-bg"),
        d = e("#header-outer"),
        c = e("#header-secondary-outer"),
        h = e("#header-outer #search-btn a"),
        u = e("#wpadminbar"),
        p = e("#ajax-loading-screen"),
        f = e(".body-border-top"),
        g = e("#page-header-bg"),
        m = e("#footer-outer"),
        v = e(".body-border-right").length > 0 ? e(".body-border-right").width() : 0,
        b = d.is("[data-logo-height]") ? parseInt(d.attr("data-logo-height")) : 30,
        w = d.is("[data-padding]") ? parseInt(d.attr("data-padding")) : 28,
        y = d.is("[data-shrink-num]") ? d.attr("data-shrink-num") : 6,
        _ = !!d.is('[data-condense="true"]'),
        x = !!d.is('[data-using-logo="1"]'),
        C = !!d.is('[data-header-resize="1"]'),
        k = !!d.is('[data-transparent-header="true"]'),
        T = (d.is('[data-mobile-fixed="1"]'), r.is("[data-header-format]") ? r.attr("data-header-format") : "default"),
        $ = r.is("[data-hhun]") ? r.attr("data-hhun") : "",
        I = r.is("[data-cae]") && "swing" !== r.attr("data-cae") ? r.attr("data-cae") : "easeOutCubic",
        E = r.is("[data-cad]") ? r.attr("data-cad") : "650",
        z = !(r.is('[data-m-animate="1"]') || !navigator.userAgent.match(/(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/)),
        O = t.nectarOptions && t.nectarOptions.ocm_btn_position && "left" === t.nectarOptions.ocm_btn_position ? "left" : "default",
        H = [],
        S = [],
        A = [],
        M = [],
        W = [],
        F = [],
        q = [],
        L = [],
        Y = [],
        j = [],
        B = [],
        P = [],
        R = [],
        V = [],
        X = [],
        N = [],
        D = [],
        Q = [],
        Z = [],
        U = [],
        G = [],
        J = [],
        K = [],
        ee = [],
        te = 0,
        ae = "",
        ne = !1,
        ie = !1,
        se = { animating: "false", perspect: "not-rolled", inUse: !1 },
        re = { $usingFullScreenRows: !1 };
    f.length > 0 &&
        (("#ffffff" == f.css("background-color") && "light" == r.attr("data-header-color")) ||
            ("rgb(255, 255, 255)" == f.css("background-color") && "light" == r.attr("data-header-color")) ||
            f.css("background-color") == d.attr("data-user-set-bg")) &&
        (ie = !0);
    var oe = {
        usingMobileBrowser: !!navigator.userAgent.match(/(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/),
        usingFrontEndEditor: void 0 !== t.vc_iframe,
        getWindowSize: function () {
            (oe.winH = t.innerHeight),
                (oe.winW = t.innerWidth),
                (oe.adminBarHeight = u.length > 0 ? u.height() : 0),
                (oe.secondaryHeaderHeight = c.length > 0 && "none" != c.css("display") ? c.outerHeight() : 0),
                (oe.footerOuterHeight = m.length > 0 ? m.outerHeight() : 0);
        },
        scrollTop: 0,
        clientX: 0,
        clientY: 0,
        scrollPosMouse: function () {
            return t.scrollY || s.scrollTop();
        },
        scrollPosRAF: function () {
            (oe.scrollTop = t.scrollY || s.scrollTop()), requestAnimationFrame(oe.scrollPosRAF);
        },
        bindEvents: function () {
            oe.usingMobileBrowser
                ? requestAnimationFrame(oe.scrollPosRAF)
                : (s.on("scroll", function () {
                      oe.scrollTop = oe.scrollPosMouse();
                  }),
                  a.addEventListener("mousemove", function (e) {
                      (oe.clientX = e.clientX), (oe.clientY = e.clientY);
                  })),
                s.on("resize", oe.getWindowSize),
                t.addEventListener("orientationchange", oe.getWindowSize);
        },
        init: function () {
            (u = e("#wpadminbar")),
                this.getWindowSize(),
                (this.usingPhoneBrowser = !!(oe.usingMobileBrowser && oe.winW < 690)),
                (this.scrollTop = this.scrollPosMouse()),
                this.bindEvents(),
                (this.usingFrontEndEditor = void 0 !== t.vc_iframe);
        },
    };
    t.nectarDOMInfo = oe;
    var le,
        de = { materialOffCanvasOpen: !1, materialSearchOpen: !1, permanentTransHeader: !!d.is('[data-permanent-transparent="1"]'), animatedScrolling: !1, preventScroll: !1, ocmOpen: !1, ocmAnimating: !1, ocmInit: !1, mobileHeader: "" };
    function ce() {
        Ot(),
            oe.usingMobileBrowser || $t(),
            un(),
            Ca(),
            e("#header-outer .sf-menu > li:not(.megamenu) > ul > li > ul").each(function () {
                e(this).removeClass("on-left-side"),
                    e(this).offset().left + e(this).outerWidth() > s.width()
                        ? (e(this).addClass("on-left-side"), e(this).find("ul").addClass("on-left-side"))
                        : (e(this).removeClass("on-left-side"), e(this).find("ul").removeClass("on-left-side"));
            }),
            Ce();
    }
    function he() {
        setTimeout(function () {
            $t();
        }, 100);
    }
    function ue() {
        wt(), Ot(), Te(), ca(), oe.usingMobileBrowser || $t();
    }
    function pe() {
        e(".flex-gallery").each(function () {
            if (e().flexslider) {
                var t = e(this);
                imagesLoaded(e(this), function () {
                    var a = !t.find("ul").is('[data-d-autorotate="true"]');
                    t.flexslider({ animation: "fade", smoothHeight: !1, animationSpeed: 500, useCSS: !1, touch: !0, slideshow: a }),
                        e(".flex-gallery .flex-direction-nav li a.flex-next").html('<i class="fa fa-angle-right"></i>'),
                        e(".flex-gallery .flex-direction-nav li a.flex-prev").html('<i class="fa fa-angle-left"></i>');
                });
            }
        });
    }
    function fe(e, t) {
        (this.lastX = oe.clientX),
            (this.lastY = oe.clientY),
            (this.$el = e),
            (this.iconType = t),
            (this.timeout = !1),
            (this.overEl = !1),
            (this.initialCalc = !1),
            (this.styleType = "default"),
            (this.bgElSelector = ""),
            (this.$dragEl = ""),
            (this.$innerParallaxEl = ""),
            (this.parallaxLastX = 0),
            (this.parallaxLastY = 0),
            (this.$viewEl = ""),
            (this.$closeEl = ""),
            (this.lerpDamp = 0.18),
            this.createMarkup(),
            this.setup(),
            this.mouseBind();
    }
    function ge() {
        e('.wpb_gallery_slidesflickity_static_height_style .cell[data-lazy="true"]').each(function () {
            e(this).css({ height: "", width: "" });
            var t = parseInt(e(this).find("img").attr("height")),
                a = qe(parseInt(e(this).find("img").attr("width")), t, 2e3, parseInt(e(this).find("img").height())),
                n = e(this).find(".item-meta").length > 0 ? e(this).find(".item-meta").outerHeight() : 0;
            e(this).css({ height: a.height + n + "px", width: a.width + "px" });
        });
    }
    function me() {
        e('.wpb_gallery_slidesflickity_static_height_style .cell[data-lazy="true"]').length > 0 && (ge(), s.on("smartresize", ge));
    }
    function ve() {
        if (0 == e(".nectar-flickity:not(.masonry)").length) return !1;
        (M = []),
            (W = []),
            e(".nectar-flickity:not(.masonry)").each(function (a) {
                e(this).removeClass(function (e, t) {
                    return (t.match(/(^|\s)instance-\S+/g) || []).join(" ");
                }),
                    e(this).addClass("instance-" + a);
                var n = !(!e(this).is("[data-free-scroll]") || "true" != e(this).attr("data-free-scroll")),
                    i = !0,
                    o = !0,
                    l = 0.025,
                    d = !1,
                    c = !0,
                    h = !0,
                    u = !0,
                    p = "center",
                    f = !1;
                e(this).is('[data-format="fixed_text_content_fullwidth"]') && ((p = "left"), (i = !1), (o = !1), (l = 0.02), e(this).parent().is('[data-alignment="right"]') && (p = "right")),
                    1 == n && (i = !1),
                    e(this).find(".nectar-el-parallax-scroll").length > 0 && e(this).parents('[class*="wpb_gallery_slidesflickity_"]').length > 0 && (i = !1),
                    (e(this).attr("data-controls").length > 0 && "next_prev_arrows" == e(this).attr("data-controls")) || (e(this).attr("data-controls").length > 0 && "next_prev_arrows_overlaid" == e(this).attr("data-controls"))
                        ? ((d = !1), (c = !0))
                        : ((d = !0), (c = !1)),
                    e(this).attr("data-controls").length > 0 && "none" == e(this).attr("data-controls") && ((d = !1), (c = !1));
                var g = !1,
                    m = !1;
                e(this).is("[data-autoplay]") &&
                    "true" == e(this).attr("data-autoplay") &&
                    ((g = !0),
                    (m = 5e3),
                    e(this).is("[data-autoplay-dur]") &&
                        e(this).attr("data-autoplay-dur").length > 0 &&
                        parseInt(e(this).attr("data-autoplay-dur")) > 100 &&
                        parseInt(e(this).attr("data-autoplay-dur")) < 3e4 &&
                        (m = g = parseInt(e(this).attr("data-autoplay-dur"))));
                var v = e(this),
                    b = !(e("body.vc_editor").length > 0),
                    w = e("body.vc_editor").length > 0,
                    y = "",
                    _ = !e(this).is("[data-wrap]") || "no-wrap" != e(this).attr("data-wrap");
                e(this).is('[data-pause-on-hover="true"]') && (w = !0), e(this).is('[data-centered-cells="true"]') && (i = 1);
                var x = !1;
                e(this).is('[data-adaptive-height="true"]') && (x = !0);
                var C = e(this).find("img[data-flickity-lazyload]").length > 0 && 1;
                e(this).find("img[data-flickity-lazyload]").length > 0 && e(this).is('[data-overflow="visible"]') && e(this).is('[data-wrap="no-wrap"]') && (C = 2);
                var k = !!r.hasClass("rtl");
                (y =
                    (e(this).attr("data-controls").length > 0 && "next_prev_arrows_overlaid" == e(this).attr("data-controls")) ||
                    (e(this).attr("data-controls").length > 0 && "touch_total" == e(this).attr("data-controls")) ||
                    e(this).hasClass("nectar-simple-slider")
                        ? { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 }
                        : { x0: 20, x1: 70, y1: 30, x2: 70, y2: 25, x3: 70 }),
                    e(this).is('[data-format="fixed_text_content_fullwidth"]') &&
                        e(this).parents(".full-width-content.wpb_row").length > 0 &&
                        e(this).parents(".full-width-content.wpb_row").removeClass("full-width-content").addClass("full-width-section"),
                    e(this).hasClass("nectar-simple-slider") &&
                        ((x = !1),
                        (d = !1),
                        (c = !1),
                        (h = !1),
                        (_ = !1),
                        (u = !1),
                        (l = 0.022),
                        "true" == e(this).attr("data-pagination") && (d = !0),
                        "true" == e(this).attr("data-wrap") && (_ = !0),
                        e(this).is('[data-simple-slider-transition="fade"]') && (f = !0)),
                    (M[a] = new Flickity(".nectar-flickity.instance-" + a, {
                        setGallerySize: h,
                        contain: o,
                        draggable: b,
                        lazyLoad: C,
                        imagesLoaded: u,
                        percentPosition: !0,
                        adaptiveHeight: x,
                        cellAlign: p,
                        groupCells: i,
                        prevNextButtons: c,
                        freeScroll: n,
                        pageDots: d,
                        resize: !0,
                        selectedAttraction: l,
                        autoPlay: g,
                        rightToLeft: k,
                        pauseAutoPlayOnHover: w,
                        wrapAround: _,
                        accessibility: !1,
                        fade: f,
                        arrowShape: y,
                    })),
                    "true" == v.attr("data-arrows") &&
                        0 == v.find(".flickity-prev-next-button").length &&
                        (v.append(
                            '<button class="flickity-button flickity-prev-next-button previous" aria-label="' +
                                nectar_front_i18n.previous +
                                '" type="button"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>'
                        ),
                        v.append(
                            '<button class="flickity-button flickity-prev-next-button next" aria-label="' +
                                nectar_front_i18n.next +
                                '" type="button"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
                        ),
                        v.find(".flickity-prev-next-button.previous").on("click", function () {
                            if (!1 === _ && 0 == M[a].selectedIndex && (0 == M[a].isAnimating || void 0 === M[a].isAnimating)) {
                                var e = M[a].x;
                                anime({ targets: M[a], x: e + 100, duration: 350, easing: "easeOutCubic" }), M[a].startAnimation();
                            }
                            M[a].previous();
                        }),
                        v.find(".flickity-prev-next-button.next").on("click", function () {
                            if (!1 === _ && M[a].selectedIndex == M[a].slides.length - 1 && 0 == M[a].isAnimating) {
                                var e = M[a].x;
                                anime({ targets: M[a], x: e - 100, duration: 350, easing: "easeOutCubic" }), M[a].startAnimation();
                            }
                            M[a].next();
                        }));
                var T,
                    $,
                    I = "",
                    E = "";
                function z() {
                    var t = e("body.vc_editor").length > 0 ? v.find(".is-selected > .cell") : v.find(".is-selected");
                    I && t && I.css({ transition: "background-color 0.5s ease-out", "background-color": t.is(".has-bg-color") ? t.find(".bg-layer-wrap").css("background-color") : E });
                }
                if (
                    (e(this).is('.nectar-simple-slider[data-row-bg-connection="true"]') &&
                        ((I = (I = e(this).parents(".wpb_row")).find("> .row-bg-wrap .row-bg")), (E = I.length > 0 ? I.css("background-color") : ""), M[a].on("change", z), z()),
                    e(this).hasClass("nectar-simple-slider") && v.find(".bg-layer[data-nectar-img-src]").length > 0)
                )
                    var O = new Waypoint({
                        element: v[0],
                        handler: function () {
                            v.find(".bg-layer[data-nectar-img-src]").each(function () {
                                var t = e(this)[0],
                                    a = t.getAttribute("data-nectar-img-src");
                                (t.style.backgroundImage = "url('" + a + "')"), t.classList.add("loaded");
                            }),
                                O.destroy();
                        },
                        offset: "95%",
                    });
                if (e(this).hasClass("nectar-simple-slider") && e(this).is('[data-parallax="true"]')) {
                    var H = e(this).find(".cell"),
                        S = a;
                    !0 === _ &&
                        v.find(".flickity-prev-next-button").on("click", function () {
                            v.addClass("disabled-nav"),
                                setTimeout(function () {
                                    v.removeClass("disabled-nav");
                                }, 500);
                        });
                    var A = k ? 1 : -1;
                    M[a].on("scroll", function () {
                        e.each(M[a].slides, function (e, t) {
                            var a = H[e].querySelector(".bg-layer"),
                                n = H[e].querySelector(".inner"),
                                i = M[S],
                                s = 0;
                            (s =
                                0 === e
                                    ? Math.abs(i.x) > i.slidesWidth
                                        ? i.slidesWidth + i.x + i.slides[i.slides.length - 1].outerWidth + t.target
                                        : t.target + i.x
                                    : e === i.slides.length - 1 && Math.abs(i.x) + i.slides[e].outerWidth < i.slidesWidth
                                    ? t.target - i.slidesWidth + i.x - i.slides[e].outerWidth
                                    : t.target + i.x),
                                (a.style.transform = "translate3d(" + s * (A / 2) + "px,0,0)"),
                                (n.style.transform = "translate3d(" + s * (A / 4) + "px,0,0)");
                        });
                    });
                }
                if (
                    (e(this).is('.nectar-carousel[data-wrap="no-wrap"]') && e(this).find('.nectar-fancy-box[data-n-parallax-bg="true"]').length > 0) ||
                    (e(this).parents('[class*="wpb_gallery_slidesflickity_"]').length > 0 && e(this).find(".nectar-el-parallax-scroll").length > 0)
                ) {
                    (H = e(this).find(".cell")), (S = a);
                    var F = e(this).find(".nectar-fancy-box").length > 0 ? ".parallax-layer .box-bg" : ".nectar-el-parallax-scroll .img-wrap",
                        q = !!e(this).is('[data-wrap="wrap"]');
                    A = k ? 1 : -1;
                    M[a].on("scroll", function () {
                        e.each(M[a].slides, function (e, t) {
                            var a = H[e].querySelector(F),
                                n = M[S],
                                i = 0;
                            (i =
                                0 === e && q
                                    ? Math.abs(n.x) > n.slidesWidth
                                        ? n.slidesWidth + n.x + n.slides[n.slides.length - 1].outerWidth + t.target
                                        : t.target + n.x
                                    : 1 === e && q
                                    ? Math.abs(n.x) > n.slidesWidth
                                        ? n.slidesWidth + n.x + n.slides[n.slides.length - 2].outerWidth + t.target
                                        : t.target + n.x
                                    : e === n.slides.length - 1 && q
                                    ? Math.abs(n.x) + n.slides[e].outerWidth < n.slidesWidth
                                        ? t.target - n.slidesWidth + n.x - n.slides[e].outerWidth
                                        : t.target + n.x
                                    : e === n.slides.length - 2 && q && Math.abs(n.x) + n.slides[e].outerWidth + n.slides[e + 1].outerWidth < n.slidesWidth
                                    ? t.target - n.slidesWidth + n.x - n.slides[e].outerWidth
                                    : t.target + n.x),
                                a && ((a.style.transform = "translate3d(" + i * (A / 11) + "px,0,0)"), (a.style.willChange = "transform"));
                        });
                    }),
                        M[a].reposition();
                }
                if (
                    (e(this).hasClass("nectar-simple-slider") &&
                        1 == d &&
                        (e(this)
                            .find(".flickity-page-dots li")
                            .append(
                                '<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>'
                            ),
                        m &&
                            (e(this)
                                .find(".flickity-page-dots li circle.time")
                                .css("transition", "stroke-dashoffset " + (parseInt(m) + 100) + "ms linear, stroke 0.2s ease"),
                            e(this).find(".flickity-page-dots li:first").addClass("no-trans"),
                            setTimeout(function () {
                                v.find(".flickity-page-dots li:first").removeClass("no-trans");
                            }, 60),
                            M[a].on("select", function (e) {
                                M[a].playPlayer();
                            }),
                            M[a].on("dragEnd", function (e) {
                                M[a].playPlayer(), v.find(".flickity-page-dots .is-selected").removeClass("no-trans");
                            }),
                            M[a].on("dragStart", function (e) {
                                v.find(".flickity-page-dots .is-selected").addClass("no-trans");
                            }))),
                    e(this).is('[data-controls="touch_total"]') || e(this).is('[data-touch-indicator="true"]'))
                ) {
                    var L = !(!e(this).hasClass("drag-indicator-only") && !e(this).is('[data-r-bottom-total="true"]'));
                    0 != e(this).find(".visualized-total").length ||
                        L ||
                        (e(this).parents(".full-width-content").length > 0 && e(this).parents(".vc_col-sm-12").length > 0
                            ? e(this).append('<div class="container normal-container"><div class="visualized-total"><span></span></div></div>')
                            : e(this).append('<div class="visualized-total"><span></span></div>')),
                        oe.usingMobileBrowser ||
                            ((W[a] = new fe(e(this), "horizontal-movement")),
                            M[a].on("dragMove", function (e, t) {
                                (oe.clientY = t.clientY), (oe.clientX = t.clientX);
                            }),
                            M[a].on("pointerDown", function (t, a) {
                                e(".nectar-drag-indicator").addClass("pointer-down");
                            }),
                            M[a].on("pointerUp", function (t, a) {
                                e(".nectar-drag-indicator").removeClass("pointer-down");
                            }));
                    var Y = e(this).find(".flickity-page-dots li").length,
                        j = e(this).find(".visualized-total span"),
                        B = 1,
                        P = e(this).find(".visualized-total").width();
                    L ||
                        (s.on("smartresize", function () {
                            setTimeout(function () {
                                (Y = v.find(".flickity-page-dots li").length),
                                    (P = v.find(".visualized-total").width()),
                                    (B = (P / Y) * v.find(".flickity-page-dots .is-selected").index()),
                                    j.css("width", 100 / Y + "%"),
                                    j.css({ x: B + "px" });
                            }, 200);
                        }),
                        setTimeout(function () {
                            (Y = v.find(".flickity-page-dots li").length), (P = v.find(".visualized-total").width()), j.css("width", 100 / Y + "%");
                        }, 200),
                        M[a].on("change", function (e, t) {
                            (B = (P / Y) * v.find(".flickity-page-dots .is-selected").index()), j.css({ x: B + "px" });
                        }));
                }
                if (e(this).is('[data-format="fixed_text_content_fullwidth"]') && !oe.usingFrontEndEditor) {
                    var R = oe.usingMobileBrowser;
                    m &&
                        (e(t).on("nectar-material-ocm-open", function () {
                            M[a].stopPlayer();
                        }),
                        e(t).on("nectar-material-ocm-close", function () {
                            M[a].playPlayer();
                        })),
                        M[a].on("scroll", function () {
                            if (!R)
                                if (1 != de.materialOffCanvasOpen) {
                                    var t = v.find(".cell").outerWidth() + 25,
                                        n = e('body[data-header-format="left-header"]').length > 0 && s.width() > 1e3 ? 275 : 0,
                                        i = (s.width() + n - v.parents(".main-content").width()) / 2;
                                    (i += parseInt(v.css("margin-left")) + 2),
                                        M[a].slides.forEach(function (n, s) {
                                            var r = 1,
                                                o = 0,
                                                l = 0,
                                                d = 10,
                                                c = 1,
                                                h = e(n.cells[0].element).offset().left,
                                                u = e(".nectar-flickity.instance-" + a + " .cell:nth-child(" + (s + 1) + ")");
                                            h - i < 0 && h - i > -1 * t ? ((r = 1 + (h - i) / 1500), (c = 1 + (h - i + 70) / 550), (o = -1 * (h - i)), (l = ((h - i) / 25) * -1)) : ((r = 1), (c = 1), (o = 0), (l = 0)),
                                                (d = h + 5 - i < 0 && h - i > -1 * t ? 5 : 10),
                                                u.css({ "z-index": d }),
                                                u.find(".inner-wrap-outer").css({ transform: "perspective(800px) translateX(" + o + "px) rotateY(" + l + "deg) translateZ(0)", opacity: c }),
                                                u.find(".inner-wrap").css({ transform: "scale(" + r + ") translateZ(0)" });
                                        });
                                } else
                                    M[a].slides.forEach(function (t, n) {
                                        var i = e(".nectar-flickity.instance-" + a + " .cell:nth-child(" + (n + 1) + ")");
                                        i.find(".inner-wrap-outer").css({ transform: "perspective(800px) translateX(0) rotateY(0) translateZ(0)", opacity: "1" }), i.find(".inner-wrap").css({ transform: "scale(1) translateZ(0)" });
                                    });
                        });
                }
                M[a].on("dragStart", function () {
                    clearTimeout(T), clearTimeout($), v.addClass("is-dragging"), v.addClass("is-moving"), v.find(".flickity-prev-next-button").addClass("hidden");
                }),
                    M[a].on("dragEnd", function () {
                        v.removeClass("is-dragging"),
                            (T = setTimeout(function () {
                                v.removeClass("is-moving"), v.find(".flickity-prev-next-button").removeClass("hidden");
                            }, 600)),
                            ($ = setTimeout(function () {
                                v.removeClass("is-moving");
                            }, 300));
                    }),
                    e(".flickity-prev-next-button").on("click", function () {
                        clearTimeout(T),
                            e(this).parents(".nectar-flickity").find(".flickity-prev-next-button").addClass("hidden"),
                            (T = setTimeout(function () {
                                v.find(".flickity-prev-next-button").removeClass("hidden");
                            }, 600));
                    }),
                    v.hasClass("nectar-carousel") &&
                        !v.is('[data-adaptive-height="true"]') &&
                        imagesLoaded(v, function () {
                            ye(v);
                        });
            }),
            e(".nectar-carousel.nectar-flickity:not(.masonry)").length > 0 && (oe.usingMobileBrowser ? t.addEventListener("orientationchange", be) : s.on("resize", be)),
            e(".wpb_gallery_slidesflickity_static_height_style .item-meta").length > 0 && (s.on("resize", we), we());
    }
    function be() {
        e('.nectar-carousel.nectar-flickity:not(.masonry):not([data-adaptive-height="true"])').each(function () {
            ye(e(this));
        });
    }
    function we() {
        e(".wpb_gallery_slidesflickity_static_height_style .item-meta").each(function () {
            e(this).css({ width: e(this).parent().find("img").width() });
        });
    }
    function ye(t) {
        var a = 0;
        t.find(".flickity-slider > .cell").css("height", "auto"),
            t.find(".flickity-slider > .cell").each(function () {
                e(this).height() > a && (a = e(this).height());
            }),
            a < 10 && (a = "auto"),
            t.find(".flickity-slider > .cell").css("height", a + "px");
    }
    function _e() {
        e(".twentytwenty-container").each(function () {
            var t = e(this);
            0 == t.find(".twentytwenty-handle").length &&
                e(this).imagesLoaded(function () {
                    t.twentytwenty();
                });
        });
    }
    function xe() {
        var n;
        (Te(), 0 != e('body[data-header-format="left-header"]').length || oe.usingPhoneBrowser) ||
            ((n = !(e('#header-outer[data-megamenu-rt="1"]').length > 0 && e('#header-outer[data-transparent-header="true"]').length > 0)),
            e(".sf-menu:not(.buttons)").superfish({ delay: 500, speed: "fast", disableHI: n, speedOut: "fast", animation: { opacity: "show" } }),
            e("#header-outer .sf-menu.buttons li.menu-item").on("mouseover", function () {
                e(this).addClass("sfHover");
            }),
            e("#header-outer .sf-menu.buttons li.menu-item").on("mouseleave", function () {
                var t = e(this);
                t.is(".menu-item-has-children")
                    ? setTimeout(function () {
                          t.is(":hover") || t.removeClass("sfHover");
                      }, 200)
                    : t.removeClass("sfHover");
            }),
            e('#header-secondary-outer li.megamenu:not(.nectar-megamenu-menu-item), #header-outer:not([data-format="menu-left-aligned"]):not([data-format="centered-logo-between-menu-alt"]) .sf-menu.buttons li.megamenu')
                .removeClass("nectar-megamenu-menu-item")
                .removeClass("megamenu"),
            e('#header-outer[data-format="centered-menu-bottom-bar"] .right-side .sf-menu li.nectar-megamenu-menu-item').removeClass("align-left").removeClass("align-middle").addClass("align-right"),
            e('#header-outer[data-format="centered-menu-bottom-bar"] .left-side .sf-menu li.nectar-megamenu-menu-item').removeClass("align-right").removeClass("align-middle").addClass("align-left"),
            e("#header-outer .sf-menu > li:not(.megamenu) > ul > li > ul").each(function () {
                e(this).offset().left + e(this).outerWidth() > s.width() && (e(this).addClass("on-left-side"), e(this).find("ul").addClass("on-left-side"));
            }),
            e('body:not([data-header-format="left-header"]) header#top nav > ul > li.megamenu > ul > li > ul > li:has("> ul")').addClass("has-ul"),
            e('body[data-megamenu-width="full-width"]').length > 0 && e("ul.sub-menu").length > 0 && (ke(), s.on("smartresize", ke), e("header#top nav > ul > li.megamenu > .sub-menu").css("box-sizing", "content-box")),
            e("header#top nav > ul.sf-menu > li.menu-item").on("mouseenter", function () {
                e(this).addClass("menu-item-over");
            }),
            e("header#top nav > ul.sf-menu > li.menu-item").on("mouseleave", function () {
                e(this).removeClass("menu-item-over");
            }),
            e("#header-outer nav .megamenu .sub-menu a.sf-with-ul .sf-sub-indicator, #header-outer .megamenu .sub-menu a .sf-sub-indicator").remove(),
            e(".sf-menu > .nectar-megamenu-menu-item > a .menu-title-text .megamenu-bg-lazy[data-bg-src]").each(function () {
                var t = e(this).parents(".nectar-megamenu-menu-item"),
                    a = e(this).attr("data-bg-src"),
                    n = e(this).attr("data-align").replace("_", " ");
                t.find("> ul").css({ "background-position": n, "background-image": 'url("' + a + '")' }), e(this).remove();
            }),
            e(".sf-menu > .nectar-megamenu-menu-item > ul > li > a .menu-title-text .megamenu-col-bg-lazy[data-bg-src]").each(function () {
                var t = e(this).closest(".menu-item"),
                    a = e(this).attr("data-bg-src"),
                    n = e(this).attr("data-align").replace("_", " ");
                t.css({ "background-position": n, "background-image": 'url("' + a + '")' }), e(this).remove();
            }),
            e("#header-outer nav > ul > li.megamenu > ul.sub-menu > li > a").each(function () {
                ("-" == e(this).text() || "Ã¢â‚¬â€œ" == e(this).text() || e(this).parent().hasClass("hide-title")) && e(this).remove();
            }));
        if ("IntersectionObserver" in t) {
            var i = new IntersectionObserver(
                function (e) {
                    e.forEach(function (e) {
                        if (e.isIntersecting) {
                            var t = e.target;
                            t.classList.add("loaded");
                            var a = t.getAttribute("data-menu-img-src");
                            a && (t.setAttribute("src", a), t.removeAttribute("data-menu-img-src")), i.unobserve(t);
                        }
                    });
                },
                { rootMargin: "0px", threshold: 0 }
            );
            [].slice.call(a.querySelectorAll(".nectar-menu-icon-img[data-menu-img-src], #header-outer .nectar-ext-menu-item .image-layer")).forEach(function (e) {
                i.observe(e);
            });
        } else
            e(".sf-menu .nectar-menu-icon-img[data-menu-img-src]").each(function () {
                e(this).attr("src", e(this).attr("data-menu-img-src")), e(this).removeAttr("data-menu-img-src");
            }),
                e(".nectar-ext-menu-item .image-layer").addClass("loaded");
        e(".sub-menu .nectar-menu-icon, .sub-menu .nectar-menu-icon-img, .off-canvas-menu-container > ul > li > a .nectar-menu-icon, .off-canvas-menu-container > ul > li > a .nectar-menu-icon-img").each(function () {
            var t = e(this).parent(),
                a = e(this).detach();
            0 == t.parents(".nectar-ext-menu-item").length && (t.wrapInner('<span class="nectar-menu-icon-text" />'), t.addClass("nectar-menu-item-with-icon")), t.prepend(a);
        }),
            e("#slide-out-widget-area:not(.fullscreen) .nectar-menu-label").each(function () {
                0 == e(this).parents(".nectar-ext-menu-item").length && e(this).closest("a").addClass("nectar-menu-item-with-icon");
            }),
            e(".off-canvas-menu-container .nectar-menu-icon, .off-canvas-menu-container .nectar-menu-icon-img").each(function () {
                var t = e(this).parent();
                (t.find(".item_desc").length > 0 || t.find(".nav_desc").length > 0) && t.addClass("nectar-menu-item-with-desc");
            }),
            Ce();
    }
    function Ce() {
        e("nav:not(.left-side):not(.right-side) .sf-menu > .nectar-megamenu-menu-item.align-left:not(.width-100)").each(function () {
            var t = e(this),
                a = e("header#top > .container > .row"),
                n = e(this).find("> ul.sub-menu");
            if (t) {
                if (n.width() + t.offset().left > oe.winW) return e(this).addClass("align-middle"), !0;
                e(this)
                    .find("> ul.sub-menu")
                    .css({ right: a.width() - (t.offset().left + t.width() - a.offset().left) - e(this).find("> ul.sub-menu").width() + t.width(), left: "auto" }),
                    e(this).removeClass("align-middle");
            }
        }),
            e("nav:not(.left-side):not(.right-side) .sf-menu > .nectar-megamenu-menu-item.align-right:not(.width-100)").each(function () {
                var t = e(this),
                    a = e("header#top > .container > .row"),
                    n = e(this).find("> ul.sub-menu");
                if (t) {
                    if (t.offset().left + t.width() - n.width() < 0) return e(this).addClass("align-middle"), !0;
                    e(this)
                        .find("> ul.sub-menu")
                        .css({ right: a.width() - (t.offset().left + t.width() - a.offset().left), left: "auto" }),
                        e(this).removeClass("align-middle");
                }
            }),
            e("nav:not(.left-side):not(.right-side) .sf-menu > .nectar-megamenu-menu-item.align-middle:not(.width-100)").each(function () {
                var t = e(this),
                    a = e("header#top > .container > .row"),
                    n = e(this).find("> ul.sub-menu");
                if (t && n.length > 0) {
                    var i = a.width(),
                        s = a.offset().left,
                        r = t.offset().left,
                        o = t.width(),
                        l = n.width();
                    n.css({ right: i - (r + o - s) - l / 2 + o / 2, left: "auto" });
                    var d = n.offset();
                    d.left < 0 ? n.css({ right: "auto", left: "0px" }) : d.left + l > oe.winW && n.css({ right: "0px", left: "auto" });
                }
            });
    }
    function ke() {
        var t = s.width(),
            a = e("header#top > .container").width();
        e("header#top nav:not(.left-side):not(.right-side) > ul > li.megamenu:not(.width-50):not(.width-75) > .sub-menu").css({
            "padding-left": (t - a) / 2 + "px",
            "padding-right": (t + 2 - a) / 2 + "px",
            width: a,
            left: "-" + (t - a) / 2 + "px",
        });
    }
    function Te() {
        oe.winW < 1e3 && "1" == r.attr("data-responsive")
            ? (r.addClass("mobile"), e("header#top nav").css("display", "none"))
            : (r.removeClass("mobile"), e("header#top nav").css("display", ""), e(".slide-out-widget-area-toggle #toggle-nav .lines-button").removeClass("close"));
    }
    function $e() {
        0 != e(".carousel").length &&
            ("undefined" != typeof SalientRecentProjectsCarousel &&
                e("ul.carousel.portfolio-items").each(function (t) {
                    U[t] = new SalientRecentProjectsCarousel(e(this));
                }),
            e('ul.carousel:not(".clients"):not(.portfolio-items)').each(function () {
                var a,
                    n,
                    i = e(this),
                    s = "true" == e(this).parents(".carousel-wrap").attr("data-full-width") ? "auto" : 3,
                    o = "true" == e(this).parents(".carousel-wrap").attr("data-full-width") ? "auto" : "",
                    l = "true" == e(this).parents(".carousel-wrap").attr("data-full-width") ? 500 : 453,
                    d = "true" == e(this).attr("data-autorotate"),
                    c = !0,
                    h = !0;
                (e("body.ascend").length > 0 && "true" != e(this).parents(".carousel-wrap").attr("data-full-width")) || (e("body.material").length > 0 && "true" != e(this).parents(".carousel-wrap").attr("data-full-width"))
                    ? e(this).find("li").length % 3 == 0
                        ? ((c = !0), (h = !0))
                        : ((c = !1), (h = !0))
                    : ((c = !0), (h = !0)),
                    (a = parseInt(e(this).attr("data-scroll-speed")) ? parseInt(e(this).attr("data-scroll-speed")) : 700),
                    (n = e(this).is("[data-easing]") ? e(this).attr("data-easing") : "linear");
                var u = i;
                0 == i.find("img").length && (u = r),
                    imagesLoaded(u, function () {
                        i
                            .carouFredSel(
                                {
                                    circular: c,
                                    infinite: h,
                                    height: "auto",
                                    responsive: !0,
                                    items: { width: l, visible: { min: 1, max: s } },
                                    swipe: {
                                        onTouch: !0,
                                        onMouse: !0,
                                        options: {
                                            excludedElements: "button, input, select, textarea, .noSwipe",
                                            tap: function (a, n) {
                                                !e(n).attr("href") || e(n).is('[target="_blank"]') || e(n).is('[rel^="prettyPhoto"]') || e(n).is(".magnific-popup") || e(n).is(".magnific") || t.open(e(n).attr("href"), "_self");
                                            },
                                        },
                                        onBefore: function () {
                                            i.find(".work-item").trigger("mouseleave"), i.find(".work-item .work-info a").trigger("mouseup");
                                        },
                                    },
                                    scroll: {
                                        items: o,
                                        easing: n,
                                        duration: a,
                                        onBefore: function () {
                                            ((e("body.ascend").length > 0 && "true" != i.parents(".carousel-wrap").attr("data-full-width")) ||
                                                (e("body.material").length > 0 && "true" != i.parents(".carousel-wrap").attr("data-full-width"))) &&
                                                i
                                                    .parents(".carousel-wrap")
                                                    .find(".item-count .total")
                                                    .html(Math.ceil(i.find("> li").length / i.triggerHandler("currentVisible").length));
                                        },
                                        onAfter: function () {
                                            ((e("body.ascend").length > 0 && "true" != i.parents(".carousel-wrap").attr("data-full-width")) ||
                                                (e("body.material").length > 0 && "true" != i.parents(".carousel-wrap").attr("data-full-width"))) &&
                                                (i
                                                    .parents(".carousel-wrap")
                                                    .find(".item-count .current")
                                                    .html(i.triggerHandler("currentPage") + 1),
                                                i
                                                    .parents(".carousel-wrap")
                                                    .find(".item-count .total")
                                                    .html(Math.ceil(i.find("> li").length / i.triggerHandler("currentVisible").length)));
                                        },
                                    },
                                    prev: {
                                        button: function () {
                                            return i.parents(".carousel-wrap").find(".carousel-prev");
                                        },
                                    },
                                    next: {
                                        button: function () {
                                            return i.parents(".carousel-wrap").find(".carousel-next");
                                        },
                                    },
                                    auto: { play: d },
                                },
                                { transition: !0 }
                            )
                            .animate({ opacity: 1 }, 1300),
                            i.parents(".carousel-wrap").wrap('<div class="carousel-outer">'),
                            "true" == i.parents(".carousel-wrap").attr("data-full-width") && i.parents(".carousel-outer").css("overflow", "visible"),
                            ((e("body.ascend").length > 0 && "true" != i.parents(".carousel-wrap").attr("data-full-width")) || (e("body.material").length > 0 && "true" != i.parents(".carousel-wrap").attr("data-full-width"))) &&
                                e('<div class="item-count"><span class="current">1</span>/<span class="total">' + i.find("> li").length / i.triggerHandler("currentVisible").length + "</span></div>").insertAfter(
                                    i.parents(".carousel-wrap").find(".carousel-prev")
                                ),
                            i.addClass("finished-loading"),
                            He();
                    });
            }),
            s.off("smartresize.carouselHeightCalcs"),
            s.on("smartresize.carouselHeightCalcs", He));
    }
    function Ie() {
        var t = 0,
            a = 0,
            n = ".carousel-wrap .portfolio-items .col .work-info a, .woocommerce .products-carousel ul.products li.product a";
        e(n).on("mousedown", function (e) {
            t = e.clientX;
        }),
            e(n).on("mouseup", function (e) {
                a = e.clientX;
            }),
            e(n).on("click", function () {
                if (Math.abs(t - a) > 10) return !1;
            });
    }
    function Ee() {
        0 !== e(".owl-carousel[data-desktop-cols]").length &&
            e(".owl-carousel[data-desktop-cols]").each(function () {
                e(this).addClass("owl-theme");
                var t = e(this),
                    a = t.attr("data-autorotate"),
                    n = t.attr("data-autorotation-speed"),
                    i = !!t.is('[data-loop="true"]'),
                    s = !!r.hasClass("rtl");
                e(this).owlCarousel({
                    responsive: {
                        0: { items: e(this).attr("data-mobile-cols") },
                        690: { items: e(this).attr("data-tablet-cols") },
                        1000: { items: e(this).attr("data-desktop-small-cols") },
                        1300: { items: e(this).attr("data-desktop-cols") },
                    },
                    autoplay: a,
                    autoplayTimeout: n,
                    loop: i,
                    rtl: s,
                    smartSpeed: 350,
                    onTranslate: function () {
                        t.addClass("moving");
                    },
                    onTranslated: function () {
                        t.removeClass("moving");
                    },
                }),
                    e(this).on("changed.owl.carousel", function (t) {
                        t.item.count - t.page.size == t.item.index && e(t.target).find(".owl-dots div:last").addClass("active").siblings().removeClass("active");
                    });
            });
    }
    function ze(e) {
        var t = e.data.wooFlickity.selectedIndex + 1;
        e.data.wooFlickityCount.text(t + "/" + e.data.wooFlickity.slides.length);
    }
    function Oe() {
        (0 === e(".products-carousel").length && 0 === e(".nectar-woo-flickity").length) ||
            (e(".products-carousel").each(function () {
                var a = e(this).find("ul.products"),
                    n = e(this).parents(".full-width-content ").length > 0 ? 400 : 353,
                    i = a;
                0 == a.find("img").length && (i = r),
                    e(this).append('<a class="carousel-prev" href="#"><i class="icon-salient-left-arrow"></i></a> <a class="carousel-next" href="#"><i class="icon-salient-right-arrow"></i></a>'),
                    imagesLoaded(i, function () {
                        a
                            .carouFredSel({
                                circular: !0,
                                responsive: !0,
                                items: { width: n, visible: { min: 1, max: "auto" } },
                                swipe: {
                                    onTouch: !0,
                                    onMouse: !0,
                                    options: {
                                        excludedElements: "button, input, select, textarea, .noSwipe",
                                        tap: function (a, n) {
                                            !e(n).attr("href") ||
                                                e(n).is('[target="_blank"]') ||
                                                e(n).hasClass("add_to_wishlist") ||
                                                e(n).hasClass("add_to_cart_button") ||
                                                e(n).is('[rel^="prettyPhoto"]') ||
                                                t.open(e(n).attr("href"), "_self"),
                                                !e(n).parent().attr("href") ||
                                                    e(n).parent().is('[target="_blank"]') ||
                                                    e(n).parent().hasClass("add_to_wishlist") ||
                                                    e(n).parent().hasClass("add_to_cart_button") ||
                                                    e(n).parent().is('[rel^="prettyPhoto"]') ||
                                                    t.open(e(n).parent().attr("href"), "_self");
                                        },
                                    },
                                    onBefore: function () {
                                        a.find(".product-wrap").trigger("mouseleave"), a.find(".product a").trigger("mouseup");
                                    },
                                },
                                scroll: { items: "auto", easing: "easeInOutQuart", duration: 800 },
                                prev: {
                                    button: function () {
                                        return a.parents(".carousel-wrap").find(".carousel-prev");
                                    },
                                },
                                next: {
                                    button: function () {
                                        return a.parents(".carousel-wrap").find(".carousel-next");
                                    },
                                },
                                auto: { play: !1 },
                            })
                            .animate({ opacity: 1 }, 1300),
                            a.parents(".carousel-wrap").wrap('<div class="carousel-outer">'),
                            a.addClass("finished-loading"),
                            Ot(),
                            s.trigger("resize");
                    });
            }),
            (R = []),
            e(".nectar-woo-flickity").each(function (a) {
                var n = e(this);
                e(this)
                    .find(".products > li")
                    .each(function () {
                        e(this).wrap('<div class="flickity-cell"></div>');
                    });
                var i = !!n.is('[data-controls="bottom-pagination"]'),
                    s = !n.is('[data-controls="bottom-pagination"]'),
                    o = !n.is('[data-wrap="no-wrap"]'),
                    l = 1 != o || i,
                    d = n.is("[data-autorotate-speed]") && parseInt(n.attr("data-autorotate-speed")) > 800 ? parseInt(n.attr("data-autorotate-speed")) : 5e3;
                n.is('[data-autorotate="true"]') || (d = !1),
                    e(this).find("ul.products").addClass("generate-markup"),
                    (R[a] = e(this).find("ul.products")),
                    n.is('[data-controls="arrows-overlaid"]') && (s = !0),
                    1 == s &&
                        R[a].on("ready.flickity", function () {
                            var e = n.find(".flickity-prev-next-button.previous").detach(),
                                t = n.find(".flickity-prev-next-button.next").detach();
                            n.find(".nectar-woo-carousel-top").append(e).append(t);
                        });
                var c = !1,
                    h = "center";
                r.hasClass("rtl") && ((c = !0), (h = "right")), n.is('[data-group-columns="no-overflow"]') ? ((l = !0), (h = "left")) : n.is('[data-group-columns="overflow"]') && ((l = !1), (h = "center"));
                var u = !1;
                if (
                    (t.nectarOptions &&
                        t.nectarOptions.woo_related_upsell_carousel &&
                        "true" == t.nectarOptions.woo_related_upsell_carousel &&
                        e(this).hasClass("related-upsell-carousel") &&
                        ((u = !0), (o = !1), (l = !0), "center" == h && e(this).find(".products > div").length < 4 && (h = "left"), e(this).find(".products > div").length < 5 && e(this).addClass("desktop-controls-hidden")),
                    R[a].flickity({
                        draggable: !0,
                        contain: !0,
                        lazyLoad: !1,
                        imagesLoaded: !0,
                        cellAlign: h,
                        groupCells: l,
                        prevNextButtons: s,
                        pageDots: i,
                        resize: !0,
                        adaptiveHeight: !1,
                        percentPosition: !0,
                        setGallerySize: !0,
                        rightToLeft: c,
                        wrapAround: o,
                        autoPlay: d,
                        accessibility: !1,
                    }),
                    e(this).is('[data-controls="touch_indicator"]'))
                )
                    oe.usingMobileBrowser ||
                        (W.push(new fe(e(this), "horizontal-movement")),
                        R[a].on("dragMove.flickity", function (e, t) {
                            (oe.clientY = t.clientY), (oe.clientX = t.clientX);
                        }),
                        R[a].on("pointerDown.flickity", function (t, a) {
                            e(".nectar-drag-indicator").addClass("pointer-down");
                        }),
                        R[a].on("pointerUp.flickity", function (t, a) {
                            e(".nectar-drag-indicator").removeClass("pointer-down");
                        }));
                else if (1 == s) {
                    n.find(".flickity-prev-next-button").append(
                        '<svg width="65px" height="65px" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><circle stroke-width="3" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle> <circle class="time" stroke-width="3" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>'
                    );
                    var p = e('<div class="woo-flickity-count" />');
                    1 == u ? n.find("section > h2").append(p) : n.append(p);
                    var f = R[a].data("flickity");
                    ze({ data: { wooFlickity: f, wooFlickityCount: p } }), R[a].on("select.flickity", { wooFlickity: f, wooFlickityCount: p }, ze);
                }
            }));
    }
    function He() {
        e('.carousel.finished-loading:not(".portfolio-items, .clients"), .caroufredsel_wrapper .products.finished-loading').each(function () {
            var t = 0;
            e(this)
                .find("> li")
                .each(function () {
                    e(this).height() > t && (t = e(this).height());
                }),
                e(this).css("height", t + 5),
                e(this)
                    .parents(".caroufredsel_wrapper")
                    .css("height", t + 5),
                ((e("body.ascend").length > 0 && "true" != e(this).parents(".carousel-wrap").attr("data-full-width")) || (e("body.material").length > 0 && "true" != e(this).parents(".carousel-wrap").attr("data-full-width"))) &&
                    (e(this)
                        .parents(".carousel-wrap")
                        .find(".item-count .current")
                        .html(Math.ceil((e(this).triggerHandler("currentPosition") + 1) / e(this).triggerHandler("currentVisible").length)),
                    e(this)
                        .parents(".carousel-wrap")
                        .find(".item-count .total")
                        .html(Math.ceil(e(this).find("> li").length / e(this).triggerHandler("currentVisible").length)));
        });
    }
    function Se() {
        0 !== e(".carousel.clients").length &&
            (e(".carousel.clients").each(function () {
                var t,
                    a = e(this),
                    n = !e(this).hasClass("disable-autorotate");
                (t = parseInt(e(this).attr("data-max")) ? parseInt(e(this).attr("data-max")) : 5), s.width() < 690 && "1" == r.attr("data-responsive") && ((t = 2), e(this).addClass("phone"));
                var i = a;
                0 == a.find("img").length && (i = r),
                    imagesLoaded(i, function () {
                        a
                            .carouFredSel({
                                circular: !0,
                                responsive: !0,
                                items: { height: a.find("> div:first").height(), width: a.find("> div:first").width(), visible: { min: 1, max: t } },
                                swipe: { onTouch: !0, onMouse: !0 },
                                scroll: { items: 1, easing: "easeInOutCubic", duration: "800", pauseOnHover: !0 },
                                auto: { play: n, timeoutDuration: 2700 },
                            })
                            .animate({ opacity: 1 }, 1300),
                            a.addClass("finished-loading"),
                            a.parents(".carousel-wrap").wrap('<div class="carousel-outer">'),
                            s.trigger("resize");
                    });
            }),
            s.off("smartresize.clientsCarouselHeight", Ae),
            s.on("smartresize.clientsCarouselHeight", Ae));
    }
    function Ae() {
        var t = 0;
        e(".carousel.clients.finished-loading").each(function () {
            e(this)
                .find("> div")
                .each(function () {
                    e(this).height() > t && (t = e(this).height());
                }),
                e(this).css("height", t),
                e(this).parent().css("height", t);
        });
    }
    function Me() {
        r.on("mousedown", '.caroufredsel_wrapper, .carousel-wrap[data-full-width="true"] .portfolio-items .col .work-info a, .woocommerce .products-carousel ul.products li.product a', function () {
            e(this).addClass("active");
        }),
            r.on("mouseup", '.caroufredsel_wrapper, .carousel-wrap[data-full-width="true"] .portfolio-items .col .work-info a, .woocommerce .products-carousel ul.products li.product a', function () {
                e(this).removeClass("active");
            }),
            e("body.ascend, body.material").on("mouseover", ".carousel-next", function () {
                e(this).parent().find(".carousel-prev, .item-count").addClass("next-hovered");
            }),
            e("body.ascend, body.material").on("mouseleave", ".carousel-next", function () {
                e(this).parent().find(".carousel-prev, .item-count").removeClass("next-hovered");
            });
    }
    function We(e, t, a) {
        return Math.max(Math.min(e, t), a);
    }
    function Fe(e, t, a) {
        return (1 - a) * e + a * t;
    }
    function qe(e, t, a, n) {
        var i = Math.min(a / e, n / t);
        return { width: e * i, height: t * i };
    }
    function Le(t) {
        if (t) {
            var a = e(t.bold());
            return a.find("script").remove(), a.html();
        }
        return "";
    }
    function Ye() {
        var t;
        if ((r.is('[data-header-format="left-header"]') && oe.winW >= 1e3) || r.is('[data-hhun="1"]') || e(".page-template-template-no-header-footer").length > 0 || e(".page-template-template-no-header").length > 0) t = 0;
        else {
            var a = w - w / 1.8,
                n = d.outerHeight();
            ((c.length > 0 && r.is(".material")) || (c.length > 0 && !r.is(".material") && oe.winW < 1e3)) && (n -= oe.secondaryHeaderHeight),
                (t = d.is('[data-header-resize="1"]') && !d.is(".small-nav") && oe.winW >= 1e3 ? n - (parseInt(y) + 2 * a) : n);
        }
        if (oe.winW >= 1e3 && e('#header-outer[data-condense="true"]').length > 0) {
            var i = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9');
            t = d.height() - (parseInt(i.position().top) - parseInt(d.find("#logo").css("margin-top"))) - parseInt(oe.secondaryHeaderHeight);
        }
        return t;
    }
    function je(e) {
        return ("0" + parseInt(e).toString(16)).slice(-2);
    }
    function Be() {
        return Math.floor(1e4 * Math.random());
    }
    function Pe(e, n, i) {
        var s = t.scrollY || a.documentElement.scrollTop,
            r = ((e = e || 0), (n = n || 2e3), (i = i || "easeOutSine"), 0),
            o = Math.max(0.1, Math.min(Math.abs(s - e) / n, 0.8)),
            l = {
                easeInOutQuint: function (e) {
                    return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 5) : 0.5 * (Math.pow(e - 2, 5) + 2);
                },
            };
        !(function a() {
            var n = (r += 1 / 60) / o,
                d = l[i](n);
            n < 1 ? (requestAnimationFrame(a), t.scrollTo(0, s + (e - s) * d)) : t.scrollTo(0, e);
        })();
    }
    function Re() {
        var t = e("body[data-header-breakpoint]").length > 0 && "1000" != r.attr("data-header-breakpoint") ? parseInt(r.attr("data-header-breakpoint")) : 1e3,
            a = !1;
        return 1e3 != t && oe.winW > 1e3 && oe.winW <= t && (a = !0), a;
    }
    function Ve(e) {
        return e.replace(/"/g, "").replace(/url\(|\)$/gi, "");
    }
    (t.nectarState = de),
        (fe.prototype.setup = function () {
            ("post-grid-images" !== this.iconType && "horizontal-movement" !== this.iconType && "link-indicator" !== this.iconType && "view-indicator" !== this.iconType) || this.viewportTracking();
        }),
        (fe.prototype.viewportTracking = function () {
            var a = this;
            if ("IntersectionObserver" in t) {
                (this.observer = new IntersectionObserver(
                    function (t) {
                        t.forEach(function (t) {
                            t.isIntersecting
                                ? (a.$el.addClass("active").addClass("el-in-view"), a.$el.find(a.bgElSelector).css("visibility", "visible"), (a.activeViewRAF = !0))
                                : (a.$el.find(a.bgElSelector).css("visibility", "hidden"),
                                  (a.activeViewRAF = !1),
                                  a.$el.removeClass("el-in-view"),
                                  0 == e(".el-in-view").length && (a.$dragEl.length > 0 ? a.$dragEl.removeClass("visible") : a.$viewEl.length > 0 && a.$viewEl.removeClass("visible")));
                        });
                    },
                    { rootMargin: "0px", threshold: 0 }
                )),
                    this.observer.observe(this.$el[0]);
            }
        }),
        (fe.prototype.createMarkup = function () {
            var t = this;
            if ("horizontal-movement" === this.iconType) {
                if ((this.$el.is("[data-indicator-bg]") && (this.styleType = "solid"), 0 == e(".nectar-drag-indicator").length)) {
                    var a = e("body > #boxed").length > 0 ? " in-boxed" : "";
                    e("body").append(
                        '<div class="nectar-drag-indicator' +
                            a +
                            '" data-type="' +
                            this.styleType +
                            '"><div class="color-circle"></div><span class="inner-layer"><i class="fa fa-angle-left"></i><i class="fa fa-angle-right"></i></span></div>'
                    ),
                        (this.$dragEl = e(".nectar-drag-indicator")),
                        this.dragRAF();
                } else this.$dragEl = e(".nectar-drag-indicator");
                "default" != this.styleType && (this.$innerParallaxEl = e(".nectar-drag-indicator .inner-layer"));
            }
            if ("view-indicator" === this.iconType || "link-indicator" === this.iconType) {
                if (((this.activeViewRAF = !0), 0 == e(".nectar-view-indicator").length)) {
                    a = e("body > #boxed").length > 0 ? " in-boxed" : "";
                    e("body").append('<div class="nectar-view-indicator' + a + '"><div class="color-circle"></div><span class="inner-layer"></span></div>'),
                        "gallery-zoom-indicator" !== this.iconType && e(".nectar-view-indicator span").text(e(".nectar-post-grid").attr("data-indicator-text")),
                        (this.$viewEl = e(".nectar-view-indicator")),
                        setTimeout(function () {
                            (t.lastY = oe.clientY), (t.lastX = oe.clientX), t.viewRAF();
                        }, 100);
                } else this.$viewEl = e(".nectar-view-indicator");
                this.$innerParallaxEl = e(".nectar-view-indicator .inner-layer");
            }
            if ("close-indicator" === this.iconType) {
                if (0 == e(".nectar-view-indicator").length) {
                    a = e("body > #boxed").length > 0 ? " in-boxed" : "";
                    e("body").append('<div class="nectar-close-indicator' + a + '"><div class="inner"><div class="inner-layer"><i class="icon-salient-m-close"></i></div></div></div>'),
                        (this.$closeEl = e(".nectar-close-indicator")),
                        this.closeRAF();
                } else this.$closeEl = e(".nectar-close-indicator");
                this.$innerParallaxEl = e(".nectar-close-indicator .inner-layer");
            }
            "post-grid-images" === this.iconType &&
                ((this.activeViewRAF = !0),
                (this.bgElSelector = this.$el.hasClass("nectar-category-grid") ? ".nectar-category-grid-item-bg" : ".nectar-post-grid-item-bg-wrap"),
                this.$el.hasClass("mouse-move-bound") ? ((this.$viewEl = this.$el.find(this.bgElSelector)), this.viewRAF()) : ((this.$viewEl = this.$el.find(this.bgElSelector)), this.$el.addClass("mouse-move-bound"), this.viewRAF()));
        }),
        (fe.prototype.mouseBind = function () {
            var t = this;
            if ("horizontal-movement" === this.iconType)
                t.$el.find(".flickity-viewport").on("mouseover", function () {
                    t.$dragEl.attr("data-type", t.styleType), t.$dragEl.addClass("visible");
                    var e = t.$el.is("[data-touch-icon-color]") ? "color-" + t.$el.attr("data-touch-icon-color") : "";
                    if ((t.$dragEl.removeClass("color-dark").removeClass("color-light").removeClass("color-default"), "default" == t.styleType))
                        t.$dragEl.addClass(e), t.$dragEl.find("> span, i").css("color", ""), t.$dragEl.find(".color-circle").css("background-color", "");
                    else if ("solid" == t.styleType) {
                        var a = t.$el.attr("data-indicator-bg");
                        t.$dragEl.find(".color-circle").css("background-color", a), t.$dragEl.find("> span").css("color", a);
                        var n = t.$el.attr("data-indicator-icon");
                        t.$dragEl.find("i").css("color", n);
                    }
                }),
                    t.$el.find(".flickity-viewport").on("mouseleave", function () {
                        t.$dragEl.removeClass("visible");
                    }),
                    t.$el.find(".product-add-to-cart a").on("mouseenter", function () {
                        t.$dragEl.removeClass("visible");
                    }),
                    t.$el.find(".product-add-to-cart a").on("mouseleave", function () {
                        t.$dragEl.addClass("visible");
                    });
            else if ("close-indicator" === this.iconType)
                e("body").on("click", '.team-member[data-style*="bio_fullscreen"]', function () {
                    e(".nectar_team_member_overlay:not(.open)").length > 0 || (t.$closeEl.addClass("visible"), t.$closeEl.find(".inner").addClass("visible"));
                }),
                    e("body").on("click", ".nectar_team_member_overlay:not(.animating)", function () {
                        t.$closeEl.removeClass("visible"), t.$closeEl.find(".inner").removeClass("visible");
                    }),
                    e("body").on("mouseenter", ".nectar_team_member_overlay .bio-inner a", function () {
                        t.$closeEl.removeClass("visible");
                    }),
                    e("body").on("mouseleave", ".nectar_team_member_overlay .bio-inner a", function () {
                        t.$closeEl.addClass("visible");
                    });
            else if ("link-indicator" === this.iconType)
                t.$el.off(),
                    t.$el.on("mouseenter", function () {
                        t.$viewEl.addClass("visible"),
                            t.$viewEl.attr("class", function (e, t) {
                                return t.replace(/(^|\s)style-\S+/g, "");
                            });
                        var e = t.$el.attr("data-indicator-bg"),
                            a = t.$el.attr("data-indicator-icon");
                        t.$viewEl.find(".color-circle").css("background-color", e);
                        var n =
                            '<div class="nectar-cta loaded" data-style="arrow-animation"><span class="link_wrap" style="color: ' +
                            a +
                            '"><svg class="next-arrow" width="20px" height="25px" viewBox="0 0 50 80"><polyline stroke-width="9" fill="none" stroke-linecap="round" stroke-linejoin="round" points="0, 0 45, 40 0, 80"></polyline></svg><span class="line" style="background-color: ' +
                            a +
                            '"></span></span></div>';
                        t.$viewEl.find("span").html(n);
                    }),
                    t.$el.on("mouseleave", function () {
                        t.$viewEl.removeClass("visible");
                    });
            else if ("view-indicator" === this.iconType) {
                var a = t.$el.is("[data-indicator-text-color]") ? t.$el.attr("data-indicator-text-color") : "#fff",
                    n = t.$el.attr("data-indicator-color"),
                    i = t.$el.attr("data-indicator-style");
                t.$el.find(".nectar-post-grid-item").off(),
                    t.$el.find(".nectar-post-grid-item").on("mouseenter", function () {
                        (t.activeViewRAF = !0),
                            t.$viewEl.addClass("visible"),
                            t.$viewEl.find("span").text(e(".nectar-post-grid").attr("data-indicator-text")),
                            t.$viewEl.attr("class", function (e, t) {
                                return t.replace(/(^|\s)style-\S+/g, "");
                            }),
                            t.$viewEl.addClass("style-" + i),
                            "see-through" !== i && (t.$viewEl.find(".color-circle").css("background-color", n), t.$viewEl.find(".inner-layer").css("color", a)),
                            clearTimeout(t.timeout);
                    }),
                    t.$el.find(".nectar-post-grid-item").on("mouseleave", function () {
                        t.timeout = setTimeout(function () {
                            t.$viewEl.removeClass("visible");
                        }, 100);
                    }),
                    t.$el.find(".nectar-post-grid-item .meta-category a").on("mouseenter", function () {
                        t.$viewEl.removeClass("visible");
                    }),
                    t.$el.find(".nectar-post-grid-item .meta-category a").on("mouseleave", function () {
                        t.$viewEl.addClass("visible");
                    });
            } else
                "post-grid-images" === this.iconType &&
                    (t.$el.on("mouseenter", function () {
                        e(this).addClass("mouse-over"), (t.activeViewRAF = !0);
                    }),
                    t.$el.on("mouseleave", function () {
                        e(this).removeClass("mouse-over");
                    }));
        }),
        (fe.prototype.updatePos = function () {
            (this.lastY = Fe(this.lastY, oe.clientY, this.lerpDamp)), (this.lastX = Fe(this.lastX, oe.clientX, this.lerpDamp));
        }),
        (fe.prototype.parallaxIcon = function () {
            (this.parallaxLastX = Fe(this.parallaxLastX, parseInt(oe.clientX) - parseInt(this.lastX), this.lerpDamp) / 1.7),
                (this.parallaxLastY = Fe(this.parallaxLastY, parseInt(oe.clientY) - parseInt(this.lastY), this.lerpDamp) / 1.7),
                this.$innerParallaxEl.length > 0 && (this.$innerParallaxEl[0].style.transform = "translateX(" + We(this.parallaxLastX, 10, -10) + "px) translateY(" + We(this.parallaxLastY, 10, -10) + "px)");
        }),
        (fe.prototype.dragRAF = function () {
            this.updatePos(), (this.$dragEl[0].style.transform = "translateX(" + this.lastX + "px) translateY(" + this.lastY + "px)"), this.parallaxIcon(), requestAnimationFrame(this.dragRAF.bind(this));
        }),
        (fe.prototype.viewRAF = function () {
            if ((this.updatePos(), this.activeViewRAF || "view-indicator" === this.iconType || "link-indicator" === this.iconType)) {
                for (var e = 0; e < this.$viewEl.length; e++) this.$viewEl[e].style.transform = "translateX(" + this.lastX + "px) translateY(" + this.lastY + "px)";
                this.parallaxIcon();
            }
            requestAnimationFrame(this.viewRAF.bind(this));
        }),
        (fe.prototype.closeRAF = function () {
            this.updatePos(), this.$closeEl.css({ transform: "translateX(" + this.lastX + "px) translateY(" + this.lastY + "px)" }), this.parallaxIcon(), requestAnimationFrame(this.closeRAF.bind(this));
        }),
        s.on("orientationchange", function () {
            setTimeout(Ae, 200);
        }),
        (t.requestAnimationFrame =
            t.requestAnimationFrame ||
            t.mozRequestAnimationFrame ||
            t.webkitRequestAnimationFrame ||
            t.msRequestAnimationFrame ||
            function (e) {
                setTimeout(e, 1e3 / 60);
            }),
        e(t).on("resize", function () {
            clearTimeout(le),
                (le = setTimeout(function () {
                    e(t).trigger("smartresize");
                }, 125));
        }),
        (e.fn.smartresize = function (e) {
            return e ? this.on("smartresize", e) : this.trigger("smartresize", ["execAsap"]);
        }),
        (function (e) {
            if (!oe.usingMobileBrowser) {
                var t = { hidden: !1 },
                    a = e.createElement("STYLE"),
                    n = "addEventListener" in e,
                    i = function (t, a) {
                        n ? e.addEventListener(t, a) : e.attachEvent("on" + t, a);
                    },
                    s = function (e) {
                        a.styleSheet ? (a.styleSheet.cssText = e) : (a.innerHTML = e);
                    };
                e.getElementsByTagName("HEAD")[0].appendChild(a),
                    i("mousedown", function () {
                        0 == t.hidden && (s(":focus{outline:0}::-moz-focus-inner{border:0;}"), (t.hidden = !0));
                    }),
                    i("keydown", function () {
                        s(""), (t.hidden = !1);
                    });
            }
        })(a),
        (jQuery.fn.setCursorPosition = function (t) {
            return 0 == this.length ? this : e(this).setSelection(t, t);
        }),
        (jQuery.fn.setSelection = function (e, t) {
            if (0 == this.length) return this;
            var a = this[0];
            if (a.createTextRange) {
                var n = a.createTextRange();
                n.collapse(!0), n.moveEnd("character", t), n.moveStart("character", e), n.select();
            } else a.setSelectionRange && (a.focus(), a.setSelectionRange(e, t));
            return this;
        }),
        e.extend(jQuery.expr.pseudos, {
            transparent: function (t, a, n) {
                return "0" === e(t).css("opacity");
            },
        }),
        (e.cssHooks.color = {
            get: function (e) {
                var n;
                return (
                    e.currentStyle ? (n = e.currentStyle.color) : t.getComputedStyle && (n = a.defaultView.getComputedStyle(e, null).getPropertyValue("color")),
                    -1 == n.search("rgb") ? n : (n = n.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)) ? "#" + je(n[1]) + je(n[2]) + je(n[3]) : void 0
                );
            },
        }),
        (e.cssHooks.backgroundColor = {
            get: function (e) {
                var n;
                return (
                    e.currentStyle ? (n = e.currentStyle.backgroundColor) : t.getComputedStyle && (n = a.defaultView.getComputedStyle(e, null).getPropertyValue("background-color")),
                    -1 == n.search("rgb") ? n : (n = n.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)) ? "#" + je(n[1]) + je(n[2]) + je(n[3]) : void 0
                );
            },
        }),
        (function (e) {
            function n(a, i) {
                var s = e.proxy(this.process, this);
                (this.$body = e("body")),
                    (this.$scrollElement = e(e(a).is("body") ? t : a)),
                    (this.options = e.extend({}, n.DEFAULTS, i)),
                    (this.selector = (this.options.target || "") + " ul li > a"),
                    (this.offsets = []),
                    (this.targets = []),
                    (this.activeTarget = null),
                    (this.scrollHeight = 0),
                    this.$scrollElement.on("scroll.bs.scrollspy", s),
                    (this.pageSubmenuHeight = 0),
                    this.calcPageSubemnu(),
                    this.refresh(),
                    this.process(),
                    e(t).on("resize", this.calcPageSubemnu.bind(this));
            }
            (n.VERSION = "3.2.0"),
                (n.DEFAULTS = { offset: 10 }),
                (n.prototype.calcPageSubemnu = function () {
                    ((e('.page-submenu[data-sticky="true"]').length > 0 && 0 == e('body[data-hhun="1"]').length) || (e('.page-submenu[data-sticky="true"]').length > 0 && e('#header-outer[data-remove-fixed="1"]').length > 0)) &&
                        (this.pageSubmenuHeight = e(".page-submenu").height());
                }),
                (n.prototype.getScrollHeight = function () {
                    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, a.documentElement.scrollHeight);
                }),
                (n.prototype.refresh = function () {
                    var t,
                        a = "offset",
                        n = 0;
                    (null != (t = this.$scrollElement[0]) && t === t.window) || ((a = "position"), (n = this.$scrollElement.scrollTop())), (this.offsets = []), (this.targets = []), (this.scrollHeight = this.getScrollHeight());
                    var i = this;
                    this.$body
                        .find(this.selector)
                        .map(function () {
                            var t = e(this),
                                i = t.data("target") || t.attr("href"),
                                s = /^#./.test(i) && e(i);
                            return (s && s.length && s.is(":visible") && [[s[a]().top + n, i]]) || null;
                        })
                        .sort(function (e, t) {
                            return e[0] - t[0];
                        })
                        .each(function () {
                            i.offsets.push(this[0]), i.targets.push(this[1]);
                        });
                }),
                (n.prototype.process = function () {
                    if (de.preventScroll) return !0;
                    var t,
                        a = oe.scrollTop + this.options.offset + this.pageSubmenuHeight,
                        n = this.getScrollHeight(),
                        i = this.options.offset + n - this.$scrollElement.height() - this.pageSubmenuHeight,
                        s = this.offsets,
                        r = this.targets,
                        o = this.activeTarget;
                    if (this.activeTarget && a < this.offsets[0] && this.offsets[0] > 0)
                        return (this.activeTarget = null), void e(this.selector).parentsUntil(this.options.target, ".current-menu-item").removeClass("current-menu-item").removeClass("sfHover");
                    if ((this.scrollHeight != n && this.refresh(), a >= i)) return o != (t = r[r.length - 1]) && this.activate(t);
                    if (o && a <= s[0]) return o != (t = r[0]) && this.activate(t);
                    for (t = s.length; t--; ) o != r[t] && a >= s[t] && (!s[t + 1] || a <= s[t + 1]) && this.activate(r[t]);
                }),
                (n.prototype.activate = function (t) {
                    (this.activeTarget = t), e(this.selector).parentsUntil(this.options.target, ".current-menu-item").removeClass("current-menu-item").removeClass("sfHover");
                    var a = this.selector + '[data-target="' + t + '"],' + this.selector + '[href="' + t + '"]',
                        n = e(a).parents("li").addClass("current-menu-item");
                    n.parent(".dropdown-menu").length && (n = n.closest("li.dropdown").addClass("current-menu-item")), n.trigger("activate.bs.scrollspy");
                });
            var i = e.fn.scrollspy;
            (e.fn.scrollspy = function (t) {
                return this.each(function () {
                    var a = e(this),
                        i = a.data("bs.scrollspy"),
                        s = "object" == typeof t && t;
                    i || a.data("bs.scrollspy", (i = new n(this, s))), "string" == typeof t && i[t]();
                });
            }),
                (e.fn.scrollspy.Constructor = n),
                (e.fn.scrollspy.noConflict = function () {
                    return (e.fn.scrollspy = i), this;
                });
        })(jQuery);
    var Xe,
        Ne,
        De = (function (e) {
            e = e.split("+").join(" ");
            for (var t, a = {}, n = /[?&]?([^=]+)=([^&]*)/g; (t = n.exec(e)); ) a[decodeURIComponent(t[1])] = decodeURIComponent(t[2]);
            return a;
        })(a.location.search);
    (Xe = jQuery),
        (Ne = Xe(t)),
        (Xe.fn.visible = function (e, t, a) {
            if (!(this.length < 1)) {
                var n = this.length > 1 ? this.eq(0) : this,
                    i = n.get(0),
                    s = Ne.width(),
                    r = Ne.height(),
                    o = ((a = a || "both"), !0 !== t || i.offsetWidth * i.offsetHeight);
                if ("function" == typeof i.getBoundingClientRect) {
                    var l = i.getBoundingClientRect(),
                        d = l.top >= 0 && l.top < r,
                        c = l.bottom > 0 && l.bottom <= r,
                        h = l.left >= 0 && l.left < s,
                        u = l.right > 0 && l.right <= s,
                        p = e ? d || c : d && c,
                        f = e ? h || u : h && u;
                    if ("both" === a) return o && p && f;
                    if ("vertical" === a) return o && p;
                    if ("horizontal" === a) return o && f;
                } else {
                    var g = Ne.scrollTop(),
                        m = g + r,
                        v = Ne.scrollLeft(),
                        b = v + s,
                        w = n.offset(),
                        y = w.top,
                        _ = y + n.height(),
                        x = w.left,
                        C = x + n.width(),
                        k = !0 === e ? _ : y,
                        T = !0 === e ? y : _,
                        $ = !0 === e ? C : x,
                        I = !0 === e ? x : C;
                    if ("both" === a) return !!o && m >= T && k >= g && b >= I && $ >= v;
                    if ("vertical" === a) return !!o && m >= T && k >= g;
                    if ("horizontal" === a) return !!o && b >= I && $ >= v;
                }
            }
        });
    var Qe = function (e, n, i, s, r, o) {
            for (var l = 0, d = ["webkit", "moz", "ms", "o"], c = 0; c < d.length && !t.requestAnimationFrame; ++c)
                (t.requestAnimationFrame = t[d[c] + "RequestAnimationFrame"]), (t.cancelAnimationFrame = t[d[c] + "CancelAnimationFrame"] || t[d[c] + "CancelRequestAnimationFrame"]);
            t.requestAnimationFrame ||
                (t.requestAnimationFrame = function (e) {
                    var a = new Date().getTime(),
                        n = Math.max(0, 16 - (a - l)),
                        i = t.setTimeout(function () {
                            e(a + n);
                        }, n);
                    return (l = a + n), i;
                }),
                t.cancelAnimationFrame ||
                    (t.cancelAnimationFrame = function (e) {
                        clearTimeout(e);
                    });
            var h = this;
            for (var u in ((h.options = { useEasing: !0, useGrouping: !0, separator: ",", decimal: ".", easingFn: null, formattingFn: null }), o)) o.hasOwnProperty(u) && (h.options[u] = o[u]);
            "" === h.options.separator && (h.options.useGrouping = !1),
                h.options.prefix || (h.options.prefix = ""),
                h.options.suffix || (h.options.suffix = ""),
                (h.d = "string" == typeof e ? a.getElementById(e) : e),
                (h.startVal = Number(n)),
                (h.endVal = Number(i)),
                (h.countDown = h.startVal > h.endVal),
                (h.frameVal = h.startVal),
                (h.decimals = Math.max(0, s || 0)),
                (h.dec = Math.pow(10, h.decimals)),
                (h.duration = 1e3 * Number(r) || 2e3),
                (h.formatNumber = function (e) {
                    var t, a, n, i;
                    if (((e = e.toFixed(h.decimals)), (a = (t = (e += "").split("."))[0]), (n = t.length > 1 ? h.options.decimal + t[1] : ""), (i = /(\d+)(\d{3})/), h.options.useGrouping))
                        for (; i.test(a); ) a = a.replace(i, "$1" + h.options.separator + "$2");
                    return h.options.prefix + a + n + h.options.suffix;
                }),
                (h.easeOutExpo = function (e, t, a, n) {
                    return (a * (1 - Math.pow(2, (-10 * e) / n)) * 1024) / 1023 + t;
                }),
                (h.easingFn = h.options.easingFn ? h.options.easingFn : h.easeOutExpo),
                (h.formattingFn = h.options.formattingFn ? h.options.formattingFn : h.formatNumber),
                (h.version = function () {
                    return "1.7.1";
                }),
                (h.printValue = function (e) {
                    var t = h.formattingFn(e);
                    "INPUT" === h.d.tagName ? (this.d.value = t) : "text" === h.d.tagName || "tspan" === h.d.tagName ? (this.d.textContent = t) : (this.d.innerHTML = t);
                }),
                (h.count = function (e) {
                    h.startTime || (h.startTime = e), (h.timestamp = e);
                    var t = e - h.startTime;
                    (h.remaining = h.duration - t),
                        h.options.useEasing
                            ? h.countDown
                                ? (h.frameVal = h.startVal - h.easingFn(t, 0, h.startVal - h.endVal, h.duration))
                                : (h.frameVal = h.easingFn(t, h.startVal, h.endVal - h.startVal, h.duration))
                            : h.countDown
                            ? (h.frameVal = h.startVal - (h.startVal - h.endVal) * (t / h.duration))
                            : (h.frameVal = h.startVal + (h.endVal - h.startVal) * (t / h.duration)),
                        h.countDown ? (h.frameVal = h.frameVal < h.endVal ? h.endVal : h.frameVal) : (h.frameVal = h.frameVal > h.endVal ? h.endVal : h.frameVal),
                        (h.frameVal = Math.round(h.frameVal * h.dec) / h.dec),
                        h.printValue(h.frameVal),
                        t < h.duration ? (h.rAF = requestAnimationFrame(h.count)) : h.callback && h.callback();
                }),
                (h.start = function (e) {
                    return (h.callback = e), (h.rAF = requestAnimationFrame(h.count)), !1;
                }),
                (h.pauseResume = function () {
                    h.paused ? ((h.paused = !1), delete h.startTime, (h.duration = h.remaining), (h.startVal = h.frameVal), requestAnimationFrame(h.count)) : ((h.paused = !0), cancelAnimationFrame(h.rAF));
                }),
                (h.reset = function () {
                    (h.paused = !1), delete h.startTime, (h.startVal = n), cancelAnimationFrame(h.rAF), h.printValue(h.startVal);
                }),
                (h.update = function (e) {
                    cancelAnimationFrame(h.rAF), (h.paused = !1), delete h.startTime, (h.startVal = h.frameVal), (h.endVal = Number(e)), (h.countDown = h.startVal > h.endVal), (h.rAF = requestAnimationFrame(h.count));
                }),
                h.printValue(h.startVal);
        },
        Ze = function (e, t, a, n) {
            return a * ((e = e / n - 1) * e * e + 1) + t;
        };
    function Ue(t, n) {
        if (t.length > 0) {
            var i = a.head || a.getElementsByTagName("head")[0],
                s = a.createElement("style");
            (s.type = "text/css"),
                s.styleSheet ? (s.styleSheet.cssText = t) : s.appendChild(a.createTextNode(t)),
                e(s).attr("id", n),
                e("head")
                    .find("#" + n)
                    .remove(),
                i.appendChild(s);
        }
    }
    function Ge() {
        setTimeout(function () {
            e('body[data-ls="magnific"]').length > 0 || e('body[data-ls="pretty_photo"]').length > 0
                ? (e("a.pp").removeClass("pp").addClass("magnific-popup"),
                  e("a[rel^='prettyPhoto']:not([rel*='_gal']):not([rel*='product-gallery']):not([rel*='prettyPhoto['])").removeAttr("rel").addClass("magnific-popup"),
                  e(".wpb_gallery .wpb_gallery_slidesnectarslider_style").each(function () {
                      e(this).find(".swiper-slide a:not(.ext-url-link)").addClass("pretty_photo");
                  }),
                  e('.wpb_gallery_slides.wpb_flexslider:not([data-onclick="custom_link"])').each(function () {
                      e(this).find(".slides > li > a").addClass("pretty_photo");
                  }),
                  e(".wpb_gallery_slidesflickity_style, .wpb_gallery_slidesflickity_static_height_style").each(function () {
                      e(this).find(".cell > a:not(.ext-url-link)").addClass("pretty_photo");
                  }),
                  e(
                      ".portfolio-items, .wpb_gallery .swiper-slide, .wpb_gallery_slidesflickity_style .cell, .wpb_gallery_slidesflickity_static_height_style .cell, .wpb_gallery_slides.wpb_flexslider ul > li, .wpb_gallery .parallax-grid-item, .nectar-post-grid-item"
                  ).each(function () {
                      e(this).find(".pretty_photo").length > 0
                          ? e(this).find(".pretty_photo").removeClass("pretty_photo").addClass("gallery").addClass("magnific")
                          : e(this).find('a[rel*="prettyPhoto["]').length > 0 && e(this).find('a[rel*="prettyPhoto["]').removeAttr("rel").addClass("gallery").addClass("magnific");
                  }),
                  e("a[data-rel='prettyPhoto[product-gallery]']").each(function () {
                      e(this).removeAttr("data-rel").addClass("magnific").addClass("gallery");
                  }),
                  r.hasClass("nectar-auto-lightbox") &&
                      (e(".gallery").each(function () {
                          0 == e(this).find('.gallery-icon a[rel^="prettyPhoto"]').length &&
                              e(this)
                                  .find('.gallery-item .gallery-icon a[href*=".jpg"], .gallery-item .gallery-icon a[href*=".png"], .gallery-item .gallery-icon a[href*=".gif"], .gallery-item .gallery-icon a[href*=".jpeg"]')
                                  .addClass("magnific")
                                  .addClass("gallery")
                                  .removeClass("pretty_photo");
                      }),
                      e(".main-content img").each(function () {
                          e(this).parent().is("[href]") &&
                              !e(this).parent().is(".magnific-popup") &&
                              0 == e(this).parents(".tiled-gallery").length &&
                              0 == e(this).parents(".product-image").length &&
                              0 == e(this).parents(".iosSlider.product-slider").length &&
                              e(this)
                                  .parent()
                                  .attr("href")
                                  .match(/\.(jpg|png|gif)\b/) &&
                              e(this).parent().addClass("magnific-popup").addClass("image-link");
                      })),
                  e("a.magnific-popup:not(.gallery):not(.nectar_video_lightbox):not(.nectar_video_lightbox_trigger)").magnificPopup({
                      type: "image",
                      callbacks: {
                          imageLoadComplete: function () {
                              var e = this;
                              setTimeout(function () {
                                  e.wrap.addClass("mfp-image-loaded");
                              }, 10);
                          },
                          beforeOpen: function () {
                              this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim");
                          },
                          open: function () {
                              (e.magnificPopup.instance.next = function () {
                                  var t = this;
                                  this.wrap.removeClass("mfp-image-loaded"),
                                      setTimeout(function () {
                                          e.magnificPopup.proto.next.call(t);
                                      }, 100);
                              }),
                                  (e.magnificPopup.instance.prev = function () {
                                      var t = this;
                                      this.wrap.removeClass("mfp-image-loaded"),
                                          setTimeout(function () {
                                              e.magnificPopup.proto.prev.call(t);
                                          }, 100);
                                  });
                          },
                      },
                      fixedContentPos: !1,
                      mainClass: "mfp-zoom-in",
                      removalDelay: 400,
                  }),
                  e(
                      "a.magnific-popup.nectar_video_lightbox, .nectar_video_lightbox_trigger, .magnific_nectar_video_lightbox a.link_text, .swiper-slide a[href*=youtube], .swiper-slide a[href*=vimeo], .nectar-video-box a.full-link.magnific-popup"
                  ).magnificPopup({ type: "iframe", fixedContentPos: !1, mainClass: "mfp-zoom-in", removalDelay: 400 }),
                  e("a.magnific.gallery").each(function () {
                      var t = e(this).closest(".wpb_column").length > 0 ? e(this).closest(".wpb_column") : e(this).parents(".row");
                      t.length > 0 &&
                          !t.hasClass("lightbox-col") &&
                          (t.magnificPopup({
                              type: "image",
                              delegate: "a.magnific",
                              mainClass: "mfp-zoom-in",
                              fixedContentPos: !1,
                              callbacks: {
                                  elementParse: function (t) {
                                      (e(t.el).is("[href]") && -1 != e(t.el).attr("href").indexOf("iframe=true")) || (e(t.el).is("[href]") && -1 != e(t.el).attr("href").indexOf("https://www.youtube.com/watch"))
                                          ? (t.type = "iframe")
                                          : e(t.el).is("[href]") && -1 != e(t.el).attr("href").indexOf("video-popup-")
                                          ? (t.type = "inline")
                                          : (t.type = "image");
                                  },
                                  imageLoadComplete: function () {
                                      var e = this;
                                      setTimeout(function () {
                                          e.wrap.addClass("mfp-image-loaded");
                                      }, 10);
                                  },
                                  beforeOpen: function () {
                                      this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim");
                                  },
                                  open: function () {
                                      if (e(this.content).find(".mejs-video video").length > 0 && e().mediaelementplayer) {
                                          e(this.content).find(".mejs-video video")[0].player.remove();
                                          var t = this;
                                          setTimeout(function () {
                                              e(t.content).find("video").mediaelementplayer(), e(t.content).find(".mejs-video video")[0].player.play();
                                          }, 50);
                                      }
                                      (e.magnificPopup.instance.next = function () {
                                          var t = this;
                                          this.wrap.removeClass("mfp-image-loaded"),
                                              setTimeout(function () {
                                                  e.magnificPopup.proto.next.call(t), e(t.content).find(".mejs-video video").length > 0 && e(t.content).find(".mejs-video video")[0].play();
                                              }, 100);
                                      }),
                                          (e.magnificPopup.instance.prev = function () {
                                              var t = this;
                                              this.wrap.removeClass("mfp-image-loaded"),
                                                  setTimeout(function () {
                                                      e.magnificPopup.proto.prev.call(t), e(t.content).find(".mejs-video video").length > 0 && e(t.content).find(".mejs-video video")[0].play();
                                                  }, 100);
                                          });
                                  },
                                  close: function () {
                                      e(this.content).find(".mejs-video video").length > 0 && e(this.content).find(".mejs-video video")[0].load();
                                  },
                              },
                              removalDelay: 400,
                              gallery: { enabled: !0 },
                          }),
                          t.addClass("lightbox-col"));
                  }))
                : e('body[data-ls="fancybox"]').length > 0 &&
                  (function () {
                      e("a.pp").removeClass("pp").attr("data-fancybox", ""), e("a[rel^='prettyPhoto']:not([rel*='_gal']):not([rel*='product-gallery']):not([rel*='prettyPhoto['])").removeAttr("rel").attr("data-fancybox", "");
                      var t = Be();
                      e(".wpb_gallery .wpb_gallery_slidesnectarslider_style").each(function () {
                          (t = Be()),
                              e(this)
                                  .find(".swiper-slide a:not(.ext-url-link)")
                                  .attr("data-fancybox", "group_" + t);
                      }),
                          e('.wpb_gallery_slides.wpb_flexslider:not([data-onclick="custom_link"])').each(function () {
                              (t = Be()),
                                  e(this)
                                      .find(".slides > li > a")
                                      .attr("data-fancybox", "group_" + t);
                          }),
                          e(".wpb_gallery_slidesflickity_style, .wpb_gallery_slidesflickity_static_height_style").each(function () {
                              (t = Be()),
                                  e(this)
                                      .find(".cell > a:not(.ext-url-link)")
                                      .attr("data-fancybox", "group_" + t);
                          }),
                          e(".portfolio-items, .wpb_gallery_slidesparallax_image_grid, .nectar-post-grid-item").each(function () {
                              (t = Be()),
                                  e(this).find(".pretty_photo").length > 0
                                      ? e(this)
                                            .find(".pretty_photo")
                                            .removeClass("pretty_photo")
                                            .attr("data-fancybox", "group_" + t)
                                      : e(this).find('a[rel*="prettyPhoto["]').length > 0 &&
                                        e(this)
                                            .find('a[rel*="prettyPhoto["]')
                                            .removeAttr("rel")
                                            .attr("data-fancybox", "group_" + t);
                          }),
                          r.hasClass("nectar-auto-lightbox") &&
                              (e(".gallery").each(function () {
                                  if (0 == e(this).find('.gallery-icon a[rel^="prettyPhoto"]').length) {
                                      var t = Be();
                                      e(this)
                                          .find('.gallery-item .gallery-icon a[href*=".jpg"], .gallery-item .gallery-icon a[href*=".png"], .gallery-item .gallery-icon a[href*=".gif"], .gallery-item .gallery-icon a[href*=".jpeg"]')
                                          .attr("data-fancybox", "group_" + t)
                                          .removeClass("pretty_photo");
                                  }
                              }),
                              e(".main-content img").each(function () {
                                  e(this).parent().is("[href]") &&
                                      !e(this).parent().is(".magnific-popup") &&
                                      0 == e(this).parents(".tiled-gallery").length &&
                                      0 == e(this).parents(".product-image").length &&
                                      0 == e(this).parents(".woocommerce-product-gallery").length &&
                                      0 == e(this).parents(".wpb_gallery_slides.wpb_flexslider").length &&
                                      0 == e(this).parents(".iosSlider.product-slider").length &&
                                      e(this)
                                          .parent()
                                          .attr("href")
                                          .match(/\.(jpg|png|gif)\b/) &&
                                      e(this).parent().attr("data-fancybox", "");
                              }));
                      var a = (e("body.admin-bar").length, [60, 100]);
                      oe.winW < 1e3 && (a = [0, 0]),
                          e("[data-fancybox]").fancybox({
                              animationEffect: "zoom-in-out",
                              animationDuration: 350,
                              buttons: ["fullScreen", "zoom", "close"],
                              margin: a,
                              backFocus: !1,
                              loop: !0,
                              caption: function () {
                                  return e(this).attr("title");
                              },
                              hash: !1,
                              beforeLoad: function (t) {
                                  "string" != typeof t.current.src && e.fancybox.close(!0);
                              },
                              mobile: { margin: 0 },
                          });
                  })();
        }, 100);
    }
    function Je() {
        e(ae + " .wpb_animate_when_almost_visible").each(function () {
            var t = e(this),
                a = 1 == ne ? "200%" : "90%",
                n = new Waypoint({
                    element: t[0],
                    handler: function () {
                        (t.parents(".wpb_tab").length > 0 && "hidden" == t.parents(".wpb_tab").css("visibility")) || t.hasClass("animated")
                            ? n.destroy()
                            : (t.addClass("animated"),
                              t.addClass("wpb_start_animation"),
                              n.destroy(),
                              t.is(".nectar-button") &&
                                  e('body[data-button-style*="rounded_shadow"]').length > 0 &&
                                  setTimeout(function () {
                                      t.removeClass("wpb_start_animation");
                                  }, 1100));
                    },
                    offset: a,
                });
        });
    }
    function Ke(e, t) {
        (this.$el = e), (this.duration = t), (this.interval = ""), (this.words = []), (this.state = { activeIndex: 0, sequenceStarted: 0, visible: !1 }), this.setup();
    }
    function et() {
        e(ae + ".nectar-milestone").each(function () {
            var t = 1 == ne ? "250%" : "98%";
            oe.usingMobileBrowser && "98%" == t && (t = "110%");
            var a = e(this),
                n = new Waypoint({
                    element: a[0],
                    handler: function () {
                        if ((a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("animated-in")) n.destroy();
                        else {
                            var t = parseInt(a.find(".number span:not(.symbol)").text().replace(/,/g, ""));
                            if (a.hasClass("motion_blur"))
                                a.find("span").each(function (t) {
                                    var a = e(this);
                                    setTimeout(function () {
                                        a.addClass("in-sight");
                                    }, 200 * t);
                                });
                            else {
                                var i = { easingFn: Ze },
                                    s = a.find(".number span:not(.symbol)")[0];
                                new Qe(s, 0, t, 0, 2.2, i).start();
                            }
                            a.addClass("animated-in"), n.destroy();
                        }
                    },
                    offset: t,
                });
        });
    }
    function tt(e) {
        var t, a, n;
        (t = e.parent()).length ? ((a = t.position().left), (n = t.width())) : (a = n = 0),
            e
                .parent()
                .parent()
                .find(".magic-line")
                .css("transform", "translateX(" + a + "px) scaleX(" + n + ")");
    }
    function at() {
        r.on("click", ".tabbed > ul li:not(.cta-button) a", function (a) {
            if (
                ((function (a) {
                    var n = a.parents("li").index() + 1,
                        i = e("body.vc_editor").length > 0 ? "> .wpb_tab " : "";
                    if (!a.hasClass("active-tab") && !a.hasClass("loading")) {
                        if (
                            (a.parents("ul").find("a").removeClass("active-tab"),
                            a.addClass("active-tab"),
                            a
                                .parents(".tabbed")
                                .find("> div:not(.clear)" + i)
                                .css({ visibility: "hidden", position: "absolute", opacity: "0", left: "-9999px", display: "none" })
                                .removeClass("visible-tab"),
                            e("body.vc_editor").length > 0)
                        ) {
                            var o = a.parent().is("[data-m-id]") ? a.parent().attr("data-m-id") : "";
                            a
                                .parents(".tabbed")
                                .find('> div[data-model-id="' + o + '"]' + i)
                                .css({ visibility: "visible", position: "relative", left: "0", display: "block" })
                                .stop()
                                .transition({ opacity: 1 }, 400)
                                .addClass("visible-tab"),
                                r.is('[data-flex-cols="true"]') || ni();
                        } else
                            a.parents(".tabbed")
                                .find("> div:nth-of-type(" + n + ")" + i)
                                .css({ visibility: "visible", position: "relative", left: "0", display: "block" })
                                .stop()
                                .transition({ opacity: 1 }, 400)
                                .addClass("visible-tab");
                        (a.parents(".tabbed").find("> div:nth-of-type(" + n + ") .iframe-embed").length > 0 || a.parents(".tabbed").find("> div:nth-of-type(" + n + ") .portfolio-items").length > 0) &&
                            setTimeout(function () {
                                s.trigger("resize");
                            }, 10);
                    }
                    if (0 != te) {
                        var l = a.parents(".tabbed").find("> div:nth-of-type(" + n + ")" + i);
                        l.find(".nectar-progress-bar").length > 0 && Lt(),
                            (l.find('.divider-small-border [data-animate="yes"]').length > 0 || l.find('.divider-border [data-animate="yes"]').length > 0) && Pt(),
                            (l.find("img.img-with-animation").length > 0 || l.find(".col.has-animation").length > 0 || l.find(".nectar_cascading_images").length > 0 || l.find(".wpb_column.has-animation").length > 0) && (Mt(), Wt()),
                            (l.find(".parallax-layer").length > 0 || l.parents(".nectar-parallax-enabled").length > 0) && $t(),
                            Ct(),
                            l.find(".nectar-milestone").length > 0 && et(),
                            l.find('.nectar_image_with_hotspots[data-animation="true"]').length > 0 &&
                                (Xt(),
                                setTimeout(function () {
                                    s.trigger("resize");
                                }, 100)),
                            l.find(".nectar-fancy-ul").length > 0 && gt(),
                            l.find(".nectar-split-heading").length > 0 && qt(),
                            l.find('.wpb_column[data-border-animation="true"]').length > 0 && Yt(),
                            l.find(".wpb_animate_when_almost_visible").length > 0 && Je(),
                            l.find(".nectar-animated-title").length > 0 && Jt(),
                            l.find(".nectar-highlighted-text").length > 0 && Kt(),
                            l.find(".nectar_food_menu_item").length > 0 && Bt(),
                            l.find('.nectar-post-grid:not([data-animation="none"])').length > 0 && Gt(),
                            l.find(".nectar-waypoint-el").length > 0 && jt(),
                            a.parents(".wpb_row").length > 0 &&
                                ((l.find(".vc_pie_chart").length > 0 ||
                                    l.find(".wp-video-shortcode").length > 0 ||
                                    l.find(".post-area.masonry .posts-container").length > 0 ||
                                    l.find(".twentytwenty-container").length > 0 ||
                                    a.parents('#nectar_fullscreen_rows[data-content-overflow="scrollbar"]').length > 0 ||
                                    a
                                        .parents(".tabbed")
                                        .find("> div:nth-of-type(" + n + ")")
                                        .find(".wpb_gallery").length > 0 ||
                                    a
                                        .parents(".tabbed")
                                        .find("> div:nth-of-type(" + n + ")")
                                        .find(".swiper-container").length > 0 ||
                                    a.parents(".wpb_row").next().hasClass("parallax_section")) &&
                                    s.trigger("resize"),
                                l.find(".nectar-flickity").length > 0 &&
                                    "undefined" != typeof Flickity &&
                                    a
                                        .parents(".tabbed")
                                        .find("> div:nth-of-type(" + n + ")")
                                        .find(".nectar-flickity")
                                        .each(function () {
                                            Flickity.data(e(this)[0]).resize();
                                        }),
                                l.find(".nectar-woo-flickity").length > 0 &&
                                    "undefined" != typeof Flickity &&
                                    (Flickity.data(
                                        a
                                            .parents(".tabbed")
                                            .find("> div:nth-of-type(" + n + ")")
                                            .find(".nectar-woo-flickity > ul")[0]
                                    ).resize(),
                                    e(t).trigger("nectar-product-filters-layout"))),
                            l.find(".svg-icon-holder").each(function (t) {
                                var a = e(this);
                                setTimeout(function () {
                                    var e = 0;
                                    a.is("[data-animation-delay]") && a.attr("data-animation-delay").length > 0 && "false" != a.attr("data-animation") && (e = a.attr("data-animation-delay")),
                                        clearTimeout(Z[t]),
                                        "false" == a.attr("data-animation")
                                            ? (a.css("opacity", "1"), S[a.find("svg").attr("id").slice(-1)].finish())
                                            : (S[a.find("svg").attr("id").slice(-1)].reset(),
                                              (Z[t] = setTimeout(function () {
                                                  S[a.find("svg").attr("id").slice(-1)].play();
                                              }, e)));
                                }, 150);
                            });
                    }
                    a
                        .parents(".tabbed")
                        .find(".wpb_row")
                        .each(function () {
                            if (void 0 !== e(this).find('[class*="vc_col-"]').first().offset()) {
                                var t = e(this).find('[class*="vc_col-"]').first().offset().left;
                                e(this)
                                    .find('[class*="vc_col-"]')
                                    .each(function () {
                                        e(this).removeClass("no-left-margin"), e(this).offset().left < t + 15 ? e(this).addClass("no-left-margin") : e(this).removeClass("no-left-margin");
                                    });
                            }
                        }),
                        te++,
                        a.parent().parent().find(".magic-line").length > 0 && tt(a),
                        e(t).trigger("nectar-tab-changed");
                })(e(this)),
                void 0 !== a.originalEvent && oe.winW < 1e3 && 0 == re.$usingFullScreenRows)
            ) {
                var n = e(this).closest(".tabbed").find("> ul");
                if (n.height() > 350) {
                    var i = n.offset().top + n.height() - oe.adminBarHeight;
                    e('#header-outer[data-mobile-fixed="1"]').length > 0 && (i = n.offset().top + n.height() - d.outerHeight() - oe.adminBarHeight), Pe(i, 700, "easeInOutQuint");
                }
            }
            return !1;
        }),
            e('a[class*="nectar-tab-trigger"]').on("click", function (t) {
                if (!e(this).is('[href*="#"]') || e(this).attr("href").length < 1) return !0;
                var a = e(this).attr("href");
                (a = (a = a.substr(1)).replace(/\s+/g, "-").replace(/</g, "&lt;").replace(/"/g, "&quot;").toLowerCase()),
                    e(".wpb_tabs_nav").each(function () {
                        e(this)
                            .find("li")
                            .each(function () {
                                var t = e(this).find("a").clone();
                                t.find("svg").remove(), (t = (t = t.text()).replace(/\s+/g, "-").toLowerCase()).length > 0 && "-" === t.substring(0, 1) && (t = t.substring(1)), t == a && e(this).find("a").trigger("click");
                            });
                    }),
                    t.preventDefault();
            }),
            e(".tabbed").each(function () {
                var t;
                e(this)
                    .find(".wpb_tab")
                    .each(function (t) {
                        if (
                            (e(this).is("[data-tab-icon]") &&
                                e(this).attr("data-tab-icon").length > 0 &&
                                0 == e(this).find(".im-icon-wrap.tab-icon").length &&
                                (e(this).parents(".tabbed").addClass("using-icons"),
                                e(this)
                                    .parents(".tabbed")
                                    .find(".wpb_tabs_nav li:nth-child(" + (t + 1) + ") > a")
                                    .prepend('<i class="' + e(this).attr("data-tab-icon") + '"></i>')),
                            e(this).find(".im-icon-wrap.tab-icon").length > 0)
                        ) {
                            var a = e(this).find(".im-icon-wrap.tab-icon").detach();
                            e(this)
                                .parents(".tabbed")
                                .find(".wpb_tabs_nav li:nth-child(" + (t + 1) + ") > a")
                                .prepend(a);
                        }
                    }),
                    e(this).find("> ul li:first-child a").trigger("click"),
                    (t = e(this)),
                    setTimeout(function () {
                        t.is('[data-style="minimal_alt"]') && (t.find("> ul").append('<li class="magic-line" />'), tt(t.find("> ul > li:first-child > a")));
                    }, 100);
            }),
            e('.tabbed[data-style="minimal_alt"]').length > 0 &&
                s.on("smartresize", function () {
                    e('.tabbed[data-style="minimal_alt"]').each(function () {
                        e(this).find("a.active-tab").length > 0 && tt(e(this).find("a.active-tab"));
                    });
                }),
            void 0 !== De.tab &&
                e(".wpb_tabs_nav").each(function () {
                    e(this)
                        .find("li")
                        .each(function () {
                            var t = e(this).find("a").clone(),
                                a = De.tab,
                                n = e(this);
                            t.find("svg").remove(),
                                (t = (t = t.text()).replace(/\s+/g, "-").toLowerCase()).length > 0 && "-" === t.substring(0, 1) && (t = t.substring(1)),
                                t == (a = a.replace(/\s+/g, "-").replace(/</g, "&lt;").replace(/"/g, "&quot;").toLowerCase()) &&
                                    (e(this).find("a").trigger("click"),
                                    setTimeout(function () {
                                        n.find("a").trigger("click");
                                    }, 501));
                        });
                }),
            e(".nectar-scrolling-tabs").each(function (t) {
                oe.usingFrontEndEditor || (J[t] = new nt(e(this)));
            });
        var a = !1;
        r.on("click", ".scrolling-tab-nav-current-item", function () {
            e(this).toggleClass("open"), e(this).siblings(".wpb_tabs_nav").toggle(), Ct();
        }),
            r.on("click", ".nectar-sticky-tabs .wpb_tabs_nav li", function (t) {
                var a = e(this).parents(".wpb_tabs_nav"),
                    n = e(this).parents(".scrolling-tab-nav").find(".scrolling-tab-nav-current-item"),
                    i = e(this).find(".tab-nav-heading").clone();
                n.html(i), void 0 !== t.originalEvent && (e(this).parents(".scrolling-tab-nav").find(".scrolling-tab-nav-current-item").toggleClass("open"), a.toggle());
            }),
            r.on("click", ".nectar-sticky-tabs .wpb_tabs_nav a", function (n) {
                var i = e(this),
                    s = i.parents("li").index() + 1,
                    r = e("body.vc_editor").length > 0 ? "> .wpb_tab " : "",
                    o = i.parents(".nectar-sticky-tabs"),
                    l = o.hasClass("content_animation_fade") ? 200 : 600;
                ((i.parents("li").hasClass("active-tab") || a) && o.hasClass("loaded")) ||
                    ((a = !0),
                    o.find(".wpb_tabs_nav li").removeClass("active-tab"),
                    i.parents("li").addClass("active-tab"),
                    o.find(".scrolling-tab-content  > div").removeClass("previously-active-tab"),
                    o.find(".scrolling-tab-content > div.active-tab").addClass("previously-active-tab").removeClass("active-tab"),
                    o.find(".scrolling-tab-content > div:nth-of-type(" + s + ")" + r).addClass("active-tab"),
                    e(t).trigger("nectar-tab-changed"),
                    setTimeout(function () {
                        a = !1;
                    }, l)),
                    n.preventDefault();
            }),
            e(".nectar-sticky-tabs .wpb_tabs_nav > li:first-child").each(function () {
                e(this).find("a").first().trigger("click");
            }),
            (a = !1),
            e(".nectar-sticky-tabs").addClass("loaded"),
            e(t).on("nectar-tab-changed", ea);
    }
    function nt(e) {
        (this.$el = e),
            (this.$tabContent = e.find(".scrolling-tab-content")),
            (this.$lineEl = e.find(".scrolling-tab-nav .line")),
            (this.observer = null),
            (this.linkFunc = this.$el.hasClass("navigation_func_active_link_only") ? "single_link" : "default"),
            this.domSetup(),
            this.highlightObserve(),
            this.events();
    }
    function it() {
        void 0 !== De.toggle &&
            e(".toggles").each(function () {
                e(this)
                    .find(".toggle")
                    .each(function () {
                        var t = e(this).find("h3 a").clone(),
                            a = De.toggle;
                        e(t).find("i").remove(), (t = (t = t.text()).replace(/\s+/g, "-").toLowerCase()) == (a = a.replace(/\s+/g, "-").replace(/</g, "&lt;").replace(/"/g, "&quot;").toLowerCase()) && e(this).find("h3 a").trigger("click");
                    });
            });
    }
    function st() {
        e(".toggles").each(function () {
            var t = e(this).find(".toggle.open");
            t.length > 0 &&
                t.each(function () {
                    var t = e(this).find("> div")[0];
                    t.style.maxHeight = t.scrollHeight + "px";
                });
        });
    }
    function rt() {
        setTimeout(function () {
            e('.toggles.accordion:not([data-starting="closed"])').each(function () {
                if (0 == e(this).find('.toggle[data-inner-wrap="true"]').length) e(this).find("> .toggle").first().addClass("open").find("> div").show();
                else if (!oe.usingFrontEndEditor) {
                    var t = e(this).find("> .toggle").first();
                    t.addClass("open"), (t.find("> div")[0].style.maxHeight = t.find("> div")[0].scrollHeight + "px");
                }
                e(this).find("> .toggle").first().find("a:not(.nectar-button) i").attr("class", "fa fa-minus-circle");
            }),
                setTimeout(it, 300);
        }, 60),
            e('.toggle[data-inner-wrap="true"]').length > 0 && s.on("smartresize", st);
    }
    function ot(e) {
        (this.$el = e), (this.$innerEl = this.$el.find(" > .n-sticky > .vc_column-inner")), 0 != this.$innerEl.length && ((this.topOffset = 0), this.resizeEvent(), s.on("resize", this.resizeEvent.bind(this)));
    }
    function lt(e, t) {
        (e = String(e).replace(/[^0-9a-f]/gi, "")).length < 6 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), (t = t || 0);
        var a,
            n,
            i = "#";
        for (n = 0; n < 3; n++) (a = parseInt(e.substr(2 * n, 2), 16)), (i += ("00" + (a = Math.round(Math.min(Math.max(0, a + a * t), 255)).toString(16))).substr(a.length));
        return i;
    }
    function dt() {
        e(".nectar-3d-transparent-button").each(function () {
            if ("visible" == e(this).css("visibility")) {
                var t = e(this),
                    a = 0,
                    n = 1.7;
                if ("extra_jumbo" == t.attr("data-size")) {
                    var i;
                    oe.winW < 1e3 && oe.winW > 690
                        ? ((a = 64), (i = 34), t.find(".back-3d rect").attr("stroke-width", "12"), (n = 1.7))
                        : oe.winW <= 690
                        ? ((a = 46), (i = 16), t.find(".back-3d rect").attr("stroke-width", "10"), (n = 1.7))
                        : ((a = 100), (i = 64), t.find(".back-3d rect").attr("stroke-width", "20"), (n = 1.6)),
                        t.find("svg text").attr("font-size", i);
                    var s = e(this).find(".back-3d .button-text")[0].getBoundingClientRect().width,
                        r = 1.5 * i;
                    t.css({ width: s + 1.5 * a + "px", height: r + a + "px" }),
                        t.find("> a").css({ height: r + a + "px" }),
                        t
                            .find(".back-3d svg, .front-3d svg")
                            .css({ width: s + 1.5 * a + "px", height: r + a + "px" })
                            .attr("viewBox", "0 0 " + (s + 1.5 * a) + " " + (r + a)),
                        t.find("svg text").attr("transform", "matrix(1 0 0 1 " + (s + 1.6 * a) / 2 + " " + (r + a) / n + ")"),
                        t.find(".front-3d ").css("transform-origin", "50% 50% -" + (r + a) / 2 + "px"),
                        t.find(".back-3d").css("transform-origin", "50% 50% -" + (r + a) / 2 + "px");
                }
            }
        });
    }
    function ct() {
        if (
            (e('.nectar-cta[data-style="text-reveal-wave"], .menu-item-hover-text-reveal-wave').each(function () {
                e(this)
                    .find(".char")
                    .each(function (t) {
                        e(this).css("animation-delay", 0.015 * t + "s");
                    });
                var t = e(this).is('[data-using-bg="true"]') ? ".link_wrap" : ".link_text";
                e(this).is(".menu-item-hover-text-reveal-wave") && (t = "a"),
                    e(this)
                        .find(t)
                        .on("mouseenter", function () {
                            if (oe.winW > 999) {
                                e(this).removeClass("hover");
                                var t = e(this);
                                setTimeout(function () {
                                    t.addClass("hover");
                                }, 20);
                            }
                        });
            }),
            e(".nectar-link-underline-effect a").on("mouseenter", function () {
                e(this).addClass("accessed");
            }),
            e(".nectar-button.see-through[data-color-override], .nectar-button.see-through-2[data-color-override], .nectar-button.see-through-3[data-color-override]").each(function () {
                var t,
                    a,
                    n = e('body.material[data-button-style^="rounded"]').length > 0;
                if ((e(this).css("visibility", "visible"), e(this).hasClass("see-through-3") && "false" == e(this).attr("data-color-override"))) return !0;
                (t = "false" != e(this).attr("data-color-override") ? e(this).attr("data-color-override") : e(this).parents(".dark").length > 0 ? "#000000" : "#ffffff"),
                    e(this).hasClass("see-through-3") || e(this).css("color", t),
                    e(this).find("i").css("color", t);
                var i = parseInt(t.substring(1), 16),
                    s = e(this).has("[data-hover-color-override]") ? e(this).attr("data-hover-color-override") : "no-override",
                    r = e(this).has("[data-hover-text-color-override]") ? e(this).attr("data-hover-text-color-override") : "#fff",
                    o = (16711680 & i) >> 16,
                    l = (65280 & i) >> 8,
                    d = (255 & i) >> 0,
                    c = e(this).hasClass("see-through-3") ? "1" : "0.75";
                e(this).css("border-color", "rgba(" + o + "," + l + "," + d + "," + c + ")"),
                    n &&
                        e(this)
                            .find("i")
                            .css({ "background-color": "rgba(" + o + "," + l + "," + d + ",1)", "box-shadow": "0px 8px 15px rgba(" + o + "," + l + "," + d + ",0.24)" }),
                    e(this).hasClass("see-through")
                        ? ((a = e(this)),
                          e(this).on("mouseenter touchstart", function () {
                              a.css("border-color", "rgba(" + o + "," + l + "," + d + ",1)");
                          }),
                          e(this).on("mouseleave touchtouchend", function () {
                              a.css("border-color", "rgba(" + o + "," + l + "," + d + ",1)"), (c = e(this).hasClass("see-through-3") ? "1" : "0.75"), a.css("border-color", "rgba(" + o + "," + l + "," + d + "," + c + ")");
                          }))
                        : (e(this).find("i").css("color", r),
                          "no-override" != s
                              ? ((a = e(this)),
                                e(this).on("mouseenter touchstart", function () {
                                    a.css({ "border-color": s, "background-color": s, color: r }), n && a.find("i").css({ "background-color": "", "box-shadow": "" });
                                }),
                                e(this).on("mouseleave touchtouchend", function () {
                                    (c = e(this).hasClass("see-through-3") ? "1" : "0.75"),
                                        n && a.find("i").css({ "background-color": "rgba(" + o + "," + l + "," + d + ",1)", "box-shadow": "0px 8px 15px rgba(" + o + "," + l + "," + d + ",0.24)" }),
                                        a.hasClass("see-through-3")
                                            ? a.css({ "border-color": "rgba(" + o + "," + l + "," + d + "," + c + ")", "background-color": "transparent" })
                                            : a.css({ "border-color": "rgba(" + o + "," + l + "," + d + "," + c + ")", "background-color": "transparent", color: t });
                                }))
                              : ((a = e(this)),
                                e(this).on("mouseenter touchstart", function () {
                                    a.css({ "border-color": s, color: r });
                                }),
                                e(this).on("mouseleave touchtouchend", function () {
                                    (c = a.hasClass("see-through-3") ? "1" : "0.75"), a.css({ "border-color": "rgba(" + o + "," + l + "," + d + "," + c + ")", color: r });
                                })));
            }),
            e(".nectar-button:not(.see-through):not(.see-through-2):not(.see-through-3)[data-color-override]").each(function () {
                if ((e(this).css("visibility", "visible"), "false" != e(this).attr("data-color-override"))) {
                    var t = e(this).attr("data-color-override");
                    e(this).removeClass("accent-color").removeClass("extra-color-1").removeClass("extra-color-2").removeClass("extra-color-3").css("background-color", t);
                }
            }),
            e(".swiper-slide .solid_color_2").length > 0 || e(".tilt-button-inner").length > 0)
        ) {
            var t,
                a = "";
            e(".swiper-slide .solid_color_2 a").each(function (n) {
                e(this).addClass("instance-" + n),
                    (t = "false" != e(this).attr("data-color-override") ? e(this).attr("data-color-override") : e(this).parents(".dark").length > 0 ? "#000000" : "#ffffff"),
                    e(this).css("color", t),
                    e(this).find("i").css("color", t);
                var i = e(this).css("background-color"),
                    s = lt(i, 0.13),
                    r = lt(i, -0.15);
                a += ".swiper-slide .solid_color_2 a.instance-" + n + ":after { background-color: " + s + ";  } .swiper-slide .solid_color_2 a.instance-" + n + ":before { background-color: " + r + "; } ";
            }),
                e(".tilt-button-wrap a").each(function (t) {
                    e(this).addClass("instance-" + t);
                    var n,
                        i = e(this).css("background-color");
                    "false" != e(this).attr("data-color-override") && ((n = e(this).attr("data-color-override")), e(this).css("background-color", n), (i = n));
                    var s = lt(i, 0.13),
                        r = lt(i, -0.15);
                    a += ".tilt-button-wrap a.instance-" + t + ":after { background-color: " + s + ";  } .tilt-button-wrap a.instance-" + t + ":before { background-color: " + r + "; } ";
                }),
                Ue(a, "tilt-button");
        }
        if (e(".nectar-3d-transparent-button").length > 0) {
            var n = "";
            e(".nectar-3d-transparent-button").each(function (t) {
                e(this).on("mouseover", function () {
                    e(this).find("*").css("display", "");
                    var t = e(this);
                    setTimeout(function () {
                        t.find("*").css("display", "block");
                    }, 60);
                }),
                    e(this).on("mouseleave", function () {
                        e(this).find("*").css("display", "block");
                        var t = e(this);
                        setTimeout(function () {
                            t.find("*").css("display", "");
                        }, 60);
                    });
                var a,
                    i = e(this),
                    s = i.attr("data-size"),
                    r = 0,
                    o = 1.5,
                    l = 1.65;
                "large" == s
                    ? ((r = 46), (a = 16), (o = 1.5), (l = 1.7))
                    : "medium" == s
                    ? ((r = 30), (a = 16))
                    : "small" == s
                    ? ((r = 20), (a = 12))
                    : "jumbo" == s
                    ? ((r = 54), (a = 24), (o = 1.5), (l = 1.68))
                    : "extra_jumbo" == s && ((r = 100), (a = 64), (o = 1.6), (l = 1.6)),
                    i.find("svg text").attr("font-size", a);
                var d = e(this).find(".back-3d .button-text")[0].getBoundingClientRect().width,
                    c = 1.5 * a;
                i.css({ width: d + 1.5 * r + "px", height: c + r + "px" }),
                    i.find("> a").css({ height: c + r + "px" }),
                    i
                        .find(".back-3d svg, .front-3d svg")
                        .css({ width: d + 1.5 * r + "px", height: c + r + "px" })
                        .attr("viewBox", "0 0 " + (d + 1.5 * r) + " " + (c + r)),
                    i.find("svg text").attr("transform", "matrix(1 0 0 1 " + (d + r * o) / 2 + " " + (c + r) / l + ")"),
                    i.find(".front-3d, .back-3d").css("transform-origin", "50% 50% -" + (c + r) / 2 + "px"),
                    e(this)
                        .find(".front-3d svg > rect")
                        .attr("id", "masked-rect-id-" + t),
                    e(this)
                        .find(".front-3d defs mask")
                        .attr("id", "button-text-mask-" + t),
                    i.css("visibility", "visible"),
                    (n += "#masked-rect-id-" + t + " { mask: url(#button-text-mask-" + t + "); -webkit-mask: url(#button-text-mask-" + t + ")} ");
            }),
                dt(),
                s.on("smartresize", dt),
                Ue(n, "nectar-td-button");
        }
        setTimeout(function () {
            e('.nectar-button[class*="color-gradient"] .start').removeClass("loading");
        }, 150),
            (navigator.userAgent.toLowerCase().indexOf("firefox") > -1 || navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.match(/Trident\/7\./)) &&
                e('.nectar-button[class*="color-gradient"] .start').addClass("no-text-grad");
    }
    function ht() {
        e(".icon-3x").each(function () {
            e(this)
                .closest(".col")
                .on("mouseenter", function () {
                    e(this).find(".icon-3x").addClass("hovered");
                }),
                e(this)
                    .closest(".col")
                    .on("mouseleave", function () {
                        e(this).find(".icon-3x").removeClass("hovered");
                    });
        }),
            (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.match(/Trident\/7\./)) &&
                e('[class^="icon-"][class*="color-gradient"], .nectar_icon_wrap[data-color*="extra-color-gradient"] .nectar_icon, .nectar-gradient-text').addClass("no-grad");
    }
    function ut() {
        var t = e('body[data-header-format="left-header"]').length > 0 && s.width() > 1e3 ? 275 : 0;
        e(".nectar_team_member_overlay").css({ width: s.width() - t, left: t });
    }
    function pt() {
        var t = "";
        e(".wpb_column").each(function (a) {
            e(this).removeClass(function (e, t) {
                return (t.match(/(^|\s)instance-\S+/g) || []).join(" ");
            }),
                ("true" == e(this).attr("data-has-bg-color") || e(this).is('[data-hover-bg^="#"]')) && e(this).addClass("instance-" + a);
            var n = e(this).find("> .vc_column-inner > .column-bg-overlay-wrap").length > 0 || e(this).find("> .vc_column-inner > .column-bg-overlay").length > 0 ? " > .vc_column-inner " : "",
                i = e(this).find(n + " > .column-bg-overlay-wrap").length > 0 ? "> .column-bg-overlay-wrap " : "";
            "true" == e(this).attr("data-has-bg-color") && (t += ".wpb_column.instance-" + a + n + i + " > .column-bg-overlay { background-color:" + e(this).attr("data-bg-color") + ";  opacity: " + e(this).attr("data-bg-opacity") + "; }"),
                e(this).is('[data-hover-bg^="#"]') &&
                    (t += ".wpb_column.instance-" + a + ":hover " + n + i + " > .column-bg-overlay { background-color: " + e(this).attr("data-hover-bg") + "!important; opacity: " + e(this).attr("data-hover-bg-opacity") + "!important; }");
        }),
            Ue(t, "column-bg-colors");
    }
    function ft() {
        if (e(".morphing-outline").length > 0) {
            var t = "",
                a = e("body.vc_editor").length > 0 ? "" : ">";
            e(".morphing-outline").each(function (n) {
                e(this).removeClass(function (e, t) {
                    return (t.match(/(^|\s)instance-\S+/g) || []).join(" ");
                }),
                    e(this)
                        .addClass("instance-" + n)
                        .css({ visibility: "visible" });
                var i = e(this).find(".inner").width(),
                    s = e(this).find(".inner").height(),
                    r = parseInt(e(this).attr("data-border-thickness")),
                    o = e('body[data-button-style*="rounded"]').length > 0 ? ":hover" : "",
                    l = e('body[data-button-style*="rounded"]').length > 0 ? "" : ":hover";
                (t += "body .morphing-outline.instance-" + n + " .inner > * { color: " + e(this).attr("data-starting-color") + "; } "),
                    (t += "body .morphing-outline.instance-" + n + " .inner:after  { border-width:" + e(this).attr("data-border-thickness") + "px ; border-color: " + e(this).attr("data-starting-color") + "; } "),
                    (t +=
                        "body .wpb_column:hover > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner > *, body .wpb_column:hover > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner > * { color: " +
                        e(this).attr("data-hover-color") +
                        "; } "),
                    (t +=
                        "body .wpb_column:hover > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after, body .wpb_column:hover > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after  { border-color: " +
                        e(this).attr("data-hover-color") +
                        "; } "),
                    (t +=
                        "body .wpb_column" +
                        l +
                        " > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after, body .wpb_column" +
                        l +
                        " > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after { padding: " +
                        ((i + 100 + 2 * r - s) / 2 - r) +
                        "px 50px}"),
                    (t += ".morphing-outline.instance-" + n + " { padding: " + (30 + (i + 80 + 2 * r - s) / 2 - r) + "px 50px}"),
                    (t +=
                        "body .wpb_column" +
                        l +
                        " > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after, body .wpb_column" +
                        l +
                        " > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after { top: -" +
                        parseInt((i + 100 + 2 * r - s) / 2 - r + r) +
                        "px }"),
                    (t +=
                        "body .wpb_column > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after, body .wpb_column > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after { left: -" +
                        parseInt(50 + r) +
                        "px }"),
                    (t +=
                        "body .wpb_column" +
                        o +
                        " > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after, body .wpb_column" +
                        o +
                        " > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after { padding: 50px 50px}"),
                    (t +=
                        "body .wpb_column" +
                        o +
                        " > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after, body .wpb_column" +
                        o +
                        " > .vc_column-inner > .wpb_wrapper " +
                        a +
                        " .morphing-outline.instance-" +
                        n +
                        " .inner:after { top: -" +
                        parseInt(50 + r) +
                        "px }");
            }),
                Ue(t, "morphing-outlines");
        }
    }
    function gt() {
        e(ae + ".nectar-fancy-ul").each(function () {
            var t = e(this).attr("data-animation"),
                a = 0;
            if ((e(this).is("[data-animation-delay]") && e(this).attr("data-animation-delay").length > 0 && "false" != e(this).attr("data-animation") && (a = e(this).attr("data-animation-delay")), "true" == t))
                var n = e(this),
                    i = new Waypoint({
                        element: n[0],
                        handler: function () {
                            (n.parents(".wpb_tab").length > 0 && "hidden" == n.parents(".wpb_tab").css("visibility")) || n.hasClass("animated-in")
                                ? i.destroy()
                                : (setTimeout(function () {
                                      n.find("li").each(function (t) {
                                          e(this)
                                              .delay(220 * t)
                                              .transition({ opacity: "1", left: "0" }, 220, "easeOutCubic");
                                      });
                                  }, a),
                                  n.addClass("animated-in"),
                                  i.destroy());
                        },
                        offset: "bottom-in-view",
                    });
        });
    }
    function mt() {
        e('.nectar-fancy-ul:not([data-list-icon="dot"]):not([data-list-icon="none"])').each(function () {
            var t = e(this).attr("data-list-icon"),
                a = e(this).attr("data-color");
            e(this)
                .find("li")
                .each(function () {
                    e(this).find("> i").remove(), e(this).prepend('<i class="icon-default-style ' + t + " " + a + '"></i> ');
                });
        });
    }
    function vt() {
        e(".nectar-flip-box").each(function () {
            var t = parseInt(e(this).attr("data-min-height")),
                a = e(this).find(".flip-box-front .inner").height();
            e(this).find(".flip-box-back .inner").height() > e(this).find(".flip-box-front .inner").height() && (a = e(this).find(".flip-box-back .inner").height()),
                a >= t - 80
                    ? e(this)
                          .find("> div")
                          .css("height", a + 80)
                    : e(this).find("> div").css("height", "auto"),
                e(this).parent().hasClass("wpb_wrapper") && e(this).parent().css("transform", "translateZ(0)");
        });
    }
    function bt() {
        e('.wpb_row .vc_col-sm-12 .nectar-slider-wrap[data-full-width="true"]').each(function () {
            0 == e(this).parents(".wpb_row.full-width-section").length && 0 == e(this).parents(".wpb_row.full-width-content").length && e(this).parents(".wpb_row").addClass("full-width-section");
        }),
            !oe.usingMobileBrowser &&
                e('body[data-boxed-style="1"]').length > 0 &&
                e("#boxed").length > 0 &&
                e("#boxed").length > 0 &&
                e(".full-width-section[data-top-percent], .full-width-section[data-bottom-percent], .full-width-content[data-top-percent], .full-width-content[data-bottom-percent]").each(function () {
                    var t = e(this).attr("data-top-percent") ? e(this).attr("data-top-percent") : "skip",
                        a = e(this).attr("data-bottom-percent") ? e(this).attr("data-bottom-percent") : "skip";
                    "skip" != t && e(this).css("padding-top", t), "skip" != a && e(this).css("padding-bottom", a);
                });
    }
    function wt() {
        if (0 != e('.carousel-wrap[data-full-width="true"], .portfolio-items[data-col-num="elastic"]:not(.fullwidth-constrained), #boxed .full-width-content').length) {
            var t,
                a,
                n,
                i = oe.winW,
                r = e(".body-border-right").length > 0 && i > 1e3 ? 2 * parseInt(e(".body-border-right").width()) : 0,
                o = e(".container-wrap").length > 0 ? parseInt(e(".container-wrap").outerWidth()) : s.width(),
                l = e("body[data-ext-padding]").length > 0 ? 2 * parseInt(e("body").attr("data-ext-padding")) : 180;
            if (1 == e("#boxed").length) a = (parseInt(e(".container-wrap").width()) - parseInt(e(".main-content").width())) / 2 + 4;
            else {
                var d = e('body[data-ext-responsive="true"]').length > 0 && i >= 1e3 ? l : 0;
                t = o - r <= parseInt(e(".main-content").css("max-width")) ? parseInt(e(".main-content").css("max-width")) : o - r;
                var c = parseInt(e(".main-content").css("max-width"));
                e('body.single-post[data-ext-responsive="true"]').length > 0 && e(".container-wrap.no-sidebar").length > 0 && ((c = e(".post-area").width()), (d = 0)), (a = Math.ceil((t + d - c) / 2));
            }
            e(".carousel-outer").has('.carousel-wrap[data-full-width="true"]').css("overflow", "visible"),
                e('.carousel-wrap[data-full-width="true"], .portfolio-items[data-col-num="elastic"]:not(.fullwidth-constrained), #boxed .full-width-content').each(function () {
                    var s = e('#header-outer[data-format="left-header"]').length > 0 && i >= 1e3 ? parseInt(e('#header-outer[data-format="left-header"]').width()) : 0,
                        r = e(".body-border-right").length > 0 && i > 1e3 ? 2 * parseInt(e(".body-border-right").width()) - 2 : 0;
                    if (1 == e("#boxed").length)
                        (n = 0 == e("#nectar_fullscreen_rows").length ? parseInt(e(".main-content").width()) : parseInt(e(this).parents(".container").width())),
                            e('body.single-post[data-ext-responsive="true"]').length > 0 && e(".container-wrap.no-sidebar").length > 0 && e(this).parents(".post-area").length > 0
                                ? ((c = e(".post-area").width()), (d = 0), (t = o - r), (a = Math.ceil((t + d - c) / 2)))
                                : (a = e(this).parents(".page-submenu").length > 0 ? (parseInt(e(".container-wrap").width()) - n) / 2 : (parseInt(e(".container-wrap").width()) - n) / 2 + 4);
                    else {
                        if (e('body.single-post[data-ext-responsive="true"]').length > 0 && e(".container-wrap.no-sidebar").length > 0 && e(this).parents(".post-area").length > 0) (c = e(".post-area").width()), (d = 0), (t = o - r);
                        else {
                            var h = 0 == e("#nectar_fullscreen_rows").length ? parseInt(e(".main-content").css("max-width")) : parseInt(e(this).parents(".container").css("max-width"));
                            o - r <= h && (t = h), (c = h), (d = e('body[data-ext-responsive="true"]').length > 0 && oe.winW >= 1e3 ? l : 0), s > 0 && (d = e('body[data-ext-responsive="true"]').length > 0 && oe.winW >= 1e3 ? 120 : 0);
                        }
                        a = Math.ceil((t + d - c) / 2);
                    }
                    var u = 0;
                    e(this).hasClass("carousel-wrap") && (u = 1), e(this).hasClass("portfolio-items") && (u = 5);
                    var p = 1 == e("#boxed").length ? n + parseInt(2 * a) : o - r + u;
                    if (
                        (0 == e("#boxed").length &&
                            e(this).hasClass("portfolio-items") &&
                            e(this).is('[data-gutter*="px"]') &&
                            e(this).attr("data-gutter").length > 0 &&
                            "none" != e(this).attr("data-gutter") &&
                            (p = o > 1e3 ? o - r + 3 : o - r),
                        e(this).parent().hasClass("default-style"))
                    )
                        (n = 0 == e("#nectar_fullscreen_rows").length ? parseInt(e(".main-content").width()) : parseInt(e(this).parents(".container").width())),
                            0 != e("#boxed").length
                                ? (p = 1 == e("#boxed").length ? n + parseInt(2 * a) : o + u)
                                : ((p = 1 == e("#boxed").length ? n + parseInt(2 * a) : o - r - 0.025 * (o - r) + u), (t = o - r <= n ? n : o - r - 0.025 * (o - r)), (a = Math.ceil((t - n) / 2)));
                    else if (e(this).parent().hasClass("spaced"))
                        if (((n = 0 == e("#nectar_fullscreen_rows").length ? parseInt(e(".main-content").width()) : parseInt(e(this).parents(".container").width())), 0 != e("#boxed").length))
                            p = 1 == e("#boxed").length ? n + parseInt(2 * a) - 0.02 * o : o + u;
                        else {
                            p = 1 == e("#boxed").length ? n + parseInt(2 * a) : o - r - Math.ceil(0.02 * (o - r)) + u;
                            var f = o - r <= n ? n : o - r - 0.02 * (o - r);
                            a = Math.ceil((f - n) / 2 + 2);
                        }
                    !e(this).parents(".span_9").length > 0 &&
                    !e(this).parent().hasClass("span_3") &&
                    "sidebar-inner" != e(this).parent().attr("id") &&
                    !e(this).find(".nectar-carousel-flickity-fixed-content").length > 0 &&
                    "portfolio-extra" != e(this).parent().attr("id")
                        ? e(".single-product").length > 0 && e(this).parents("#tab-description").length > 0 && 0 == e(this).parents(".full-width-tabs").length
                            ? e(this).css({ visibility: "visible" })
                            : e(this).hasClass("portfolio-items")
                            ? 0 == e(this).parents(".full-width-content").length && e(this).css({ "margin-left": -a, left: 0, width: p, visibility: "visible" })
                            : e("#nectar_fullscreen_rows").length > 0 && e(this).hasClass("wpb_row")
                            ? e(this).css({ "margin-left": -a, width: p, visibility: "visible" })
                            : 0 == e(this).parents(".full-width-content").length && e(this).css({ left: 0, "margin-left": -a, width: p, visibility: "visible" })
                        : "portfolio-extra" == e(this).parent().attr("id") && 0 != e("#full_width_portfolio").length
                        ? !e(this).find(".nectar-carousel-flickity-fixed-content").length > 0 && e(this).css({ left: 0, "margin-left": -a, width: p, visibility: "visible" })
                        : e(this).css({ "margin-left": 0, width: "auto", left: "0", visibility: "visible" });
                });
        }
    }
    function yt() {
        e(".full-width-section.wpb_row, .full-width-content.wpb_row").each(function () {
            if (!e(this).parent().hasClass("span_9") && !e(this).parent().hasClass("span_3") && "sidebar-inner" != e(this).parent().attr("id")) {
                if (e(this).parents("#portfolio-extra").length > 0 && 0 == e("#full_width_portfolio").length) return !1;
                if ("0" == e(this).index() && 0 == g.length && 0 == e(".page-header-no-bg").length && 0 == e(".project-title").length && 0 == e("body.single").length && 0 == e(".project-title").length) {
                    e(this).addClass("first-section");
                    var t = e(this);
                    setTimeout(function () {
                        t.addClass("loaded");
                    }, 50);
                }
            }
        });
    }
    function _t(e) {
        if (
            ((this.$element = e),
            (this.$elementInner = e.find("> .vc_column-inner")),
            (this.inView = !1),
            (this.topLevel = !1),
            (this.lastY = 0),
            (this.lerp = e.data("scroll-animation-lerp") ? parseFloat(e.data("scroll-animation-lerp")) : 0.28),
            (this.intensity = e.data("scroll-animation-intensity") ? Math.max(Math.min(parseFloat(e.data("scroll-animation-intensity")), 5), -5) : 3),
            (this.intensity = this.intensity / 10),
            (this.storedWinH = oe.winH),
            (this.type = "translateY"),
            (this.persistOnMobile = !(!e.is("[data-scroll-animation-mobile]") || "true" != e.attr("data-scroll-animation-mobile"))),
            !oe.usingMobileBrowser || 0 != this.persistOnMobile)
        ) {
            this.setType(),
                this.calculatePos(),
                this.trackView(),
                this.animate(),
                0 == this.$element.parents(".wpb_column.has-animation").length && setInterval(this.calculatePos.bind(this), 1e3),
                s.on("resize", this.calculatePos.bind(this));
            var a = this;
            t.addEventListener("orientationchange", function () {
                this.setTimeout(function () {
                    a.orientationChange();
                }, 80);
            });
        }
    }
    function xt(e, t, a, n) {
        (this.$el = e),
            (this.$parallaxEl = this.$el.find(t)),
            (this.firstSection = !1),
            (this.nestedParallax = !1),
            (this.type = n),
            (this.speed = a),
            (this.storedWinH = oe.winH),
            e.parents(".nectar-sticky-tabs").length > 0 || e.parents(".nectar-sticky-column-css").length > 0 || (this.setup(), this.update());
    }
    function Ct() {
        for (var e = 0; e < j.length; e++) j[e].resize();
        for (e = 0; e < B.length; e++) B[e].calculatePos();
    }
    function kt(e) {
        var t;
        switch (e) {
            case "slow":
                t = 0.6;
                break;
            case "medium":
                t = 0.4;
                break;
            case "medium_fast":
                t = 0.28;
                break;
            case "fast":
                t = 0.2;
                break;
            case "mid_subtle":
                t = 0.15;
                break;
            case "subtle":
                t = 0.13;
                break;
            case "very_subtle":
                t = 0.12;
                break;
            case "minimum":
                t = 0.09;
        }
        return t;
    }
    function Tt() {
        if (!(oe.usingMobileBrowser && e('body[data-remove-m-parallax="1"]').length > 0)) {
            (B = []),
                e('.wpb_column[data-scroll-animation="true"], .nectar-el-parallax-scroll[data-scroll-animation="true"]').each(function (t) {
                    imagesLoaded(e(this), function (a) {
                        e(a.elements[0]).is('[data-scroll-animation="true"]') && 0 == e("#nectar_fullscreen_rows").length && (B[t] = new _t(e(a.elements[0])));
                    });
                }),
                $t();
            var t = 0;
            e(
                '.nectar-recent-posts-single_featured, [data-n-parallax-bg="true"], .wpb_row.parallax_section, #page-header-bg[data-parallax="1"] .page-header-bg-image-wrap, #page-header-bg[data-parallax="1"] .nectar-video-wrap, .parallax_slider_outer .nectar-slider-wrap'
            ).each(function () {
                e(this).is("[data-n-parallax-bg][data-parallax-speed]")
                    ? ((j[t] = new xt(e(this), ".parallax-layer", kt(e(this).attr("data-parallax-speed")), "regular")), t++)
                    : 0 == e(this).find('[data-parallax-speed="fixed"]').length &&
                      (e(this).hasClass("nectar-slider-wrap")
                          ? (j[t] = new xt(e(this), ".video-wrap, .image-bg", 0.25, "nectar-slider"))
                          : e(this).hasClass("page-header-bg-image-wrap")
                          ? (j[t] = new xt(e(this), ".page-header-bg-image", 0.25, "page-header"))
                          : e(this).hasClass("nectar-video-wrap") && e(this).parents("#page-header-bg").length > 0
                          ? (j[t] = new xt(e(this), ".nectar-video-bg", 0.25, "page-header"))
                          : (j[t] = new xt(e(this), ".row-bg.using-image", kt(e(this).find(".row-bg").attr("data-parallax-speed")), "regular")),
                      t++),
                    e(this).addClass("nectar-parallax-enabled");
            }),
                e(".woocommerce-tabs .wc-tabs li").on("click", function () {
                    setTimeout($t, 100);
                });
        }
    }
    function $t() {
        (oe.usingMobileBrowser && e('body[data-remove-m-parallax="1"]').length > 0) ||
            e('.nectar-recent-posts-single_featured, [data-n-parallax-bg="true"], .wpb_row.parallax_section, #page-header-bg[data-parallax="1"] .page-header-bg-image-wrap, .parallax_slider_outer .nectar-slider-wrap .slide-bg-wrap').each(
                function () {
                    var t;
                    if ((e(this).parents(".wpb_tab:not(.visible-tab)").length > 0 && 0 == e(this).parents(".nectar-scrolling-tabs").length) || (e(this).parents(".wc-tab").length > 0 && "block" !== e(this).parents(".wc-tab").css("display")))
                        return !0;
                    if (0 == e(this).find(".row-bg").length && e(this).find(".page-header-bg-image").length > 0);
                    else if (0 == e(this).find(".row-bg").length && e(this).find(".image-bg").length > 0)
                        (t = !1),
                            0 == e(".wpb_row").length &&
                                e(this).parents('.nectar-slider-wrap[data-full-width="true"]').length > 0 &&
                                e(this).parents(".parallax_slider_outer").length > 0 &&
                                "1" == e(this).parents(".parallax_slider_outer").index() &&
                                (t = !0),
                            e("#portfolio-extra").length > 0 && e(this).parents(".wpb_row").length > 0 && e(this).parents(".parallax_slider_outer").length > 0 && "0" == e(this).parents(".wpb_row").index() && (t = !0),
                            (e(this).parents(".top-level").length > 0 && !oe.usingFrontEndEditor) || (t && !oe.usingFrontEndEditor)
                                ? e(this)
                                      .find(".image-bg")
                                      .css({ height: Math.ceil(0.25 * e(this).parent().offset().top) + e(this).outerHeight(!0) })
                                : e(this)
                                      .find(".image-bg")
                                      .css({ height: Math.ceil(0.25 * s.height()) + e(this).outerHeight(!0) });
                    else if (0 == e(this).find(".row-bg").length && e(this).find(".video-wrap").length > 0) {
                        (t = !1),
                            0 == e(".wpb_row").length &&
                                e(this).parents('.nectar-slider-wrap[data-full-width="true"]').length > 0 &&
                                e(this).parents(".parallax_slider_outer").length > 0 &&
                                "1" == e(this).parents(".parallax_slider_outer").index() &&
                                (t = !0),
                            e("#portfolio-extra").length > 0 && e(this).parents(".wpb_row").length > 0 && e(this).parents(".parallax_slider_outer").length > 0 && "0" == e(this).parents(".wpb_row").index() && (t = !0),
                            (e(this).parents(".top-level").length > 0 && !oe.usingFrontEndEditor) || (t && !oe.usingFrontEndEditor)
                                ? e(this)
                                      .find(".video-wrap")
                                      .css({ height: Math.ceil(0.25 * e(this).parent().offset().top) + e(this).outerHeight(!0) })
                                : e(this)
                                      .find(".video-wrap")
                                      .css({ height: Math.ceil(0.25 * oe.winH) + e(this).outerHeight(!0) });
                        var a = e(this).find(".video-wrap video"),
                            n = a.parent().width() / 1280,
                            i = a.parent().height() / 720,
                            r = n > i ? n : i;
                        a.width(1280 * r), a.height(720 * r);
                    } else if (e(this).is(".nectar-recent-posts-single_featured") && e(this).parents(".top-level").length > 0 && !oe.usingFrontEndEditor);
                    else if (e(this).is(".nectar-simple-slider") && e(this).parents(".top-level").length > 0 && !oe.usingFrontEndEditor);
                    else if (e(this).is(".column-image-bg-wrap") && e(this).parents(".top-level").length > 0 && e(this).parent().parent().is(".vc_col-sm-12:not(.child_column)"));
                    else if (!e(this).hasClass("top-level") || oe.usingFrontEndEditor || e(this).find(".parallax-layer").length > 0) {
                        var o = ".row-bg",
                            l = e(this).find(".row-bg").attr("data-parallax-speed");
                        e(this).find(".parallax-layer").length > 0 && !e(this).hasClass("wpb_row") && ((o = ".parallax-layer"), (l = e(this).attr("data-parallax-speed")));
                        var d = e(this).find(o + '[data-parallax-speed="fast"]').length > 0 ? 60 : 0;
                        e(this)
                            .find(o)
                            .css({ height: Math.ceil(oe.winH * kt(l)) + e(this).outerHeight(!0) + d });
                    }
                }
            );
    }
    function It() {
        e('.wpb_wrapper > .nectar-slider-wrap[data-full-width="true"]').each(function () {
            e(this).parent().hasClass("span_9") || e(this).parent().hasClass("span_3") || "sidebar-inner" == e(this).parent().attr("id") || ("0" == e(this).parents(".wpb_row").index() && e(this).addClass("first-nectar-slider"));
        });
        var t = 0 == e("#portfolio-extra").length ? e(".main-content > .row > *").length : e(".main-content > .row #portfolio-extra > *").length;
        (t =
            0 == e("#portfolio-extra").length ? (e(".main-content > .row > .wpb_row").length > 0 ? e(".main-content > .row > .wpb_row").length : e(".main-content > .row > *").length) : e(".main-content > .row #portfolio-extra > *").length),
            e(
                '.container-wrap .full-width-section, .container-wrap .full-width-content:not(.page-submenu .full-width-content):not(.blog-fullwidth-wrap), .row > .nectar-slider-wrap[data-full-width="true"], .wpb_wrapper > .nectar-slider-wrap[data-full-width="true"], .portfolio-items[data-col-num="elastic"]'
            ).each(function () {
                if (e(this).parents(".nectar-global-section.before-footer").length > 0) return !0;
                if (!e(this).parent().hasClass("span_9") && !e(this).parent().hasClass("span_3") && "sidebar-inner" != e(this).parent().attr("id"))
                    if (e(this).parents(".wpb_row").length > 0) {
                        if (e(this).parents("#portfolio-extra").length > 0 && 0 == e("#full_width_portfolio").length) return !1;
                        ("0" == e(this).parents(".wpb_row").index() && 0 != g.length) ||
                            ("0" == e(this).parents(".wpb_row").index() &&
                                0 == g.length &&
                                0 == e(".page-header-no-bg").length &&
                                0 == e(".project-title").length &&
                                "0" == e(this).parents(".wpb_row").index() &&
                                0 == e(".project-title").length &&
                                0 == e('body[data-bg-header="true"]').length &&
                                (0 == e(".single").length ? e(".container-wrap").css("padding-top", "0px") : e(this).addClass("first-section"))),
                            e(this).parents(".wpb_row").index() == t - 1 &&
                                0 == e("#respond").length &&
                                "portfolio-filters-inline" != e(this).attr("id") &&
                                (e(".container-wrap").css("padding-bottom", "0px"), e("#call-to-action .triangle").remove());
                    } else {
                        if (e(this).parents("#portfolio-extra").length > 0 && 0 == e("#full_width_portfolio").length) return !1;
                        0 == e(this).find(".portfolio-filters-inline").length &&
                            "post-area" != e(this).attr("id") &&
                            (("0" == e(this).index() && 0 != g.length) ||
                                "0" != e(this).index() ||
                                0 != g.length ||
                                "0" != e(this).index() ||
                                0 != e(".page-header-no-bg").length ||
                                "0" != e(this).index() ||
                                e(this).hasClass("blog_next_prev_buttons") ||
                                e(this).hasClass("nectar-shop-outer") ||
                                0 != e(this).parents(".pum-container").length ||
                                ((1 == e('body[data-header-resize="0"]').length && 0 == e(".single").length) || (e("body.material").length > 0 && 0 == e(".single").length)
                                    ? !e("body.blog .blog-fullwidth-wrap > .masonry:not(.meta-overlaid)").length > 0 && e(".container-wrap").css("padding-top", "0px")
                                    : e(this).addClass("first-section")),
                            e(this).index() == t - 1 &&
                                0 == e("#respond").length &&
                                0 == e("body.woocommerce-checkout").length &&
                                (e(".container-wrap").css("padding-bottom", "0px"), e(".bottom_controls").css("margin-top", "0px"), e("#call-to-action .triangle").remove()));
                    }
            }),
            e('#portfolio-extra > .nectar-slider-wrap[data-full-width="true"], .portfolio-wrap').each(function () {
                e(this).index() == t - 1 &&
                    0 == e("#commentform").length &&
                    0 == e("#pagination").length &&
                    (parseInt(e(".container-wrap").css("padding-bottom")) > 0 && e(this).css("margin-bottom", "-40px"), e("#call-to-action .triangle").remove());
            }),
            e(".portfolio-filters").each(function () {
                ("0" == e(this).index() && 0 != g.length) || "0" == e(this).index()
                    ? e(this).addClass("first-section nder-page-header")
                    : (("0" == e(this).index() && 0 == g.length) || "0" == e(this).index()) && e(this).css({ "margin-top": "0px" }).addClass("first-section");
            }),
            e(".portfolio-filters-inline").each(function () {
                e(this).parents(".wpb_row").length > 0 ||
                    (("0" == e(this).index() && 0 != g.length) || "0" == e(this).index()
                        ? e(this).addClass("first-section nder-page-header")
                        : (("0" == e(this).index() && 0 == g.length) || "0" == e(this).index()) && e(this).css({ "margin-top": "-30px", "padding-top": "50px" }).addClass("first-section"));
            });
    }
    function Et() {
        0 == e("#boxed").length &&
            e(".full-width-section[data-top-percent], .full-width-section[data-bottom-percent], .full-width-content[data-top-percent], .full-width-content[data-bottom-percent]").each(function () {
                var t = s.width(),
                    a = e(this).attr("data-top-percent") ? e(this).attr("data-top-percent") : "skip",
                    n = e(this).attr("data-bottom-percent") ? e(this).attr("data-bottom-percent") : "skip";
                "skip" != a && e(this).css("padding-top", t * (parseInt(a) / 100)), "skip" != n && e(this).css("padding-bottom", t * (parseInt(n) / 100));
            });
    }
    function zt() {
        oe.usingMobileBrowser && Et(), s.on("resize", Et);
    }
    function Ot() {
        var t = e("body.vc_editor").length > 0 ? ".vc_element > " : "";
        e(
            ".main-content > .row > " + t + " .full-width-content, #portfolio-extra > " + t + " .full-width-content, .woocommerce-tabs #tab-description > .full-width-content, .post-area.span_12 article .content-inner > .full-width-content"
        ).each(function () {
            if (e(this).find("> .span_12 > " + t + " .col").length > 1) {
                var a,
                    n = 0,
                    i = 0;
                e(this)
                    .find("> .span_12 > " + t + "  .col")
                    .each(function () {
                        a = e(this).find("> .vc_column-inner > .wpb_wrapper").length > 0 ? ".vc_column-inner" : ".column-inner-wrap > .column-inner";
                        var i = r.is('[data-flex-cols="true"]') ? parseInt(e(this).find("> .vc_column-inner").css("padding-top")) : parseInt(e(this).css("padding-top")),
                            s = t.length > 2 && e(this).find("> .vc_column-inner").length > 0 ? parseInt(e(this).find("> .vc_column-inner").css("padding-top")) : 0;
                        e(this)
                            .find("> " + a + " > .wpb_wrapper")
                            .height() +
                            2 * i +
                            s >
                            n &&
                            (n =
                                e(this)
                                    .find("> " + a + " > .wpb_wrapper")
                                    .height() +
                                2 * i +
                                s);
                    }),
                    e(this)
                        .find("> .span_12 > " + t + " .col")
                        .each(function () {
                            (a = e(this).find("> .vc_column-inner > .wpb_wrapper").length > 0 ? ".vc_column-inner" : ".column-inner-wrap > .column-inner"),
                                e(this).find("> " + a + " > .wpb_wrapper > *").length > 0
                                    ? t.length < 2 && !e(this).parent().parent().hasClass("vc_row-o-equal-height")
                                        ? (e(this).css("height", n), r.is('[data-flex-cols="true"]') && e(this).find("> .vc_column-inner").css("height", n))
                                        : t.length > 2 &&
                                          !e(this).parent().parent().parent().hasClass("vc_row-o-equal-height") &&
                                          (e(this).css("height", n), r.is('[data-flex-cols="true"]') && e(this).find("> .vc_column-inner").css("height", n))
                                    : e(this).is('[data-using-bg="true"]') &&
                                      (e(this).css("min-height", n),
                                      r.is('[data-flex-cols="true"]') && e(this).find("> .vc_column-inner").css("min-height", n),
                                      e(this).is('[data-animation*="reveal"]') && e(this).find(".column-inner").css("min-height", n));
                        }),
                    oe.winW < 1e3 &&
                        e(this)
                            .find("> .span_12 > " + t + " .col .wpb_row .col")
                            .css("min-height", "0px"),
                    e(this).hasClass("vertically-align-columns") &&
                        oe.winW > 1e3 &&
                        !e(this).hasClass("vc_row-o-equal-height") &&
                        e(this)
                            .find("> .span_12 > " + t + " .col")
                            .each(function () {
                                (a = e(this).find("> .vc_column-inner > .wpb_wrapper").length > 0 ? ".vc_column-inner" : ".column-inner-wrap > .column-inner"),
                                    (i = e(this)
                                        .find("> " + a + " > .wpb_wrapper")
                                        .height());
                                var t = e(this).height() / 2 - i / 2;
                                t <= 0 && (t = 0),
                                    e(this)
                                        .find("> " + a + " > .wpb_wrapper")
                                        .css("margin-top", t)
                                        .css("margin-bottom", t);
                            });
            }
        }),
            0 == e('body[data-flex-cols="true"]').length &&
                (e(".main-content > .row > .wpb_row:not(.full-width-content).vc_row-o-equal-height").each(function () {
                    if (e(this).find(">.span_12 > " + t + ' .wpb_column[data-animation*="reveal"]').length > 0) {
                        var a = 0;
                        e(this)
                            .find("> .span_12 > " + t + " .col")
                            .each(function () {
                                var t = parseInt(e(this).find("> .column-inner-wrap > .column-inner").css("padding-top"));
                                e(this).find("> .column-inner-wrap > .column-inner").height() + 2 * t > a && (a = e(this).find("> .column-inner-wrap > .column-inner").height() + 2 * t);
                            }),
                            e(this)
                                .find("> .span_12 > " + t + " .col")
                                .each(function () {
                                    e(this).find("> .column-inner-wrap > .column-inner .wpb_wrapper > *").length > 0
                                        ? e(this).find("> .column-inner-wrap").css("height", a)
                                        : (e(this).css("min-height", a), e(this).is('[data-animation*="reveal"]') && e(this).find(".column-inner").css("min-height", a));
                                });
                    }
                }),
                e(".wpb_row.vc_row-o-equal-height>.span_12> " + t + '.wpb_column[class*="padding-"][data-padding-pos="all"]').each(function () {
                    0 == e(this).parents(".tabbed").length && e(this).css({ "padding-top": e(this).css("padding-left"), "padding-bottom": e(this).css("padding-left") });
                }));
    }
    function Ht() {
        e(".wpb_row:has(.nectar-parallax-scene)").each(function (t) {
            var a = parseInt(e(this).find(".nectar-parallax-scene").attr("data-scene-strength"));
            N[t] = e(this).find(".nectar-parallax-scene").parallax({ scalarX: a, scalarY: a });
            var n = e(this).find(".nectar-parallax-scene li");
            e.each(n, function () {
                if (e(this).find("div").length > 0) {
                    var t = e(this)
                        .find("div")
                        .css("background-image")
                        .replace(/"/g, "")
                        .replace(/url\(|\)$/gi, "");
                    t && "" !== t && "none" !== t && (n = n.add(e("<img>").attr("src", t)));
                }
            });
        });
    }
    function St() {
        e("ul.checks li").each(function () {
            0 == e(this).find("i.fa-check-circle").length && e(this).prepend('<i class="fa fa-check-circle"></i>');
        });
    }
    function At() {
        e('.nectar-cta[data-style="arrow-animation"]').addClass("loaded");
    }
    function Mt() {
        var a = 1 == ne ? "500%" : "88%",
            n = 1 == ne ? "500%" : "70%",
            i = 1 == ne ? "500%" : "70%";
        e(ae + ".img-with-animation").each(function () {
            var t = e(this),
                n = t.is("[data-animation]") ? t.attr("data-animation") : "fade-in";
            (("ro-reveal-from-right" == n && "88%" == a) || ("ro-reveal-from-left" == n && "88%" == a)) && (a = "75%");
            var i = new Waypoint({
                element: t[0],
                handler: function () {
                    if ((t.parents(".wpb_tab").length > 0 && "hidden" == t.parents(".wpb_tab").css("visibility")) || t.hasClass("animated-in")) i.destroy();
                    else {
                        if (!z || e('body[data-responsive="0"]').length > 0) {
                            var a = t.is("[data-delay]") ? t.attr("data-delay") : 0,
                                s = t.parents(".hover-wrap").length > 0 ? t.parents(".hover-wrap") : t;
                            "fade-in-from-left" == n || "fade-in-from-right" == n
                                ? s.delay(a).transition({ opacity: 1, x: "0px" }, E, I)
                                : "fade-in-from-bottom" == n
                                ? s.delay(a).transition({ opacity: 1, y: "0px" }, E, I)
                                : "fade-in" == n
                                ? s.delay(a).transition({ opacity: 1 }, E, I)
                                : "grow-in" == n
                                ? setTimeout(function () {
                                      s.transition({ scale: 1, opacity: 1 }, E, I);
                                  }, a)
                                : "flip-in" == n
                                ? setTimeout(function () {
                                      s.transition({ rotateY: 0, opacity: 1 }, E, I);
                                  }, a)
                                : "flip-in-vertical" == n
                                ? setTimeout(function () {
                                      s.transition({ rotateX: 0, opacity: 1 }, E, I);
                                  }, a)
                                : ("ro-reveal-from-left" != n && "ro-reveal-from-right" != n && "ro-reveal-from-bottom" != n && "ro-reveal-from-top" != n) || t.parents(".img-with-aniamtion-wrap").addClass("animated-in"),
                                t.addClass("animated-in");
                        }
                        i.destroy();
                    }
                },
                offset: a,
            });
        }),
            e(ae + ".nectar_cascading_images").each(function () {
                var t = e(this),
                    a = e(this).is("[data-animation-timing]") ? e(this).attr("data-animation-timing") : 175;
                a = parseInt(a);
                var i = new Waypoint({
                    element: t[0],
                    handler: function () {
                        (t.parents(".wpb_tab").length > 0 && "hidden" == t.parents(".wpb_tab").css("visibility")) || t.hasClass("animated-in")
                            ? i.destroy()
                            : ((!z || e('body[data-responsive="0"]').length > 0) &&
                                  (t.find(".cascading-image").each(function (t) {
                                      var n = e(this);
                                      "flip-in" == n.attr("data-animation") || "flip-in-vertical" == n.attr("data-animation")
                                          ? setTimeout(function () {
                                                n.find(".inner-wrap").css({ opacity: 1, transform: "rotate(0deg) translateZ(0px)" });
                                            }, t * a)
                                          : "grow-in-reveal" == n.attr("data-animation")
                                          ? setTimeout(function () {
                                                n.find(".inner-wrap").css({ opacity: 1, transform: "translateX(0px) translateY(0px) scale(1,1) translateZ(0px)" }),
                                                    n.find(".inner-wrap img").css({ transform: "translateX(0px) translateY(0px) scale(1,1) translateZ(0px)" });
                                            }, t * a)
                                          : setTimeout(function () {
                                                n.find(".inner-wrap").css({ opacity: 1, transform: "translateX(0px) translateY(0px) scale(1,1) translateZ(0px)" });
                                            }, t * a);
                                  }),
                                  t.addClass("animated-in")),
                              i.destroy());
                    },
                    offset: n,
                });
            }),
            e(ae + '.col.has-animation:not([data-animation*="reveal"]), ' + ae + '.wpb_column.has-animation:not([data-animation*="reveal"]), ' + ae + ".nectar-fancy-box.has-animation").each(function (n) {
                var i = e(this),
                    s = a;
                e(this)[0].hasAttribute("data-animation-offset") && (s = parseInt(e(this).attr("data-animation-offset")) + "%");
                var r = new Waypoint({
                    element: i[0],
                    handler: function () {
                        if ((i.parents(".wpb_tab").length > 0 && "hidden" == i.parents(".wpb_tab").css("visibility")) || i.hasClass("animated-in")) r.destroy();
                        else {
                            if (!z || e('body[data-responsive="0"]').length > 0) {
                                i.addClass("triggered-animation"), e(t).trigger("nectar-column-animation-start");
                                var a = i.attr("data-delay");
                                "fade-in-from-left" == i.attr("data-animation") || "fade-in-from-right" == i.attr("data-animation")
                                    ? (Q[n] = setTimeout(function () {
                                          i.transition({ opacity: 1, x: "0px" }, E, I);
                                      }, a))
                                    : "fade-in-from-bottom" == i.attr("data-animation")
                                    ? (Q[n] = setTimeout(function () {
                                          i.transition({ opacity: 1, y: "0px" }, E, I);
                                      }, a))
                                    : "fade-in" == i.attr("data-animation")
                                    ? (Q[n] = setTimeout(function () {
                                          i.transition({ opacity: 1 }, E, I);
                                      }, a))
                                    : "grow-in" == i.attr("data-animation") || "zoom-out" == i.attr("data-animation")
                                    ? (Q[n] = setTimeout(function () {
                                          i.transition({ scale: 1, opacity: 1 }, E, I);
                                      }, a))
                                    : "flip-in" == i.attr("data-animation")
                                    ? (Q[n] = setTimeout(function () {
                                          i.transition({ rotateY: "0", opacity: 1 }, E, I);
                                      }, a))
                                    : "flip-in-vertical" == i.attr("data-animation")
                                    ? (Q[n] = setTimeout(function () {
                                          i.transition({ rotateX: "0", y: "0", opacity: 1 }, E, I);
                                      }, a))
                                    : "slight-twist" == i.attr("data-animation") &&
                                      (Q[n] = setTimeout(function () {
                                          anime({ targets: i[0], rotateY: [20, 0], rotateZ: [-4, 0], opacity: 1, easing: I, duration: E });
                                      }, a)),
                                    i.hasClass("boxed") &&
                                        (i.addClass("no-pointer-events"),
                                        setTimeout(function () {
                                            i.removeClass("no-pointer-events");
                                        }, parseInt(E) + parseInt(a) + 30)),
                                    i.find('.nectar-post-grid-wrap[data-style="mouse_follow_image"]') &&
                                        setTimeout(function () {
                                            i[0].style.transform = "none";
                                        }, parseInt(E) + parseInt(a) + 30),
                                    i.addClass("animated-in");
                            }
                            r.destroy();
                        }
                    },
                    offset: s,
                });
            }),
            e(ae + '.wpb_column.has-animation[data-animation*="reveal"]').each(function () {
                var t = e(this),
                    a = new Waypoint({
                        element: t[0],
                        handler: function () {
                            if ((t.parents(".wpb_tab").length > 0 && "hidden" == t.parents(".wpb_tab").css("visibility")) || t.hasClass("animated-in")) a.destroy();
                            else {
                                var n = t.attr("data-delay");
                                if (!z || e('body[data-responsive="0"]').length > 0) {
                                    var i = t.find("> .vc_column-inner").length > 0;
                                    "reveal-from-bottom" == t.attr("data-animation") || "reveal-from-top" == t.attr("data-animation")
                                        ? setTimeout(function () {
                                              t.hasClass("animated-in") &&
                                                  (1 == i
                                                      ? t.find("> .vc_column-inner").transition({ y: 0 }, E, I)
                                                      : t.find(".column-inner-wrap, .column-inner").transition({ y: 0 }, E, I, function () {
                                                            t.find(".column-inner-wrap, .column-inner").addClass("no-transform");
                                                        }));
                                          }, n)
                                        : ("reveal-from-right" != t.attr("data-animation") && "reveal-from-left" != t.attr("data-animation")) ||
                                          setTimeout(function () {
                                              t.hasClass("animated-in") &&
                                                  (1 == i
                                                      ? t.find("> .vc_column-inner").transition({ x: 0 }, E, I)
                                                      : t.find(".column-inner-wrap, .column-inner").transition({ x: 0 }, E, I, function () {
                                                            t.find(".column-inner-wrap, .column-inner").addClass("no-transform");
                                                        }));
                                          }, n),
                                        t.addClass("animated-in");
                                }
                                a.destroy();
                            }
                        },
                        offset: i,
                    });
            });
    }
    function Wt() {
        e(".nectar_cascading_images").each(function () {
            var t = !!e(this).hasClass("forced-aspect");
            e(this).parents(".vc_row-o-equal-height").length > 0 && e(this).parents(".wpb_column").length > 0 && e(this).css("max-width", e(this).parents(".wpb_column").width()),
                e(this)
                    .find(".bg-color")
                    .each(function () {
                        if (1 == t && 0 == e(this).parents(".cascading-image").index()) return !0;
                        var a = 0,
                            n = 0;
                        if (0 == e(this).parent().find(".img-wrap").length) {
                            var i = e(this).parents(".cascading-image").siblings('.cascading-image[data-has-img="true"]').first();
                            (a = i.find(".img-wrap").height()), (n = i.find(".img-wrap").width());
                        } else (a = e(this).parent().find(".img-wrap").height()), (n = e(this).parent().find(".img-wrap").width());
                        e(this).css({ height: a, width: n }).addClass("calculated");
                    });
        });
    }
    function Ft(t, a) {
        switch (((this.$element = t), (this.inView = !1), (this.topLevel = !1), (this.lastY = 0), (this.layer1Parallax = !!this.$element.is('[data-layer-1-parallax="yes"]')), a)) {
            case "subtle":
                this.intensity = 0.09;
                break;
            case "medium":
                this.intensity = 0.15;
                break;
            case "high":
                this.intensity = 0.25;
        }
        this.calculatePos(),
            this.trackView(),
            this.animate(),
            (e(".portfolio-filters").length > 0 || e(".portfolio-filters-inline").length > 0) && setInterval(this.calculatePos.bind(this), 700),
            s.on("resize", this.calculatePos.bind(this));
    }
    function qt() {
        var t = 1 == ne ? "500%" : "bottom-in-view";
        e(ae + ".nectar-split-heading").each(function () {
            e(this)[0].hasAttribute("data-animation-offset") && 1 != ne && e(this).attr("data-animation-offset").length > 0 && (t = parseInt(e(this).attr("data-animation-offset")) + "%");
            var a = e(this),
                n = a.is("[data-animation-delay]") ? parseInt(a.attr("data-animation-delay")) : 0,
                i = new Waypoint({
                    element: a[0],
                    handler: function () {
                        if ((a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("animated-in")) i.destroy();
                        else {
                            var t;
                            if (!z || e('body[data-responsive="0"]').length > 0)
                                setTimeout(function () {
                                    if (a.is('[data-animation-type="line-reveal-by-space"]:not([data-text-effect*="letter-reveal"])')) {
                                        var n = 0;
                                        a.is('[data-stagger="true"]') && ((n = 500 / a.find("> * > span").length), (n = Math.min(Math.max(n, 15), 50))),
                                            (t = parseInt(E) < 1100 ? E : "1100"),
                                            a.is('[data-m-rm-animation="true"]') && oe.winW < 1e3
                                                ? a.find("> * > span .inner").css({ transform: "translateY(0)", opacity: "1" })
                                                : a.find("> * > span").each(function (a) {
                                                      if (0 == n)
                                                          e(this)
                                                              .find("> .inner")
                                                              .delay(a * n)
                                                              .transition({ y: "0px", opacity: "1" }, t, I);
                                                      else {
                                                          var i = e(this).find("> .inner");
                                                          setTimeout(function () {
                                                              (i[0].style.transform = "translateY(0em)"), (i[0].style.opacity = "1");
                                                          }, a * n);
                                                      }
                                                  });
                                    } else if (a.is('[data-animation-type="line-reveal-by-space"][data-text-effect*="letter-reveal"]')) {
                                        t = parseInt(E) < 1e3 ? E : "1000";
                                        n = 0;
                                        var i = a.find("> * > span span"),
                                            s = a.is('[data-text-effect="letter-reveal-top"]') ? ["-1.3em", "0em"] : ["1.3em", "0em"];
                                        (n = 400 / i.length),
                                            (n = Math.min(Math.max(n, 20), 50)),
                                            i.length > 0 && anime({ targets: a.find("> * > span span").toArray(), translateY: s, delay: anime.stagger(n), duration: 1200, easing: "cubicBezier(0.25,1,0.5,1)" });
                                    } else
                                        a.find(".heading-line").each(function (t) {
                                            e(this)
                                                .find("> div")
                                                .delay(70 * t)
                                                .transition({ y: "0px" }, E, I);
                                        });
                                    a.addClass("animated-in");
                                }, n);
                            i.destroy();
                        }
                    },
                    offset: t,
                });
        });
    }
    function Lt() {
        var t = 1 == ne ? "500%" : "bottom-in-view",
            a = e('#nectar_fullscreen_rows[data-mobile-disable="on"]').length > 0 && oe.usingMobileBrowser ? ".nectar-progress-bar" : ae + ".nectar-progress-bar";
        oe.usingMobileBrowser && "bottom-in-view" == t && (t = "70%"),
            e(a).each(function () {
                var a = e(this),
                    n = new Waypoint({
                        element: a[0],
                        handler: function () {
                            if ((a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("completed")) n.destroy();
                            else {
                                "100%" == t && a.find(".bar-wrap").css("opacity", "1");
                                var e = a.find("span").attr("data-width"),
                                    i = parseInt(a.find("span strong i").text());
                                a.find("span").transition({ width: e + "%" }, 800, "easeInOutCubic");
                                var s = a.find("span strong i")[0];
                                new Qe(s, 0, i, 0, 1, { useEasing: !1 }).start(),
                                    a.find("span strong").transition({ opacity: 1 }, 550, "easeInCirc"),
                                    "100" == e && a.find("span strong").addClass("full"),
                                    a.addClass("completed"),
                                    n.destroy();
                            }
                        },
                        offset: t,
                    });
            });
    }
    function Yt() {
        var t = 1 == ne ? "500%" : "75%";
        e(ae + '.wpb_column[data-border-animation="true"]').each(function () {
            var a = e(this),
                n = new Waypoint({
                    element: a[0],
                    handler: function () {
                        if ((a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("completed")) n.destroy();
                        else {
                            var e = a.attr("data-border-animation-delay").length > 0 ? parseInt(a.attr("data-border-animation-delay")) : 0;
                            setTimeout(function () {
                                a.find(".border-wrap").addClass("animation"), a.find(".border-wrap").addClass("completed");
                            }, e),
                                n.destroy();
                        }
                    },
                    offset: t,
                });
        });
    }
    function jt() {
        var t = 1 == ne ? "500%" : "90%";
        e(ae + ".nectar-waypoint-el").each(function () {
            var a = !!e(this).is("[data-nectar-waypoint-el-stagger]") && e(this).attr("data-nectar-waypoint-el-stagger"),
                n = e(this).is("[data-nectar-waypoint-el-delay]") ? parseInt(e(this).attr("data-nectar-waypoint-el-delay")) : 0,
                i = e(this),
                s = new Waypoint({
                    element: i[0],
                    handler: function () {
                        (i.parents(".wpb_tab").length > 0 && "hidden" == i.parents(".wpb_tab").css("visibility")) || i.hasClass("completed")
                            ? s.destroy()
                            : (setTimeout(function () {
                                  a
                                      ? i.find("." + a).each(function (t) {
                                            var a = e(this);
                                            setTimeout(function () {
                                                a.addClass("animated-in");
                                            }, 100 * t);
                                        })
                                      : e(this).addClass("animated-in");
                              }, n),
                              s.destroy());
                    },
                    offset: t,
                });
        });
    }
    function Bt() {
        var t = 1 == ne ? "500%" : "80%";
        e(ae + ".nectar_food_menu_item")
            .parent()
            .each(function () {
                var a = e(this),
                    n = new Waypoint({
                        element: a[0],
                        handler: function () {
                            (a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("completed")
                                ? n.destroy()
                                : (a.find(".nectar_food_menu_item").each(function (t) {
                                      var a = e(this);
                                      setTimeout(function () {
                                          a.addClass("animated-in");
                                      }, 150 * t);
                                  }),
                                  n.destroy());
                        },
                        offset: t,
                    });
            });
    }
    function Pt() {
        var t = 1 == ne ? "500%" : "bottom-in-view";
        e(ae + '.divider-small-border[data-animate="yes"], ' + ae + '.divider-border[data-animate="yes"]').each(function () {
            var a = e(this).hasClass("divider-small-border") ? 1300 : 1500,
                n = e(this),
                i = new Waypoint({
                    element: n[0],
                    handler: function () {
                        (n.parents(".wpb_tab").length > 0 && "hidden" == n.parents(".wpb_tab").css("visibility")) || n.hasClass("completed")
                            ? i.destroy()
                            : (n.each(function () {
                                  e(this).css({ transform: "scale(0,1)", visibility: "visible" });
                                  var t = e(this);
                                  t.delay(t.attr("data-animation-delay")).transition({ transform: "scale(1, 1)" }, a, "cubic-bezier(.18,0.75,.25,1)");
                              }),
                              n.addClass("completed"),
                              i.destroy());
                    },
                    offset: t,
                });
        });
    }
    function Rt() {
        e(".nectar_image_with_hotspots").each(function () {
            e(this)
                .find(".nectar_hotspot_wrap")
                .each(function () {
                    if (oe.winW > 690) {
                        e(this).parents('.nectar_image_with_hotspots[data-tooltip-func="hover"]').length > 0 && (e(this).find(".nectar_hotspot").removeClass("click"), e(this).find(".nttip").removeClass("open")),
                            e(this).find(".nttip .inner a.tipclose").remove(),
                            e(".nttip").css("height", "auto"),
                            e(this).css({ width: "auto", height: "auto" }),
                            e(this).find(".nttip").removeClass("force-right").removeClass("force-left").removeClass("force-top").css("width", "auto");
                        var t = e(this).find(".nttip").offset();
                        t.left > e(this).parents(".nectar_image_with_hotspots").width() - 200 ? e(this).find(".nttip").css("width", "250px") : e(this).find(".nttip").css("width", "auto"),
                            t.left < 0
                                ? e(this).find(".nttip").addClass("force-right")
                                : t.left + e(this).find(".nttip").outerWidth(!0) > oe.winW
                                ? e(this).find(".nttip").addClass("force-left").css("width", "250px")
                                : t.top + e(this).find(".nttip").height() + 35 > s.height() && e("#nectar_fullscreen_rows").length > 0 && e(this).find(".nttip").addClass("force-top"),
                            0 == e(this).find("> .open").length && e(this).css({ width: "30px", height: "30px" });
                    } else e(this).find(".nttip").removeClass("force-left").removeClass("force-right").removeClass("force-top"), e(this).find(".nectar_hotspot").addClass("click"), 0 == e(this).find(".nttip a.tipclose").length && e(this).find(".nttip .inner").append('<a href="#" class="tipclose"><span></span></a>'), e(".nttip").css("height", s.height());
                });
        });
    }
    function Vt() {
        0 != e(".nectar_image_with_hotspots").length &&
            (!(function () {
                e('.nectar_image_with_hotspots[data-hotspot-icon="numerical"]').each(function () {
                    e(this)
                        .find(".nectar_hotspot_wrap")
                        .each(function (t) {
                            var a = e(this);
                            setTimeout(function () {
                                a.find(".nectar_hotspot").addClass("pulse");
                            }, 300 * t);
                        });
                });
                var t = [];
                e('.nectar_image_with_hotspots:not([data-tooltip-func="click"]) .nectar_hotspot').each(function (a) {
                    (t[a] = ""),
                        e(this).on("mouseover", function () {
                            clearTimeout(t[a]), e(this).parent().css({ "z-index": "400", height: "auto", width: "auto" });
                        }),
                        e(this).on("mouseleave", function () {
                            var n = e(this);
                            n.parent().css({ "z-index": "auto" }),
                                (t[a] = setTimeout(function () {
                                    n.parent().css({ height: "30px", width: "30px" });
                                }, 300));
                        });
                });
            })(),
            r.on("click", ".nectar_hotspot.click", function () {
                if (
                    (e(this).parents(".nectar_image_with_hotspots").find(".nttip").removeClass("open"),
                    e(this).parent().find(".nttip").addClass("open"),
                    e(this).parents(".nectar_image_with_hotspots").find(".nectar_hotspot").removeClass("open"),
                    e(this).parent().find(".nectar_hotspot").addClass("open"),
                    oe.winW > 690)
                ) {
                    e(this).parent().css({ "z-index": "120", height: "auto", width: "auto" });
                    var t = e(this);
                    setTimeout(function () {
                        t.parents(".nectar_image_with_hotspots")
                            .find(".nectar_hotspot_wrap")
                            .each(function () {
                                0 == e(this).find("> .open").length && e(this).css({ height: "30px", width: "30px", "z-index": "auto" });
                            });
                    }, 300);
                }
                return oe.winW <= 690 && (e("body.nectar_box_roll").length > 0 && e(".container-wrap").addClass("hotspot-open"), e(this).parents('.wpb_row, [class*="vc_col-"]').css("z-index", "200")), !1;
            }),
            r.on("click", ".nectar_hotspot.open", function () {
                return e(this).parent().find(".nttip").removeClass("open"), e(this).parent().find(".nectar_hotspot").removeClass("open"), e(this).parents(".wpb_row").css("z-index", "auto"), !1;
            }),
            r.on("click", ".nttip.open", function (t) {
                if (oe.winW < 690) {
                    if (t.target && e(t.target).is("a")) return;
                    return (
                        e("body.nectar_box_roll").length > 0 && e(".container-wrap").removeClass("hotspot-open"),
                        e(this).parents(".nectar_image_with_hotspots").find(".nttip").removeClass("open"),
                        e(this).parents(".nectar_image_with_hotspots").find(".nectar_hotspot").removeClass("open"),
                        e(this).parents(".wpb_row").css("z-index", "auto"),
                        !1
                    );
                }
            }),
            Rt(),
            s.on("resize", Rt));
    }
    function Xt() {
        var t = 1 == ne ? "500%" : "50%";
        e(ae + '.nectar_image_with_hotspots[data-animation="true"]').each(function () {
            var a = e(this),
                n = new Waypoint({
                    element: a[0],
                    handler: function () {
                        (a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("completed")
                            ? n.destroy()
                            : (a.addClass("completed"),
                              a.find(".nectar_hotspot_wrap").each(function (t) {
                                  var a = e(this),
                                      n = a.parents(".col.has-animation").length > 0 ? 1 : 0;
                                  setTimeout(function () {
                                      a.addClass("animated-in");
                                  }, 175 * (t + n));
                              }),
                              n.destroy());
                    },
                    offset: t,
                });
        });
    }
    function Nt() {
        var n = [].slice.call(a.querySelectorAll("[data-nectar-img-src]")),
            i = [].slice.call(a.querySelectorAll(".nectar-lazy-video"));
        if ("IntersectionObserver" in t) {
            var r = { rootMargin: "300px" };
            Dt(), s.off("resize.nectarLazySizing", Dt), s.on("resize.nectarLazySizing", Dt);
            var o = new IntersectionObserver(function (a) {
                a.forEach(function (a) {
                    if (a.isIntersecting) {
                        var n = a.target,
                            i = n.getAttribute("data-nectar-img-src");
                        if (i)
                            if (n.classList.contains("nectar-lazy")) {
                                n.addEventListener("load", function () {
                                    n.classList.contains("keep-calculated-size") || ((n.style.height = ""), (n.style.width = "")),
                                        n.classList.add("loaded"),
                                        n.removeAttribute("data-nectar-img-src"),
                                        "undefined" != typeof SalientPortfolio && n.classList.contains("image-gallery-portfolio-item") && e(t).trigger("salient-portfolio-recalculate"),
                                        o.unobserve(n);
                                }),
                                    (n.src = i);
                                var s = n.getAttribute("data-nectar-img-srcset");
                                s && (n.setAttribute("srcset", s), n.removeAttribute("data-nectar-img-srcset")), n.parentNode.classList.add("img-loaded");
                            } else (n.style.backgroundImage = "url('" + i + "')"), n.classList.add("loaded"), n.removeAttribute("data-nectar-img-src"), o.unobserve(n);
                    }
                });
            }, r);
            n.forEach(function (e) {
                o.observe(e);
            });
            var l = new IntersectionObserver(function (e, t) {
                e.forEach(function (e) {
                    if (e.isIntersecting) {
                        for (var t in e.target.children) {
                            var a = e.target.children[t];
                            "string" == typeof a.tagName && "SOURCE" === a.tagName && (a.src = a.dataset.nectarVideoSrc);
                        }
                        e.target.load(), e.target.classList.remove("lazy"), l.unobserve(e.target);
                    }
                });
            }, r);
            i.forEach(function (e) {
                l.observe(e);
            });
        } else
            n.forEach(function (e) {
                if (e.classList.contains("nectar-lazy")) {
                    e.classList.contains("keep-calculated-size") || ((e.style.height = ""), (e.style.width = "")), (e.src = e.getAttribute("data-nectar-img-src"));
                    var t = e.getAttribute("data-nectar-img-srcset");
                    t && (e.setAttribute("srcset", t), e.removeAttribute("data-nectar-img-srcset")), e.parentNode.classList.add("img-loaded"), e.classList.add("loaded"), e.removeAttribute("data-nectar-img-src");
                } else (e.style.backgroundImage = "url('" + e.getAttribute("data-nectar-img-src") + "')"), e.classList.add("loaded"), e.removeAttribute("data-nectar-img-src");
            });
    }
    function Dt() {
        e("img.nectar-lazy:not(.loaded):not(.image-gallery-portfolio-item)").each(function () {
            if (e(this).hasClass("attachment-shop_thumbnail") || e(this).hasClass("attachment-woocommerce_thumbnail")) return !0;
            e(this).css({ height: "", width: "" });
            var t = parseInt(e(this).attr("height")),
                a = parseInt(e(this).attr("width")),
                n = e(this).parents(".nectar_cascading_images").length > 0 ? e(this).parents(".bg-layer").width() : e(this).width();
            e(this).parents(".img-with-aniamtion-wrap.custom-size").length > 0 && n > a && (n = a),
                e(this).parents('.img-with-aniamtion-wrap[data-shadow*="depth"]').length > 0 && (n = e(this).parents(".img-with-aniamtion-wrap").width()),
                e(this).parents(".nectar-post-grid-item-bg-wrap-inner").length > 0 && !e(this).hasClass("nectar-post-grid-item__overlaid-img") && (n = e(this).parents(".nectar-post-grid-item-bg-wrap-inner").width());
            var i = qe(a, t, n, 2e3);
            e(this).css({ height: i.height + "px", width: i.width + "px" });
        });
    }
    function Qt() {
        (F = []),
            (Y = []),
            oe.usingMobileBrowser ||
                (e('.nectar-post-grid[data-indicator="yes"]').each(function (t) {
                    F[t] = new fe(e(this), "view-indicator");
                }),
                e('.nectar-post-grid-wrap[data-style="mouse_follow_image"] .nectar-post-grid').each(function (t) {
                    Y[t] = new fe(e(this), "post-grid-images");
                }),
                e('.nectar-category-grid[data-style="mouse_follow_image"]').each(function (t) {
                    Y[t] = new fe(e(this), "post-grid-images");
                }));
    }
    function Zt() {
        (G = []),
            Qt(),
            e(".nectar-post-grid-wrap").each(function (t) {
                G[t] = new Ut(e(this));
            });
    }
    function Ut(e) {
        (this.el = e),
            (this.currentPage = 0),
            (this.activeFilter = 1),
            (this.activeCatTotal = 0),
            (this.settingsData = JSON.parse(this.el.attr("data-el-settings"))),
            (this.queryData = JSON.parse(this.el.attr("data-query"))),
            (this.sortable = this.el.find(".nectar-post-grid-filters").attr("data-sortable")),
            (this.gridStyle = this.el.attr("data-style")),
            this.initialMarkup(),
            this.clickEvents(),
            this.deepLinking(),
            this.lightboxGroups(),
            this.externalProjectLinks();
    }
    function Gt() {
        var t = 1 == ne ? "200%" : "75%";
        e(ae + ".nectar-post-grid-wrap").each(function () {
            var a = e(this),
                n = new Waypoint({
                    element: a[0],
                    handler: function () {
                        (a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("completed")
                            ? n.destroy()
                            : (a.find(".nectar-post-grid-filters").addClass("animated-in"),
                              a.find(".nectar-post-grid-item").each(function (t) {
                                  var a = e(this);
                                  setTimeout(function () {
                                      a.addClass("animated-in");
                                  }, 90 * t);
                              }),
                              setTimeout(function () {
                                  a.addClass("finished-animating");
                              }, 950),
                              n.destroy());
                    },
                    offset: t,
                });
        });
    }
    function Jt() {
        var t = 1 == ne ? "500%" : "bottom-in-view";
        e(ae + ".nectar-animated-title").each(function () {
            var a = e(this),
                n = new Waypoint({
                    element: a[0],
                    handler: function () {
                        (a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("completed") ? n.destroy() : (a.addClass("completed"), n.destroy());
                    },
                    offset: t,
                });
        });
    }
    function Kt() {
        var t = 1 == ne ? "500%" : "bottom-in-view";
        oe.usingMobileBrowser && "bottom-in-view" == t && (t = "85%"),
            e(ae + ".nectar-highlighted-text").each(function (a) {
                var n = 0;
                e(this)
                    .find("i")
                    .each(function () {
                        e(this).replaceWith(function () {
                            return e("<em />").append(e(this).html());
                        });
                    }),
                    e(this).is("[data-animation-delay]") && e(this).attr("data-animation-delay").length > 0 && "false" != e(this).attr("data-animation") && (n = e(this).attr("data-animation-delay")),
                    e(this).find("em:has(a)").addClass("has-link"),
                    z && e(this).find("em").addClass("animated");
                var i = e(this),
                    s = new Waypoint({
                        element: i[0],
                        handler: function () {
                            (i.parents(".wpb_tab").length > 0 && "hidden" == i.parents(".wpb_tab").css("visibility")) || i.hasClass("animated")
                                ? s.destroy()
                                : (setTimeout(function () {
                                      i.find("em").each(function (t) {
                                          var a = e(this);
                                          setTimeout(function () {
                                              a.addClass("animated");
                                          }, 300 * t);
                                      });
                                  }, n),
                                  s.destroy());
                        },
                        offset: t,
                    });
            });
    }
    function ea() {
        var t = 1 == ne ? "500%" : "75%";
        e(ae + '.nectar-woo-flickity[data-animation*="fade-in"]').each(function () {
            var a = e(this),
                n = new Waypoint({
                    element: a[0],
                    handler: function () {
                        (a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("animated-in")
                            ? n.destroy()
                            : (a.addClass("animated-in"),
                              a.find(".flickity-cell").each(function (t) {
                                  var a = e(this);
                                  setTimeout(function () {
                                      a.css({ transform: "translate3d(0,0,0)", opacity: "1" });
                                  }, 100 * t);
                              }),
                              n.destroy());
                    },
                    offset: t,
                });
        });
    }
    function ta() {
        var t;
        e('.pricing-table[data-style="default"]').each(function () {
            (t = 0),
                e(this)
                    .find("> div ul")
                    .each(function () {
                        e(this).height() > t && (t = e(this).height());
                    }),
                0 == t && (t = "auto"),
                e(this).find("> div ul").css("height", t);
        });
    }
    function aa() {
        (X = []),
            "undefined" != typeof NectarTestimonialSlider &&
                e(".testimonial_slider").each(function (t) {
                    var a = e(this),
                        n = e(this).is("[data-style]") ? e(this).attr("data-style") : "none";
                    (X[t] = new NectarTestimonialSlider(a, n, ua, Ot)),
                        e(this).is('.disable-height-animation:not([data-style*="multiple_visible"])') && (X[t].testimonialSliderHeight(), setTimeout(X[t].testimonialSliderHeight.bind(X[t]), 700)),
                        e(this).is('.testimonial_slider[data-style="multiple_visible_minimal"]') &&
                            (X[t].testimonialSliderHeightMinimalMult(),
                            setTimeout(function () {
                                X[t].testimonialSliderHeightMinimalMult(), X[t].flickityEl.flickity("resize");
                            }, 700));
                });
    }
    function na() {
        s.off("smartresize.nectarTestimonials"),
            s.off("resize.nectarTestimonialsMin"),
            X.length > 0 && s.on("smartresize.nectarTestimonials", ia),
            e('.testimonial_slider[data-style="multiple_visible_minimal"]').length > 0 && s.on("resize.nectarTestimonialsMin", sa);
    }
    function ia() {
        for (var e = 0; e < X.length; e++) X[e].testimonialSliderHeight(), X[e].testimonialHeightResize();
    }
    function sa() {
        for (var e = 0; e < X.length; e++) X[e].testimonialSliderHeightMinimalMult();
    }
    function ra(t) {
        return t.parents('.wpb_column[data-bg-color*="#"]').length > 0 && t.parents('.wpb_column[data-bg-opacity="1"]').length > 0
            ? t.parents(".wpb_column").attr("data-bg-color")
            : (t.parents(".wpb_row").length > 0 && t.parents(".wpb_row").find(".row-bg.using-bg-color").length > 0) || (t.parents(".wpb_row").length > 0 && t.parents(".wpb_row").find(".row-bg.using-bg-color-excluded").length > 0)
            ? t.parents(".wpb_row").find(".row-bg").css("background-color")
            : e("#nectar_fullscreen_rows").length > 0
            ? e("#nectar_fullscreen_rows > .wpb_row .full-page-inner-wrap").css("background-color")
            : e(".container-wrap").css("background-color");
    }
    function oa() {
        var t = "";
        e('.nectar-icon-list[data-icon-style="border"], .nectar_icon_wrap[data-style="border-animation"][data-color*="extra-color-gradient-"]').each(function (a) {
            var n = ra(e(this));
            e(this).hasClass("nectar-icon-list")
                ? e(this).find(".list-icon-holder").css("background-color", n)
                : (e(this).removeClass(function (e, t) {
                      return (t.match(/(^|\s)instance-\S+/g) || []).join(" ");
                  }),
                  e(this).addClass("instance-" + a),
                  (t += ".nectar_icon_wrap.instance-" + a + " .nectar_icon:before { background-color: " + n + "!important; }"));
        }),
            e('body.material .nectar-button.see-through[class*="m-extra-color-gradient"]').each(function (a) {
                var n = ra(e(this));
                e(this).removeClass(function (e, t) {
                    return (t.match(/(^|\s)instance-\S+/g) || []).join(" ");
                }),
                    e(this).addClass("instance-" + a),
                    (t += ".nectar-button.see-through.instance-" + a + ":after { background-color: " + n + "!important; }");
            }),
            Ue(t, "nectaricon-color-match");
    }
    function la() {
        e(".col.span_3, .vc_span3, .vc_col-sm-3").each(function () {
            if (!e(this).is('[data-t-w-inherits="small_desktop"]')) {
                var t = e(this),
                    a = e(this).next("div");
                ((a.hasClass("span_3") && !t.hasClass("one-fourths")) || (a.hasClass("vc_span3") && !t.hasClass("one-fourths")) || (a.hasClass("vc_col-sm-3") && !t.hasClass("one-fourths"))) &&
                    (t.addClass("one-fourths clear-both"), a.addClass("one-fourths right-edge"));
            }
        }),
            e(".span_12 .col.span_6").each(function () {
                e(this).next("div").hasClass("span_6") && 0 == e.trim(e(this).next("div").html()).length && e(this).addClass("empty-second");
            });
    }
    function da() {
        e("iframe").each(function () {
            if (
                void 0 !== e(this).attr("src") &&
                !e(this).hasClass("skip-nectar-video-size") &&
                !e(this).hasClass("iframe-embed") &&
                0 == e(this).parents(".ult_modal").length &&
                0 == e(this).parents(".ls-slide").length &&
                0 == e(this).parents(".woo-variation-product-gallery").length &&
                0 == e(this).parents(".esg-entry-media").length &&
                0 == e(this).parents(".wpb_video_widget.wpb_content_element").length
            ) {
                if (e(this).parents(".woocommerce-product-gallery").length > 0 && (!e(this).is('[width="100%"]') || !e(this).is('[height="100%"]'))) return !0;
                var t = e(this).attr("src").toLowerCase();
                (t.indexOf("youtube") >= 0 || t.indexOf("vimeo") >= 0 || t.indexOf("twitch.tv") >= 0 || t.indexOf("kickstarter") >= 0 || t.indexOf("embed-ssl.ted") >= 0 || t.indexOf("dailymotion") >= 0) &&
                    (e(this).addClass("iframe-embed"),
                    e(this).width() < e(this).parent().width()
                        ? e(this)
                              .attr("data-aspectRatio", e(this).height() / e(this).width())
                              .removeAttr("height")
                              .removeAttr("width")
                        : e(this).attr("data-aspectRatio", "0.56").removeAttr("height").removeAttr("width"),
                    e(this).parents(".post-area.masonry.classic").length > 0 && e(this).attr("data-aspectRatio", "0.56").removeAttr("height").removeAttr("width"));
            }
        });
    }
    function ca() {
        e("iframe[data-aspectRatio]").each(function () {
            var t = e(this),
                a = t.parent().width();
            e(this).parents(".swiper-slide").length > 0 ? e(this).is(":visible") && t.width(a).height(a * t.attr("data-aspectRatio")) : t.width(a).height(a * t.attr("data-aspectRatio"));
        });
    }
    function ha() {
        e(".video-wrap iframe").unwrap(),
            e("#sidebar iframe[src]").unwrap(),
            e("audio").attr("width", "100%").attr("height", "100%").css("visibility", "visible"),
            e("video").css("visibility", "visible"),
            e(".wp-video").each(function () {
                e(this)
                    .find("video")
                    .get(0)
                    .addEventListener(
                        "loadeddata",
                        function () {
                            s.trigger("resize");
                        },
                        !1
                    );
            }),
            e(".main-content iframe[src]").each(function () {
                e(this).css({ opacity: "1", visibility: "visible" });
            });
    }
    function ua() {
        var t = 1200;
        e(".nectar-video-wrap").each(function () {
            var a, n;
            if (0 != e(this).find("video").length) {
                if (e(this).parents("#page-header-bg").length > 0) {
                    if (e(".container-wrap.auto-height").length > 0) return !1;
                    (a = e(this).parents("#page-header-bg").outerHeight()), (n = e(this).parents("#page-header-bg").outerWidth());
                } else if (e(this).hasClass("column-video"))
                    if (r.is('[data-flex-cols="true"]')) {
                        var i = e(this).parents(".vc_column-inner");
                        (a = i.outerHeight()), (n = i.outerWidth());
                    } else (a = e(this).parents(".wpb_column").outerHeight()), (n = e(this).parents(".wpb_column").outerWidth());
                else {
                    var s = e(this).parents(".wpb_row");
                    (a = s.outerHeight()), (n = e(this).parents(".full-width-section").length > 0 ? oe.winW : s.outerWidth());
                }
                e(this).width(n), e(this).parents("#page-header-bg").length > 0 && e(this).height(a);
                var o = n / 1280,
                    l = (a - a) / 720,
                    d = o > l ? o : l;
                1280 * d < (t = (1280 / 720) * (a + 40)) && (d = t / 1280),
                    e(this)
                        .find("video, .mejs-overlay, .mejs-poster")
                        .width(Math.ceil(1280 * d + 0)),
                    e(this)
                        .find("video, .mejs-overlay, .mejs-poster")
                        .height(Math.ceil(720 * d + 0)),
                    e(this).scrollLeft((e(this).find("video").width() - n) / 2),
                    e(this).scrollTop((e(this).find("video").height() - a) / 2),
                    e(this)
                        .find(".mejs-overlay, .mejs-poster")
                        .scrollTop((e(this).find("video").height() - a) / 2),
                    "center bottom" == e(this).attr("data-bg-alignment") || "bottom" == e(this).attr("data-bg-alignment")
                        ? e(this).scrollTop(e(this).find("video").height() - (a + 6))
                        : ("center top" != e(this).attr("data-bg-alignment") && "top" != e(this).attr("data-bg-alignment")) || e(this).scrollTop(0),
                    e(this).addClass("position-loaded");
            }
        });
    }
    function pa() {
        function a(e) {
            var t,
                a,
                n,
                i,
                s = e.innerWidth(),
                r = e.innerHeight();
            16 / 9 > s / r
                ? ((t = r * (16 / 9)), (a = r), (n = -Math.round((t - s) / 2) + "px"), (i = -Math.round((a - r) / 2) + "px"), (t += "px"), (a += "px"))
                : ((t = s), (a = s * (9 / 16)), (i = -Math.round((a - r) / 2) + "px"), (n = -Math.round((t - s) / 2) + "px"), (t += "px"), (a += "px")),
                e.find(".vc_video-bg iframe").css({ maxWidth: "1000%", marginLeft: n, marginTop: i, width: t, height: a });
        }
        (0 == e(".nectar-video-wrap").length && 0 == e(".nectar-youtube-bg").length) ||
            (setTimeout(function () {
                ua(),
                    s.on("resize", ua),
                    t.addEventListener("orientationchange", function () {
                        this.setTimeout(function () {
                            ua();
                        }, 100);
                    }),
                    e(".video-color-overlay").each(function () {
                        e(this).css("background-color", e(this).attr("data-color"));
                    }),
                    e(".nectar-video-wrap").each(function () {
                        if (0 != e(this).find("video").length) {
                            var t = e(this).parents("#page-header-bg").length > 0,
                                a = e(this),
                                n = setInterval(function () {
                                    a.find("video").get(0).readyState > 3 &&
                                        (oe.usingMobileBrowser ||
                                            (a.transition({ opacity: "1" }, 400), a.find("video").transition({ opacity: "1" }, 400), a.parent().find(".video-color-overlay").transition({ opacity: "0.7" }, 400), 1 == t && Ya()),
                                        p.addClass("loaded"),
                                        setTimeout(function () {
                                            p.addClass("hidden");
                                        }, 1e3),
                                        clearInterval(n));
                                }, 60);
                            oe.usingMobileBrowser &&
                                (a.parents(".full-width-section").length > 0 && 0 == a.parents("#nectar_fullscreen_rows").length && !a.hasClass("column-video") ? a.css("left", "50%") : a.css("left", "0px"),
                                1 == t && Ya(),
                                (a.find("video")[0].onplay = function () {
                                    a.transition({ opacity: "1" }, 400), a.find("video").transition({ opacity: "1" }, 400), a.parent().find(".video-color-overlay").transition({ opacity: "0.7" }, 400);
                                }));
                        }
                    });
            }, 300),
            oe.usingMobileBrowser &&
                e(".nectar-video-wrap").each(function () {
                    e(this).find("video").is("[muted]") || (e(this).parent().find(".mobile-video-image").show(), e(this).remove());
                }),
            e('.wpb_row:has(".nectar-video-wrap"):not(.fp-section)').each(function (t) {
                e(this).css("z-index", 100 + t);
            }),
            e(".vc_row").each(function () {
                var e,
                    n = jQuery(this);
                n.find(".nectar-youtube-bg").length > 0
                    ? (e = (function (e) {
                          if (void 0 === e) return !1;
                          var t = e.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
                          return null !== t && t[1];
                      })(n.find(".nectar-youtube-bg span").text())) &&
                      (n.find(".vc_video-bg").remove(),
                      (function e(n, i, s) {
                          if ("undefined" == typeof YT || void 0 === YT.Player)
                              return 100 < (s = void 0 === s ? 0 : s)
                                  ? void console.warn("Too many attempts to load YouTube api")
                                  : void setTimeout(function () {
                                        e(n, i, s++);
                                    }, 100);
                          var r = n.prepend('<div class="vc_video-bg"><div class="inner"></div></div>').find(".inner");
                          var o;
                          (o = new YT.Player(r[0], {
                              width: "100%",
                              height: "100%",
                              videoId: i,
                              playerVars: { playlist: i, iv_load_policy: 3, enablejsapi: 1, disablekb: 1, autoplay: 1, controls: 0, showinfo: 0, rel: 0, loop: 1 },
                              events: {
                                  onStateChange: function (e) {
                                      -1 === e.data && (o.mute(), o.playVideo());
                                  },
                                  onReady: function (e) {
                                      o.mute(), o.playVideo(), a(n);
                                  },
                              },
                          })),
                              a(n),
                              jQuery(t).on("resize", function () {
                                  a(n);
                              });
                          setTimeout(function () {
                              a(n);
                          }, 100);
                      })(n.find(".nectar-youtube-bg"), e))
                    : n.find(".nectar-youtube-bg").remove(),
                    n.find(".nectar-youtube-bg span").remove(),
                    oe.usingMobileBrowser || n.find(".nectar-video-wrap, .nectar-youtube-bg").css({ opacity: "1", width: "100%", height: "100%" }),
                    n.find(".video-color-overlay").transition({ opacity: "0.7" }, 400);
            }));
    }
    function fa() {
        if (
            (r.hasClass("single-post") &&
                e(".content-inner[data-has-gallery]").length > 0 &&
                (e(".wp-block-gallery").length > 0
                    ? e(".content-inner")
                          .find(".wp-block-gallery")
                          .each(function (t) {
                              0 !== t && e(this).css("display", "flex");
                          })
                    : e(".content-inner")
                          .find(".gallery")
                          .each(function (t) {
                              0 !== t && e(this).css("display", "block");
                          })),
            r.hasClass("single-post") && e(".nectar-social.vertical").length > 0)
        ) {
            var t = e(".nectar-social.vertical");
            new Waypoint({
                element: e(".post-area")[0],
                handler: function (e) {
                    de.materialOffCanvasOpen || ("down" === e ? t.addClass("visible") : t.removeClass("visible"));
                },
                offset: "70%",
            });
        }
    }
    function ga() {
        var t = e("#top #mobile-menu").length > 0 ? "#top #mobile-menu " : ".off-canvas-menu-container.mobile-only ";
        e(t + ".menu-item > ul > li > a").each(function () {
            if ("-" == e(this).text() || "Ã¢â‚¬â€œ" == e(this).text() || e(this).parent().hasClass("hide-title") || e(this).find("> .remove-menu-item-title").length > 0) {
                var t = e(this).parent().find("> ul > li").clone();
                e(this).parent().find("> .widget-area-active").length > 0 ? e(this).parent().find("> a").remove() : (e(this).parent().find("ul").remove(), e(this).parent().parent().append(t), e(this).parent().remove());
            }
        });
    }
    function ma() {
        if (e('body.material[data-slide-out-widget-area-style="slide-out-from-right"]').length > 0 && (ba(), u.length > 0)) {
            var a = u.detach();
            e(".ocm-effect-wrap-inner").append(a);
        }
        !(function () {
            if (e("body.material").length > 0 && 0 == e('body[data-slide-out-widget-area-style="slide-out-from-right-hover"]').length) {
                if (0 == e("#mobile-menu").length) {
                    var t = e("header#top ul .slide-out-widget-area-toggle:first a > span > i").clone();
                    t.addClass("hover-effect"), e("header#top ul .slide-out-widget-area-toggle a > span").append(t);
                    var a = e("header#top .slide-out-widget-area-toggle.mobile-icon a > span > i").clone();
                    a.addClass("hover-effect"), e("header#top .slide-out-widget-area-toggle.mobile-icon a > span").append(a);
                }
                e('body:not([data-slide-out-widget-area-style="slide-out-from-right"]) header#top .slide-out-widget-area-toggle a > span').append(
                    e('<span class="close-wrap"> <span class="close-line close-line1"></span> <span class="close-line close-line2"></span> </span>')
                ),
                    setTimeout(function () {
                        e("header#top .slide-out-widget-area-toggle a > span .close-wrap").addClass("loaded");
                    }, 200);
            }
            e("body.material #boxed").length > 0 &&
                e('body[data-slide-out-widget-area-style="slide-out-from-right-hover"]').length > 0 &&
                e(".ocm-effect-wrap").length > 0 &&
                e("#ajax-content-wrap > .slide-out-widget-area-toggle.slide-out-hover-icon-effect").insertAfter(".ocm-effect-wrap");
            e("body.material").length > 0 &&
                0 == e('body[data-slide-out-widget-area-style*="fullscreen"]').length &&
                e(".ocm-effect-wrap").length > 0 &&
                (e("body.material #slide-out-widget-area.slide-out-from-right .slide_out_area_close").insertAfter(".ocm-effect-wrap"), e("#slide-out-widget-area-bg").insertAfter(".ocm-effect-wrap"), o.insertAfter(".ocm-effect-wrap"));
        })(),
            (function () {
                if (e('body.material[data-header-search="true"]').length > 0 || e("body.material .ocm-effect-wrap").length > 0) {
                    var a,
                        n = !1,
                        i = 0,
                        r = oe.winW,
                        o = oe.winH;
                    t.addEventListener("orientationchange", function () {
                        i = 1;
                    }),
                        s.on("resize", function () {
                            oe.usingMobileBrowser ? ((s.width() != r && s.height != o) || 1 === i) && ((r = oe.winW), (o = oe.winH), (i = 0), (n = !0)) : (n = !0),
                                n &&
                                    (clearTimeout(a),
                                    e('body[data-slide-out-widget-area-style="slide-out-from-right"] > a.slide_out_area_close, .material #header-outer, .ocm-effect-wrap, .ocm-effect-wrap-shadow').addClass("no-material-transition"),
                                    (a = setTimeout(function () {
                                        e('body[data-slide-out-widget-area-style="slide-out-from-right"] > a.slide_out_area_close, .material #header-outer, .ocm-effect-wrap, .ocm-effect-wrap-shadow').removeClass("no-material-transition");
                                    }, 250)),
                                    ba(),
                                    (n = !1));
                        });
                }
            })(),
            s.on("resize", wa);
    }
    function va() {
        var t,
            a = 0;
        e("#slide-out-widget-area > .widget").each(function () {
            a += e(this).height();
        }),
            (t =
                o.height() - 25 - e(".bottom-meta-wrap").outerHeight(!0) - a > e("#slide-out-widget-area .off-canvas-menu-container:last-child").height()
                    ? o.height() - 25 - e(".bottom-meta-wrap").outerHeight(!0) - a
                    : e("#slide-out-widget-area .off-canvas-menu-container:last-child").height()),
            e("#slide-out-widget-area .inner").css({ height: "auto", "min-height": t });
    }
    function ba() {
        e("#slide-out-widget-area.slide-out-from-right").css({ "padding-top": 0.1 * s.height(), "padding-bottom": 0.1 * s.height() }), Ca();
    }
    function wa() {
        e(".ocm-effect-wrap.material-ocm-open").length > 0 && (e(".ocm-effect-wrap").css({ height: s.height() }), e(".ocm-effect-wrap-inner").css({ "padding-top": oe.adminBarHeight }));
    }
    function ya() {
        "separate-dropdown-parent-link" == (e("#slide-out-widget-area[data-dropdown-func]").length > 0 ? o.attr("data-dropdown-func") : "default") &&
            e("#slide-out-widget-area .off-canvas-menu-container li.menu-item-has-children").append('<span class="ocm-dropdown-arrow"><i class="fa fa-angle-down"></i></span>');
    }
    function _a() {
        e('#slide-out-widget-area[class*="slide-out-from-right"] .off-canvas-menu-container li.menu-item-has-children').each(function () {
            e(this)
                .find(".ocm-dropdown-arrow")
                .css({ top: e(this).find("a").height() / 2 });
        }),
            e("#slide-out-widget-area.fullscreen-split .off-canvas-menu-container li.menu-item-has-children").each(function () {
                e(this)
                    .find(".ocm-dropdown-arrow")
                    .css({ top: e(this).find("a").height() / 2 });
            });
    }
    function xa() {
        t.nectarOptions &&
            t.nectarOptions.ocm_remove_ext_menu_items &&
            "remove_images" == t.nectarOptions.ocm_remove_ext_menu_items &&
            !1 === de.ocmInit &&
            (e('.off-canvas-menu-container .title[class*="inherit-h"], #mobile-menu .title[class*="inherit-h"]').removeClass(function (e, t) {
                return (t.match(/(^|\s)inherit-h\S+/g) || []).join(" ");
            }),
            e(".off-canvas-menu-container .nectar-ext-menu-item .image-layer-outer, #mobile-menu .nectar-ext-menu-item .image-layer-outer").remove(),
            e(".off-canvas-menu-container .nectar-ext-menu-item .menu-item-desc").removeClass("menu-item-desc").addClass("item_desc"),
            e(".off-canvas-menu-container .nectar-ext-menu-item .inner-content > .title").each(function () {
                0 == e(this).find(".menu-title-text").length && e(this).removeClass("title").addClass("menu-title-text");
            }),
            e(".off-canvas-menu-container .item_desc").each(function () {
                "none" !== e(this).css("display") && e(this).parents(".menu-item").addClass("nectar-extra-menu-item-spacing");
            }),
            _a(),
            (de.ocmInit = !0));
    }
    function Ca() {
        oe.winW < 1e3 || e("body > #boxed").length > 0 || e(".ocm-effect-wrap-inner > #boxed").length > 0
            ? (e("#slide-out-widget-area.fullscreen .off-canvas-social-links, #slide-out-widget-area.fullscreen-alt .off-canvas-social-links").appendTo("#slide-out-widget-area .inner"),
              e("#slide-out-widget-area.fullscreen .bottom-text, #slide-out-widget-area.fullscreen-alt .bottom-text").appendTo("#slide-out-widget-area .inner"))
            : (e("#slide-out-widget-area.fullscreen .off-canvas-social-links,#slide-out-widget-area.fullscreen-alt .off-canvas-social-links").appendTo("#slide-out-widget-area .inner-wrap"),
              e("#slide-out-widget-area.fullscreen .bottom-text, #slide-out-widget-area.fullscreen-alt .bottom-text").appendTo("#slide-out-widget-area .inner-wrap")),
            e(".slide-out-from-right.open .off-canvas-menu-container.mobile-only").length > 0 && 0 == e("body.mobile").length && e("#slide-out-widget-area .slide_out_area_close").trigger("click"),
            _a();
    }
    function ka() {
        if ((va(), oe.usingMobileBrowser && e("#slide-out-widget-area.open").length > 0)) return $a(), !1;
        oe.usingMobileBrowser && (e(".slide-out-widget-area-toggle a").attr("aria-expanded", "true"), l.css({ height: "100%", width: "100%" })), o.css({ transform: "translate3d(0,0,0)" }).addClass("open"), xa();
        var a = Re();
        oe.winW < 1e3 && (a = !0);
        var n = t.nectarOptions && t.nectarOptions.mobile_header_format && "centered-menu" === t.nectarOptions.mobile_header_format && a ? "left" : "right";
        if (e("header#top .container .span_9 > .slide-out-widget-area-toggle").length > 0) {
            var i,
                c = e(".slide-out-hover-icon-effect"),
                h = oe.secondaryHeaderHeight,
                u = Re();
            if ((e('#header-outer[data-format="centered-menu-bottom-bar"]').length > 0 && (u = !1), e("body.mobile").length > 0 || u || "left" === O))
                c.css({ top: e("header#top .span_9 > .slide-out-widget-area-toggle a").offset().top - oe.scrollTop }),
                    "left" === n || "left" === O
                        ? c.css({ left: parseInt(e("#header-outer header > .container").css("padding-right")) + 1, right: "" })
                        : c.css({ right: parseInt(e("#header-outer header > .container").css("padding-right")) + 1, left: "" });
            else if (ie) {
                var p = e('#header-outer[data-has-menu="false"]').length > 0 ? 2 : 1;
                c.css({ top: oe.adminBarHeight + h + parseInt(e("header#top nav >ul .slide-out-widget-area-toggle a").css("padding-top")), right: 29 + p });
            } else
                e('#header-outer[data-format="centered-menu-bottom-bar"]').length > 0
                    ? ((i =
                          "flex" == e("header#top .span_9 > .slide-out-widget-area-toggle").css("display")
                              ? e("header#top .span_9 > .slide-out-widget-area-toggle.mobile-icon a").offset()
                              : e("header#top .span_3 .right-side .slide-out-widget-area-toggle > div").offset()),
                      "flex" == e("#top .span_3 .slide-out-widget-area-toggle.mobile-icon").css("display") && (i = e("#top .span_3 .slide-out-widget-area-toggle.mobile-icon a").offset()),
                      c.css({ top: parseInt(i.top) - oe.scrollTop, right: parseInt(e("#header-outer header >.container").css("padding-right")) + 2, left: "" }))
                    : ((i = r.hasClass("ascend")
                          ? "block" == e("header#top .span_9 > .slide-out-widget-area-toggle").css("display")
                              ? e("header#top .span_9 > .slide-out-widget-area-toggle.mobile-icon").position()
                              : e("header#top nav .buttons .slide-out-widget-area-toggle > div a > span:not(.screen-reader-text)").position()
                          : "block" == e("header#top .span_9 > .slide-out-widget-area-toggle").css("display")
                          ? e("header#top .span_9 > .slide-out-widget-area-toggle.mobile-icon").position()
                          : e("header#top nav .buttons .slide-out-widget-area-toggle > div").position()),
                      e("#header-secondary-outer.hide-up").length > 0 && (h = 0),
                      c.css({ top: oe.adminBarHeight + h + parseInt(i.top), right: parseInt(e("#header-outer header >.container").css("padding-right")) + 2, left: "" }));
        }
        if (
            (e(".slide-out-hover-icon-effect .lines-button").removeClass("no-delay").addClass("unhidden-line"),
            0 == e('#header-outer[data-permanent-transparent="1"]').length &&
                0 == e("#nectar_fullscreen_rows").length &&
                !oe.usingFrontEndEditor &&
                oe.winW > 1e3 &&
                ((0 == oe.scrollTop && e("#header-outer.transparent").length > 0) ||
                    (0 == e("body.mobile").length && ie && (d.attr("data-transparent", "true").addClass("no-bg-color").addClass("slide-out-hover"), e("#header-outer header, #header-outer > .cart-outer").addClass("all-hidden"))),
                0 == e('#header-outer[data-remove-fixed="1"]').length && 0 == e("body.mobile").length && ie && (1 == C ? (s.off("scroll", sn), s.off("scroll", nn)) : (s.off("scroll", rn), s.off("scroll", on)))),
            oe.usingMobileBrowser)
        )
            return !1;
        s.on("mousemove.rightOffsetCheck", Ta);
    }
    function Ta(a) {
        var n = s.width(),
            i = o.outerWidth(),
            r = Re();
        oe.winW < 1e3 && (r = !0);
        ("left" !== (t.nectarOptions && t.nectarOptions.mobile_header_format && "centered-menu" === t.nectarOptions.mobile_header_format && r ? "left" : "right") && "left" !== O
            ? a.clientX < n - parseInt(i) - v
            : a.clientX > parseInt(i) + v) &&
            o.hasClass("mouse-accessed") &&
            (o.removeClass("mouse-accessed"),
            s.off("mousemove.rightOffsetCheck", Ta),
            o.css({ transform: "" }).removeClass("open"),
            d.removeClass("style-slide-out-from-right"),
            e(".slide-out-hover-icon-effect .lines-button").removeClass("unhidden-line").addClass("no-delay"),
            0 == e('#header-outer[data-permanent-transparent="1"]').length &&
                (0 == e('#header-outer[data-remove-fixed="1"]').length &&
                    0 == e("body.mobile").length &&
                    ie &&
                    0 == e("body.mobile").length &&
                    (d.removeClass("no-bg-color"), e("#header-outer header, #header-outer > .cart-outer").removeClass("all-hidden")),
                0 == e('#header-outer[data-remove-fixed="1"]').length &&
                    0 == e("body.mobile").length &&
                    ie &&
                    (1 == C
                        ? (s.off("scroll.headerResizeEffect"),
                          0 == oe.scrollTop
                              ? (s.on("scroll.headerResizeEffect", nn),
                                e('#header-outer[data-full-width="true"][data-transparent-header="true"]').length > 0 &&
                                    f.length > 0 &&
                                    1 == ie &&
                                    e("#header-outer.pseudo-data-transparent").length > 0 &&
                                    e('#header-outer[data-full-width="true"] header > .container').stop(!0, !0).animate({ padding: "0" }, { queue: !1, duration: 250, easing: "easeOutCubic" }))
                              : s.on("scroll.headerResizeEffect", sn))
                        : (s.off("scroll.headerResizeEffectOpaque"), s.on("scroll.headerResizeEffectOpaque", rn)))));
    }
    function $a() {
        oe.usingMobileBrowser && (e(".slide-out-widget-area-toggle a").attr("aria-expanded", "false"), l.css({ height: "1px", width: "1px" })),
            o.css({ transform: "" }).removeClass("open"),
            d.removeClass("style-slide-out-from-right"),
            e(".slide-out-hover-icon-effect .lines-button").removeClass("unhidden-line").addClass("no-delay"),
            0 == e('#header-outer[data-permanent-transparent="1"]').length && (d.removeClass("no-bg-color"), e("#header-outer header").removeClass("all-hidden")),
            0 == e('#header-outer[data-remove-fixed="1"]').length &&
                0 == e("body.mobile").length &&
                ie &&
                (1 == C
                    ? (s.off("scroll.headerResizeEffect"),
                      0 == oe.scrollTop
                          ? (s.on("scroll.headerResizeEffect", nn),
                            e('#header-outer[data-full-width="true"][data-transparent-header="true"]').length > 0 &&
                                f.length > 0 &&
                                1 == ie &&
                                e("#header-outer.pseudo-data-transparent").length > 0 &&
                                e('#header-outer[data-full-width="true"] header > .container').stop(!0, !0).animate({ padding: "0" }, { queue: !1, duration: 250, easing: "easeOutCubic" }))
                          : s.on("scroll.headerResizeEffect", sn))
                    : (s.off("scroll.headerResizeEffectOpaque"), s.on("scroll.headerResizeEffectOpaque", rn)));
    }
    function Ia() {
        e(".slide-out-from-right-hover.open").length > 0 &&
            (e(".slide-out-widget-area-toggle:not(.std-menu) a").first().addClass("non-human-allowed").trigger("click"),
            setTimeout(function () {
                e(".slide-out-widget-area-toggle:not(.std-menu) a").removeClass("non-human-allowed");
            }, 100));
    }
    function Ea(t) {
        e("#mobile-menu").show(),
            e("header#top")
                .find("." + t + ":not(.std-menu) .lines-button")
                .addClass("close"),
            e("body.material").length > 0 &&
                e("header#top")
                    .find("." + t + " a")
                    .addClass("menu-push-out"),
            setTimeout(function () {
                e("header#top")
                    .find("." + t + " > div > a")
                    .removeClass("animating");
            }, 100);
    }
    function za(t) {
        e("#mobile-menu").hide(),
            e("body")
                .find("." + t + ":not(.std-menu) .lines-button")
                .removeClass("close"),
            setTimeout(function () {
                e("body.material").length > 0 && e("header#top ." + t + " a").removeClass("menu-push-out"),
                    e("body")
                        .find("." + t + " a")
                        .removeClass("animating");
            }, 350);
    }
    function Oa() {
        if (
            (r.on("click", ".slide-out-widget-area-toggle:not(.std-menu) a.closed.animating", function () {
                return !1;
            }),
            r.on("click", ".slide-out-widget-area-toggle:not(.std-menu) a.closed:not(.animating), .nectar-ocm-trigger-open", function () {
                if (de.ocmAnimating || "true" == se.animating || e(".slide-out-from-right-hover").length > 0) return !1;
                var a,
                    n = 700;
                return (
                    (de.ocmOpen = !0),
                    xa(),
                    d.removeClass("no-transition"),
                    e(this).hasClass("simple-mobile-menu")
                        ? (Ea("simple-mobile-menu"), e(this).find("a").addClass("open"), !1)
                        : (o.hasClass("slide-out-from-right")
                              ? (function () {
                                    var a = f.length > 0 && 0 == e("body.mobile").length ? f.height() : 0,
                                        n = Re();
                                    oe.winW < 1e3 && (n = !0);
                                    var i = t.nectarOptions && t.nectarOptions.mobile_header_format && "centered-menu" === t.nectarOptions.mobile_header_format && n ? "left" : "right";
                                    if (0 == e("body.material").length) {
                                        if (
                                            (e("#slide-out-widget-area .inner").css({ height: "auto", "min-height": o.height() - 25 - e(".bottom-meta-wrap").height() }),
                                            e('#slide-out-widget-area[data-dropdown-func="separate-dropdown-parent-link"] .inner > div:first-of-type > .menu > li:first-child').length > 0 &&
                                                e("#slide-out-widget-area .inner > div:first-of-type > .menu > li:first-child").hasClass("menu-item-has-children") &&
                                                e("#slide-out-widget-area .inner > div:first-of-type").css({ "margin-top": "50px" }),
                                            0 == e("#boxed").length)
                                        ) {
                                            e(
                                                ".container-wrap, .home-wrap, #footer-outer:not(#nectar_fullscreen_rows #footer-outer), .nectar-box-roll, #page-header-wrap .page-header-bg-image, #page-header-wrap .nectar-video-wrap, #page-header-wrap .mobile-video-image, #page-header-wrap #page-header-bg > .container, .page-header-no-bg, div:not(.container) > .project-title"
                                            )
                                                .stop(!0)
                                                .transition({ x: "left" === i || "left" === O ? "300px" : "-300px" }, 700, "easeInOutCubic");
                                            var h = Re();
                                            0 == e('#header-outer[data-format="centered-logo-between-menu"]').length || h
                                                ? 0 == e('#header-outer[data-transparency-option="1"]').length ||
                                                  (e('#header-outer[data-transparency-option="1"]').length > 0 && 0 == e('#header-outer[data-full-width="true"]').length) ||
                                                  e("body.mobile").length > 0
                                                    ? d
                                                          .stop(!0)
                                                          .css("transform", "translateY(0)")
                                                          .transition({ x: "left" === i || "left" === O ? 300 + a + "px" : "-" + (300 + a) + "px" }, 700, "easeInOutCubic")
                                                    : d
                                                          .stop(!0)
                                                          .css("transform", "translateY(0)")
                                                          .transition(
                                                              { x: "left" === i || "left" === O ? 300 + a + "px" : "-" + (300 + a) + "px", "background-color": "transparent", "border-bottom": "1px solid rgba(255,255,255,0.22)" },
                                                              700,
                                                              "easeInOutCubic"
                                                          )
                                                : e('#header-outer header#top nav > ul.buttons, body:not(.material) #header-outer:not([data-format="centered-logo-between-menu"]) .cart-outer .cart-menu-wrap').transition(
                                                      { x: "left" === i || "left" === O ? "300px" : "-300px" },
                                                      700,
                                                      "easeInOutCubic"
                                                  );
                                        }
                                        if (
                                            (o
                                                .stop(!0)
                                                .transition({ x: "left" === i || "left" === O ? a + "px" : "-" + a + "px" }, 700, "easeInOutCubic")
                                                .addClass("open"),
                                            0 == e("#boxed").length &&
                                                e('#header-outer[data-full-width="true"]').length > 0 &&
                                                !r.hasClass("mobile") &&
                                                (d.addClass("highzI"),
                                                e("#ascrail2000").addClass("z-index-adj"),
                                                0 == e('#header-outer[data-format="centered-logo-between-menu"]').length &&
                                                    0 == v &&
                                                    ("left" === O ||
                                                        e("header#top #logo")
                                                            .stop(!0)
                                                            .transition({ x: 300 + a + "px" }, 700, "easeInOutCubic")),
                                                e("header#top .slide-out-widget-area-toggle .lines-button:not(.legacy-double)").addClass("close"),
                                                e("body #header-outer nav > ul > li > a").css({ "margin-bottom": "0" })),
                                            d.addClass("style-slide-out-from-right"),
                                            l
                                                .css({ height: "100%", width: "100%" })
                                                .stop(!0)
                                                .transition({ opacity: 1 }, 700, "easeInOutCubic", function () {
                                                    e(".slide-out-widget-area-toggle:not(.std-menu) > div > a").removeClass("animating");
                                                }),
                                            0 == e('#header-outer[data-format="centered-logo-between-menu"]').length)
                                        ) {
                                            var u = e("#logo img:visible").length > 0 ? e("#logo img:visible").width() : e("#logo").width();
                                            e("header#top nav > .sf-menu").offset().left - u - 300 < 20 && d.addClass("hidden-menu");
                                        } else d.addClass("hidden-menu-items");
                                        0 == e('#header-outer[data-remove-fixed="1"]').length &&
                                            oe.winW > 1e3 &&
                                            (1 == ie && 1 == C && "true" == d.attr("data-transparent-header")
                                                ? (d.stop(!0).transition({ y: "0" }, 0).addClass("transparent").css("transition", "transform"), s.off("scroll", sn), s.off("scroll", nn))
                                                : 1 == ie && "true" == d.attr("data-transparent-header") && (d.addClass("transparent"), s.off("scroll", rn), s.off("scroll", on)));
                                    } else
                                        e("body.material").length > 0 &&
                                            (p.length > 0 && e(".ocm-effect-wrap #ajax-loading-screen").length > 0 && p.insertBefore(".ocm-effect-wrap"),
                                            oe.scrollTop > 40 && e('body[data-hhun="1"] #header-secondary-outer').addClass("hidden"),
                                            setTimeout(function () {
                                                e(".slide-out-widget-area-toggle:not(.std-menu) > div > a").removeClass("animating");
                                            }, 300),
                                            e("#slide-out-widget-area, #slide-out-widget-area-bg, #header-outer .slide-out-widget-area-toggle").addClass("material-open"),
                                            e('body:not(.mobile) #header-outer[data-format="centered-menu-bottom-bar"][data-condense="true"]').length > 0 &&
                                                "none" != e('#header-outer[data-format="centered-menu-bottom-bar"] .span_9').css("display") &&
                                                (e("#header-outer:not(.fixed-menu)").css("top", oe.adminBarHeight - oe.scrollTop + "px"), c.length > 0 && e("#header-outer.fixed-menu").length > 0 && c.css("visibility", "hidden")),
                                            e("#ajax-content-wrap").css({ position: "relative", top: "-" + oe.scrollTop + "px" }),
                                            e(".ocm-effect-wrap-inner").css({ "padding-top": oe.adminBarHeight }),
                                            e("#fp-nav").addClass("material-ocm-open"),
                                            (de.materialOffCanvasOpen = !0),
                                            r.addClass("material-ocm-open"),
                                            r.addClass("nectar-no-flex-height"),
                                            e(".ocm-effect-wrap").css({ height: oe.winH }),
                                            setTimeout(function () {
                                                e(".ocm-effect-wrap").addClass("material-ocm-open");
                                            }, 40),
                                            e("body > .slide_out_area_close").addClass("follow-body"),
                                            e('#header-outer:not([data-format="left-header"]) header#top .slide-out-widget-area-toggle a').addClass("effect-shown"),
                                            e('body[data-hhun="1"]:not(.no-scroll):not(.mobile) #header-outer[data-permanent-transparent="false"]:not(.detached):not(.parallax-contained):not(.at-top-before-box)').css({
                                                transition: "none",
                                                transform: "translateY(" + oe.adminBarHeight + "px)",
                                            }),
                                            setTimeout(function () {
                                                e("body > .slide_out_area_close").addClass("material-ocm-open");
                                            }, 350));
                                    e(t).trigger("nectar-material-ocm-open");
                                })()
                              : o.hasClass("fullscreen")
                              ? (function () {
                                    e("body.material").length > 0 && e("header#top .slide-out-widget-area-toggle a").addClass("menu-push-out");
                                    var t = 0,
                                        a = 0;
                                    oe.scrollTop + s.height() > e(".blurred-wrap").height() &&
                                        0 == e("#nectar_fullscreen_rows").length &&
                                        (e("body,html")
                                            .stop()
                                            .animate({ scrollTop: e(".blurred-wrap").height() - s.height() }, 600, "easeInOutCubic"),
                                        (t = 550),
                                        (a = 200)),
                                        e("header#top .slide-out-widget-area-toggle:not(.std-menu) .lines-button:not(.legacy-double)").addClass("close"),
                                        setTimeout(function () {
                                            e(".blurred-wrap").addClass("blurred");
                                        }, t),
                                        e("#slide-out-widget-area.fullscreen").show().addClass("open"),
                                        0 == e(".nectar-social.fixed").length && Wn(),
                                        e(".container-wrap").addClass("no-shadow"),
                                        d.stop(!0).css("transform", "translateY(0)"),
                                        setTimeout(function () {
                                            e(".off-canvas-menu-container .menu > li").each(function (t) {
                                                e(this)
                                                    .delay(50 * t)
                                                    .transition({ y: 0, opacity: 1 }, 800, "easeOutExpo");
                                            }),
                                                e("#slide-out-widget-area.fullscreen .widget").each(function (t) {
                                                    e(this)
                                                        .delay(100 * t)
                                                        .transition({ y: 0, opacity: 1 }, 800, "easeOutExpo");
                                                });
                                        }, 370 + a),
                                        setTimeout(function () {
                                            e("#slide-out-widget-area .off-canvas-social-links").addClass("line-shown"),
                                                e("#slide-out-widget-area .off-canvas-social-links li").each(function (t) {
                                                    e(this)
                                                        .delay(50 * t)
                                                        .transition({ scale: 1 }, 400, "easeOutCubic");
                                                }),
                                                e("#slide-out-widget-area .bottom-text").transition({ opacity: 0.7 }, 400, "easeOutCubic");
                                        }, 750 + a),
                                        setTimeout(function () {
                                            var t = e("body.mobile").length > 0 ? "easeOutCubic" : "easeInOutQuint";
                                            l.css({ height: "100%", width: "100%" })
                                                .show()
                                                .stop(!0)
                                                .transition({ y: "0%" }, 920, t, function () {
                                                    e(".slide-out-widget-area-toggle > div > a").removeClass("animating");
                                                });
                                        }, 50 + a),
                                        Ca(),
                                        e('.mobile #header-outer[data-permanent-transparent="false"]').length > 0 && e(".container-wrap").hasClass("no-scroll") && e("#ajax-content-wrap").addClass("at-content");
                                    var n = d.offset().top - oe.scrollTop + oe.secondaryHeaderHeight;
                                    e("#slide-out-widget-area.fullscreen .inner-wrap").css("padding-top", d.outerHeight() + n);
                                })()
                              : o.hasClass("fullscreen-alt") || o.hasClass("fullscreen-split")
                              ? (function () {
                                    var t = ".fullscreen-alt";
                                    o.hasClass("fullscreen-split") && (t = ".fullscreen-split"),
                                        e("body.material").length > 0 && e("header#top .slide-out-widget-area-toggle a").addClass("menu-push-out"),
                                        e("header#top .slide-out-widget-area-toggle:not(.std-menu) .lines-button:not(.legacy-double)").addClass("close"),
                                        ".fullscreen-alt" === t
                                            ? e("#slide-out-widget-area" + t)
                                                  .show()
                                                  .addClass("open")
                                            : e("#slide-out-widget-area" + t)
                                                  .addClass("open")
                                                  .removeClass("hidden"),
                                        l.addClass("open").removeClass("hidden"),
                                        e('body > div[class*="body-border"]').css("z-index", "9995"),
                                        ".fullscreen-alt" === t && e(".off-canvas-menu-container .menu").transition({ y: "0px", opacity: 1 }, 0),
                                        0 == e(".nectar-social.fixed").length && Wn(),
                                        e("#header-outer.transparent").length > 0 &&
                                            f.length > 0 &&
                                            (e(".admin-bar #slide-out-widget-area-bg" + t).css({ "padding-top": f.outerHeight(!0) + 32 + "px" }),
                                            e("body:not(.admin-bar) #slide-out-widget-area-bg" + t).css({ "padding-top": f.outerHeight(!0) + "px" })),
                                        d.stop(!0).css("transform", "translateY(0)"),
                                        s.width() > 1e3 &&
                                            0 == e('#header-outer[data-format="centered-menu-bottom-bar"].fixed-menu').length &&
                                            0 == e('body.material #header-outer[data-condense="true"]').length &&
                                            "true" == d.attr("data-transparent-header") &&
                                            !oe.usingFrontEndEditor &&
                                            (e("#logo .starting-logo").length > 0 || e("#logo.no-image").length > 0) &&
                                            d.stop(!0).css("transform", "translateY(0)").addClass("transparent"),
                                        e(".off-canvas-menu-container .clip-wrap").css("transition-duration", "0s"),
                                        ".fullscreen-alt" === t &&
                                            (setTimeout(function () {
                                                e(".off-canvas-menu-container .menu > li").each(function (t) {
                                                    e(this)
                                                        .delay(50 * t)
                                                        .transition({ y: 0, opacity: 1 }, 750, "easeOutCubic")
                                                        .addClass("no-pointer-events");
                                                }),
                                                    setTimeout(function () {
                                                        e(".off-canvas-menu-container .menu > li").removeClass("no-pointer-events"), e(".off-canvas-menu-container .clip-wrap").css("transition-duration", ".45s");
                                                    }, 500),
                                                    e("#slide-out-widget-area.fullscreen-alt .widget").each(function (t) {
                                                        e(this)
                                                            .delay(100 * t)
                                                            .transition({ y: 0, opacity: 1 }, 650, "easeOutCubic");
                                                    });
                                            }, 200),
                                            setTimeout(function () {
                                                e("#slide-out-widget-area .off-canvas-social-links").addClass("line-shown"),
                                                    e("#slide-out-widget-area .off-canvas-social-links li")
                                                        .css("opacity", "1")
                                                        .each(function (t) {
                                                            e(this)
                                                                .delay(50 * t)
                                                                .transition({ scale: 1 }, 400, "easeOutCubic");
                                                        }),
                                                    e("#slide-out-widget-area .bottom-text").transition({ opacity: 1 }, 600, "easeOutCubic");
                                            }, 200));
                                    var a = 0.4;
                                    if (
                                        (l.hasClass("solid") && (a = 1),
                                        l.hasClass("dark") && (a = 0.97),
                                        l.hasClass("medium") && (a = 0.6),
                                        l.hasClass("light") && (a = 0.4),
                                        l.removeClass("no-transition"),
                                        ".fullscreen-alt" === t && (l.addClass("padding-removed").css({ height: "100%", width: "100%", left: "0", opacity: a }), Ca()),
                                        setTimeout(function () {
                                            e(".slide-out-widget-area-toggle > div > a").removeClass("animating");
                                        }, 600),
                                        e('.mobile #header-outer[data-permanent-transparent="false"]').length > 0 && e(".container-wrap").hasClass("no-scroll") && e("#ajax-content-wrap").addClass("at-content"),
                                        ".fullscreen-alt" === t)
                                    ) {
                                        var n = d.offset().top - oe.scrollTop + oe.secondaryHeaderHeight;
                                        e("#slide-out-widget-area" + t + " .inner-wrap").css("padding-top", d.outerHeight() + n);
                                    } else e("#slide-out-widget-area" + t + " .inner-wrap").css("padding-top", d.outerHeight());
                                })()
                              : o.hasClass("fullscreen-inline-images")
                              ? ((a = oe.winW < oe.winH),
                                d.css({ "z-index": "9990", transition: "transform 0.3s ease" }),
                                0 == e(".nectar-social.fixed").length && Wn(),
                                e("body.material").length > 0 && e("header#top .slide-out-widget-area-toggle a").addClass("menu-push-out"),
                                e("header#top .slide-out-widget-area-toggle:not(.std-menu) .lines-button:not(.legacy-double)").addClass("close"),
                                e("#slide-out-widget-area.fullscreen-inline-images").addClass("open").removeClass("hidden"),
                                l.addClass("open").removeClass("hidden"),
                                e('body > div[class*="body-border"]').css("z-index", "9995"),
                                setTimeout(
                                    function () {
                                        d.removeClass("side-widget-closed").addClass("side-widget-open"),
                                            k || (d.attr("data-transparent-header", "true"), d.addClass("lighten-logo")),
                                            oe.usingFrontEndEditor || d.stop(!0).css("transform", "translateY(0)").addClass("transparent"),
                                            e("#header-outer.dark-slide.transparent").length > 0 && 0 == e("#boxed").length && d.removeClass("dark-slide").addClass("temp-removed-dark-slide"),
                                            setTimeout(function () {
                                                anime({ targets: "#header-outer #top > .container", opacity: [0, 1], duration: 900, easing: "easeOutQuad" }), d.css({ "z-index": "", transition: "" });
                                            }, 50);
                                    },
                                    a ? 350 : 425
                                ),
                                e(".off-canvas-menu-container .clip-wrap").css("transition-duration", "0s"),
                                l.removeClass("no-transition"),
                                setTimeout(function () {
                                    e(".slide-out-widget-area-toggle > div > a").removeClass("animating");
                                }, 600),
                                e('.mobile #header-outer[data-permanent-transparent="false"]').length > 0 && e(".container-wrap").hasClass("no-scroll") && e("#ajax-content-wrap").addClass("at-content"),
                                e("#slide-out-widget-area.fullscreen-inline-images .inner-wrap").css("padding-top", d.outerHeight()),
                                (n = 1100))
                              : e("#header-outer #mobile-menu").length > 0 && Ea("slide-out-widget-area-toggle"),
                          (de.ocmAnimating = !0),
                          setTimeout(function () {
                              de.ocmAnimating = !1;
                          }, n),
                          0 != e("#header-outer #mobile-menu").length ||
                              o.hasClass("fullscreen-inline-images") ||
                              (d.removeClass("side-widget-closed").addClass("side-widget-open"),
                              e('#header-outer[data-transparency-option="1"]').length > 0 &&
                                  0 == e("#boxed").length &&
                                  e('#header-outer[data-full-width="true"]').length > 0 &&
                                  !oe.usingFrontEndEditor &&
                                  0 == e('body.material[data-slide-out-widget-area-style="slide-out-from-right"]').length &&
                                  0 == e('body.material #header-outer[data-condense="true"]').length &&
                                  d.addClass("transparent"),
                              e("#header-outer.dark-slide.transparent").length > 0 && 0 == e("#boxed").length && 0 == e("body.material-ocm-open").length && d.removeClass("dark-slide").addClass("temp-removed-dark-slide")),
                          e(".slide-out-widget-area-toggle:not(.simple-mobile-menu) > div > a").removeClass("closed").addClass("open").attr("aria-expanded", "true"),
                          e(".slide-out-widget-area-toggle:not(.simple-mobile-menu) > div > a").addClass("animating"),
                          !1)
                );
            }),
            r.on("click", ".slide-out-widget-area-toggle:not(.std-menu) a.open.animating", function () {
                return !1;
            }),
            r.on(
                "click",
                ".slide-out-widget-area-toggle:not(.std-menu) a.open:not(.animating), .nectar-ocm-trigger-open a.open, #slide-out-widget-area .slide_out_area_close, > .slide_out_area_close, #slide-out-widget-area-bg.slide-out-from-right, .material-ocm-open #ajax-content-wrap",
                function (a) {
                    var n;
                    if (null != a.originalEvent || 0 != e(".slide_out_area_close.non-human-allowed").length || 0 != e(".slide-out-widget-area-toggle.mobile-icon a.non-human-allowed").length)
                        return (
                            !(de.ocmAnimating || e(".slide-out-widget-area-toggle:not(.std-menu) a.animating").length > 0) &&
                            ((de.ocmOpen = !1),
                            d.removeClass("no-transition"),
                            e(this).parents(".simple-mobile-menu").length > 0
                                ? (za("simple-mobile-menu"), e(this).removeClass("open"), !1)
                                : (e(".slide-out-widget-area-toggle:not(.std-menu):not(.simple-mobile-menu) a").removeClass("open").addClass("closed").attr("aria-expanded", "false"),
                                  e(".slide-out-widget-area-toggle:not(.simple-mobile-menu):not(.std-menu) a").addClass("animating"),
                                  o.hasClass("slide-out-from-right")
                                      ? (function () {
                                            if (0 == e("body.material").length) {
                                                var a = Re();
                                                oe.winW < 1e3 && (a = !0);
                                                var n = t.nectarOptions && t.nectarOptions.mobile_header_format && "centered-menu" === t.nectarOptions.mobile_header_format && a ? "left" : "right";
                                                if (
                                                    (e(
                                                        ".container-wrap, .home-wrap, #footer-outer:not(#nectar_fullscreen_rows #footer-outer), .nectar-box-roll, #page-header-wrap .page-header-bg-image,  #page-header-wrap .nectar-video-wrap, #page-header-wrap .mobile-video-image, #page-header-wrap #page-header-bg > .container, .page-header-no-bg, div:not(.container) > .project-title"
                                                    )
                                                        .stop(!0)
                                                        .transition({ x: "0px" }, 700, "easeInOutCubic"),
                                                    e('#header-outer[data-transparency-option="1"]').length > 0 && 0 == e("#boxed").length)
                                                ) {
                                                    var i = e("#header-outer[data-current-row-bg-color]").length > 0 ? d.attr("data-current-row-bg-color") : d.attr("data-user-set-bg");
                                                    d.stop(!0).transition({ x: "0px", "background-color": i }, 700, "easeInOutCubic");
                                                } else d.stop(!0).transition({ x: "0px" }, 700, "easeInOutCubic");
                                                o
                                                    .stop(!0)
                                                    .transition({ x: "left" === n || "left" === O ? "-301px" : "301px" }, 700, "easeInOutCubic")
                                                    .removeClass("open"),
                                                    0 == e("#boxed").length &&
                                                        e('#header-outer[data-full-width="true"]').length > 0 &&
                                                        (d.removeClass("highzI"), e("header#top #logo").stop(!0).transition({ x: "0px" }, 700, "easeInOutCubic"), e(".lines-button").removeClass("close")),
                                                    e('#header-outer[data-format="centered-logo-between-menu"]').length > 0 &&
                                                        e("#header-outer header#top nav > ul.buttons, #header-outer .cart-outer .cart-menu-wrap").stop(!0).transition({ x: "0px" }, 700, "easeInOutCubic"),
                                                    l.stop(!0).transition({ opacity: 0 }, 700, "easeInOutCubic", function () {
                                                        e(".slide-out-widget-area-toggle a").removeClass("animating"),
                                                            e(this).css({ height: "1px", width: "1px" }),
                                                            0 == e('#header-outer[data-remove-fixed="1"]').length &&
                                                                (d.hasClass("parallax-contained") && oe.scrollTop > 0 && 0 == e('#header-outer[data-permanent-transparent="1"]').length
                                                                    ? d.removeClass("parallax-contained").addClass("detached").removeClass("transparent")
                                                                    : ((0 == oe.scrollTop && e('body[data-hhun="1"]').length > 0 && e('#page-header-bg[data-parallax="1"]').length > 0) ||
                                                                          (0 == oe.scrollTop && e('body[data-hhun="1"]').length > 0 && e(".parallax_slider_outer").length > 0)) &&
                                                                      e('#header-outer[data-transparency-option="1"]').length > 0 &&
                                                                      d.addClass("transparent")),
                                                            e(".container-wrap").css("transform", "none");
                                                    }),
                                                    d.removeClass("style-slide-out-from-right"),
                                                    0 == e('#header-outer[data-remove-fixed="1"]').length &&
                                                        (1 == ie && 1 == C && oe.winW > 1e3
                                                            ? (s.off("scroll.headerResizeEffect"),
                                                              0 == oe.scrollTop
                                                                  ? (s.on("scroll.headerResizeEffect", nn),
                                                                    e('#header-outer[data-full-width="true"][data-transparent-header="true"]').length > 0 &&
                                                                        f.length > 0 &&
                                                                        1 == ie &&
                                                                        e("#header-outer.pseudo-data-transparent").length > 0 &&
                                                                        e('#header-outer[data-full-width="true"] header > .container').stop(!0, !0).animate({ padding: "0" }, { queue: !1, duration: 250, easing: "easeOutCubic" }))
                                                                  : s.on("scroll.headerResizeEffect", sn),
                                                              d.hasClass("pseudo-data-transparent") && d.attr("data-transparent-header", "false").removeClass("pseudo-data-transparent").removeClass("transparent"),
                                                              d.css("transition", "transform"))
                                                            : 1 == ie &&
                                                              oe.winW > 1e3 &&
                                                              (s.off("scroll.headerResizeEffectOpaque"),
                                                              s.on("scroll.headerResizeEffectOpaque", rn),
                                                              d.css("transition", "transform"),
                                                              d.hasClass("pseudo-data-transparent") && d.attr("data-transparent-header", "false").removeClass("pseudo-data-transparent").removeClass("transparent")));
                                            } else
                                                e("body.material").length > 0 &&
                                                    (o.removeClass("open"),
                                                    e("#slide-out-widget-area, #slide-out-widget-area-bg, #header-outer .slide-out-widget-area-toggle").removeClass("material-open"),
                                                    e(".ocm-effect-wrap, .ocm-effect-wrap-shadow, body > .slide_out_area_close, #fp-nav").removeClass("material-ocm-open"),
                                                    e("body > .slide_out_area_close").removeClass("follow-body"),
                                                    setTimeout(function () {
                                                        e(".slide-out-widget-area-toggle a").removeClass("animating"),
                                                            r.removeClass("material-ocm-open"),
                                                            r.removeClass("nectar-no-flex-height"),
                                                            e(".ocm-effect-wrap").css({ height: "100%" }),
                                                            e(".ocm-effect-wrap-inner").css({ "padding-top": "0" }),
                                                            s.scrollTop(Math.abs(parseInt(e("#ajax-content-wrap").css("top")))),
                                                            e("#ajax-content-wrap").css({ position: "", top: "" }),
                                                            e('#header-outer[data-format="centered-menu-bottom-bar"]').length > 0 &&
                                                                "none" != e('#header-outer[data-format="centered-menu-bottom-bar"] .span_9').css("display") &&
                                                                0 == e("body.mobile").length &&
                                                                (e("#header-outer:not(.fixed-menu)").css("top", ""), c.css("visibility", "")),
                                                            e('body[data-hhun="1"]:not(.no-scroll) #header-outer[data-permanent-transparent="false"]:not(.detached):not(.parallax-contained):not(.at-top-before-box)').css({ transform: "" }),
                                                            setTimeout(function () {
                                                                e('body[data-hhun="1"]:not(.no-scroll) #header-outer[data-permanent-transparent="false"]:not(.detached):not(.parallax-contained):not(.at-top-before-box)').css({
                                                                    transition: "",
                                                                });
                                                            }, 30),
                                                            e('body[data-hhun="1"] #header-secondary-outer.hidden').removeClass("hidden"),
                                                            (de.materialOffCanvasOpen = !1),
                                                            e(t).trigger("nectar-material-ocm-close");
                                                    }, 900),
                                                    setTimeout(function () {
                                                        e('#header-outer:not([data-format="left-header"]) header#top .slide-out-widget-area-toggle a').addClass("no-trans").removeClass("effect-shown");
                                                    }, 200),
                                                    setTimeout(function () {
                                                        e('#header-outer:not([data-format="left-header"]) header#top .slide-out-widget-area-toggle a').removeClass("no-trans");
                                                    }, 500));
                                        })()
                                      : o.hasClass("fullscreen")
                                      ? (e("body.material").length > 0 &&
                                            setTimeout(function () {
                                                e("header#top .slide-out-widget-area-toggle a").removeClass("menu-push-out");
                                            }, 350),
                                        e(".slide-out-widget-area-toggle:not(.std-menu) .lines-button:not(.legacy-double)").removeClass("close"),
                                        e(".blurred-wrap").removeClass("blurred"),
                                        e("#slide-out-widget-area.fullscreen")
                                            .transition({ opacity: 0 }, 700, "easeOutQuad", function () {
                                                e("#slide-out-widget-area.fullscreen").hide().css("opacity", "1");
                                            })
                                            .removeClass("open"),
                                        e("#slide-out-widget-area.fullscreen .widget").transition({ opacity: 0 }, 700, "easeOutQuad", function () {
                                            e(this).transition({ y: "110px" }, 0);
                                        }),
                                        setTimeout(function () {
                                            e(".off-canvas-menu-container .menu > li").transition({ y: "80px", opacity: 0 }, 0),
                                                e("#slide-out-widget-area .off-canvas-social-links li").transition({ scale: 0 }, 0),
                                                e("#slide-out-widget-area .off-canvas-social-links").removeClass("line-shown"),
                                                e("#slide-out-widget-area .bottom-text").transition({ opacity: 0 }, 0),
                                                e("#slide-out-widget-area .menuwrapper .menu").removeClass("subview"),
                                                e("#slide-out-widget-area .menuwrapper .menu li").removeClass("subview subviewopen"),
                                                e("#slide-out-widget-area.fullscreen .inner .menu-wrap").css("height", "auto");
                                        }, 800),
                                        setTimeout(function () {
                                            0 == e(".nectar-social.fixed").length && Mn(), e(".container-wrap").removeClass("no-shadow");
                                        }, 500),
                                        l.stop(!0).transition({ opacity: 0 }, 900, "easeOutQuad", function () {
                                            e('.mobile #header-outer[data-permanent-transparent="false"]').length > 0 && e(".container-wrap").hasClass("no-scroll") && e("#ajax-content-wrap").removeClass("at-content"),
                                                0 == e('.mobile #header-outer[data-permanent-transparent="false"]').length && e("#slide-out-widget-area.fullscreen .inner-wrap").css("padding-top", "0"),
                                                e(".slide-out-widget-area-toggle a").removeClass("animating");
                                            var t = 0.4;
                                            l.hasClass("solid") && (t = 1),
                                                l.hasClass("dark") && (t = 0.93),
                                                l.hasClass("medium") && (t = 0.6),
                                                l.hasClass("light") && (t = 0.4),
                                                e(this).css({ height: "1px", width: "1px", opacity: t }).transition({ y: "-100%" }, 0);
                                        }))
                                      : o.hasClass("fullscreen-alt") || o.hasClass("fullscreen-split") || o.hasClass("fullscreen-inline-images")
                                      ? ((n = ".fullscreen-alt"),
                                        o.hasClass("fullscreen-inline-images")
                                            ? ((n = ".fullscreen-inline-images"),
                                              d.css({ "z-index": "9990", transition: "transform 0.3s ease" }),
                                              setTimeout(function () {
                                                  d.css({ "z-index": "", transition: "" });
                                              }, 450),
                                              k || (d.removeClass("lighten-logo"), d.attr("data-transparent-header", "").removeClass("transparent")))
                                            : o.hasClass("fullscreen-split") && (n = ".fullscreen-split"),
                                        e("body.material").length > 0 &&
                                            setTimeout(function () {
                                                e("header#top .slide-out-widget-area-toggle a").removeClass("menu-push-out");
                                            }, 350),
                                        e(".slide-out-widget-area-toggle:not(.std-menu) .lines-button:not(.legacy-double)").removeClass("close"),
                                        l.removeClass("open"),
                                        (".fullscreen-split" !== n && ".fullscreen-inline-images" !== n) ||
                                            setTimeout(function () {
                                                l.addClass("hidden"), e("#slide-out-widget-area" + n).addClass("hidden");
                                            }, 550),
                                        ".fullscreen-alt" === n &&
                                            (e(".blurred-wrap").removeClass("blurred"),
                                            e("#slide-out-widget-area.fullscreen-alt .widget").transition({ opacity: 0 }, 500, "easeOutQuad", function () {
                                                e(this).transition({ y: "40px" }, 0);
                                            }),
                                            e("#slide-out-widget-area .bottom-text, #slide-out-widget-area .off-canvas-social-links li").transition({ opacity: 0 }, 250, "easeOutQuad"),
                                            e("#slide-out-widget-area .off-canvas-social-links").removeClass("line-shown"),
                                            e(".off-canvas-menu-container .menu").transition({ y: "-13px", opacity: 0 }, 400)),
                                        setTimeout(function () {
                                            ".fullscreen-alt" === n &&
                                                (e(".off-canvas-menu-container .menu > li").stop(!0, !0).transition({ y: "40px", opacity: 0 }, 0),
                                                e("#slide-out-widget-area .off-canvas-social-links li").transition({ scale: 0 }, 0),
                                                e("#slide-out-widget-area .off-canvas-social-links").removeClass("line-shown"),
                                                e("#slide-out-widget-area .menuwrapper .menu").removeClass("subview"),
                                                e("#slide-out-widget-area .menuwrapper .menu li").removeClass("subview subviewopen"),
                                                e("#slide-out-widget-area.fullscreen-alt .inner .menu-wrap").css("height", "auto"),
                                                l.css({ height: "1px", width: "1px", left: "-100%" })),
                                                e('.mobile #header-outer[data-permanent-transparent="false"]').length > 0 && e(".container-wrap").hasClass("no-scroll") && e("#ajax-content-wrap").removeClass("at-content"),
                                                0 == e('.mobile #header-outer[data-permanent-transparent="false"]').length && e("#slide-out-widget-area" + n + " .inner-wrap").css("padding-top", "0"),
                                                e(".slide-out-widget-area-toggle a").removeClass("animating"),
                                                ".fullscreen-alt" === n &&
                                                    e("#slide-out-widget-area" + n)
                                                        .hide()
                                                        .removeClass("open");
                                        }, 550),
                                        (".fullscreen-split" !== n && ".fullscreen-inline-images" !== n) || e("#slide-out-widget-area" + n).removeClass("open"),
                                        setTimeout(function () {
                                            0 == e(".nectar-social.fixed").length && Mn();
                                        }, 600),
                                        setTimeout(function () {
                                            l.removeClass("padding-removed");
                                        }, 50),
                                        setTimeout(
                                            function () {
                                                ".fullscreen-alt" === n && l.stop(!0).css({ opacity: 0 }), e('#header-outer[data-transparent-header="true"]').length > 0 && e('body > div[class*="body-border"]').css("z-index", "10000");
                                            },
                                            1 == ie ? 150 : 50
                                        ),
                                        setTimeout(
                                            function () {
                                                e(
                                                    '#header-outer:not([data-permanent-transparent="1"]).transparent.small-nav, body[data-hhun="1"] #header-outer:not([data-permanent-transparent="1"]).transparent.scrolling, #header-outer:not([data-permanent-transparent="1"]).transparent.scrolled-down'
                                                ).removeClass("transparent"),
                                                    d.hasClass("pseudo-data-transparent") && d.attr("data-transparent-header", "false").removeClass("pseudo-data-transparent").removeClass("transparent");
                                            },
                                            ".fullscreen-inline-images" == n ? 0 : 100
                                        ))
                                      : e("#header-outer #mobile-menu").length > 0 && za("slide-out-widget-area-toggle"),
                                  0 == e("#header-outer #mobile-menu").length &&
                                      (e("#header-outer.temp-removed-dark-slide.transparent").length > 0 && 0 == e("#boxed").length && d.removeClass("temp-removed-dark-slide").addClass("dark-slide"),
                                      0 == e('#header-outer[data-permanent-transparent="1"]').length &&
                                          0 == e("#slide-out-widget-area.fullscreen-alt").length &&
                                          (0 == e(".nectar-box-roll").length
                                              ? (e("#header-outer.small-nav").length > 0 || e("#header-outer.scrolled-down").length > 0) && d.removeClass("transparent")
                                              : (e("#header-outer.small-nav").length > 0 || e("#header-outer.scrolled-down").length > 0 || e(".container-wrap.auto-height").length > 0) && d.removeClass("transparent")),
                                      d.removeClass("hidden-menu"),
                                      d.removeClass("side-widget-open").addClass("side-widget-closed")),
                                  !1))
                        );
                }
            ),
            o.hasClass("fullscreen-inline-images"))
        ) {
            var a = e('#slide-out-widget-area .off-canvas-menu-container .menu > li[class*="current"][id]').attr("id");
            e(".nectar-ocm-image." + a).length > 0 && (e(".nectar-ocm-image.default").remove(), e(".nectar-ocm-image." + a).addClass("current")),
                e("#slide-out-widget-area .off-canvas-menu-container li[id]").on("mouseenter", function () {
                    var t = e(this).attr("id");
                    e(".nectar-ocm-image." + t).addClass("active"), e(".nectar-ocm-image." + t).length > 0 && e(".nectar-ocm-image.current:not(.active)").addClass("hidden");
                }),
                e("#slide-out-widget-area .off-canvas-menu-container li").on("mouseleave", function () {
                    e(".nectar-ocm-image.active").removeClass("active"), e(".nectar-ocm-image.current").removeClass("hidden");
                });
        }
    }
    function Ha() {
        e("#slide-out-widget-area.slide-out-from-right-hover").length > 0
            ? (function () {
                  if (0 == e("#ajax-content-wrap > .slide-out-widget-area-toggle").length) {
                      var t = e('.slide-out-widget-area-toggle[data-custom-color="true"]').length > 0 ? "#slide-out-widget-area > div" : "#slide-out-widget-area";
                      e(
                          '<div class="slide-out-widget-area-toggle slide-out-hover-icon-effect" data-icon-animation="simple-transform"><div> <a href="#sidewidgetarea" class="closed"> <span> <i class="lines-button x2"> <i class="lines"></i> </i> </span> </a> </div> </div>'
                      ).insertAfter(t),
                          (e('#header-outer[data-has-menu="true"]').length > 0 ||
                              e('body[data-header-search="true"]').length > 0 ||
                              e(".slide-out-widget-area-toggle a.using-label").length > 0 ||
                              e('.slide-out-widget-area-toggle[data-custom-color="true"]').length > 0) &&
                              e(".slide-out-widget-area-toggle").addClass("small");
                  }
                  oe.usingMobileBrowser
                      ? (r.on("click", ".slide-out-widget-area-toggle:not(.std-menu) a", ka), r.on("click", "#slide-out-widget-area-bg", Ia))
                      : (r.on("mouseenter", "#header-outer .slide-out-widget-area-toggle:not(.std-menu) a", ka),
                        o.on("mouseenter", function () {
                            e(this).addClass("mouse-accessed");
                        })),
                      s.on("smartresize", va);
              })()
            : (Oa(),
              0 != e("#header-outer #mobile-menu").length &&
                  (e("#header-outer #mobile-menu li.megamenu").removeClass("megamenu"),
                  e("#header-outer #mobile-menu ul li a").each(function () {
                      e(this).hasClass("nectar-widget-link") || 0 != e(this).find(".nectar-ext-menu-item").length || e(this).wrapInner("<span></span>");
                  }),
                  e("#header-outer #mobile-menu ul li").each(function () {
                      e(this).find("> ul").length > 0 && e(this).find("> a").append('<span class="sf-sub-indicator"><i class="fa fa-angle-down"></i></span>');
                  }),
                  e("#header-outer #mobile-menu .sf-sub-indicator").on("click", function () {
                      var t = e(this).parent().parent();
                      return (
                          t.toggleClass("current-open-item"),
                          t.hasClass("current-open-item")
                              ? (t.find("> ul").show(),
                                setTimeout(function () {
                                    t.addClass("visible");
                                }, 30))
                              : (t.find("ul").hide(), t.find("li").removeClass("visible").removeClass("current-open-item"), t.removeClass("visible")),
                          !1
                      );
                  }),
                  s.on("smartresize", function () {
                      ((oe.winW > 1e3 && e(".slide-out-widget-area-toggle.mobile-icon a.open").length > 0) || (oe.winW > 1e3 && e(".nectar-ocm-trigger-open.simple-mobile-menu a.open").length > 0)) &&
                          (e(".slide-out-widget-area-toggle.mobile-icon a, .nectar-ocm-trigger-open.simple-mobile-menu a").addClass("non-human-allowed"),
                          e(".slide-out-widget-area-toggle.mobile-icon a.open, .nectar-ocm-trigger-open.simple-mobile-menu a.open").trigger("click"),
                          setTimeout(function () {
                              e(".slide-out-widget-area-toggle.mobile-icon a, .nectar-ocm-trigger-open.simple-mobile-menu a").removeClass("non-human-allowed");
                          }, 100));
                  }))),
            e("#slide-out-widget-area").hasClass("fullscreen-inline-images") && 0 == e(".off-canvas-menu-container .menu > li > a span.wrap").length && e(".off-canvas-menu-container .menu > li a").wrapInner('<span class="wrap"></span>'),
            0 == e("#slide-out-widget-area.fullscreen-split").length &&
            0 == e('body.material[data-slide-out-widget-area-style*="slide-out-from-right"]').length &&
            0 == e('#slide-out-widget-area[data-dropdown-func="separate-dropdown-parent-link"]').length
                ? (function () {
                      e("#slide-out-widget-area .off-canvas-menu-container .menu").wrap('<div class="menu-wrap menuwrapper" />'), e("#slide-out-widget-area .off-canvas-menu-container .menu").addClass("menuopen");
                      var t = e("#slide-out-widget-area.fullscreen-alt").length > 0 || e("#slide-out-widget-area.fullscreen-inline-images").length > 0 ? "4" : "5";
                      e("#slide-out-widget-area .off-canvas-menu-container .menu-wrap").dlmenu({ animationClasses: { classin: "dl-animate-in-" + t, classout: "dl-animate-out-" + t } });
                  })()
                : e('body.using-mobile-browser[data-slide-out-widget-area-style="slide-out-from-right-hover"]').length > 0 &&
                  e('body #slide-out-widget-area .inner .off-canvas-menu-container li a[href*="#"]').on("click", function () {
                      "#" != e(this).attr("href") && Aa(e(this).parent());
                  }),
            e("#nectar_fullscreen_rows").length > 0 &&
                (e('body[data-slide-out-widget-area-style*="fullscreen"]').length > 0 || e('body[data-slide-out-widget-area-style="slide-out-from-right"]:not(.material)').length > 0) &&
                e("body #slide-out-widget-area .inner .off-canvas-menu-container li a[href]").on("click", function () {
                    var t = e(this).is('[href*="#"]') ? e(this).attr("href") : "";
                    "#" != t &&
                        e('div[data-fullscreen-anchor-id="' + t.substr(t.indexOf("#") + 1) + '"]').length > 0 &&
                        (setTimeout(function () {
                            e("#slide-out-widget-area .slide_out_area_close").addClass("non-human-allowed").trigger("click");
                        }, 100),
                        setTimeout(function () {
                            e("#slide-out-widget-area .slide_out_area_close").removeClass("non-human-allowed");
                        }, 150));
                }),
            r.on("mouseover", "#slide-out-widget-area .off-canvas-menu-container .menuwrapper > .sub-menu li > a", function () {
                var t = e(this).text();
                e(".off-canvas-menu-container .menuwrapper .menu li > a").removeClass("hovered"), e(".off-canvas-menu-container .menuwrapper .menu li > a:contains(" + t + ")").addClass("hovered");
            }),
            r.on("mouseover", ".off-canvas-menu-container .menuwrapper .menu li > a", function () {
                e(".off-canvas-menu-container .menuwrapper .menu li > a").removeClass("hovered");
            }),
            o.hasClass("fullscreen-inline-images") || setTimeout(Sa, 500),
            oe.usingMobileBrowser && o.addClass("mobile");
    }
    function Sa() {
        o.mousewheel(function (e, t) {
            (this.scrollTop -= (e.deltaY * e.deltaFactor) / 1.5), e.preventDefault();
        });
    }
    function Aa(a) {
        e("#slide-out-widget-area.open").length > 0 &&
            (t.location.href.split("#")[0] == a.find("> a").attr("href").split("#")[0] || a.find('a[href^="#"]').length > 0) &&
            (a.parents(".slide-out-from-right-hover").length > 0 ? e(".slide-out-widget-area-toggle.slide-out-hover-icon-effect a").trigger("click") : e(".slide-out-widget-area-toggle a").trigger("click"));
    }
    function Ma() {
        if (
            !(
                !e('#header-outer[data-format="left-header"]').length > 0 &&
                !e('body.material[data-slide-out-widget-area-style*="slide-out-from-right"]').length > 0 &&
                !e("#slide-out-widget-area.fullscreen-split").length > 0 &&
                !e('#slide-out-widget-area[data-dropdown-func="separate-dropdown-parent-link"]').length > 0
            )
        ) {
            var a;
            e('#header-outer[data-format="left-header"] nav li.megamenu').removeClass("nectar-megamenu-menu-item").removeClass("megamenu"),
                (a =
                    e('#slide-out-widget-area[data-dropdown-func="separate-dropdown-parent-link"]').length > 0
                        ? "#slide-out-widget-area .off-canvas-menu-container li.menu-item-has-children > .ocm-dropdown-arrow"
                        : 'body.material #slide-out-widget-area[class*="slide-out-from-right"] .off-canvas-menu-container li.menu-item-has-children > a, #slide-out-widget-area.fullscreen-split .off-canvas-menu-container li.menu-item-has-children > a');
            var n = '#header-outer[data-format="left-header"] nav li.menu-item-has-children > a',
                i = t.nectarOptions && t.nectarOptions.left_header_dropdown_func ? t.nectarOptions.left_header_dropdown_func : "default";
            "separate-dropdown-parent-link" === i && (n = '#header-outer[data-format="left-header"] nav li.menu-item-has-children > a .sf-sub-indicator'),
                e(n + ", " + a).on("click", function () {
                    var t = e(this).parent();
                    if (("separate-dropdown-parent-link" === i && (t = e(this).closest(".menu-item")), t.hasClass("open-submenu"))) t.find(".sub-menu").css({ "max-height": "0" }), t.removeClass("open-submenu");
                    else {
                        var a,
                            n = e(this);
                        t.find("> .sub-menu").addClass("no-trans"),
                            setTimeout(function () {
                                t.find("> .sub-menu").css({ "max-height": "none", position: "absolute", visibility: "hidden" }),
                                    (a = t.find("> .sub-menu").height()),
                                    t.find("> .sub-menu").removeClass("no-trans"),
                                    t.find("> .sub-menu").css({ "max-height": "0", position: "relative", visibility: "visible" });
                            }, 25),
                            setTimeout(function () {
                                n.closest("ul").find("li.menu-item-has-children").removeClass("open-submenu"),
                                    n.closest("ul").find("li.menu-item-has-children > .sub-menu").css({ "max-height": "0" }),
                                    t.addClass("open-submenu"),
                                    t.find("> .sub-menu").css("max-height", a),
                                    n.parents("ul").length > 0 &&
                                        n.parents("ul:not(.sf-menu)").each(function () {
                                            e(this).css("max-height"), e(this).css("max-height", parseInt(e(this).height() + 2 * parseInt(e(this).css("padding-top")) + a) + "px");
                                        });
                            }, 50);
                    }
                    return !1;
                });
            var s = e('#header-outer[data-format="left-header"] nav .sf-menu > .current-menu-ancestor.menu-item-has-children');
            if (s.length > 0 && s.find(".current-menu-item").length > 0) {
                s.find("ul").css("transition", "none");
                var r = s.find(".current-menu-item").parents(".current-menu-ancestor.menu-item-has-children");
                (r = Array.from(r)),
                    "separate-dropdown-parent-link" === i
                        ? r.reverse().forEach(function (t) {
                              e(t).find("> a .sf-sub-indicator").trigger("click");
                          })
                        : r.reverse().forEach(function (t) {
                              e(t).find("> a").trigger("click");
                          }),
                    setTimeout(function () {
                        s.find("ul").css("transition", "");
                    }, 100);
            }
        }
    }
    (Ke.prototype.setup = function () {
        var a = this;
        this.$el.find(".dynamic-words > span").each(function (t) {
            a.words[t] = e(this);
        }),
            this.viewportTracking(),
            this.$el.hasClass("element_stagger_words")
                ? (this.staggerWaypoint(), e(t).on("nectar-waypoints-reinit nectar-tab-changed", this.staggerWaypoint.bind(this)))
                : (clearInterval(this.interval), (this.interval = setInterval(this.sequence.bind(this), this.duration))),
            oe.usingMobileBrowser ? t.addEventListener("orientationchange", this.calcWidth.bind(this)) : e(t).on("resize", this.calcWidth.bind(this));
    }),
        (Ke.prototype.viewportTracking = function () {
            var e = this;
            if ("IntersectionObserver" in t) {
                (this.observer = new IntersectionObserver(
                    function (t) {
                        t.forEach(function (t) {
                            t.isIntersecting ? (e.state.visible = !0) : (e.state.visible = !1);
                        });
                    },
                    { rootMargin: "0px", threshold: 0 }
                )),
                    this.observer.observe(this.$el[0]);
            } else this.state.visible = !0;
        }),
        (Ke.prototype.calcWidth = function () {
            var e = this,
                t = this.$el.find(".dynamic-words").width();
            this.$el.find(".dynamic-words").css({ width: "" });
            var a = this.words[this.state.activeIndex].find("span").width();
            this.$el.find(".dynamic-words").css({ width: t }),
                setTimeout(function () {
                    e.$el.find(".dynamic-words").css({ width: a });
                }, 30);
        }),
        (Ke.prototype.sequence = function () {
            if (this.$el.find(".dynamic-words > span").length < 2 || 0 == this.state.visible) return !0;
            var e, t;
            (this.state.activeIndex = ((e = this.words.length), (t = this.state.activeIndex + 1) >= 0 ? t % e : ((t % e) + e) % e)),
                this.calcWidth(),
                this.$el.find(".dynamic-words > span").removeClass("active"),
                this.words[this.state.activeIndex].addClass("active");
        }),
        (Ke.prototype.staggerWaypoint = function () {
            var t = this;
            if (1 == ne && 0 == this.$el.parents(".active").length) return !0;
            var a = e(this).hasClass("animated-in") ? " animated" : "";
            this.$el.find(".beginning-text, .ending-text").each(function () {
                var t = e(this).text();
                (t = (t = t.trim()).split(" ")), (e(this)[0].innerHTML = "");
                for (var n = 0; n < t.length; n++) e(this)[0].innerHTML += '<span class="text-wrap"><span class="inner' + a + '">' + t[n] + "</span></span> ";
            }),
                this.$el.hasClass("animated-in") && this.$el.find(".beginning-text .inner, .ending-text .inner").css({ transform: "translateY(0)" }),
                this.$el.addClass("markup-generated");
            var n = 1 == ne ? "500%" : "bottom-in-view",
                i = this.$el,
                s = i.is("[data-delay]") ? parseInt(i.attr("data-delay")) : 0,
                r = new Waypoint({
                    element: i[0],
                    handler: function () {
                        if ((i.parents(".wpb_tab").length > 0 && "hidden" == i.parents(".wpb_tab").css("visibility")) || i.hasClass("animated-in")) r.destroy();
                        else {
                            if (!z || e('body[data-responsive="0"]').length > 0)
                                setTimeout(function () {
                                    var t = 0;
                                    (t = 500 / i.find(".text-wrap").length), (t = Math.min(Math.max(t, 15), 50)), parseInt(E) < 1100 ? E : "1100";
                                    var a = 0;
                                    i.find(".text-wrap").each(function () {
                                        var n = e(this);
                                        if (e(this).parents(".dynamic-words").length > 0 && !e(this).hasClass("active")) return n.find("> span").css({ transform: "translate3d(0,0,0)" }), !0;
                                        setTimeout(function () {
                                            n.find("> span").css({ transform: "translate3d(0,0,0)" });
                                        }, a * t),
                                            a++;
                                    }),
                                        i.addClass("animated-in");
                                }, s);
                            1 != t.state.sequenceStarted && (clearInterval(t.interval), (t.interval = setInterval(t.sequence.bind(t), t.duration))), (t.state.sequenceStarted = !0), r.destroy();
                        }
                    },
                    offset: n,
                });
        }),
        (nt.prototype.events = function () {
            var a = this;
            "single_link" == this.linkFunc &&
                (e(t).on("resize", this.setVertCenter.bind(this)),
                this.setVertCenter(),
                this.$el.find(".wpb_tabs_nav li").on("click", function (t) {
                    if (oe.winW < 1e3) {
                        var n = a.$el.find(".wpb_tabs_nav");
                        void 0 !== t.originalEvent && (a.$el.find(".scrolling-tab-nav .scrolling-tab-nav-current-item").toggleClass("open"), n.toggle(), Ct()),
                            a.$el.find(".scrolling-tab-nav li").removeClass("active"),
                            e(this).addClass("active"),
                            a.updateActiveTitle();
                    }
                }));
        }),
        (nt.prototype.setVertCenter = function () {
            var e = (oe.winH - this.$el.find(".scrolling-tab-nav").height()) / 2;
            a.documentElement.style.setProperty("--nectar-sticky-tabs-vert-y", e + "px");
        }),
        (nt.prototype.updateActiveTitle = function () {
            var e = this.$el.find(".scrolling-tab-nav .scrolling-tab-nav-current-item"),
                t = this.$el.find(".scrolling-tab-nav .menu-item.active .tab-nav-heading").clone(),
                a = this.$el.find(".scrolling-tab-nav .menu-item.active").index();
            this.$el.find(".scrolling-tab-content > div").removeClass("active"),
                this.$el.find(".scrolling-tab-content > div:eq(" + a + ")").addClass("active"),
                this.$el.find(".scrolling-tab-nav .scrolling-tab-nav-total .inner").css("transform", "translateY(-" + 100 * a + "%)"),
                e.html(t);
        }),
        (nt.prototype.domSetup = function () {
            var t = this,
                a = "";
            this.$el.find(".wpb_tab").each(function (n) {
                if (
                    (e(this).is("[data-tab-icon]") &&
                        e(this).attr("data-tab-icon").length > 0 &&
                        0 === e(this).find(".im-icon-wrap.tab-icon").length &&
                        (t.$el.addClass("using-icons"),
                        (a = t.$el.find(".wpb_tabs_nav li:nth-child(" + (n + 1) + ") a").attr("href")),
                        t.$el
                            .find(".wpb_tabs_nav li:nth-child(" + (n + 1) + ")")
                            .addClass("has-icon")
                            .prepend('<a class="skip-hash" href="' + a + '"><i class="' + e(this).attr("data-tab-icon") + '"></i></a>')),
                    e(this).find(".im-icon-wrap.tab-icon").length > 0)
                ) {
                    a = t.$el.find(".wpb_tabs_nav li:nth-child(" + (n + 1) + ") a").attr("href");
                    var i = e(this).find(".im-icon-wrap.tab-icon").detach();
                    t.$el
                        .find(".wpb_tabs_nav li:nth-child(" + (n + 1) + ")")
                        .addClass("has-icon")
                        .prepend('<a class="skip-hash svg-icon-link" href="' + a + '"></a>'),
                        t.$el.find(".wpb_tabs_nav li:nth-child(" + (n + 1) + ") .svg-icon-link").append(i);
                }
            }),
                this.$el.find(".scrolling-tab-nav .menu-item:first").addClass("active"),
                this.lineAnimation(),
                "single_link" == t.linkFunc && this.updateActiveTitle(),
                1 == this.$el.find(".scrolling-tab-nav .menu-item").length && this.$el.find(".scrolling-tab-nav").addClass("single-tab");
            var n = this.$el.find(".scrolling-tab-content");
            this.$el.find(".scrolling-tab-nav .menu-item").each(function (a) {
                a += 1;
                var i = n.find("> div:nth-child(" + a + ")");
                if ("default" == t.linkFunc) {
                    var s = e(this).html();
                    if ((i.prepend('<div class="scrolling-tab-mobile-title"><div class="inner">' + Le(s) + "</div></div>"), i.find(".scrolling-tab-mobile-title a").contents().unwrap(), i)) {
                        var r = e(this).find("a").attr("href");
                        (r = r.substr(1)), i.find("> .scrolling-tab-mobile-title").attr("id", r), i.removeAttr("id");
                    }
                }
            }),
                this.$el.addClass("initalized");
        }),
        (nt.prototype.highlightObserve = function () {
            var a = this;
            if (!(oe.usingMobileBrowser && oe.winW < 1e3) && "IntersectionObserver" in t) {
                var n = { rootMargin: d.is('[data-remove-fixed="1"]') ? "100px 0px 0px 0px" : "5px 0px 0px 0px", threshold: 1 };
                (this.observer = new IntersectionObserver(function (t) {
                    t.forEach(function (t) {
                        var n = "#" + e(t.target).attr("id"),
                            i = a.$el.find('.scrolling-tab-nav a[href="' + n + '"]');
                        t.isIntersecting && t.intersectionRatio >= 1 ? i.parents(".menu-item").addClass("visible") : i.parents(".menu-item").removeClass("visible");
                        var s = a.$el.find(".scrolling-tab-nav .menu-item.visible:first");
                        s.length > 0 && (a.$el.find(".scrolling-tab-nav .menu-item").removeClass("active"), s.addClass("active"), a.lineAnimation());
                    });
                }, n)),
                    this.$tabContent.find("> div > .scrolling-tab-mobile-title[id]").each(function () {
                        a.observer.observe(e(this)[0]);
                    }),
                    (this.tabs = Array.from(this.$tabContent.find("> div"))),
                    (this.scrollDir = "up"),
                    (this.prevScroll = 0),
                    (this.prevIndex = 0),
                    (this.observer = new IntersectionObserver(
                        function (t) {
                            t.forEach(function (t) {
                                if (!(oe.winW < 1e3)) {
                                    oe.scrollTop > a.prevScroll ? (a.scrollDir = "down") : (a.scrollDir = "up");
                                    var n = "down" === a.scrollDir ? a.getTargetSection(t) : t.target;
                                    if (a.shouldUpdate(t)) {
                                        var i = e(n).index();
                                        i < a.prevIndex ? a.$el.addClass("scrolling-up") : a.$el.removeClass("scrolling-up"),
                                            a.$el.find(".scrolling-tab-nav .ui-tabs-nav > .menu-item").removeClass("prev-active"),
                                            a.$el.find(".scrolling-tab-nav .ui-tabs-nav > .menu-item.active").addClass("prev-active"),
                                            a.$el.find(".scrolling-tab-nav .ui-tabs-nav > .menu-item").removeClass("active"),
                                            a.$el.find(".scrolling-tab-nav .ui-tabs-nav > .menu-item:eq(" + i + ")").addClass("active"),
                                            a.updateActiveTitle(),
                                            (a.prevIndex = i);
                                    }
                                    a.prevScroll = oe.scrollTop;
                                }
                            });
                        },
                        { rootMargin: "-40% 0% -40% 0%", threshold: 0 }
                    )),
                    this.$tabContent.find("> div").each(function () {
                        a.observer.observe(e(this)[0]);
                    });
            }
        }),
        (nt.prototype.getTargetSection = function (e) {
            var t = this.tabs.findIndex(function (t) {
                return t == e.target;
            });
            return t >= this.tabs.length - 1 ? e.target : this.tabs[t + 1];
        }),
        (nt.prototype.shouldUpdate = function (e) {
            return ("down" === this.scrollDir && !e.isIntersecting && 0 != this.prevScroll) || !("up" !== this.scrollDir || !e.isIntersecting || 0 == this.prevScroll);
        }),
        (nt.prototype.lineAnimation = function () {
            var e = this.$el.find(".scrolling-tab-nav .active");
            if (0 != e.length) {
                var t = parseInt(e.position().top),
                    a = parseInt(e.height());
                this.$lineEl.css({ "max-height": a + "px", transform: "translate3d(0px, " + t + "px, 0px)" });
            }
        }),
        (ot.prototype.calcTopOffset = function () {
            this.topOffset = (oe.winH - this.$innerEl.height()) / 2;
        }),
        (ot.prototype.resizeEvent = function () {
            oe.winW > 1e3 ? (this.calcTopOffset(), this.$innerEl.css({ top: this.topOffset })) : this.$innerEl.css({ top: "" });
        }),
        (_t.prototype.setType = function () {
            this.$element.is("[data-scroll-animation-movement]") && "transform_x" == this.$element.attr("data-scroll-animation-movement") && (this.type = "translateX");
        }),
        (_t.prototype.calculatePos = function () {
            1 != de.materialOffCanvasOpen && 1 != de.ocmAnimating && ((this.offsetTop = this.$element.offset().top), (this.height = this.$element.outerHeight()), (this.vertCenter = this.storedWinH / 2 - this.height / 2)),
                oe.usingMobileBrowser || (this.storedWinH = oe.winH);
        }),
        (_t.prototype.orientationChange = function () {
            oe.usingMobileBrowser && ((this.offsetTop = this.$element.offset().top), (this.height = this.$element.outerHeight()), (this.storedWinH = oe.winH));
        }),
        (_t.prototype.trackView = function () {
            var e = this;
            if ((this.$element.parents(".top-level").length > 0 && ((this.topLevel = !0), this.offsetTop > oe.winH && (this.topLevel = !1)), "IntersectionObserver" in t)) {
                new IntersectionObserver(
                    function (t) {
                        t.forEach(function (t) {
                            var a = t.isIntersecting;
                            e.inView = !!a;
                        });
                    },
                    { rootMargin: "250px" }
                ).observe(this.$element[0]);
            }
        }),
        (_t.prototype.animate = function () {
            if (1 != de.materialOffCanvasOpen) {
                if (((this.lastY = parseInt(Fe(this.lastY, oe.scrollTop, this.lerp))), 1 == de.animatedScrolling && (this.inView = !0), this.inView)) {
                    var e = this.intensity;
                    oe.winW < 1025 && (e /= 1.2),
                        oe.winW < 690 && (e /= 1.35),
                        (!0 === this.topLevel && oe.winW > 1e3) || (!0 === this.topLevel && this.persistOnMobile)
                            ? (this.$elementInner[0].style.transform = this.type + "(" + -this.lastY * e + "px) translateZ(0)")
                            : oe.winW > 1e3 || this.persistOnMobile
                            ? (this.$elementInner[0].style.transform = this.type + "(" + -(this.lastY - this.offsetTop + this.vertCenter) * e + "px) translateZ(0)")
                            : (this.$elementInner[0].style.transform = this.type + "(0px) translateZ(0)");
                }
                t.requestAnimationFrame(this.animate.bind(this));
            } else t.requestAnimationFrame(this.animate.bind(this));
        }),
        (xt.prototype.setup = function () {
            var a = this;
            (this.$el.parents("#page-header-bg").length > 0 || this.$el.parents(".featured-media-under-header").length > 0) && (this.type = "page-header"),
                ((this.$el.parents(".top-level").length > 0 && this.$el.parents(".parallax_slider_outer").length > 0) ||
                    (this.$el.parents(".top-level").length > 0 && this.$el.hasClass("nectar-simple-slider")) ||
                    (this.$el.parents(".top-level").length > 0 && this.$el.hasClass("nectar-recent-posts-single_featured")) ||
                    (this.$el.parents(".top-level").length > 0 && this.$el.hasClass("column-image-bg-wrap") && this.$el.parent().parent().is(".vc_col-sm-12:not(.child_column)")) ||
                    this.$el.is(".wpb_row.top-level") ||
                    "page-header" == this.type ||
                    0 == e(".wpb_row").length) &&
                    (this.firstSection = !0),
                ((0 == e(".wpb_row").length && this.$el.parents(".parallax_slider_outer").length > 0 && this.$el.is('[data-full-width="true"]')) ||
                    (e("#portfolio-extra").length > 0 && this.$el.parents(".parallax_slider_outer").length > 0 && this.$el.parents(".wpb_row").length > 0 && "0" == this.$el.parents(".wpb_row").index())) &&
                    (this.firstSection = !0),
                oe.usingFrontEndEditor && "page-header" != this.type && (this.firstSection = !1),
                this.$parallaxEl.addClass("translate"),
                (this.nestedParallax = this.$parallaxEl.parents('[data-scroll-animation="true"]').length > 0),
                this.nestedParallax ||
                    setInterval(function () {
                        1 != de.materialOffCanvasOpen && 1 != de.ocmAnimating && ((a.offsetTop = a.$el.offset().top), (a.height = a.$el.outerHeight(!0)));
                    }, 800),
                e(t).on("nectar-column-animation-start", this.checkColumnAnimation.bind(this)),
                e(t).on("resize load", this.resize.bind(this)),
                t.addEventListener("orientationchange", function () {
                    this.setTimeout(function () {
                        a.orientationChange();
                    }, 110);
                }),
                (this.offsetTop = this.$el.offset().top),
                (this.height = this.$el.outerHeight(!0));
        }),
        (xt.prototype.checkColumnAnimation = function () {
            this.$parallaxEl.parents(".col.has-animation.triggered-animation:not(.animated-in)").length > 0 && this.realtimeOffsetUpdate();
        }),
        (xt.prototype.realtimeOffsetUpdate = function () {
            var e = this,
                t = setInterval(function () {
                    1 != de.materialOffCanvasOpen && ((e.offsetTop = e.$el.offset().top), (e.height = e.$el.outerHeight(!0)));
                }, 30);
            setTimeout(function () {
                clearInterval(t);
            }, 2e3);
        }),
        (xt.prototype.resize = function () {
            oe.usingMobileBrowser
                ? this.nestedParallax || ((this.offsetTop = this.$el.offset().top), (this.height = this.$el.outerHeight(!0)))
                : ((this.storedWinH = oe.winH), (this.offsetTop = this.$el.offset().top), (this.height = this.$el.outerHeight(!0)));
        }),
        (xt.prototype.orientationChange = function () {
            oe.usingMobileBrowser && ((this.offsetTop = this.$el.offset().top), (this.height = this.$el.outerHeight(!0)), (this.storedWinH = oe.winH));
        }),
        (xt.prototype.update = function () {
            if (this.offsetTop + 150 + this.height < oe.scrollTop || this.offsetTop - 150 > oe.scrollTop + this.storedWinH || 1 == de.materialOffCanvasOpen) {
                for (var e = 0; e < this.$parallaxEl.length; e++) this.$parallaxEl[e].style.willChange = "auto";
                requestAnimationFrame(this.update.bind(this));
            } else {
                for (e = 0; e < this.$parallaxEl.length; e++)
                    !0 === this.firstSection
                        ? (this.$parallaxEl[e].style.transform = "translate3d(0, " + parseInt(oe.scrollTop * this.speed) + "px, 0)")
                        : (this.$parallaxEl[e].style.transform = "translate3d(0, " + parseInt((this.storedWinH + oe.scrollTop - this.offsetTop) * this.speed) + "px, 0) scale(1.005)"),
                        (this.$parallaxEl[e].style.willChange = "transform");
                requestAnimationFrame(this.update.bind(this));
            }
        }),
        (Ft.prototype.calculatePos = function () {
            1 != de.materialOffCanvasOpen && 1 != de.ocmAnimating && ((this.offsetTop = this.$element.offset().top), (this.height = this.$element.outerHeight()), (this.vertCenter = oe.winH / 2 - this.height / 2));
        }),
        (Ft.prototype.trackView = function () {
            var e = this;
            if ((this.$element.parents(".top-level").length > 0 && (this.topLevel = !0), "IntersectionObserver" in t)) {
                new IntersectionObserver(
                    function (t) {
                        t.forEach(function (t) {
                            var a = t.isIntersecting;
                            e.inView = !!a;
                        });
                    },
                    { rootMargin: "250px" }
                ).observe(this.$element[0]);
            }
        }),
        (Ft.prototype.animate = function () {
            if (1 != de.materialOffCanvasOpen) {
                if ((1 == de.animatedScrolling && (this.inView = !0), (this.lastY = Fe(this.lastY, oe.scrollTop, 0.2)), this.inView)) {
                    var a = this;
                    this.$element.find(".bg-layer").each(function (t) {
                        var n = e(this).data("scale");
                        a.layer1Parallax && (t = t / 1.5 + 1),
                            !0 === a.topLevel && oe.winW > 1e3
                                ? (e(this)[0].style.transform = "translateY(" + -a.lastY * a.intensity * t + "px) translateZ(0) scale(" + n + ")")
                                : (e(this)[0].style.transform = "translateY(" + -(a.lastY - a.offsetTop + a.vertCenter) * a.intensity * t + "px) translateZ(0) scale(" + n + ")");
                    });
                }
                t.requestAnimationFrame(this.animate.bind(this));
            } else t.requestAnimationFrame(this.animate.bind(this));
        }),
        e(t).on("salient-lazyloading-image-reinit", Nt),
        (Ut.prototype.initialMarkup = function () {
            0 == this.el.find(".nectar-post-grid-filters a.active").length && this.el.find(".nectar-post-grid-filters a:first-child").addClass("active"),
                "load-more" === this.settingsData.pagination &&
                    0 == this.el.find(".load-more-wrap").length &&
                    (this.el.find(".active.all-filter").length > 0 && (this.activeFilter = this.el.find(".active.all-filter").index() + 1),
                    (this.activeCatTotal = parseInt(this.el.find(".nectar-post-grid-filters a:nth-child(" + this.activeFilter + ")").attr("data-total-count"))),
                    this.el.find(".nectar-post-grid-item").length >= this.activeCatTotal
                        ? (this.el.addClass("all-loaded"), this.el.append('<div class="load-more-wrap inactive"><a href="#" class="load-more">' + this.el.attr("data-load-more-text") + "</a></div>"))
                        : (this.el.removeClass("all-loaded"), this.el.append('<div class="load-more-wrap"><a href="#" class="load-more">' + this.el.attr("data-load-more-text") + "</a></div>")));
        }),
        (Ut.prototype.lightboxGroups = function () {
            var t = Be(),
                a = this.el.find(".nectar-post-grid-link.pretty_photo").length > 0;
            e('body[data-ls="magnific"]').length > 0
                ? this.el.find(".nectar-post-grid-link.pretty_photo").addClass("magnific").addClass("gallery").removeClass("pretty_photo")
                : e('body[data-ls="fancybox"]').length > 0 &&
                  (this.el
                      .find(".nectar-post-grid-link.pretty_photo")
                      .attr("data-fancybox", "group_" + t)
                      .removeClass("pretty_photo"),
                  this.el.find(".nectar-post-grid-link[data-fancybox]").attr("data-fancybox", "group_" + t)),
                a && Ge();
        }),
        (Ut.prototype.externalProjectLinks = function () {
            this.el.hasClass("target-blank-external-urls") &&
                (this.el.find(".nectar-post-grid-item a[href*='http://']:not([href*='" + t.location.hostname + "'])").attr("target", "_blank"),
                this.el.find(".nectar-post-grid-item a[href*='https://']:not([href*='" + t.location.hostname + "'])").attr("target", "_blank"));
        }),
        (Ut.prototype.clickEvents = function () {
            this.el.find(".nectar-post-grid-filters h4").on("click", function () {
                e(this).parent().find("div").toggleClass("visible"), e(this).toggleClass("visible");
            }),
                "content_under_image" == this.gridStyle &&
                    this.el.find(".nectar-post-grid-link.pretty_photo").length > 0 &&
                    this.el.on("click", ".bg-wrap-link", function () {
                        return e(this).parents(".nectar-post-grid-item").find(".nectar-post-grid-link").trigger("click"), !1;
                    });
            var a = this.settingsData,
                n = this.queryData,
                i = this;
            this.el.find(".nectar-post-grid-filters a, .load-more-wrap .load-more").on("click", function () {
                var r = e(this);
                if (r.parents(".nectar-post-grid-wrap.loading").length > 0 || e(this).hasClass("active") || e(this).hasClass("inactive")) return !1;
                e(this).parents(".nectar-post-grid-filters").length > 0 ? (r.parent().find("a").removeClass("active"), r.addClass("active"), (i.currentPage = 0), (i.activeFilter = r.index() + 1)) : i.currentPage++;
                var o = r.parents(".nectar-post-grid-wrap").find(".nectar-post-grid"),
                    l = a.pagination,
                    d = r.hasClass("load-more") && "load-more" === l ? "load-more" : "filter",
                    c = "",
                    h = "";
                if ("yes" === i.sortable)
                    (c = r.parents(".nectar-post-grid-wrap").find(".nectar-post-grid-filters a.active").attr("data-filter")), (h = r.parents(".nectar-post-grid-wrap").find(".nectar-post-grid-filters a.active").attr("data-filter"));
                else {
                    var u = r.parents(".nectar-post-grid-wrap").find(".nectar-post-grid-filters a").length > 1 ? ":not(.all-filter)" : "";
                    r
                        .parents(".nectar-post-grid-wrap")
                        .find(".nectar-post-grid-filters a" + u)
                        .each(function () {
                            (c += e(this).attr("data-filter") + ", "), (h += e(this).attr("data-filter") + ", ");
                        }),
                        (c = c.substring(0, c.length - 2)),
                        (h = h.substring(0, h.length - 2));
                }
                var p = {
                    action: "nectar_get_post_grid_segment",
                    post_type: n.post_type,
                    cpt_name: n.cpt_name,
                    custom_query_tax: h,
                    category: c,
                    posts_per_page: n.posts_per_page,
                    current_page: i.currentPage,
                    offset: n.offset,
                    order: n.order,
                    orderby: n.orderby,
                    load_action: d,
                    ignore_sticky_posts: n.ignore_sticky_posts,
                    settings: {
                        pagination: l,
                        post_type: a.post_type,
                        image_size: a.image_size,
                        aspect_ratio_image_size: a.aspect_ratio_image_size,
                        card_bg_color: a.card_bg_color,
                        display_categories: a.display_categories,
                        display_excerpt: a.display_excerpt,
                        display_date: a.display_date,
                        color_overlay: a.color_overlay,
                        color_overlay_opacity: a.color_overlay_opacity,
                        color_overlay_hover_opacity: a.color_overlay_hover_opacity,
                        grid_style: a.grid_style,
                        hover_effect: a.hover_effect,
                        heading_tag: a.heading_tag,
                        post_title_overlay: a.post_title_overlay,
                        enable_gallery_lightbox: a.enable_gallery_lightbox,
                        overlay_secondary_project_image: a.overlay_secondary_project_image,
                        vertical_list_hover_effect: a.vertical_list_hover_effect,
                        vertical_list_read_more: a.vertical_list_read_more,
                    },
                };
                return (
                    r.parents(".nectar-post-grid-wrap").addClass("loading"),
                    e.post(t.nectarLove.ajaxurl, p, function (t) {
                        "load-more" === d ? o.append(t) : o.html(t),
                            o.is('[data-animation="fade-in-from-bottom"]') &&
                                (r.parents(".nectar-post-grid-wrap").removeClass("finished-animating"),
                                o.find(".nectar-post-grid-item:not(.animated-in)").each(function (t) {
                                    var a = e(this);
                                    setTimeout(function () {
                                        a.addClass("animated-in");
                                    }, 90 * t);
                                }),
                                setTimeout(function () {
                                    r.parents(".nectar-post-grid-wrap").addClass("finished-animating");
                                }, 950)),
                            "load-more" === l &&
                                ((i.activeCatTotal = parseInt(i.el.find(".nectar-post-grid-filters a:nth-child(" + i.activeFilter + ")").attr("data-total-count"))),
                                o.find(".nectar-post-grid-item").length >= i.activeCatTotal
                                    ? (i.el.find(".load-more-wrap").addClass("inactive"), i.el.addClass("all-loaded"))
                                    : (i.el.find(".load-more-wrap").removeClass("inactive"), i.el.removeClass("all-loaded"))),
                            i.lightboxGroups(),
                            i.externalProjectLinks(),
                            r.parents(".nectar-post-grid-wrap").removeClass("loading"),
                            s.trigger("resize"),
                            Qt();
                    }),
                    !1
                );
            });
        }),
        (Ut.prototype.deepLinking = function () {
            void 0 !== De["grid-filter"] &&
                this.el.find(".nectar-post-grid-filters a").each(function () {
                    var t = e(this).clone(),
                        a = De["grid-filter"];
                    e(this);
                    (t = (t = t.text()).replace(/\s+/g, "-").toLowerCase()).length > 0 && "-" === t.substring(0, 1) && (t = t.substring(1)),
                        t == (a = a.replace(/\s+/g, "-").replace(/</g, "&lt;").replace(/"/g, "&quot;").toLowerCase()) && e(this).trigger("click");
                });
        }),
        (e.DLMenu = function (t, a) {
            (this.$el = e(a)), this._init(t);
        }),
        (e.DLMenu.defaults = {
            animationClasses: { classin: "dl-animate-in-1", classout: "dl-animate-out-1" },
            onLevelClick: function () {
                return !1;
            },
            onLinkClick: function () {
                return !1;
            },
        }),
        (e.DLMenu.prototype = {
            _init: function (t) {
                (this.options = e.extend(!0, {}, e.DLMenu.defaults, t)), this._config();
                (this.animEndEventName = "animationend.menu"), (this.transEndEventName = "transitionend.menu"), (this.supportAnimations = !0), (this.supportTransitions = !0), this._initEvents();
            },
            _config: function () {
                (this.open = !1),
                    (this.$trigger = this.$el.children(".trigger")),
                    (this.$menu = this.$el.children("ul.menu")),
                    (this.$menuitems = this.$menu.find("li:not(.back) > a")),
                    this.$el.find("ul.sub-menu").prepend('<li class="back"><a href="#"> ' + o.attr("data-back-txt") + " </a></li>"),
                    (this.$back = this.$menu.find("li.back"));
            },
            _initEvents: function () {
                var t = this;
                this.$trigger.on("click.menu", function () {
                    return t.open ? t._closeMenu() : t._openMenu(), !1;
                }),
                    this.$menuitems.on("click.menu", function (a) {
                        var n = e(this).parent("li"),
                            i = n.children("ul.sub-menu");
                        if ((e(".fullscreen-alt .off-canvas-menu-container .clip-wrap, .fullscreen-alt .off-canvas-menu-container .clip-wrap span").css("transition-duration", "0s"), i.length > 0)) {
                            var s = i.clone().css("opacity", 0).insertAfter(t.$menu),
                                r = function () {
                                    t.$menu.off(t.animEndEventName).removeClass(t.options.animationClasses.classout).addClass("subview"),
                                        n.addClass("subviewopen").parents(".subviewopen:first").removeClass("subviewopen").addClass("subview"),
                                        s.remove(),
                                        setTimeout(function () {
                                            e(".off-canvas-menu-container .menu > li").removeClass("no-pointer-events"),
                                                e(".off-canvas-menu-container .clip-wrap, .off-canvas-menu-container .clip-wrap span").css("transition-duration", ".45s");
                                        }, 300);
                                };
                            return (
                                setTimeout(function () {
                                    s.addClass(t.options.animationClasses.classin),
                                        t.$menu.addClass(t.options.animationClasses.classout),
                                        t.supportAnimations ? t.$menu.on(t.animEndEventName, r) : r.call(),
                                        t.options.onLevelClick(n, n.children("a:first").text());
                                }),
                                n.parents(".menu-wrap").css("height", n.parents(".off-canvas-menu-container").find(".menuwrapper .menu").height()).transition({ height: s.height() }, 500, "easeInOutQuad"),
                                setTimeout(Ca, 600),
                                !1
                            );
                        }
                        t.options.onLinkClick(n.find("> a"), a), Aa(n);
                    }),
                    this.$back.on("click.menu", function () {
                        var a = e(this),
                            n = a.parents("ul.sub-menu:first"),
                            i = n.parent(),
                            s = n.clone().insertAfter(t.$menu),
                            r = function () {
                                t.$menu.off(t.animEndEventName).removeClass(t.options.animationClasses.classin), s.remove();
                            };
                        return (
                            setTimeout(function () {
                                s.addClass(t.options.animationClasses.classout), t.$menu.addClass(t.options.animationClasses.classin), t.supportAnimations ? t.$menu.on(t.animEndEventName, r) : r.call(), i.removeClass("subviewopen");
                                var e = a.parents(".subview:first");
                                e.is("li") && e.addClass("subviewopen"), e.removeClass("subview");
                            }),
                            setTimeout(function () {
                                i.parents(".menu-wrap").transition({ height: i.parent().height() }, 500, "easeInOutQuad"), setTimeout(Ca, 600);
                            }, 50),
                            !1
                        );
                    });
            },
            closeMenu: function () {
                this.open && this._closeMenu();
            },
            _closeMenu: function () {
                var e = this,
                    t = function () {
                        e.$menu.off(e.transEndEventName), e._resetMenu();
                    };
                this.$menu.removeClass("menuopen"), this.$menu.addClass("menu-toggle"), this.$trigger.removeClass("active"), this.supportTransitions ? this.$menu.on(this.transEndEventName, t) : t.call(), (this.open = !1);
            },
            openMenu: function () {
                this.open || this._openMenu();
            },
            _openMenu: function () {
                var t = this;
                r.off("click").on("click.menu", function () {
                    t._closeMenu();
                }),
                    this.$menu.addClass("menuopen menu-toggle").on(this.transEndEventName, function () {
                        e(this).removeClass("menu-toggle");
                    }),
                    this.$trigger.addClass("active"),
                    (this.open = !0);
            },
            _resetMenu: function () {
                this.$menu.removeClass("subview"), this.$menuitems.removeClass("subview subviewopen");
            },
        });
    var Wa = function (e) {
        t.console && t.console.error(e);
    };
    function Fa() {
        var t = parseInt(g.height());
        e('body[data-aie="slide-down"] #page-header-wrap:not(.fullscreen-header):not([data-responsive="true"])').css("height", t + "px");
    }
    function qa() {
        0 != e("#ajax-content-wrap").length && r.hasClass("ajax-loaded")
            ? 1 == e("#ajax-content-wrap").length && e('#page-header-bg[data-parallax="1"]').css({ opacity: 1 })
            : e('#page-header-bg[data-parallax="1"]').animate({ opacity: 1 }, 350, "easeInCubic"),
            e('#page-header-bg[data-parallax="1"] .nectar-particles').append('<div class="fade-out" />');
    }
    function La() {
        var a = { inView: !0 },
            n = e("#page-header-bg .span_6 .inner-wrap"),
            i = e("#page-header-bg #canvas");
        if (e('#page-header-bg[data-parallax="1"]').length > 0) {
            var r = new Image(),
                o = parseInt(g.height()),
                l = e("#header-space").height(),
                d = e(".nectar-global-section.after-nav").length > 0 ? e(".nectar-global-section.after-nav").height() : 0,
                c = Ve(e('#page-header-bg[data-parallax="1"]').css("background-image"));
            c && -1 !== c.indexOf(".")
                ? ((r.onload = function () {
                      qa();
                  }),
                  (r.src = Ve(e('#page-header-bg[data-parallax="1"]').css("background-image"))))
                : qa(),
                oe.winW > 1e3 && p(),
                t.addEventListener(
                    "scroll",
                    function () {
                        oe.winW > 1e3 && t.requestAnimationFrame(p);
                    },
                    !1
                );
        }
        var h = e('body[data-ajax-transitions="true"]').length > 0 && e('#page-header-bg[data-animate-in-effect="slide-down"]').length > 0 ? 350 : 0;
        if (g.length > 0) {
            setTimeout(function () {
                Fa();
            }, h),
                e('#page-header-bg[data-animate-in-effect="fade-in"]').addClass("loaded");
            var u = Ve(g.css("background-image"));
            u && -1 !== u.indexOf(".") && g.addClass("has-bg"), s.on("smartresize", Fa);
        }
        function p() {
            oe.winW >= 1e3 &&
                null == navigator.userAgent.match(/iPad/i) &&
                1 != de.materialOffCanvasOpen &&
                (1 == a.inView && (n.css({ transform: "translateY(" + 0.15 * oe.scrollTop + "px)", opacity: 1 - oe.scrollTop / (0.7 * (d + o)) }), i && i.css({ transform: "translateY(" + 0.15 * oe.scrollTop * 2 + "px)" })),
                oe.scrollTop / (o + l + oe.adminBarHeight) > 1
                    ? ((a.inView = !1), e(".nectar-particles, #page-header-bg .fade-out").css("visibility", "hidden").addClass("out-of-sight"), e("#page-header-bg").addClass("out-of-sight"))
                    : ((a.inView = !0), e("#page-header-bg, .nectar-particles, #page-header-bg .fade-out").css("visibility", "visible").removeClass("out-of-sight")));
        }
        g.length > 0 &&
            (((-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")) || navigator.userAgent.match(/(iPod|iPhone|iPad)/)) &&
                (t.onunload = function () {
                    La(), e('#page-header-bg[data-parallax="1"] .span_6').css({ opacity: 1 });
                }),
            0 == e(".nectar-box-roll").length && ja());
    }
    function Ya() {
        if ((0 == e("#page-header-bg .nectar-particles").length && 0 == e('#page-header-bg[data-text-effect="none"]').length) || (e(".nectar-box-roll").length > 0 && 0 == e("#page-header-bg .nectar-particles").length)) {
            var t = 0 == e(".nectar-box-roll").length ? "#page-header-bg .span_6" : ".nectar-box-roll .overlaid-content .span_6";
            e(t)
                .find(".wraped")
                .each(function (t) {
                    e(this)
                        .find("span")
                        .delay(370 * t)
                        .transition({ rotateX: "0", opacity: 1, y: 0 }, 400, "easeOutQuad");
                }),
                setTimeout(function () {
                    e(t)
                        .find(".inner-wrap > *:not(.top-heading)")
                        .each(function (t) {
                            e(this)
                                .delay(370 * t)
                                .transition({ rotateX: "0", opacity: 1, y: 0 }, 650, "easeOutQuad");
                        }),
                        e(".scroll-down-wrap, .scroll-down-wrap .section-down-arrow").removeClass("hidden");
                }, 370 * e(t).find(".wraped").length);
        }
    }
    function ja() {
        g.each(function () {
            if ("rotate_in" == e(this).attr("data-text-effect")) {
                var t = "none";
                if ((e(this).find(".span_6 h1").length > 0 && (t = "h1"), "none" != t)) {
                    var a = e(this).find(".nectar-particles").length > 0 ? ".inner-wrap.shape-1" : ".span_6";
                    e(this)
                        .find(a)
                        .find(t)
                        .addClass("top-heading")
                        .contents()
                        .filter(function () {
                            return 3 === this.nodeType && void 0 !== this.data && this.data.replace(/\s+/, "");
                        })
                        .wrap('<span class="wraped"></span>'),
                        e(this)
                            .find(a)
                            .find(".wraped")
                            .each(function () {
                                var t = e(this),
                                    a = t.text().split(" "),
                                    n = "";
                                e.each(a, function (e, t) {
                                    t.replace(/\s+/, "") && (n += '<span class="wraped"><span>' + t + "</span></span> ");
                                }),
                                    t.replaceWith(e(n));
                            });
                }
            }
        });
        var t = p.length > 0 ? 800 : 0;
        0 == e("#page-header-bg .nectar-video-wrap video").length && setTimeout(Ya, t);
    }
    function Ba() {
        if (e('#header-outer[data-permanent-transparent="1"]').length > 0 && e('body[data-bg-header="true"]').length > 0) {
            0 == e(".container-wrap div[data-midnight]").length && e(".container-wrap").attr("data-midnight", "dark");
            var t = [];
            e("div[data-midnight]:not(.has-global-section)").each(function () {
                (("light" == e(this).attr("data-midnight") && 0 == e(this).parents(".pum-content").length) || ("dark" == e(this).attr("data-midnight") && 0 == e(this).parents(".pum-content").length)) &&
                    ((e(this).is("#page-header-bg") && e(this).parents("#page-header-wrap[data-midnight]").length > 0) || t.push(e(this)));
            }),
                t.length > 0 &&
                    e.each(t, function (a, n) {
                        if ("light" == n.attr("data-midnight") || "dark" == n.attr("data-midnight")) {
                            var i = n;
                            new Waypoint({
                                element: i[0],
                                handler: function (n) {
                                    var s;
                                    e("body.material-ocm-open").length > 0 ||
                                        e("#slide-out-widget-area.open").length > 0 ||
                                        "none" == i.css("display") ||
                                        ("down" == n
                                            ? ((s = "light" == i.attr("data-midnight") ? "" : "dark-slide"), d.removeClass("dark-slide").addClass(s))
                                            : ((s = "light" == t[a - 1 >= 0 ? a - 1 : a].attr("data-midnight") ? "" : "dark-slide"), d.removeClass("dark-slide").addClass(s)));
                                },
                                offset: d.height(),
                            });
                        }
                    });
        }
    }
    function Pa() {
        e(".nectar-box-roll").length > 0 &&
            "undefined" != typeof NectarBoxRoll &&
            (ja(),
            e(t).on("nectar-box-roll-scroll-disabled", function () {
                de.preventScroll = !0;
            }),
            e(t).on("nectar-box-roll-scroll-enabled", function () {
                de.preventScroll = !1;
            }),
            ((se = new NectarBoxRoll(oe, Ra, Ba, Ln, ua)).inUse = !0));
    }
    function Ra() {
        var t, a, i, o, l, c, h, u, p;
        (a = 1 == ne ? "500%" : "93%"),
            (i = 1 == ne ? "500%" : "95%"),
            e(ae + '.row-bg-wrap[data-bg-animation]:not([data-bg-animation="none"]) .row-bg').each(function () {
                var n = e(this).parents(".row-bg-wrap").attr("data-bg-animation");
                t = "zoom-out-reveal" != n && -1 == n.indexOf("reveal-from-") ? a : i;
                var s = e(this),
                    r = new Waypoint({
                        element: s.parents(".row-bg-wrap")[0],
                        handler: function () {
                            (s.parents(".wpb_tab").length > 0 && "hidden" == s.parents(".wpb_tab").css("visibility")) || s.hasClass("animated-in")
                                ? r.destroy()
                                : (s.parents(".inner-wrap").addClass("animated-in"),
                                  ("zoom-out-reveal" == n || n.indexOf("reveal-from-") > -1 || s.parents(".nectar-scrolling-text").length > 0) && s.parents(".row-bg-wrap").addClass("animated-in"),
                                  r.destroy());
                        },
                        offset: t,
                    });
            }),
            (l = 1 == ne ? "500%" : "93%"),
            (c = 1 == ne ? "500%" : "80%"),
            e(ae + '.column-image-bg-wrap[data-bg-animation]:not([data-bg-animation="none"]):not([data-bg-animation*="displace-filter"]) .column-image-bg').each(function () {
                var t = e(this).parents(".column-image-bg-wrap").attr("data-bg-animation");
                o = "zoom-out-reveal" != t && -1 == t.indexOf("reveal-from-") ? l : "ro-reveal-from-bottom" == t && 0 == ne ? "95%" : "ro-reveal-from-top" == t && 0 == ne ? "65%" : c;
                var a = e(this),
                    n = new Waypoint({
                        element: a.parents(".column-image-bg-wrap")[0],
                        handler: function () {
                            (a.parents(".wpb_tab").length > 0 && "hidden" == a.parents(".wpb_tab").css("visibility")) || a.hasClass("animated-in")
                                ? n.destroy()
                                : (a.parents(".inner-wrap").addClass("animated-in"),
                                  ("zoom-out-reveal" == t || t.indexOf("reveal-from-") > -1) &&
                                      (a.parents(".column-image-bg-wrap").addClass("animated-in"),
                                      a.parents(".column-image-bg-wrap").siblings(".column-bg-overlay-wrap").addClass("animated-in"),
                                      a.parents(".vc_column-inner").addClass("revealed-bg")),
                                  n.destroy());
                        },
                        offset: o,
                    });
            }),
            e(ae + ".column-bg-overlay-wrap[data-bg-animation]").each(function () {
                o = c;
                var t = e(this),
                    a = e(this).attr("data-bg-animation");
                if (("zoom-out-reveal" == a || a.indexOf("reveal-from-") > 0) && 0 == t.parent().find(".column-image-bg-wrap").length)
                    var n = new Waypoint({
                        element: t[0],
                        handler: function () {
                            t.hasClass("animated-in") ? n.destroy() : (t.addClass("animated-in"), t.parents(".vc_column-inner").addClass("revealed-bg"), n.destroy());
                        },
                        offset: o,
                    });
            }),
            Mt(),
            Lt(),
            Pt(),
            (h = 1 == ne ? "250%" : "75%"),
            e(ae + '.nectar-icon-list[data-animate="true"]').each(function () {
                var t = e(this),
                    a = new Waypoint({
                        element: t[0],
                        handler: function () {
                            (t.parents(".wpb_tab").length > 0 && "hidden" == t.parents(".wpb_tab").css("visibility")) || t.hasClass("completed")
                                ? a.destroy()
                                : (t.each(function () {
                                      var a = t.is('[data-direction="horizontal"]') ? 100 : 300;
                                      e(this)
                                          .find(".nectar-icon-list-item")
                                          .each(function (t) {
                                              var n = e(this);
                                              setTimeout(function () {
                                                  n.addClass("animated");
                                              }, t * a);
                                          });
                                  }),
                                  t.addClass("completed"),
                                  a.destroy());
                        },
                        offset: h,
                    });
            }),
            Jt(),
            Kt(),
            Xt(),
            (u = 1 == ne ? "200%" : "95%"),
            e(ae + ".clients.fade-in-animation").each(function () {
                var t = e(this),
                    a = new Waypoint({
                        element: t[0],
                        handler: function () {
                            (t.parents(".wpb_tab").length > 0 && "hidden" == t.parents(".wpb_tab").css("visibility")) || t.hasClass("animated-in")
                                ? a.destroy()
                                : (t.find("> div").each(function (t) {
                                      e(this)
                                          .delay(80 * t)
                                          .transition({ opacity: "1" }, 450);
                                  }),
                                  setTimeout(function () {
                                      t.addClass("completed");
                                  }, 80 * t.find("> div").length + 450),
                                  t.addClass("animated-in"),
                                  a.destroy());
                        },
                        offset: u,
                    });
            }),
            qt(),
            (p = 1 == ne ? "500%" : "bottom-in-view"),
            0 == S.length
                ? (e(".svg-icon-holder:not(.animated-in)")
                      .has("svg")
                      .each(function (t) {
                          var a = e(this);
                          z && a.attr("data-animation", "false"),
                              a.find("svg").css({ height: parseInt(a.attr("data-size")) + "px", width: parseInt(a.attr("data-size")) + "px" }),
                              e(this)
                                  .find("svg")
                                  .attr("id", "nectar-svg-animation-instance-" + t);
                          var n = a.is("[data-animation-speed]") && a.attr("data-animation-speed").length > 0 ? a.attr("data-animation-speed") : 200;
                          if (
                              ("false" == a.attr("data-animation") && ((n = 1), a.css("opacity", "1")),
                              a.hasClass("bound") ||
                                  (S[t] = new Vivus(a.find("svg").attr("id"), {
                                      type: "delayed",
                                      pathTimingFunction: Vivus.EASE_OUT,
                                      animTimingFunction: Vivus.LINEAR,
                                      duration: n,
                                      onReady: function () {
                                          a.css({ height: parseInt(a.attr("data-size")) + "px", width: parseInt(a.attr("data-size")) + "px" });
                                      },
                                  })),
                              1 !== n)
                          )
                              var i = new Waypoint({
                                  element: a[0],
                                  handler: function () {
                                      a.hasClass("animated-in") ? i.destroy() : (s(), a.addClass("animated-in"), i.destroy());
                                  },
                                  offset: p,
                              });
                          else s();
                          function s() {
                              var e = 0;
                              a.is("[data-animation-delay]") && a.attr("data-animation-delay").length > 0 && "false" != a.attr("data-animation") && (e = a.attr("data-animation-delay"));
                              var t = a
                                  .find("svg")
                                  .attr("id")
                                  .replace(/[^0-9]/g, "");
                              1 == S[t].isReady
                                  ? setTimeout(function () {
                                        a.css("opacity", "1"), S[t].reset().play();
                                    }, e)
                                  : setTimeout(s, 50);
                          }
                          a.addClass("bound");
                      }),
                  e('.vc_row-o-equal-height .svg-icon-holder[data-animation="true"]').length > 0 &&
                      0 == e("#nectar_fullscreen_rows").length &&
                      s.on("smartresize", function () {
                          clearTimeout(n),
                              (n = setTimeout(function () {
                                  S.length > 0 &&
                                      e(".svg-icon-holder.animated-in").each(function () {
                                          if ((e(this).css("opacity", "1"), e(this).is("[id]"))) {
                                              var t = e(this)
                                                  .attr("id")
                                                  .replace(/[^0-9]/g, "");
                                              S[t].finish();
                                          }
                                      });
                              }, 300));
                      }))
                : e(".svg-icon-holder").addClass("animated-in").css("opacity", "1"),
            e("#nectar_fullscreen_rows .svg-icon-holder.animated-in")
                .has("svg")
                .each(function (t) {
                    var a = 0;
                    e(this).is("[data-animation-delay]") && e(this).attr("data-animation-delay").length > 0 && "false" != e(this).attr("data-animation") && (a = e(this).attr("data-animation-delay"));
                    var n = e(this),
                        i = n
                            .find("svg")
                            .attr("id")
                            .replace(/[^0-9]/g, "");
                    clearTimeout(Z[t]),
                        "false" == n.attr("data-animation")
                            ? (n.css("opacity", "1"), S[i].finish())
                            : e(this).parents(".active").length > 0 || e(this).parents("#footer-outer").length > 0 || e("body.mobile").length > 0
                            ? (S[i].reset(),
                              (Z[t] = setTimeout(function () {
                                  S[i].play();
                              }, a)))
                            : S[i].reset().stop();
                }),
            (function () {
                if (
                    (e(".nectar-milestone").each(function () {
                        var t;
                        e(this).is("[data-symbol]") &&
                            (0 == e(this).find(".symbol-wrap").length &&
                                ("before" == e(this).attr("data-symbol-pos")
                                    ? e(this)
                                          .find(".number")
                                          .prepend('<div class="symbol-wrap"><span class="symbol">' + e(this).attr("data-symbol") + "</span></div>")
                                    : e(this)
                                          .find(".number")
                                          .append('<div class="symbol-wrap"><span class="symbol">' + e(this).attr("data-symbol") + "</span></div>")),
                            (t = e(this).attr("data-symbol-size") == e(this).find(".number").attr("data-number-size") && "superscript" == e(this).attr("data-symbol-alignment") ? 32 : parseInt(e(this).attr("data-symbol-size"))),
                            e(this)
                                .find(".symbol-wrap")
                                .css({ "font-size": t + "px", "line-height": t + "px" })),
                            e(this)
                                .find(".number")
                                .css({ "font-size": e(this).find(".number").attr("data-number-size") + "px", "line-height": e(this).find(".number").attr("data-number-size") + "px" });
                    }),
                    (!z && e(".nectar-milestone").length > 0) || (r.hasClass("rtl") && e(".nectar-milestone").length > 0))
                ) {
                    var t = "";
                    e(ae + ".nectar-milestone.motion_blur").each(function (a) {
                        e(this).removeClass(function (e, t) {
                            return (t.match(/(^|\s)instance-\S+/g) || []).join(" ");
                        }),
                            e(this).addClass("instance-" + a);
                        var n = e(this).find(".number").css("color"),
                            i = parseInt(n.substring(1), 16),
                            s = (16711680 & i) >> 16,
                            r = (65280 & i) >> 8,
                            o = (255 & i) >> 0,
                            l = "rgba(" + s + "," + r + "," + o + ",0.2)",
                            d = "rgba(" + s + "," + r + "," + o + ",1)",
                            c = parseInt(e(this).find(".number").attr("data-number-size"));
                        if (
                            ((t +=
                                "@keyframes motion-blur-number-" +
                                a +
                                " {  0% { opacity: 0;color: " +
                                l +
                                "; text-shadow: 0 " +
                                c / 20 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 10 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 6 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 5 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 4 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 20 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 10 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 6 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 5 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 4 +
                                "px 0 " +
                                l +
                                "; transform: translateZ(0px) translateY(-100%); -webkit-transform: translateZ(0px) translateY(-100%); } 33% { opacity: 1 }100% { color: " +
                                d +
                                "; text-shadow: none; transform: translateZ(0px) translateY(0px); -webkit-transform: translateZ(0px) translateY(0px); } } @-webkit-keyframes motion-blur-number-" +
                                a +
                                " {  0% { opacity: 0;color: " +
                                l +
                                "; text-shadow: 0 " +
                                c / 20 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 10 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 6 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 5 +
                                "px 0 " +
                                l +
                                ", 0 " +
                                c / 4 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 20 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 10 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 6 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 5 +
                                "px 0 " +
                                l +
                                ", 0 -" +
                                c / 4 +
                                "px 0 " +
                                l +
                                "; transform: translateZ(0px) translateY(-100%); -webkit-transform: translateZ(0px) translateY(-100%); } 33% { opacity: 1 }100% { color: " +
                                d +
                                "; text-shadow: none; transform: translateZ(0px) translateY(0px); -webkit-transform: translateZ(0px) translateY(0px); } } .nectar-milestone.motion_blur.instance-" +
                                a +
                                " .number span.in-sight { animation: 0.65s cubic-bezier(0, 0, 0.17, 1) 0s normal backwards 1 motion-blur-number-" +
                                a +
                                "; -webkit-animation: 0.65s cubic-bezier(0, 0, 0.17, 1) 0s normal backwards 1 motion-blur-number-" +
                                a +
                                "; } "),
                            0 != re.$usingFullScreenRows || 0 == e(this).find(".number > span").length)
                        ) {
                            var h = e(this).find(".symbol-wrap").clone();
                            e(this).find(".symbol-wrap").remove();
                            var u = e(this).find(".number").text().split(""),
                                p = e(this).find(".number");
                            p.empty(),
                                e.each(u, function (e, t) {
                                    p.append("<span>" + t + "</span");
                                }),
                                e(this).has("[data-symbol]") && ("after" == e(this).attr("data-symbol-pos") ? p.append(h) : p.prepend(h));
                        }
                    }),
                        Ue(t, "milestone-blur"),
                        et();
                }
            })(),
            gt(),
            e(ae + '.owl-carousel[data-enable-animation="true"]').each(function () {
                var t = 1 == ne ? "200%" : "bottom-in-view",
                    a = 0;
                e(this).is("[data-animation-delay]") && e(this).attr("data-animation-delay").length > 0 && "false" != e(this).attr("data-animation") && (a = e(this).attr("data-animation-delay"));
                var n = e(this),
                    i = new Waypoint({
                        element: n[0],
                        handler: function () {
                            (n.parents(".wpb_tab").length > 0 && "hidden" == n.parents(".wpb_tab").css("visibility")) || n.hasClass("animated-in")
                                ? i.destroy()
                                : (setTimeout(function () {
                                      n.find(".owl-stage > .owl-item").each(function (t) {
                                          e(this)
                                              .delay(200 * t)
                                              .transition({ opacity: "1", y: "0" }, 600, "easeOutQuart");
                                      }),
                                          n.addClass("animated-in");
                                  }, a),
                                  i.destroy());
                        },
                        offset: t,
                    });
            }),
            (function () {
                if (e('body[data-header-inherit-rc="true"]').length > 0 && 0 == e(".mobile").length && e('#header-outer[data-transparent-header="true"]').length > 0) {
                    var t = b / 2 + w + oe.adminBarHeight;
                    0 == e('#header-outer[data-permanent-transparent="1"]').length && (t = b - y + Math.ceil((2 * w) / 1.8) + oe.adminBarHeight),
                        e(".main-content > .row > .wpb_row").each(function () {
                            var a,
                                n = e(this);
                            new Waypoint({
                                element: n[0],
                                handler: function (t) {
                                    "down" == t
                                        ? n.find(".row-bg.using-bg-color").length > 0
                                            ? ((a = n.find("> .col.span_12.light").length > 0 ? "light-text" : "dark-text"),
                                              d.css("background-color", n.find(".row-bg").css("background-color")).removeClass("light-text").removeClass("dark-text").addClass(a),
                                              d.attr("data-current-row-bg-color", n.find(".row-bg").css("background-color")),
                                              e("body.material #header-outer .bg-color-stripe").css("background-color", n.find(".row-bg").css("background-color")))
                                            : (d.css("background-color", d.attr("data-user-set-bg")).removeClass("light-text").removeClass("dark-text"),
                                              d.attr("data-current-row-bg-color", d.attr("data-user-set-bg")),
                                              e("body.material #header-outer .bg-color-stripe").css("background-color", ""))
                                        : n.prev("div.wpb_row").find(".row-bg.using-bg-color").length > 0
                                        ? ((a = n.prev("div.wpb_row").find("> .col.span_12.light").length > 0 ? "light-text" : "dark-text"),
                                          d.css("background-color", n.prev("div.wpb_row").find(".row-bg").css("background-color")).removeClass("light-text").removeClass("dark-text").addClass(a),
                                          d.attr("data-current-row-bg-color", n.prev("div.wpb_row").find(".row-bg").css("background-color")),
                                          e("body.material #header-outer .bg-color-stripe").css("background-color", n.prev("div.wpb_row").find(".row-bg").css("background-color")))
                                        : (d.css("background-color", d.attr("data-user-set-bg")).removeClass("light-text").removeClass("dark-text"),
                                          d.attr("data-current-row-bg-color", d.attr("data-user-set-bg")),
                                          e("body.material #header-outer .bg-color-stripe").css("background-color", ""));
                                },
                                offset: t,
                            });
                        });
                }
            })(),
            ft(),
            Yt(),
            ea(),
            Bt(),
            Je(),
            Gt(),
            (function () {
                if (K.length > 0) for (var t = 0; t < K.length; t++) clearInterval(K[t].interval);
                (K = []),
                    e(".nectar-rotating-words-title").each(function (t) {
                        var a = parseInt(e(this).attr("data-rotation"));
                        K[t] = new Ke(e(this), a);
                    });
            })(),
            jt();
    }
    function Va() {
        var a;
        pe(),
            me(),
            setTimeout(ve, 100),
            _e(),
            $e(),
            Oe(),
            Se(),
            Me(),
            setTimeout(at, 60),
            rt(),
            r.on("click", ".toggle h3 a", function () {
                if (!e(this).parents(".toggles").hasClass("accordion")) {
                    if (0 == e(this).parents('.toggle[data-inner-wrap="true"]').length) e(this).parents(".toggle").find("> div").slideToggle(300);
                    else {
                        var t = e(this).parents(".toggle").find("> div")[0];
                        t.style.maxHeight ? (t.style.maxHeight = null) : (t.style.maxHeight = t.scrollHeight + "px");
                    }
                    if (
                        (e(this).parents(".toggle").toggleClass("open"),
                        e(this).parents(".toggle").hasClass("open") ? e(this).find("i").attr("class", "fa fa-minus-circle") : e(this).find("i").attr("class", "fa fa-plus-circle"),
                        e(this).parents(".toggle").find("> div .iframe-embed").length > 0 && "0" == e(this).parents(".toggle").find("> div iframe.iframe-embed").height() && ca(),
                        e(this).parents(".toggle").find("> div img").length > 0 && e(this).parents(".toggle").is('[data-inner-wrap="true"]'))
                    )
                        for (var a = 1; a < 10; a++) setTimeout(st, 100 * a);
                    return (
                        e(this).parents(".full-width-content").length > 0 &&
                            setTimeout(function () {
                                Ot();
                            }, 300),
                        e("#nectar_fullscreen_rows").length > 0 &&
                            setTimeout(function () {
                                s.trigger("smartresize");
                            }, 300),
                        !1
                    );
                }
            }),
            r.on("click", ".toggles.accordion .toggle h3 a", function (t) {
                if (e(this).parents(".toggle").hasClass("open")) return !1;
                var a,
                    n = e(this).parents(".toggles"),
                    i = e(this).parents(".toggle");
                if (0 == e(this).parents('.toggle[data-inner-wrap="true"]').length)
                    n.find(".toggle > div").slideUp(300), n.find(".toggle h3 a i").attr("class", "fa fa-plus-circle"), n.find(".toggle").removeClass("open"), i.find("> div").slideDown(300), i.addClass("open");
                else {
                    void 0 !== t.originalEvent &&
                        oe.winW < 1e3 &&
                        n.find(".toggle.open").length > 0 &&
                        0 == re.$usingFullScreenRows &&
                        (n.find(".toggle.open"),
                        setTimeout(function () {
                            var t = i.offset().top - oe.adminBarHeight;
                            e('#header-outer[data-mobile-fixed="1"]').length > 0 && (t = i.offset().top - d.outerHeight() - oe.adminBarHeight), Pe(t, 500, "easeInOutQuint");
                        }, 50));
                    var r = i.find("> div")[0];
                    n.find(".toggle > div").each(function () {
                        e(this)[0].style.maxHeight = null;
                    }),
                        n.find(".toggle h3 a i").attr("class", "fa fa-plus-circle"),
                        n.find(".toggle").removeClass("open"),
                        (r.style.maxHeight = r.scrollHeight + "px"),
                        i.addClass("open");
                }
                return (
                    i.hasClass("open") ? e(this).find("i").attr("class", "fa fa-minus-circle") : e(this).find("i").attr("class", "fa fa-plus-circle"),
                    e(this).parents(".full-width-content").length > 0 &&
                        (clearTimeout(a),
                        (a = setTimeout(function () {
                            Ot();
                        }, 400))),
                    e("#nectar_fullscreen_rows").length > 0 &&
                        (clearTimeout(a),
                        (a = setTimeout(function () {
                            s.trigger("smartresize");
                        }, 400))),
                    !1
                );
            }),
            ht(),
            oa(),
            ct(),
            r.on("click", '.nectar-cta[data-using-bg="true"]:not([data-style="material"]) .link_wrap', function (t) {
                e(t.target).is("a") || e(this).find("a.link_text")[0].click();
            }),
            0 !== e(".team-member").length &&
                (r.on("click", '.team-member[data-style="bio_fullscreen"], .team-member[data-style="bio_fullscreen_alt"]', function () {
                    if (!(e(".nectar_team_member_overlay").length > 0)) {
                        var t = e("body > #boxed").length > 0 ? "in-boxed" : "",
                            a = e(this).find(".nectar_team_bio").html(),
                            n = e(this).is('[data-style="bio_fullscreen_alt"]') ? e(this).find(".team-meta h5").text() : e(this).find(".team-meta p").text(),
                            i = e(this).find(".nectar_team_bio_img[data-img-src]").length > 0 ? e(this).find(".nectar_team_bio_img").attr("data-img-src") : "",
                            o = e(this).is('[data-style="bio_fullscreen_alt"]') ? "bio-fullscreen-alt" : "bio-fullscreen",
                            l = "";
                        if (
                            ((l = e(this).is('[data-style="bio_fullscreen_alt"]')
                                ? '<div class="title">' + n + "</div><h2>" + e(this).find(".team-meta h3").text() + "</h2>"
                                : "<h2>" + e(this).find(".team-meta h3").text() + '</h2><div class="title">' + n + "</div>"),
                            r.append(
                                '<div class="nectar_team_member_overlay ' +
                                    t +
                                    '" data-style="' +
                                    o +
                                    '"><div class="inner-wrap"><div class="team_member_details"><div class="bio-inner"><span class="mobile-close"></span>' +
                                    l +
                                    '<div class="team-desc">' +
                                    Le(a) +
                                    '</div></div></div><div class="team_member_picture"><div class="team_member_image_bg_cover"></div><div class="team_member_picture_wrap"><div class="team_member_image"></div></div></div></div></div>'
                            ),
                            i.length > 0)
                        ) {
                            var c = new Image();
                            (c.src = i),
                                (c.onload = function () {
                                    e(".nectar_team_member_overlay .team_member_image").css("opacity", "1");
                                }),
                                e(".nectar_team_member_overlay .team_member_image").css({ "background-image": 'url("' + i + '")' });
                        }
                        var h = e('body[data-header-format="left-header"]').length > 0 && s.width() > 1e3 ? 0 : d.height();
                        e(".nectar_team_member_overlay .inner-wrap").css({ "padding-top": h }),
                            e(".using-mobile-browser").length > 0 && e("body,html").addClass("nectar-no-scrolling"),
                            ut(),
                            e(".nectar_team_member_overlay").addClass("open").addClass("animating"),
                            setTimeout(function () {
                                e(".nectar_team_member_close").addClass("visible"), e(".nectar_team_member_overlay").removeClass("animating");
                            }, 500),
                            e('.team-member[data-style="bio_fullscreen"]').length > 0 && oe.usingMobileBrowser && e(".nectar_team_member_overlay").addClass("on-mobile"),
                            ca();
                    }
                }),
                r.on("click", ".nectar_team_member_overlay", function (t) {
                    if (e(t.target).is("a") || e(t.target).parents("a").length > 0 || e(t.target).is(".skip-team-member-close") || e(t.target).parents(".skip-team-member-close").length > 0) return !0;
                    e(this).hasClass("animating") ||
                        (e(".nectar_team_member_overlay").removeClass("open"),
                        e(".nectar_team_member_close").removeClass("visible"),
                        e(".using-mobile-browser").length > 0 && e("body,html").removeClass("nectar-no-scrolling"),
                        setTimeout(function () {
                            e(".nectar_team_member_overlay, .nectar_team_member_close").remove();
                        }, 820));
                }),
                (e('.team-member[data-style="bio_fullscreen"]').length > 0 || e('.team-member[data-style="bio_fullscreen_alt"]').length > 0) && (s.on("resize", ut), !oe.usingMobileBrowser)) &&
                new fe("", "close-indicator"),
            e(".nectar-flip-box").length > 0 &&
                (oe.usingMobileBrowser &&
                    r.on("click", ".nectar-flip-box", function () {
                        e(this).toggleClass("flipped");
                    }),
                vt(),
                s.on("smartresize", vt)),
            Ee(),
            Ht(),
            St(),
            mt(),
            En(),
            On(),
            At(),
            e(".morphing-outline").length > 0 && (setTimeout(ft, 100), setTimeout(Ot, 125), s.on("smartresize", ft)),
            (q = []),
            oe.usingMobileBrowser ||
                e("[data-nectar-link-indicator]").each(function (t) {
                    q[t] = new fe(e(this), "link-indicator");
                }),
            Zt(),
            (function () {
                if (e(".nectar_cascading_images").length > 0) {
                    var t = [];
                    e(".nectar_cascading_images").each(function (a) {
                        imagesLoaded(e(this), function (n) {
                            Wt(), e(n.elements[0]).is('[data-parallax="yes"]') && !oe.usingMobileBrowser && 0 == e("#nectar_fullscreen_rows").length && (t[a] = new Ft(e(n.elements[0]), e(n.elements[0]).attr("data-parallax-intensity")));
                        });
                    }),
                        s.on("resize", Wt);
                }
            })(),
            Vt(),
            ta(),
            (function () {
                e('.page-submenu[data-sticky="true"]').length > 0 &&
                    0 == e("#nectar_fullscreen_rows").length &&
                    (!(function () {
                        var e = t.jQuery,
                            a = t.Waypoint,
                            n = Ye();
                        Ye();
                        function i(t) {
                            (this.options = e.extend({}, a.defaults, i.defaults, t)),
                                (this.element = this.options.element),
                                (this.$element = e(this.element)),
                                this.createWrapper(),
                                (this.topLevel = e(this.element).parents(".top-level").length > 0),
                                this.createWaypoint();
                        }
                        s.on("smartresize", function () {
                            if (
                                ((n = Ye()),
                                u.length > 0 && "fixed" == u.css("position") && (n += u.height()),
                                f.length > 0 && s.width() > 1e3 && e('body[data-hhun="1"]').length > 0 && (n += f.height()),
                                e(".page-submenu.stuck").length > 0)
                            ) {
                                if (
                                    (e(".page-submenu.stuck").addClass("no-trans").css("top", n).css("transform", "translateY(0)").addClass("stuck"),
                                    setTimeout(function () {
                                        e(".page-submenu.stuck").removeClass("no-trans");
                                    }, 50),
                                    e(".page-submenu.stuck").parents(".wpb_row").css("z-index", 1e4),
                                    e("#boxed").length > 0)
                                ) {
                                    var t = s.width() > 1e3 ? 0.04 * e(".container-wrap").width() : 39;
                                    e(".page-submenu.stuck").css({ "margin-left": "-" + t + "px", width: e(".container-wrap").width() });
                                }
                            } else e(".page-submenu.stuck").css("top", "0").removeClass("stuck"), e(".page-submenu.stuck").parents(".wpb_row").css("z-index", "auto"), e("#boxed").length > 0 && e(".page-submenu.stuck").css({ "margin-left": "0px", width: "100%" });
                        }),
                            (i.prototype.createWaypoint = function () {
                                var t = this.options.handler;
                                (n = Ye()),
                                    this.topLevel && e('body[data-hhun="1"] #header-outer.detached:not(.invisible)').length > 0 && ((n += 1), this.$element.css({ "margin-top": "-1px" })),
                                    u.length > 0 && "fixed" == u.css("position") && (n += u.height()),
                                    f.length > 0 && s.width() > 1e3 && e('body[data-hhun="1"]').length > 0 && (n += f.height()),
                                    (this.waypoint = new a(
                                        e.extend({}, this.options, {
                                            element: this.wrapper,
                                            handler: e.proxy(function (a) {
                                                var i = this.options.direction.indexOf(a) > -1,
                                                    r = i ? this.$element.outerHeight(!0) : "";
                                                if ((this.$wrapper.height(r), i)) {
                                                    var o = 0;
                                                    if (this.topLevel && e('body[data-hhun="1"] #header-outer.detached:not(.invisible)').length > 0) {
                                                        var l = d.outerHeight(),
                                                            h = 0;
                                                        c.length > 0 && (l -= oe.secondaryHeaderHeight), f.length > 0 && 0 == e("body.mobile").length && (h = ie ? f.height() : 0), (o = l - h);
                                                    }
                                                    this.$element
                                                        .addClass("no-trans")
                                                        .css("top", n)
                                                        .css("transform", "translateY(" + o + "px)")
                                                        .addClass("stuck");
                                                    var u = this;
                                                    if (
                                                        (setTimeout(function () {
                                                            u.$element.removeClass("no-trans");
                                                        }, 50),
                                                        this.$element.parents(".wpb_row").css("z-index", 1e4),
                                                        e("#boxed").length > 0)
                                                    ) {
                                                        var p = s.width() > 1e3 ? 0.04 * e(".container-wrap").width() : 39;
                                                        this.$element.css({ "margin-left": "-" + p + "px", width: e(".container-wrap").width() });
                                                    }
                                                } else this.$element.css("top", "0").removeClass("stuck"), e("#boxed").length > 0 && this.$element.css({ "margin-left": "0px", width: "100%" });
                                                t && t.call(this, a);
                                            }, this),
                                            offset: n,
                                        })
                                    ));
                                var i = this;
                                setInterval(function () {
                                    if (e('body[data-hhun="1"] #header-outer.detached:not(.invisible)').length > 0) {
                                        var t = d.outerHeight();
                                        c.length > 0 && (t -= oe.secondaryHeaderHeight), (i.waypoint.options.offset = n + t);
                                    } else i.waypoint.options.offset = n;
                                    a.refreshAll();
                                }, 100);
                            }),
                            (i.prototype.createWrapper = function () {
                                this.options.wrapper && this.$element.wrap(this.options.wrapper), (this.$wrapper = this.$element.parent()), (this.wrapper = this.$wrapper[0]);
                            }),
                            (i.prototype.destroy = function () {
                                this.$element.parent()[0] === this.wrapper && (this.waypoint.destroy(), this.$element.removeClass(this.options.stuckClass), this.options.wrapper && this.$element.unwrap());
                            }),
                            (i.defaults = { wrapper: '<div class="sticky-wrapper" />', stuckClass: "stuck", direction: "down right" }),
                            (a.Sticky = i);
                    })(),
                    e('.page-submenu[data-sticky="true"]').each(function () {
                        var t = e(this)[0];
                        if (e(this).parents(".span_12").find("> .wpb_column").length > 1) {
                            var a = e(this).clone(),
                                n = e(this).parents(".wpb_row");
                            e(this).parents(".wpb_row.has-global-section").length > 0 && (n = e(this).parents(".wpb_row.has-global-section")), e(this).remove(), n.before(a), (t = a[0]);
                        }
                        new Waypoint.Sticky({ element: t });
                    }));
                0 == e("#nectar_fullscreen_rows").length && e(".page-submenu").parents(".wpb_row").css("z-index", 1e4);
                e(".page-submenu .mobile-menu-link").on("click", function () {
                    return e(this).parents(".page-submenu").find("ul").stop(!0).slideToggle(350), !1;
                }),
                    e(".page-submenu ul li a").on("click", function () {
                        e("body.mobile").length > 0 && e(this).parents(".page-submenu").find("ul").stop(!0).slideToggle(350);
                    });
            })(),
            (V = []),
            "undefined" == typeof NectarLiquid ||
                oe.usingFrontEndEditor ||
                e('.row-bg-wrap[data-bg-animation*="displace-filter"] .row-bg.using-image, .column-image-bg-wrap[data-bg-animation*="displace-filter"] .column-image-bg').each(function (t) {
                    var a,
                        n,
                        i = e(this);
                    e(this).is(".row-bg")
                        ? ((a = e(this).parents(".row-bg-wrap").attr("data-bg-animation")), (n = "row"))
                        : e(this).is(".column-image-bg") && ((a = e(this).parents(".column-image-bg-wrap").attr("data-bg-animation")), (n = "col")),
                        (V[t] = new NectarLiquid(i, a, n));
                }),
            aa(),
            na(),
            (function () {
                function t() {
                    e('.blog-recent[data-style="title_only"]').each(function () {
                        if (e(this).find("> .col").length > 1) return !1;
                        var t = e(this).parent().parent().parent();
                        if (t.hasClass("vc_col-sm-3") || t.hasClass("vc_col-sm-4") || t.hasClass("vc_col-sm-6") || t.hasClass("vc_col-sm-8") || t.hasClass("vc_col-sm-9"))
                            if (0 == e("body.mobile").length && 0 == e(this).next("div").length) {
                                var a = 0;
                                e(this).find("> .col").css("padding", "50px 20px"),
                                    e(this)
                                        .parents(".span_12")
                                        .find(" > .wpb_column")
                                        .each(function () {
                                            Math.floor(e(this).height()) > a && (a = Math.floor(e(this).height()));
                                        }),
                                    Math.floor(e(this).find("> .col").outerHeight(!0)) < Math.floor(e(this).parents(".wpb_row").height()) - 1 &&
                                        (e(this)
                                            .find("> .col")
                                            .css("padding-top", (a - e(this).find("> .col").height()) / 2 + "px"),
                                        e(this)
                                            .find("> .col")
                                            .css("padding-bottom", (a - e(this).find("> .col").height()) / 2 + "px"));
                            } else e(this).find("> .col").css("padding", "50px 20px");
                    });
                }
                e('.blog-recent[data-style="title_only"]').length > 0 && (t(), s.on("smartresize", t));
            })(),
            $n(),
            In(),
            Sn(),
            r.on("mouseover", '.post-area.featured_img_left .grav-wrap .text a, .masonry.material .masonry-blog-item .grav-wrap .text a, .blog-recent[data-style="material"] .grav-wrap .text a', function () {
                e(this).parents(".grav-wrap").find("img").addClass("hovered");
            }),
            r.on("mouseleave", '.post-area.featured_img_left .grav-wrap .text a, .masonry.material .masonry-blog-item .grav-wrap .text a, .blog-recent[data-style="material"] .grav-wrap .text a', function () {
                e(this).parents(".grav-wrap").find("img").removeClass("hovered");
            }),
            r.on("mouseleave", '.container-wrap[data-nav-pos="after_project_2"] #portfolio-nav ul li, .blog_next_prev_buttons[data-style="fullwidth_next_prev"] ul li', function () {
                e(this).addClass("mouse-leaving");
            }),
            Bn(),
            Xn(),
            (function () {
                if (e(".portfolio-items .col .style-3-alt").length > 0 || e(".portfolio-items .col .style-3").length > 0 || e(".portfolio-items .col .style-2").length > 0 || e(".portfolio-items .col .style-5").length > 0) {
                    var t = "";
                    e(".portfolio-items .col").each(function () {
                        var a = e(this).attr("data-title-color"),
                            n = e(this).attr("data-subtitle-color");
                        a.length > 0 &&
                            ((t += '.col[data-title-color="' + a + '"] .vert-center h3, .portfolio-items[data-ps="6"] .col[data-title-color="' + a + '"] .work-meta h4 { color: ' + a + "!important; } "),
                            (t += ' .portfolio-items[data-ps="8"] .col[data-title-color="' + a + '"] .line { background-color: ' + a + "; }"),
                            (t += '.portfolio-items[data-ps="8"] .col[data-title-color="' + a + '"] .next-arrow line { stroke: ' + a + "; } ")),
                            n.length > 0 && (t += '.col[data-subtitle-color="' + n + '"] .vert-center p, .portfolio-items[data-ps="6"] .col[data-title-color="' + a + '"] .work-meta p { color: ' + n + "!important; } ");
                    }),
                        Ue(t, "nectar-portfolio-colors");
                }
            })(),
            e("body.search-results").length > 0 &&
                e("#search-results article").length > 0 &&
                0 == e('#search-results[data-layout="list-no-sidebar"]').length &&
                0 == e('#search-results[data-layout="list-with-sidebar"]').length &&
                ((a = e("#search-results")).is('[data-layout="masonry-no-sidebar"]'),
                a.imagesLoaded(function () {
                    a.isotope({ itemSelector: ".result", layoutMode: "packery", packery: { gutter: 0 } }), a.find("article").css("opacity", "1");
                }),
                s.on("resize", function () {
                    a.isotope({ layoutMode: "packery", packery: { gutter: 0 } });
                })),
            Dn(),
            (function () {
                e(".single-portfolio #sidebar").attr("data-follow-on-scroll");
                if (0 == e("body.single-portfolio").length || 0 == e("#sidebar[data-follow-on-scroll]").length) return;
                if (1 == e(".single-portfolio #sidebar").attr("data-follow-on-scroll") && !r.hasClass("mobile") && parseInt(e("#sidebar").height()) + 50 <= parseInt(e(".post-area").height())) {
                    var t = Nn();
                    e(".single-portfolio #sidebar").theiaStickySidebar({ additionalMarginTop: t, updateSidebarHeight: !1 });
                }
            })(),
            xn();
    }
    function Xa() {
        (this.$toggleBtn = e(".nectar-shop-filters .nectar-shop-filter-trigger")),
            (this.$sidebar = e("#sidebar")),
            (this.sidebarPos = this.$sidebar.hasClass("col_last") ? "right" : "left"),
            (this.state = { open: this.getLS() ? this.getLS() : "true" }),
            this.setup(),
            this.events();
    }
    function Na() {
        (this.$qty = ""), (this.step = 1), (this.ajaxTimeout = ""), (this.ajaxTimeoutDur = 500), (this.state = { max: 1e5, min: 0, currentVal: 1, key: 0, removeFlag: !1 }), this.events();
    }
    function Da() {
        (this.state = { processing: !1, productID: !1, type: "regular" }), this.events();
    }
    function Qa() {
        var n;
        r.on("click", ".product .add_to_cart_button", function () {
            var t = e(this).parents("li").find("h2").length > 0 ? "h2" : "h3",
                a = e(this).parents("li").find(t).text();
            e("#header-outer .cart-notification span.item-name").html(a);
        }),
            r.on("mouseenter", "#header-outer .cart-notification", function () {
                e(this).hide(), e("#header-outer .widget_shopping_cart").addClass("open").stop(!0, !0).show(), e("#header-outer .cart_list").stop(!0, !0).show(), clearTimeout(n);
            });
        var i, o;
        function l() {
            !e(".widget_shopping_cart .widget_shopping_cart_content .cart_list .empty").length &&
                e(".widget_shopping_cart .widget_shopping_cart_content .cart_list").length > 0 &&
                (e(".cart-menu-wrap").addClass("has_products"),
                e("header#top nav > ul, #search-outer #search #close a, header#top .span_9 >.slide-out-widget-area-toggle").addClass("product_added"),
                e(".cart-menu-wrap").hasClass("static") || e(".cart-menu-wrap, #mobile-cart-link").addClass("first-load"));
        }
        function d() {
            e("#header-outer .cart-notification").stop(!0, !0).fadeOut();
        }
        if (
            (e("#header-outer .nectar-woo-cart").length > 0 &&
                e("#header-outer .nectar-woo-cart").hoverIntent(function () {
                    e("#header-outer .widget_shopping_cart").addClass("open").stop(!0, !0).show(), e("#header-outer .cart_list").stop(!0, !0).show(), clearTimeout(n), e("#header-outer .cart-notification").hide();
                }),
            r.on("mouseleave", "#header-outer .nectar-woo-cart", function () {
                var t = e(this);
                setTimeout(function () {
                    t.is(":hover") || (e("#header-outer .widget_shopping_cart").removeClass("open").stop(!0, !0).fadeOut(300), e("#header-outer .cart_list").stop(!0, !0).fadeOut(300));
                }, 200);
            }),
            0 == e('#header-outer[data-cart="false"]').length &&
                (r.on("added_to_cart", function (t) {
                    if ((clearTimeout(n), !e(".widget_shopping_cart .widget_shopping_cart_content .cart_list .empty").length && e(".widget_shopping_cart .widget_shopping_cart_content .cart_list").length > 0 && void 0 !== t.type)) {
                        if (e("#header-outer .cart-notification .item-name").length > 0 && 0 == e("#header-outer .cart-notification .item-name").text().length) return;
                        e("#header-outer .cart-menu-wrap").hasClass("has_products")
                            ? e("#header-outer .cart-notification").is(":visible")
                                ? e("#header-outer .cart-notification").show()
                                : e("#header-outer .cart-notification").fadeIn(400)
                            : setTimeout(function () {
                                  e("#header-outer .cart-notification").fadeIn(400);
                              }, 400),
                            e('body #header-outer [data-cart-style="slide_in_click"] .cart-menu-wrap').trigger("click"),
                            (n = setTimeout(d, 2700));
                    }
                }),
                r.on("added_to_cart", l)),
            0 == e('#header-outer[data-cart="false"]').length &&
                ((i = setInterval(l, 250)),
                setTimeout(function () {
                    clearInterval(i);
                }, 4500)),
            0 != e("body.woocommerce-account #customer_login").length &&
                (e(".woocommerce-account .woocommerce > #customer_login").prepend('<div class="nectar-form-controls" />'),
                e(".woocommerce-account .woocommerce > #customer_login > div:not(.nectar-form-controls)").each(function () {
                    var t = e(this).find("> h2").text();
                    e("#customer_login .nectar-form-controls").append('<div class="control">' + t + "</div>");
                }),
                e(".woocommerce-account .woocommerce > #customer_login .nectar-form-controls .control").on("click", function () {
                    e(".woocommerce-account .woocommerce > #customer_login .nectar-form-controls .control").removeClass("active"), e(this).addClass("active");
                    var t = e(this).index() + 1;
                    e('#customer_login div[class*="u-column"]').hide(),
                        e('#customer_login div[class*="u-column"].col-' + t).show(),
                        setTimeout(function () {
                            e('#customer_login div[class*="u-column"]').removeClass("visible"), e('#customer_login div[class*="u-column"].col-' + t).addClass("visible");
                        }, 30);
                }),
                e(".woocommerce-account .woocommerce > #customer_login .nectar-form-controls .control:nth-child(1)").trigger("click")),
            !(e('.products[data-rm-m-hover="1"]').length > 0 && oe.usingMobileBrowser) &&
                (r.on("mouseover", ".text_on_hover .product-wrap, .text_on_hover > a:first-child", function () {
                    e(this).parent().addClass("hovered");
                }),
                r.on("mouseout", ".text_on_hover .product-wrap, .text_on_hover > a:first-child", function () {
                    e(this).parent().removeClass("hovered");
                })),
            e(".material.product").length > 0 ||
                e(".minimal.product").length > 0 ||
                e('.nectar-fancy-box[data-style="parallax_hover"]').length > 0 ||
                e('.nectar-category-grid[data-shadow-hover="yes"]').length > 0 ||
                e('.nectar-post-grid[data-shadow-hover="yes"]').length > 0)
        ) {
            var c = 101;
            r.on(
                "mouseenter",
                '.material.product, .nectar-fancy-box[data-style="parallax_hover"], .nectar-post-grid[data-shadow-hover="yes"] .nectar-post-grid-item, .nectar-category-grid[data-shadow-hover="yes"] .nectar-category-grid-item',
                function () {
                    c++, e(this).css("z-index", c + 1);
                }
            ),
                r.on(
                    "mouseleave",
                    '.material.product, .nectar-fancy-box[data-style="parallax_hover"], .nectar-post-grid[data-shadow-hover="yes"] .nectar-post-grid-item, .nectar-category-grid[data-shadow-hover="yes"] .nectar-category-grid-item',
                    function () {
                        var t = e(this);
                        setTimeout(function () {
                            t.is(":hover") || t.css("z-index", 100);
                        }, 350);
                    }
                ),
                t.nectarOptions &&
                    t.nectarOptions.woo_minimal_product_effect &&
                    "default" === t.nectarOptions.woo_minimal_product_effect &&
                    (r.on("mouseenter", ".minimal.product", function () {
                        c++, e(this).css("z-index", c + 1);
                    }),
                    r.on("mouseleave", ".minimal.product", function () {
                        var t = e(this);
                        setTimeout(function () {
                            t.is(":hover") || t.css("z-index", 100);
                        }, 350);
                    })),
                setInterval(function () {
                    e('.nectar-fancy-box[data-style="parallax_hover"]:hover').length > 0 ||
                        e(".minimal.product:hover").length > 0 ||
                        (e(
                            '.material.product:not(:hover), .minimal.product:not(:hover), .nectar-fancy-box[data-style="parallax_hover"]:not(:hover), .nectar-post-grid[data-shadow-hover="yes"] .nectar-post-grid-item:not(:hover), .nectar-category-grid[data-shadow-hover="yes"] .nectar-category-grid-item:not(:hover)'
                        ).css("z-index", 100),
                        (c = 101));
                }, 1e4);
        }
        function h(t) {
            var a = s.width();
            t.clientX < a - 370 - v && e(".nectar-slide-in-cart").hasClass("mouse-accessed") && (s.off("mousemove.rightCartOffsetCheck", h), e(".nectar-slide-in-cart").removeClass("open").removeClass("mouse-accessed"));
        }
        if (
            (e(".products .classic .product-wrap .add_to_cart_button").wrapInner("<span />"),
            e(".products .classic .product-wrap .add_to_cart_button").prepend('<i class="normal icon-salient-cart"></i>'),
            !(e('.products[data-rm-m-hover="1"]').length > 0 && oe.usingMobileBrowser) &&
                t.nectarOptions &&
                t.nectarOptions.woo_minimal_product_effect &&
                "default" === t.nectarOptions.woo_minimal_product_effect &&
                (r.on("mouseover", ".products .minimal.product", function () {
                    var t, a, n, i, s, r;
                    (t = e(this)),
                        (n = (a = t).width()),
                        (i = a.height()),
                        (s = (parseInt(n) + 40) / parseInt(n)),
                        (r = (parseInt(i) + 40) / parseInt(i)),
                        a.addClass("hover-bound"),
                        a.find(".background-color-expand").css({ transform: "scale(" + s + "," + r + ") translateY(0px) translateZ(0px)" });
                }),
                r.on("mouseleave", ".products .minimal.product", function () {
                    e(this).find(".background-color-expand").css({ transform: "scale(1, 1) translateY(0) translateZ(0px)" });
                })),
            e(".products .minimal.product").each(function () {
                e(this).is(":hover") && e(this).trigger("mouseover");
            }),
            e(".woocommerce #sidebar .widget.woocommerce").each(function () {
                0 == e(this).find("> h4").length && e(this).addClass("no-widget-title");
            }),
            r.on("click", "#sidebar .widget.woocommerce:not(.widget_price_filter) h4", function () {
                t.nectarOptions &&
                    "false" !== t.nectarOptions.woo_sidebar_toggles &&
                    s.width() < 1e3 &&
                    (e(this).parent().is(".widget_product_tag_cloud") && e(this).parent().find("> div").slideToggle(),
                    e(this).parent().is(".woocommerce-widget-layered-nav") &&
                        e(this).parent().find("> .woocommerce-widget-layered-nav-dropdown").length > 0 &&
                        e(this).parent().find("> .woocommerce-widget-layered-nav-dropdown").slideToggle(),
                    e(this).parent().find("> ul").slideToggle(),
                    e(this).parent().toggleClass("open-filter"));
            }),
            r.on("mouseenter", '#header-outer [data-cart-style="slide_in"] .cart-menu-wrap', function () {
                e(".nectar-slide-in-cart ul.cart_list li:not(.empty)").length > 0 && (e(".nectar-slide-in-cart").addClass("open"), s.on("mousemove.rightCartOffsetCheck", h));
            }),
            r.on("mouseenter", ".nectar-slide-in-cart", function () {
                e(this).addClass("mouse-accessed");
            }),
            r.on("click", '#header-outer [data-cart-style="slide_in_click"] .cart-menu-wrap, #mobile-cart-link[data-cart-style="slide_in_click"]', function () {
                if (r.is(".woocommerce-checkout") || r.is(".woocommerce-cart")) return !0;
                return (
                    e(".nectar-slide-in-cart, .nectar-slide-in-cart-bg").addClass("open"),
                    e(".nectar-slide-in-cart-bg").addClass("revealed"),
                    clearTimeout(o),
                    e(".style_slide_in_click div.quantity").each(function () {
                        e(this).find(".minus").length > 1 && e(this).find(".minus").first().remove(), e(this).find(".plus").length > 1 && e(this).find(".plus").first().remove();
                    }),
                    !1
                );
            }),
            r.on("click", ".nectar-slide-in-cart.style_slide_in_click .close-cart, .nectar-slide-in-cart-bg", function () {
                return (
                    e(".nectar-slide-in-cart, .nectar-slide-in-cart-bg").removeClass("open"),
                    (o = setTimeout(function () {
                        e(".nectar-slide-in-cart-bg").removeClass("revealed");
                    }, 400)),
                    !1
                );
            }),
            new Na(),
            t.nectarOptions && "1" === t.nectarOptions.ajax_add_to_cart)
        )
            new Da();
        if (t.nectarOptions && "1" === t.nectarOptions.woo_product_filter_toggle && r.is(".archive.woocommerce")) new Xa();
        e(a).on("yith-wcan-ajax-filtered", Nt);
    }
    function Za() {
        (this.$el = e("#search-outer #search .container #s")),
            (this.$container = ""),
            (this.$parent = ""),
            (this.$searchEl = e("#search-outer")),
            (this.request = ""),
            (this.timeout = ""),
            this.setup(),
            this.events(),
            (this.state = { requesting: !1, open: !1, prevResults: "" }),
            (this.minChars = 2);
    }
    function Ua() {
        t.nectarOptions && t.nectarOptions.quick_search && "true" === t.nectarOptions.quick_search && new Za();
        var n = e("#search-outer #search input[type=text][data-placeholder]").length > 0 ? e("#search-outer #search input[type=text]").attr("data-placeholder") : "";
        function i() {
            if (
                (r.hasClass("ascend") || (e('body[data-header-format="left-header"]').length > 0 && 0 == e("body.material").length)
                    ? (e("#search-outer").stop().transition({ opacity: 0 }, 300, "cubic-bezier(0.2, 1, 0.3, 1)"),
                      h.addClass("inactive"),
                      setTimeout(function () {
                          e("#search-outer").hide(), h.removeClass("inactive");
                      }, 300))
                    : 0 == e("body.material").length && e("#search-outer").stop(!0).fadeOut(450, "easeOutExpo"),
                r.hasClass("material"))
            ) {
                e(t).trigger("nectar-search-close");
                var a = d.hasClass("results-shown") ? 800 : 400;
                setTimeout(function () {
                    e("#search-outer #s").val("");
                }, a),
                    e("#ajax-content-wrap").removeClass("material-open"),
                    (de.materialSearchOpen = !1),
                    d.removeClass("material-search-open"),
                    e("#search-outer").removeClass("material-open"),
                    e("#fp-nav").removeClass("material-ocm-open");
            }
        }
        r.hasClass("material") && 0 == e("#header-outer .bg-color-stripe").length && d.append('<div class="bg-color-stripe" />'),
            r.on("click", "#search-btn a", function () {
                return !1;
            }),
            r.on("click", "#search-btn a:not(.inactive), #header-outer .mobile-search", function () {
                return (
                    !e(this).hasClass("open-search") &&
                    (r.hasClass("original") &&
                        e(".slide-out-widget-area-toggle.mobile-icon a.open").length > 0 &&
                        (e(".slide-out-widget-area-toggle.mobile-icon a").addClass("non-human-allowed").trigger("click"),
                        setTimeout(function () {
                            e(".slide-out-widget-area-toggle.mobile-icon a").removeClass("non-human-allowed");
                        }, 100)),
                    r.hasClass("ascend") || (e('body[data-header-format="left-header"]').length > 0 && 0 == e("body.material").length)
                        ? (e("#search-outer > #search form, #search-outer #search .span_12 span, #search-outer #search #close").css("opacity", 0),
                          e("#search-outer > #search form").css("transform", "translateY(-30px)"),
                          e("#search-outer #search .span_12 span").css("transform", "translateY(20px)"),
                          e("#search-outer").show(),
                          e("#search-outer").stop().transition({ scale: "1,0", opacity: 1 }, 0).transition({ scale: "1,1" }, 700, "cubic-bezier(0.2, 1, 0.3, 1)"),
                          e("#search-outer > #search form").delay(350).transition({ opacity: 1, transform: "translateY(0)" }, 700, "cubic-bezier(0.2, 1, 0.3, 1)"),
                          e("#search-outer #search #close").delay(500).transition({ opacity: 1 }, 700, "cubic-bezier(0.2, 1, 0.3, 1)"),
                          e("#search-outer #search .span_12 span").delay(450).transition({ opacity: 1, transform: "translateY(0)" }, 700, "cubic-bezier(0.2, 1, 0.3, 1)"))
                        : r.hasClass("material")
                        ? (e('#header-outer[data-transparent-header="true"] .bg-color-stripe').css("transition", ""),
                          e("#search-outer, #ajax-content-wrap").addClass("material-open"),
                          (de.materialSearchOpen = !0),
                          d.addClass("material-search-open"),
                          e("#fp-nav").addClass("material-ocm-open"),
                          e(t).trigger("nectar-search-open"))
                        : e("#search-outer").stop(!0).fadeIn(600, "easeOutExpo"),
                    setTimeout(function () {
                        e("#search input[type=text]").trigger("focus"), e("#search input[type=text]").val() == n && e("#search input[type=text]").setCursorPosition(0);
                    }, 300),
                    e(this).toggleClass("open-search"),
                    e(".slide-out-widget-area-toggle a:not(#toggle-nav).open:not(.animating)").trigger("click"),
                    !1)
                );
            }),
            e("body:not(.material)").on("keydown", "#search input[type=text]", function () {
                e(this).val() == n && e(this).val("");
            }),
            e("body:not(.material)").on("keyup", "#search input[type=text]", function () {
                0 == e(this).val().length && (e(this).val(n), e(this).setCursorPosition(0));
            }),
            r.on("click", "#close", function () {
                return i(), h.removeClass("open-search"), e("#header-outer .mobile-search").removeClass("open-search"), !1;
            }),
            e("body:not(.material)").on("blur", "#search-box input[type=text]", function () {
                i(), h.removeClass("open-search"), e("#header-outer .mobile-search").removeClass("open-search");
            }),
            e("body.material").on("click", "#ajax-content-wrap", function (t) {
                void 0 !== t.originalEvent && (i(), h.removeClass("open-search"), e("#header-outer .mobile-search").removeClass("open-search"));
            }),
            e("body.material").length > 0 &&
                e(a).on("keyup", function (t) {
                    27 == t.keyCode && (i(), h.removeClass("open-search"), e(".ocm-effect-wrap.material-ocm-open").length > 0 && e(".slide-out-widget-area-toggle.material-open a").trigger("click"));
                });
    }
    function Ga() {
        e('#header-outer[data-format="centered-menu-bottom-bar"]').length > 0 &&
            (function () {
                var t = d,
                    a = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9'),
                    n = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_3'),
                    i = c,
                    r = n.find("nav >ul.buttons"),
                    o = parseInt(e("body.material #header-outer").attr("data-padding")),
                    l = parseInt(e("body.material #header-outer").attr("data-logo-height")),
                    h = parseInt(n.css("margin-bottom")),
                    u = o + h + l + parseInt(oe.secondaryHeaderHeight);
                function p() {
                    Re() ? d.addClass("within-custom-breakpoint") : d.removeClass("within-custom-breakpoint");
                }
                function g() {
                    if (
                        !(
                            oe.winW < 1e3 ||
                            e("body.page-template-template-no-header").length > 0 ||
                            e("body.page-template-template-no-header-footer").length > 0 ||
                            e("body.material-ocm-open").length > 0 ||
                            "none" == e('#header-outer[data-has-menu="true"][data-format="centered-menu-bottom-bar"] .span_9').css("display") ||
                            "none" == e('#header-outer[data-has-menu="true"][data-format="centered-menu-bottom-bar"] .span_9 > nav').css("display")
                        )
                    )
                        if (((f = f.length > 0 && oe.secondaryHeaderHeight > 0 ? f.height() : 0), t.hasClass("force-condense") || (!t.hasClass("fixed-menu") && oe.scrollTop >= u))) {
                            var n = parseInt(a.position().top) - o - parseInt(oe.adminBarHeight) + parseInt(oe.secondaryHeaderHeight) - f;
                            if (
                                (e('#header-outer[data-megamenu-rt="1"]').length > 0 && e("#header-outer .megamenu").length > 0 && e('#header-outer[data-transparent-header="true"]').length > 0 && d.removeClass("no-transition"),
                                t
                                    .addClass("fixed-menu")
                                    .removeClass("transparent")
                                    .css({ top: "-" + n + "px", position: "fixed" }),
                                !t.is('[data-menu-bottom-bar-align="left"]'))
                            ) {
                                var i = e("header#top .span_9 nav > ul .menu-title-text").length > 0 ? e("header#top .span_9 nav > ul .menu-title-text").offset().top : 0,
                                    s = r.find("li:first-child > *").length > 0 ? r.find("li:first-child > *").offset().top : 0,
                                    l = a.find("nav .sf-menu > li > a .menu-title-text").length > 0 ? (20 - parseInt(a.find("nav .sf-menu > li > a .menu-title-text").height())) / 2 : 2;
                                r.css("transform", "translateY(" + Math.ceil(parseInt(i) - parseInt(s) - l) + "px)"), r.find(".nectar-woo-cart").css("height", t.height() + parseInt(t.css("top")) - parseInt(oe.adminBarHeight));
                            }
                        } else
                            (t.hasClass("force-condense-remove") || (t.hasClass("fixed-menu") && oe.scrollTop < u)) &&
                                (t.removeClass("fixed-menu").css({ top: "0", position: "absolute" }),
                                r.css("transform", "translateY(0px)"),
                                r.find(".nectar-woo-cart").css("height", ""),
                                0 == e("#header-outer.transparent").length &&
                                    (e('#header-outer[data-megamenu-rt="1"]').length > 0 && e("#header-outer .megamenu").length > 0 && d.removeClass("no-transition"),
                                    e('#header-outer[data-megamenu-rt="1"]').length > 0 && e('#header-outer[data-transparent-header="true"]').length > 0 && e("#header-outer .megamenu").length > 0
                                        ? "true" == d.attr("data-transparent-header") && 0 == e(".nectar-box-roll").length && 0 == e(".megamenu.sfHover:not(.width-75):not(.width-50)").length
                                            ? (d.addClass("transparent"), d.removeClass("no-transition"))
                                            : "true" == d.attr("data-transparent-header") && 0 == e(".nectar-box-roll").length && e(".megamenu.sfHover").length > 0 && d.addClass("no-transition")
                                        : "true" == d.attr("data-transparent-header") && 0 == e(".nectar-box-roll").length && d.addClass("transparent")));
                }
                i.length > 0 &&
                    0 == e('#header-outer[data-remove-fixed="1"]').length &&
                    e('#header-outer[data-condense="true"]').length > 0 &&
                    setTimeout(function () {
                        "none" != c.css("display") && (oe.secondaryHeaderHeight = c.outerHeight());
                    }, 50),
                    e('#header-outer[data-condense="true"]').length > 0 &&
                        (s.on("scroll.centeredNavCondense", g),
                        s.trigger("scroll"),
                        s.on("resize", function () {
                            (oe.winW < 1e3 || Re()) && (t.addClass("force-condense-remove"), s.off("scroll.centeredNavCondense"));
                        }),
                        s.on("smartresize", function () {
                            p(),
                                oe.winW >= 1e3 &&
                                    0 == Re() &&
                                    t.hasClass("force-condense-remove") &&
                                    (g(),
                                    t.removeClass("force-condense-remove"),
                                    setTimeout(function () {
                                        oe.scrollTop >= u && (t.addClass("force-condense"), g(), t.removeClass("force-condense")), s.on("scroll.centeredNavCondense", g);
                                    }, 200));
                        }),
                        p());
            })();
    }
    function Ja() {
        if (oe.winW > 1e3) {
            var t,
                a,
                n = e('#header-outer[data-format="centered-logo-between-menu"] #top nav > .sf-menu:not(.buttons) > li').length;
            e("#header-outer #social-in-menu").length > 0 && n--,
                (t = 0 == e("#header-outer #top .row .col.span_3 #logo img:visible").length ? parseInt(e("#header-outer #top .row .col.span_3").width()) : parseInt(e("#header-outer #top .row .col.span_3 img:visible").width())),
                (a = e('#header-outer[data-lhe="animated_underline"]').length > 0 ? parseInt(e("header#top nav > ul > li:first-child > a").css("margin-right")) : parseInt(e("header#top nav > ul > li:first-child > a").css("padding-right"))),
                (a += a > 30 ? 45 : a > 20 ? 40 : 30),
                r.hasClass("rtl")
                    ? e('#header-outer[data-format="centered-logo-between-menu"] #top nav > .sf-menu:not(.buttons) > li:nth-child(' + Math.floor(n / 2) + ")")
                          .css({ "margin-left": t + a + "px" })
                          .addClass("menu-item-with-margin")
                    : e('#header-outer[data-format="centered-logo-between-menu"] #top nav > .sf-menu:not(.buttons) > li:nth-child(' + Math.floor(n / 2) + ")")
                          .css({ "margin-right": t + a + "px" })
                          .addClass("menu-item-with-margin");
            var i = 0,
                s = 0;
            e('#header-outer[data-format="centered-logo-between-menu"] #top nav > .sf-menu:not(.buttons) > li:not(#social-in-menu)').each(function (t) {
                t + 1 <= Math.floor(n / 2) ? (i += e(this).width()) : (s += e(this).width());
            });
            var o = Math.abs(s - i);
            i > s || (r.hasClass("rtl") && i < s) ? e("#header-outer #top .row > .col.span_9").css("padding-right", o) : e("#header-outer #top .row > .col.span_9").css("padding-left", o),
                e('#header-outer[data-format="centered-logo-between-menu"] nav').css("visibility", "visible");
        } else e('#header-outer[data-format="centered-logo-between-menu"]').length > 0 && oe.winW < 1e3 && e("#header-outer .row > .col.span_9").css({ "padding-right": "0", "padding-left": "0" });
    }
    function Ka() {
        if (e('#header-outer[data-format="centered-logo-between-menu"]').length > 0) {
            if (x) {
                if (x && e('#header-outer[data-format="centered-logo-between-menu"]').length > 0 && e("header#top #logo img:first[src]").length > 0) {
                    var t = new Image();
                    (t.src = e("header#top #logo img:first").attr("src")),
                        (t.onload = function () {
                            Ja();
                        });
                }
            } else Ja();
            s.on("smartresize", Ja);
        }
    }
    function en() {
        e("#nectar_fullscreen_rows").length > 0 && 1 == ne && d.attr("data-permanent-transparent", "false"),
            oe.usingMobileBrowser && e('#header-outer[data-mobile-fixed="1"]').length > 0 && 0 == e('#header-outer[data-transparent-header="true"]').length && e("#header-space").css("height", d.outerHeight()),
            t.nectarOptions && t.nectarOptions.header_entrance && "true" == t.nectarOptions.header_entrance && (0 == oe.scrollTop ? e("#header-outer").addClass("entrance-animation") : e("#header-outer").css("opacity", "1"));
    }
    (e.fn.dlmenu = function (t) {
        if ("string" == typeof t) {
            var a = Array.prototype.slice.call(arguments, 1);
            this.each(function () {
                var n = e.data(this, "menu");
                n ? (e.isFunction(n[t]) && "_" !== t.charAt(0) ? n[t].apply(n, a) : Wa("no such method '" + t + "' for menu instance")) : Wa("cannot call methods on menu prior to initialization; attempted to call method '" + t + "'");
            });
        } else
            this.each(function () {
                var a = e.data(this, "menu");
                a ? a._init() : (a = e.data(this, "menu", new e.DLMenu(t, this)));
            });
        return this;
    }),
        (Xa.prototype.events = function () {
            this.$toggleBtn.on("click", this.toggle.bind(this)), this.$sidebar.find(".nectar-close-btn-wrap").on("click", this.mobileToggle.bind(this)), e(t).on("smartresize", this.mobileToggleResize.bind(this));
        }),
        (Xa.prototype.mobileToggleResize = function () {
            this.$sidebar.hasClass("open") && oe.winW > 999 && (this.$sidebar.removeClass("open"), this.$sidebar.find(".nectar-close-btn-wrap").removeClass("open"), e(".container-wrap").css("z-index", "11"));
        }),
        (Xa.prototype.mobileToggle = function () {
            return (
                this.$sidebar.hasClass("open")
                    ? (this.$sidebar.removeClass("open"), this.$sidebar.find(".nectar-close-btn-wrap").removeClass("open"), e(".container-wrap").css("z-index", "11"))
                    : (e(".container-wrap").css("z-index", "10000"), this.$sidebar.addClass("open"), this.$sidebar.find(".nectar-close-btn-wrap").addClass("open")),
                !1
            );
        }),
        (Xa.prototype.toggle = function () {
            if (oe.winW < 1e3) return this.mobileToggle(), !1;
            var a = "";
            return (
                "true" == this.state.open
                    ? ((this.state.open = "false"),
                      (a = "false"),
                      this.$toggleBtn.find(".hide").hide(),
                      this.$toggleBtn.find(".show").show(),
                      this.$toggleBtn.find(".top-line, .bottom-line").css({ transform: "translateX(0)" }),
                      "left" == this.sidebarPos ? this.$sidebar.css({ "margin-right": "-25%", opacity: "0" }) : this.$sidebar.css({ "margin-left": "-25%", opacity: "0" }),
                      this.$sidebar.find("> .inner").css({ transform: "left" == this.sidebarPos ? "translateX(-100%)" : "translateX(100%)" }))
                    : ((this.state.open = "true"),
                      (a = "true"),
                      this.$toggleBtn.find(".show").hide(),
                      this.$toggleBtn.find(".hide").show(),
                      this.$toggleBtn.find(".top-line").css({ transform: "translateX(10px)" }),
                      this.$toggleBtn.find(".bottom-line").css({ transform: "translateX(-10px)" }),
                      "left" == this.sidebarPos ? this.$sidebar.css({ "margin-right": "0", opacity: "1" }) : this.$sidebar.css({ "margin-left": "0", opacity: "1" }),
                      this.$sidebar.find("> .inner").css({ transform: "translateX(0)" })),
                setTimeout(function () {
                    e(t).trigger("nectar-product-filters-layout");
                }, 425),
                "undefined" != typeof Storage && localStorage.setItem("nectar_product_filters_vis", a),
                !1
            );
        }),
        (Xa.prototype.setup = function () {
            if (
                (this.$sidebar.find(".widget.woocommerce").addClass("open-filter").find("ul").css({ display: "block" }),
                this.$sidebar.find(".widget.woocommerce.widget_product_tag_cloud").find("div.tagcloud").css({ display: "block" }),
                e(".nectar-active-product-filters").length > 0)
            ) {
                var t = e(".nectar-active-product-filters").clone();
                this.$sidebar.find("> .inner").prepend(t);
            }
        }),
        (Xa.prototype.getLS = function () {
            return "undefined" != typeof Storage ? localStorage.getItem("nectar_product_filters_vis") : null;
        }),
        (Na.prototype.updateState = function (e) {
            var t = 0;
            !0 === this.checkMiniCart(this.$qty) && (t = this.$qty.attr("name").match(/cart\[(\w+)\]/)[1]);
            var a = parseFloat(this.$qty.val());
            (a && "" !== a && "NaN" !== a) || (a = 0);
            var n = parseFloat(this.$qty.attr("max")),
                i = parseFloat(this.$qty.attr("min"));
            ("" === n || "NaN" === n || isNaN(n)) && (n = ""), ("" === i || "NaN" === i || isNaN(i)) && (i = 0), (this.state = { currentVal: a, max: n, min: i, key: t });
        }),
        (Na.prototype.events = function () {
            var t = this;
            e("body").on("click", ".quantity .plus", function () {
                (t.$qty = e(this).closest(".quantity").find(".qty")), t.setStep(), t.updateState(), t.increment(e(this));
            }),
                e("body").on("click", ".quantity .minus", function () {
                    (t.$qty = e(this).closest(".quantity").find(".qty")), t.setStep(), t.updateState(), t.decrement(e(this));
                }),
                e("body").on("keyup", ".woocommerce-mini-cart .quantity .qty", function (a) {
                    (t.$qty = e(this)),
                        t.updateState(),
                        t.state.max && t.$qty.val() > t.state.max && t.$qty.val(t.state.max),
                        t.state.min && (t.state.min == t.state.currentVal || t.state.currentVal < t.state.min) && (t.state.removeFlag = !0),
                        e(this).trigger("change");
                }),
                e("body").on("change", ".woocommerce-mini-cart .quantity .qty", function (e) {
                    e.originalEvent || !0 !== t.checkMiniCart(t.$qty) || t.updateCart(t.$qty.val());
                });
        }),
        (Na.prototype.setStep = function () {
            if (this.$qty.is("[step]")) {
                var e = parseInt(this.$qty.attr("step"));
                isNaN(e) || "" == e || 0 == e || (this.step = e);
            }
        }),
        (Na.prototype.increment = function () {
            this.state.max && (this.state.max == this.state.currentVal || this.state.currentVal > this.state.max) ? this.$qty.val(this.state.max) : this.$qty.val(this.state.currentVal + parseFloat(this.step)), this.$qty.trigger("change");
        }),
        (Na.prototype.decrement = function () {
            this.state.min && (this.state.min == this.state.currentVal || this.state.currentVal < this.state.min)
                ? (this.$qty.val(0), (this.state.removeFlag = !0))
                : this.state.currentVal > 0 && this.$qty.val(this.state.currentVal - parseFloat(this.step)),
                this.$qty.trigger("change");
        }),
        (Na.prototype.checkMiniCart = function (e) {
            return e.parents(".woocommerce-mini-cart").length > 0;
        }),
        (Na.prototype.updateCart = function (n) {
            var i = this;
            clearTimeout(this.ajaxTimeout),
                (this.ajaxTimeout = setTimeout(function () {
                    i.$qty.closest(".widget_shopping_cart_content").addClass("loading"),
                        i.$qty.closest(".woocommerce-mini-cart-item").addClass("blockUI").addClass("blockOverlay"),
                        e.ajax({
                            type: "POST",
                            url: t.nectarLove.ajaxurl,
                            data: { action: "nectar_minicart_update_quantity", quantity: n, item_key: i.state.key },
                            cache: !1,
                            success: function (t) {
                                if (t) {
                                    i.$qty.closest(".widget_shopping_cart_content").removeClass("loading"), i.$qty.closest(".woocommerce-mini-cart-item").removeClass("blockUI").removeClass("blockOverlay");
                                    var n = i.$qty.closest(".widget_shopping_cart_content").find(".woocommerce-mini-cart__total");
                                    n.find(".woocommerce-Price-amount, .tax_label").remove(),
                                        n.append(t.subtotal),
                                        !0 === i.state.removeFlag && (i.$qty.closest(".woocommerce-mini-cart-item").remove(), (i.state.removeFlag = !1), e(a.body).trigger("updated_wc_div")),
                                        e("#header-outer a.cart-contents .cart-wrap span").length > 0 && e("#header-outer a.cart-contents .cart-wrap span").text(t.item_count);
                                }
                            },
                        });
                }, this.ajaxTimeoutDur));
        }),
        (Da.prototype.events = function () {
            e("body:not(.woocommerce-account)").on("submit", "form.cart", this.addToCartAJAX.bind(this));
        }),
        (Da.prototype.addNotices = function (t) {
            var a = e(".nectar-slide-in-cart.style_slide_in_click .widget_shopping_cart_content");
            e.each(t, function (e, t) {
                a.prepend('<div class="nectar-notice">' + t.notice + "</div>");
            }),
                setTimeout(function () {
                    a.find(".nectar-notice").slideUp(function () {
                        e(this).remove();
                    });
                }, 6e3);
        }),
        (Da.prototype.addToCartAJAX = function (a) {
            var n = this,
                i = e(a.currentTarget);
            if (!(i.closest(".product").hasClass("product-type-external") || (wc_add_to_cart_params && "yes" === wc_add_to_cart_params.cart_redirect_after_add)) && (a.preventDefault(), 1 != n.state.processing)) {
                (n.state.processing = !0), (n.state.productID = !1), (n.state.type = "regular"), i.parents(".nectar-quick-view-box").length > 0 && (n.state.type = "quickview");
                var s = i.closest(".product"),
                    r = i.find("button.single_add_to_cart_button"),
                    o = i.serializeArray(),
                    l = 0;
                s.is('[id*="product-"]') && (l = s.attr("id").match(/\d+/)) && l[0] && (n.state.productID = l[0]),
                    !1 === n.state.productID && r.length > 0 && (l = r.val().match(/\d+/)) && l[0] && (n.state.productID = l[0]),
                    !1 !== n.state.productID
                        ? ("quickview" === n.state.type && (r = e(".single_add_to_cart_button_wrap .single_add_to_cart_button")),
                          r.prepend('<div class="loading-wrap"><div class="loading" /></div></div>'),
                          setTimeout(function () {
                              r.addClass("processing");
                          }, 50),
                          o.push({ name: "action", value: "nectar_ajax_add_to_cart" }, { name: "add-to-cart", value: n.state.productID }),
                          e.ajax({
                              type: "POST",
                              url: t.nectarLove.ajaxurl,
                              data: o,
                              cache: !1,
                              success: function (t) {
                                  setTimeout(function () {
                                      (n.state.processing = !1), r.removeClass("processing"), r.find(".loading-wrap").remove();
                                  }, 300),
                                      t &&
                                          t.fragments &&
                                          (e("body").trigger("added_to_cart", [t.fragments, t.cart_hash]),
                                          t.notices &&
                                              t.notices.length > 0 &&
                                              setTimeout(function () {
                                                  n.addNotices(t.notices);
                                              }, 100),
                                          "quickview" === n.state.type && e(".nectar-quick-view-box .close").trigger("click"));
                              },
                          }))
                        : console.log("Error: no product ID found.");
            }
        }),
        (Za.prototype.setup = function () {
            (this.$container = e('<div class="inner"></div>')),
                e("#search-outer").append(e('<div class="nectar-ajax-search-results"><div class="container"></div></div>')),
                (this.$parent = e("#search-outer .nectar-ajax-search-results")),
                e("#search-outer .nectar-ajax-search-results .container").append(this.$container);
        }),
        (Za.prototype.events = function () {
            var a,
                n,
                i,
                s = this;
            (this.throttled =
                ((a = this.getResults.bind(this)),
                (n = 350),
                (i = !1),
                function () {
                    i ||
                        (a.call(),
                        (i = !0),
                        setTimeout(function () {
                            i = !1;
                        }, n));
                })),
                this.$el.on("keyup", this.keyHandle.bind(this)),
                e(t).on("resize", this.resize.bind(this)),
                e(t).on("nectar-search-close", function () {
                    s.resetHeight(), s.requestCheck();
                });
        }),
        (Za.prototype.keyHandle = function (e) {
            -1 == [16, 91, 32, 37, 39, 17].indexOf(e.keyCode) && (this.throttled(), this.debouncedSearch());
        }),
        (Za.prototype.debouncedSearch = function () {
            var e = this;
            clearTimeout(this.timeout),
                (this.timeout = setTimeout(function () {
                    e.state.requesting || e.getResults();
                }, 400));
        }),
        (Za.prototype.resize = function () {
            this.$parent.css({ "max-height": "" }), !0 === this.state.open && this.$parent.css({ "max-height": parseInt(this.$container.outerHeight()) + "px" });
        }),
        (Za.prototype.resetHeight = function () {
            this.$parent.css({ "max-height": "" }),
                setTimeout(function () {
                    d.removeClass("results-shown");
                }, 400),
                (this.state.prevResults = ""),
                (this.state.open = !1);
        }),
        (Za.prototype.requestCheck = function () {
            !0 === this.state.requesting && (this.request.abort(), (this.state.requesting = !1));
        }),
        (Za.prototype.getResults = function () {
            var a = this,
                n = this.$el.val();
            if (0 == n.length || n.length < this.minChars) return d.removeClass("results-shown"), this.requestCheck(), void this.resetHeight();
            (this.request = e.ajax({
                type: "POST",
                url: t.nectarLove.ajaxurl,
                data: { action: "nectar_ajax_ext_search_results", search: n },
                cache: !1,
                success: function (t) {
                    (a.state.requesting = !1),
                        t || a.resetHeight(),
                        t &&
                            t.content &&
                            t.content !== a.state.prevResults &&
                            a.$searchEl.hasClass("material-open") &&
                            (a.$container.html(t.content),
                            a.$parent.css({ "max-height": parseInt(a.$container.outerHeight()) + "px" }),
                            setTimeout(function () {
                                d.addClass("results-shown");
                            }, 200),
                            oe.winW >= 1e3 &&
                                !d.hasClass("results-shown") &&
                                (a.$container.find(".product, .search-post-item").css({ opacity: "0", transform: "translateY(25px)", transition: "none" }),
                                setTimeout(function () {
                                    a.$container.find(".product, .search-post-item").css({ transition: "box-shadow 0.25s ease, opacity 0.55s cubic-bezier(0.2, 0.6, 0.4, 1), transform 0.55s cubic-bezier(0.2, 0.6, 0.4, 1)" });
                                }, 50),
                                a.$container.find(".product, .search-post-item").each(function (t) {
                                    var a = e(this);
                                    setTimeout(function () {
                                        a.css({ opacity: "1", transform: "translateY(0)" });
                                    }, 50 + 60 * t);
                                })),
                            (a.state.open = !0),
                            (a.state.prevResults = t.content));
                },
            })),
                (this.state.requesting = !0);
        });
    var tn = { timeoutQueued: !1, visible: !0, init: !1, raf: "", bodyOffsetHeight: 1e4 };
    function an() {
        var t = 0,
            n = 0 == k && e('#page-header-bg[data-parallax="1"]').length > 0 ? 200 : 60,
            s = 3,
            r = e('.page-submenu[data-sticky="true"]').length > 0;
        (tn.bodyOffsetHeight = a.body.offsetHeight),
            0 == tn.init &&
                setInterval(function () {
                    1 != de.materialOffCanvasOpen && (tn.bodyOffsetHeight = a.body.offsetHeight);
                }, 1500),
            (tn.raf = requestAnimationFrame(function a() {
                d[0].classList.add("detached");
                var o = oe.scrollTop,
                    l = Math.abs(o - t);
                if (1 == de.animatedScrolling || 1 == de.preventScroll || 1 == de.ocmOpen)
                    return (
                        o > n && (1 == de.animatedScrolling && 1 == k && 0 == de.permanentTransHeader && d.removeClass("transparent").addClass("scrolling"), (t = oe.scrollTop), (o = oe.scrollTop)), void (tn.raf = requestAnimationFrame(a))
                    );
                if (1 == de.materialOffCanvasOpen || 1 == de.materialSearchOpen)
                    return (
                        1 == de.materialSearchOpen && 1 == k && (0 == de.permanentTransHeader && o > n ? d.removeClass("transparent").addClass("scrolling") : d.addClass("transparent").removeClass("scrolling")),
                        void (tn.raf = requestAnimationFrame(a))
                    );
                if (!d.hasClass("side-widget-open") && !e("#header-outer .slide-out-widget-area-toggle a").hasClass("animating")) {
                    var h;
                    if ((c.length > 0 && (o > n ? (c.addClass("hide-up"), d.css("transform", "translateY(-" + oe.secondaryHeaderHeight + "px)")) : (c.removeClass("hide-up"), d.css("transform", "0px)"))), o > n))
                        0 == de.permanentTransHeader &&
                            (0 == tn.timeoutQueued &&
                                setTimeout(function () {
                                    0 == de.ocmOpen && (d.removeClass("transparent"), d.addClass("scrolling")), (tn.timeoutQueued = !1);
                                }, 400),
                            (tn.timeoutQueued = !0)),
                            d.removeClass("no-transition"),
                            l >= s &&
                                (o > t
                                    ? (d.hasClass("invisible") ||
                                          (d.addClass("invisible").removeClass("at-top"),
                                          oe.winW > 1e3 && e(".sf-menu").length > 0 && e().superfish && (e(".sf-menu").superfish("hide"), e("header#top nav > ul.sf-menu > li.menu-item-over").removeClass("menu-item-over"))),
                                      1 == r && e(".page-submenu.stuck").css("transform", "translateY(0px)").addClass("header-not-visible"))
                                    : (d.hasClass("invisible") && d.removeClass("invisible"),
                                      1 == r &&
                                          ((h = d.outerHeight()),
                                          c.length > 0 && (h -= oe.secondaryHeaderHeight),
                                          f.length > 0 && oe.winW > 999
                                              ? ((i = ie ? f.height() : 0),
                                                e(".page-submenu.stuck")
                                                    .css("transform", "translateY(" + (h - i) + "px)")
                                                    .removeClass("header-not-visible"))
                                              : e(".page-submenu.stuck")
                                                    .css("transform", "translateY(" + h + "px)")
                                                    .removeClass("header-not-visible"))));
                    else {
                        var u = c.length > 0 ? 32 : 0;
                        f.length > 0 && (u = c.length > 0 ? 32 + f.height() : f.height()),
                            o <= u &&
                                (d.addClass("at-top").removeClass("invisible").removeClass("scrolling"),
                                oe.winW > 999 && e('#header-outer[data-megamenu-rt="1"]').length > 0 && 1 == k && e("#header-outer .megamenu").length > 0
                                    ? 0 == e(".nectar-box-roll").length && 0 == e(".megamenu.sfHover:not(.width-75):not(.width-50)").length
                                        ? d.addClass("transparent").css("transform", "translateY(0)").removeClass("no-transition")
                                        : e(".nectar-box-roll").length > 0 && d.css("transform", "translateY(0)").addClass("at-top-before-box")
                                    : 1 == k && 0 == se.inUse
                                    ? d.addClass("transparent").css("transform", "translateY(0)")
                                    : 1 == se.inUse && d.css("transform", "translateY(0)").addClass("at-top-before-box"));
                    }
                    oe.winH + oe.scrollTop >= tn.bodyOffsetHeight &&
                        (d.removeClass("invisible"),
                        1 == r &&
                            ((h = d.outerHeight()),
                            c.length > 0 && (h -= oe.secondaryHeaderHeight),
                            f.length > 0 && oe.winW > 999
                                ? ((i = ie ? f.height() : 0),
                                  e(".page-submenu.stuck")
                                      .css("transform", "translateY(" + (h - i) + "px)")
                                      .removeClass("header-not-visible"))
                                : e(".page-submenu.stuck")
                                      .css("transform", "translateY(" + h + "px)")
                                      .removeClass("header-not-visible")));
                }
                (t = o), (tn.raf = requestAnimationFrame(a));
            })),
            0 == tn.init && (tn.init = !0);
    }
    function nn() {
        var t = oe.scrollTop,
            a = oe.winW,
            n = 30;
        1 != k || oe.usingMobileBrowser || (n = 0),
            t > n &&
                a >= 1e3 &&
                0 == e("body.material-ocm-open").length &&
                (r.is(".material") &&
                    (0 == e("#search-outer.material-open").length && e('#header-outer[data-transparent-header="true"] .bg-color-stripe').css("transition", "none"),
                    c.length > 0 && (c.addClass("hide-up"), d.css("transform", "translateY(-" + oe.secondaryHeaderHeight + "px)"))),
                e('#header-outer[data-megamenu-rt="1"]').length > 0 && e('#header-outer[data-transparent-header="true"]').length > 0 && e("#header-outer .megamenu").length > 0
                    ? "true" == d.attr("data-transparent-header") &&
                      0 == e("#header-outer.side-widget-open").length &&
                      0 == e('#header-outer[data-permanent-transparent="1"]').length &&
                      0 == e(".megamenu.sfHover:not(.width-75):not(.width-50)").length &&
                      (d.removeClass("transparent"), d.removeClass("no-transition"))
                    : "true" == d.attr("data-transparent-header") && 0 == e("#header-outer.side-widget-open").length && 0 == e('#header-outer[data-permanent-transparent="1"]').length && d.removeClass("transparent"),
                e("#header-outer:not(.small-nav) header#top nav > ul > li.menu-item-with-margin")
                    .stop(!0, !0)
                    .animate({ "margin-right": parseInt(e("header#top nav > ul > li.menu-item-with-margin").css("margin-right")) - 3 * parseInt(y) + "px" }, { queue: !1, duration: 250, easing: "easeOutCubic" }),
                e("#header-outer, #search-outer").addClass("small-nav"),
                e('#header-outer[data-full-width="true"][data-transparent-header="true"]').length > 0 &&
                    f.length > 0 &&
                    1 == ie &&
                    e('#header-outer[data-full-width="true"] header > .container').stop(!0, !0).animate({ padding: "0" }, { queue: !1, duration: 250, easing: "easeOutCubic" }),
                e(".nectar-box-roll").length > 0 &&
                    0 == e('#header-outer[data-permanent-transparent="1"]').length &&
                    e("#ajax-content-wrap").animate({ "margin-top": Math.floor(b - y + (2 * w) / 1.8 + oe.adminBarHeight + oe.secondaryHeaderHeight) }, { queue: !1, duration: 250, easing: "easeOutCubic" }),
                s.off("scroll.headerResizeEffect", nn),
                s.on("scroll.headerResizeEffect", sn),
                e('#header-outer[data-transparent-header="true"]').css("transition", "transform 0.3s ease, background-color 0.30s ease, opacity 0.3s ease, box-shadow 0.30s ease, margin 0.25s ease-out"),
                e('#header-outer[data-transparent-header="true"] .cart-menu').css("transition", "none"),
                setTimeout(function () {
                    e('#header-outer[data-transparent-header="true"]').css("transition", "transform 0.3s ease, background-color 0.30s ease, opacity 0.3s ease, box-shadow 0.30s ease, border-color 0.30s ease, margin 0.25s ease-out"),
                        e('#header-outer[data-transparent-header="true"] .cart-menu').css("transition", "border-color 0.30s ease");
                }, 300));
    }
    function sn() {
        var t = oe.scrollTop,
            a = oe.winW,
            n = 30;
        if (r.is(".material-ocm-open")) return !1;
        1 != k || oe.usingMobileBrowser || (n = 0),
            ((t <= n && a >= 1e3) || (e(".small-nav").length > 0 && e("#ajax-content-wrap.no-scroll").length > 0)) &&
                (e("#header-outer, #search-outer").removeClass("small-nav"),
                e('#header-outer[data-megamenu-rt="1"]').length > 0 && e('#header-outer[data-transparent-header="true"]').length > 0 && e("#header-outer .megamenu").length > 0
                    ? "true" == d.attr("data-transparent-header") && 0 == e(".nectar-box-roll").length && 0 == e(".megamenu.sfHover:not(.width-75):not(.width-50)").length && (d.addClass("transparent"), d.removeClass("no-transition"))
                    : "true" == d.attr("data-transparent-header") && 0 == e(".nectar-box-roll").length && d.addClass("transparent"),
                e('#header-outer[data-full-width="true"][data-transparent-header="true"]').length > 0 &&
                    f.length > 0 &&
                    1 == ie &&
                    e('#header-outer[data-full-width="true"] header > .container').stop(!0, !0).animate({ padding: "0 28px" }, { queue: !1, duration: 250, easing: "easeOutCubic" }),
                e("header#top nav > ul > li.menu-item-with-margin")
                    .stop(!0, !0)
                    .animate({ "margin-right": parseInt(e("header#top nav > ul > li.menu-item-with-margin").css("margin-right")) + 3 * parseInt(y) + "px" }, { queue: !1, duration: 150, easing: "easeOutCubic" }),
                c.length > 0 && (c.removeClass("hide-up"), d.removeClass("hide-up").css("transform", "translateY(0%)")),
                e(".nectar-box-roll").length > 0 &&
                    0 == e('#header-outer[data-permanent-transparent="1"]').length &&
                    e("#ajax-content-wrap").animate({ "margin-top": Math.floor(b + 2 * w + oe.adminBarHeight + oe.secondaryHeaderHeight) }, { queue: !1, duration: 250, easing: "easeOutCubic" }),
                s.off("scroll.headerResizeEffect", sn),
                s.on("scroll.headerResizeEffect", nn),
                e('#header-outer[data-transparent-header="true"]').css("transition", "transform 0.3s ease, background-color 0.30s ease, opacity 0.3s ease, box-shadow 0.30s ease, margin 0.25s ease-out"),
                e('#header-outer[data-transparent-header="true"] .cart-menu').css("transition", "none"),
                setTimeout(function () {
                    e('#header-outer[data-transparent-header="true"]').css("transition", "transform 0.3s ease, background-color 0.30s ease, opacity 0.3s ease, box-shadow 0.30s ease, border-color 0.30s ease, margin 0.25s ease-out"),
                        e('#header-outer[data-transparent-header="true"] .cart-menu').css("transition", "border-color 0.30s ease");
                }, 300));
    }
    function rn() {
        (e('#header-outer[data-format="centered-menu-bottom-bar"][data-condense="true"]').length > 0 && !d.hasClass("within-custom-breakpoint")) ||
            (oe.scrollTop > 0 &&
                (e("body.material").length > 0 && (d.addClass("scrolled-down"), c.length > 0 && oe.winW > 1e3 && (c.addClass("hide-up"), d.css("transform", "translateY(-" + oe.secondaryHeaderHeight + "px)"))),
                "true" == d.attr("data-transparent-header") && 0 == e('#header-outer[data-permanent-transparent="1"]').length && d.removeClass("transparent").addClass("scrolled-down"),
                s.off("scroll.headerResizeEffectOpaque", rn),
                s.on("scroll.headerResizeEffectOpaque", on)));
    }
    function on() {
        (e('#header-outer[data-format="centered-menu-bottom-bar"][data-condense="true"]').length > 0 && !d.hasClass("within-custom-breakpoint")) ||
            (0 == oe.scrollTop &&
                0 == e("body.material-ocm-open").length &&
                (e('#header-outer[data-megamenu-rt="1"]').length > 0 && e('#header-outer[data-transparent-header="true"]').length > 0 && e("#header-outer .megamenu").length > 0
                    ? "true" == d.attr("data-transparent-header") && 0 == e(".megamenu.sfHover:not(.width-75):not(.width-50)").length
                        ? (d.addClass("transparent").removeClass("scrolled-down"), d.removeClass("no-transition"))
                        : "true" == d.attr("data-transparent-header") && d.removeClass("scrolled-down")
                    : "true" == d.attr("data-transparent-header") && d.addClass("transparent").removeClass("scrolled-down"),
                e("body.material").length > 0 && (d.removeClass("scrolled-down"), c.length > 0 && oe.winW > 1e3 && (c.removeClass("hide-up"), d.removeClass("hide-up").css("transform", "translateY(0%)"))),
                s.off("scroll.headerResizeEffectOpaque", on),
                s.on("scroll.headerResizeEffectOpaque", rn)));
    }
    function ln() {
        1 != de.materialOffCanvasOpen
            ? (oe.scrollTop > 5
                  ? "scrolled" != de.mobileHeader &&
                    (0 == de.permanentTransHeader && d.removeClass("transparent"),
                    oe.secondaryHeaderHeight > 0 ? (c.addClass("hide-up"), d.css("transform", "translateY(-" + oe.secondaryHeaderHeight + "px)").addClass("hidden-secondary")) : d.removeClass("hidden-secondary"),
                    d.addClass("scrolled-down"),
                    (de.mobileHeader = "scrolled"))
                  : "at-top" != de.mobileHeader &&
                    ("true" == d.attr("data-transparent-header") && d.addClass("transparent"),
                    oe.secondaryHeaderHeight > 0 && (c.removeClass("hide-up"), d.css("transform", "translateY(0px)")),
                    d.removeClass("hidden-secondary").removeClass("scrolled-down"),
                    (de.mobileHeader = "at-top")),
              oe.winW < 1e3 && requestAnimationFrame(ln))
            : requestAnimationFrame(ln);
    }
    function dn() {
        oe.winW > 999 ||
            ((de.mobileHeader = ""),
            s.off("scroll.headerResizeEffect"),
            s.off("scroll.headerResizeEffectOpaque"),
            "1" == $ && 0 == e('#header-outer[data-remove-fixed="1"]').length
                ? e('#header-outer[data-mobile-fixed="1"]').length > 0
                    ? (e(".nectar-box-roll").length > 0 && d.addClass("at-top-before-box"), cancelAnimationFrame(tn.raf), an())
                    : (cancelAnimationFrame(tn.raf), d.removeClass("scrolled-down").removeClass("detached").removeClass("invisible").removeClass("at-top").css("transform", "none"))
                : e('#header-outer[data-mobile-fixed="1"]').length > 0
                ? requestAnimationFrame(ln)
                : "true" == d.attr("data-transparent-header") && d.addClass("transparent"),
            s.off("smartresize.nectarNavScrollEffects"),
            s.on("smartresize.nectarNavScrollEffects", cn));
    }
    function cn() {
        oe.winW < 1e3 ||
            (1 == C && "1" != $
                ? (s.off("scroll.headerResizeEffect"),
                  0 == e("#nectar_fullscreen_rows").length ? s.on("scroll.headerResizeEffect", nn) : e('#nectar_fullscreen_rows[data-mobile-disable="on"]').length > 0 && oe.usingMobileBrowser && s.on("scroll.headerResizeEffect", nn))
                : "1" != $
                ? (s.off("scroll.headerResizeEffectOpaque"), s.on("scroll.headerResizeEffectOpaque", rn))
                : "1" == $ && (e(".nectar-box-roll").length > 0 && d.addClass("at-top-before-box"), 0 == e('#header-outer[data-remove-fixed="1"]').length && (cancelAnimationFrame(tn.raf), an())),
            e('#header-outer[data-format="centered-menu-bottom-bar"][data-condense="true"]').length > 0 && (c.length > 0 && d.css("transform", ""), oe.scrollTop > 200 && !d.hasClass("fixed-menu") && d.addClass("fixed-menu")),
            s.off("smartresize.nectarNavScrollEffects"),
            s.on("smartresize.nectarNavScrollEffects", dn));
    }
    function hn() {
        0 == e('#header-outer[data-remove-fixed="1"]').length && oe.winW > 1e3 && 0 != e(t).scrollTop() && 1 == e('#header-outer.transparent[data-permanent-transparent="false"]').length && d.removeClass("transparent"),
            0 == e("#nectar_fullscreen_rows").length && 0 == e(".nectar-box-roll").length ? Ba() : e("#nectar_fullscreen_rows").length > 0 && 0 == ne && Ba(),
            oe.winW < 1e3 && 0 == e(".nectar-box-roll").length ? (dn(), s.on("smartresize.nectarNavScrollEffects", dn)) : (cn(), s.on("smartresize.nectarNavScrollEffects", cn));
    }
    function un() {
        if (e(".mobile").length > 0) oe.winH < oe.winW && oe.winW > 1e3 ? 0 == e("#header-outer.small-nav").length && e("#header-space").css("height", d.outerHeight()) : e("#header-space").css("height", d.outerHeight());
        else if (0 == e(".nectar-parallax-scene.first-section").length) {
            var t = w - w / 1.8,
                a = e('#header-outer[data-header-resize="1"]').length > 0 && e(".small-nav").length > 0 ? d.outerHeight() + (parseInt(y) + 2 * t) : d.outerHeight();
            Math.abs(a - e("#header-space").height()) > 7 && e("#header-space").css("height", a);
        }
    }
    function pn() {
        var t = -1,
            a = oe.scrollTop;
        function n() {
            if (!r.hasClass("compose-mode")) {
                if (((a = oe.scrollTop), t == a)) return requestAnimationFrame(n), !1;
                (t = a), i(), requestAnimationFrame(n);
            }
        }
        function i() {
            var t = 0;
            if (oe.winW < 1e3 || (1 == _ && "none" == e("#header-outer .span_9").css("display")) || (1 == _ && "none" == e("#header-outer .span_9 > nav").css("display"))) {
                t = 0;
                var n = "fixed" == u.css("position") ? u.height() : 0;
                (t += oe.adminBarHeight) - a > n ? d.css("top", t - a + "px") : d.css("top", n);
            } else 0 == _ && ((t = 0), d.is('[data-remove-fixed="1"]') || (t += oe.adminBarHeight), d.css("top", t + "px"));
        }
        e('#header-outer[data-mobile-fixed="1"]').length > 0 &&
            u.length > 0 &&
            (0 == e("#nectar_fullscreen_rows").length ? requestAnimationFrame(n) : e("#nectar_fullscreen_rows").length > 0 && oe.usingMobileBrowser && requestAnimationFrame(n), s.on("smartresize", i));
    }
    function fn() {
        var t = 0,
            a = 0;
        if (
            (d.is("[data-logo-height]") && d.is("[data-padding]")
                ? d.hasClass("transparent") ||
                  (t =
                      d.find("#logo.no-image").length > 0
                          ? "left-header" == T && oe.winW > 1e3
                              ? 0
                              : parseInt(d.find("#logo.no-image").height()) + parseInt(2 * d.attr("data-padding"))
                          : "left-header" == T && oe.winW > 1e3
                          ? 0
                          : parseInt(d.attr("data-logo-height")) + parseInt(2 * d.attr("data-padding")))
                : (t = "left-header" == T && oe.winW > 1e3 ? 0 : d.outerHeight()),
            g.length > 0 && (a += g.height()),
            e(".page-header-no-bg").length > 0 && (a += e(".page-header-no-bg").height()),
            oe.winH - oe.adminBarHeight - t - oe.footerOuterHeight - 1 - a > 0)
        ) {
            var n = e('body:not(.material) #header-outer[data-header-resize="1"]').length > 0 ? 55 : 0;
            e('body[data-footer-reveal="1"]:not(.nectar_using_pfsr) .container-wrap').css({ "margin-bottom": oe.footerOuterHeight }),
                e(".container-wrap").css({ "min-height": oe.winH - oe.adminBarHeight - t - oe.footerOuterHeight - a + n });
        } else e('body[data-footer-reveal="1"]:not(.nectar_using_pfsr) .container-wrap').css({ "margin-bottom": oe.footerOuterHeight });
        oe.winW < 1e3 ? m.attr("data-midnight", "light") : m.removeAttr("data-midnight");
    }
    function gn() {
        (e('body[data-footer-reveal="1"]').length > 0 || e('body.material[data-slide-out-widget-area-style="slide-out-from-right"]').length > 0) &&
            (setTimeout(fn, 60), fn(), s.on("resize", fn), e('body[data-footer-reveal="1"][data-footer-reveal-shadow="large_2"]').length > 0 && e(".container-wrap").css({ boxShadow: "0 70px 110px -30px " + m.css("backgroundColor") }));
    }
    function mn(e) {
        (this.$el = e), (this.offsetTop = 0), (this.fullHeight = 100), (this.storedWinH = oe.winH), this.events(), this.calculate();
    }
    function vn() {
        (ee = []),
            e(".vc_row-o-full-height").each(function (t) {
                ee[t] = new mn(e(this));
            });
    }
    function bn() {
        var a = t.navigator.userAgent.indexOf("MSIE ");
        (a > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) &&
            e(".vc_row-o-full-height").each(function () {
                "flex" === e(this).find("> .span_12").css("display") && e(this).wrap('<div class="vc_ie-flexbox-fixer"></div>');
            }),
            (a > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) && (wn(), e(t).on("resize", wn));
    }
    function wn() {
        e(".img-with-aniamtion-wrap img.img-with-animation").each(function () {
            if (0 == e(this).parents(".tabbed").length && 0 == e(this).parents(".toggle").length) {
                var t = e(this).parents(".img-with-aniamtion-wrap");
                t.css({ height: "" });
                var a = e(this).height();
                t.css({ height: a });
            }
        });
    }
    function yn() {
        e(".nectar-recent-posts-slider").each(function () {
            var t = parseInt(e(this).attr("data-height")),
                a = e('body[data-ext-responsive="true"]').length > 0 ? s.width() / 1400 : s.width() / 1100,
                n = e(this).find(".nectar-recent-post-slide, .flickity-viewport");
            if (oe.winW > 1e3 && 0 == e("#boxed").length)
                0 == e(this).parents(".full-width-content").length
                    ? e('body[data-ext-responsive="true"]').length > 0 && oe.winW >= 1400
                        ? n.css("height", Math.ceil(t))
                        : 0 == e('body[data-ext-responsive="true"]').length && oe.winW >= 1100
                        ? n.css("height", Math.ceil(t))
                        : n.css("height", Math.ceil(t * a))
                    : n.css("height", Math.ceil(t * a));
            else {
                var i = e(this).parents(".wpb_column").length > 0 ? e(this).parents(".wpb_column") : e(this).parents(".col");
                if ((0 == i.length && (i = e(".main-content")), i.hasClass("vc_span12") || i.hasClass("main-content") || i.hasClass("span_12") || i.hasClass("vc_col-sm-12")))
                    t * a <= 250 ? n.css("height", 250) : n.css("height", Math.ceil(t * a));
                else {
                    var r =
                        t /
                        (function (t) {
                            var a = 1100,
                                n = e(t).attr("class").match(/\d+/);
                            "2" == n ? (a = 170) : "3" == n ? (a = 260) : "4" == n ? (a = 340) : "6" == n ? (a = 530) : "8" == n ? (a = 700) : "9" == n ? (a = 805) : "10" == n ? (a = 916.3) : "12" == n && (a = 1100);
                            return a;
                        })(i);
                    r * i.width() <= 250 ? n.css("height", 250) : n.css("height", r * i.width());
                }
            }
        });
    }
    function _n() {
        e(".nectar-recent-posts-single_featured.multiple_featured").each(function () {
            var t = e(this).find(".project-slides").length > 0 ? ".project-slide" : ".nectar-recent-post-slide",
                a = e(this).find(".project-slides").length > 0 ? ".project-info h1" : ".inner-wrap h2 a";
            e(this)
                .find(t)
                .each(function () {
                    e(this)
                        .find(a)
                        .each(function () {
                            var t = e(this).text();
                            (t = (t = t.trim()).split(" ")), (e(this)[0].innerHTML = "");
                            for (var a = 0; a < t.length; a++) e(this)[0].innerHTML += "<span>" + t[a] + "</span> ";
                        }),
                        e(this)
                            .find(a + " > span")
                            .wrapInner('<span class="inner" />');
                });
        });
    }
    function xn() {
        (e('.nectar-split-heading[data-animation-type="line-reveal-by-space"]').length > 0 || e('.nectar-split-heading[data-animation-type="letter-fade-reveal"]').length > 0) &&
            (e('.nectar-split-heading[data-animation-type="line-reveal-by-space"]:not([data-text-effect="none"])').each(function () {
                var t = e(this).hasClass("animated-in") ? " animated" : "";
                e(this)
                    .find("> *")
                    .each(function () {
                        var a = e(this).text();
                        (a = (a = a.trim()).split(" ")), (e(this)[0].innerHTML = "");
                        for (var n = 0; n < a.length; n++) e(this)[0].innerHTML += '<span><span class="inner' + t + '">' + a[n] + "</span></span> ";
                    }),
                    e(this).addClass("markup-generated");
            }),
            e('.nectar-split-heading[data-animation-type="line-reveal-by-space"][data-text-effect*="letter-reveal"]').each(function () {
                if (e(this).is('[data-m-rm-animation="true"]') && oe.winW < 1e3) return !0;
                var t = e(this).hasClass("animated-in") ? ' style="transform: none;"' : "";
                e(this)
                    .find("> *")
                    .each(function () {
                        var t = e(this).text();
                        (t = (t = t.trim()).split(" ")), (e(this)[0].innerHTML = "");
                        for (var a = 0; a < t.length; a++) e(this)[0].innerHTML += "<span>" + t[a] + "</span> ";
                    }),
                    e(this)
                        .find("span")
                        .each(function () {
                            var a = e(this),
                                n = e(this).text().split("");
                            a.empty(),
                                e.each(n, function (e, n) {
                                    a.append('<span class="inner"' + t + ">" + n + "</span>");
                                });
                        }),
                    e(this).addClass("markup-generated");
            }));
    }
    function Cn() {
        if (e(".nectar-recent-posts-slider-inner").length > 0) {
            var t = e(".nectar-recent-posts-slider_multiple_visible").length > 0 && "90%",
                a = e(".nectar-recent-posts-slider-inner").flickity({
                    contain: !0,
                    groupCells: t,
                    draggable: !0,
                    lazyLoad: !1,
                    imagesLoaded: !0,
                    percentPosition: !0,
                    prevNextButtons: !1,
                    pageDots: !0,
                    resize: !0,
                    setGallerySize: !0,
                    wrapAround: !0,
                    accessibility: !1,
                });
            setTimeout(function () {
                e(".nectar-recent-posts-slider-inner").addClass("loaded");
            }, 1150);
            var n;
            a.data("flickity");
            a.on("dragStart.flickity", function () {
                e(".flickity-viewport").addClass("is-moving");
            }),
                a.on("dragEnd.flickity", function () {
                    e(".flickity-viewport").removeClass("is-moving");
                }),
                a.on("select.flickity", function () {
                    e(".flickity-viewport").addClass("no-hover"),
                        clearTimeout(n),
                        (n = setTimeout(function () {
                            e(".flickity-viewport").removeClass("no-hover");
                        }, 400));
                }),
                yn(),
                s.on("resize", yn),
                oe.usingMobileBrowser || oe.usingFrontEndEditor || s.on("resize", Tn);
        }
        e(".nectar-recent-posts-single_featured.multiple_featured").each(function (t) {
            e(this).find("> .normal-container").length > 0 && e(this).find("> .normal-container").remove(),
                e(this).append('<div class="normal-container container"> <ul class="controls" data-color="' + e(this).attr("data-button-color") + '" data-num="' + e(this).find(".nectar-recent-post-slide").length + '"></ul> </div>');
            var a,
                n = e(this),
                i = 0;
            (A[t] = { autorotate: "" }),
                e(this)
                    .find(".nectar-recent-post-slide")
                    .each(function (t) {
                        e(this).find(".recent-post-container").height() > i && (e(this).siblings().removeClass("tallest"), e(this).addClass("tallest"), (i = e(this).find(".recent-post-container").height()));
                        var a = 0 == t && e(this).parents('.nectar-recent-posts-single_featured.multiple_featured[data-autorotate="none"]').length > 0 ? 'class="active"' : "";
                        n.find(".controls").append("<li " + a + '><span class="title">' + e(this).find("h2").text() + "</span></li>");
                    }),
                e(this).addClass("js-loaded"),
                e(this)
                    .find(".controls li")
                    .on("click", function (n) {
                        if (!e(this).hasClass("active")) {
                            void 0 !== n.originalEvent && e(this).parent().find(".active").addClass("trans-out");
                            var i = e(this).index(),
                                s = e(this).parent().find(".active").index(),
                                r = e(this);
                            clearTimeout(a),
                                e(this).siblings().removeClass("active"),
                                e(this).addClass("active"),
                                (a = setTimeout(function () {
                                    r
                                        .parents(".multiple_featured")
                                        .find(".nectar-recent-post-slide:not(:eq(" + i + "))")
                                        .css("opacity", "0")
                                        .removeClass("active"),
                                        r.parent().find(".trans-out").removeClass("trans-out");
                                }, 300)),
                                r
                                    .parents(".multiple_featured")
                                    .find(".nectar-recent-post-slide:not(:eq(" + i + "))")
                                    .css("z-index", "10"),
                                r
                                    .parents(".multiple_featured")
                                    .find(".nectar-recent-post-slide:eq(" + s + ")")
                                    .css("z-index", "15"),
                                e(this).parents(".multiple_featured").find(".nectar-recent-post-slide").eq(i).css({ opacity: "1", "z-index": "20" }).addClass("active"),
                                "none" != e(this).parents(".multiple_featured").attr("data-autorotate") &&
                                    (function (e, t) {
                                        if ((clearInterval(A[t].autorotate), e.attr("data-autorotate").length > 0)) {
                                            var a = parseInt(e.attr("data-autorotate")) < 100 ? 4e3 : parseInt(e.attr("data-autorotate"));
                                            A[t].autorotate = setInterval(function () {
                                                Hn(e);
                                            }, a);
                                        }
                                    })(r.parents(".nectar-recent-posts-single_featured.multiple_featured"), t);
                        }
                    }),
                (n = e(this)),
                e(this).attr("data-autorotate").length > 0 &&
                    "none" != e(this).attr("data-autorotate") &&
                    0 == e("body.vc_editor").length &&
                    setTimeout(function () {
                        var e = parseInt(n.attr("data-autorotate")) < 100 ? 4e3 : parseInt(n.attr("data-autorotate"));
                        (A[t].autorotate = setInterval(function () {
                            Hn(n);
                        }, e)),
                            n.find(".controls > li:first-child").addClass("active");
                    }, 30);
        }),
            _n(),
            s.on("resize", _n);
    }
    function kn() {
        e(".nectar-recent-posts-slider").each(function () {
            var t = parseInt(e(this).find(".flickity-slider").position().left),
                a = e(this).find(".nectar-recent-post-slide"),
                n = a.length,
                i = a.width(),
                s = e(this).find(".nectar-recent-post-slide:last-child").index(),
                r = e(this).find(".nectar-recent-post-slide:first-child .nectar-recent-post-bg"),
                o = e(this).find(".nectar-recent-post-slide:last-child .nectar-recent-post-bg");
            t >= -3 ? o.css("margin-left", parseInt(Math.ceil(i / 3.5)) + "px") : o.css("margin-left", "-" + parseInt(Math.ceil((i / 3.5) * s)) + "px"),
                Math.abs(t) >= (n - 1) * i ? r.css("margin-left", "-" + parseInt(Math.ceil((i / 3.5) * n)) + "px") : r.css("margin-left", "0px"),
                e(this)
                    .find(".nectar-recent-post-bg")
                    .css("transform", "translateX(" + Math.ceil(e(this).find(".flickity-slider").position().left / -3.5) + "px)");
        }),
            requestAnimationFrame(kn);
    }
    function Tn() {
        e(".nectar-recent-posts-slider").each(function () {
            var t = e(this).find(".nectar-recent-post-slide").width();
            e(this)
                .find(".nectar-recent-post-slide")
                .each(function (a) {
                    e(this)
                        .find(".nectar-recent-post-bg")
                        .css("margin-left", "-" + parseInt(Math.ceil(t / 3.5) * a) + "px");
                });
        });
    }
    function $n() {
        Cn(),
            e('.blog-recent[data-style="classic_enhanced_alt"] .inner-wrap').each(function () {
                e(this)
                    .find(".post-featured-img")
                    .each(function () {
                        var t = e(this).find("img").attr("src");
                        e(this).css("background-image", "url(" + t + ")");
                    });
            }),
            e('.blog-recent[data-style="classic_enhanced"]').each(function () {
                0 == e(this).find(".inner-wrap.has-post-thumbnail").length && e(this).addClass("no-thumbs");
            }),
            oe.usingMobileBrowser || (e(".nectar-recent-posts-slider").length > 0 && !oe.usingFrontEndEditor && t.requestAnimationFrame(kn)),
            oe.usingMobileBrowser || oe.usingFrontEndEditor || Tn();
    }
    function In() {
        e(".style-5").each(function () {
            e(this).find(".sizer").insertBefore(e(this).find(".parallaxImg"));
        }),
            e(".style-5").parents(".wpb_row").css("z-index", "100");
        var n = a,
            i = (n.getElementsByTagName("body")[0], t),
            s = n.querySelectorAll(".parallaxImg"),
            o = s.length,
            l = "ontouchstart" in i || navigator.msMaxTouchPoints,
            d = !1;
        if (!(o <= 0)) {
            for (var c = 0; c < o; c++) {
                var h = s[c],
                    u = h.querySelectorAll(".parallaxImg-layer"),
                    p = u.length;
                if (!(p <= 0)) {
                    for (; h.firstChild; ) h.removeChild(h.firstChild);
                    var f = 0,
                        g = 80;
                    navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge/") < 1 ? ((g = 1), e("html").addClass("cssreflections")) : r.addClass("cssreflections");
                    var m = n.createElement("div"),
                        v = n.createElement("div"),
                        b = n.createElement("div"),
                        w = n.createElement("div"),
                        y = [];
                    (h.id = "parallaxImg__" + c), (m.className = "parallaxImg-container"), (b.className = "parallaxImg-shadow"), (w.className = "parallaxImg-layers");
                    for (var _ = 0; _ < p; _++) {
                        var x = n.createElement("div"),
                            C = n.createElement("div"),
                            k = u[_].getAttribute("data-img");
                        e(x).html(e(u[_]).html()),
                            (x.className = "parallaxImg-rendered-layer"),
                            x.setAttribute("data-layer", _),
                            0 == _ &&
                                0 == e(h).parents(".wpb_gallery").length &&
                                ((C.className = "bg-img"), e(h).parents(".nectar-fancy-box").length > 0 ? (C.setAttribute("data-nectar-img-src", k), (d = !0)) : (C.style.backgroundImage = "url(" + k + ")"), x.appendChild(C)),
                            w.appendChild(x),
                            y.push(x);
                    }
                    m.appendChild(w),
                        h.appendChild(m),
                        e(h).wrap('<div class="parallaxImg-wrap" />'),
                        (-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")) || e(h).parent().append(b),
                        (l && e("body.using-mobile-browser").length > 0) ||
                            (function (a, n, i, s) {
                                e(h)
                                    .parents(".style-5")
                                    .on("mousemove", function (r) {
                                        var o = e(this),
                                            l = o.find(".parallaxImg-container"),
                                            d = o.find(".parallaxImg-shadow"),
                                            c = Date.now(),
                                            h = e(a).parents(".wpb_gallery").length > 0;
                                        c > f + g &&
                                            ((f = c),
                                            t.requestAnimationFrame(function () {
                                                T(r, !1, a, n, i, s, o, l, d, h);
                                            }));
                                    }),
                                    e(h)
                                        .parents(".style-5")
                                        .on("mouseenter", function (e) {
                                            $(e, a);
                                        }),
                                    e(h)
                                        .parents(".style-5")
                                        .on("mouseleave", function (e) {
                                            I(e, a);
                                        });
                            })(h, y, p, v),
                        (function (e, a, n, i) {
                            E(!1, e, a, n),
                                t.addEventListener("resize", function () {
                                    E(!1, e, a, n);
                                });
                        })(h, y, p);
                }
            }
            d && Nt();
        }
        function T(t, a, n, i, s, r, o, l, d, c) {
            if (!e(n.firstChild).hasClass("over")) return I(t, n), !1;
            var h = 0.03,
                u = 0.063,
                p = "1.03",
                f = "-10",
                g = !1;
            e(n).parents(".col.wide").length > 0
                ? ((h = 0.03), (u = 0.063), (g = !0))
                : e(n).parents(".col.regular").length > 0 || e(n).parents(".wpb_gallery").length > 0
                ? ((h = 0.045), (u = 0.045))
                : e(n).parents(".col.tall").length > 0
                ? ((h = 0.05), (u = 0.015), (g = !0))
                : e(n).parents(".col.wide_tall").length > 0
                ? ((h = 0.04), (u = 0.04), (g = !0))
                : o.hasClass("nectar-fancy-box")
                ? ((h = 0.045), (u = 0.022), (p = "1.06"), (f = "-2"))
                : ((h = 0.045), (u = 0.075));
            var m,
                v = oe.scrollTop,
                b = a ? t.touches[0].pageX : t.pageX,
                w = a ? t.touches[0].pageY : t.pageY,
                y = n.getBoundingClientRect(),
                _ = n.clientWidth || n.offsetWidth || n.scrollWidth,
                x = n.clientHeight || n.offsetHeight || n.scrollHeight,
                C = 320 / _,
                k = 0.52 - (b - y.left - 0) / _,
                T = 0.52 - (w - y.top - v) / x,
                $ = w - y.top - v - x / 2,
                E = h * C * (k - (b - y.left - 0 - _ / 2)),
                z = u * C * ($ - T);
            (m =
                1 == c
                    ? " perspective(" + 3 * _ + "px) rotateX(" + 1.9 * -z + "deg) rotateY(" + 1.3 * -E + "deg)"
                    : 0 == g
                    ? " perspective(" + 3 * _ + "px) rotateX(" + z + "deg) rotateY(" + E + "deg)  translateY(" + T * f + "px) translateX(" + k * f + "px) scale(" + p + ")"
                    : " perspective(" + 3 * _ + "px) rotateX(" + z + "deg) rotateY(" + E + "deg)  translateY(" + -10 * T + "px) translateX(" + -10 * k + "px) scale(1.013)"),
                l.css("transform", m),
                (-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")) || d.css("transform", m);
        }
        function $(t, a) {
            (a.firstChild.className += " over"),
                (a.className += " over"),
                e(a).addClass("transition"),
                e(a).parents(".wpb_gallery").length > 0
                    ? setTimeout(function () {
                          e(a).removeClass("transition");
                      }, 450)
                    : setTimeout(function () {
                          e(a).removeClass("transition");
                      }, 200);
        }
        function I(t, a) {
            var n = a.clientWidth || a.offsetWidth || a.scrollWidth,
                i = a.firstChild;
            (i.className = i.className.replace(" over", "")),
                (a.className = a.className.replace(" over", "")),
                e(i).css("transform", "perspective(" + 3 * n + "px) rotateX(0deg) rotateY(0deg) translateZ(0)"),
                e(a)
                    .parents(".parallaxImg-wrap")
                    .find(".parallaxImg-shadow")
                    .css("transform", "perspective(" + 3 * n + "px) rotateX(0deg) rotateY(0deg) translateZ(0)"),
                e(a).addClass("transition"),
                setTimeout(function () {
                    e(a).removeClass("transition");
                }, 200);
        }
        function E(t, a, n, i) {
            for (var s = a.clientWidth || a.offsetWidth || a.scrollWidth, r = a.firstChild, o = 0; o < i; o++)
                0 == o ? e(n[o]).css("transform", "translateZ(0px)") : e(n[o]).css("transform", "translateZ(" + ((3 * s) / 27) * (1.1 * o) + "px) ");
            (i += 3), e(r).css("transform", "perspective(" + 3 * s + "px)");
        }
    }
    function En() {
        if (0 == e('.nectar-fancy-box[data-style="hover_desc"]').length) return !1;
        var t = 0;
        e("body").on("mouseenter touchstart", '.nectar-fancy-box[data-style="hover_desc"]', function () {
            (t = parseInt(e(this).find(".hover-content").outerHeight(!0))),
                e(this).addClass("hovered"),
                e(this)
                    .find(".heading-wrap")
                    .css("transform", "translateY(-" + t + "px)");
        }),
            e("body").on("mouseleave touchend", '.nectar-fancy-box[data-style="hover_desc"]', function () {
                e(this).removeClass("hovered"), e(this).find(".heading-wrap").css("transform", "translateY(0)");
            });
    }
    function zn(e, t) {
        (this.$el = e),
            (this.$iconEl = this.$el.find(t)),
            (this.$innerIconEl = this.$el.find(".inner")),
            (this.initialX = this.$el.width() / 2),
            (this.initialY = this.$el.height() / 2),
            (this.elX = 0),
            (this.elY = 0),
            (this.lastScroll = 0),
            (this.scrollAdjust = 0),
            (this.lastX = this.initialX),
            (this.lastY = this.initialY),
            (this.lastY2 = this.initialY),
            (this.innerLastX = 0),
            (this.innerLastY = 0),
            (this.activeFollow = !1),
            (this.percentage = 0.03),
            this.percentageInterval,
            this.$iconEl.css({ top: "0", left: "0" }),
            s.on("resize", this.resizeEvent.bind(this)),
            this.mouseEvents(),
            this.rafLoop();
    }
    function On() {
        (L = []),
            r.on("mouseenter", '.nectar_video_lightbox[data-parent-hover="1"]', function () {
                var t = e(this).parents(".wpb_row");
                t.find("> .row-bg-wrap .row-bg, > .nectar-video-wrap .nectar-video-inner").addClass("transition"), t.find("> .row-bg-wrap .row-bg, > .nectar-video-wrap .nectar-video-inner").css({ transform: "scale(1.08)" });
            }),
            r.on("mouseleave", '.nectar_video_lightbox[data-parent-hover="1"]', function () {
                e(this).parents(".wpb_row").find("> .row-bg-wrap .row-bg, > .nectar-video-wrap .nectar-video-inner").css({ transform: "scale(1)" });
            }),
            e(".nectar_video_player_self_hosted").each(function (t) {
                !oe.usingMobileBrowser && e(this).find(".play_button.follow_mouse").length > 0 && (L[t] = new zn(e(this), ".play_button.follow_mouse .play"));
            }),
            e(".nectar-video-box").each(function (t) {
                if (e(this).find(".play_button_mouse_follow").length > 0) {
                    var a = e(this);
                    e(this).imagesLoaded(function () {
                        oe.usingMobileBrowser || (L[t] = new zn(a, ".play_button_mouse_follow"));
                        var e = a.is("[data-mouse-icon-color]") && a.attr("data-mouse-icon-color").length > 0 ? a.attr("data-mouse-icon-color") : "#000";
                        a.is('[data-mouse-style="solid_color"]') && a.find(".play_button_mouse_follow").css({ "background-color": e }), a.find(".play_button_mouse_follow").addClass("visible");
                    });
                }
            });
    }
    function Hn(t) {
        if (!(e("body.vc_editor").length > 0)) {
            var a = t.find(".project-slides").length > 0 ? ".dot-nav > span" : ".controls > li",
                n = t.find(".project-slides").length > 0 ? "span" : " li",
                i = t.find(a).length;
            t.find(a + ".active").index() + 1 == i
                ? t.find(a + ":first-child").trigger("click")
                : t
                      .find(a + ".active")
                      .next(n)
                      .trigger("click");
        }
    }
    function Sn() {
        (P = []),
            "undefined" != typeof SalientRecentProjectsFullScreen &&
                e(".nectar_fullscreen_zoom_recent_projects").each(function (t) {
                    P[t] = new SalientRecentProjectsFullScreen(e(this));
                });
    }
    function An() {
        e(".infinite_scroll").length > 0 &&
            (e(".portfolio-items.infinite_scroll").infinitescroll(
                {
                    navSelector: "div#pagination",
                    nextSelector: "div#pagination a:first",
                    itemSelector: ".portfolio-items.infinite_scroll .element",
                    finishedMsg: "<em>Congratulations, you've reached the end of the internet.</em>",
                    msgText: " ",
                },
                function (t) {
                    var a = e(".portfolio-items.infinite_scroll:not(.carousel)");
                    e(t)
                        .css("opacity", 0)
                        .imagesLoaded(function () {
                            var n;
                            (e(t).css("opacity", 1),
                            a.isotope("appended", e(t)),
                            e(t).find(".work-item").addClass("ajax-loaded"),
                            e(t).addClass("ajax-loaded"),
                            e(t).find(".work-meta, .nectar-love-wrap").css({ opacity: 1 }),
                            e(".portfolio-filters-inline").length > 0 || e(".portfolio-filters").length > 0) &&
                                ((n = e(".portfolio-filters-inline").length > 0 ? e(".portfolio-filters-inline a.active").attr("data-filter") : e(".portfolio-filters a.active").attr("data-filter")),
                                e(".portfolio-filters-inline a.active").attr("data-filter"),
                                a.isotope({ filter: n }));
                            for (var i = 0; i < H.length; i++) H[i].reLayout();
                            if ((e(t).find(".work-item.style-5").length > 0 && In(), "none" == e(t).find(".inner-wrap").attr("data-animation"))) e(".portfolio-items .col .inner-wrap").removeClass("animated");
                            else {
                                for (i = 0; i < H.length; i++) H[i].masonryZindex(), H[i].portfolioAccentColor();
                                e(t).each(function () {
                                    var t = e("#nectar_fullscreen_rows").length > 0 ? "200%" : "90%",
                                        a = e(this),
                                        n = new Waypoint({
                                            element: a[0],
                                            handler: function () {
                                                var e = a.is('[data-masonry-type="photography"].masonry-items') ? 85 : 115;
                                                setTimeout(function () {
                                                    a.addClass("animated-in");
                                                }, e * a.attr("data-delay-amount")),
                                                    n.destroy();
                                            },
                                            offset: t,
                                        });
                                });
                            }
                            e(".portfolio-items").each(function () {
                                var t = Be();
                                e(this)
                                    .find('a[rel^="prettyPhoto"], a.pretty_photo')
                                    .attr("rel", "prettyPhoto[" + t + "_gal]")
                                    .removeClass("pretty_photo");
                            }),
                                e(".portfolio-items").each(function () {
                                    var t = Be();
                                    e(this)
                                        .find('a[data-fancybox^="group_"]')
                                        .attr("data-fancybox", "group_" + t);
                                }),
                                Ge(),
                                setTimeout(function () {
                                    for (var a = 0; a < H.length; a++) H[a].masonryZindex(), H[a].reLayout(), H[a].isotopeCatSelection();
                                    e(t).removeClass("ajax-loaded");
                                }, 700),
                                $t();
                        });
                }
            ),
            e(".post-area.infinite_scroll .posts-container").infinitescroll(
                {
                    navSelector: "div#pagination",
                    nextSelector: "div#pagination a:first",
                    itemSelector: ".post-area.infinite_scroll .posts-container .post",
                    finishedMsg: "<em>Congratulations, you've reached the end of the internet.</em>",
                    msgText: " ",
                },
                function (t) {
                    e(t).find("[data-nectar-img-src]").length > 0 && Nt(),
                        e(".masonry.classic").length > 0 || e(".post-area:not(.masonry):not(.featured_img_left)").length > 0 || e(".post-area.standard-minimal").length > 0
                            ? (pe(),
                              e().mediaelementplayer && e(t).find(".wp-audio-shortcode, .wp-video-shortcode").mediaelementplayer(),
                              Ge(),
                              e(".carousel").length > 0 && ($e(), Se()),
                              Ra(),
                              e(".testimonial_slider").animate({ opacity: "1" }, 800),
                              aa(),
                              na(),
                              setTimeout(function () {
                                  da(), ca(), s.trigger("resize");
                              }, 500),
                              $t(),
                              s.trigger("resize"))
                            : ($t(), s.trigger("resize"));
                    var a = e(".infinite_scroll .posts-container");
                    a.parent().hasClass("masonry") && e(t).addClass("masonry-blog-item");
                    var n = e(t);
                    0 == n.find("img").length && (n = e("body")),
                        n.imagesLoaded(function () {
                            a.parent().hasClass("masonry") && !a.parent().hasClass("auto_meta_overlaid_spaced") && a.isotope("appended", e(t));
                            for (var n = 0; n < D.length; n++) D[n].flickityBlogInit();
                            if (
                                (e(t).addClass("ajax-loaded"),
                                a.parent().hasClass("classic_enhanced") &&
                                    (a.find(".large_featured.has-post-thumbnail.ajax-loaded .post-featured-img, .wide_tall.has-post-thumbnail.ajax-loaded .post-featured-img").each(function () {
                                        var t = e(this).find("img").attr("src");
                                        e(this).css("background-image", "url(" + t + ")");
                                    }),
                                    a.find(".large_featured.ajax-loaded .nectar-flickity, .wide_tall.ajax-loaded .nectar-flickity").each(function () {
                                        e(this)
                                            .find(".cell")
                                            .each(function () {
                                                var t = e(this).find("img").attr("src");
                                                e(this).css("background-image", "url(" + t + ")");
                                            });
                                    })),
                                "none" == e(t).parents(".posts-container").attr("data-animation"))
                            )
                                e(t).find(".inner-wrap").removeClass("animated");
                            else {
                                for (n = 0; n < D.length; n++) D[n].blogMasonryZindex();
                                e(t).each(function () {
                                    var t = e(this),
                                        a = new Waypoint({
                                            element: t[0],
                                            handler: function () {
                                                setTimeout(function () {
                                                    t.addClass("animated-in");
                                                }, 80 * t.attr("data-delay-amount")),
                                                    a.destroy();
                                            },
                                            offset: "90%",
                                        });
                                });
                            }
                            setTimeout(function () {
                                e(t).removeClass("ajax-loaded");
                            }, 700);
                        });
                }
            ));
    }
    function Mn() {
        oe.scrollTop > 350 && !o.is(".fullscreen.open") && (e("#to-top").stop().transition({ transform: "translateY(-50%)" }, 350, "easeInOutCubic"), s.off("scroll", Mn), s.on("scroll", Wn));
    }
    function Wn() {
        if (oe.scrollTop < 350 || o.is(".fullscreen.open")) {
            var t = e("#slide-out-widget-area.fullscreen.open").length > 0 ? 1150 : 350;
            e("#to-top").stop().transition({ transform: "translateY(105%)" }, t, "easeInOutQuint"), s.off("scroll", Wn), s.on("scroll", Mn);
        }
    }
    function Fn() {
        if (
            (0 == e(".nectar-social.fixed").length && ((e("#to-top").length > 0 && s.width() > 1020) || (e("#to-top").length > 0 && e("#to-top.mobile-enabled").length > 0)) && (oe.scrollTop > 350 ? s.on("scroll", Wn) : s.on("scroll", Mn)),
            e('body[data-button-style*="rounded"]').length > 0)
        ) {
            var t = e("#to-top .fa-angle-up").clone();
            t.addClass("top-icon"), e("#to-top").prepend(t);
        }
        r.on("click", '#to-top, a[href="#top"]', function () {
            return (
                e("body,html")
                    .stop()
                    .animate({ scrollTop: 0 }, 800, "easeOutQuad", function () {
                        e(".nectar-box-roll").length > 0 && r.trigger("mousewheel", [1, 0, 0]);
                    }),
                !1
            );
        });
    }
    function qn() {
        var a = e('body[data-header-format="left-header"]').length > 0 && s.width() > 1e3 ? 0 : d.outerHeight();
        (e(".page-template-template-no-header-footer").length > 0 || e(".page-template-template-no-header").length > 0) && (a = 0);
        var n = !1;
        e('header#top .sf-menu li a[href="#"]').on("click", function (e) {
            e.preventDefault();
        }),
            0 == e("#nectar_fullscreen_rows").length || 0 == re.$usingFullScreenRows
                ? e("a.nectar-next-section").each(function () {
                      if (e(this).parents(".wpb_row:not(.inner_row)").length > 0) {
                          var t = e(this).parents(".wpb_row:not(.inner_row)");
                          if (t.next(".wpb_row[id]:not(.inner_row)").length > 0) {
                              var a = t.next(".wpb_row[id]:not(.inner_row)").attr("id");
                              e(this).attr("href", "#" + a), (n = !0);
                          }
                      }
                  })
                : e().fullpage &&
                  e("a.nectar-next-section").on("click", function () {
                      return e.fn.fullpage.moveSectionDown(), !1;
                  }),
            e("#slide-out-widget-area .off-canvas-menu-container").length > 0 &&
                e("#slide-out-widget-area .off-canvas-menu-container")
                    .find("a[href*='" + location.pathname + "']")
                    .each(function () {
                        var t = e(this).attr("href");
                        "#" != t &&
                            -1 != t.indexOf("#") &&
                            "#" !== t.substr(t.indexOf("#")) &&
                            e("div" + t.substr(t.indexOf("#"))).length > 0 &&
                            (e(this).attr("href", t.substr(t.indexOf("#"))), e(this).parent().removeClass("current_page_item").removeClass("current-menu-item")),
                            e('div[data-fullscreen-anchor-id="' + t.substr(t.indexOf("#") + 1) + '"]').length > 0 && e(this).parent().removeClass("current_page_item").removeClass("current-menu-item");
                    }),
            e("#header-outer")
                .find("a[href*='" + location.pathname + "']")
                .each(function () {
                    var t = e(this).attr("href");
                    -1 != t.indexOf("#") &&
                        "#" !== t.substr(t.indexOf("#")) &&
                        e("div" + t.substr(t.indexOf("#"))).length > 0 &&
                        (e(this).attr("href", t.substr(t.indexOf("#"))), e(this).parent().removeClass("current_page_item").removeClass("current-menu-item")),
                        e('div[data-fullscreen-anchor-id="' + t.substr(t.indexOf("#") + 1) + '"]').length > 0 && e(this).parent().removeClass("current_page_item").removeClass("current-menu-item");
                }),
            e("#header-outer").length > 0 &&
                e("#header-outer")
                    .find("a[href*='#']:not([href='#'])")
                    .each(function () {
                        "#" !== e(this).attr("href") && "#searchbox" !== e(this).attr("href") && "#sidewidgetarea" !== e(this).attr("href") && (n = !0);
                    }),
            e("#slide-out-widget-area .off-canvas-menu-container").length > 0 &&
                e("#slide-out-widget-area .off-canvas-menu-container")
                    .find("a[href*='#']:not([href='#'])")
                    .each(function () {
                        "#" !== e(this).attr("href") && (n = !0);
                    });
        var i = [];
        1 == n && i.push("#header-outer nav"),
            e('.page-submenu[data-sticky="true"] a[href*="#"]').length > 0 && i.push('.page-submenu[data-sticky="true"]'),
            i.length > 0 &&
                i.forEach(function (n, i) {
                    (0 == i ? r : e(t)).scrollspy({ target: n, offset: a + oe.adminBarHeight + 40 });
                });
    }
    function Ln() {
        var a = t.location.hash;
        a && a.length > 0 && (a = a.replace(/<|>/g, ""));
        var n = a && a.length > 0 ? a.substring(1, a.length) : 0,
            i = w - w / 1.8,
            o = 0;
        if (
            (n && (o = (o = n.split("/")).length),
            n && o > 1 && ((n = n.replace(/\//g, "")), (a = a.replace(/\//g, ""))),
            (a && e(".main-content").find(a).length > 0) || (a && e(".main-content").find('[data-fullscreen-anchor-id="' + n + '"]').length > 0))
        ) {
            var l = e(".main-content").find(a).length > 0 ? e(".main-content").find(a) : e(".main-content").find('[data-fullscreen-anchor-id="' + n + '"]'),
                h = e('body[data-header-format="left-header"]').length > 0 && s.width() > 1e3 ? 0 : e("#header-space").outerHeight();
            (e(".page-template-template-no-header-footer").length > 0 || e(".page-template-template-no-header").length > 0) && (h = 0);
            var u = 100;
            e(".nectar-box-roll").length > 0 && e(".container-wrap.bottomBoxOut").length > 0 && (se.boxRoll(null, -1), (u = 2050)),
                setTimeout(function () {
                    var t;
                    if (0 == e('body[data-permanent-transparent="1"]').length)
                        if (r.hasClass("mobile")) t = e('#header-outer[data-mobile-fixed="1"]').length > 0 ? l.offset().top + 2 - h + oe.adminBarHeight : l.offset().top - oe.adminBarHeight + 1;
                        else {
                            var a = e('#header-outer[data-header-resize="0"]').length > 0 ? 0 : parseInt(y) + 2 * i;
                            if (
                                (e('#header-outer[data-remove-fixed="1"]').length > 0 && (h = 0),
                                (t = l.offset().top - parseInt(h) + a + 3 - oe.adminBarHeight),
                                0 == e("body.mobile").length &&
                                    e('#header-outer[data-condense="true"]').length > 0 &&
                                    0 === e("body.page-template-template-no-header").length &&
                                    0 === e("body.page-template-template-no-header-footer").length)
                            ) {
                                var n = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9'),
                                    s = d.height() - (parseInt(n.height()) + parseInt(e("#header-outer #logo").css("margin-top")));
                                t = l.offset().top - parseInt(h) + s - oe.adminBarHeight;
                            }
                        }
                    else t = l.offset().top - oe.adminBarHeight + 1;
                    e('body[data-hhun="1"]').length > 0 && 0 == e('#header-outer[data-remove-fixed="1"]').length && 0 == e("#header-outer.detached").length && (t += h),
                        Pe(
                            t -
                                (e('.page-submenu[data-sticky="true"]').length > 0 ? e(".page-submenu").height() : 0) +
                                (e("body.material").length > 0 && c.length > 0 && 0 == e('body[data-hhun="1"]').length && 0 == e('#header-outer[data-remove-fixed="1"]').length && !r.hasClass("mobile") ? c.height() : 0),
                            700,
                            "easeInOutQuint"
                        ),
                        (de.animatedScrolling = !0),
                        setTimeout(function () {
                            de.animatedScrolling = !1;
                        }, 1100);
                }, u);
        }
    }
    function Yn() {
        e('body[data-animated-anchors="true"]').length > 0 &&
            (0 == e(".nectar-box-roll").length &&
                0 == e("#nectar_fullscreen_rows").length &&
                (void 0 !== De.tab
                    ? setTimeout(function () {
                          Ln();
                      }, 800)
                    : Ln()),
            e('#nectar_fullscreen_rows[data-mobile-disable="on"]').length > 0 && 0 == e(".nectar-box-roll").length && oe.usingMobileBrowser && Ln());
    }
    function jn() {
        if (e('body[data-animated-anchors="true"]').length > 0 || e('.single-product [data-gallery-style="left_thumb_sticky"]').length > 0) {
            var a,
                n = w - w / 1.8;
            setTimeout(qn, 100),
                r.on(
                    "click",
                    "#header-outer nav .sf-menu a, #footer-outer .nectar-button, #footer-outer .widget_nav_menu a, #footer-widgets .textwidget a, #mobile-menu li a, .nectar-scrolling-tabs:not(.navigation_func_active_link_only) .scrolling-tab-nav a, .container-wrap a:not(.wpb_tabs_nav a):not(.navigation_func_active_link_only .scrolling-tab-nav a):not(.woocommerce-checkout a):not(.um-woo-view-order):not(.magnific):not([data-fancybox]):not(.woocommerce-tabs .tabs a):not(.slider-prev):not(.slider-next):not(.testimonial-next-prev a):not(.page-numbers), .swiper-slide .button a, #slide-out-widget-area a, #slide-out-widget-area .inner div a",
                    function (i) {
                        var o = !0,
                            l = e(this).prop("hash");
                        l && !e(this).hasClass("nectar-next-section") && 0 == e(this).parents(".slide-out-widget-area-toggle").length && (r.addClass("animated-scrolling"), (de.animatedScrolling = !0)),
                            clearTimeout(a),
                            (a = setTimeout(function () {
                                r.removeClass("animated-scrolling"), (de.animatedScrolling = !1);
                            }, 1100));
                        var h = e('body[data-header-format="left-header"]').length > 0 && s.width() > 1e3 ? 0 : e("#header-space").outerHeight();
                        if (
                            ((e(".page-template-template-no-header-footer").length > 0 || e(".page-template-template-no-header").length > 0 || 0 == e("#header-space").length) && (h = 0),
                            0 != re.$usingFullScreenRows &&
                                e('#nectar_fullscreen_rows[data-anchors="on"]').length > 0 &&
                                l &&
                                "" != l &&
                                "#top" != l &&
                                e('body.material[data-slide-out-widget-area-style="slide-out-from-right"].material-ocm-open').length > 0 &&
                                (i.preventDefault(),
                                e(this).hasClass("skip-hash") || (history.pushState ? history.pushState(null, null, l) : (location.hash = l)),
                                setTimeout(function () {
                                    e(t).trigger("hashchange");
                                }, 800)),
                            (l && r.find(l).length > 0 && "#top" != l && "" != l && -1 !== e(this).attr("href").indexOf(t.location.href.split("#")[0])) || (e(this).is('[href^="#"]') && "" != l && r.find(l).length > 0 && "#top" != l))
                        ) {
                            if (
                                (e(this).hasClass("skip-hash") || (history.pushState ? history.pushState(null, null, l) : (location.hash = l)),
                                e(this).parents("ul").length > 0 && e(this).parents("ul").find("li").removeClass("current-menu-item"),
                                e(this).parents("#slide-out-widget-area").length > 0)
                            ) {
                                if (e('body.material[data-slide-out-widget-area-style="slide-out-from-right"].material-ocm-open').length > 0) {
                                    e("body > .slide_out_area_close").addClass("non-human-allowed").trigger("click");
                                    var u = e(this);
                                    (o = !1),
                                        setTimeout(function () {
                                            u.trigger("click");
                                        }, 1e3);
                                } else e("#slide-out-widget-area .slide_out_area_close").addClass("non-human-allowed").trigger("click");
                                setTimeout(function () {
                                    e('body.material[data-slide-out-widget-area-style="slide-out-from-right"]').length > 0
                                        ? e("body > .slide_out_area_close").removeClass("non-human-allowed")
                                        : e("#slide-out-widget-area .slide_out_area_close").removeClass("non-human-allowed");
                                }, 100);
                            }
                            e(this).parents("#mobile-menu").length > 0 &&
                                (e(".slide-out-widget-area-toggle.mobile-icon a").addClass("non-human-allowed").trigger("click"),
                                setTimeout(function () {
                                    e(".slide-out-widget-area-toggle.mobile-icon a").removeClass("non-human-allowed");
                                }, 100));
                            var p = e(this).parents("#mobile-menu").length > 0 ? e(this).parents("#mobile-menu").height() : null,
                                f = 1,
                                g = e(this);
                            e(".nectar-box-roll").length > 0 && e(".container-wrap.bottomBoxOut").length > 0 && (se.boxRoll(null, -1), (f = 2050)),
                                setTimeout(function () {
                                    var t;
                                    if (0 == e('body[data-permanent-transparent="1"]').length)
                                        if (r.hasClass("mobile")) t = e('#header-outer[data-mobile-fixed="1"]').length > 0 ? e(l).offset().top + 2 - h + oe.adminBarHeight : e(l).offset().top - p - oe.adminBarHeight + 1;
                                        else {
                                            var a = e('#header-outer[data-header-resize="0"]').length > 0 ? 0 : parseInt(y) + 2 * n;
                                            if (
                                                (e('#header-outer[data-remove-fixed="1"]').length > 0 && (h = 0),
                                                (t = e(l).offset().top - p - parseInt(h) + a + 3 - oe.adminBarHeight),
                                                0 == e("body.mobile").length &&
                                                    0 === e("body.page-template-template-no-header").length &&
                                                    0 === e("body.page-template-template-no-header-footer").length &&
                                                    e('#header-outer[data-condense="true"]').length > 0)
                                            ) {
                                                var i = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9'),
                                                    s = d.height() - (parseInt(i.height()) + parseInt(e("#header-outer #logo").css("margin-top")));
                                                t = e(l).offset().top - parseInt(h) + s - oe.adminBarHeight;
                                            }
                                        }
                                    else t = e(l).offset().top - oe.adminBarHeight + 1;
                                    e('body[data-hhun="1"]').length > 0 &&
                                        0 == e('#header-outer[data-remove-fixed="1"]').length &&
                                        ((0 == e("#header-outer.detached").length || g.parents('.page-submenu[data-sticky="true"]').length > 0) && (t += h),
                                        g.parents('.page-submenu[data-sticky="true"]').length > 0 &&
                                            (e("#header-outer.detached").addClass("invisible"), e(".page-submenu").addClass("header-not-visible").css("transform", "translateY(0px)")));
                                    var u,
                                        f = g.parents('.page-submenu[data-sticky="true"]').length > 0 ? g.parents(".page-submenu").height() : 0;
                                    (u =
                                        e("body.material").length > 0 && c.length > 0 && 0 == e('body[data-hhun="1"]').length && 0 == e('#header-outer[data-remove-fixed="1"]').length && !r.hasClass("mobile")
                                            ? c.height()
                                            : e('body[data-hhun="1"]').length > 0 && c.length > 0 && !r.hasClass("mobile") && 0 == e('#header-outer[data-remove-fixed="1"]').length
                                            ? c.height()
                                            : 0),
                                        o && Pe(t - f + u, 700, "easeInOutQuint");
                                }, f),
                                i.preventDefault();
                        }
                        "#top" == l && e(this).parents("#slide-out-widget-area").length > 0 && e("#slide-out-widget-area .slide_out_area_close").trigger("click");
                    }
                );
        }
    }
    function Bn() {
        H = [];
        var t = 0;
        e(".portfolio-items:not(.carousel)").each(function (a) {
            e(this).attr("instance", a), e(this).parent().parent().find("div[class^=portfolio-filters]").attr("instance", a), "undefined" != typeof SalientPortfolio && ((H[t] = new SalientPortfolio(e(this), Ot, ae, wt)), t++);
        });
    }
    function Pn() {
        oe.winW > 690 && e('.posts-container[data-load-animation="perspective"]').css("perspective-origin", "50% " + (oe.scrollTop + oe.winH) + "px"), requestAnimationFrame(Pn);
    }
    function Rn() {
        e('.posts-container[data-load-animation="perspective"]').length > 0 && requestAnimationFrame(Pn);
    }
    function Vn(t) {
        "none" == t.attr("data-load-animation")
            ? t.find(".inner-wrap").removeClass("animated")
            : t.find("article").each(function (t) {
                  if (e(this).visible(!0))
                      e(this)
                          .delay(110 * t)
                          .queue(function (t) {
                              e(this).addClass("animated-in"), t();
                          });
                  else
                      var a = e(this),
                          n = new Waypoint({
                              element: a[0],
                              handler: function () {
                                  setTimeout(function () {
                                      a.addClass("animated-in");
                                  }, 80 * a.attr("data-delay-amount")),
                                      n.destroy();
                              },
                              offset: "90%",
                          });
              });
    }
    function Xn() {
        (D = []),
            e(".posts-container").each(function (t) {
                if (e(this).parent().hasClass("masonry") && !e(this).parent().hasClass("auto_meta_overlaid_spaced")) {
                    if ("undefined" == typeof NectarMasonryBlog) return;
                    D[t] = new NectarMasonryBlog(e(this), wt, Vn);
                } else Vn(e(this));
            });
    }
    function Nn() {
        var t = 50;
        if (e('#header-outer[data-remove-fixed="0"]').length > 0 && 0 == e('#header-outer[data-format="left-header"]').length) {
            if (((t += d.outerHeight()), e('#header-outer[data-shrink-num][data-header-resize="1"]').length > 0)) {
                var a = parseInt(d.attr("data-padding")) - parseInt(d.attr("data-padding")) / 1.8;
                (t -= y), (t -= a);
            }
            if (0 == e("body.mobile").length && e('#header-outer[data-condense="true"]').length > 0) {
                var n = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9');
                (t = 50), (t += d.height() - (parseInt(n.position().top) - parseInt(e("#header-outer #logo").css("margin-top"))) - parseInt(oe.secondaryHeaderHeight));
            }
        }
        return u.length > 0 && (t += u.outerHeight()), t;
    }
    function Dn() {
        var n = Nn();
        if (
            ((oe.winW < 690 && oe.usingMobileBrowser) || a.documentElement.style.setProperty("--nectar-sticky-top-distance", n + "px"),
            e(".nectar-sticky-column-css").each(function () {
                0 == e(this).find(".n-sticky").length && (e(this).wrapInner('<div class="n-sticky" />'), e(this).hasClass("nectar-sticky-column-css--middle") && new ot(e(this)));
            }),
            e().theiaStickySidebar && !(oe.usingMobileBrowser && oe.winW < 1e3) && !(0 != re.$usingFullScreenRows && oe.winW > 1e3))
        ) {
            var i = '#sidebar[data-nectar-ss="true"], #sidebar[data-nectar-ss="1"], .nectar-scrolling-tabs:not(.navigation_func_active_link_only) .scrolling-tab-nav, .nectar-sticky-column';
            t.nectarOptions && t.nectarOptions.woo_sticky_sidebar && "1" === t.nectarOptions.woo_sticky_sidebar && (i += ", .woocommerce.archive #sidebar"),
                e(i).each(function () {
                    var t = n;
                    e(this).parents(".wpb_widgetised_column").length > 0
                        ? e("body.vc_editor").length > 0 || e(this).parents(".wpb_column").theiaStickySidebar({ additionalMarginTop: t, updateSidebarHeight: !1 })
                        : e(this).theiaStickySidebar({ additionalMarginTop: t, updateSidebarHeight: !1 });
                });
        }
    }
    function Qn() {
        var t = w - w / 1.8;
        r.on("click", ".section-down-arrow, .scroll-down-wrap > .minimal-arrow", function () {
            if (e(this).parents(".nectar-box-roll").length > 0) return !1;
            var a = e(this).parents("#page-header-bg"),
                n = a.height(),
                i = 0 == a.parents(".first-section").length || e('body[data-transparent-header="false"]').length > 0 ? a.offset().top : 0,
                o = f.length > 0 && s.width() > 1e3 ? f.height() : 0,
                l = e('body[data-header-format="left-header"]').length > 0 ? 0 : e("#header-space").height(),
                h = 0;
            if ((e("body.material").length > 0 && c.length > 0 && (h = c.height()), 0 == e('body[data-permanent-transparent="1"]').length))
                if (r.hasClass("mobile")) Pe((e('#header-outer[data-mobile-fixed="1"]').length > 0 ? parseInt(n) - l + parseInt(a.offset().top) + 2 : parseInt(n) + parseInt(a.offset().top) + 2) - 2 * o, 700, "easeInOutQuint");
                else if (e('body[data-hhun="1"]').length > 0 && 0 == e('#header-outer[data-remove-fixed="1"]').length) Pe(parseInt(n) + i + 2 - 2 * o, 700, "easeInOutQuint");
                else {
                    var u = e('#header-outer[data-header-resize="0"]').length > 0 ? 0 : parseInt(y) + 2 * t;
                    if ((e('#header-outer[data-remove-fixed="1"]').length > 0 && ((l = 0), (i = 0)), 0 == e("body.mobile").length && e('#header-outer[data-condense="true"]').length > 0)) {
                        var p = e('#header-outer[data-format="centered-menu-bottom-bar"] header#top .span_9');
                        l = d.height() - (parseInt(p.position().top) - parseInt(e("#header-outer #logo").css("margin-top"))) - parseInt(oe.secondaryHeaderHeight);
                    }
                    Pe(parseInt(n - l) + u + 3 + i + h, 700, "easeInOutQuint");
                }
            else Pe(parseInt(n) + parseInt(a.offset().top) + 2 - 2 * o, 700, "easeInOutQuint");
            return !1;
        });
    }
    function Zn() {
        e(".nectar-liquid-bg").removeClass("animated-in");
        for (var t = 0; t < V.length; t++)
            "displace-filter-fade" == V[t].animationType &&
                e(V[t].canvasContainer).parents(".fp-section.active").length > 0 &&
                (0 == e(V[t].canvasContainer).find(".image-added-to-stage").length && V[t].imgContainer.addChild(V[t].bg), e(V[t].canvasContainer).find(".nectar-liquid-bg").addClass("image-added-to-stage"), V[t].animateProps(V[t]));
    }
    function Un() {
        if (e("#nectar_fullscreen_rows").length > 0 && e().fullpage) {
            ae = t.vc_iframe ? ".vc_element.vc_vc_row.active " : ".wpb_row.active ";
            var a = e("#nectar_fullscreen_rows[data-mobile-disable]").length > 0 ? e("#nectar_fullscreen_rows").attr("data-mobile-disable") : "off";
            oe.usingMobileBrowser || (a = "off"), "on" != a ? (ne = !0) : (ae = ""), (re = new NectarFullScreenRows(Ra, N, Zn, oe, Rt, Q, S));
        }
    }
    function Gn() {
        oe.usingMobileBrowser && r.addClass("using-mobile-browser"),
            t.navigator.userAgent.indexOf("Edge/") > 0 && r.addClass("msie"),
            0 == e("html.js").length && e("html").removeClass("no-js").addClass("js"),
            e("code").find("br").remove(),
            e(".wpcf7-form p:has(input[type=submit])").css("padding-bottom", "0px"),
            e(".full-width-content .wpcf7-submit").on("click", function () {
                setTimeout(function () {
                    Ot();
                }, 1e3),
                    setTimeout(function () {
                        Ot();
                    }, 2e3);
            }),
            e(".gform_body").on("click", function () {
                setTimeout(function () {
                    Ot();
                }, 200);
            }),
            e(".pum.pum-theme-salient-page-builder-optimized button.pum-close").wrapInner("<span />"),
            e("#nectar_fullscreen_rows").length > 0 &&
                e(".pum-container .pum-content > .wpb_row .full-page-inner > .container > .span_12").length > 0 &&
                e(".pum-container .pum-content > .wpb_row .full-page-inner > .container > .span_12").unwrap(),
            e(".single .blog_next_prev_buttons").length > 0 && e(".container-wrap").css("padding-bottom", 0),
            e(".full-width-section").each(function () {
                e(this).find("> .span_12 > div.col_last").last().css("margin-bottom", "0");
            }),
            e(".full-width-content .col.boxed").removeClass("boxed"),
            e(".wpb_column.neg-marg").parents(".wpb_row:not(.inner_row):not(.zindex-set)").css("z-index", "110"),
            e(".wpb_row.legacy").each(function () {
                e(this).find(".wpb_column").length > 0 && e(this).removeClass("legacy");
            });
    }
    function Jn() {
        e(".wpb_row").each(function () {
            void 0 !== e(this).find(".span_12").offset() &&
                e(this)
                    .find('[class*="vc_col-"]')
                    .each(function () {
                        var t = e(this).parents(".span_12").offset().left;
                        e(this).removeClass("no-left-margin"), e(this).offset().left < t + 27 ? e(this).addClass("no-left-margin") : e(this).removeClass("no-left-margin");
                    });
        });
    }
    function Kn() {
        var a = oe.winW,
            n = oe.winH,
            i = 0;
        r.is('[data-flex-cols="true"]') ||
            (e('[class*="vc_col-xs-"], [class*="vc_col-md-"], [class*="vc_col-lg-"]').length > 0 &&
                (Jn(),
                oe.usingMobileBrowser
                    ? (t.addEventListener("orientationchange", function () {
                          i = 1;
                      }),
                      s.on("resize", function () {
                          ((s.width() != a && s.height != n) || 1 === i) && (Jn(), (a = oe.winW), (n = oe.winH), (i = 0));
                      }))
                    : s.on("resize", Jn)));
    }
    function ei() {
        e('body[data-fancy-form-rcs="1"]').length > 0 &&
            0 == e("#wcfm-main-content").length &&
            (e("select:not(.comment-form-rating #rating)").each(function () {
                var t;
                e(this).parents(".wpcf7-form-control-wrap").length > 0
                    ? 1 == (t = e(this).parents(".wpcf7-form-control-wrap").find(".select2-container").length > 0 ? e(e(this).prev(".select2-container")) : e(this)).parents(".wpcf7-form-control-wrap").parent().find("label").length
                        ? t.parents(".wpcf7-form-control-wrap").parent().wrapInner('<div class="fancy-select-wrap" />')
                        : t.wrap('<div class="fancy-select-wrap" />')
                    : ((t = e(this).prev(".select2-container").length > 0 ? e(this).prev(".select2-container") : e(this)),
                      0 == e(this).parents("#buddypress").length &&
                          0 == e(this).parents(".widget_categories").length &&
                          (1 == t.prev("label").length
                              ? t.prev("label").andSelf().wrapAll('<div class="fancy-select-wrap" />')
                              : 1 == t.next("label").length
                              ? t.next("label").andSelf().wrapAll('<div class="fancy-select-wrap" />')
                              : t.wrap('<div class="fancy-select-wrap" />')));
            }),
            e("select:not(.state_select):not(.country_select):not(.comment-form-rating #rating):not(#tribe-bar-form select):not(.woocommerce-currency-switcher):not(.nectar-custom-product-attr select)").each(function () {
                var a = oe.winW > 690 ? 7 : 200;
                if (((e(this).hasClass("skip-select2-search") || e(this).parents(".skip-select2-search").length > 0) && (a = 1e3), 0 == e(this).parents("#buddypress").length)) {
                    var n = { minimumResultsForSearch: a, width: "100%" };
                    ("underline" == (t.nectarOptions && t.nectarOptions.woo_product_variable_select ? t.nectarOptions.woo_product_variable_select : "default") || e(this).parents(".woocommerce-ordering").length > 0) &&
                        (n = { minimumResultsForSearch: a, dropdownParent: e(this).parent(), dropdownAutoWidth: !0 }),
                        e(this).select2(n);
                }
            }));
    }
    function ti() {
        ((-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")) || navigator.userAgent.match(/(iPod|iPhone|iPad)/)) &&
            (t.onpageshow = function (t) {
                t.persisted &&
                    (e(".nectar-video-wrap, .nectar-slider-wrap .swiper-slide .video-wrap").each(function () {
                        e(this).find("video").length > 0 && e(this).find("video")[0].play();
                    }),
                    e("body.material-ocm-open").length > 0
                        ? (e("body > .slide_out_area_close").addClass("non-human-allowed").trigger("click"),
                          setTimeout(function () {
                              e("body > .slide_out_area_close").removeClass("non-human-allowed");
                          }, 100))
                        : e("#slide-out-widget-area.slide-out-from-right-hover.open").length > 0 && navigator.userAgent.match(/(iPod|iPhone|iPad)/)
                        ? $a()
                        : (e("#slide-out-widget-area.fullscreen.open").length > 0 || e("#slide-out-widget-area.fullscreen-alt.open").length > 0 || e("#slide-out-widget-area.slide-out-from-right.open").length > 0) &&
                          (e("#slide-out-widget-area .slide_out_area_close").addClass("non-human-allowed"),
                          e(".slide-out-widget-area-toggle:not(.std-menu) a.open").addClass("non-human-allowed").trigger("click"),
                          setTimeout(function () {
                              e("#slide-out-widget-area .slide_out_area_close").removeClass("non-human-allowed");
                          }, 100)));
            });
    }
    function ai() {
        e(".wpb_row").removeClass("only-ns"),
            e('.nectar-slider-wrap[data-full-width="true"], .page-submenu, .portfolio-items[data-col-num="elastic"]:not(.fullwidth-constrained), .blog-fullwidth-wrap').parents(".wpb_row").addClass("only-ns"),
            e("body.vc_editor.compose-mode .wpb_row .vc_vc_column > .wpb_column > .vc_column-inner").each(function () {
                e(this).find("> .vc_element-container > div").length > 0 &&
                    (e(this).find("> .vc_element-container > div:first-child").is(".vc_vc_row_inner")
                        ? e(this).find("> .vc_element-container > div:first-child").addClass("first-inner-row-el")
                        : e(this).find("> .vc_element-container > div:first-child").removeClass("first-inner-row-el"));
            }),
            e("body.vc_editor.compose-mode .vc_row.inner_row").each(function () {
                e(this).hasClass("row_position_absolute") ? e(this).parent().css({ position: "static", "min-height": "0" }) : e(this).parent().css({ position: "", "min-height": "" });
            });
    }
    function ni() {
        e('.vc_element > .wpb_column[class*="padding-"][class*="-percent"]').each(function () {
            var t = 4,
                a = this.className.match(/padding-\d+/);
            if ((a && (t = (t = a[0].match(/\d+/)) ? t[0] / 100 : 0), t)) {
                var n = e(this).parents(".span_12").width();
                e(this).is('[data-padding-pos="all"]')
                    ? e(this).css("padding", n * t)
                    : e(this).is('[data-padding-pos="top"]')
                    ? e(this).css("padding-top", n * t)
                    : e(this).is('[data-padding-pos="bottom"]')
                    ? e(this).css("padding-bottom", n * t)
                    : e(this).is('[data-padding-pos="left"]')
                    ? e(this).css("padding-left", n * t)
                    : e(this).is('[data-padding-pos="right"]')
                    ? e(this).css("padding-right", n * t)
                    : e(this).is('[data-padding-pos="top-bottom"]')
                    ? e(this).css({ "padding-top": n * t, "padding-bottom": n * t })
                    : e(this).is('[data-padding-pos="top-right"]')
                    ? e(this).css({ "padding-top": n * t, "padding-right": n * t })
                    : e(this).is('[data-padding-pos="bottom-right"]')
                    ? e(this).css({ "padding-right": n * t, "padding-bottom": n * t })
                    : e(this).is('[data-padding-pos="bottom-left"]')
                    ? e(this).css({ "padding-left": n * t, "padding-bottom": n * t })
                    : e(this).is('[data-padding-pos="left-right"]') && e(this).css({ "padding-left": n * t, "padding-right": n * t });
            }
        }),
            e('.wpb_row[class*="vc_custom_"]').each(function () {
                e(this).parent().addClass("no-bottom-margin");
            });
    }
    function ii() {
        setTimeout(function () {
            e("body.compose-mode").length > 0 && e(".container-wrap").addClass("visible-editor-controls"), oe.usingFrontEndEditor && (ai(), r.is('[data-flex-cols="true"]') || (ni(), s.on("smartresize", ni)));
        }, 200),
            s.on("vc_reload", function () {
                if (
                    (ai(),
                    pt(),
                    ct(),
                    _e(),
                    $t(),
                    pe(),
                    rt(),
                    St(),
                    mt(),
                    En(),
                    la(),
                    Me(),
                    Zt(),
                    xn(),
                    On(),
                    At(),
                    Nt(),
                    e(".carousel").length > 0 && ($e(), Se(), He()),
                    e(".owl-carousel").length > 0 &&
                        (e(".owl-carousel").each(function () {
                            e(this).trigger("destroy.owl.carousel").removeClass("owl-loaded"),
                                e(this).find(".owl-stage-outer .owl-stage > *").unwrap(),
                                e(this).find(".owl-stage-outer > *").unwrap(),
                                e(this).find(".owl-item > *").unwrap(),
                                e(this).find(".owl-dots").remove(),
                                e(this).find(".owl-nav").remove();
                        }),
                        Ee()),
                    e(".nectar_cascading_images").length > 0 &&
                        imagesLoaded(e(".nectar_cascading_images"), function () {
                            Wt();
                        }),
                    wt(),
                    It(),
                    $n(),
                    zt(),
                    M.length > 0)
                )
                    for (var a = 0; a < M.length; a++) M[a].reloadCells(), M[a].off("scroll.flickity"), M[a].off("dragStart.flickity"), M[a].off("dragEnd.flickity");
                if (
                    (me(),
                    setTimeout(function () {
                        if ((ve(), M.length > 0)) for (var e = 0; e < M.length; e++) M[e].reloadCells(), M[e].resize();
                    }, 100),
                    R.length > 0)
                )
                    for (a = 0; a < R.length; a++) R[a].flickity("reloadCells"), R[a].off("scroll.flickity"), R[a].off("dragStart.flickity"), R[a].off("dragEnd.flickity");
                setTimeout(function () {
                    if ((e(".nectar-woo-flickity").length > 0 && Oe(), R.length > 0)) for (var t = 0; t < R.length; t++) R[t].flickity("reloadCells"), R[t].flickity("resize");
                }, 100),
                    aa();
                for (a = 0; a < X.length; a++)
                    ("multiple_visible" != X[a].type && "multiple_visible_minimal" != X[a].type) || (X[a].flickityEl.flickity("reloadCells"), X[a].flickityEl.off("select.flickity"), aa(), X[a].flickityEl.resize()),
                        X[a].testimonialSliderHeight();
                if ((na(), ta(), oa(), Ge(), Vt(), ht(), Ba(), da(), ca(), Ot(), setTimeout(Ot, 1e3), pa(), vn(), s.off("scroll.parallaxSections").off("resize.parallaxSections"), Tt(), Xn(), Bn(), H.length > 0))
                    for (a = 0; a < H.length; a++) H[a].portfolioAccentColor();
                if (
                    (In(),
                    Sn(),
                    setTimeout(function () {
                        if (e(".nectar_fullscreen_zoom_recent_projects").length > 0 && P.length > 0) for (var t = 0; t < P.length; t++) P[t].sliderCalcs();
                    }, 300),
                    s.unbind(".infscr"),
                    An(),
                    Ht(),
                    e(".nectar-video-wrap").each(function () {
                        e(this).find("video").length > 0 && e(this).find("video").css("visibility", "visible");
                    }),
                    e(".wpb_column[data-t-w-inherits]").each(function () {
                        e(this).is('[data-t-w-inherits="small_desktop"]') ? e(this).parent().addClass("inherits-s-desktop-col") : e(this).parent().removeClass("inherits-s-desktop-col");
                    }),
                    e("#nectar_fullscreen_rows").length > 0)
                ) {
                    0 == e("#nectar_fullscreen_rows > .vc_element").length && e("#nectar_fullscreen_rows").prepend('<div class="vc_element empty_placeholder" />'),
                        e("#nectar_fullscreen_rows > .vc_element:not(.empty_placeholder)").length > 0 && e("#nectar_fullscreen_rows >.vc_element.empty_placeholder").remove(),
                        e.fn.fullpage.destroy("all"),
                        Un();
                    var n = [{ el: "", offset: 0 }];
                    e("#nectar_fullscreen_rows > div.vc_element").each(function (t) {
                        n[t] = { el: e(this), offset: e(this).offset().top };
                    }),
                        1 === e("#nectar_fullscreen_rows > div.vc_element").length && e("#nectar_fullscreen_rows").css({ transform: "translate3d(0,0,0)" }),
                        r.scrollTo(0, 0);
                } else e('body .main-content > .row > .vc_element:first > .wpb_row[class*="full-width-"]').length > 0 || e('body .main-content > .row > .vc_element:first .nectar-slider-wrap[data-full-width="true"]').length > 0 ? e(".container-wrap").css({ "padding-top": "0", "margin-top": "0" }) : e(".container-wrap").css({ "padding-top": "40px" });
                (S = []),
                    e(".svg-icon-holder").removeClass("animated-in").removeClass("bound"),
                    e(".vc_nectar_gmap").length > 0 &&
                        setTimeout(function () {
                            "object" == typeof google && "object" == typeof google.maps
                                ? t.mapAPI_Loaded()
                                : t.nectarLove.mapApiKey.length > 0 && e.getScript("https://maps.google.com/maps/api/js?sensor=false&key=" + t.nectarLove.mapApiKey + "&callback=mapAPI_Loaded");
                        }, 100),
                    Dn(),
                    void 0 !== t.Waypoint && (Waypoint.destroyAll(), Ra());
            });
    }
    function si() {
        var a = !1;
        if (
            (e('body[data-ajax-transitions="true"]').length > 0 && e('#ajax-loading-screen[data-disable-mobile="1"]').length > 0 && oe.winW < 1e3 && (a = !0),
            e('body[data-ajax-transitions="true"]').length > 0 && e('#ajax-loading-screen[data-method="standard"]').length > 0 && 0 == a)
        ) {
            if (
                (e("html").addClass("page-trans-loaded"),
                e('#ajax-loading-screen[data-effect="standard"]').length > 0
                    ? (0 == e(".nectar-particles").length &&
                          (p.transition({ opacity: 0 }, 500, function () {
                              e(this).css({ display: "none" });
                          }),
                          e("#ajax-loading-screen .loading-icon").transition({ opacity: 0 }, 500)),
                      0 == e(".nectar-box-roll").length &&
                          setTimeout(function () {
                              Ra();
                          }, 550))
                    : (e('#ajax-loading-screen[data-effect*="horizontal_swipe"]').length > 0 &&
                          setTimeout(function () {
                              p.addClass("loaded");
                          }, 60),
                      0 == e('#page-header-wrap #page-header-bg[data-animate-in-effect="zoom-out"] .nectar-video-wrap').length &&
                          setTimeout(function () {
                              e("#ajax-loading-screen:not(.loaded)").addClass("loaded"),
                                  setTimeout(function () {
                                      p.addClass("hidden");
                                  }, 1e3);
                          }, 150),
                      0 == e(".nectar-box-roll").length && e('#ajax-loading-screen[data-effect*="horizontal_swipe"]').length > 0
                          ? setTimeout(function () {
                                Ra();
                            }, 750)
                          : 0 == e(".nectar-box-roll").length &&
                            setTimeout(function () {
                                Ra();
                            }, 350)),
                (-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")) || navigator.userAgent.match(/(iPod|iPhone|iPad)/)
                    ? ((t.onunload = function () {
                          e("#ajax-loading-screen")
                              .stop()
                              .transition({ opacity: 0 }, 800, function () {
                                  e(this).css({ display: "none" });
                              }),
                              e("#ajax-loading-screen .loading-icon").transition({ opacity: 0 }, 600);
                      }),
                      (t.onpageshow = function (t) {
                          t.persisted &&
                              (e("#ajax-loading-screen")
                                  .stop()
                                  .transition({ opacity: 0 }, 800, function () {
                                      e(this).css({ display: "none" });
                                  }),
                              e("#ajax-loading-screen .loading-icon").transition({ opacity: 0 }, 600));
                      }))
                    : -1 != navigator.userAgent.indexOf("Firefox") && (t.onunload = function () {}),
                e(".portfolio-loading, .nectar-slider-loading .loading-icon").remove(),
                0 == e('#ajax-loading-screen[data-disable-fade-on-click="1"]').length && 0 == e('body.using-mobile-browser #ajax-loading-screen[data-method="standard"][data-disable-mobile="1"]').length)
            ) {
                var n = !1;
                e('a[href^="mailto"], a[href^="tel"], .woocommerce-order-downloads a[class*="downloads-file"], .wpdm-cta.download-link a[data-downloadurl], .nectar-ignore-beforeunload a').on("click", function () {
                    n = !0;
                }),
                    t.addEventListener("beforeunload", function () {
                        n ||
                            (p.addClass("set-to-fade"),
                            e('#ajax-loading-screen[data-effect*="horizontal_swipe"]').length > 0
                                ? (p.removeClass("loaded"),
                                  p.addClass("in-from-right"),
                                  setTimeout(function () {
                                      p.addClass("loaded");
                                  }, 30))
                                : e('#ajax-loading-screen[data-effect="center_mask_reveal"]').length > 0
                                ? p.css("opacity", "0").css("display", "block").transition({ opacity: "1" }, 450)
                                : p.show().transition({ opacity: "1" }, 450)),
                            (n = !1);
                    });
            }
        } else 1 == a && p.css({ opacity: "0", display: "none" }).addClass("loaded").addClass("hidden"), 0 != e(".nectar-box-roll").length || oe.usingFrontEndEditor || Ra();
    }
    (mn.prototype.events = function () {
        var a = this;
        e(t).on("smartresize", this.resize.bind(this)),
            t.addEventListener("orientationchange", function () {
                this.setTimeout(function () {
                    a.orientationChange();
                }, 100);
            });
    }),
        (mn.prototype.resize = function () {
            oe.usingMobileBrowser || ((this.storedWinH = oe.winH), this.calculate());
        }),
        (mn.prototype.calculate = function () {
            if (1 == de.materialOffCanvasOpen) return !0;
            (this.offsetTop = this.$el.offset().top),
                (this.offsetTop < this.storedWinH && this.$el.hasClass("top-level") && !oe.usingFrontEndEditor) || (this.$el.css("min-height", this.storedWinH), this.$el.find("> .col.span_12").css("min-height", this.storedWinH));
        }),
        (mn.prototype.orientationChange = function () {
            oe.usingMobileBrowser && ((this.storedWinH = oe.winH), this.calculate());
        }),
        (zn.prototype.resizeEvent = function () {
            (this.initialX = this.$el.width() / 2), (this.initialY = this.$el.height() / 2);
        }),
        (zn.prototype.mouseEvents = function () {
            var a = this;
            a.$el.on("mouseenter", function (e) {
                (a.activeFollow = !0),
                    (a.elX = e.offsetX),
                    (a.elY = e.offsetY),
                    (a.lastScroll = 0),
                    clearInterval(a.percentageInterval),
                    (a.percentageInterval = setInterval(function () {
                        a.percentage < 0.16 ? (a.percentage += 0.008) : clearInterval(a.percentageInterval);
                    }, 30));
            }),
                a.$el.on("mouseleave", function () {
                    (a.activeFollow = !1), (a.lastScroll = 0), clearInterval(a.percentageInterval), (a.percentage = 0.03);
                }),
                a.$el.on("mousemove", function (e) {
                    (a.elX = e.offsetX), (a.elY = e.offsetY), (a.lastScroll = 0);
                }),
                e(t).on("scroll", function () {
                    1 == a.activeFollow && 0 == a.lastScroll && (a.lastScroll = oe.scrollTop);
                });
        }),
        (zn.prototype.rafLoop = function () {
            1 == this.activeFollow
                ? ((this.scrollAdjust = this.lastScroll > 0 ? oe.scrollTop - this.lastScroll : 0),
                  (this.lastY = Fe(this.lastY, this.elY + this.scrollAdjust, this.percentage)),
                  (this.lastX = Fe(this.lastX, this.elX, this.percentage)),
                  (this.lastY2 = Fe(this.lastY2, this.elY, this.percentage)),
                  (this.innerLastX = Fe(this.innerLastX, parseInt(this.elX) - parseInt(this.lastX), this.percentage) / 1.7),
                  (this.innerLastY = Fe(this.innerLastY, parseInt(this.elY) - parseInt(this.lastY2), this.percentage) / 1.7))
                : ((this.lastY = Fe(this.lastY, this.initialY, 0.055)), (this.lastX = Fe(this.lastX, this.initialX, 0.055)), (this.innerLastX = 0), (this.innerLastY = 0)),
                (this.$iconEl[0].style.transform = "translateX(" + this.lastX + "px) translateY(" + this.lastY + "px)"),
                this.$innerIconEl.length > 0 && (this.$innerIconEl[0].style.transform = "translateX(" + We(this.innerLastX, 14, -14) + "px) translateY(" + We(this.innerLastY, 14, -14) + "px)"),
                requestAnimationFrame(this.rafLoop.bind(this));
        }),
        jQuery(a).ready(function (e) {
            oe.init(),
                Pa(),
                Un(),
                Nt(),
                xe(),
                Ua(),
                Ga(),
                Ka(),
                en(),
                hn(),
                pn(),
                Va(),
                pt(),
                Kn(),
                wt(),
                It(),
                Ie(),
                bt(),
                yt(),
                Tt(),
                $t(),
                zt(),
                Ot(),
                la(),
                bn(),
                vn(),
                Ge(),
                ha(),
                da(),
                ca(),
                pa(),
                fa(),
                ga(),
                ma(),
                ya(),
                Ma(),
                Ha(),
                La(),
                gn(),
                Qa(),
                ei(),
                An(),
                Fn(),
                jn(),
                Rn(),
                Qn(),
                Gn(),
                ti(),
                ii(),
                si(),
                s.off("smartresize.srInit"),
                s.on("smartresize.srInit", ce),
                s.off("resize.srInit"),
                s.on("resize.srInit", ue),
                t.addEventListener("orientationchange", he),
                "complete" === a.readyState &&
                    setTimeout(function () {
                        s.trigger("load");
                    }, 30),
                s.on("load", function () {
                    0 == e(t).scrollTop() && un(), e("video").css("visibility", "visible"), Yn(), Ot(), $t(), ua();
                });
        });
})(window.jQuery, window, document);

(function (d) {
    var m = "left",
        l = "right",
        c = "up",
        s = "down",
        b = "in",
        t = "out",
        j = "none",
        o = "auto",
        i = "swipe",
        p = "pinch",
        u = "tap",
        x = "horizontal",
        q = "vertical",
        g = "all",
        e = "start",
        h = "move",
        f = "end",
        n = "cancel",
        a = "ontouchstart" in window,
        v = "TouchSwipe";
    var k = {
        fingers: 1,
        threshold: 75,
        cancelThreshold: 25,
        pinchThreshold: 20,
        maxTimeThreshold: null,
        fingerReleaseThreshold: 250,
        swipe: null,
        swipeLeft: null,
        swipeRight: null,
        swipeUp: null,
        swipeDown: null,
        swipeStatus: null,
        pinchIn: null,
        pinchOut: null,
        pinchStatus: null,
        click: null,
        tap: null,
        triggerOnTouchEnd: true,
        triggerOnTouchLeave: false,
        allowPageScroll: "auto",
        fallbackToMouseEvents: true,
        excludedElements: "button, input, select, textarea, a, .noSwipe",
    };
    d.fn.swipe = function (A) {
        var z = d(this),
            y = z.data(v);
        if (y && typeof A === "string") {
            if (y[A]) {
                return y[A].apply(this, Array.prototype.slice.call(arguments, 1));
            } else {
                d.error("Method " + A + " does not exist on jQuery.swipe");
            }
        } else {
            if (!y && (typeof A === "object" || !A)) {
                return r.apply(this, arguments);
            }
        }
        return z;
    };
    d.fn.swipe.defaults = k;
    d.fn.swipe.phases = { PHASE_START: e, PHASE_MOVE: h, PHASE_END: f, PHASE_CANCEL: n };
    d.fn.swipe.directions = { LEFT: m, RIGHT: l, UP: c, DOWN: s, IN: b, OUT: t };
    d.fn.swipe.pageScroll = { NONE: j, HORIZONTAL: x, VERTICAL: q, AUTO: o };
    d.fn.swipe.fingers = { ONE: 1, TWO: 2, THREE: 3, ALL: g };
    function r(y) {
        if (y && y.allowPageScroll === undefined && (y.swipe !== undefined || y.swipeStatus !== undefined)) {
            y.allowPageScroll = j;
        }
        if (y.click !== undefined && y.tap === undefined) {
            y.tap = y.click;
        }
        if (!y) {
            y = {};
        }
        y = d.extend({}, d.fn.swipe.defaults, y);
        return this.each(function () {
            var A = d(this);
            var z = A.data(v);
            if (!z) {
                z = new w(this, y);
                A.data(v, z);
            }
        });
    }
    function w(S, ag) {
        var aJ = a || !ag.fallbackToMouseEvents,
            az = aJ ? "touchstart" : "mousedown",
            U = aJ ? "touchmove" : "mousemove",
            av = aJ ? "touchend" : "mouseup",
            D = aJ ? null : "mouseleave",
            R = "touchcancel";
        var ad = 0,
            N = null,
            ah = 0,
            aF = 0,
            A = 0,
            aj = 1,
            aA = 0,
            aN = 0,
            Z = null;
        var H = d(S);
        var O = "start";
        var aI = 0;
        var ai = null;
        var I = 0,
            Y = 0,
            aD = 0,
            aP = 0;
        try {
            H.bind(az, at);
            H.bind(R, L);
        } catch (aG) {
            d.error("events not supported " + az + "," + R + " on jQuery.swipe");
        }
        this.enable = function () {
            H.bind(az, at);
            H.bind(R, L);
            return H;
        };
        this.disable = function () {
            Q();
            return H;
        };
        this.destroy = function () {
            Q();
            H.data(v, null);
            return H;
        };
        this.option = function (aR, aQ) {
            if (ag[aR] !== undefined) {
                if (aQ === undefined) {
                    return ag[aR];
                } else {
                    ag[aR] = aQ;
                }
            } else {
                d.error("Option " + aR + " does not exist on jQuery.swipe.options");
            }
        };
        function at(aS) {
            if (X()) {
                return;
            }
            if (d(aS.target).closest(ag.excludedElements, H).length > 0) {
                return;
            }
            var aT = aS.originalEvent ? aS.originalEvent : aS;
            var aR,
                aQ = a ? aT.touches[0] : aT;
            O = e;
            if (a) {
                aI = aT.touches.length;
            } else {
                aS.preventDefault();
            }
            ad = 0;
            N = null;
            aN = null;
            ah = 0;
            aF = 0;
            A = 0;
            aj = 1;
            aA = 0;
            ai = T();
            Z = aE();
            z();
            if (!a || aI === ag.fingers || ag.fingers === g || ap()) {
                aO(0, aQ);
                I = B();
                if (aI == 2) {
                    aO(1, aT.touches[1]);
                    aF = A = aa(ai[0].start, ai[1].start);
                }
                if (ag.swipeStatus || ag.pinchStatus) {
                    aR = aH(aT, O);
                }
            } else {
                aR = false;
            }
            if (aR === false) {
                O = n;
                aH(aT, O);
                return aR;
            } else {
                ak(true);
            }
        }
        function P(aT) {
            var aW = aT.originalEvent ? aT.originalEvent : aT;
            if (O === f || O === n || af()) {
                return;
            }
            var aS,
                aR = a ? aW.touches[0] : aW;
            var aU = V(aR);
            Y = B();
            if (a) {
                aI = aW.touches.length;
            }
            O = h;
            if (aI == 2) {
                if (aF == 0) {
                    aO(1, aW.touches[1]);
                    aF = A = aa(ai[0].start, ai[1].start);
                } else {
                    V(aW.touches[1]);
                    A = aa(ai[0].end, ai[1].end);
                    aN = ao(ai[0].end, ai[1].end);
                }
                aj = y(aF, A);
                aA = Math.abs(aF - A);
            }
            if (aI === ag.fingers || ag.fingers === g || !a || ap()) {
                N = ar(aU.start, aU.end);
                C(aT, N);
                ad = G(aU.start, aU.end);
                ah = K();
                aK(N, ad);
                if (ag.swipeStatus || ag.pinchStatus) {
                    aS = aH(aW, O);
                }
                if (!ag.triggerOnTouchEnd || ag.triggerOnTouchLeave) {
                    var aQ = true;
                    if (ag.triggerOnTouchLeave) {
                        var aV = au(this);
                        aQ = aC(aU.end, aV);
                    }
                    if (!ag.triggerOnTouchEnd && aQ) {
                        O = aM(h);
                    } else {
                        if (ag.triggerOnTouchLeave && !aQ) {
                            O = aM(f);
                        }
                    }
                    if (O == n || O == f) {
                        aH(aW, O);
                    }
                }
            } else {
                O = n;
                aH(aW, O);
            }
            if (aS === false) {
                O = n;
                aH(aW, O);
            }
        }
        function ab(aS) {
            var aU = aS.originalEvent;
            if (a) {
                if (aU.touches.length > 0) {
                    aw();
                    return true;
                }
            }
            if (af()) {
                aI = aP;
            }
            aS.preventDefault();
            Y = B();
            if (ag.triggerOnTouchEnd || (ag.triggerOnTouchEnd == false && O === h)) {
                O = f;
                var aR = aI === ag.fingers || ag.fingers === g || !a;
                var aQ = ai[0].end.x !== 0;
                var aT = aR && aQ && (an() || aB());
                if (aT) {
                    aH(aU, O);
                } else {
                    O = n;
                    aH(aU, O);
                }
            } else {
                if (!ag.triggerOnTouchEnd && ay()) {
                    O = f;
                    am(aU, O, u);
                } else {
                    if (O === h) {
                        O = n;
                        aH(aU, O);
                    }
                }
            }
            ak(false);
        }
        function L() {
            aI = 0;
            Y = 0;
            I = 0;
            aF = 0;
            A = 0;
            aj = 1;
            z();
            ak(false);
        }
        function W(aQ) {
            var aR = aQ.originalEvent;
            if (ag.triggerOnTouchLeave) {
                O = aM(f);
                aH(aR, O);
            }
        }
        function Q() {
            H.unbind(az, at);
            H.unbind(R, L);
            H.unbind(U, P);
            H.unbind(av, ab);
            if (D) {
                H.unbind(D, W);
            }
            ak(false);
        }
        function aM(aT) {
            var aS = aT;
            var aR = aq();
            var aQ = ae();
            if (!aR) {
                aS = n;
            } else {
                if (aQ && aT == h && (!ag.triggerOnTouchEnd || ag.triggerOnTouchLeave)) {
                    aS = f;
                } else {
                    if (!aQ && aT == f && ag.triggerOnTouchLeave) {
                        aS = n;
                    }
                }
            }
            return aS;
        }
        function aH(aS, aQ) {
            var aR = undefined;
            if (ac()) {
                aR = am(aS, aQ, i);
            }
            if (ap() && aR !== false) {
                aR = am(aS, aQ, p);
            }
            if (ay() && aR !== false) {
                aR = am(aS, aQ, u);
            }
            if (aQ === n) {
                L(aS);
            }
            if (aQ === f) {
                if (a) {
                    if (aS.touches.length == 0) {
                        L(aS);
                    }
                } else {
                    L(aS);
                }
            }
            return aR;
        }
        function am(aT, aQ, aS) {
            var aR = undefined;
            if (aS == i) {
                H.trigger("swipeStatus", [aQ, N || null, ad || 0, ah || 0, aI]);
                if (ag.swipeStatus) {
                    aR = ag.swipeStatus.call(H, aT, aQ, N || null, ad || 0, ah || 0, aI);
                    if (aR === false) {
                        return false;
                    }
                }
                if (aQ == f && aB()) {
                    H.trigger("swipe", [N, ad, ah, aI]);
                    if (ag.swipe) {
                        aR = ag.swipe.call(H, aT, N, ad, ah, aI);
                        if (aR === false) {
                            return false;
                        }
                    }
                    switch (N) {
                        case m:
                            H.trigger("swipeLeft", [N, ad, ah, aI]);
                            if (ag.swipeLeft) {
                                aR = ag.swipeLeft.call(H, aT, N, ad, ah, aI);
                            }
                            break;
                        case l:
                            H.trigger("swipeRight", [N, ad, ah, aI]);
                            if (ag.swipeRight) {
                                aR = ag.swipeRight.call(H, aT, N, ad, ah, aI);
                            }
                            break;
                        case c:
                            H.trigger("swipeUp", [N, ad, ah, aI]);
                            if (ag.swipeUp) {
                                aR = ag.swipeUp.call(H, aT, N, ad, ah, aI);
                            }
                            break;
                        case s:
                            H.trigger("swipeDown", [N, ad, ah, aI]);
                            if (ag.swipeDown) {
                                aR = ag.swipeDown.call(H, aT, N, ad, ah, aI);
                            }
                            break;
                    }
                }
            }
            if (aS == p) {
                H.trigger("pinchStatus", [aQ, aN || null, aA || 0, ah || 0, aI, aj]);
                if (ag.pinchStatus) {
                    aR = ag.pinchStatus.call(H, aT, aQ, aN || null, aA || 0, ah || 0, aI, aj);
                    if (aR === false) {
                        return false;
                    }
                }
                if (aQ == f && an()) {
                    switch (aN) {
                        case b:
                            H.trigger("pinchIn", [aN || null, aA || 0, ah || 0, aI, aj]);
                            if (ag.pinchIn) {
                                aR = ag.pinchIn.call(H, aT, aN || null, aA || 0, ah || 0, aI, aj);
                            }
                            break;
                        case t:
                            H.trigger("pinchOut", [aN || null, aA || 0, ah || 0, aI, aj]);
                            if (ag.pinchOut) {
                                aR = ag.pinchOut.call(H, aT, aN || null, aA || 0, ah || 0, aI, aj);
                            }
                            break;
                    }
                }
            }
            if (aS == u) {
                if (aQ === n || aQ === f) {
                    if ((aI === 1 || !a) && (isNaN(ad) || ad === 0)) {
                        H.trigger("tap", [aT.target]);
                        if (ag.tap) {
                            aR = ag.tap.call(H, aT, aT.target);
                        }
                    }
                }
            }
            return aR;
        }
        function ae() {
            var aQ = true;
            if (ag.threshold !== null) {
                aQ = ad >= ag.threshold;
            }
            if (aQ && ag.cancelThreshold !== null) {
                aQ = M(N) - ad < ag.cancelThreshold;
            }
            return aQ;
        }
        function al() {
            if (ag.pinchThreshold !== null) {
                return aA >= ag.pinchThreshold;
            }
            return true;
        }
        function aq() {
            var aQ;
            if (ag.maxTimeThreshold) {
                if (ah >= ag.maxTimeThreshold) {
                    aQ = false;
                } else {
                    aQ = true;
                }
            } else {
                aQ = true;
            }
            return aQ;
        }
        function C(aQ, aR) {
            if (ag.allowPageScroll === j || ap()) {
                aQ.preventDefault();
            } else {
                var aS = ag.allowPageScroll === o;
                switch (aR) {
                    case m:
                        if ((ag.swipeLeft && aS) || (!aS && ag.allowPageScroll != x)) {
                            aQ.preventDefault();
                        }
                        break;
                    case l:
                        if ((ag.swipeRight && aS) || (!aS && ag.allowPageScroll != x)) {
                            aQ.preventDefault();
                        }
                        break;
                    case c:
                        if ((ag.swipeUp && aS) || (!aS && ag.allowPageScroll != q)) {
                            aQ.preventDefault();
                        }
                        break;
                    case s:
                        if ((ag.swipeDown && aS) || (!aS && ag.allowPageScroll != q)) {
                            aQ.preventDefault();
                        }
                        break;
                }
            }
        }
        function an() {
            return al();
        }
        function ap() {
            return !!(ag.pinchStatus || ag.pinchIn || ag.pinchOut);
        }
        function ax() {
            return !!(an() && ap());
        }
        function aB() {
            var aQ = aq();
            var aS = ae();
            var aR = aS && aQ;
            return aR;
        }
        function ac() {
            return !!(ag.swipe || ag.swipeStatus || ag.swipeLeft || ag.swipeRight || ag.swipeUp || ag.swipeDown);
        }
        function E() {
            return !!(aB() && ac());
        }
        function ay() {
            return !!ag.tap;
        }
        function aw() {
            aD = B();
            aP = event.touches.length + 1;
        }
        function z() {
            aD = 0;
            aP = 0;
        }
        function af() {
            var aQ = false;
            if (aD) {
                var aR = B() - aD;
                if (aR <= ag.fingerReleaseThreshold) {
                    aQ = true;
                }
            }
            return aQ;
        }
        function X() {
            return !!(H.data(v + "_intouch") === true);
        }
        function ak(aQ) {
            if (aQ === true) {
                H.bind(U, P);
                H.bind(av, ab);
                if (D) {
                    H.bind(D, W);
                }
            } else {
                H.unbind(U, P, false);
                H.unbind(av, ab, false);
                if (D) {
                    H.unbind(D, W, false);
                }
            }
            H.data(v + "_intouch", aQ === true);
        }
        function aO(aR, aQ) {
            var aS = aQ.identifier !== undefined ? aQ.identifier : 0;
            ai[aR].identifier = aS;
            ai[aR].start.x = ai[aR].end.x = aQ.pageX || aQ.clientX;
            ai[aR].start.y = ai[aR].end.y = aQ.pageY || aQ.clientY;
            return ai[aR];
        }
        function V(aQ) {
            var aS = aQ.identifier !== undefined ? aQ.identifier : 0;
            var aR = J(aS);
            aR.end.x = aQ.pageX || aQ.clientX;
            aR.end.y = aQ.pageY || aQ.clientY;
            return aR;
        }
        function J(aR) {
            for (var aQ = 0; aQ < ai.length; aQ++) {
                if (ai[aQ].identifier == aR) {
                    return ai[aQ];
                }
            }
        }
        function T() {
            var aQ = [];
            for (var aR = 0; aR <= 5; aR++) {
                aQ.push({ start: { x: 0, y: 0 }, end: { x: 0, y: 0 }, identifier: 0 });
            }
            return aQ;
        }
        function aK(aQ, aR) {
            aR = Math.max(aR, M(aQ));
            Z[aQ].distance = aR;
        }
        function M(aQ) {
            return Z[aQ].distance;
        }
        function aE() {
            var aQ = {};
            aQ[m] = aL(m);
            aQ[l] = aL(l);
            aQ[c] = aL(c);
            aQ[s] = aL(s);
            return aQ;
        }
        function aL(aQ) {
            return { direction: aQ, distance: 0 };
        }
        function K() {
            return Y - I;
        }
        function aa(aT, aS) {
            var aR = Math.abs(aT.x - aS.x);
            var aQ = Math.abs(aT.y - aS.y);
            return Math.round(Math.sqrt(aR * aR + aQ * aQ));
        }
        function y(aQ, aR) {
            var aS = (aR / aQ) * 1;
            return aS.toFixed(2);
        }
        function ao() {
            if (aj < 1) {
                return t;
            } else {
                return b;
            }
        }
        function G(aR, aQ) {
            return Math.round(Math.sqrt(Math.pow(aQ.x - aR.x, 2) + Math.pow(aQ.y - aR.y, 2)));
        }
        function F(aT, aR) {
            var aQ = aT.x - aR.x;
            var aV = aR.y - aT.y;
            var aS = Math.atan2(aV, aQ);
            var aU = Math.round((aS * 180) / Math.PI);
            if (aU < 0) {
                aU = 360 - Math.abs(aU);
            }
            return aU;
        }
        function ar(aR, aQ) {
            var aS = F(aR, aQ);
            if (aS <= 45 && aS >= 0) {
                return m;
            } else {
                if (aS <= 360 && aS >= 315) {
                    return m;
                } else {
                    if (aS >= 135 && aS <= 225) {
                        return l;
                    } else {
                        if (aS > 45 && aS < 135) {
                            return s;
                        } else {
                            return c;
                        }
                    }
                }
            }
        }
        function B() {
            var aQ = new Date();
            return aQ.getTime();
        }
        function au(aQ) {
            aQ = d(aQ);
            var aS = aQ.offset();
            var aR = { left: aS.left, right: aS.left + aQ.outerWidth(), top: aS.top, bottom: aS.top + aQ.outerHeight() };
            return aR;
        }
        function aC(aQ, aR) {
            return aQ.x > aR.left && aQ.x < aR.right && aQ.y > aR.top && aQ.y < aR.bottom;
        }
    }
})(jQuery);
/*! This file is auto-generated */
!(function (c, d) {
    "use strict";
    var e = !1,
        n = !1;
    if (d.querySelector) if (c.addEventListener) e = !0;
    if (((c.wp = c.wp || {}), !c.wp.receiveEmbedMessage))
        if (
            ((c.wp.receiveEmbedMessage = function (e) {
                var t = e.data;
                if (t)
                    if (t.secret || t.message || t.value)
                        if (!/[^a-zA-Z0-9]/.test(t.secret)) {
                            for (var r, a, i, s = d.querySelectorAll('iframe[data-secret="' + t.secret + '"]'), n = d.querySelectorAll('blockquote[data-secret="' + t.secret + '"]'), o = 0; o < n.length; o++) n[o].style.display = "none";
                            for (o = 0; o < s.length; o++)
                                if (((r = s[o]), e.source === r.contentWindow)) {
                                    if ((r.removeAttribute("style"), "height" === t.message)) {
                                        if (1e3 < (i = parseInt(t.value, 10))) i = 1e3;
                                        else if (~~i < 200) i = 200;
                                        r.height = i;
                                    }
                                    if ("link" === t.message)
                                        if (((a = d.createElement("a")), (i = d.createElement("a")), (a.href = r.getAttribute("src")), (i.href = t.value), i.host === a.host)) if (d.activeElement === r) c.top.location.href = t.value;
                                }
                        }
            }),
            e)
        )
            c.addEventListener("message", c.wp.receiveEmbedMessage, !1), d.addEventListener("DOMContentLoaded", t, !1), c.addEventListener("load", t, !1);
    function t() {
        if (!n) {
            n = !0;
            for (var e, t, r = -1 !== navigator.appVersion.indexOf("MSIE 10"), a = !!navigator.userAgent.match(/Trident.*rv:11\./), i = d.querySelectorAll("iframe.wp-embedded-content"), s = 0; s < i.length; s++) {
                if (!(e = i[s]).getAttribute("data-secret")) (t = Math.random().toString(36).substr(2, 10)), (e.src += "#?secret=" + t), e.setAttribute("data-secret", t);
                if (r || a) (t = e.cloneNode(!0)).removeAttribute("security"), e.parentNode.replaceChild(t, e);
            }
        }
    }
})(window, document);
/*!
 * WPBakery Page Builder v6.0.0 (https://wpbakery.com)
 * Copyright 2011-2021 Michael M, WPBakery
 * License: Commercial. More details: http://go.wpbakery.com/licensing
 */
(document.documentElement.className += " js_active "),
    (document.documentElement.className += "ontouchstart" in document.documentElement ? " vc_mobile " : " vc_desktop "),
    (function () {
        for (var prefix = ["-webkit-", "-moz-", "-ms-", "-o-", ""], i = 0; i < prefix.length; i++) prefix[i] + "transform" in document.documentElement.style && (document.documentElement.className += " vc_transform ");
    })(),
    (function ($) {
        "function" != typeof window.vc_js &&
            (window.vc_js = function () {
                /* nectar addition */
            }),
            "function" != typeof window.vc_plugin_flexslider &&
                (window.vc_plugin_flexslider = function ($parent) {
                    ($parent ? $parent.find(".wpb_flexslider") : jQuery(".wpb_flexslider")).each(function () {
                        var this_element = jQuery(this),
                            sliderTimeout = 1e3 * parseInt(this_element.attr("data-interval"), 10),
                            sliderFx = this_element.attr("data-flex_fx"),
                            slideshow = 0 == sliderTimeout ? !1 : !0;
                        this_element.is(":visible") &&
                            this_element.flexslider({
                                animation: sliderFx,
                                slideshow: slideshow,
                                slideshowSpeed: sliderTimeout,
                                sliderSpeed: 800,
                                smoothHeight: !0,
                            });
                    });
                }),
            "function" != typeof window.vc_googleplus &&
                (window.vc_googleplus = function () {
                    0 < jQuery(".wpb_googleplus").length &&
                        (function () {
                            var po = document.createElement("script");
                            (po.type = "text/javascript"), (po.async = !0), (po.src = "https://apis.google.com/js/plusone.js");
                            var s = document.getElementsByTagName("script")[0];
                            s.parentNode.insertBefore(po, s);
                        })();
                }),
            "function" != typeof window.vc_pinterest &&
                (window.vc_pinterest = function () {
                    0 < jQuery(".wpb_pinterest").length &&
                        (function () {
                            var po = document.createElement("script");
                            (po.type = "text/javascript"), (po.async = !0), (po.src = "https://assets.pinterest.com/js/pinit.js");
                            var s = document.getElementsByTagName("script")[0];
                            s.parentNode.insertBefore(po, s);
                        })();
                }),
            "function" != typeof window.vc_progress_bar &&
                (window.vc_progress_bar = function () {
                    void 0 !== jQuery.fn.vcwaypoint &&
                        jQuery(".vc_progress_bar").each(function () {
                            var $el = jQuery(this);
                            $el.vcwaypoint(
                                function () {
                                    $el.find(".vc_single_bar").each(function (index) {
                                        var bar = jQuery(this).find(".vc_bar"),
                                            val = bar.data("percentage-value");
                                        setTimeout(function () {
                                            bar.css({
                                                width: val + "%",
                                            });
                                        }, 200 * index);
                                    });
                                },
                                {
                                    offset: "85%",
                                }
                            );
                        });
                }),
            "function" != typeof window.vc_waypoints &&
                (window.vc_waypoints = function () {
                    void 0 !== jQuery.fn.vcwaypoint &&
                        jQuery(".wpb_animate_when_almost_visible:not(.wpb_start_animation)").each(function () {
                            var $el = jQuery(this);
                            $el.vcwaypoint(
                                function () {
                                    $el.addClass("wpb_start_animation animated");
                                },
                                {
                                    offset: "85%",
                                }
                            );
                        });
                }),
            "function" != typeof window.vc_toggleBehaviour &&
                (window.vc_toggleBehaviour = function ($el) {
                    function event(content) {
                        content && content.preventDefault && content.preventDefault();
                        var element = jQuery(this).closest(".vc_toggle"),
                            content = element.find(".vc_toggle_content");
                        element.hasClass("vc_toggle_active")
                            ? content.slideUp({
                                  duration: 300,
                                  complete: function () {
                                      element.removeClass("vc_toggle_active");
                                  },
                              })
                            : content.slideDown({
                                  duration: 300,
                                  complete: function () {
                                      element.addClass("vc_toggle_active");
                                  },
                              });
                    }
                    ($el ? ($el.hasClass("vc_toggle_title") ? $el.unbind("click") : $el.find(".vc_toggle_title").off("click")) : jQuery(".vc_toggle_title").off("click")).on("click", event);
                }),
            "function" != typeof window.vc_tabsBehaviour &&
                (window.vc_tabsBehaviour = function (ver) {
                    var $call, old_version;
                    jQuery.ui &&
                        (($call = ver || jQuery(".wpb_tabs, .wpb_tour")),
                        (ver = jQuery.ui && jQuery.ui.version ? jQuery.ui.version.split(".") : "1.10"),
                        (old_version = 1 === parseInt(ver[0], 10) && parseInt(ver[1], 10) < 9),
                        $call.each(function (index) {
                            var interval = jQuery(this).attr("data-interval"),
                                tabs_array = [],
                                $tabs = jQuery(this)
                                    .find(".wpb_tour_tabs_wrapper")
                                    .tabs({
                                        show: function (event, ui) {
                                            wpb_prepare_tab_content(event, ui);
                                        },
                                        activate: function (event, ui) {
                                            wpb_prepare_tab_content(event, ui);
                                        },
                                    });
                            if (interval && 0 < interval)
                                try {
                                    $tabs.tabs("rotate", 1e3 * interval);
                                } catch (err) {
                                    window.console && window.console.warn && console.warn("tabs behaviours error", err);
                                }
                            jQuery(this)
                                .find(".wpb_tab")
                                .each(function () {
                                    tabs_array.push(this.id);
                                }),
                                jQuery(this)
                                    .find(".wpb_tabs_nav li")
                                    .on("click", function (e) {
                                        return e && e.preventDefault && e.preventDefault(), old_version ? $tabs.tabs("select", jQuery("a", this).attr("href")) : $tabs.tabs("option", "active", jQuery(this).index()), !1;
                                    }),
                                jQuery(this)
                                    .find(".wpb_prev_slide a, .wpb_next_slide a")
                                    .on("click", function (length) {
                                        var index;
                                        length && length.preventDefault && length.preventDefault(),
                                            old_version
                                                ? ((index = $tabs.tabs("option", "selected")),
                                                  jQuery(this).parent().hasClass("wpb_next_slide") ? index++ : index--,
                                                  index < 0 ? (index = $tabs.tabs("length") - 1) : index >= $tabs.tabs("length") && (index = 0),
                                                  $tabs.tabs("select", index))
                                                : ((index = $tabs.tabs("option", "active")),
                                                  (length = $tabs.find(".wpb_tab").length),
                                                  (index = jQuery(this).parent().hasClass("wpb_next_slide") ? (length <= index + 1 ? 0 : index + 1) : index - 1 < 0 ? length - 1 : index - 1),
                                                  $tabs.tabs("option", "active", index));
                                    });
                        }));
                }),
            "function" != typeof window.vc_accordionBehaviour &&
                (window.vc_accordionBehaviour = function () {
                    jQuery(".wpb_accordion").each(function (index) {
                        var $this = jQuery(this),
                            active_tab = ($this.attr("data-interval"), !isNaN(jQuery(this).data("active-tab")) && 0 < parseInt($this.data("active-tab"), 10) && parseInt($this.data("active-tab"), 10) - 1),
                            $tabs = !1 === active_tab || "yes" === $this.data("collapsible"),
                            $tabs = $this.find(".wpb_accordion_wrapper").accordion({
                                header: "> div > h3",
                                autoHeight: !1,
                                heightStyle: "content",
                                active: active_tab,
                                collapsible: $tabs,
                                navigation: !0,
                                activate: vc_accordionActivate,
                                change: function (event, ui) {
                                    void 0 !== jQuery.fn.isotope && ui.newContent.find(".isotope").isotope("layout"), vc_carouselBehaviour(ui.newPanel);
                                },
                            });
                        !0 === $this.data("vcDisableKeydown") && ($tabs.data("uiAccordion")._keydown = function () {});
                    });
                }),
            "function" != typeof window.vc_teaserGrid &&
                (window.vc_teaserGrid = function () {
                    var layout_modes = {
                        fitrows: "fitRows",
                        masonry: "masonry",
                    };
                    jQuery(".wpb_grid .teaser_grid_container:not(.wpb_carousel), .wpb_filtered_grid .teaser_grid_container:not(.wpb_carousel)").each(function () {
                        var $container = jQuery(this),
                            $thumbs = $container.find(".wpb_thumbnails"),
                            layout_mode = $thumbs.attr("data-layout-mode");
                        $thumbs.isotope({
                            itemSelector: ".isotope-item",
                            layoutMode: void 0 === layout_modes[layout_mode] ? "fitRows" : layout_modes[layout_mode],
                        }),
                            $container
                                .find(".categories_filter a")
                                .data("isotope", $thumbs)
                                .on("click", function ($thumbs) {
                                    $thumbs && $thumbs.preventDefault && $thumbs.preventDefault();
                                    $thumbs = jQuery(this).data("isotope");
                                    jQuery(this).parent().parent().find(".active").removeClass("active"),
                                        jQuery(this).parent().addClass("active"),
                                        $thumbs.isotope({
                                            filter: jQuery(this).attr("data-filter"),
                                        });
                                }),
                            jQuery(window).on("load resize", function () {
                                $thumbs.isotope("layout");
                            });
                    });
                }),
            "function" != typeof window.vc_carouselBehaviour &&
                (window.vc_carouselBehaviour = function ($parent) {
                    ($parent ? $parent.find(".wpb_carousel") : jQuery(".wpb_carousel")).each(function () {
                        var fluid_ul = jQuery(this);
                        !0 !== fluid_ul.data("carousel_enabled") &&
                            fluid_ul.is(":visible") &&
                            (fluid_ul.data("carousel_enabled", !0),
                            getColumnsCount(jQuery(this)),
                            jQuery(this).hasClass("columns_count_1"),
                            (fluid_ul = jQuery(this).find(".wpb_thumbnails-fluid li")).css({
                                "margin-right": fluid_ul.css("margin-left"),
                                "margin-left": 0,
                            }),
                            (fluid_ul = jQuery(this).find("ul.wpb_thumbnails-fluid")).width(fluid_ul.width() + 300),
                            jQuery(window).on("resize", function () {
                                screen_size != (screen_size = getSizeName()) &&
                                    window.setTimeout(function () {
                                        location.reload();
                                    }, 20);
                            }));
                    });
                }),
            "function" != typeof window.vc_slidersBehaviour &&
                (window.vc_slidersBehaviour = function () {
                    jQuery(".wpb_gallery_slides").each(function (index) {
                        var $imagesGrid,
                            sliderTimeout,
                            this_element = jQuery(this);
                        this_element.hasClass("wpb_slider_nivo")
                            ? (0 === (sliderTimeout = 1e3 * this_element.attr("data-interval")) && (sliderTimeout = 9999999999),
                              this_element.find(".nivoSlider").nivoSlider({
                                  effect: "boxRainGrow,boxRain,boxRainReverse,boxRainGrowReverse",
                                  slices: 15,
                                  boxCols: 8,
                                  boxRows: 4,
                                  animSpeed: 800,
                                  pauseTime: sliderTimeout,
                                  startSlide: 0,
                                  directionNav: !0,
                                  directionNavHide: !0,
                                  controlNav: !0,
                                  keyboardNav: !1,
                                  pauseOnHover: !0,
                                  manualAdvance: !1,
                                  prevText: "Prev",
                                  nextText: "Next",
                              }))
                            : this_element.hasClass("wpb_image_grid") &&
                              (jQuery.fn.imagesLoaded
                                  ? ($imagesGrid = this_element.find(".wpb_image_grid_ul").imagesLoaded(function () {
                                        $imagesGrid.isotope({
                                            itemSelector: ".isotope-item",
                                            layoutMode: "fitRows",
                                        });
                                    }))
                                  : this_element.find(".wpb_image_grid_ul").isotope({
                                        itemSelector: ".isotope-item",
                                        layoutMode: "fitRows",
                                    }));
                    });
                }),
            "function" != typeof window.vc_prettyPhoto &&
                (window.vc_prettyPhoto = function () {
                    try {
                        jQuery &&
                            jQuery.fn &&
                            jQuery.fn.prettyPhoto &&
                            jQuery('a.prettyphoto, .gallery-icon a[href*=".jpg"]').prettyPhoto({
                                animationSpeed: "normal",
                                hook: "data-rel",
                                padding: 15,
                                opacity: 0.7,
                                showTitle: !0,
                                allowresize: !0,
                                counter_separator_label: "/",
                                hideflash: !1,
                                deeplinking: !1,
                                modal: !1,
                                callback: function () {
                                    -1 < location.href.indexOf("#!prettyPhoto") && (location.hash = "");
                                },
                                social_tools: "",
                            });
                    } catch (err) {
                        window.console && window.console.warn && window.console.warn("vc_prettyPhoto initialize error", err);
                    }
                }),
            "function" != typeof window.vc_google_fonts &&
                (window.vc_google_fonts = function () {
                    return window.console && window.console.warn && window.console.warn("function vc_google_fonts is deprecated, no need to use it"), !1;
                }),
            (window.vcParallaxSkroll = !1),
            "function" != typeof window.vc_rowBehaviour &&
                (window.vc_rowBehaviour = function () {
                    var vcSkrollrOptions,
                        callSkrollInit,
                        $ = window.jQuery;
                    function fullWidthRow() {
                        var $elements = $('[data-vc-full-width="true"]');
                        $.each($elements, function (key, item) {
                            var $el = $(this);
                            $el.addClass("vc_hidden");
                            var el_margin_left,
                                el_margin_right,
                                offset,
                                width,
                                padding,
                                paddingRight,
                                $el_full = $el.next(".vc_row-full-width");
                            ($el_full = !$el_full.length ? $el.parent().next(".vc_row-full-width") : $el_full).length &&
                                ((el_margin_left = parseInt($el.css("margin-left"), 10)),
                                (el_margin_right = parseInt($el.css("margin-right"), 10)),
                                (offset = 0 - $el_full.offset().left - el_margin_left),
                                (width = $(window).width()),
                                "rtl" === $el.css("direction") && ((offset -= $el_full.width()), (offset += width), (offset += el_margin_left), (offset += el_margin_right)),
                                $el.css({
                                    position: "relative",
                                    left: offset,
                                    "box-sizing": "border-box",
                                    width: width,
                                }),
                                $el.data("vcStretchContent") ||
                                    ("rtl" === $el.css("direction")
                                        ? ((padding = offset) < 0 && (padding = 0), (paddingRight = offset) < 0 && (paddingRight = 0))
                                        : (paddingRight = width - (padding = (padding = -1 * offset) < 0 ? 0 : padding) - $el_full.width() + el_margin_left + el_margin_right) < 0 && (paddingRight = 0),
                                    $el.css({
                                        "padding-left": padding + "px",
                                        "padding-right": paddingRight + "px",
                                    })),
                                $el.attr("data-vc-full-width-init", "true"),
                                $el.removeClass("vc_hidden"),
                                $(document).trigger("vc-full-width-row-single", {
                                    el: $el,
                                    offset: offset,
                                    marginLeft: el_margin_left,
                                    marginRight: el_margin_right,
                                    elFull: $el_full,
                                    width: width,
                                }));
                        }),
                            $(document).trigger("vc-full-width-row", $elements);
                    }
                    function fullHeightRow() {
                        var fullHeight,
                            offsetTop,
                            $element = $(".vc_row-o-full-height:first");
                        $element.length && ((fullHeight = $(window).height()), (offsetTop = $element.offset().top) < fullHeight && ((fullHeight = 100 - offsetTop / (fullHeight / 100)), $element.css("min-height", fullHeight + "vh"))),
                            $(document).trigger("vc-full-height-row", $element);
                    }
                    $(window).off("resize.vcRowBehaviour").on("resize.vcRowBehaviour", fullWidthRow).on("resize.vcRowBehaviour", fullHeightRow),
                        fullWidthRow(),
                        fullHeightRow(),
                        (0 < window.navigator.userAgent.indexOf("MSIE ") || navigator.userAgent.match(/Trident.*rv\:11\./)) &&
                            $(".vc_row-o-full-height").each(function () {
                                "flex" === $(this).css("display") && $(this).wrap('<div class="vc_ie-flexbox-fixer"></div>');
                            }),
                        vc_initVideoBackgrounds(),
                        (callSkrollInit = !1),
                        window.vcParallaxSkroll && window.vcParallaxSkroll.destroy(),
                        $(".vc_parallax-inner").remove(),
                        $("[data-5p-top-bottom]").removeAttr("data-5p-top-bottom data-30p-top-bottom"),
                        $("[data-vc-parallax]").each(function () {
                            var skrollrStart, $parallaxElement, parallaxImage, youtubeId;
                            (callSkrollInit = !0),
                                "on" === $(this).data("vcParallaxOFade") && $(this).children().attr("data-5p-top-bottom", "opacity:0;").attr("data-30p-top-bottom", "opacity:1;"),
                                (skrollrStart = 100 * $(this).data("vcParallax")),
                                ($parallaxElement = $("<div />").addClass("vc_parallax-inner").appendTo($(this))).height(skrollrStart + "%"),
                                (parallaxImage = $(this).data("vcParallaxImage")),
                                (youtubeId = vcExtractYoutubeId(parallaxImage))
                                    ? insertYoutubeVideoAsBackground($parallaxElement, youtubeId)
                                    : void 0 !== parallaxImage && $parallaxElement.css("background-image", "url(" + parallaxImage + ")"),
                                (skrollrStart = -(skrollrStart - 100)),
                                $parallaxElement.attr("data-bottom-top", "top: " + skrollrStart + "%;").attr("data-top-bottom", "top: 0%;");
                        }),
                        callSkrollInit &&
                            window.skrollr &&
                            ((vcSkrollrOptions = {
                                forceHeight: !1,
                                smoothScrolling: !1,
                                mobileCheck: function () {
                                    return !1;
                                },
                            }),
                            (window.vcParallaxSkroll = skrollr.init(vcSkrollrOptions)),
                            window.vcParallaxSkroll);
                }),
            "function" != typeof window.vc_gridBehaviour &&
                (window.vc_gridBehaviour = function () {
                    jQuery.fn.vcGrid && jQuery("[data-vc-grid]").vcGrid();
                }),
            "function" != typeof window.getColumnsCount &&
                (window.getColumnsCount = function (el) {
                    for (var find = !1, i = 1; !1 === find; ) {
                        if (el.hasClass("columns_count_" + i)) return (find = !0), i;
                        i++;
                    }
                });
        var screen_size = getSizeName();
        function getSizeName() {
            var screen_w = jQuery(window).width();
            return 1170 < screen_w ? "desktop_wide" : 960 < screen_w && screen_w < 1169 ? "desktop" : 768 < screen_w && screen_w < 959 ? "tablet" : 300 < screen_w && screen_w < 767 ? "mobile" : screen_w < 300 ? "mobile_portrait" : "";
        }
        "function" != typeof window.wpb_prepare_tab_content &&
            (window.wpb_prepare_tab_content = function (event, ui) {
                var panel = ui.panel || ui.newPanel,
                    $pie_charts = panel.find(".vc_pie_chart:not(.vc_ready)"),
                    $round_charts = panel.find(".vc_round-chart"),
                    $frame = panel.find(".vc_line-chart"),
                    $google_maps = panel.find('[data-ride="vc_carousel"]');
                vc_carouselBehaviour(),
                    vc_plugin_flexslider(panel),
                    ui.newPanel.find(".vc_masonry_media_grid, .vc_masonry_grid").length &&
                        ui.newPanel.find(".vc_masonry_media_grid, .vc_masonry_grid").each(function () {
                            var grid = jQuery(this).data("vcGrid");
                            grid && grid.gridBuilder && grid.gridBuilder.setMasonry && grid.gridBuilder.setMasonry();
                        }),
                    panel.find(".vc_masonry_media_grid, .vc_masonry_grid").length &&
                        panel.find(".vc_masonry_media_grid, .vc_masonry_grid").each(function () {
                            var grid = jQuery(this).data("vcGrid");
                            grid && grid.gridBuilder && grid.gridBuilder.setMasonry && grid.gridBuilder.setMasonry();
                        }),
                    $pie_charts.length && jQuery.fn.vcChat && $pie_charts.vcChat(),
                    $round_charts.length &&
                        jQuery.fn.vcRoundChart &&
                        $round_charts.vcRoundChart({
                            reload: !1,
                        }),
                    $frame.length &&
                        jQuery.fn.vcLineChart &&
                        $frame.vcLineChart({
                            reload: !1,
                        }),
                    $google_maps.length && jQuery.fn.carousel && $google_maps.carousel("resizeAction"),
                    ($frame = panel.find(".isotope, .wpb_image_grid_ul")),
                    ($google_maps = panel.find(".wpb_gmaps_widget")),
                    0 < $frame.length && $frame.isotope("layout"),
                    $google_maps.length && !$google_maps.is(".map_ready") && (($frame = $google_maps.find("iframe")).attr("src", $frame.attr("src")), $google_maps.addClass("map_ready")),
                    panel.parents(".isotope").length &&
                        panel.parents(".isotope").each(function () {
                            jQuery(this).isotope("layout");
                        }),
                    $(document).trigger("wpb_prepare_tab_content", panel);
            }),
            "function" != typeof window.vc_ttaActivation &&
                (window.vc_ttaActivation = function () {
                    jQuery("[data-vc-accordion]").on("show.vc.accordion", function (e) {
                        var $ = window.jQuery,
                            ui = {};
                        (ui.newPanel = $(this).data("vc.accordion").getTarget()), window.wpb_prepare_tab_content(e, ui);
                    });
                }),
            "function" != typeof window.vc_accordionActivate &&
                (window.vc_accordionActivate = function (event, ui) {
                    var $pie_charts, $round_charts, $line_charts, $carousel;
                    ui.newPanel.length &&
                        ui.newHeader.length &&
                        (($pie_charts = ui.newPanel.find(".vc_pie_chart:not(.vc_ready)")),
                        ($round_charts = ui.newPanel.find(".vc_round-chart")),
                        ($line_charts = ui.newPanel.find(".vc_line-chart")),
                        ($carousel = ui.newPanel.find('[data-ride="vc_carousel"]')),
                        void 0 !== jQuery.fn.isotope && ui.newPanel.find(".isotope, .wpb_image_grid_ul").isotope("layout"),
                        ui.newPanel.find(".vc_masonry_media_grid, .vc_masonry_grid").length &&
                            ui.newPanel.find(".vc_masonry_media_grid, .vc_masonry_grid").each(function () {
                                var grid = jQuery(this).data("vcGrid");
                                grid && grid.gridBuilder && grid.gridBuilder.setMasonry && grid.gridBuilder.setMasonry();
                            }),
                        vc_carouselBehaviour(ui.newPanel),
                        vc_plugin_flexslider(ui.newPanel),
                        $pie_charts.length && jQuery.fn.vcChat && $pie_charts.vcChat(),
                        $round_charts.length &&
                            jQuery.fn.vcRoundChart &&
                            $round_charts.vcRoundChart({
                                reload: !1,
                            }),
                        $line_charts.length &&
                            jQuery.fn.vcLineChart &&
                            $line_charts.vcLineChart({
                                reload: !1,
                            }),
                        $carousel.length && jQuery.fn.carousel && $carousel.carousel("resizeAction"),
                        ui.newPanel.parents(".isotope").length &&
                            ui.newPanel.parents(".isotope").each(function () {
                                jQuery(this).isotope("layout");
                            }));
                }),
            "function" != typeof window.initVideoBackgrounds &&
                (window.initVideoBackgrounds = function () {
                    return window.console && window.console.warn && window.console.warn("this function is deprecated use vc_initVideoBackgrounds"), vc_initVideoBackgrounds();
                }),
            "function" != typeof window.vc_initVideoBackgrounds &&
                (window.vc_initVideoBackgrounds = function () {
                    jQuery("[data-vc-video-bg]").each(function () {
                        var youtubeId,
                            $element = jQuery(this);
                        $element.data("vcVideoBg")
                            ? ((youtubeId = $element.data("vcVideoBg")),
                              (youtubeId = vcExtractYoutubeId(youtubeId)) && ($element.find(".vc_video-bg").remove(), insertYoutubeVideoAsBackground($element, youtubeId)),
                              jQuery(window).on("grid:items:added", function (event, $grid) {
                                  $element.has($grid).length && vcResizeVideoBackground($element);
                              }))
                            : $element.find(".vc_video-bg").remove();
                    });
                }),
            "function" != typeof window.insertYoutubeVideoAsBackground &&
                (window.insertYoutubeVideoAsBackground = function ($element, youtubeId, counter) {
                    if ("undefined" == typeof YT || void 0 === YT.Player)
                        return 100 < (counter = void 0 === counter ? 0 : counter)
                            ? void console.warn("Too many attempts to load YouTube api")
                            : void setTimeout(function () {
                                  insertYoutubeVideoAsBackground($element, youtubeId, counter++);
                              }, 100);
                    var $container = $element.prepend('<div class="vc_video-bg vc_hidden-xs"><div class="inner"></div></div>').find(".inner");
                    new YT.Player($container[0], {
                        width: "100%",
                        height: "100%",
                        videoId: youtubeId,
                        playerVars: {
                            playlist: youtubeId,
                            iv_load_policy: 3,
                            enablejsapi: 1,
                            disablekb: 1,
                            autoplay: 1,
                            controls: 0,
                            showinfo: 0,
                            rel: 0,
                            loop: 1,
                            wmode: "transparent",
                        },
                        events: {
                            onReady: function (event) {
                                event.target.mute().setLoop(!0);
                            },
                        },
                    }),
                        vcResizeVideoBackground($element),
                        jQuery(window).on("resize", function () {
                            vcResizeVideoBackground($element);
                        });
                }),
            "function" != typeof window.vcResizeVideoBackground &&
                (window.vcResizeVideoBackground = function ($element) {
                    var iframeW,
                        iframeH,
                        marginLeft,
                        marginTop,
                        containerW = $element.innerWidth(),
                        containerH = $element.innerHeight();
                    containerW / containerH < 16 / 9
                        ? ((iframeW = containerH * (16 / 9)), (iframeH = containerH), (marginLeft = -Math.round((iframeW - containerW) / 2) + "px"), (marginTop = -Math.round((iframeH - containerH) / 2) + "px"))
                        : ((iframeH = (iframeW = containerW) * (9 / 16)), (marginTop = -Math.round((iframeH - containerH) / 2) + "px"), (marginLeft = -Math.round((iframeW - containerW) / 2) + "px")),
                        (iframeW += "px"),
                        (iframeH += "px"),
                        $element.find(".vc_video-bg iframe").css({
                            maxWidth: "1000%",
                            marginLeft: marginLeft,
                            marginTop: marginTop,
                            width: iframeW,
                            height: iframeH,
                        });
                }),
            "function" != typeof window.vcExtractYoutubeId &&
                (window.vcExtractYoutubeId = function (id) {
                    if (void 0 === id) return !1;
                    id = id.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
                    return null !== id && id[1];
                }),
            "function" != typeof window.vc_googleMapsPointer &&
                (window.vc_googleMapsPointer = function () {
                    var $ = window.jQuery,
                        $wpbGmapsWidget = $(".wpb_gmaps_widget");
                    $wpbGmapsWidget.on("click", function () {
                        $("iframe", this).css("pointer-events", "auto");
                    }),
                        $wpbGmapsWidget.on("mouseleave", function () {
                            $("iframe", this).css("pointer-events", "none");
                        }),
                        $(".wpb_gmaps_widget iframe").css("pointer-events", "none");
                }),
            "function" != typeof window.vc_setHoverBoxPerspective &&
                (window.vc_setHoverBoxPerspective = function (hoverBox) {
                    hoverBox.each(function () {
                        var $this = jQuery(this),
                            perspective = 4 * $this.width() + "px";
                        $this.css("perspective", perspective);
                    });
                }),
            "function" != typeof window.vc_setHoverBoxHeight &&
                (window.vc_setHoverBoxHeight = function (hoverBox) {
                    hoverBox.each(function () {
                        var hoverBoxHeight = jQuery(this),
                            hoverBoxInner = hoverBoxHeight.find(".vc-hoverbox-inner");
                        hoverBoxInner.css("min-height", 0);
                        var frontHeight = hoverBoxHeight.find(".vc-hoverbox-front-inner").outerHeight(),
                            hoverBoxHeight = hoverBoxHeight.find(".vc-hoverbox-back-inner").outerHeight(),
                            hoverBoxHeight = hoverBoxHeight < frontHeight ? frontHeight : hoverBoxHeight;
                        hoverBoxHeight < 250 && (hoverBoxHeight = 250), hoverBoxInner.css("min-height", hoverBoxHeight + "px");
                    });
                }),
            "function" != typeof window.vc_prepareHoverBox &&
                (window.vc_prepareHoverBox = function () {
                    var hoverBox = jQuery(".vc-hoverbox");
                    vc_setHoverBoxHeight(hoverBox), vc_setHoverBoxPerspective(hoverBox);
                }),
            jQuery(document).ready(window.vc_prepareHoverBox),
            jQuery(window).on("resize", window.vc_prepareHoverBox),
            jQuery(document).ready(function ($) {
                window.vc_js();
            });
    })(window.jQuery);
jQuery(document).on("click", "#gtech-menu-wrapper .sub-menu-wrapper a", function () {
    const menuItemName = jQuery(this).data("menu_name");
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Mega Menu", eventAction: "Auto | Marine", eventLabel: menuItemName, eventValue: undefined });
});
jQuery(document).on("click", "#gtech-menu-wrapper a.parent-link", function () {
    const menuItemName = jQuery(this).data("menu_name");
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Header Navigation", eventAction: menuItemName, eventLabel: undefined, eventValue: undefined });
});
jQuery(document).on("click", "td.product-remove a.remove", function () {
    var prodName = jQuery(this).data("gtm4wp_product_name");
    var prodVariant = jQuery(this).data("gtm4wp_product_variant");
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Product removed", eventLabel: prodName + " " + prodVariant, eventValue: undefined });
});
jQuery(document).on("click", '.product-quantity input[type="button"]', function () {
    var prodName = jQuery(this).siblings("label").text();
    var prodName = prodName.replace(" quantity", "");
    var addRemoveName = jQuery(this).attr("class");
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Product Add/Remove", eventLabel: addRemoveName.toUpperCase() + " - " + prodName, eventValue: undefined });
});
jQuery("body").on("applied_coupon", function (coupon) {
    if (jQuery('.woocommerce-notices-wrapper .woocommerce-message:contains("applied successfully")').length > 0) {
        window.wpdataLayer = window.wpdataLayer || [];
        wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Coupon Applied", eventLabel: "Coupon Applied Successfully | " + coupon, eventValue: undefined });
    }
});
jQuery(document).on("click", 'td.actions button[name="update_cart"]', function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Update Cart Btn.", eventLabel: undefined, eventValue: undefined });
});
jQuery(document).on("click", '.woocommerce-shipping-calculator a.shipping-calculator-button:contains("Calculate shipping")', function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Calculate Shipping", eventLabel: undefined, eventValue: undefined });
});
jQuery(document).on("click", "#shipping_method input.shipping_method", function () {
    var deliveryName = jQuery(this).siblings("label").text();
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: deliveryName.split(":")[0], eventLabel: undefined, eventValue: undefined });
});
jQuery(document).on("click", '.shipping-calculator-form button[name="calc_shipping"]', function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Address Update", eventLabel: undefined, eventValue: undefined });
});
jQuery(document).on("click", '.woocommerce-shipping-calculator a.shipping-calculator-button:contains("Change address")', function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Cart Interaction", eventAction: "Change Address", eventLabel: undefined, eventValue: undefined });
});
jQuery("li.nectar-woo-cart").mouseover(function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Minicart Interaction", eventAction: "Minicart Open", eventLabel: undefined, eventValue: undefined });
});
jQuery(document).on("click", "li.mini_cart_item a.remove", function () {
    const miniCartProdName = jQuery(this).siblings("a").text();
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Minicart Interaction", eventAction: "Minicart Product Delete", eventLabel: jQuery.trim(miniCartProdName), eventValue: undefined });
});
jQuery(document).on("click", "p.woocommerce-mini-cart__buttons.buttons a:contains(Checkout)", function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Minicart Interaction", eventAction: "Start Checkout", eventLabel: "Click through to checkout", eventValue: undefined });
});
jQuery(document).on("click", "li.mini_cart_item a:not(.remove)", function () {
    const miniCartProdName = jQuery(this).text();
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Minicart Interaction", eventAction: "Product Click", eventLabel: jQuery.trim(miniCartProdName), eventValue: undefined });
});
jQuery(document).on("click", "p.woocommerce-mini-cart__buttons.buttons a:contains(View cart)", function () {
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Minicart Interaction", eventAction: "View Cart", eventLabel: "Click through to cart page", eventValue: undefined });
});
jQuery(".woocommerce-info > a.showlogin").click(function () {
    var clicks = jQuery(this).data("clicks");
    if (clicks) {
        window.wpdataLayer = window.wpdataLayer || [];
        wpdataLayer.push({ event: "GAEvent", eventCategory: "Checkout Interaction", eventAction: "Login Close", eventLabel: undefined, eventValue: undefined });
    } else {
        window.wpdataLayer = window.wpdataLayer || [];
        wpdataLayer.push({ event: "GAEvent", eventCategory: "Checkout Interaction", eventAction: "Login Open", eventLabel: undefined, eventValue: undefined });
    }
    jQuery(this).data("clicks", !clicks);
});
jQuery(".woocommerce-info > a.showcoupon").click(function () {
    var couponWrapperclicks = jQuery(this).data("clicks");
    if (couponWrapperclicks) {
        window.wpdataLayer = window.wpdataLayer || [];
        wpdataLayer.push({ event: "GAEvent", eventCategory: "Checkout Interaction", eventAction: "Coupon Close", eventLabel: undefined, eventValue: undefined });
    } else {
        window.wpdataLayer = window.wpdataLayer || [];
        wpdataLayer.push({ event: "GAEvent", eventCategory: "Checkout Interaction", eventAction: "Coupon Open", eventLabel: undefined, eventValue: undefined });
    }
    jQuery(this).data("clicks", !couponWrapperclicks);
});
jQuery("form.checkout_coupon.woocommerce-form-coupon button").click(function () {
    var couponCode = jQuery("input#coupon_code").val();
    jQuery(document.body).on("update_checkout", function () {
        if (jQuery('.woocommerce-message:contains("applied successfully")').length > 0) {
            window.wpdataLayer = window.wpdataLayer || [];
            wpdataLayer.push({ event: "GAEvent", eventCategory: "Checkout Interaction", eventAction: "Apply Coupon | Status", eventLabel: "Coupon Applied Successfully | " + couponCode, eventValue: undefined });
        }
    });
});
jQuery(document).on("click", ".wc_payment_method .wc_payment_method", function () {
    var paymentMethod = jQuery(this).find("input").val();
    var paymentMethod = paymentMethod.replace(/(^|_)./g, " ");
    window.wpdataLayer = window.wpdataLayer || [];
    wpdataLayer.push({ event: "GAEvent", eventCategory: "Checkout Interaction", eventAction: "Payment Option", eventLabel: paymentMethod, eventValue: undefined });
});